
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("6aq5c", function(module, exports) {

var $jqXx5 = parcelRequire("jqXx5");


var $d925B = parcelRequire("d925B");


var $juTiU = parcelRequire("juTiU");


var $4jM0A = parcelRequire("4jM0A");

const $a505c57fde83bb0c$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $a505c57fde83bb0c$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $a505c57fde83bb0c$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables,
            allowTableInPanel: validationOverrides?.allowTableInPanel
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $a505c57fde83bb0c$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $a505c57fde83bb0c$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return (0, $4jM0A.wrapWithUnsupported)(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $a505c57fde83bb0c$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
   * There's a inconsistency between ProseMirror and ADF.
   * `content` is actually optional in ProseMirror.
   * And, also empty `text` node is not valid.
   */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $a505c57fde83bb0c$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $a505c57fde83bb0c$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    // panel_c1 is a ProseMirror-only variant: on save, table-in-panel documents are stored as
    // plain ADF `panel` nodes containing a `table`. The base validator-spec does not permit
    // `table` inside `panel` (it's gated behind the experiment), so we suppress the
    // INVALID_CONTENT error when the experiment is active.
    if (options.allowTableInPanel) {
        const meta = error.meta;
        if (meta?.parentType === 'panel' && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return (0, $4jM0A.wrapWithUnsupported)(entity);
    if (options.allowUnsupportedInline) return (0, $4jM0A.wrapWithUnsupported)(entity, 'inline');
    if (dispatchAnalyticsEvent) $a505c57fde83bb0c$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $a505c57fde83bb0c$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? (0, $4jM0A.wrapWithUnsupported)(child) : validate(child, $a505c57fde83bb0c$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return (0, $4jM0A.wrapWithUnsupported)(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? (0, $4jM0A.wrapWithUnsupported)(child) : child;
        });
    }
    return entity;
}
function $a505c57fde83bb0c$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $juTiU.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $a505c57fde83bb0c$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $jqXx5.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $a505c57fde83bb0c$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
module.exports["validateADFEntity"] = $a505c57fde83bb0c$export$884cfad20dece33e;

});

parcelRegister("jqXx5", function(module, exports) {

var $dh538 = parcelRequire("dh538");

var $58b4146701b9e110$exports = {};
$parcel$export($58b4146701b9e110$exports, "alignment", () => (parcelRequire("4rpi6")).alignment);
$parcel$export($58b4146701b9e110$exports, "annotation", () => (parcelRequire("4rpi6")).annotation);
$parcel$export($58b4146701b9e110$exports, "backgroundColor", () => (parcelRequire("4rpi6")).backgroundColor);
$parcel$export($58b4146701b9e110$exports, "blockCard", () => (parcelRequire("4rpi6")).blockCard);
$parcel$export($58b4146701b9e110$exports, "block_content", () => (parcelRequire("4rpi6")).block_content);
$parcel$export($58b4146701b9e110$exports, "blockRootOnly", () => (parcelRequire("4rpi6")).blockRootOnly);
$parcel$export($58b4146701b9e110$exports, "blockquote", () => (parcelRequire("4rpi6")).blockquote);
$parcel$export($58b4146701b9e110$exports, "blockTaskItem", () => (parcelRequire("4rpi6")).blockTaskItem);
$parcel$export($58b4146701b9e110$exports, "bodiedExtension", () => (parcelRequire("4rpi6")).bodiedExtension);
$parcel$export($58b4146701b9e110$exports, "bodiedExtension_with_marks", () => (parcelRequire("4rpi6")).bodiedExtension_with_marks);
$parcel$export($58b4146701b9e110$exports, "border", () => (parcelRequire("4rpi6")).border);
$parcel$export($58b4146701b9e110$exports, "breakout", () => (parcelRequire("4rpi6")).breakout);
$parcel$export($58b4146701b9e110$exports, "bulletList", () => (parcelRequire("4rpi6")).bulletList);
$parcel$export($58b4146701b9e110$exports, "caption", () => (parcelRequire("4rpi6")).caption);
$parcel$export($58b4146701b9e110$exports, "code", () => (parcelRequire("4rpi6")).code);
$parcel$export($58b4146701b9e110$exports, "codeBlock", () => (parcelRequire("4rpi6")).codeBlock);
$parcel$export($58b4146701b9e110$exports, "codeBlock_root_only", () => (parcelRequire("4rpi6")).codeBlock_root_only);
$parcel$export($58b4146701b9e110$exports, "text_with_no_marks", () => (parcelRequire("4rpi6")).text_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "confluenceInlineComment", () => (parcelRequire("4rpi6")).confluenceInlineComment);
$parcel$export($58b4146701b9e110$exports, "dataConsumer", () => (parcelRequire("4rpi6")).dataConsumer);
$parcel$export($58b4146701b9e110$exports, "date", () => (parcelRequire("4rpi6")).date);
$parcel$export($58b4146701b9e110$exports, "decisionItem", () => (parcelRequire("4rpi6")).decisionItem);
$parcel$export($58b4146701b9e110$exports, "decisionList", () => (parcelRequire("4rpi6")).decisionList);
$parcel$export($58b4146701b9e110$exports, "doc", () => (parcelRequire("4rpi6")).doc);
$parcel$export($58b4146701b9e110$exports, "em", () => (parcelRequire("4rpi6")).em);
$parcel$export($58b4146701b9e110$exports, "embedCard", () => (parcelRequire("4rpi6")).embedCard);
$parcel$export($58b4146701b9e110$exports, "emoji", () => (parcelRequire("4rpi6")).emoji);
$parcel$export($58b4146701b9e110$exports, "expand", () => (parcelRequire("4rpi6")).expand);
$parcel$export($58b4146701b9e110$exports, "expand_root_only", () => (parcelRequire("4rpi6")).expand_root_only);
$parcel$export($58b4146701b9e110$exports, "extension", () => (parcelRequire("4rpi6")).extension);
$parcel$export($58b4146701b9e110$exports, "extensionFrame", () => (parcelRequire("4rpi6")).extensionFrame);
$parcel$export($58b4146701b9e110$exports, "extension_with_marks", () => (parcelRequire("4rpi6")).extension_with_marks);
$parcel$export($58b4146701b9e110$exports, "fontSize", () => (parcelRequire("4rpi6")).fontSize);
$parcel$export($58b4146701b9e110$exports, "fragment", () => (parcelRequire("4rpi6")).fragment);
$parcel$export($58b4146701b9e110$exports, "hardBreak", () => (parcelRequire("4rpi6")).hardBreak);
$parcel$export($58b4146701b9e110$exports, "heading", () => (parcelRequire("4rpi6")).heading);
$parcel$export($58b4146701b9e110$exports, "heading_with_alignment", () => (parcelRequire("4rpi6")).heading_with_alignment);
$parcel$export($58b4146701b9e110$exports, "heading_with_indentation", () => (parcelRequire("4rpi6")).heading_with_indentation);
$parcel$export($58b4146701b9e110$exports, "heading_with_no_marks", () => (parcelRequire("4rpi6")).heading_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "indentation", () => (parcelRequire("4rpi6")).indentation);
$parcel$export($58b4146701b9e110$exports, "inlineCard", () => (parcelRequire("4rpi6")).inlineCard);
$parcel$export($58b4146701b9e110$exports, "inlineExtension", () => (parcelRequire("4rpi6")).inlineExtension);
$parcel$export($58b4146701b9e110$exports, "inlineExtension_with_marks", () => (parcelRequire("4rpi6")).inlineExtension_with_marks);
$parcel$export($58b4146701b9e110$exports, "inline_content", () => (parcelRequire("4rpi6")).inline_content);
$parcel$export($58b4146701b9e110$exports, "layoutColumn", () => (parcelRequire("4rpi6")).layoutColumn);
$parcel$export($58b4146701b9e110$exports, "layoutSection", () => (parcelRequire("4rpi6")).layoutSection);
$parcel$export($58b4146701b9e110$exports, "layoutSection_full", () => (parcelRequire("4rpi6")).layoutSection_full);
$parcel$export($58b4146701b9e110$exports, "layoutSection_with_single_column", () => (parcelRequire("4rpi6")).layoutSection_with_single_column);
$parcel$export($58b4146701b9e110$exports, "link", () => (parcelRequire("4rpi6")).link);
$parcel$export($58b4146701b9e110$exports, "listItem", () => (parcelRequire("4rpi6")).listItem);
$parcel$export($58b4146701b9e110$exports, "media", () => (parcelRequire("4rpi6")).media);
$parcel$export($58b4146701b9e110$exports, "mediaGroup", () => (parcelRequire("4rpi6")).mediaGroup);
$parcel$export($58b4146701b9e110$exports, "mediaInline", () => (parcelRequire("4rpi6")).mediaInline);
$parcel$export($58b4146701b9e110$exports, "mediaSingle", () => (parcelRequire("4rpi6")).mediaSingle);
$parcel$export($58b4146701b9e110$exports, "mediaSingle_caption", () => (parcelRequire("4rpi6")).mediaSingle_caption);
$parcel$export($58b4146701b9e110$exports, "mediaSingle_full", () => (parcelRequire("4rpi6")).mediaSingle_full);
$parcel$export($58b4146701b9e110$exports, "mention", () => (parcelRequire("4rpi6")).mention);
$parcel$export($58b4146701b9e110$exports, "multiBodiedExtension", () => (parcelRequire("4rpi6")).multiBodiedExtension);
$parcel$export($58b4146701b9e110$exports, "nestedExpand", () => (parcelRequire("4rpi6")).nestedExpand);
$parcel$export($58b4146701b9e110$exports, "nestedExpand_content", () => (parcelRequire("4rpi6")).nestedExpand_content);
$parcel$export($58b4146701b9e110$exports, "nestedExpand_with_no_marks", () => (parcelRequire("4rpi6")).nestedExpand_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "non_nestable_block_content", () => (parcelRequire("4rpi6")).non_nestable_block_content);
$parcel$export($58b4146701b9e110$exports, "orderedList", () => (parcelRequire("4rpi6")).orderedList);
$parcel$export($58b4146701b9e110$exports, "panel", () => (parcelRequire("4rpi6")).panel);
$parcel$export($58b4146701b9e110$exports, "panel_root_only", () => (parcelRequire("4rpi6")).panel_root_only);
$parcel$export($58b4146701b9e110$exports, "paragraph", () => (parcelRequire("4rpi6")).paragraph);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_alignment", () => (parcelRequire("4rpi6")).paragraph_with_alignment);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_font_size", () => (parcelRequire("4rpi6")).paragraph_with_font_size);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_indentation", () => (parcelRequire("4rpi6")).paragraph_with_indentation);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_no_marks", () => (parcelRequire("4rpi6")).paragraph_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "placeholder", () => (parcelRequire("4rpi6")).placeholder);
$parcel$export($58b4146701b9e110$exports, "rule", () => (parcelRequire("4rpi6")).rule);
$parcel$export($58b4146701b9e110$exports, "rule_root_only", () => (parcelRequire("4rpi6")).rule_root_only);
$parcel$export($58b4146701b9e110$exports, "status", () => (parcelRequire("4rpi6")).status);
$parcel$export($58b4146701b9e110$exports, "strike", () => (parcelRequire("4rpi6")).strike);
$parcel$export($58b4146701b9e110$exports, "strong", () => (parcelRequire("4rpi6")).strong);
$parcel$export($58b4146701b9e110$exports, "subsup", () => (parcelRequire("4rpi6")).subsup);
$parcel$export($58b4146701b9e110$exports, "table", () => (parcelRequire("4rpi6")).table);
$parcel$export($58b4146701b9e110$exports, "tableCell", () => (parcelRequire("4rpi6")).tableCell);
$parcel$export($58b4146701b9e110$exports, "tableHeader", () => (parcelRequire("4rpi6")).tableHeader);
$parcel$export($58b4146701b9e110$exports, "tableRow", () => (parcelRequire("4rpi6")).tableRow);
$parcel$export($58b4146701b9e110$exports, "taskItem", () => (parcelRequire("4rpi6")).taskItem);
$parcel$export($58b4146701b9e110$exports, "taskList", () => (parcelRequire("4rpi6")).taskList);
$parcel$export($58b4146701b9e110$exports, "text", () => (parcelRequire("4rpi6")).text);
$parcel$export($58b4146701b9e110$exports, "textColor", () => (parcelRequire("4rpi6")).textColor);
$parcel$export($58b4146701b9e110$exports, "text_code_inline", () => (parcelRequire("4rpi6")).text_code_inline);
$parcel$export($58b4146701b9e110$exports, "text_formatted", () => (parcelRequire("4rpi6")).text_formatted);
$parcel$export($58b4146701b9e110$exports, "text_link_inline", () => (parcelRequire("4rpi6")).text_link_inline);
$parcel$export($58b4146701b9e110$exports, "underline", () => (parcelRequire("4rpi6")).underline);
$parcel$export($58b4146701b9e110$exports, "syncBlock", () => (parcelRequire("4rpi6")).syncBlock);
$parcel$export($58b4146701b9e110$exports, "bodiedSyncBlock", () => (parcelRequire("4rpi6")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4rpi6 = parcelRequire("4rpi6");



const $b212eb2b08ba23cd$export$4e62c701997796c1 = (x)=>x != null;
const $b212eb2b08ba23cd$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $b212eb2b08ba23cd$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $b212eb2b08ba23cd$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $b212eb2b08ba23cd$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $b212eb2b08ba23cd$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $b212eb2b08ba23cd$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $b212eb2b08ba23cd$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];


function $f843a69f28c03b39$export$7d2123bc001cdbf8(validatorSpecs, entity) {
    // Filter out content type + irrelevant nodes
    const potentialAllowedContent = Object.entries(validatorSpecs).filter((item)=>{
        const [node, value] = item;
        if ($f843a69f28c03b39$var$isValidatorSpec(value)) return node === entity.type;
        const [nodeName, spec] = [
            value[0],
            value[1]
        ];
        if (typeof spec === 'string' || typeof spec !== 'object') return false;
        return nodeName === entity.type;
    });
    // Keep types such as `mediaSingle_full` which contain additional spec information
    const contentArray = potentialAllowedContent.map((allowedContent)=>{
        if ($f843a69f28c03b39$var$isValidatorSpec(allowedContent)) return undefined;
        const value = allowedContent[1];
        return !$f843a69f28c03b39$var$isValidatorSpec(value) ? [
            [
                value[0],
                value[1]
            ]
        ] : undefined;
    });
    return contentArray.filter((x)=>!!x);
}
function $f843a69f28c03b39$var$isValidatorSpec(spec) {
    return spec.props !== undefined || spec.required !== undefined || spec.maxItems !== undefined || spec.minItems !== undefined;
}



var $81OAa = parcelRequire("81OAa");

const $7553da36add03409$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $81OAa.isSafeUrl)
};


// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5a24607d60a15c5e$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5a24607d60a15c5e$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Checks if a spec is a variant spec.
 * A variant spec is an array where the first element is a string (base spec name)
 * and the second element is a ValidatorSpec object { props: { ... } }
 */ const $5a24607d60a15c5e$var$isVariant = (spec)=>typeof spec === 'object' && !!spec && 0 in spec && 1 in spec && typeof spec[0] === 'string' && typeof spec[1] === 'object';
function $5a24607d60a15c5e$export$a49afc9edc88765c(nodes, marks) {
    const variantOverrides = $5a24607d60a15c5e$var$getVariantSpecOverrides();
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($58b4146701b9e110$exports).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let spec = {
            ...$58b4146701b9e110$exports[k]
        };
        if ($5a24607d60a15c5e$var$isVariant(spec) && Object.values(variantOverrides).includes(k)) // When the spec is a variant it will be in the form of ['base_spec_name', { props: { ... } }]
        // The actual validator spec of the variant will be the second item in the array
        spec = {
            ...spec[1]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $b212eb2b08ba23cd$export$844ec244b1367d54)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $58b4146701b9e110$exports[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $b212eb2b08ba23cd$export$844ec244b1367d54)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($58b4146701b9e110$exports[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $58b4146701b9e110$exports[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($58b4146701b9e110$exports[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $58b4146701b9e110$exports[subItem] : (0, $b212eb2b08ba23cd$export$844ec244b1367d54)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $5a24607d60a15c5e$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5a24607d60a15c5e$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $5a24607d60a15c5e$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $5a24607d60a15c5e$export$66c739158ef99a42(spec, value) {
    if (!(0, $b212eb2b08ba23cd$export$4e62c701997796c1)(value)) return !!spec.optional;
    if ($5a24607d60a15c5e$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $5a24607d60a15c5e$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $5a24607d60a15c5e$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $b212eb2b08ba23cd$export$f9ce7b637dfbe238)(value);
        case 'number':
            return (0, $b212eb2b08ba23cd$export$7e4aa119212bc614)(value) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $b212eb2b08ba23cd$export$a287f47fed4544b8)(value) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $b212eb2b08ba23cd$export$4e62c701997796c1)((0, $7553da36add03409$export$d1b377ca77ac267d)[rule]) && (0, $7553da36add03409$export$d1b377ca77ac267d)[rule](value);
            return (0, $b212eb2b08ba23cd$export$844ec244b1367d54)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $b212eb2b08ba23cd$export$53b83ca8eaab0383)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$5a24607d60a15c5e$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$5a24607d60a15c5e$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $b212eb2b08ba23cd$export$844ec244b1367d54)(value) && spec.values.indexOf(value) > -1;
    }
}
const $5a24607d60a15c5e$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $5a24607d60a15c5e$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $5a24607d60a15c5e$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $5a24607d60a15c5e$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $5a24607d60a15c5e$var$getUnsupportedOptions(parentSpec));
};
const $5a24607d60a15c5e$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $5a24607d60a15c5e$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $5a24607d60a15c5e$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
/**
 * Returns a map of base spec names to a preferred variant spec that should be used
 * in their place during validation. Implemented as a getter function so that entries
 * can be conditionally included behind feature gates.
 *
 * WARNING: The variant spec must be a strict superset of the base spec, i.e. any content valid
 * under the base spec must also be valid under the variant.
 */ const $5a24607d60a15c5e$var$getVariantSpecOverrides = ()=>{
    if ((0, $dh538.fg)('platform_editor_lovability_resize_gracefully')) return {
        panel: 'panel_root_only',
        rule: 'rule_root_only'
    };
    return {};
};
/**
 * Replaces base validator specs with their designated variant overrides.
 */ const $5a24607d60a15c5e$var$applyVariantSpecOverrides = (validatorSpecs)=>{
    Object.entries($5a24607d60a15c5e$var$getVariantSpecOverrides()).forEach(([base, variant])=>{
        const baseSpec = validatorSpecs[base];
        const variantOverride = validatorSpecs[variant];
        if (baseSpec?.props && variantOverride?.props && typeof baseSpec.props === 'object' && typeof variantOverride.props === 'object') // Merge variant overrides INTO the base spec
        baseSpec.props = {
            ...baseSpec.props,
            ...variantOverride.props
        };
    });
};
function $5a24607d60a15c5e$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $5a24607d60a15c5e$export$a49afc9edc88765c(nodes, marks);
    $5a24607d60a15c5e$var$applyVariantSpecOverrides(validatorSpecs);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        if (!allowed) for (const allowed of (0, $f843a69f28c03b39$export$7d2123bc001cdbf8)(validatorSpecs, entity)){
            const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
            if (validationResult.valid) return {
                entity: validationResult.entity,
                valid: validationResult.valid
            };
        }
        // If `allowed` was provided or we haven't passed yet, return the initial result
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $5a24607d60a15c5e$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $5a24607d60a15c5e$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $5a24607d60a15c5e$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $5a24607d60a15c5e$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $b212eb2b08ba23cd$export$4e62c701997796c1)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$5a24607d60a15c5e$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $b212eb2b08ba23cd$export$7b85fd78dd236198)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $5a24607d60a15c5e$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $5a24607d60a15c5e$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $5a24607d60a15c5e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $5a24607d60a15c5e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $5a24607d60a15c5e$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $5a24607d60a15c5e$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $5a24607d60a15c5e$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $5a24607d60a15c5e$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $b212eb2b08ba23cd$export$4e62c701997796c1)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $b212eb2b08ba23cd$export$784d13d8ee351f07)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $5a24607d60a15c5e$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $b212eb2b08ba23cd$export$4e62c701997796c1)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $5a24607d60a15c5e$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $b212eb2b08ba23cd$export$7b85fd78dd236198)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $b212eb2b08ba23cd$export$7b85fd78dd236198)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $5a24607d60a15c5e$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $5a24607d60a15c5e$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}
module.exports["validator"] = $5a24607d60a15c5e$export$956325f45c5d174a;

});

parcelRegister("4rpi6", function(module, exports) {
const $281e0d22c9e4e7a0$export$8e53000a4ec837 = {
    props: {
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$8512c9afa7b24c3b = {
    props: {
        attrs: {
            props: {
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                },
                id: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$8c5a050822fd698c = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $281e0d22c9e4e7a0$export$c4c2f833baaebdb8 = {
    props: {
        attrs: [
            {
                props: {
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    layout: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        optional: true,
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $281e0d22c9e4e7a0$export$67dc04e652a298ca = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $281e0d22c9e4e7a0$export$16018c61064a18df = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$27903d543b563e39 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$e92c7e4302dd4371 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel',
                    'rule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$1edee58a52776cd9 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                },
                size: {
                    maximum: 3,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$89015c65f1c75e3f = {
    props: {
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$a140c94e5ea26bee = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$8e3c2dfdc4f0453d = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$7bb0d5c671655cc4 = {
    props: {
        attrs: {
            optional: true,
            props: {
                hideLineNumbers: {
                    optional: true,
                    type: 'boolean'
                },
                language: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                uniqueId: {
                    optional: true,
                    type: 'string'
                },
                wrap: {
                    optional: true,
                    type: 'boolean'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$f3b72f8fc4684ecd = {
    props: {
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$3024f02c495408d6 = {
    props: {
        attrs: {
            props: {
                sources: {
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1,
                    type: 'array'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$324d90190a8b822a = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$6959e16eeff859b4 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$62d45a65fb43d95e = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'decisionItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$2a111da947c407d2 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'panel_root_only',
                    'rule_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$be4283d9a1cb1ff6 = {
    props: {
        attrs: {
            props: {
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                originalHeight: {
                    optional: true,
                    type: 'number'
                },
                originalWidth: {
                    optional: true,
                    type: 'number'
                },
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$a19185d1233fc4b2 = {
    props: {
        attrs: {
            props: {
                id: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                shortName: {
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$9f77e0932fb78f72 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$1b45514b112dd749 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$4fdcae991fd743e7 = {
    props: {
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$85e3c3ca0c6fb93 = {
    props: {
        attrs: {
            props: {
                fontSize: {
                    type: 'enum',
                    values: [
                        'small'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fontSize'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$f00aeb236b6f05af = {
    props: {
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$371da9dd35aba193 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'enum',
                    values: [
                        '\n'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$46e4a324ac90507f = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                },
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'alignment'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'indentation'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$480c699bd4ec0d86 = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $281e0d22c9e4e7a0$export$cbf8224b64e0d942 = {
    props: {
        attrs: [
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $281e0d22c9e4e7a0$export$16b353b2649bd8d9 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$ab76e7c03cd6f650 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'block_content'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$b3b6a70a7fa4a5be = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'layoutColumn'
            ],
            maxItems: 3,
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 3,
                minItems: 2,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                optional: true,
                props: {
                    columnRuleStyle: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            },
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 5,
                minItems: 1,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$9c30223ca0a664fb = {
    props: {
        attrs: {
            props: {
                collection: {
                    optional: true,
                    type: 'string'
                },
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                id: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$76c7e83ecc9cdf05 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$987d49ffe1b0900f = {
    props: {
        attrs: [
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    occurrenceKey: {
                        minLength: 1,
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    url: {
                        type: 'string'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            }
        ],
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $281e0d22c9e4e7a0$export$2855e964765eac9 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                'media'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$38bab695e3f720f1 = {
    props: {
        attrs: {
            props: {
                alt: {
                    optional: true,
                    type: 'string'
                },
                collection: {
                    type: 'string'
                },
                data: {
                    optional: true,
                    type: 'object'
                },
                height: {
                    optional: true,
                    type: 'number'
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                type: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ]
                },
                url: {
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$969fe3781ca15058 = {
    props: {
        attrs: [
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        maximum: 100,
                        minimum: 0,
                        optional: true,
                        type: 'number'
                    },
                    widthType: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'percentage'
                        ]
                    }
                }
            },
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        minimum: 0,
                        type: 'number'
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    }
                }
            }
        ],
        marks: {
            items: [
                'link'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                maxItems: 2,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$db83999c14438df4 = {
    props: {
        attrs: {
            props: {
                accessLevel: {
                    optional: true,
                    type: 'string'
                },
                id: {
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                },
                userType: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ]
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$c3c04d555a8b9013 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'extensionFrame'
            ],
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$63cadbf5f4296627 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: 'nestedExpand_content',
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $281e0d22c9e4e7a0$export$9584f52f3ebd5d7e = {
    allowUnsupportedBlock: true,
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_font_size',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    type: 'array'
};
const $281e0d22c9e4e7a0$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'paragraph_with_font_size',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $281e0d22c9e4e7a0$export$a5dc81035676e7a = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                order: {
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$21f42ab9b6679f44 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                panelColor: {
                    optional: true,
                    type: 'string'
                },
                panelIcon: {
                    optional: true,
                    type: 'string'
                },
                panelIconId: {
                    optional: true,
                    type: 'string'
                },
                panelIconText: {
                    optional: true,
                    type: 'string'
                },
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$9388c8efa26ea154 = [
    'panel',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$9c206ddddb32a9b = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'alignment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$f745a1f9fa5e1ca8 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    'fontSize'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'indentation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$c7187bbd1a7a9244 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$fbeb3a3956e8a3c7 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$5bc14ade5ae67510 = [
    'rule',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$471f7ae5c4103ae1 = {
    props: {
        attrs: {
            props: {
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                style: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$b3401ee80eb31041 = {
    props: {
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$faab0ca9701d7048 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$9852986a3ec5f6a0 = {
    props: {
        attrs: {
            optional: true,
            props: {
                displayMode: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ]
                },
                isNumberColumnEnabled: {
                    optional: true,
                    type: 'boolean'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'tableRow'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'fragment'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$e1e720e5f4603e6a = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $281e0d22c9e4e7a0$export$48884d2a5190dc73 = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $281e0d22c9e4e7a0$export$ce666bf02318c957 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$6d8b0ef52e2e6390 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$375b6afcc5f4d291 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$6f093cfa640b7166 = {
    props: {
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        text: {
            minLength: 1,
            type: 'string'
        },
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    'link'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$32f78bffcd82ff28 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};
module.exports["alignment"] = $281e0d22c9e4e7a0$export$8e53000a4ec837;
module.exports["annotation"] = $281e0d22c9e4e7a0$export$8512c9afa7b24c3b;
module.exports["backgroundColor"] = $281e0d22c9e4e7a0$export$8c5a050822fd698c;
module.exports["block_content"] = $281e0d22c9e4e7a0$export$a31afb40076fa18b;
module.exports["blockCard"] = $281e0d22c9e4e7a0$export$c4c2f833baaebdb8;
module.exports["blockquote"] = $281e0d22c9e4e7a0$export$67dc04e652a298ca;
module.exports["blockRootOnly"] = $281e0d22c9e4e7a0$export$ebb5393736e9ba23;
module.exports["blockTaskItem"] = $281e0d22c9e4e7a0$export$16018c61064a18df;
module.exports["bodiedExtension"] = $281e0d22c9e4e7a0$export$27903d543b563e39;
module.exports["bodiedExtension_with_marks"] = $281e0d22c9e4e7a0$export$ee052cc5b2356e83;
module.exports["bodiedSyncBlock"] = $281e0d22c9e4e7a0$export$e92c7e4302dd4371;
module.exports["border"] = $281e0d22c9e4e7a0$export$1edee58a52776cd9;
module.exports["breakout"] = $281e0d22c9e4e7a0$export$89015c65f1c75e3f;
module.exports["bulletList"] = $281e0d22c9e4e7a0$export$a140c94e5ea26bee;
module.exports["caption"] = $281e0d22c9e4e7a0$export$8e3c2dfdc4f0453d;
module.exports["code"] = $281e0d22c9e4e7a0$export$6565f9f03506010b;
module.exports["codeBlock"] = $281e0d22c9e4e7a0$export$7bb0d5c671655cc4;
module.exports["codeBlock_root_only"] = $281e0d22c9e4e7a0$export$38d90d1aac6883a3;
module.exports["confluenceInlineComment"] = $281e0d22c9e4e7a0$export$f3b72f8fc4684ecd;
module.exports["dataConsumer"] = $281e0d22c9e4e7a0$export$3024f02c495408d6;
module.exports["date"] = $281e0d22c9e4e7a0$export$324d90190a8b822a;
module.exports["decisionItem"] = $281e0d22c9e4e7a0$export$6959e16eeff859b4;
module.exports["decisionList"] = $281e0d22c9e4e7a0$export$62d45a65fb43d95e;
module.exports["doc"] = $281e0d22c9e4e7a0$export$2a111da947c407d2;
module.exports["em"] = $281e0d22c9e4e7a0$export$c63c6f932822f543;
module.exports["embedCard"] = $281e0d22c9e4e7a0$export$be4283d9a1cb1ff6;
module.exports["emoji"] = $281e0d22c9e4e7a0$export$a19185d1233fc4b2;
module.exports["expand"] = $281e0d22c9e4e7a0$export$9f77e0932fb78f72;
module.exports["expand_root_only"] = $281e0d22c9e4e7a0$export$b2817c6954dd6d2c;
module.exports["extension"] = $281e0d22c9e4e7a0$export$1b45514b112dd749;
module.exports["extension_with_marks"] = $281e0d22c9e4e7a0$export$15be7c145cec614a;
module.exports["extensionFrame"] = $281e0d22c9e4e7a0$export$4fdcae991fd743e7;
module.exports["fontSize"] = $281e0d22c9e4e7a0$export$85e3c3ca0c6fb93;
module.exports["fragment"] = $281e0d22c9e4e7a0$export$f00aeb236b6f05af;
module.exports["hardBreak"] = $281e0d22c9e4e7a0$export$371da9dd35aba193;
module.exports["heading"] = $281e0d22c9e4e7a0$export$46e4a324ac90507f;
module.exports["heading_with_alignment"] = $281e0d22c9e4e7a0$export$c17edf9af655deaf;
module.exports["heading_with_indentation"] = $281e0d22c9e4e7a0$export$1902f9737466a0dc;
module.exports["heading_with_no_marks"] = $281e0d22c9e4e7a0$export$7b491e75f1be9278;
module.exports["indentation"] = $281e0d22c9e4e7a0$export$480c699bd4ec0d86;
module.exports["inline_content"] = $281e0d22c9e4e7a0$export$e23e6162adaa368d;
module.exports["inlineCard"] = $281e0d22c9e4e7a0$export$cbf8224b64e0d942;
module.exports["inlineExtension"] = $281e0d22c9e4e7a0$export$16b353b2649bd8d9;
module.exports["inlineExtension_with_marks"] = $281e0d22c9e4e7a0$export$e37f10815f36843d;
module.exports["layoutColumn"] = $281e0d22c9e4e7a0$export$ab76e7c03cd6f650;
module.exports["layoutSection"] = $281e0d22c9e4e7a0$export$b3b6a70a7fa4a5be;
module.exports["layoutSection_full"] = $281e0d22c9e4e7a0$export$941b63fbd931e449;
module.exports["layoutSection_with_single_column"] = $281e0d22c9e4e7a0$export$e0e9834198e8601d;
module.exports["link"] = $281e0d22c9e4e7a0$export$9c30223ca0a664fb;
module.exports["listItem"] = $281e0d22c9e4e7a0$export$76c7e83ecc9cdf05;
module.exports["media"] = $281e0d22c9e4e7a0$export$987d49ffe1b0900f;
module.exports["mediaGroup"] = $281e0d22c9e4e7a0$export$2855e964765eac9;
module.exports["mediaInline"] = $281e0d22c9e4e7a0$export$38bab695e3f720f1;
module.exports["mediaSingle"] = $281e0d22c9e4e7a0$export$969fe3781ca15058;
module.exports["mediaSingle_caption"] = $281e0d22c9e4e7a0$export$68b0ead306f9670f;
module.exports["mediaSingle_full"] = $281e0d22c9e4e7a0$export$f7fd577406abd5f8;
module.exports["mention"] = $281e0d22c9e4e7a0$export$db83999c14438df4;
module.exports["multiBodiedExtension"] = $281e0d22c9e4e7a0$export$c3c04d555a8b9013;
module.exports["nestedExpand"] = $281e0d22c9e4e7a0$export$63cadbf5f4296627;
module.exports["nestedExpand_content"] = $281e0d22c9e4e7a0$export$9584f52f3ebd5d7e;
module.exports["nestedExpand_with_no_marks"] = $281e0d22c9e4e7a0$export$b756fc994eb0bc4f;
module.exports["non_nestable_block_content"] = $281e0d22c9e4e7a0$export$ed866000601e7fa5;
module.exports["orderedList"] = $281e0d22c9e4e7a0$export$a5dc81035676e7a;
module.exports["panel"] = $281e0d22c9e4e7a0$export$21f42ab9b6679f44;
module.exports["panel_root_only"] = $281e0d22c9e4e7a0$export$9388c8efa26ea154;
module.exports["paragraph"] = $281e0d22c9e4e7a0$export$9c206ddddb32a9b;
module.exports["paragraph_with_alignment"] = $281e0d22c9e4e7a0$export$9ca11c06877e5c64;
module.exports["paragraph_with_font_size"] = $281e0d22c9e4e7a0$export$f745a1f9fa5e1ca8;
module.exports["paragraph_with_indentation"] = $281e0d22c9e4e7a0$export$a3bd66932996fb7d;
module.exports["paragraph_with_no_marks"] = $281e0d22c9e4e7a0$export$f06f75eb1e56b0c5;
module.exports["placeholder"] = $281e0d22c9e4e7a0$export$c7187bbd1a7a9244;
module.exports["rule"] = $281e0d22c9e4e7a0$export$fbeb3a3956e8a3c7;
module.exports["rule_root_only"] = $281e0d22c9e4e7a0$export$5bc14ade5ae67510;
module.exports["status"] = $281e0d22c9e4e7a0$export$471f7ae5c4103ae1;
module.exports["strike"] = $281e0d22c9e4e7a0$export$4899a95d70ec5056;
module.exports["strong"] = $281e0d22c9e4e7a0$export$59ae2c325a998f89;
module.exports["subsup"] = $281e0d22c9e4e7a0$export$b3401ee80eb31041;
module.exports["syncBlock"] = $281e0d22c9e4e7a0$export$faab0ca9701d7048;
module.exports["table"] = $281e0d22c9e4e7a0$export$9852986a3ec5f6a0;
module.exports["tableCell"] = $281e0d22c9e4e7a0$export$e1e720e5f4603e6a;
module.exports["tableHeader"] = $281e0d22c9e4e7a0$export$48884d2a5190dc73;
module.exports["tableRow"] = $281e0d22c9e4e7a0$export$ce666bf02318c957;
module.exports["taskItem"] = $281e0d22c9e4e7a0$export$6d8b0ef52e2e6390;
module.exports["taskList"] = $281e0d22c9e4e7a0$export$375b6afcc5f4d291;
module.exports["text"] = $281e0d22c9e4e7a0$export$6f093cfa640b7166;
module.exports["text_code_inline"] = $281e0d22c9e4e7a0$export$5008c13f04d544f6;
module.exports["text_formatted"] = $281e0d22c9e4e7a0$export$d24a7becb4e0da7c;
module.exports["text_link_inline"] = $281e0d22c9e4e7a0$export$2a9d18d5b3064e6c;
module.exports["text_with_no_marks"] = $281e0d22c9e4e7a0$export$437a3d96346717e0;
module.exports["textColor"] = $281e0d22c9e4e7a0$export$32f78bffcd82ff28;
module.exports["underline"] = $281e0d22c9e4e7a0$export$425327af25286e5e;

});

parcelRegister("juTiU", function(module, exports) {

var $d925B = parcelRequire("d925B");

const $e291ba685b2f2282$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $e291ba685b2f2282$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e291ba685b2f2282$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $e291ba685b2f2282$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $e291ba685b2f2282$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$e291ba685b2f2282$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $e291ba685b2f2282$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $e291ba685b2f2282$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $e291ba685b2f2282$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $e291ba685b2f2282$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $e291ba685b2f2282$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$e291ba685b2f2282$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $e291ba685b2f2282$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $e291ba685b2f2282$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $e291ba685b2f2282$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $e291ba685b2f2282$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $d925B.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $e291ba685b2f2282$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $e291ba685b2f2282$var$trackUnsupportedContentTooltipActionFor((0, $d925B.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};
module.exports["findAndTrackUnsupportedContentNodes"] = $e291ba685b2f2282$export$d343369b8f25914;
module.exports["fireUnsupportedEvent"] = $e291ba685b2f2282$export$e1051b410945e4d4;
module.exports["trackUnsupportedContentTooltipDisplayedFor"] = $e291ba685b2f2282$export$3a34598135e7219b;

});

parcelRegister("67O0h", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $iyDxB = parcelRequire("iyDxB");


var $4FxUL = parcelRequire("4FxUL");

var $6mbqi = parcelRequire("6mbqi");


var $4BBKV = parcelRequire("4BBKV");

var $kckFS = parcelRequire("kckFS");

var $iq4lN = parcelRequire("iq4lN");

var $bWRlG = parcelRequire("bWRlG");




var $1DWH0 = parcelRequire("1DWH0");

const $0d5221b11c687d15$export$9ac3d19711324187 = (0, $1DWH0.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});



var $iu6m9 = parcelRequire("iu6m9");


var $9K4OG = parcelRequire("9K4OG");


var $d7ZU3 = parcelRequire("d7ZU3");


var $gySSb = parcelRequire("gySSb");


var $2T4ch = parcelRequire("2T4ch");


var $jz9wK = parcelRequire("jz9wK");


var $8aL2H = parcelRequire("8aL2H");





var $hTKp4 = parcelRequire("hTKp4");


var $cQJcI = parcelRequire("cQJcI");

var $bBdDv = parcelRequire("bBdDv");

var $bONsc = parcelRequire("bONsc");

var $damll = parcelRequire("damll");

var $czJBF = parcelRequire("czJBF");


var $dh538 = parcelRequire("dh538");




const $af6ef71a6f2fded7$export$3325eba9424d3c32 = (options = {})=>{
    const { stabilityWaitTime: stabilityWaitTime = 200, maxStabilityWaitTime: maxStabilityWaitTime = 10000 } = options;
    const stabilityTimeoutRef = (0, $42omo.useRef)(null);
    const resizeObserverRef = (0, $42omo.useRef)(null);
    const lastStableTimeRef = (0, $42omo.useRef)(0);
    const onStableCallbackRef = (0, $42omo.useRef)(null);
    const cleanup = (0, $42omo.useCallback)(()=>{
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        onStableCallbackRef.current = null;
        lastStableTimeRef.current = 0;
    }, []);
    const scheduleStabilityCheck = (0, $42omo.useCallback)(()=>{
        // Clear any existing stability timeout.
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        // Check if we've exceeded the maximum stability wait time.
        const now = Date.now();
        if (lastStableTimeRef.current === 0) lastStableTimeRef.current = now;
        else if (now - lastStableTimeRef.current > maxStabilityWaitTime) {
            // We've waited too long for stability, call the callback now.
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
            return;
        }
        // Set a timeout to call the callback after the stability wait time.
        stabilityTimeoutRef.current = setTimeout(()=>{
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
        }, stabilityWaitTime);
    }, [
        stabilityWaitTime,
        maxStabilityWaitTime,
        cleanup
    ]);
    const waitForStability = (0, $42omo.useCallback)((container, onStable)=>{
        // Clean up any existing observer
        cleanup();
        // Store the callback
        onStableCallbackRef.current = onStable;
        // Check if ResizeObserver is available
        if (typeof ResizeObserver === 'undefined') {
            // Fallback: just call the callback after the stability wait time
            stabilityTimeoutRef.current = setTimeout(()=>{
                if (onStableCallbackRef.current) {
                    onStableCallbackRef.current();
                    cleanup();
                }
            }, stabilityWaitTime);
            return;
        }
        // Create a ResizeObserver to monitor the container for size changes.
        resizeObserverRef.current = new ResizeObserver(()=>{
            // Container size changed, reset stability timer.
            scheduleStabilityCheck();
        });
        resizeObserverRef.current.observe(container);
        // Start the initial stability check
        scheduleStabilityCheck();
    }, [
        stabilityWaitTime,
        scheduleStabilityCheck,
        cleanup
    ]);
    return {
        waitForStability: waitForStability,
        cleanup: cleanup
    };
};


const $d95cfbbdf326d486$export$81bdbc2b3f1c95ef = (containerRef, adfDoc, scrollToBlock)=>{
    const { waitForStability: waitForStability, cleanup: cleanupStability } = (0, $af6ef71a6f2fded7$export$3325eba9424d3c32)({
        stabilityWaitTime: 750,
        maxStabilityWaitTime: 10000
    });
    (0, $42omo.useEffect)(()=>{
        // Only run in browser environment.
        if (typeof window === 'undefined' || !containerRef?.current) return;
        // Parse hash fragment for block ID (format: #block-{localId}).
        const hash = window.location.hash;
        const defaultPrefixWithHash = `#${(0, $cQJcI.DEFAULT_BLOCK_LINK_HASH_PREFIX)}`;
        const blockId = hash && hash.startsWith(defaultPrefixWithHash) ? hash.slice(defaultPrefixWithHash.length) : null;
        if (!blockId) return;
        let retryCount = 0;
        const maxRetries = 40;
        const retryInterval = 250;
        let intervalId = null;
        let hasScrolled = false;
        let cancelExpandAndScroll = null;
        const scrollToElement = ()=>{
            // Step 1: Search the ADF document for the node with the given blockId.
            // This works even if the node is hidden inside a collapsed expand.
            if (!adfDoc || !containerRef?.current) return false;
            const nodeWithExpandParents = (0, $bBdDv.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) // Node not found in ADF document.
            return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Step 2: If the node has expand parents, we need to expand them first.
            if (expandParentLocalIds.length > 0) {
                // Find the expand elements in the DOM using their localIds.
                // Note: We need to expand from outermost to innermost.
                let allExpandsFound = true;
                let anyExpandsCollapsed = false;
                for (const expandLocalId of expandParentLocalIds){
                    const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                    if (!expandContainer) {
                        // Expand not found in DOM yet (shouldn't happen but handle it).
                        allExpandsFound = false;
                        break;
                    }
                    // Check if this expand is collapsed.
                    if ((0, $czJBF.isExpandCollapsed)(expandContainer)) {
                        anyExpandsCollapsed = true;
                        // Expand it.
                        (0, $bONsc.expandElement)(expandContainer);
                        // After expanding, we need to retry to handle nested expands.
                        // The DOM needs time to update.
                        return false; // Will retry after interval.
                    }
                }
                if (!allExpandsFound) // Retry later when expands are in DOM.
                return false;
                // All parent expands are now open (or we just expanded one and need to wait).
                if (anyExpandsCollapsed) // Just expanded something, wait for DOM update.
                return false;
            }
            // Step 3: Now the target element should be visible in the DOM, find it and scroll.
            const element = (0, $damll.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) // Element still not in DOM, retry.
            return false;
            // Element found and all parent expands are open! Use the utility to scroll.
            // (This will handle any final edge cases and do the actual scrolling).
            // Capture cleanup function to cancel pending timeouts.
            if ((0, $dh538.fg)('platform_editor_block_menu_v2_patch_4')) cancelExpandAndScroll = (0, $bBdDv.expandAllParentsThenScroll)(element, 0, (el)=>{
                if (scrollToBlock) scrollToBlock(el);
                else el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
            else cancelExpandAndScroll = (0, $bBdDv.expandAllParentsThenScroll)(element);
            return true;
        };
        const performScroll = ()=>{
            if (hasScrolled) return;
            // Try to scroll to element.
            if (scrollToElement()) {
                hasScrolled = true;
                cleanup();
            }
        };
        const attemptScroll = ()=>{
            retryCount++;
            // Try to find the element first.
            if (!adfDoc || !containerRef?.current) return false;
            const nodeWithExpandParents = (0, $bBdDv.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Check if all expands are expanded and element exists.
            let allReady = true;
            if (expandParentLocalIds.length > 0) for (const expandLocalId of expandParentLocalIds){
                const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                if (!expandContainer) {
                    allReady = false;
                    break;
                }
                if ((0, $czJBF.isExpandCollapsed)(expandContainer)) {
                    (0, $bONsc.expandElement)(expandContainer);
                    allReady = false;
                    break;
                }
            }
            const element = (0, $damll.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) allReady = false;
            // If everything is ready, start monitoring for stability.
            if (allReady) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                waitForStability(containerRef.current, performScroll);
                return true;
            }
            // Stop retrying if we've exceeded max retries.
            if (retryCount >= maxRetries) {
                cleanup();
                return false;
            }
            return false;
        };
        const cleanup = ()=>{
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
            cleanupStability();
            // Cancel any pending expand and scroll operations.
            if (cancelExpandAndScroll) {
                cancelExpandAndScroll();
                cancelExpandAndScroll = null;
            }
        };
        // Try to scroll immediately.
        if (attemptScroll()) return cleanup;
        if ((0, $hTKp4.getDocument)()?.readyState === 'complete') // Document is already ready, try a few more times with delays.
        // This handles cases where elements are added after document ready.
        intervalId = setInterval(()=>{
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry.
        intervalId = setInterval(()=>{
            if ((0, $hTKp4.getDocument)()?.readyState === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) cleanup();
            else retryCount++;
        }, retryInterval);
        // Cleanup function.
        return cleanup;
    // Intentionally not including adfDoc in the dependency array to avoid unnecessary re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        containerRef,
        waitForStability,
        cleanupStability,
        scrollToBlock
    ]);
};



var $fLvO8 = parcelRequire("fLvO8");

var $lWghV = parcelRequire("lWghV");

var $NPJKR = parcelRequire("NPJKR");





var $k7eoe = parcelRequire("k7eoe");


var $ffCOo = parcelRequire("ffCOo");


var $d925B = parcelRequire("d925B");


var $9ciHB = parcelRequire("9ciHB");


var $cUcZ5 = parcelRequire("cUcZ5");


var $aUnCJ = parcelRequire("aUnCJ");

var $lf9Ji = parcelRequire("lf9Ji");


var $6uN0A = parcelRequire("6uN0A");


var $59U23 = parcelRequire("59U23");





var $grxv4 = parcelRequire("grxv4");

var $3rvSa = parcelRequire("3rvSa");








var $1oCLl = parcelRequire("1oCLl");

const $bd8a5c6aad625abd$var$getMediaClientConfigForRenderer = (provider)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    return provider.viewAndUploadMediaClientConfig && (0, $dh538.fg)('platform_media_video_captions') && (0, $dh538.fg)('platform_editor_video_caption_commit') ? provider.viewAndUploadMediaClientConfig : provider.viewMediaClientConfig;
};
const $bd8a5c6aad625abd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $42omo.useState)(()=>(0, $1oCLl.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true) ? ssr?.config : undefined);
    const providerFactory = (0, $6mbqi.useProviderFactory)();
    const mediaProvider = (0, $6mbqi.useProviderLayout)('mediaProvider');
    /**
   * Whether this renderer has its own media provider and should never inherit
   * the mediaClient from a parent renderer's context.
   *
   * We use providerFactory.hasProvider() rather and checking the mediaProvider
   * state value, because useProviderLayout subscribes via useLayoutEffect —
   * meaning mediaProvider state is always undefined on the first render, even
   * if the ProviderFactory already has a provider registered. This would cause
   * shouldSkipContext to be false on the first render, incorrectly allowing the
   * inner renderer to inherit the outer renderer's MediaClientContext (which
   * carries the wrong media token for this page).
   *
   * hasProvider() is synchronous and correct from render 1, closing that window.
   */ const shouldSkipContext = (0, $1oCLl.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true) ? Boolean(ssr?.config || providerFactory.hasProvider('mediaProvider') || mediaProvider) : Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $42omo.useMemo)(()=>mediaClientConfig ? (0, $grxv4.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    // When the experiment is enabled, use useEffect instead of useLayoutEffect because:
    // - For the ssr.config branch: useState is already initialised with ssr.config, so this
    //   effect is a no-op on first render — the "before paint" guarantee is irrelevant.
    // - For the mediaProvider branch: the actual work happens inside a Promise callback which
    //   resolves asynchronously, so it can never run before paint regardless of which hook
    //   schedules it — useLayoutEffect's guarantee is equally irrelevant here.
    // The legacy path keeps useLayoutEffect to preserve existing behaviour when the experiment is off.
    //
    // The two hooks below are mutually exclusive — only one runs per render — so there is no
    // actual chaining of state updates at runtime. The lint rule cannot statically prove this.
    (0, $42omo.useEffect)(()=>{
        if (!(0, $1oCLl.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true)) return;
        if (ssr?.config) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        setMediaClientConfig(ssr.config);
        else if (mediaProvider) {
            let cancelled = false;
            // Cancellation flag prevents setMediaClientConfig from being called after
            // unmount or when mediaProvider changes mid-flight (stale promise fix).
            // No .catch() is needed — the media provider is not expected to reject,
            // and a catch handler would be a no-op anyway.
            mediaProvider.then((provider)=>{
                if (!cancelled) setMediaClientConfig($bd8a5c6aad625abd$var$getMediaClientConfigForRenderer(provider));
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        mediaProvider,
        ssr?.config
    ]);
    // Legacy path (experiment off): keep useLayoutEffect to preserve existing behaviour.
    // remove this when clean up platform_editor_media_reliability_enhancements
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true)) return;
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig($bd8a5c6aad625abd$var$getMediaClientConfigForRenderer(provider));
        });
    }, [
        mediaProvider,
        ssr?.config
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3rvSa.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient
    }, children);
};



var $iNqGB = parcelRequire("iNqGB");


var $bBvs5 = parcelRequire("bBvs5");


var $b7FrM = parcelRequire("b7FrM");


var $lspPP = parcelRequire("lspPP");


var $bZfVt = parcelRequire("bZfVt");


var $9KIOh = parcelRequire("9KIOh");


var $d7o2V = parcelRequire("d7o2V");


var $fZRom = parcelRequire("fZRom");

/* eslint-disable jsdoc/require-jsdoc -- SSR inline script helpers */ 



var $fJNzZ = parcelRequire("fJNzZ");





var $1zvWv = parcelRequire("1zvWv");




function $a8c331734550a1c3$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const shouldSkipScript = {
        table: (0, $dh538.fg)('platform-ssr-table-resize')
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $a8c331734550a1c3$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $a8c331734550a1c3$export$92859d13f30c883e(id, shouldSkipScript) {
    const flags = {
        platform_editor_fix_media_in_renderer: (0, $dh538.fg)('platform_editor_fix_media_in_renderer'),
        platform_editor_renderer_extension_width_fix: (0, $1oCLl.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)
    };
    return `(function(window){
if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }
${$a8c331734550a1c3$export$47813c4121c8b4b3};
(${$a8c331734550a1c3$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${JSON.stringify(shouldSkipScript)}, ${JSON.stringify(flags)});
})(window);
`;
}
const $a8c331734550a1c3$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $fJNzZ.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $fJNzZ.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $fJNzZ.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $fJNzZ.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $fJNzZ.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $fJNzZ.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $1zvWv.FullPagePadding).toString()};
`;
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a8c331734550a1c3$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript, flags) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- inline script runs in browser document context
    document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const nodeType = node.dataset.nodeType;
                const widthType = node.dataset.widthType;
                const isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                isMediaSingleWithPixelWidth && flags['platform_editor_fix_media_in_renderer'] || isExtension && flags['platform_editor_renderer_extension_width_fix']) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target, flags);
        });
    });
    const applyMediaBreakout = (card, flags)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override width
        if (isPixelBasedResizing) return;
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width) card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $a8c331734550a1c3$export$2a0b3eeee3f2ea40 = (0, $fJNzZ.breakoutConsts).calcLineLength((0, $fJNzZ.breakoutConsts));



var $jTudT = parcelRequire("jTudT");


var $ozLJl = parcelRequire("ozLJl");

function $d3e1cf2918b1cf26$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $ozLJl.mediaViewerPopupClass))) return true;
    if (element.classList.contains((0, $jTudT.fileCardImageViewSelector))) return true;
    return false;
}



var $1Qaul = parcelRequire("1Qaul");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766






const $af8e00728130c250$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $9K4OG.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, #00000000)"}, ${backgroundColor} )`
        }
    });
const $af8e00728130c250$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $af8e00728130c250$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: styles
    }, children);
};
class $af8e00728130c250$export$79ad592494094f07 extends (0, $42omo.Component) {
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, #FFFFFF)", children: children } = this.props;
        return /*#__PURE__*/ (0, $9K4OG.jsx)($af8e00728130c250$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
    constructor(props){
        super(props);
    }
}



var $iZq0X = parcelRequire("iZq0X");

/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766










var $jVL42 = parcelRequire("jVL42");


var $aFUXX = parcelRequire("aFUXX");


var $fhm10 = parcelRequire("fhm10");


var $3HdsG = parcelRequire("3HdsG");


var $5MaNT = parcelRequire("5MaNT");

var $7bDsi = parcelRequire("7bDsi");

var $4mSjx = parcelRequire("4mSjx");

var $gnMzP = parcelRequire("gnMzP");

var $cV5SN = parcelRequire("cV5SN");

var $1zav4 = parcelRequire("1zav4");

var $9Fl9f = parcelRequire("9Fl9f");

var $7iisy = parcelRequire("7iisy");


var $ghpxT = parcelRequire("ghpxT");

var $fGuiW = parcelRequire("fGuiW");


var $frt7o = parcelRequire("frt7o");

var $i0VQt = parcelRequire("i0VQt");








var $2jkq1 = parcelRequire("2jkq1");


var $1j8OE = parcelRequire("1j8OE");


var $j2w4t = parcelRequire("j2w4t");


var $ilPbq = parcelRequire("ilPbq");




const $ec7cc60cabf60b92$export$8e2864079bc476bd = (appearance, contentMode)=>{
    if (contentMode === 'compact') return 0, $aFUXX.akEditorFullPageDenseFontSize;
    return appearance && appearance !== 'comment' ? (0, $aFUXX.akEditorFullPageDefaultFontSize) : 14;
};



var $fhsiz = parcelRequire("fhsiz");

var $98HrB = parcelRequire("98HrB");





var $dZ8uq = parcelRequire("dZ8uq");


var $e6n00 = parcelRequire("e6n00");

function $913a570f210a4bc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $913a570f210a4bc3$var$wrappedMediaBreakoutPoint = 410;
const $913a570f210a4bc3$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $913a570f210a4bc3$var$tableShadowWidth = 32;
const $913a570f210a4bc3$var$LAYOUT_BREAKPOINT_RENDERER = 629;
const $913a570f210a4bc3$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME = 'remix-block-highlight';
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $913a570f210a4bc3$var$tableRowHeight = 44;
const $913a570f210a4bc3$var$isBackgroundClipBrowserFixNeeded = ()=>{
    const browser = (0, $d7ZU3.getBrowserInfo)();
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
const $913a570f210a4bc3$var$baseFontStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    font: (0, $ilPbq.default)('editor.font.body')
});
const $913a570f210a4bc3$var$fontSizeStyles = {
    name: "jdulnm",
    styles: ".fabric-editor-font-size{&[data-font-size='small']{font:var(--ak-renderer-editor-font-small-text);}}li:has(> .fabric-editor-font-size[data-font-size='small'])::marker{font:var(--ak-renderer-editor-font-small-text);}"
};
const $913a570f210a4bc3$var$originalBaseFontLineHeight = {
    name: "1dw7ik1",
    styles: "line-height:1.5rem"
};
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $913a570f210a4bc3$var$baseStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    color: "var(--ds-text, #292A2E)",
    '--ak-editor--full-width-layout-width': `${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px`,
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    [`& span.akActionMark`]: {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: "var(--ds-link, #1868DB)",
            textDecoration: 'underline'
        },
        '&:active': {
            color: "var(--ds-link-pressed, #1558BC)"
        }
    },
    '& span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #6B6E76)"
    }
});
const $913a570f210a4bc3$var$headingAnchorStylesDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: 'translate(-8px, 0px)',
                    transitionProperty: 'opacity, transform',
                    transitionDuration: `${"var(--ds-duration-medium, 0.2s)"}, ${"var(--ds-duration-medium, 0.2s)"}`,
                    transitionTimingFunction: `${"var(--ds-easing-out-practical, ease)"}, ${"var(--ds-easing-out-practical, ease)"}`,
                    transitionDelay: '0s, 0s'
                }
            },
            '&:hover': {
                [`.${0, $3HdsG.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $913a570f210a4bc3$var$headingAnchorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $3HdsG.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    // Line-height for heading anchor based on heading level (via data-level attribute on .renderer-heading-wrapper)
    '& .renderer-heading-wrapper[data-level="1"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $913a570f210a4bc3$var$headingAnchorButtonFocusVisibleStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
        'button:focus-visible': {
            outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
            borderRadius: "var(--ds-radius-small, 3px)"
        }
    }
});
const $913a570f210a4bc3$var$akEditorBreakpointForSmallDevice = '1266px';
const $913a570f210a4bc3$var$responsiveBreakoutWidth = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - ${(0, $aFUXX.akEditorGutterPadding)}px * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$913a570f210a4bc3$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $913a570f210a4bc3$var$responsiveBreakoutWidthFullWidth = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$913a570f210a4bc3$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $913a570f210a4bc3$var$responsiveBreakoutWidthWithReducedPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$913a570f210a4bc3$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidth)}px`
    },
    [`@media (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`
    }
});
const $913a570f210a4bc3$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererFullPageStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $1zvWv.FullPagePadding)}px`
});
const $913a570f210a4bc3$var$rendererFullPageStylesWithReducedPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-renderer--full-page-gutter': `${(0, $1zvWv.FullPagePadding)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 var(--ak-renderer--full-page-gutter)`,
    [`@media (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-renderer--full-page-gutter': `${(0, $aFUXX.akEditorGutterPaddingReduced)}px`
    }
});
const $913a570f210a4bc3$var$oldRendererFullWidthStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $913a570f210a4bc3$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $913a570f210a4bc3$var$oldRendererMaxWidthStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $913a570f210a4bc3$var$rendererMaxWidthStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $913a570f210a4bc3$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
const $913a570f210a4bc3$var$rovoTelepointerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`#${$913a570f210a4bc3$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '24px',
        backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            width: '31.5px',
            height: '15.5px',
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
            'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
        },
        '&::before': {
            content: '"Rovo"',
            position: 'absolute',
            fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            color: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-text, #292A2E)",
            top: 1,
            left: 1,
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            zIndex: 1,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            padding: '0.5px 2.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});
const $913a570f210a4bc3$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $913a570f210a4bc3$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $913a570f210a4bc3$var$headingsSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 20px)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    }
});
/**
 * When the copy-link a11y fix is enabled, the heading copy-link button is a sibling of the heading
 * text within `.renderer-heading-wrapper`. To ensure the button sits immediately after the last
 * rendered character (including when the heading wraps), the heading itself needs to participate in
 * inline layout.
 *
 * Since inline elements don't support vertical margins in normal flow, we migrate the UGC heading
 * `marginTop` values (from `headingsSharedStyles`) onto the wrapper.
 */ const $913a570f210a4bc3$var$headingWrapperInlineFlowStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Ensure heading and copy-link button participate in inline flow so the button sits after the final wrapped line of text.
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        display: 'inline'
    },
    [`& .renderer-heading-wrapper > .${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
        display: 'inline',
        verticalAlign: 'baseline'
    },
    '& .renderer-heading-wrapper[data-level="1"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em'
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em'
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.25em'
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em'
    }
});
const $913a570f210a4bc3$var$headingWithAlignmentStylesDuplicateAnchor = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $913a570f210a4bc3$var$headingWithAlignmentStyles = {
    name: "1abdc8p",
    styles: ".fabric-editor-block-mark[data-align=\"center\"] > .renderer-heading-wrapper{justify-content:center;}.fabric-editor-block-mark[data-align=\"end\"] > .renderer-heading-wrapper{justify-content:flex-end;}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $913a570f210a4bc3$var$ruleSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $aFUXX.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $913a570f210a4bc3$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $aFUXX.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $913a570f210a4bc3$var$paragraphStylesUGCScaledMargin = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $aFUXX.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $913a570f210a4bc3$var$paragraphSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $aFUXX.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $aFUXX.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $913a570f210a4bc3$var$paragraphSharedStyleScaledMargin = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $aFUXX.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $aFUXX.scaledBlockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $913a570f210a4bc3$var$listsSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $4mSjx.listItemCounterPadding)}px)`
    },
    [`${0, $fGuiW.orderedListSelector}, ${0, $ghpxT.bulletListSelector}`]: {
        /*
    Ensures list item content adheres to the list's margin instead
    of filling the entire block row. This is important to allow
    clicking interactive elements which are floated next to a list.
    	For some history and context on this block, see PRs related to tickets.:
    @see ED-6551 - original issue.
    @see ED-7015 - follow up issue.
    @see ED-7447 - flow-root change.
    	used to have display: 'table' in tag template style but not supported in object styles
    removed display: 'table' as 'flow-root' is supported in latest browsers
    	@see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $913a570f210a4bc3$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
/**
 * Hides list markers for "wrapper items" - list items that only contain nested lists with no other content.
 * These wrapper items have no meaningful content themselves, only nested lists below.
 * Applied when platform_editor_flexible_list_schema experiment is enabled.
 */ const $913a570f210a4bc3$var$listItemHiddenMarkerStyles = {
    name: "j8szsq",
    styles: "li:has(> ul:only-child), li:has(> ol:only-child){list-style-type:none;margin-top:0;margin-bottom:0;}li:has(> ul:only-child) > ul, li:has(> ol:only-child) > ol{margin-top:0;}div[data-task-list-local-id] > div[data-task-list-local-id]{margin-top:0;}div[data-task-local-id] + div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);}"
};
const $913a570f210a4bc3$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $913a570f210a4bc3$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $aFUXX.blockNodesVerticalMargin)
        }
    }
});
const $913a570f210a4bc3$var$blockMarksSharedStylesDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $913a570f210a4bc3$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        },
        '.renderer-heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                'h1, h2, h3, h4, h5, h6': {
                    marginTop: 0
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #0515240F)"})`,
        color: "var(--ds-text, #292A2E)",
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $913a570f210a4bc3$var$extensionStyle = {
    name: "188isfx",
    styles: ".ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *){font-size:var(--ak-renderer-base-font-size);}"
};
const $913a570f210a4bc3$var$oldExtensionAsInlineStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        // use !important here because the current width has !important applied to it and it's not working when used in React style prop
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        marginTop: 0
    },
    [`.${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jVL42.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
const $913a570f210a4bc3$var$extensionAsInlineStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        width: 'auto',
        marginTop: 0
    },
    [`.${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jVL42.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
// Removes the blockNodesVerticalMargin styling for inline extensions, i.e. borderless excerpt-include
const $913a570f210a4bc3$var$inlineExtensionRendererMarginFix = {
    name: "vgr91k",
    styles: ".ak-renderer-document .inline-extension-renderer .ak-renderer-extension{margin-top:0;}"
};
const $913a570f210a4bc3$var$shadowSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $aFUXX.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $i0VQt.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $i0VQt.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $913a570f210a4bc3$var$dateSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $7bDsi.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $913a570f210a4bc3$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $913a570f210a4bc3$var$backgroundColorStyles = {
    name: "1rjaz80",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
// Don't show text highlight styling when there is a hyperlink.
// Conditionally applied when the highlight-on-links experiment is off.
const $913a570f210a4bc3$var$highlightLinksUnsetStyles = {
    name: "1d6748d",
    styles: "a .fabric-background-color-mark{background-color:unset;}"
};
const $913a570f210a4bc3$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $913a570f210a4bc3$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $7iisy.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $aFUXX.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $7iisy.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $aFUXX.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $aFUXX.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $aFUXX.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $aFUXX.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-150, 12px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $913a570f210a4bc3$var$headingPanelStyles = {
    name: "e0for6",
    styles: ".ak-editor-panel__content{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $913a570f210a4bc3$var$smartCardStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $913a570f210a4bc3$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $913a570f210a4bc3$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $913a570f210a4bc3$var$smartCardStylesAvatarListZeroMarginTop = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginTop: 0
        }
    }
});
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
const $913a570f210a4bc3$var$headerSmartCardStyles = {
    name: "qwtpmh",
    styles: "[data-inline-card=\"true\"]{[data-inlinecard-button-overlay=\"icon-wrapper-line-height\"] span{line-height:0;}}"
};
// Flex wrapper for centering without transform (platform_editor_flex_based_centering).
// flex: 1 1 0% + minWidth: 0 so the wrapper takes full width when it's a flex item (full-width nodes otherwise render narrow).
// flexShrink: 0 on child so the node keeps size.
const $913a570f210a4bc3$var$centerWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        flex: '1 1 0%',
        minWidth: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flexShrink: 0
        }
    }
});
const $913a570f210a4bc3$var$baseOtherStylesDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + .${0, $gnMzP.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.image-align-start,
		.${0, $gnMzP.richMediaClassName}.image-center,
		.${0, $gnMzP.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $jVL42.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $jVL42.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $aFUXX.blockNodesVerticalMargin)}`
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $jVL42.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* platform_editor_flex_based_centering: embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $i0VQt.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $913a570f210a4bc3$var$hideExtensionStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).EXTENSION}:has([data-extension-key='hide'])`]: {
        marginTop: 0
    }
});
const $913a570f210a4bc3$var$extensionCenterAlignLegacyStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        }
    }
});
const $913a570f210a4bc3$var$baseOtherStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + .${0, $gnMzP.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.image-align-start,
		.${0, $gnMzP.richMediaClassName}.image-center,
		.${0, $gnMzP.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $jVL42.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $jVL42.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $aFUXX.blockNodesVerticalMargin)}`
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $jVL42.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* platform_editor_flex_based_centering: embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $i0VQt.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $913a570f210a4bc3$var$alignedHeadingAnchorStyleDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $913a570f210a4bc3$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        '.renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                position: 'relative'
            }
        }
    },
    // Center alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="center"] > .renderer-heading-wrapper': {
        justifyContent: 'center'
    },
    // Right/end alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="end"] > .renderer-heading-wrapper': {
        justifyContent: 'flex-end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $913a570f210a4bc3$var$firstWrappedMediaStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
    [`.${0, $gnMzP.richMediaClassName}[class*="image-wrap-"]:has(+ .${0, $gnMzP.richMediaClassName}[class*="image-wrap-"])`]: {
        marginRight: 0,
        marginLeft: 0
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $913a570f210a4bc3$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $gnMzP.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $gnMzP.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-right, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$913a570f210a4bc3$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            marginTop: "var(--ds-space-150, 12px)",
            marginRight: 0,
            marginBottom: "var(--ds-space-150, 12px)",
            marginLeft: 0
        }
    }
});
// was shared between editor-core and renderer
const $913a570f210a4bc3$var$tableSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E7F9FF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFECEB)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #CFE1FD)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #C6EDFB)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #BAF3DB)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #F5E989)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFD5D2)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #EED7FC)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #8C8F97)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #669DF1)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #6CC3E0)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #4BCE97)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FCA700)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #C97CF4)"} !important`
    },
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        marginTop: 0,
        marginRight: 'auto',
        marginBottom: "var(--ds-space-200, 16px)",
        marginLeft: 'auto',
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $aFUXX.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
    },
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: "var(--ds-space-100, 8px)",
        marginBottom: 0,
        marginLeft: 0
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $1zav4.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '&[data-initial-width-mode="content"]': {
            tableLayout: 'auto',
            width: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
                    [`&:not(.${0, $aFUXX.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #0B120E24)"}`
                    },
                    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, #0515240F)"
                    }
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$roundedTableRemixBlockHighlightStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}.${$913a570f210a4bc3$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > table,
	.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}.${$913a570f210a4bc3$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > .${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}.${$913a570f210a4bc3$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '&::after': {
            borderColor: "var(--ds-border-selected, #1868DB)"
        }
    }
});
const $913a570f210a4bc3$var$roundedTableOuterBorderOverlayStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderColor: 'transparent',
        position: 'relative',
        '&::after': {
            content: "''",
            position: 'absolute',
            inset: '-0.5px',
            border: `${(0, $1zav4.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRadius: "var(--ds-radius-xlarge, 12px)",
            pointerEvents: 'none',
            zIndex: 1
        },
        '> tbody > tr > th[data-reaches-top], > tbody > tr > td[data-reaches-top]': {
            borderTopColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-bottom], > tbody > tr > td[data-reaches-bottom]': {
            borderBottomColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            borderLeftColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            borderRightColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-left], > tbody > tr > td[data-reaches-top][data-reaches-left]': {
            borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box',
            clipPath: `inset(0 round ${"var(--ds-radius-xlarge, 12px)"} 0 0 0)`
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-right], > tbody > tr > td[data-reaches-top][data-reaches-right]': {
            borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box',
            clipPath: `inset(0 round 0 ${"var(--ds-radius-xlarge, 12px)"} 0 0)`
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-left], > tbody > tr > td[data-reaches-bottom][data-reaches-left]': {
            borderBottomLeftRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box',
            clipPath: `inset(0 round 0 0 0 ${"var(--ds-radius-xlarge, 12px)"})`
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-right], > tbody > tr > td[data-reaches-bottom][data-reaches-right]': {
            borderBottomRightRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box',
            clipPath: `inset(0 round 0 0 ${"var(--ds-radius-xlarge, 12px)"} 0)`
        }
    },
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`]: {
        borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
        borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },
    // Keep the cloned sticky header rounded at the top while preserving a square bottom edge.
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '&::after': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        '> tbody > tr': {
            // The sticky table clone sets a row background locally; force it off so
            // the rounded header cells, not a square row box, own the visible fill.
            background: 'transparent !important'
        },
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
            borderBottomLeftRadius: 0,
            clipPath: `inset(0 round ${"var(--ds-radius-xlarge, 12px)"} 0 0 0)`
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
            borderBottomRightRadius: 0,
            clipPath: `inset(0 round 0 ${"var(--ds-radius-xlarge, 12px)"} 0 0)`
        },
        '> tbody > tr > th[data-reaches-left][data-reaches-bottom], > tbody > tr > td[data-reaches-left][data-reaches-bottom]': {
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right][data-reaches-bottom], > tbody > tr > td[data-reaches-right][data-reaches-bottom]': {
            borderBottomRightRadius: 0
        },
        '> tbody > tr > th[data-reaches-left]::after, > tbody > tr > td[data-reaches-left]::after': {
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right]::after, > tbody > tr > td[data-reaches-right]::after': {
            borderBottomRightRadius: 0
        }
    }
});
const $913a570f210a4bc3$var$tableContentModeStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}:has(table[data-initial-width-mode="content"])`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'max-content !important',
        maxWidth: 'var(--renderer-table-max-width)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > colgroup > col`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'unset !important'
    }
});
const $913a570f210a4bc3$var$tableContentModeNestedTableStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Nested tables may sit inside expands, extensions, or other blocks within the parent cell.
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $jVL42.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} > .${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $jVL42.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} > .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        width: 'max-content !important',
        maxWidth: '100%'
    }
});
const $913a570f210a4bc3$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $1zav4.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $913a570f210a4bc3$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
    }
});
const $913a570f210a4bc3$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $913a570f210a4bc3$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $913a570f210a4bc3$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $1zav4.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $1zav4.tableMarginTop)}px)`,
            zIndex: `${(0, $aFUXX.akEditorStickyHeaderZIndex)}`,
            width: `${$913a570f210a4bc3$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $i0VQt.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $i0VQt.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $1zav4.tableMarginTop)}px)`
        }
    }
});
const $913a570f210a4bc3$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$913a570f210a4bc3$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $913a570f210a4bc3$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $1zav4.tableCellPadding)}px`,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-shape
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${"var(--ds-border-focused, #4688EC)"}`
                        }
                    }
                },
                [`> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
// Sortable header cells render content inside an extra div, so mirror the th alignment there.
const $913a570f210a4bc3$var$rendererTableSortableColumnValignStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`th[data-valign='middle'].${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} > .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            [`th[data-valign='bottom'].${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} > .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end'
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $jVL42.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`,
                borderRight: `${"var(--ds-border-width, 1px)"} solid
								${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
                width: `${(0, $aFUXX.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${"var(--ds-text-subtlest, #6B6E76)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $jVL42.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '> .renderer-heading-wrapper': {
                        // Reserve space for the sortable-column icon so the heading+anchor wrapper never overlaps it.
                        // Use padding (instead of margin on the heading) so we don't create a gap between the heading
                        // text and the copy-link anchor button
                        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                        paddingRight: '30px'
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $913a570f210a4bc3$var$stickyHeaderStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $aFUXX.akEditorStickyHeaderZIndex)}`,
        borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $aFUXX.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -0.5px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			inset -1px 0px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $913a570f210a4bc3$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $aFUXX.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}
		> .${(0, $j2w4t.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $aFUXX.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $aFUXX.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $aFUXX.blockNodesVerticalMargin)
        }
    }
});
const $913a570f210a4bc3$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $913a570f210a4bc3$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $913a570f210a4bc3$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $aFUXX.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $aFUXX.akEditorLineHeight)}em !important`
        }
    }
});
const $913a570f210a4bc3$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $913a570f210a4bc3$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $913a570f210a4bc3$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$913a570f210a4bc3$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $913a570f210a4bc3$var$rendererAnnotationStylesOld = /*#__PURE__*/ (0, $9K4OG.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    }
});
const $913a570f210a4bc3$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    },
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'][data-has-focus='true'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
});
const $913a570f210a4bc3$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        paddingRight: 0,
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: 0,
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP = `max(0px,calc((var(--ak-renderer-base-font-size) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px)* (4/3)))`;
const $913a570f210a4bc3$var$TASKLIST_CONTAINER_DENSE_MARGIN = `max(calc(10px + (var(--ak-renderer-base-font-size) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) *( 2 / 3)))`;
const $913a570f210a4bc3$var$scaledDenseEmojiStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`,
        minHeight: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`,
        minWidth: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`,
        maxHeight: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
        maxWidth: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
        width: `${(0, $fhsiz.denseEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.denseEmojiHeightH2)}px`,
        width: `${(0, $fhsiz.denseEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.denseEmojiHeightH3)}px`,
        width: `${(0, $fhsiz.denseEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.denseEmojiHeightH4)}px`,
        width: `${(0, $fhsiz.denseEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`,
        width: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        minHeight: `${(0, $fhsiz.defaultInlineEmojiHeight)}px`,
        minWidth: `${(0, $fhsiz.defaultInlineEmojiHeight)}px`,
        height: `${(0, $fhsiz.defaultInlineEmojiHeight)}px`,
        width: `${(0, $fhsiz.defaultInlineEmojiHeight)}px`
    }
});
const $913a570f210a4bc3$var$scaledDenseUnicodeEmojiStylesNew = /*#__PURE__*/ (0, $9K4OG.css)({
    [`[data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.defaultDenseEmojiHeight)}px`
    },
    [`h1 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.denseEmojiHeightH1)}px`
    },
    [`h2 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.denseEmojiHeightH2)}px`
    },
    [`h3 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.denseEmojiHeightH3)}px`
    },
    [`h4 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.denseEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.defaultDenseEmojiHeight)}px`
    }
});
const $913a570f210a4bc3$var$scaledEmojiStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        minHeight: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        minWidth: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        maxHeight: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        maxWidth: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        width: `${(0, $fhsiz.scaledEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.scaledEmojiHeightH2)}px`,
        width: `${(0, $fhsiz.scaledEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.scaledEmojiHeightH3)}px`,
        width: `${(0, $fhsiz.scaledEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.scaledEmojiHeightH4)}px`,
        width: `${(0, $fhsiz.scaledEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        width: `${(0, $fhsiz.defaultEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        minHeight: `${(0, $fhsiz.defaultInlineEmojiHeight)}px`,
        minWidth: `${(0, $fhsiz.defaultInlineEmojiHeight)}px`,
        height: `${(0, $fhsiz.defaultInlineEmojiHeight)}px`,
        width: `${(0, $fhsiz.defaultInlineEmojiHeight)}px`
    }
});
const $913a570f210a4bc3$var$scaledUnicodeEmojiStylesNew = /*#__PURE__*/ (0, $9K4OG.css)({
    [`[data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.defaultEmojiHeight)}px`
    },
    [`h1 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.scaledEmojiHeightH1)}px`
    },
    [`h2 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.scaledEmojiHeightH2)}px`
    },
    [`h3 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.scaledEmojiHeightH3)}px`
    },
    [`h4 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.scaledEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $fhsiz.defaultEmojiHeight)}px`
    }
});
const $913a570f210a4bc3$var$denseStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Scale emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `calc(${(0, $fhsiz.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $aFUXX.akEditorFullPageDefaultFontSize)})`,
        width: `calc(${(0, $fhsiz.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $aFUXX.akEditorFullPageDefaultFontSize)})`,
        maxHeight: `calc(${(0, $fhsiz.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $aFUXX.akEditorFullPageDefaultFontSize)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    // Scale panel icon
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .ak-editor-panel .ak-editor-panel__icon`]: {
        height: "var(--ds-space-250, 20px)",
        width: "var(--ds-space-250, 20px)"
    },
    // Condense spacing across lists, tasks and decisions
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        // Adjacent list items
        'li + li': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        },
        // Nested lists directly under an li (unordered and ordered)
        'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        },
        // Task lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id]': {
            // Task lists: container top margin
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$TASKLIST_CONTAINER_DENSE_MARGIN
        },
        // Task lists: sibling items and nested lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] > * + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        }
    }
});
const $913a570f210a4bc3$var$syncBlockRendererStyles = {
    name: "g5u32w",
    styles: "margin:0;max-width:none;padding:0"
};
/**
 * Fake left/right table borders.
 *
 * Adapted from the editor-plugin-table behavior (see editor-common's
 * `tableSharedStyle()` in `editor-common/src/styles/shared/table.ts`). The
 * visible vertical edges of the table are painted by these absolutely-positioned
 * 1px divs that live inside the (non-scrolling) TABLE_CONTAINER, while the real
 * <table> left/right borders are made `transparent`. Because the divs are not
 * inside the horizontally scrolling TABLE_NODE_WRAPPER, they remain visible
 * regardless of scroll position — fixing the missing right border when an
 * overflowing table inside a reference synced block is scrolled all the way to
 * the left.
 *
 * The `height` formula adjusted for table in renderer
 */ const $913a570f210a4bc3$var$tableFakeBorderStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        // Mirror the editor's tableSharedStyle() rule from
        // `editor-common/src/styles/shared/table.ts` (lines 142-150). The fake
        // borders are absolutely positioned inside pm-table-container;
        // their height is adjusted for renderer to `100% - space.300 - space.250` so the border runs from
        // the top of the table to the bottom of the container
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_RIGHT_BORDER},
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_LEFT_BORDER}`]: {
            display: 'block',
            width: '1px',
            height: `calc(100% - ${"var(--ds-space-300, 24px)"} - ${"var(--ds-space-250, 20px)"})`,
            background: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
            position: 'absolute',
            top: "var(--ds-space-300, 24px)"
        },
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_RIGHT_BORDER}`]: {
            right: 0
        },
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_LEFT_BORDER},
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_LEFT_BORDER}[data-with-numbered-table='true']`]: {
            left: 0
        }
    },
    // Make the real left/right table borders transparent so the fake border
    // divs above are the only painted vertical edges. Top/bottom borders on the
    // <table> element remain visible.
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent'
    }
});
const $913a570f210a4bc3$var$roundedTableFakeBorderOverlayStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_RIGHT_BORDER},
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_LEFT_BORDER}`]: {
            display: 'none'
        }
    }
});
const $913a570f210a4bc3$var$syncBlockStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).renderer}, .${(0, $e6n00.SyncBlockSharedCssClassName).error}, .${(0, $e6n00.SyncBlockSharedCssClassName).loading}`]: {
        borderRadius: "var(--ds-radius-small, 3px)",
        marginTop: "var(--ds-space-075, 6px)",
        paddingBlock: "var(--ds-space-150, 12px)",
        overflow: 'visible'
    },
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}`]: {
        // First child node in syncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-renderer-document > :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).renderer}`]: {
        // First child node in bodiedSyncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '> :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).error}`]: {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    },
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).loading}`]: {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $913a570f210a4bc3$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, contentMode: contentMode, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId, isInsideSyncBlock: isInsideSyncBlock } = props;
    const isAdvancedLayoutsOn = (0, $iu6m9.editorExperiment)('advanced_layouts', true);
    const isPreviewPanelResponsivenessOn = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    const baseFontSize = (0, $ec7cc60cabf60b92$export$8e2864079bc476bd)(appearance, contentMode);
    const browser = (0, $d7ZU3.getBrowserInfo)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        role: "none",
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${baseFontSize}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $ilPbq.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $ilPbq.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $ilPbq.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $ilPbq.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $ilPbq.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $ilPbq.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $ilPbq.default)('editor.font.body')}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- CSS custom properties for UGC font tokens
            ...(0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && {
                '--ak-renderer-editor-font-small-text': (0, $ilPbq.default)('editor.font.body.small')
            }
        },
        css: [
            (0, $1oCLl.expValEquals)('confluence_ttvc_inline_extensions', 'isEnabled', true) ? $913a570f210a4bc3$var$baseFontStyle : $913a570f210a4bc3$var$originalBaseFontLineHeight,
            $913a570f210a4bc3$var$baseStyles,
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && $913a570f210a4bc3$var$fontSizeStyles,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$headingAnchorStyles : $913a570f210a4bc3$var$headingAnchorStylesDuplicateAnchor,
            $913a570f210a4bc3$var$headingAnchorButtonFocusVisibleStyles,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$hideHeadingCopyLinkWrapperStyles : $913a570f210a4bc3$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$rendererFullPageStyles,
            appearance === 'full-width' && ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $913a570f210a4bc3$var$rendererFullWidthStyles : $913a570f210a4bc3$var$oldRendererFullWidthStyles),
            (appearance === 'full-width' || appearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && !(0, $2jkq1.isTableResizingEnabled)(appearance) && $913a570f210a4bc3$var$rendererFullWidthStylesForTableResizing,
            appearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $913a570f210a4bc3$var$rendererMaxWidthStyles : $913a570f210a4bc3$var$oldRendererMaxWidthStyles),
            $913a570f210a4bc3$var$rovoTelepointerStyles,
            $913a570f210a4bc3$var$whitespaceSharedStyles,
            $913a570f210a4bc3$var$blockquoteSharedStyles,
            $913a570f210a4bc3$var$headingsSharedStyles,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $913a570f210a4bc3$var$headingWrapperInlineFlowStyles,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$headingWithAlignmentStyles : $913a570f210a4bc3$var$headingWithAlignmentStylesDuplicateAnchor,
            $913a570f210a4bc3$var$ruleSharedStyles,
            contentMode === 'compact' && $913a570f210a4bc3$var$extensionStyle,
            (0, $dh538.fg)('platform_editor_typography_ugc') ? contentMode === 'compact' ? $913a570f210a4bc3$var$paragraphStylesUGCScaledMargin : $913a570f210a4bc3$var$paragraphSharedStylesWithEditorUGC : contentMode === 'compact' ? $913a570f210a4bc3$var$paragraphSharedStyleScaledMargin : $913a570f210a4bc3$var$paragraphSharedStyles,
            $913a570f210a4bc3$var$listsSharedStyles,
            browser.gecko && $913a570f210a4bc3$var$listsSharedStylesForGekko,
            (0, $1oCLl.expValEquals)('platform_editor_flexible_list_schema', 'isEnabled', true) && $913a570f210a4bc3$var$listItemHiddenMarkerStyles,
            $913a570f210a4bc3$var$indentationSharedStyles,
            $913a570f210a4bc3$var$indentationSharedStylesWithMarginFix,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$blockMarksSharedStyles : $913a570f210a4bc3$var$blockMarksSharedStylesDuplicateAnchor,
            $913a570f210a4bc3$var$codeMarkSharedStyles,
            $913a570f210a4bc3$var$shadowSharedStyle,
            $913a570f210a4bc3$var$dateSharedStyle,
            $913a570f210a4bc3$var$textColorStyles,
            $913a570f210a4bc3$var$backgroundColorStyles,
            !(0, $1oCLl.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $913a570f210a4bc3$var$highlightLinksUnsetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $913a570f210a4bc3$export$a365082c2a191514,
            $913a570f210a4bc3$var$tasksAndDecisionsStyles,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $913a570f210a4bc3$var$headingPanelStyles,
            $913a570f210a4bc3$var$smartCardStyles,
            $913a570f210a4bc3$var$smartCardStylesAvatarFix,
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true) && $913a570f210a4bc3$var$headerSmartCardStyles,
            $913a570f210a4bc3$var$smartCardStylesAvatarMarginFix,
            $913a570f210a4bc3$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') && ((0, $1oCLl.expValEquals)('confluence_fe_renderer_inline_node_mark_color_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$rendererAnnotationStyles : $913a570f210a4bc3$var$rendererAnnotationStylesOld),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') && $913a570f210a4bc3$var$rendererAnnotationStylesCommentHeightFix,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$baseOtherStyles : $913a570f210a4bc3$var$baseOtherStylesDuplicateAnchor,
            !(0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) && $913a570f210a4bc3$var$extensionCenterAlignLegacyStyles,
            // this should be placed after baseOtherStyles
            (0, $1oCLl.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true) && ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $913a570f210a4bc3$var$extensionAsInlineStyle : $913a570f210a4bc3$var$oldExtensionAsInlineStyle),
            $913a570f210a4bc3$var$inlineExtensionRendererMarginFix,
            allowNestedHeaderLinks && ((0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$alignedHeadingAnchorStyle : $913a570f210a4bc3$var$alignedHeadingAnchorStyleDuplicateAnchor),
            $913a570f210a4bc3$var$mediaSingleSharedStyle,
            // merge firstWrappedMediaStyles with mediaSingleSharedStyle when clean up platform_editor_fix_media_in_renderer
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $913a570f210a4bc3$var$firstWrappedMediaStyles,
            $913a570f210a4bc3$var$tableSharedStyle,
            (0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $913a570f210a4bc3$var$roundedTableOuterBorderOverlayStyles,
            (0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_table_q4_patch_1') && $913a570f210a4bc3$var$roundedTableRemixBlockHighlightStyles,
            (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) && $913a570f210a4bc3$var$tableContentModeStyles,
            (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_table_nested_renderer_fix') && $913a570f210a4bc3$var$tableContentModeNestedTableStyles,
            $913a570f210a4bc3$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $dh538.fg)('platform_editor_bordered_panel_nested_in_table') && $913a570f210a4bc3$var$tableRendererNestedPanelStyles,
            $913a570f210a4bc3$var$isBackgroundClipBrowserFixNeeded() && $913a570f210a4bc3$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $913a570f210a4bc3$var$firstNodeWithNotMarginTopWithNestedDnD : $913a570f210a4bc3$var$firstNodeWithNotMarginTop,
            $913a570f210a4bc3$var$rendererTableStyles,
            (0, $2jkq1.isStickyScrollbarEnabled)(appearance) && $913a570f210a4bc3$var$stickyScrollbarStyles,
            $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $913a570f210a4bc3$var$rendererTableSortableColumnStyles,
            allowColumnSorting && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) && $913a570f210a4bc3$var$rendererTableSortableColumnValignStyles,
            allowColumnSorting && allowNestedHeaderLinks && ((0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks : $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor),
            $913a570f210a4bc3$var$rendererTableColumnStyles,
            $913a570f210a4bc3$var$stickyHeaderStyles,
            $913a570f210a4bc3$var$codeBlockAndLayoutStyles,
            $913a570f210a4bc3$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $913a570f210a4bc3$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $913a570f210a4bc3$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $913a570f210a4bc3$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $913a570f210a4bc3$var$gridRenderForCodeBlockStyles,
            browser.safari && $913a570f210a4bc3$var$codeBlockInListSafariFixStyles,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$responsiveBreakoutWidthWithReducedPadding,
            (appearance === 'full-width' || appearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && $913a570f210a4bc3$var$responsiveBreakoutWidthFullWidth,
            (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? contentMode === 'compact' ? $913a570f210a4bc3$var$scaledDenseEmojiStyles : $913a570f210a4bc3$var$scaledEmojiStyles : contentMode === 'compact' ? $913a570f210a4bc3$var$denseStyles : undefined,
            contentMode === 'compact' ? $913a570f210a4bc3$var$scaledDenseUnicodeEmojiStylesNew : $913a570f210a4bc3$var$scaledUnicodeEmojiStylesNew,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && $913a570f210a4bc3$var$syncBlockStyles,
            $913a570f210a4bc3$var$centerWrapperStyles,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && isInsideSyncBlock ? $913a570f210a4bc3$var$syncBlockRendererStyles : null,
            isInsideSyncBlock && (0, $iu6m9.editorExperiment)('platform_synced_block', true) && $913a570f210a4bc3$var$tableFakeBorderStyles,
            isInsideSyncBlock && (0, $iu6m9.editorExperiment)('platform_synced_block', true) && (0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $913a570f210a4bc3$var$roundedTableFakeBorderOverlayStyles : null,
            (0, $1oCLl.expValEquals)('platform_editor_hide_extension_renderer_support', 'isEnabled', true) && $913a570f210a4bc3$var$hideExtensionStyles
        ],
        "data-testid": testId
    }, children);
};



const $72f5f4ba20544324$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !(child?.type === 'hardBreak' || child?.type === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};


/* eslint-disable jsdoc/require-jsdoc */ 


function $6d2060ea59e4ee09$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $42omo.useRef)(props);
    const prevFactory = (0, $42omo.useRef)(null);
    return (0, $42omo.useMemo)(()=>{
        // check if the serializer is already created
        let shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            const propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}



var $eauJy = parcelRequire("eauJy");










var $e2wMq = parcelRequire("e2wMq");

var $3824I = parcelRequire("3824I");




const $ac23999863c9cf10$export$208d2421b73f3f86 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    const editorWidth = renderer.scrollWidth;
    return {
        action: (0, $3824I.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $lWghV.getBreakpointKey)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $lWghV.getBreakpointKey)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            mode: (0, $e2wMq.MODE).RENDERER
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};
const $ac23999863c9cf10$export$34e5b28c67455a81 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableHeight: table.scrollHeight,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    /** NOTE: Renderer is not scrollable, so this height represents the height of the content */ const rendererClientHeight = renderer.clientHeight;
    const viewportHeight = window.innerHeight;
    if (!viewportHeight) return undefined;
    return {
        action: (0, $3824I.TABLE_ACTION).TABLE_RENDERER_HEIGHT_INFO,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            viewportHeight: viewportHeight,
            rendererHeight: rendererClientHeight,
            maxTableHeight: maxTableHeight,
            maxTableToViewportHeightRatio: maxTableHeight / viewportHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};


function $19370cae7f055953$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19370cae7f055953$export$47b2879ca9bbf67a = 2000;
const $19370cae7f055953$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
const $19370cae7f055953$var$TABLE_INFO_TIMEOUT = 10000;
const $19370cae7f055953$var$RENDER_EVENT_SAMPLE_RATE = 0.2;
const $19370cae7f055953$var$packageName = "platform-pkg";
const $19370cae7f055953$var$packageVersion = "0.0.0-use.local";
const $19370cae7f055953$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $19370cae7f055953$var$handleMouseTripleClickInTables = (event)=>{
    const browser = (0, $d7ZU3.getBrowserInfo)();
    if (browser.ios || browser.android) return;
    const badBrowser = browser.chrome || browser.safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $19370cae7f055953$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $19370cae7f055953$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $b7FrM.findInTree)(targetElement, rendererWrapper, (0, $d3e1cf2918b1cf26$export$3dee5e4542c672d9));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $19370cae7f055953$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $42omo.useRef)(undefined);
    const providerFactory = (0, $42omo.useMemo)(()=>props.dataProviders || new (0, $4FxUL.default)(), [
        props.dataProviders
    ]);
    const { nestedRendererType: nestedRendererType } = (0, $bBvs5.useRendererContext)();
    const createRendererContext = (0, $42omo.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $9ciHB.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined,
                nestedRendererType: // Propagate nestedRendererType into the inner RendererContextProvider so that
                // React components inside the renderer (e.g. Colgroup) can read it via
                // useRendererContext(). Without this, the inner provider overwrites the outer
                // AKRendererWrapper context and nestedRendererType becomes undefined.
                nestedRendererType
            };
        }, [
        nestedRendererType
    ]);
    const fireAnalyticsEventOld = (0, $42omo.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $k7eoe.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $42omo.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $k7eoe.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $iu6m9.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $42omo.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $72f5f4ba20544324$export$c94cfc0c675062a1)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext,
                nestedRendererType: nestedRendererType
            },
            appearance: props.appearance,
            contentMode: props.contentMode,
            onSetLinkTarget: props.onSetLinkTarget,
            disableHeadingIDs: props.disableHeadingIDs,
            headingIdPrefix: props.headingIdPrefix,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionHeight: props.getExtensionHeight,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption,
            shouldDisplayExtensionAsInline: props.shouldDisplayExtensionAsInline
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent,
        nestedRendererType
    ]);
    const serializer = (0, $6d2060ea59e4ee09$export$80ffe7e3c6bf25c3)((serializerProps)=>props.createSerializer?.(serializerProps) ?? new (0, $aUnCJ.default)(serializerProps), deriveSerializerProps, props);
    const localRef = (0, $42omo.useRef)(null);
    const editorRef = props.innerRef || localRef;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $42omo.useMemo)(()=>(0, $jz9wK.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $42omo.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $2T4ch.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $42omo.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- anchor navigation uses document.getElementById for hash targets
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $d925B.ACTION).VIEWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    mode: (0, $59U23.MODE).RENDERER
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $42omo.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $iyDxB.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $42omo.useEffect)(()=>{
        let rafID;
        let heightWidthAnalyticsSetTimeoutID;
        let heightWidthAnalyticsRicID;
        let heightWidthAnalyticsRafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $d925B.ACTION).STARTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $2T4ch.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $NPJKR.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $lWghV.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $19370cae7f055953$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $19370cae7f055953$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) {
                        const event = {
                            action: (0, $d925B.ACTION).RENDERED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                            attributes: {
                                platform: (0, $59U23.PLATFORM).WEB,
                                duration: duration,
                                // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                                ttfb: (0, $8aL2H.getResponseEndTime)(),
                                nodes: (0, $1Qaul.countNodes)(props.document),
                                nestedRendererType: (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? nestedRendererType : undefined,
                                severity: severity
                            },
                            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                        };
                        fireAnalyticsEvent(event);
                        if ((0, $1oCLl.expValEquals)('platform_editor_sample_renderer_rendered_event', 'isEnabled', true) && Math.random() < $19370cae7f055953$var$RENDER_EVENT_SAMPLE_RATE) fireAnalyticsEvent({
                            ...event,
                            action: (0, $d925B.ACTION).RENDERED_SAMPLED
                        });
                    }
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            // send statistics about the heights/widths of the tables on the page for alerting
            heightWidthAnalyticsSetTimeoutID = setTimeout(()=>{
                const requestIdleCallbackFn = ()=>{
                    const renderer = props.innerRef?.current?.querySelector('.ak-renderer-document');
                    if (renderer) {
                        const payload = (0, $ac23999863c9cf10$export$208d2421b73f3f86)(renderer);
                        if (payload) fireAnalyticsEvent(payload);
                        if ((0, $dh538.fg)('platform_editor_table_height_analytics_event')) {
                            const payloadHeight = (0, $ac23999863c9cf10$export$34e5b28c67455a81)(renderer);
                            if (payloadHeight) fireAnalyticsEvent(payloadHeight);
                        }
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') heightWidthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                heightWidthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $19370cae7f055953$var$TABLE_INFO_TIMEOUT);
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (heightWidthAnalyticsSetTimeoutID) window.clearTimeout(heightWidthAnalyticsSetTimeoutID);
            if (heightWidthAnalyticsRafID) window.cancelAnimationFrame(heightWidthAnalyticsRafID);
            if (heightWidthAnalyticsRicID) window.cancelIdleCallback(heightWidthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $42omo.useMemo)(()=>({
            ...createRendererContext(props.featureFlags, props.isTopLevelRenderer),
            timeZone: props.timeZone
        }), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.timeZone
    ]);
    (0, $d95cfbbdf326d486$export$81bdbc2b3f1c95ef)(editorRef, props.document, props.scrollToBlock);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const allowTableInPanel = (0, $gySSb.isPanelNestingTableSupported)(schema);
        const validationOverrides = allowTableInPanel ? {
            ...props.validationOverrides,
            allowTableInPanel: true
        } : props.validationOverrides;
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $lf9Ji.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $72f5f4ba20544324$export$c94cfc0c675062a1)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bBvs5.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9KIOh.ActiveHeaderIdProvider), {
            value: (0, $iNqGB.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6uN0A.default).Provider, {
            // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bZfVt.Provider), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6mbqi.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $iNqGB.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$19370cae7f055953$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a8c331734550a1c3$export$cfc1361be0de4203), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $af8e00728130c250$export$79ad592494094f07), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $iNqGB.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$19370cae7f055953$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iq4lN.default), null));
    }
};
const $19370cae7f055953$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($19370cae7f055953$export$c49fe2316038f3c2);
const $19370cae7f055953$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($19370cae7f055953$var$RendererFunctionalComponentMemoized, props);
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eauJy.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($19370cae7f055953$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $19370cae7f055953$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $d7o2V.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $bBvs5.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $42omo.useContext)((0, $iZq0X.ValidationContext)) || {};
    const validationOverrides = (0, $42omo.useMemo)(()=>({
            allowNestedTables: allowNestedTables
        }), [
        allowNestedTables
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererFunctionalComponentWithPortalContext, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: props.isTopLevelRenderer ?? isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: validationOverrides
    });
}
const $19370cae7f055953$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $ffCOo.FabricEditorAnalyticsContext), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        data: {
            appearance: (0, $fLvO8.getAnalyticsAppearance)(props.appearance),
            packageName: $19370cae7f055953$var$packageName,
            packageVersion: $19370cae7f055953$var$packageVersion,
            componentName: 'renderer',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $0d5221b11c687d15$export$9ac3d19711324187), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fZRom.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kckFS.IntlErrorBoundary), null, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $19370cae7f055953$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, contentMode: contentMode, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- telepointer span for collaborative presence
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $1zvWv.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    const { nestedRendererType: nestedRendererType } = (0, $bBvs5.useRendererContext)();
    (0, $42omo.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation, _index)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $1zvWv.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $1zvWv.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ if (mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && mutation.addedNodes[0]?.id === (0, $1zvWv.TELEPOINTER_ID) || mutation.removedNodes.length === 1 && mutation.removedNodes[0]?.id === (0, $1zvWv.TELEPOINTER_ID))) {
                        const lastChild = renderer.lastChild;
                        if (lastChild) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ const contentElements = lastChild.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            const lastElement = contentElements[contentElements.length - 1];
                            const oldTelepointer = renderer.querySelector(`#${(0, $1zvWv.TELEPOINTER_ID)}`);
                            if (lastElement) {
                                oldTelepointer?.remove();
                                lastElement?.appendChild(createTelepointer());
                            } else {
                                oldTelepointer?.remove();
                                lastChild?.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthProvider), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop -- legacy renderer wrapper appearance classes
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4BBKV.BaseTheme), {
        baseFontSize: (0, $ec7cc60cabf60b92$export$8e2864079bc476bd)(appearance, contentMode)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bd8a5c6aad625abd$export$77218b6ff680865f), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $913a570f210a4bc3$export$8f0929e72efe521f), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles,
        isInsideSyncBlock: nestedRendererType === 'syncedBlock'
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer && (0, $dh538.fg)('platform-ssr-table-resize')) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $19370cae7f055953$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || ((0, $dZ8uq.expValEqualsNoExposure)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && appearance === 'max') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles && (0, $dh538.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $19370cae7f055953$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $19370cae7f055953$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $19370cae7f055953$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($19370cae7f055953$var$RootRendererContext);
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const rendererRef = (0, $42omo.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $42omo.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true)) return(// eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children));
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $19370cae7f055953$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const innerRef = props.innerRef || localRef;
    // @see https://hello.jira.atlassian.cloud/browse/EDITOR-3389
    if (props.appearance === 'max' && !(0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) props.appearance = 'full-width';
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d7o2V.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $19370cae7f055953$export$2e2bcd8739ae039 = $19370cae7f055953$var$RendererWithAnnotationSelection;
module.exports["RendererWithAnalytics"] = $19370cae7f055953$export$af81ffb59b6ef0dd;
module.exports["default"] = $19370cae7f055953$export$2e2bcd8739ae039;

});

parcelRegister("4FxUL", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a192a3f63d3335de$var$isUndefined(x) {
    return x === undefined;
}
class $a192a3f63d3335de$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $a192a3f63d3335de$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$a192a3f63d3335de$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}
module.exports["default"] = $a192a3f63d3335de$export$2e2bcd8739ae039;

});

parcelRegister("6mbqi", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4FxUL = parcelRequire("4FxUL");

const $78deebab959b7b48$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(new (0, $4FxUL.default)());
const $78deebab959b7b48$export$617c134b25cc4265 = $78deebab959b7b48$var$ProviderFactoryContext.Provider;
const $78deebab959b7b48$export$a3af4b6980aa23b5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($78deebab959b7b48$var$ProviderFactoryContext);
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($78deebab959b7b48$var$ProviderFactoryContext);
const $78deebab959b7b48$export$693cdb10cec23617 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (name)=>{
    const $ = (0, $frIzR.c)(4);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerFactory = $78deebab959b7b48$export$a3af4b6980aa23b5();
    let t0;
    let t1;
    if ($[0] !== name || $[1] !== providerFactory) {
        t0 = ()=>{
            const providerHandler = (_, provider_0)=>{
                setProvider(provider_0);
            };
            providerFactory.subscribe(name, providerHandler);
            return ()=>{
                providerFactory.unsubscribe(name, providerHandler);
            };
        };
        t1 = [
            name,
            providerFactory
        ];
        $[0] = name;
        $[1] = providerFactory;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t0, t1);
    return provider;
} : (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerFactory = $78deebab959b7b48$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const providerHandler = (_, provider_0)=>{
            setProvider(provider_0);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $78deebab959b7b48$export$6fde1d0d81db98e1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (name)=>{
    const $ = (0, $frIzR.c)(4);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerFactory = $78deebab959b7b48$export$a3af4b6980aa23b5();
    let t0;
    let t1;
    if ($[0] !== name || $[1] !== providerFactory) {
        t0 = ()=>{
            const providerHandler = (_, provider_0)=>{
                setProvider(provider_0);
            };
            providerFactory.subscribe(name, providerHandler);
            return ()=>{
                providerFactory.unsubscribe(name, providerHandler);
            };
        };
        t1 = [
            name,
            providerFactory
        ];
        $[0] = name;
        $[1] = providerFactory;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(t0, t1);
    return provider;
} : (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerFactory = $78deebab959b7b48$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        const providerHandler = (_, provider_0)=>{
            setProvider(provider_0);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
module.exports["ProviderFactoryProvider"] = $78deebab959b7b48$export$617c134b25cc4265;
module.exports["useProviderFactory"] = $78deebab959b7b48$export$a3af4b6980aa23b5;
module.exports["useProvider"] = $78deebab959b7b48$export$693cdb10cec23617;
module.exports["useProviderLayout"] = $78deebab959b7b48$export$6fde1d0d81db98e1;

});

parcelRegister("bWRlG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2XqLN = parcelRequire("2XqLN");


var $2P8Ax = parcelRequire("2P8Ax");


var $4JDbp = parcelRequire("4JDbp");


var $eTj7Y = parcelRequire("eTj7Y");

function $3aa0833fdfae2152$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3aa0833fdfae2152$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $3aa0833fdfae2152$var$SCROLLBAR_WIDTH = 30;
function $3aa0833fdfae2152$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $3aa0833fdfae2152$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $3aa0833fdfae2152$export$1eb095b00b926404(width)
    };
}
const $3aa0833fdfae2152$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($3aa0833fdfae2152$export$31a4966bffb9ac98());
const $3aa0833fdfae2152$var$Provider = $3aa0833fdfae2152$export$27e39f636459b9f.Provider;
const $3aa0833fdfae2152$export$5d8538aa831b6ebb = $3aa0833fdfae2152$export$27e39f636459b9f.Consumer;
const $3aa0833fdfae2152$export$df154c49e93b2ac2 = (0, $2XqLN.default)(()=>{
    return (0, $eTj7Y.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $3aa0833fdfae2152$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $42omo.useContext)($3aa0833fdfae2152$export$27e39f636459b9f);
    const [width, setWidth] = (0, $42omo.useState)($3aa0833fdfae2152$export$df154c49e93b2ac2);
    const widthRef = (0, $42omo.useRef)(width);
    const isMountedRef = (0, $42omo.useRef)(true);
    const providerValue = (0, $42omo.useMemo)(()=>$3aa0833fdfae2152$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $42omo.useMemo)(()=>{
        return (0, $2P8Ax.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $3aa0833fdfae2152$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $3aa0833fdfae2152$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4JDbp.default), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $9K4OG.jsx)($3aa0833fdfae2152$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};
module.exports["getBreakpoint"] = $3aa0833fdfae2152$export$1eb095b00b926404;
module.exports["createWidthContext"] = $3aa0833fdfae2152$export$31a4966bffb9ac98;
module.exports["WidthContext"] = $3aa0833fdfae2152$export$27e39f636459b9f;
module.exports["WidthConsumer"] = $3aa0833fdfae2152$export$5d8538aa831b6ebb;
module.exports["WidthProvider"] = $3aa0833fdfae2152$export$7921e18173e8c666;

});

parcelRegister("kckFS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $f91595f582fbd74b$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $f91595f582fbd74b$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f91595f582fbd74b$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, _errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($f91595f582fbd74b$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            locale: "en"
        }, this.props.children);
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}
module.exports["IntlErrorBoundary"] = $f91595f582fbd74b$export$7df0749115d18d19;

});

parcelRegister("iq4lN", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $aFUXX = parcelRequire("aFUXX");


var $ci7Ox = parcelRequire("ci7Ox");


var $3gadb = parcelRequire("3gadb");


var $d925B = parcelRequire("d925B");


var $iCOwP = parcelRequire("iCOwP");


var $juTiU = parcelRequire("juTiU");


var $1QdLR = parcelRequire("1QdLR");

const $879359e6a013f2d4$var$blockNodeStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    background: "var(--ds-background-disabled, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $879359e6a013f2d4$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $1QdLR.getUnsupportedContent)((0, $iCOwP.unsupportedContentMessages).unsupportedBlockContent, (0, $iCOwP.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $iCOwP.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $42omo.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $42omo.useCallback)(()=>dispatchAnalyticsEvent && (0, $juTiU.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $879359e6a013f2d4$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
        label: "?"
    })))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $879359e6a013f2d4$var$_default_1 = (0, $aXWIB.injectIntl)($879359e6a013f2d4$var$UnsupportedBlockNode);
var $879359e6a013f2d4$export$2e2bcd8739ae039 = $879359e6a013f2d4$var$_default_1;
module.exports["default"] = $879359e6a013f2d4$export$2e2bcd8739ae039;

});

parcelRegister("d7ZU3", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$IE_EDGE_REGEX = /\sedg\//i;
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$IE_EDGE2_REGEX = /edg([ea]|ios)/i;
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$INTERNET_EXPLORER_REGEX = /msie|trident/i;
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$MAC_REGEX = /Mac/;
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$WINDOWS_REGEX = /Windows|Win\d+/i;
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$IE_EDGE_VERSION_REGEX = /\sedg\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$IE_EDGE2_VERSION_REGEX = /edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$IE_VERSION_REGEX = /(?:msie |rv:)(\d+(\.?_?\d+)+)/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$GECKO_REGEX = /gecko\/\d/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$FIREFOX_VERSION_REGEX = /Firefox\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$CHROME_REGEX = /Chrome\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$CHROME_VERSION_REGEX = /Chrome\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$ANDROID_REGEX = /Android \d/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$APPLE_WEBKIT_REGEX = /AppleWebKit/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$MOBILE_REGEX = /Mobile\/\w+/;
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$SAFARI_REGEX = /safari|applewebkit/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$SAFARI_VERSION_REGEX = /Version\/([0-9\._]+).*Safari/;
// eslint-disable-next-line require-unicode-regexp
const $e9b48e5e619880d3$var$WEBKIT_REGEX = /(apple)?webkit/i;
const $e9b48e5e619880d3$var$getFirstMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
};
const $e9b48e5e619880d3$var$getSecondMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[2] || '';
};
// Helper functions to safely access browser properties
const $e9b48e5e619880d3$var$getSafeUserAgent = ()=>{
    if (typeof window === 'undefined') return undefined;
    // Fallback to navigator.userAgent with proper null checking
    return window.navigator?.userAgent;
};
const $e9b48e5e619880d3$var$getSafePlatform = ()=>{
    if (typeof window === 'undefined') return undefined;
    return window.navigator?.platform;
};
const $e9b48e5e619880d3$var$hasIntersectionObserver = ()=>{
    return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
const $e9b48e5e619880d3$var$hasResizeObserver = ()=>{
    return typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
};
const $e9b48e5e619880d3$export$6c724a6ffa2dc3e1 = (0, $2XqLN.default)(()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    const userAgent = $e9b48e5e619880d3$var$getSafeUserAgent();
    const platform = $e9b48e5e619880d3$var$getSafePlatform();
    if (userAgent) {
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        const ieEdge = $e9b48e5e619880d3$var$IE_EDGE_REGEX.test(userAgent);
        const ieEdge2 = $e9b48e5e619880d3$var$IE_EDGE2_REGEX.test(userAgent);
        const internetExplorer = $e9b48e5e619880d3$var$INTERNET_EXPLORER_REGEX.test(userAgent);
        // Ideally we should use userAgent instead of platform, but we have lots of keymap tests failure when we change it
        // So leave it as is for now.
        result.mac = platform && $e9b48e5e619880d3$var$MAC_REGEX.test(platform);
        // Previously relied on navigator.userAgentData?.platform and userAgent, now used only userAgent
        result.windows = $e9b48e5e619880d3$var$WINDOWS_REGEX.test(userAgent);
        // used userAgent rather than relying on documentMode
        const ie = ieEdge || ieEdge2 || internetExplorer;
        result.ie = ie;
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        result.ie_version = ieEdge ? parseInt($e9b48e5e619880d3$var$getFirstMatch($e9b48e5e619880d3$var$IE_EDGE_VERSION_REGEX, userAgent), 10) : ieEdge2 ? parseInt($e9b48e5e619880d3$var$getSecondMatch($e9b48e5e619880d3$var$IE_EDGE2_VERSION_REGEX, userAgent), 10) : parseInt($e9b48e5e619880d3$var$getFirstMatch($e9b48e5e619880d3$var$IE_VERSION_REGEX, userAgent), 10);
        result.gecko = !ie && $e9b48e5e619880d3$var$GECKO_REGEX.test(userAgent);
        result.gecko_version = parseInt((userAgent.match($e9b48e5e619880d3$var$FIREFOX_VERSION_REGEX) || [])[1], 10);
        result.chrome = !ie && $e9b48e5e619880d3$var$CHROME_REGEX.test(userAgent);
        result.chrome_version = parseInt((userAgent.match($e9b48e5e619880d3$var$CHROME_VERSION_REGEX) || [])[1], 10);
        result.android = $e9b48e5e619880d3$var$ANDROID_REGEX.test(userAgent);
        result.ios = !ie && $e9b48e5e619880d3$var$APPLE_WEBKIT_REGEX.test(userAgent) && $e9b48e5e619880d3$var$MOBILE_REGEX.test(userAgent);
        // Previously relied on navigator.vendor, now used userAgent
        result.safari = !result.chrome && !result.ie && !result.gecko && !result.android && !userAgent.includes('CriOS') && !userAgent.includes('FxiOS') && $e9b48e5e619880d3$var$SAFARI_REGEX.test(userAgent);
        result.safari_version = parseInt((userAgent.match($e9b48e5e619880d3$var$SAFARI_VERSION_REGEX) || [])[1], 10);
        // Previously we relied on documentElement.style.WebkitAppearance, now changed to userAgent
        result.webkit = $e9b48e5e619880d3$var$WEBKIT_REGEX.test(userAgent);
        result.supportsIntersectionObserver = $e9b48e5e619880d3$var$hasIntersectionObserver();
        result.supportsResizeObserver = $e9b48e5e619880d3$var$hasResizeObserver();
    }
    return result;
});
module.exports["getBrowserInfo"] = $e9b48e5e619880d3$export$6c724a6ffa2dc3e1;

});

parcelRegister("gySSb", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");

const $f133ab37c306cfea$export$da873e3c90937d2a = (schema)=>{
    const { table: table, panel_c1: panel_c1 } = schema.nodes;
    if (!table || !panel_c1) return false;
    // Confirm the PM schema actually allows table inside panel_c1
    const panelC1CanContainTable = panel_c1.contentMatch.matchType(table)?.validEnd === true;
    return panelC1CanContainTable && (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true);
};
module.exports["isPanelNestingTableSupported"] = $f133ab37c306cfea$export$da873e3c90937d2a;

});

parcelRegister("2T4ch", function(module, exports) {

var $aAn37 = parcelRequire("aAn37");

const $0c7596c6c4d45ef6$var$measureMap = new Map();
function $0c7596c6c4d45ef6$export$b62aa2130c86b59b(measureName) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $0c7596c6c4d45ef6$var$measureMap.set(measureName, performance.now());
}
function $0c7596c6c4d45ef6$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $0c7596c6c4d45ef6$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $0c7596c6c4d45ef6$export$6f766653554dac02(measureName);
    }
}
function $0c7596c6c4d45ef6$export$6f766653554dac02(measureName) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    $0c7596c6c4d45ef6$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $0c7596c6c4d45ef6$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return false;
    return $0c7596c6c4d45ef6$var$measureMap.get(measureName) !== undefined;
}
module.exports["startMeasure"] = $0c7596c6c4d45ef6$export$b62aa2130c86b59b;
module.exports["stopMeasure"] = $0c7596c6c4d45ef6$export$37c25be427bec097;
module.exports["clearMeasure"] = $0c7596c6c4d45ef6$export$6f766653554dac02;
module.exports["isMeasuring"] = $0c7596c6c4d45ef6$export$b0a51f9f0047ea32;

});

parcelRegister("aAn37", function(module, exports) {
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => (parcelRequire("3pKiG")).isPerformanceObserverAvailable);

var $3pKiG = parcelRequire("3pKiG");

let $5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs;
function $5fe8bf23ec0d3d67$export$b5717a625dd4a3eb() {
    if ($5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs === undefined) $5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs;
}
function $5fe8bf23ec0d3d67$export$4370ec0f52022f66() {
    return (0, $3pKiG.isPerformanceObserverAvailable)() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}
module.exports["isPerformanceAPIAvailable"] = $5fe8bf23ec0d3d67$export$b5717a625dd4a3eb;

});

parcelRegister("3pKiG", function(module, exports) {
function $f374714be1728b57$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
module.exports["isPerformanceObserverAvailable"] = $f374714be1728b57$export$48995af1e77d8643;

});

parcelRegister("jz9wK", function(module, exports) {

var $aAn37 = parcelRequire("aAn37");

const $ecd76f47871a107c$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
     * Cleans up the document visibility event listener
     */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $ecd76f47871a107c$export$267ed650a5d21ae6(/**
 * Unique name for the measurement
 *
 * Important: if multiple measureRender events are fired at the same time
 * with the same measure name -- the result will not be correct.
 */ measureName, /**
 * Call back fired when the measurement completes.
 *
 * Note: when this function is called when the Document.visibilityState is not
 * visible -- the duration is likely to be misleading/inaccurate. This is due
 * to the measurements use of the `requestAnimationFrame` api which only fires
 * when the Document.visibilityState is visible.
 */ onMeasureComplete) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $ecd76f47871a107c$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}
module.exports["getDistortedDurationMonitor"] = $ecd76f47871a107c$export$70f7d127254a90c;
module.exports["measureRender"] = $ecd76f47871a107c$export$267ed650a5d21ae6;

});

parcelRegister("8aL2H", function(module, exports) {

var $aAn37 = parcelRequire("aAn37");

function $6b93af43897a4933$export$92d097a1155bbe27() {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}
module.exports["getResponseEndTime"] = $6b93af43897a4933$export$92d097a1155bbe27;

});

parcelRegister("cQJcI", function(module, exports) {
const $514594b472e6880e$export$18a71eb9fe4307bc = 'block-';
const $514594b472e6880e$export$d7e471f6502a69e2 = (hash, prefix = $514594b472e6880e$export$18a71eb9fe4307bc)=>{
    if (!hash || !prefix) return false;
    // Match either UUID format (8-4-4-4-12) or short hex ID format (exactly 12 hex chars without dashes).
    // Ignored via go/ees019
    const uuidRegex = new RegExp(`^#?${prefix}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$`, 'iu');
    // Ignored via go/ees019
    const shortIdRegex = new RegExp(`^#?${prefix}[0-9a-f]{12}$`, 'iu');
    return uuidRegex.test(hash) || shortIdRegex.test(hash);
};
const $514594b472e6880e$export$c95c8d5e0fd74b32 = (hash, prefix = $514594b472e6880e$export$18a71eb9fe4307bc)=>{
    if (!$514594b472e6880e$export$d7e471f6502a69e2(hash, prefix)) return null;
    // Remove leading # if present, then remove the prefix.
    const normalized = hash.startsWith('#') ? hash.slice(1) : hash;
    return normalized.slice(prefix.length);
};
const $514594b472e6880e$export$7d28ccc9eddf2197 = (blockId, prefix = $514594b472e6880e$export$18a71eb9fe4307bc)=>{
    return `${prefix}${blockId}`;
};
module.exports["DEFAULT_BLOCK_LINK_HASH_PREFIX"] = $514594b472e6880e$export$18a71eb9fe4307bc;
module.exports["extractBlockIdFromLinkHash"] = $514594b472e6880e$export$c95c8d5e0fd74b32;
module.exports["createBlockLinkHashValue"] = $514594b472e6880e$export$7d28ccc9eddf2197;

});

parcelRegister("bBdDv", function(module, exports) {
/**
 * Shared utilities for scrolling to block elements with expand node support.
 * Used by both Confluence's useScrollOnUrlChange and platform renderer's useScrollToBlock.
 */ 
var $bONsc = parcelRequire("bONsc");


var $czJBF = parcelRequire("czJBF");


var $c7dWI = parcelRequire("c7dWI");


function $d796894128b2da9f$export$e070f925e0e65bbc(adfDoc, targetLocalId) {
    let result;
    /**
   * Recursive helper to traverse the ADF document and track expand ancestors.
   * We use recursion to properly maintain the expand ancestor stack.
   */ const traverse = (node, expandAncestors)=>{
        // If we already found the target, stop traversing
        if (result) return false;
        // Check if this is the target node by localId
        if (node?.attrs?.localId === targetLocalId) {
            result = {
                expandParentLocalIds: [
                    ...expandAncestors
                ] // Copy the array
            };
            return false; // Stop traversing
        }
        // Check if this node is an expand or nestedExpand
        const isExpand = node?.type === 'expand' || node?.type === 'nestedExpand';
        const newExpandAncestors = isExpand && node?.attrs?.localId ? [
            ...expandAncestors,
            node.attrs.localId
        ] : expandAncestors;
        // Traverse children if they exist
        if (node?.content && Array.isArray(node.content)) for (const child of node.content){
            if (result || !child) break;
            traverse(child, newExpandAncestors);
        }
        return !result; // Continue if we haven't found it yet
    };
    // Start traversal from the root
    traverse(adfDoc, []);
    return result;
}
const $d796894128b2da9f$export$4fc3b03d60a46096 = (element, maxDepth = (0, $c7dWI.SCROLL_TO_BLOCK_TIMING).MAX_EXPAND_DEPTH)=>{
    const expands = [];
    let currentElement = element;
    let depth = 0;
    while(currentElement && depth < maxDepth){
        // Look for expand container - handles both "expand" and "nestedExpand" types
        const expandContainer = currentElement.closest('[data-node-type="expand"], [data-node-type="nestedExpand"]');
        if (!expandContainer || expands.includes(expandContainer)) break;
        expands.push(expandContainer);
        currentElement = expandContainer.parentElement;
        depth++;
    }
    // Return in reverse order so we expand from outermost to innermost
    return expands.reverse();
};
const $d796894128b2da9f$export$9d8f3695c9ce7da0 = (element, attempt = 0, scrollFn)=>{
    const { MAX_EXPAND_DEPTH: MAX_EXPAND_DEPTH, MAX_ATTEMPTS: MAX_ATTEMPTS, DOM_UPDATE_DELAY: DOM_UPDATE_DELAY, RETRY_DELAY: RETRY_DELAY } = (0, $c7dWI.SCROLL_TO_BLOCK_TIMING);
    const doScroll = scrollFn ?? ((el)=>el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        }));
    // Store timeout ID and nested cleanup function so they can be cancelled.
    let timeoutId = null;
    let nestedCleanup = null;
    // Cleanup function that cancels pending timeout and any nested operations.
    const cleanup = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        if (nestedCleanup) {
            nestedCleanup();
            nestedCleanup = null;
        }
    };
    // Guard against element being disconnected from DOM or exceeding max attempts.
    if (attempt >= MAX_ATTEMPTS || !element.isConnected) {
        // Max attempts reached or element disconnected, scroll anyway.
        if (element.isConnected) doScroll(element);
        return cleanup;
    }
    try {
        // Step 1: Find all parent expands (outermost to innermost).
        const parentExpands = $d796894128b2da9f$export$4fc3b03d60a46096(element, MAX_EXPAND_DEPTH);
        // Step 2: Find any collapsed expands (filter out disconnected elements).
        const collapsedExpands = parentExpands.filter((expandContainer)=>expandContainer.isConnected && (0, $czJBF.isExpandCollapsed)(expandContainer));
        if (collapsedExpands.length === 0) {
            // All expands are open (or there are no expands), scroll to element.
            doScroll(element);
            return cleanup;
        }
        // Step 3: Expand ONLY the outermost collapsed expand first.
        // This is critical for nested expands - we must expand parent before child.
        const outermostCollapsed = collapsedExpands[0];
        try {
            const expanded = (0, $bONsc.expandElement)(outermostCollapsed);
            if (expanded) // Successfully expanded, wait briefly for DOM update then recurse to handle any nested expands.
            // Note: There's no animation, but we need a minimal delay for DOM/React updates.
            timeoutId = setTimeout(()=>{
                try {
                    // Verify element is still connected before proceeding.
                    if (!element.isConnected) return;
                    // Recurse to handle any nested collapsed expands or retry if still collapsed.
                    nestedCleanup = $d796894128b2da9f$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
                } catch  {
                    // Fallback to simple scroll on error.
                    if (element.isConnected) doScroll(element);
                }
            }, DOM_UPDATE_DELAY);
            else // Failed to expand, retry with longer delay.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $d796894128b2da9f$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        } catch  {
            // Retry on error.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $d796894128b2da9f$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        }
    } catch  {
        // Fallback to simple scroll on error.
        if (element.isConnected) doScroll(element);
    }
    return cleanup;
};
module.exports["findNodeWithExpandParents"] = $d796894128b2da9f$export$e070f925e0e65bbc;
module.exports["expandAllParentsThenScroll"] = $d796894128b2da9f$export$9d8f3695c9ce7da0;

});

parcelRegister("damll", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $85ec6044b6a868dc$export$94a68fcf7c5634d2 = (localId, container)=>{
    // Check if the element with data-local-id exists
    let element = container.querySelector(`[data-local-id="${localId}"]`);
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector(`[data-decision-list-local-id="${localId}"]`);
    if (element) return element;
    element = container.querySelector(`[data-task-list-local-id="${localId}"]`);
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector(`[data-table-local-id="${localId}"]`);
    if (element) {
        if ((0, $dh538.fg)('platform_editor_block_menu_v2_patch_4')) return element.parentElement; // return table wrapper instead of table div, so the height calculation is correct
        return element;
    }
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector(`[localid="${localId}"]`);
    if (element) return element;
    return null;
};
module.exports["getLocalIdSelector"] = $85ec6044b6a868dc$export$94a68fcf7c5634d2;

});

parcelRegister("fLvO8", function(module, exports) {

var $7i8J9 = parcelRequire("7i8J9");

const $6d2af20aab3f8b1c$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        case 'max':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).MAX;
    }
};
module.exports["getAnalyticsAppearance"] = $6d2af20aab3f8b1c$export$be87849653b93e6b;

});

parcelRegister("lWghV", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsAppearance", () => (parcelRequire("fLvO8")).getAnalyticsAppearance);

var $fLvO8 = parcelRequire("fLvO8");


var $ezTnE = parcelRequire("ezTnE");


var $2XzVT = parcelRequire("2XzVT");

const $b76cb162368f342e$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${(0, $fLvO8.getAnalyticsAppearance)(editorAppearance)}` : '_unknown';
const $b76cb162368f342e$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return (0, $ezTnE.SEVERITY).DEGRADED;
    if (duration > degradedThreshold) return (0, $ezTnE.SEVERITY).BLOCKING;
    return (0, $ezTnE.SEVERITY).NORMAL;
};
const $b76cb162368f342e$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
const $b76cb162368f342e$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
const $b76cb162368f342e$var$TABLE_BREAKPOINT_KEYS = Object.keys($b76cb162368f342e$var$EDITOR_BREAKPOINT_WIDTH);
const $b76cb162368f342e$export$afdcbbd112676ca8 = (width)=>{
    return $b76cb162368f342e$var$TABLE_BREAKPOINT_KEYS.find((key)=>width <= $b76cb162368f342e$var$EDITOR_BREAKPOINT_WIDTH[key]) || 'L';
};
module.exports["getAnalyticsEditorAppearance"] = $b76cb162368f342e$export$31ae53e002edded0;
module.exports["getAnalyticsEventSeverity"] = $b76cb162368f342e$export$f8edd689e8b20f3a;
module.exports["analyticsEventKey"] = $b76cb162368f342e$export$288273ee3e3b6132;
module.exports["getBreakpointKey"] = $b76cb162368f342e$export$afdcbbd112676ca8;

});

parcelRegister("ezTnE", function(module, exports) {
var $f2f9e7e86b6b08fa$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
module.exports["SEVERITY"] = $f2f9e7e86b6b08fa$export$6a6bef12562cd865;

});

parcelRegister("2XzVT", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");

function $2a18877ddcddca7a$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $ks2lK.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $7XFGZ.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $8m4tT.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
module.exports["findInsertLocation"] = $2a18877ddcddca7a$export$d770b562ead089d8;

});

parcelRegister("7XFGZ", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json




var $bMyNT = parcelRequire("bMyNT");

class $52ce063c47c095ed$export$ca751a6394ad160e {
    map(mapping) {
        return new $52ce063c47c095ed$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $bMyNT.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $ks2lK.Selection).fromJSON(doc, data);
        }
        return (0, $ks2lK.Selection).near($headCell, 1);
    }
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
}



var $LmqWp = parcelRequire("LmqWp");


var $3gZJH = parcelRequire("3gZJH");


var $jl382 = parcelRequire("jl382");







function $ae78fe5cf073a8d4$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $LmqWp.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $ks2lK.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}





class $72b1aa04a2aec42d$export$831cc7e2a83afa94 extends (0, $ks2lK.Selection) {
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $3gZJH.pointsAtCell)($anchorCell) && (0, $3gZJH.pointsAtCell)($headCell) && (0, $bMyNT.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $72b1aa04a2aec42d$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $72b1aa04a2aec42d$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $72b1aa04a2aec42d$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $ks2lK.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $LmqWp.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $jl382.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $jl382.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            const rowNode = table.child(row).copy((0, $5SAOw.Fragment).from(rowContent));
            rows.push(rowNode);
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $5SAOw.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $5SAOw.Slice).empty : content);
        }
        const sel = (0, $ks2lK.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $LmqWp.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $LmqWp.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $72b1aa04a2aec42d$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $LmqWp.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $72b1aa04a2aec42d$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell, reverse = false) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $LmqWp.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return reverse ? new $72b1aa04a2aec42d$export$831cc7e2a83afa94($calculatedHeadCell, $calculatedAnchorCell) : new $72b1aa04a2aec42d$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $72b1aa04a2aec42d$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $72b1aa04a2aec42d$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $52ce063c47c095ed$export$ca751a6394ad160e)(this.$anchorCell.pos, this.$headCell.pos);
    }
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $ae78fe5cf073a8d4$export$a60a444208fd5099)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        // :: (ResolvedPos, ?ResolvedPos)
        // A table selection is identified by its anchor and head cells. The
        // positions given to this constructor should point _before_ two
        // cells in the same table. They may be the same, to select a single
        // cell.
        this.$anchorCell = void 0;
        this.$headCell = void 0;
        this.visible = void 0;
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
}
(0, $ks2lK.Selection).jsonID('cell', $72b1aa04a2aec42d$export$831cc7e2a83afa94);
module.exports["CellSelection"] = $72b1aa04a2aec42d$export$831cc7e2a83afa94;

});

parcelRegister("bMyNT", function(module, exports) {
function $153dcb01ebe77604$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $153dcb01ebe77604$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}
module.exports["isInTable"] = $153dcb01ebe77604$export$217a88ad224d1b11;
module.exports["inSameTable"] = $153dcb01ebe77604$export$debd62b44eb7e281;

});

parcelRegister("3gZJH", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $LmqWp = parcelRequire("LmqWp");

function $462b8962de02df31$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $462b8962de02df31$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $462b8962de02df31$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $462b8962de02df31$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $LmqWp.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}
module.exports["pointsAtCell"] = $462b8962de02df31$export$3c89e45c7dff9619;
module.exports["cellNear"] = $462b8962de02df31$export$7a283ef453dbae9e;
module.exports["cellAround"] = $462b8962de02df31$export$1f482d92c57578ce;
module.exports["nextCell"] = $462b8962de02df31$export$172699367bb25225;

});

parcelRegister("jl382", function(module, exports) {
function $cbe2c55ec9e68dec$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $cbe2c55ec9e68dec$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $cbe2c55ec9e68dec$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $cbe2c55ec9e68dec$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}
module.exports["removeColSpan"] = $cbe2c55ec9e68dec$export$b24d9c3cc95412e0;
module.exports["assertColspan"] = $cbe2c55ec9e68dec$export$6fccdf7cee1b5201;
module.exports["addColSpan"] = $cbe2c55ec9e68dec$export$147ee78a1321ac36;

});

parcelRegister("NPJKR", function(module, exports) {
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $10cc70c3cd038eda$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260
module.exports["shouldForceTracking"] = $10cc70c3cd038eda$export$5b59d3e9e22dbdc6;

});

parcelRegister("9ciHB", function(module, exports) {

var $5nZsM = parcelRequire("5nZsM");


var $kB2tR = parcelRequire("kB2tR");


var $25Vvn = parcelRequire("25Vvn");

const $afdd01693dbe3419$var$EMPTY = {};
function $afdd01693dbe3419$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $afdd01693dbe3419$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $afdd01693dbe3419$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $afdd01693dbe3419$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($afdd01693dbe3419$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(e[0]), e[1], options?.objectFlagKeys) && $afdd01693dbe3419$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($afdd01693dbe3419$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
module.exports["normalizeFeatureFlags"] = $afdd01693dbe3419$export$f1485fc4974593c0;

});

parcelRegister("kB2tR", function(module, exports) {

var $2Ed9T = parcelRequire("2Ed9T");

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $efe92ff277fe7159$var$kebabCase = $2Ed9T(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $efe92ff277fe7159$var$kebabCase;

});

parcelRegister("25Vvn", function(module, exports) {
function $dd30687d219f8ef5$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}
module.exports["getEnabledFeatureFlagKeys"] = $dd30687d219f8ef5$export$6d018dd0f6cbebcb;

});

parcelRegister("aUnCJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5SAOw = parcelRequire("5SAOw");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");

parcelRequire("hlcQd");
var $8jc2v = parcelRequire("8jc2v");
var $hlcQd = parcelRequire("hlcQd");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");

var $95b75d6dcf8c3302$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});





const $1ab33d55077bc7e8$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($1ab33d55077bc7e8$var$isReactElement(childNode) && childNode.props.children) result = $1ab33d55077bc7e8$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $1ab33d55077bc7e8$var$isReactElement(child) {
    return !!child.type;
}
const $1ab33d55077bc7e8$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $1ab33d55077bc7e8$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};



const $6bc9d398fb95b20f$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).START;
    return false;
};



var $jZG1P = parcelRequire("jZG1P");

function $5f4b8fc731c93068$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}





function $53c7ce50256f5198$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            key: `${segment.text}_${startPos}_${idx}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            match: segment.text,
            groups: segment.groups,
            marks: marks,
            startPos: startPos + idx
        }, segment.text));
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        key: `text-wrapper_${startPos}`
    }, segments.map(renderSegment));
}



var $jSHzw = parcelRequire("jSHzw");


var $3h7Ko = parcelRequire("3h7Ko");

// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $5f8afa0614c300d4$var$markStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
});
const $5f8afa0614c300d4$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const markRef = (0, $42omo.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $jZG1P.dataAttributes)(draftPosition),
        css: $5f8afa0614c300d4$var$markStyles,
        ref: markRef
    }, children);
};
const $5f8afa0614c300d4$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).START) return 0;
    if (annotationPosition === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).END) return fragmentCount - 1;
    if (annotationPosition === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $5f8afa0614c300d4$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $5f8afa0614c300d4$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)($5f8afa0614c300d4$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: index
        }, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $5f8afa0614c300d4$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $6bc9d398fb95b20f$export$b1baddbd5f289877)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $1ab33d55077bc7e8$export$a9795c84b22a1f06)(children);
    if (!textString) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).AROUND_TEXT) {
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $9K4OG.jsx)($5f8afa0614c300d4$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $1ab33d55077bc7e8$export$1059bfc467f4f55d)(nextDraftPosition, textPosition, textString);
    const texts = (0, $1ab33d55077bc7e8$export$2878cc467c8be8fe)(textString, offsets);
    if (!texts) {
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $5f8afa0614c300d4$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, components);
};


const $3ab91fd4d23d289e$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5f8afa0614c300d4$export$69a4e0ac39aaf9b7), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks
    }, children);
};
var $3ab91fd4d23d289e$export$2e2bcd8739ae039 = $3ab91fd4d23d289e$var$TextWrapper;



var $iNqGB = parcelRequire("iNqGB");


var $caYZ2 = parcelRequire("caYZ2");


var $bSXAs = parcelRequire("bSXAs");

var $ew9YK = parcelRequire("ew9YK");


var $8m4tT = parcelRequire("8m4tT");


var $dh538 = parcelRequire("dh538");


var $b7FrM = parcelRequire("b7FrM");


var $7nUdN = parcelRequire("7nUdN");
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $GH4gU = parcelRequire("GH4gU");


var $hMQQ9 = parcelRequire("hMQQ9");


var $g5cj9 = parcelRequire("g5cj9");


var $jyYl7 = parcelRequire("jyYl7");


var $cHFH7 = parcelRequire("cHFH7");


var $2KFEz = parcelRequire("2KFEz");


var $6wVZ8 = parcelRequire("6wVZ8");


var $4XjCW = parcelRequire("4XjCW");


var $6ObvC = parcelRequire("6ObvC");


var $hJ84o = parcelRequire("hJ84o");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");





var $anbEX = parcelRequire("anbEX");

const $82b4ce436e9fddb4$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $anbEX.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $82b4ce436e9fddb4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)($82b4ce436e9fddb4$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}





function $a3a9aa36f44a86d5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level
    }, props.children);
}



var $9DaqG = parcelRequire("9DaqG");


var $gwCgB = parcelRequire("gwCgB");


var $118BP = parcelRequire("118BP");


var $a6ktG = parcelRequire("a6ktG");





var $5UG0R = parcelRequire("5UG0R");


var $kzW3z = parcelRequire("kzW3z");




class $9e616c67c8d349d1$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference
        }, children);
    }
}


const $75a8f360c7129c0b$export$c00d967a0f56fdb7 = {
    code: (0, $GH4gU.default),
    em: (0, $hMQQ9.default),
    link: (0, $g5cj9.default),
    strike: (0, $jyYl7.default),
    strong: (0, $cHFH7.default),
    subsup: (0, $2KFEz.default),
    textColor: (0, $6wVZ8.default),
    backgroundColor: (0, $4XjCW.default),
    underline: (0, $6ObvC.default),
    annotation: (0, $7nUdN.default),
    border: (0, $5UG0R.default),
    fontSize: (0, $kzW3z.default),
    // Stage0
    confluenceInlineComment: (0, $9e616c67c8d349d1$export$2e2bcd8739ae039),
    breakout: (0, $hJ84o.default),
    alignment: (0, $82b4ce436e9fddb4$export$2e2bcd8739ae039),
    indentation: (0, $a3a9aa36f44a86d5$export$2e2bcd8739ae039),
    unsupportedMark: (0, $9DaqG.default),
    unsupportedNodeAttribute: (0, $gwCgB.default),
    dataConsumer: (0, $118BP.default),
    fragment: (0, $a6ktG.default)
};
const $75a8f360c7129c0b$export$d4334b129116aad7 = (mark)=>{
    return $75a8f360c7129c0b$export$c00d967a0f56fdb7[mark.type.name];
};





const $816aa5ff776b1fd8$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $816aa5ff776b1fd8$var$isExpandNode = (node)=>node.type.name === 'expand';
const $816aa5ff776b1fd8$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $816aa5ff776b1fd8$export$d7bc71cca336a3b = (path)=>path.some((item)=>$816aa5ff776b1fd8$var$isLayoutNode(item) && $816aa5ff776b1fd8$var$hasBreakOutMark(item));
const $816aa5ff776b1fd8$export$3e763fd7277c58c5 = (path)=>path.some((item)=>$816aa5ff776b1fd8$var$isExpandNode(item) && $816aa5ff776b1fd8$var$hasBreakOutMark(item));
const $816aa5ff776b1fd8$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $816aa5ff776b1fd8$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $816aa5ff776b1fd8$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};
const $816aa5ff776b1fd8$export$a8df1f99c673fa27 = (path, nodeTypeNames)=>{
    for (const node of path){
        if (nodeTypeNames.includes(node.type.name)) return node.type.name;
    }
    return undefined;
};





var $aUnCJ = parcelRequire("aUnCJ");

const $96ace269c0bdcf98$export$eeb66772b38d7581 = (content)=>{
    const standaloneMarks = [];
    // keep track of the previous node's state
    let prev = {
        selfSpaceOnTheRight: true
    };
    let prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(let i = 0; i < content.length; i++){
        const node = content[i];
        const nodeMarks = (0, $aUnCJ.default).getMarks(node);
        const isBackgroundColor = nodeMarks.some((m)=>m.type.name === 'backgroundColor');
        let selfSpaceOnTheLeft = false;
        let selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    const mark = (0, $aUnCJ.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            const mark = (0, $aUnCJ.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
            if (mark) standaloneMarks.push(mark);
        }
    }
    return standaloneMarks;
};


function $8ae98293eca6c2e6$export$3a88c97d9b0d8d1c({ nodes: nodes, onMark: onMark, parentPos: parentPos, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline }) {
    if (!nodes || nodes.length === 0 || nodes[0].isInline) return;
    function isInlineBodiedExtension(node) {
        return Boolean(node?.type.name === 'bodiedExtension' && shouldDisplayExtensionAsInline({
            type: node.type.name,
            extensionKey: node.attrs?.extensionKey,
            extensionType: node.attrs?.extensionType,
            parameters: node.attrs?.parameters,
            content: node.content,
            localId: node.attrs?.localId
        }));
    }
    try {
        let prevPos = parentPos;
        let pos = parentPos;
        let prevTextBlockType;
        for (const [index, node] of nodes.entries()){
            const prevNode = nodes[index - 1];
            // textblock + inlinedBodiedExtension
            if (prevNode?.isTextblock && isInlineBodiedExtension(node)) onMark({
                pos: prevPos
            });
            else if (isInlineBodiedExtension(prevNode) && node.isTextblock && (!prevTextBlockType || node.type === prevTextBlockType)) onMark({
                pos: pos
            });
            if (!isInlineBodiedExtension(node)) prevTextBlockType = node.isTextblock ? node.type : undefined;
            prevPos = pos;
            pos += node.nodeSize;
        }
    } catch  {}
}


function $4b5cdd4f3b34cbcf$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $5SAOw.MarkType) && prev && prev.type instanceof (0, $5SAOw.MarkType) && Array.isArray(prev.content) && (0, $ew9YK.isSameMark)(prev, markOrNode)) prev.content = $4b5cdd4f3b34cbcf$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039 {
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node, path);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'inlineCard':
                return this.getInlineCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'nestedExpand':
                if ((0, $dh538.fg)('hot-121622_lazy_load_expand_content')) return this.getExpandProps(node, path);
                return this.getProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            case 'panel_c1':
                if ((0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return this.getPanelProps(node);
                return this.getProps(node, path);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $8jc2v.DocWithSelectAllTrap) : (0, $8jc2v.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, this.getChildNodes(fragment).map((node, index)=>{
            if ((0, $hlcQd.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        this.standaloneBackgroundColorMarks.push(...(0, $96ace269c0bdcf98$export$eeb66772b38d7581)(content));
        return $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, _index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $hlcQd.isTextNode)(mark)) {
            const serializeContent = (childMark, _index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            const isStandalone = this.standaloneBackgroundColorMarks.some((m)=>mark.eq(m));
            return this.renderMark((0, $75a8f360c7129c0b$export$d4334b129116aad7)(mark), {
                ...this.getMarkProps(mark, parentMark.path),
                isStandalone: isStandalone
            }, markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ab91fd4d23d289e$export$2e2bcd8739ae039), {
                key: textKey,
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks
            }, mark.text);
        }
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(mark.text, this.textHighlighter);
        return (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NodeComponent, {
            key: key,
            ...props
        }, content));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(MarkComponent, {
            key: key,
            ...props
        }, content));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $816aa5ff776b1fd8$export$42ddc573eb5a7b43)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $816aa5ff776b1fd8$export$9f1e9347b0411934)(path, node.type.schema);
        const isInsideOfTable = (0, $816aa5ff776b1fd8$export$244bf4b32387ef62)(path, node.type.schema);
        const isStickySafeCenteringEnabled = (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const isInsideBreakoutExpand = !isStickySafeCenteringEnabled && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $816aa5ff776b1fd8$export$3e763fd7277c58c5)(path);
        const stickyHeaders = isStickySafeCenteringEnabled ? !isInsideOfTable ? this.stickyHeaders : undefined : !isInsideOfTable && !(0, $816aa5ff776b1fd8$export$d7bc71cca336a3b)(path) && !isInsideBreakoutExpand ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $caYZ2.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            // eslint-disable-next-line @atlaskit/platform/valid-gate-name
            isPresentational: (0, $dh538.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
            disableTableOverflowShadow: this.disableTableOverflowShadow,
            allowFixedColumnWidthOption: this.allowFixedColumnWidthOption
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $816aa5ff776b1fd8$export$42ddc573eb5a7b43)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        // Only check path for bodiedSyncBlock; syncBlock uses RendererContext
        const nestedUnder = (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? (0, $816aa5ff776b1fd8$export$a8df1f99c673fa27)(path, [
            'bodiedSyncBlock'
        ]) : undefined;
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            enableSyncMediaCard: this.media?.enableSyncMediaCard,
            mediaViewerExtensions: this.media?.mediaViewerExtensions,
            fallbackMediaNameFetcher: this.media?.fallbackMediaNameFetcher,
            nestedUnder: nestedUnder
        };
    }
    getExtensionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes,
            nodeHeight: this.getExtensionHeight?.(node),
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        };
    }
    getEmojiProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $816aa5ff776b1fd8$export$42ddc573eb5a7b43)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getInlineCardProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr,
            fallbackMediaNameFetcher: this.media?.fallbackMediaNameFetcher
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            asInline: this.inlinePositions.has(startPos) ? 'on' : undefined,
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowDownloadCodeBlock: this.allowDownloadCodeBlock,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            rendererContentMode: this.contentMode,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $iNqGB.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, _path = []) {
        let loadBodyContent = false;
        if ((0, $dh538.fg)('hot-121622_lazy_load_expand_content')) {
            const annotations = (0, $8m4tT.findChildrenByMark)(node, node.type.schema.marks.annotation, true);
            // Force rendering children if there are inline comments to support comments navigation
            // which relies on the HTML node to be present.
            loadBodyContent = annotations.some((annotation)=>{
                return annotation.node.marks.some((mark)=>mark.attrs.annotationType === 'inlineComment');
            });
        }
        // Only compute searchText when the browser find experiment is enabled,
        // to avoid unnecessary node.textContent string allocations per expand node.
        const searchText = (0, $1oCLl.expValEquals)('platform_editor_close_expand_find', 'isEnabled', true) ? node.textContent : undefined;
        if (!(0, $iNqGB.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return {
            ...this.getProps(node),
            loadBodyContent: loadBodyContent,
            searchText: searchText
        };
        const nestedHeaderIds = (0, $8m4tT.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds,
            loadBodyContent: loadBodyContent,
            searchText: searchText
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $b7FrM.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        const uniqueId = this.getUniqueHeadingId(nodeContent, headingIds);
        return this.headingIdPrefix ? `${this.headingIdPrefix}-${uniqueId}` : uniqueId;
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    getChildNodes(fragment) {
        let children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        children = (0, $hlcQd.mergeTextNodes)(children);
        if (!!this.shouldDisplayExtensionAsInline && (0, $1oCLl.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true)) (0, $8ae98293eca6c2e6$export$3a88c97d9b0d8d1c)({
            nodes: children,
            onMark: ({ pos: pos })=>{
                this.inlinePositions.add(pos);
            },
            parentPos: this.startPos,
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        });
        return children;
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $bSXAs.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $4b5cdd4f3b34cbcf$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    constructor(init){
        this.providers = void 0;
        this.eventHandlers = void 0;
        this.extensionHandlers = void 0;
        this.portal = void 0;
        this.rendererContext = void 0;
        this.appearance = void 0;
        this.contentMode = void 0;
        this.disableHeadingIDs = void 0;
        this.headingIdPrefix = void 0;
        this.disableActions = void 0;
        this.headingIds = [];
        /**
     * The reason we have this extra array here is because we need to generate the same unique
     * heading id for 2 different nodes: headers and expands (check the implementation of
     * `getUniqueHeadingId` for more info).
     *
     * We will eventually need to refactor the current approach to generate unique ids
     * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
     */ this.expandHeadingIds = [];
        this.allowHeadingAnchorLinks = void 0;
        this.allowColumnSorting = void 0;
        this.allowCopyToClipboard = false;
        this.allowDownloadCodeBlock = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.fireAnalyticsEvent = void 0;
        this.shouldOpenMediaViewer = void 0;
        this.allowAltTextOnImages = void 0;
        this.stickyHeaders = void 0;
        this.allowMediaLinking = void 0;
        this.initStartPos = void 0;
        this.startPos = void 0;
        this.surroundTextNodesWithTextWrapper = false;
        this.media = void 0;
        this.emojiResourceConfig = void 0;
        this.smartLinks = void 0;
        this.extensionViewportSizes = void 0;
        this.getExtensionHeight = void 0;
        this.allowAnnotations = false;
        this.allowSelectAllTrap = void 0;
        this.nodeComponents = void 0;
        this.allowWindowedCodeBlock = void 0;
        this.isInsideOfInlineExtension = void 0;
        this.textHighlighter = void 0;
        this.allowTableAlignment = void 0;
        this.allowTableResizing = void 0;
        this.allowFixedColumnWidthOption = void 0;
        this.isPresentational = void 0;
        this.disableTableOverflowShadow = void 0;
        this.standaloneBackgroundColorMarks = [];
        this.onSetLinkTarget = void 0;
        this.shouldDisplayExtensionAsInline = void 0;
        this.inlinePositions = new Set();
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem' && (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && parentInfo?.parentIsIncompleteTask === true && (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true);
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $hlcQd.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $75a8f360c7129c0b$export$d4334b129116aad7)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $7nUdN.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $7nUdN.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $GH4gU.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            // Add deepLinkTarget for link marks
            const linkSpecificProps = mark.type.name === 'link' ? {
                onSetLinkTarget: this.onSetLinkTarget
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                ...linkSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.headingIdPrefix = init.headingIdPrefix;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowDownloadCodeBlock = init.allowDownloadCodeBlock;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.getExtensionHeight = init.getExtensionHeight;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.allowFixedColumnWidthOption = init.allowFixedColumnWidthOption;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
        this.onSetLinkTarget = init.onSetLinkTarget;
        this.shouldDisplayExtensionAsInline = init.shouldDisplayExtensionAsInline;
    }
}
module.exports["default"] = $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039;

});

parcelRegister("hlcQd", function(module, exports) {
$parcel$export(module.exports, "Doc", () => (parcelRequire("8jc2v")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("8jc2v")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $4wH3g = parcelRequire("4wH3g");


var $iq4lN = parcelRequire("iq4lN");

var $gndLe = parcelRequire("gndLe");


var $dh538 = parcelRequire("dh538");


var $8FDtv = parcelRequire("8FDtv");


var $bHs3B = parcelRequire("bHs3B");


var $1acNj = parcelRequire("1acNj");


var $l5RsK = parcelRequire("l5RsK");


var $4aPtv = parcelRequire("4aPtv");


var $8jc2v = parcelRequire("8jc2v");


var $k8515 = parcelRequire("k8515");


var $8dFG8 = parcelRequire("8dFG8");


var $9IIii = parcelRequire("9IIii");


var $AXP6M = parcelRequire("AXP6M");


var $iPgHB = parcelRequire("iPgHB");


var $gaxtd = parcelRequire("gaxtd");


var $2y2LK = parcelRequire("2y2LK");


var $e3xiQ = parcelRequire("e3xiQ");


var $iKbB3 = parcelRequire("iKbB3");


var $4AYMa = parcelRequire("4AYMa");


var $12YDi = parcelRequire("12YDi");


var $40qpT = parcelRequire("40qpT");


var $2jkq1 = parcelRequire("2jkq1");


var $iKFPk = parcelRequire("iKFPk");


var $a78Ri = parcelRequire("a78Ri");


var $cCNNZ = parcelRequire("cCNNZ");


const $bcf3851500a04fac$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "lyuNf",
    name: "WindowedCodeBlock",
    loader: ()=>(parcelRequire("5Njvm")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7voiQ",
    name: "CodeBlock",
    loader: ()=>(parcelRequire("apc9n")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "QxM0Q",
    name: "TaskList",
    loader: ()=>(parcelRequire("jblE9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "mFjlc",
    name: "TaskItem",
    loader: ()=>(parcelRequire("2ve85")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Es_G2",
    name: "DecisionList",
    loader: ()=>(parcelRequire("8DVsQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "tXkFq",
    name: "DecisionItem",
    loader: ()=>(parcelRequire("gbCDG")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "UW2mx",
    name: "Date",
    loader: ()=>(parcelRequire("gNkHO")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "YWl55",
    name: "Status",
    loader: ()=>(parcelRequire("cwpfK")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "vg-Rq",
    name: "Emoji",
    _vcPlaceholderIgnored: true,
    loader: ()=>(parcelRequire("16xNn")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Hm6N8",
    name: "Panel",
    _addVCPlaceholderWrapper: "span",
    loader: ()=>(parcelRequire("8tFtj")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Ecfpn",
    name: "EmbedCard",
    loader: ()=>(parcelRequire("gwvIa")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "0vDZ-",
    name: "InlineCard",
    loader: ()=>(parcelRequire("5PMVm")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "cNtW6",
    name: "BlockCard",
    loader: ()=>(parcelRequire("aegRE")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "nouWf",
    name: "Media",
    _vcPlaceholderIgnored: true,
    loader: ()=>(parcelRequire("kCV4q")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "l7RKL",
    name: "MediaGroup",
    loader: ()=>(parcelRequire("dlKx2")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "IVdRD",
    name: "MediaInline",
    loader: ()=>(parcelRequire("X850C")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Eb7Gh",
    name: "MediaSingle",
    _delayHydration: true,
    loader: ()=>(parcelRequire("2kBsZ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "w10Xv",
    name: "Mention",
    loader: ()=>(parcelRequire("P4EZp")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "UPgdC",
    name: "Expand",
    loader: ()=>(parcelRequire("eilMb")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "f1NYX",
    name: "SyncBlockLoader",
    loader: ()=>(parcelRequire("64LyH")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "uj9UW",
    name: "BodiedSyncBlock",
    loader: ()=>(parcelRequire("dvtp1")).then((mod)=>mod.default),
    loading: ()=>null
});
const $bcf3851500a04fac$export$3931063f6a5f290e = {
    blockquote: (0, $8FDtv.default),
    bulletList: (0, $4aPtv.default),
    blockCard: $bcf3851500a04fac$export$d18ccd25c0d2c6b0,
    caption: (0, $e3xiQ.default),
    date: $bcf3851500a04fac$export$6341f9a885713487,
    decisionItem: $bcf3851500a04fac$export$b6f73a2b0b0de599,
    decisionList: $bcf3851500a04fac$export$b458dfa720128865,
    doc: (0, $8jc2v.default),
    emoji: $bcf3851500a04fac$export$56cc48506ff790a,
    extension: (0, $k8515.default),
    bodiedExtension: (0, $bHs3B.default),
    multiBodiedExtension: (0, $1acNj.default),
    extensionFrame: (0, $l5RsK.default),
    hardBreak: (0, $8dFG8.default),
    heading: (0, $9IIii.default),
    inlineCard: $bcf3851500a04fac$export$aff6291803939b05,
    inlineExtension: (0, $AXP6M.default),
    layoutSection: (0, $iPgHB.default),
    layoutColumn: (0, $gaxtd.default),
    listItem: (0, $2y2LK.default),
    media: $bcf3851500a04fac$export$7fc53215244aec38,
    mediaGroup: $bcf3851500a04fac$export$d7858be3df00d59,
    mediaInline: $bcf3851500a04fac$export$462ea7c2a1c4cb1f,
    mediaSingle: $bcf3851500a04fac$export$888d74bc001c3a5d,
    mention: $bcf3851500a04fac$export$e891316fea657d90,
    orderedList: (0, $iKbB3.default),
    panel: $bcf3851500a04fac$export$2ddb90ad54e5f587,
    panel_c1: $bcf3851500a04fac$export$2ddb90ad54e5f587,
    paragraph: (0, $4AYMa.default),
    placeholder: (0, $12YDi.default),
    rule: (0, $40qpT.default),
    status: $bcf3851500a04fac$export$96e9906d6d93a972,
    taskItem: $bcf3851500a04fac$export$27c4189b8be1bf93,
    taskList: $bcf3851500a04fac$export$771a55a10b0a40ae,
    table: (0, $2jkq1.default),
    tableCell: (0, $iKFPk.TableCell),
    tableHeader: (0, $iKFPk.TableHeader),
    tableRow: (0, $a78Ri.default),
    unknownBlock: (0, $cCNNZ.default),
    unsupportedBlock: (0, $iq4lN.default),
    unsupportedInline: (0, $gndLe.default),
    expand: $bcf3851500a04fac$export$49bd1dfb0ad29c40,
    syncBlock: $bcf3851500a04fac$var$SyncBlockLoader,
    bodiedSyncBlock: $bcf3851500a04fac$var$BodiedSyncBlock,
    nestedExpand: $bcf3851500a04fac$export$49bd1dfb0ad29c40,
    embedCard: $bcf3851500a04fac$export$6789d7ecdc77631b,
    blockTaskItem: $bcf3851500a04fac$export$27c4189b8be1bf93
};
const $bcf3851500a04fac$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $8jc2v.DocWithSelectAllTrap;
    if (!(0, $dh538.fg)('jfp-magma-ssr-iv-editor-codeblock')) {
        if (node.type.name === 'codeBlock') {
            if (flags?.allowWindowedCodeBlock === true) return $bcf3851500a04fac$export$a22ee8f907eecb5f;
            return $bcf3851500a04fac$export$6c415d1fdae3dfdb;
        }
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$bcf3851500a04fac$export$3931063f6a5f290e,
        ...nodeComponents
    };
    if ((0, $dh538.fg)('jfp-magma-ssr-iv-editor-codeblock')) {
        if (node.type.name === 'codeBlock') {
            if (flags?.allowWindowedCodeBlock === true) return nodes.windowedCodeBlock ?? $bcf3851500a04fac$export$a22ee8f907eecb5f;
            return nodes.codeBlock ?? $bcf3851500a04fac$export$6c415d1fdae3dfdb;
        }
    }
    nodes['multiBodiedExtension'] = (0, $1acNj.default);
    return nodes[node.type.name];
};
const $bcf3851500a04fac$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$bcf3851500a04fac$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $bcf3851500a04fac$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $bcf3851500a04fac$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $bcf3851500a04fac$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $bcf3851500a04fac$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $bcf3851500a04fac$var$whitespaceRegex = /^\s*$/;
const $bcf3851500a04fac$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $bcf3851500a04fac$var$isEmojiBlock(node.content);
};
const $bcf3851500a04fac$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($bcf3851500a04fac$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};
module.exports["InlineCard"] = $bcf3851500a04fac$export$aff6291803939b05;
module.exports["nodeToReact"] = $bcf3851500a04fac$export$3931063f6a5f290e;
module.exports["toReact"] = $bcf3851500a04fac$export$d4334b129116aad7;
module.exports["mergeTextNodes"] = $bcf3851500a04fac$export$8045509d14b5046f;
module.exports["isTextWrapper"] = $bcf3851500a04fac$export$d4ebd3557ee7fac1;
module.exports["isTextNode"] = $bcf3851500a04fac$export$ccbedd67ef6e9417;

});

parcelRegister("gndLe", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $aFUXX = parcelRequire("aFUXX");


var $ci7Ox = parcelRequire("ci7Ox");


var $3gadb = parcelRequire("3gadb");


var $d925B = parcelRequire("d925B");


var $iCOwP = parcelRequire("iCOwP");


var $juTiU = parcelRequire("juTiU");


var $1QdLR = parcelRequire("1QdLR");

const $21cc51f6839cd966$var$inlineNodeStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $21cc51f6839cd966$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $1QdLR.getUnsupportedContent)((0, $iCOwP.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $iCOwP.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $42omo.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $42omo.useCallback)(()=>dispatchAnalyticsEvent && (0, $juTiU.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $21cc51f6839cd966$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
        label: "?"
    }))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $21cc51f6839cd966$var$_default_1 = (0, $aXWIB.injectIntl)($21cc51f6839cd966$var$UnsupportedInlineNode);
var $21cc51f6839cd966$export$2e2bcd8739ae039 = $21cc51f6839cd966$var$_default_1;
module.exports["default"] = $21cc51f6839cd966$export$2e2bcd8739ae039;

});

parcelRegister("5VmpF", function(module, exports) {
$parcel$export(module.exports, "default", () => $52efeb67c19e95a1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $heH5c = parcelRequire("heH5c");


var $dYBVS = parcelRequire("dYBVS");


var $2diEG = parcelRequire("2diEG");

function $52efeb67c19e95a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $52efeb67c19e95a1$var$inlineExtensionStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
const $52efeb67c19e95a1$var$plainTextMacroStyle = {
    name: "1b7osz4",
    styles: "display:inline;vertical-align:baseline;[data-macro-body]{display:inline;}"
};
function $52efeb67c19e95a1$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $2XqLN.default)((0, $heH5c.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((_name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        const isPlainTextMacro = Boolean(node?.parameters?.macroParams?.__bodyContent);
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2diEG.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $9K4OG.jsx)($52efeb67c19e95a1$export$f41ccc3bd3324832, {
                    isPlainTextMacro: isPlainTextMacro
                }, /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch  {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            node: node,
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dYBVS.WithProviders), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $52efeb67c19e95a1$export$f41ccc3bd3324832 = ({ children: children, isPlainTextMacro: isPlainTextMacro, ssrPlaceholder: ssrPlaceholder, ssrPlaceholderReplace: ssrPlaceholderReplace })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `inline-extension-renderer ${isPlainTextMacro ? 'plain-text-macro' : ''}`,
        css: [
            $52efeb67c19e95a1$var$inlineExtensionStyle,
            isPlainTextMacro && $52efeb67c19e95a1$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};
module.exports["InlineNodeRendererWrapper"] = $52efeb67c19e95a1$export$f41ccc3bd3324832;

});

parcelRegister("heH5c", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4wH3g = parcelRequire("4wH3g");


var $dh538 = parcelRequire("dh538");


var $3jQ9y = parcelRequire("3jQ9y");


var $5pF33 = parcelRequire("5pF33");


var $9XfBK = parcelRequire("9XfBK");











var $gMc0m = parcelRequire("gMc0m");





var $1oCLl = parcelRequire("1oCLl");




const $6061b910d878542d$var$neutralBorder = "var(--ds-background-neutral, #0515240F)";
const $6061b910d878542d$var$unknownMacroContainerStyles = null; // Match LCM header exactly: lcmHeaderStyles from LegacyContentHeader/index.tsx
const $6061b910d878542d$var$unknownMacroHeaderStyles = null; // Match LCM content area: white surface, text color inherits
const $6061b910d878542d$var$unknownMacroBodyStyles = null;
const $6061b910d878542d$var$unknownMacroPreStyles = null;
const $6061b910d878542d$var$formatParam = (key, param)=>{
    const value = String(param?.value ?? '').trim();
    return `${key} = ${value}`;
};
const $6061b910d878542d$var$EMPTY_MACRO_PARAMS = {};
const $6061b910d878542d$export$414b5225f50e455b = (0, $4pOgL.isReactCompilerActivePlatform)() ? function UnknownMacroPlaceholder(t0) {
    const $ = (0, $frIzR.c)(22);
    const { extensionNode: extensionNode } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const macroTitle = extensionNode.parameters?.macroMetadata?.title || extensionNode.extensionKey;
    const bodyContent = extensionNode.parameters?.macroParams?.__bodyContent?.value;
    let t1;
    if ($[0] !== extensionNode.parameters?.macroParams) {
        const macroParamsOld = extensionNode.parameters?.macroParams ?? {};
        const macroParams = extensionNode.parameters?.macroParams ?? $6061b910d878542d$var$EMPTY_MACRO_PARAMS;
        const formatParamInline = $6061b910d878542d$var$_temp;
        let t2;
        if ($[2] !== macroParams) {
            t2 = Object.entries(macroParams).filter($6061b910d878542d$var$_temp2).map($6061b910d878542d$var$_temp3);
            $[2] = macroParams;
            $[3] = t2;
        } else t2 = $[3];
        const memoizedVisibleParams = t2.join(" | ");
        t1 = (0, $1oCLl.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? memoizedVisibleParams : Object.entries(macroParamsOld).filter($6061b910d878542d$var$_temp4).map((t3)=>{
            const [key_3, param_1] = t3;
            return formatParamInline(key_3, param_1);
        }).join(" | ");
        $[0] = extensionNode.parameters?.macroParams;
        $[1] = t1;
    } else t1 = $[1];
    const visibleParams = t1;
    let t2;
    if ($[4] !== intl || $[5] !== macroTitle || $[6] !== visibleParams) {
        t2 = visibleParams ? `${intl.formatMessage((0, $5pF33.messages).unknownMacroHeader, {
            macroTitle: macroTitle
        })} | ${visibleParams}` : intl.formatMessage((0, $5pF33.messages).unknownMacroHeader, {
            macroTitle: macroTitle
        });
        $[4] = intl;
        $[5] = macroTitle;
        $[6] = visibleParams;
        $[7] = t2;
    } else t2 = $[7];
    const headerText = t2;
    let t3;
    if ($[8] !== intl) {
        t3 = intl.formatMessage((0, $5pF33.messages).unknownMacroPlaceholderAriaLabel);
        $[8] = intl;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $gMc0m.default)([
            "_19it1tra _2rko12b0 _1reo15vq _18m915vq _bfhkhp5a"
        ]);
        t5 = (0, $gMc0m.default)([
            "_2rko14xi _11c8wadc _n7zlbjo2 _bfhki8nm _ca0qu2gc _u5f3pxbi _n3td1b66 _19bvpxbi _kqswh2mm _154i1n1a"
        ]);
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    let t6;
    if ($[12] !== headerText) {
        t6 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t5
        }, headerText);
        $[12] = headerText;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    let t8;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkvuon _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
        ]);
        t8 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey _o5721jtm _1nmz1hna _6z24egat"
        ]);
        $[14] = t7;
        $[15] = t8;
    } else {
        t7 = $[14];
        t8 = $[15];
    }
    let t9;
    if ($[16] !== bodyContent) {
        t9 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t7
        }, /*#__PURE__*/ $42omo.createElement("pre", {
            className: t8
        }, bodyContent));
        $[16] = bodyContent;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t3 || $[19] !== t6 || $[20] !== t9) {
        t10 = /*#__PURE__*/ $42omo.createElement("section", {
            "aria-label": t3,
            className: t4
        }, t6, t9);
        $[18] = t3;
        $[19] = t6;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    return t10;
} : function UnknownMacroPlaceholder({ extensionNode: extensionNode }) {
    const intl = (0, $aXWIB.useIntl)();
    const macroTitle = extensionNode.parameters?.macroMetadata?.title || extensionNode.extensionKey;
    const bodyContent = extensionNode.parameters?.macroParams?.__bodyContent?.value;
    const macroParamsOld = extensionNode.parameters?.macroParams ?? {};
    const macroParams = extensionNode.parameters?.macroParams ?? $6061b910d878542d$var$EMPTY_MACRO_PARAMS;
    const formatParamInline = (key, param)=>{
        const value = String(param?.value ?? '').trim();
        return `${key} = ${value}`;
    };
    const memoizedVisibleParams = (0, $42omo.useMemo)(()=>Object.entries(macroParams).filter(([key_0])=>!key_0.startsWith('_')).map(([key_1, param_0])=>$6061b910d878542d$var$formatParam(key_1, param_0)).join(' | '), [
        macroParams
    ]);
    const visibleParams = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedVisibleParams : // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- intentional fallback for experiment off path
    Object.entries(macroParamsOld).filter(([key_2])=>!key_2.startsWith('_')).map(([key_3, param_1])=>formatParamInline(key_3, param_1)).join(' | ');
    const headerText = visibleParams ? `${intl.formatMessage((0, $5pF33.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    })} | ${visibleParams}` : intl.formatMessage((0, $5pF33.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    });
    return /*#__PURE__*/ $42omo.createElement("section", {
        "aria-label": intl.formatMessage((0, $5pF33.messages).unknownMacroPlaceholderAriaLabel),
        className: (0, $gMc0m.default)([
            "_19it1tra _2rko12b0 _1reo15vq _18m915vq _bfhkhp5a"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko14xi _11c8wadc _n7zlbjo2 _bfhki8nm _ca0qu2gc _u5f3pxbi _n3td1b66 _19bvpxbi _kqswh2mm _154i1n1a"
        ])
    }, headerText), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkvuon _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
        ])
    }, /*#__PURE__*/ $42omo.createElement("pre", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey _o5721jtm _1nmz1hna _6z24egat"
        ])
    }, bodyContent)));
};
function $6061b910d878542d$var$_temp4(t0) {
    const [key_2] = t0;
    return !key_2.startsWith("_");
}
function $6061b910d878542d$var$_temp3(t0) {
    const [key_1, param_0] = t0;
    return $6061b910d878542d$var$formatParam(key_1, param_0);
}
function $6061b910d878542d$var$_temp2(t0) {
    const [key_0] = t0;
    return !key_0.startsWith("_");
}
function $6061b910d878542d$var$_temp(key, param) {
    const value = String(param?.value ?? "").trim();
    return `${key} = ${value}`;
}



function $05c1a9b049285eb2$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $05c1a9b049285eb2$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $05c1a9b049285eb2$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $05c1a9b049285eb2$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider?.getPreloadedExtension?.(extensionType, extKey);
    if (manifest) return $05c1a9b049285eb2$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$05c1a9b049285eb2$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $05c1a9b049285eb2$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $05c1a9b049285eb2$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $05c1a9b049285eb2$var$isUnknownConfluenceMacroWithBody(extensionNode) {
    return extensionNode !== null && extensionNode.type === 'extension' && extensionNode.extensionType === 'com.atlassian.confluence.macro.core' && !!extensionNode.parameters?.macroParams?.__bodyContent?.value;
}
const $05c1a9b049285eb2$var$ExtensionLoading = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ExtensionLoading(props) {
    const $ = (0, $frIzR.c)(6);
    const intl = (0, $aXWIB.useIntl)();
    const extensionNode = props.node;
    if (props.error || props.timedOut) {
        console.error("Error rendering extension", props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $05c1a9b049285eb2$var$isUnknownConfluenceMacroWithBody(extensionNode) && (0, $dh538.fg)("tinymce_display_unknown_macro_body_content")) {
            let t0;
            if ($[0] !== extensionNode) {
                t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6061b910d878542d$export$414b5225f50e455b), {
                    extensionNode: extensionNode
                });
                $[0] = extensionNode;
                $[1] = t0;
            } else t0 = $[1];
            return t0;
        }
        let t0;
        if ($[2] !== intl) {
            t0 = intl.formatMessage((0, $5pF33.messages).extensionLoadingError);
            $[2] = intl;
            $[3] = t0;
        } else t0 = $[3];
        let t1;
        if ($[4] !== t0) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, t0);
            $[4] = t0;
            $[5] = t1;
        } else t1 = $[5];
        return t1;
    } else return null;
} : function ExtensionLoading(props) {
    const intl = (0, $aXWIB.useIntl)();
    const extensionNode = props.node;
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $05c1a9b049285eb2$var$isUnknownConfluenceMacroWithBody(extensionNode) && (0, $dh538.fg)('tinymce_display_unknown_macro_body_content')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6061b910d878542d$export$414b5225f50e455b), {
            extensionNode: extensionNode
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, intl.formatMessage((0, $5pF33.messages).extensionLoadingError));
    } else return null;
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $05c1a9b049285eb2$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "w8Pzf",
        name: "getNodeRenderer",
        _maybeSyncLoader: true,
        loader: ()=>{
            const maybePromise = $05c1a9b049285eb2$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
            if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $3jQ9y.resolveImport)(node.render()));
            else {
                const preloaded = maybePromise?.renderSync?.();
                // Only product implemented preloading will return sync result
                // However the out-of-box won't handle this. Confluence uses a custom implementation
                return preloaded ? (0, $dh538.fg)('platform_editor_extension_renderer_promise_fix') ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Promise.resolve((0, $9XfBK.resolveImportSync)(preloaded)) : // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $9XfBK.resolveImportSync)(preloaded) : (0, $3jQ9y.resolveImport)(maybePromise.render());
            }
        },
        // react-loadable passes all props from <NodeRenderer> to the loading component at runtime,
        // but its TypeScript types only expect LoadingComponentProps. We cast here because
        // ExtensionLoading accepts additional props (node, showUnknownMacroPlaceholder) that
        // react-loadable will pass through but doesn't know about in its type definitions.
        loading: $05c1a9b049285eb2$var$ExtensionLoading
    });
}
module.exports["getExtensionModuleNode"] = $05c1a9b049285eb2$export$82dd45c2db936caf;
module.exports["getExtensionModuleNodePrivateProps"] = $05c1a9b049285eb2$export$426f8efd8690d8aa;
module.exports["getNodeRenderer"] = $05c1a9b049285eb2$export$67a7d49db68d30a0;

});

parcelRegister("3jQ9y", function(module, exports) {

var $WaLVU = parcelRequire("WaLVU");


var $9XfBK = parcelRequire("9XfBK");

const $e45bd9e65e516a2b$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $e45bd9e65e516a2b$export$862c0e8acc7585d7 = 'com.atlassian.confluence.macro.core';
const $e45bd9e65e516a2b$export$b343a94058bea058 = 'native-embed';
const $e45bd9e65e516a2b$export$e400f4d17a615c24 = 'agent-managed-block';
const $e45bd9e65e516a2b$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $e45bd9e65e516a2b$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
function $e45bd9e65e516a2b$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $e45bd9e65e516a2b$export$33863d887d6f4bfd(action, manifest);
}
const $e45bd9e65e516a2b$export$d69c9b451c47653b = async (importPromise)=>{
    return (0, $9XfBK.resolveImportSync)(await importPromise);
};
function $e45bd9e65e516a2b$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = (0, $WaLVU.buildExtensionKeyAndNodeKey)(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}
module.exports["NATIVE_EMBED_EXTENSION_TYPE"] = $e45bd9e65e516a2b$export$862c0e8acc7585d7;
module.exports["NATIVE_EMBED_EXTENSION_KEY"] = $e45bd9e65e516a2b$export$b343a94058bea058;
module.exports["AGENT_MANAGED_EXTENSION_KEY"] = $e45bd9e65e516a2b$export$e400f4d17a615c24;
module.exports["getExtensionKeyAndNodeKey"] = $e45bd9e65e516a2b$export$8a49818572e1d105;
module.exports["buildAction"] = $e45bd9e65e516a2b$export$bb33bcdd9a10a608;
module.exports["resolveImport"] = $e45bd9e65e516a2b$export$d69c9b451c47653b;

});

parcelRegister("5pF33", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


const $888908f21431656e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    edit: {
        id: "fabric.editor.edit",
        defaultMessage: "Edit"
    },
    deleteElementTitle: {
        id: "fabric.editor.extension.deleteElementTitle",
        defaultMessage: "Delete element"
    },
    unnamedSource: {
        id: "fabric.editor.extension.sourceNoTitledName",
        defaultMessage: "this element"
    },
    confirmDeleteLinkedModalOKButton: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalOKButton",
        defaultMessage: "Delete"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    confirmModalCheckboxLabel: {
        id: "fabric.editor.floatingToolbar.confirmModalCheckboxLabel",
        defaultMessage: "Also delete connected elements"
    },
    saveIndicator: {
        id: "fabric.editor.extensions.config-panel.save-indicator",
        defaultMessage: "All changes are always autosaved"
    },
    panelLoadingError: {
        id: "fabric.editor.extensions.config-panel.loading-error.non-final",
        defaultMessage: "We ran into a bit of trouble. Refresh to try again."
    },
    extensionLoadingError: {
        id: "fabric.editor.extension.loading-error",
        defaultMessage: "Error loading the extension!"
    },
    unknownMacroPlaceholderAriaLabel: {
        id: "fabric.editor.extension.unknownMacroPlaceholderAriaLabel",
        defaultMessage: "Unknown macro placeholder"
    },
    unknownMacroHeader: {
        id: "fabric.editor.extension.unknownMacroHeader",
        defaultMessage: "Unknown macro: ''{macroTitle}''"
    }
});
module.exports["messages"] = $888908f21431656e$export$defe85febe8b728c;

});

parcelRegister("dYBVS", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $42omo = parcelRequire("42omo");

class $45c1f6450eda5090$export$d498ee8be33e096f extends (0, $42omo.PureComponent) {
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProviderIfMounted);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
    constructor(props){
        super(props);
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            _providers[name] = providerPromise;
        });
        this.state = {
            providers: _providers
        };
    }
}
$45c1f6450eda5090$export$d498ee8be33e096f.displayName = 'WithProviders';
module.exports["WithProviders"] = $45c1f6450eda5090$export$d498ee8be33e096f;

});

parcelRegister("2diEG", function(module, exports) {
function $b48cc40544bb1d44$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}
module.exports["getExtensionRenderer"] = $b48cc40544bb1d44$export$9214452ef07eda7;

});

parcelRegister("frt7o", function(module, exports) {
$parcel$export(module.exports, "default", () => $df5484c93cd47d97$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $1oCLl = parcelRequire("1oCLl");


var $jHS8C = parcelRequire("jHS8C");


var $i0VQt = parcelRequire("i0VQt");

const $6610dd290dab91d5$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $6610dd290dab91d5$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $6610dd290dab91d5$export$51a5b28e4fb2dba2 {
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $6610dd290dab91d5$var$cancelIdleCallback(this.requestCallbackId);
        }
        if ((0, $1oCLl.expValEquals)('platform_editor_renderer_shadow_observer_cleanup', 'isEnabled', true)) {
            this.sentinels.left?.remove();
            this.sentinels.right?.remove();
            this.sentinels = {};
        }
    }
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.intersectionObserver = void 0;
        this.scrollContainer = void 0;
        this.onUpdateShadows = void 0;
        this.sentinels = {};
        this.requestCallbackId = void 0;
        this.shadowStates = {
            [(0, $jHS8C.ShadowKeys).SHOW_LEFT_SHADOW]: false,
            [(0, $jHS8C.ShadowKeys).SHOW_RIGHT_SHADOW]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add((0, $i0VQt.shadowObserverClassNames).SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add((0, $i0VQt.shadowObserverClassNames).SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $6610dd290dab91d5$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains((0, $i0VQt.shadowObserverClassNames).SENTINEL_LEFT)) this.shadowStates[(0, $jHS8C.ShadowKeys).SHOW_LEFT_SHADOW] = !entry.isIntersecting;
                if (entry.target.classList.contains((0, $i0VQt.shadowObserverClassNames).SENTINEL_RIGHT)) this.shadowStates[(0, $jHS8C.ShadowKeys).SHOW_RIGHT_SHADOW] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
}





const $df5484c93cd47d97$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $df5484c93cd47d97$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $6610dd290dab91d5$export$51a5b28e4fb2dba2)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                !this.props?.disableTableOverflowShadow && showRightShadow && $df5484c93cd47d97$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                !this.props?.disableTableOverflowShadow && showLeftShadow && $df5484c93cd47d97$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $i0VQt.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            /**
       * The widths have already been calculated to determine
       * showRightShadow and showLeftShadow. If either is true,
       * then the content is scrollable and we need to set the
       * tabIndex to 0 to allow the user to scroll the content
       * for a11y purposes.
       */ const hasOverflowScroll = showRightShadow || showLeftShadow;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                handleRef: this.handleContainer,
                tabIndex: hasOverflowScroll ? 0 : undefined,
                shadowClassNames: classNames,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.overflowContainer = void 0;
            this.container = void 0;
            this.shadowObserver = void 0;
            this.overflowContainerWidth = 0;
            this.scrollable = void 0;
            this.diff = void 0;
            this.state = {
                showLeftShadow: false,
                showRightShadow: false
            };
            this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            };
            this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            };
            this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            };
            this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            };
            this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    if ($df5484c93cd47d97$var$isElementNode(scrollableElement)) width += scrollableElement.scrollWidth;
                }
                return width;
            };
            this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}
// Helper function to check if the passed node is of Element class
function $df5484c93cd47d97$var$isElementNode(node) {
    return node.nodeType === 1;
}
module.exports["shadowClassNames"] = $df5484c93cd47d97$export$4735dd2b0fa88aa5;

});

parcelRegister("fJNzZ", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $4BBKV = parcelRequire("4BBKV");


var $bWRlG = parcelRequire("bWRlG");


var $a8v5u = parcelRequire("a8v5u");





const $d5ea6d1627235160$export$ead1fecec2ecf57c = {
    padding: (0, $aFUXX.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $aFUXX.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $aFUXX.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $aFUXX.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $aFUXX.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $4BBKV.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $bWRlG.getBreakpoint,
    /**
   * This function can return percentage value or px value depending upon the inputs
   */ calcBreakoutWidth: (breakoutConsts)=>(layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    const wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
    calcBreakoutWithCustomWidth: (breakoutConsts)=>(mode, width, editorContainerWidth)=>{
            if (width !== null && width > 0) {
                const effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return `${Math.min(width, effectiveFullWidth)}px`;
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        },
    calcLineLength: (breakoutConsts)=>()=>breakoutConsts.defaultLayoutWidth,
    calcWideWidth: (breakoutConsts)=>(containerWidth = breakoutConsts.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            const layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
};
const $d5ea6d1627235160$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcBreakoutWidth($d5ea6d1627235160$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $aFUXX.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $aFUXX.akEditorWideLayoutWidth;
        default:
            return $d5ea6d1627235160$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($d5ea6d1627235160$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $d5ea6d1627235160$export$86325001fe8f3adc = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcWideWidth($d5ea6d1627235160$export$ead1fecec2ecf57c);
const $d5ea6d1627235160$export$5f4502874a28dfce = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcBreakoutWidth($d5ea6d1627235160$export$ead1fecec2ecf57c);
const $d5ea6d1627235160$export$ccc0a02edddeed39 = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($d5ea6d1627235160$export$ead1fecec2ecf57c);
function $d5ea6d1627235160$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $d5ea6d1627235160$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $a8v5u.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $aFUXX.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $aFUXX.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $d5ea6d1627235160$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $a8v5u.parsePx)($d5ea6d1627235160$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
module.exports["breakoutConsts"] = $d5ea6d1627235160$export$ead1fecec2ecf57c;
module.exports["absoluteBreakoutWidth"] = $d5ea6d1627235160$export$b34ea040d1533a3;
module.exports["calcWideWidth"] = $d5ea6d1627235160$export$86325001fe8f3adc;
module.exports["calcBreakoutWidth"] = $d5ea6d1627235160$export$5f4502874a28dfce;
module.exports["calculateBreakoutStyles"] = $d5ea6d1627235160$export$c377853ecdd53e5b;

});

parcelRegister("a8v5u", function(module, exports) {
/**
 * Util for converting a css pixel size value to a number (of pixels).
 *
 * ie.
 * ```ts
 * const pixels = parsePx('10px')
 * //    ^$ const pixels: number
 * ```
 * * ```ts
 * const pixels = parsePx('10')
 * //    ^$ const pixels: number | undefined
 * ```
 */ // At time of writting prettier would strip the extend here.
// prettier-ignore
function $b2ffc38186e17d0e$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
module.exports["parsePx"] = $b2ffc38186e17d0e$export$b0eef8cd00b29d5c;

});

parcelRegister("jVL42", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $ade5271c9bbd1338$var$clPrefix = 'ak-renderer-';
const $ade5271c9bbd1338$export$91f3bbbf974496e2 = {
    FLEX_CENTER_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}flex-center-wrapper`,
    DOCUMENT: `${$ade5271c9bbd1338$var$clPrefix}document`,
    EXTENSION: `${$ade5271c9bbd1338$var$clPrefix}extension`,
    EXTENSION_AS_INLINE: `${$ade5271c9bbd1338$var$clPrefix}extension-as-inline`,
    EXTENSION_CENTER_ALIGN: `${$ade5271c9bbd1338$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$ade5271c9bbd1338$var$clPrefix}extension-overflow-container`,
    EXTENSION_INNER_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}extension-inner-wrapper`,
    /** Wrapper for center-aligned extensions/MBE; margin here so it participates in collapse */ STICKY_SAFE_CENTER_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}sticky-safe-center-wrapper`,
    /** Wrapper for center-aligned embed card (wide/full-width); margin here so it participates in collapse */ EMBED_CARD_CENTER_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}embed-card-center-wrapper`,
    /** Wrapper for center-aligned block card datasource (wide/full-width); margin here so it participates in collapse */ BLOCK_CARD_DATASOURCE_CENTER_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}block-card-datasource-center-wrapper`,
    /** Outer flex wrapper for sticky-safe breakout (has vertical margin); zero margin when first in doc */ STICKY_SAFE_BREAKOUT_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}sticky-safe-breakout-wrapper`,
    /** Flex item in sticky-safe breakout; zero first/last child margin so flex container height matches legacy */ STICKY_SAFE_BREAKOUT_INNER: `${$ade5271c9bbd1338$var$clPrefix}sticky-safe-breakout-inner`,
    NUMBER_COLUMN: `${$ade5271c9bbd1338$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sorting-icon__no-order`
};
module.exports["RendererCssClassName"] = $ade5271c9bbd1338$export$91f3bbbf974496e2;

});

parcelRegister("fZRom", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $k7eoe = parcelRequire("k7eoe");


var $hWRJP = parcelRequire("hWRJP");


var $59U23 = parcelRequire("59U23");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e10374371e1c8ea4$var$FAILED_TO_EXECUTE_REGEX = /Failed to execute.*on 'Node'.*/;
class $e10374371e1c8ea4$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $k7eoe.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'renderer'
        });
        const matchesPattern = $e10374371e1c8ea4$var$FAILED_TO_EXECUTE_REGEX.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState((prevState)=>({
                    domError: true,
                    domErrorCount: prevState.domErrorCount + 1
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: this.state.domErrorCount
        }, this.props.children);
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false,
            domError: false,
            domErrorCount: 0
        };
    }
}
module.exports["ErrorBoundary"] = $e10374371e1c8ea4$export$e926676385687eaf;

});

parcelRegister("hWRJP", function(module, exports) {

var $7hGsm = parcelRequire("7hGsm");


var $dh538 = parcelRequire("dh538");

const $6df845e06168a227$var$FEDRAMP_MODERATE = 'fedramp-moderate';
// Ignored via go/ees005
/* eslint-disable require-unicode-regexp */ const $6df845e06168a227$var$FEDRAMP_HOSTNAME_REGEX = /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/;
function $6df845e06168a227$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $6df845e06168a227$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match($6df845e06168a227$var$FEDRAMP_HOSTNAME_REGEX);
    return matches ? matches.length > 0 : false;
}


const $5b6a7d5ed82a6889$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $5b6a7d5ed82a6889$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$5b6a7d5ed82a6889$export$b5bdb04ea16a02e3
];
const $5b6a7d5ed82a6889$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$5b6a7d5ed82a6889$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gmu');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $5b6a7d5ed82a6889$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($5b6a7d5ed82a6889$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $5b6a7d5ed82a6889$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category?.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $5b6a7d5ed82a6889$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $bbb29939e3426646$var$NETWORK_ERROR_REGEX = /^network error/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $bbb29939e3426646$var$NETWORK_FAILURE_REGEX = /^network failure/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $bbb29939e3426646$var$RESIZE_OBSERVER_LOOP_REGEX = /ResizeObserver loop completed with undelivered notifications/;
const $bbb29939e3426646$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $bbb29939e3426646$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $bbb29939e3426646$var$packageVersion = "0.0.0-use.local";
const $bbb29939e3426646$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $bbb29939e3426646$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await Promise.resolve((parcelRequire("7hGsm")));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("4vlZc"));
        const breadcrumbsIntegration = (0, $dh538.fg)('platform_editor_sentry_breadcrumbs') ? new (0, $7hGsm.Integrations).Breadcrumbs({
            // only enable breadcrumbs for dom (UI clicks and inputs)
            // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
            dom: {
                serializeAttribute: (0, $5b6a7d5ed82a6889$export$b5bdb04ea16a02e3)
            },
            fetch: false,
            xhr: false,
            console: false,
            history: false,
            sentry: false
        }) : undefined;
        const sentryOptions = {
            dsn: (0, $6df845e06168a227$export$64d6499adf9b2e51)() ? undefined : $bbb29939e3426646$var$SENTRY_DSN,
            release: `${$bbb29939e3426646$var$packageName}@${$bbb29939e3426646$var$packageVersion}`,
            environment: "production" ?? 'unknown',
            beforeBreadcrumb: (0, $dh538.fg)('platform_editor_sentry_breadcrumbs') ? (0, $5b6a7d5ed82a6889$export$6f14342128c6eaa4) : undefined,
            ignoreErrors: [
                // Network issues
                $bbb29939e3426646$var$NETWORK_ERROR_REGEX,
                $bbb29939e3426646$var$NETWORK_FAILURE_REGEX,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                $bbb29939e3426646$var$RESIZE_OBSERVER_LOOP_REGEX
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    ...breadcrumbsIntegration ? [
                        breadcrumbsIntegration
                    ] : [],
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $bbb29939e3426646$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        // @ts-ignore - TypeScript 5.9.2 upgrade
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        // @ts-ignore - TypeScript 5.9.2 upgrade
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};
module.exports["logException"] = $bbb29939e3426646$export$f86b2a1a2ce291b3;

});

parcelRegister("4vlZc", function(module, exports) {

let $347b1ca8206c0bf4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $347b1ca8206c0bf4$var$load("7U84Z"),
    $347b1ca8206c0bf4$var$load("1FTmX")
]).then(()=>parcelRequire('aGHdx'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("59U23", function(module, exports) {
var $7452dae99863188e$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $7452dae99863188e$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $7452dae99863188e$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($7452dae99863188e$var$RESOLVE_METHOD || {});
module.exports["PLATFORM"] = $7452dae99863188e$export$88c4881e092abcaf;
module.exports["MODE"] = $7452dae99863188e$export$e48589d9e4824227;

});

parcelRegister("gi5bC", function(module, exports) {
var $b7a27a5000feb1b6$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $b7a27a5000feb1b6$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $b7a27a5000feb1b6$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $b7a27a5000feb1b6$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_DOWNLOAD"] = "codeBlockDownload";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});
module.exports["EVENT_TYPE"] = $b7a27a5000feb1b6$export$76a2e4c433c23bb9;
module.exports["ACTION"] = $b7a27a5000feb1b6$export$9523889e0a5da4ba;
module.exports["ACTION_SUBJECT"] = $b7a27a5000feb1b6$export$7525482b5931e326;
module.exports["ACTION_SUBJECT_ID"] = $b7a27a5000feb1b6$export$9957974f8b4d8f74;

});

parcelRegister("d7o2V", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cUycv = parcelRequire("cUycv");





var $IcpgS = parcelRequire("IcpgS");


var $1lzbj = parcelRequire("1lzbj");


var $lspPP = parcelRequire("lspPP");

const $a9788d28138ffd57$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const actionContext = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $1lzbj.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $42omo.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $42omo.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};


















var $jZG1P = parcelRequire("jZG1P");


var $k7eoe = parcelRequire("k7eoe");


var $d925B = parcelRequire("d925B");





var $3h7Ko = parcelRequire("3h7Ko");

const $e42187240da9c39a$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const onCreateCallback = (0, $42omo.useCallback)((annotationId)=>{
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        }).fire((0, $k7eoe.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $42omo.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $42omo.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $d925B.ACTION).OPENED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $k7eoe.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $jZG1P.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $42omo.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $42omo.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $k7eoe.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});









var $hFjCV = parcelRequire("hFjCV");

const $a2ccd099cd67e7f8$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $3h7Ko.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $hFjCV.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e42187240da9c39a$export$2109cd350bcf6eda), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$a2ccd099cd67e7f8$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';











/** Exists in its own module to allow mocking in unit tests */ const $3fda5c6b1c3401ed$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};



var $jSHzw = parcelRequire("jSHzw");


var $1oCLl = parcelRequire("1oCLl");

const $9c05d72e21b72e90$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $42omo.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $3h7Ko.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $42omo.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $42omo.useCallback)((_event)=>{
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        /*
			 * The 100ms debounce batches rapid `selectionchange` events during user drag/extend
			 * operations into a single React update. When the nudge button triggers a programmatic
			 * `addRange`, it fires exactly ONE `selectionchange` — no batching needed. Skipping the
			 * debounce ensures annotation position is computed synchronously so the first click
			 * applies the yellow highlight immediately. `data-nudge-selection-active` is set
			 * exclusively by the Confluence comment nudge feature and is double-gated:
			 * (1) `expValEquals('confluence_comment_nudgebar_improvement', ...)` — explicit experiment
			 * gate; (2) `data-nudge-selection-active` — ensures 0ms only fires during an actual nudge
			 * click, not on every selectionchange for experiment-ON users. Zero behavioral change for
			 * other products or experiment-OFF users.
			 */ const nudgeDelay = typeof document !== 'undefined' && document.body?.getAttribute('data-nudge-selection-active') === 'true' && (0, $1oCLl.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true) ? 0 : 100;
        selectionTimeoutRef.current = setTimeout(()=>{
            const sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            let _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $3fda5c6b1c3401ed$export$90ee8f2d9317f430)(rendererDOM, _range)) {
                const { startContainer: startContainer, endContainer: endContainer } = _range;
                const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    let p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        const range = document.createRange();
                        range.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(range);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, nudgeDelay);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};






var $cUcZ5 = parcelRequire("cUcZ5");





var $dh538 = parcelRequire("dh538");











var $djzd2 = parcelRequire("djzd2");










const $b40078015275204e$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $jSHzw.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $42omo.useMemo)(()=>{
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $djzd2.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $42omo.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        // !!! at this point, the documentPosition can be the wrong position if the user select something else
        const positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        }).fire((0, $k7eoe.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $42omo.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $42omo.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $d925B.ACTION).OPENED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $k7eoe.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $jZG1P.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // at this point, the documentPosition is the position that the user has selected,
        // not the selectionDraftDocumentPosition
        // because the documentPosition is not promoted to selectionDraftDocumentPosition yet
        // use platform_editor_comments_api_manager here so we can clear the code path when the flag is removed
        const positionToAnnotate = (0, $dh538.fg)('platform_editor_comments_api_manager') ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $42omo.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $42omo.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $k7eoe.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $cUycv.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $42omo.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});





const $b486b70e1a3998ec$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $9c05d72e21b72e90$export$47201332e612f5a4)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b40078015275204e$export$ca7741472ed8ba00), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$b486b70e1a3998ec$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';


const $93be4f7567f6fd00$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children, !!hoverComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a2ccd099cd67e7f8$export$6d8376a902cb8aa7), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        component: hoverComponent
    }), !!selectionComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b486b70e1a3998ec$export$74435b85e23b84d9), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectionComponent: selectionComponent
    }));
};









var $21K7m = parcelRequire("21K7m");










const $d2f9ac245b0d60aa$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $42omo.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};






var $inPa6 = parcelRequire("inPa6");










const $848af0e2e5a97564$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $d2f9ac245b0d60aa$export$39f7c1a861a0d41c)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $848af0e2e5a97564$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    startPos: 1
});
const $848af0e2e5a97564$export$7121915072388536 = (props)=>{
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $1lzbj.useAnnotationStateByTypeEvent)({
        type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $IcpgS.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3h7Ko.AnnotationRangeProvider), {
        allowCommentsOnMedia: providers?.inlineComment?.allowCommentsOnMedia ?? false,
        isNestedRender: isNestedRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hFjCV.AnnotationHoverContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $93be4f7567f6fd00$export$787af8a111ff3c03), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        isNestedRender: isNestedRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($848af0e2e5a97564$var$LoadAnnotations, {
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9788d28138ffd57$export$41cd4a02859c2806), {
        isNestedRender: isNestedRender,
        createAnalyticsEvent: createAnalyticsEvent
    }), children))));
};
const $848af0e2e5a97564$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider?.annotationManager) // We need to ensure there is a single instance of the annotation manager for the whole document
    // and that it is the same instance for all annotations.
    // This is because the annotation manager is responsible for managing the state of ALL annotations.
    // This includes annotations inside extensions.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $IcpgS.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jSHzw.AnnotationManagerProvider), {
        annotationManager: annotationProvider.annotationManager,
        updateSubscriber: annotationProvider?.inlineComment?.updateSubscriber ?? undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($848af0e2e5a97564$export$7121915072388536, {
        rendererRef: rendererRef,
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }, children)));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $IcpgS.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($848af0e2e5a97564$export$7121915072388536, {
        rendererRef: rendererRef,
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }, children));
};
module.exports["AnnotationsPositionContext"] = $848af0e2e5a97564$export$8c8c3e12db6c0591;
module.exports["AnnotationsWrapper"] = $848af0e2e5a97564$export$cef0157dd42cbb3f;

});

parcelRegister("lspPP", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $inPa6 = parcelRequire("inPa6");


var $3pfAb = parcelRequire("3pfAb");


var $d925B = parcelRequire("d925B");


var $cUycv = parcelRequire("cUycv");


var $bYZ53 = parcelRequire("bYZ53");


var $h9yJL = parcelRequire("h9yJL");


var $ks2lK = parcelRequire("ks2lK");





var $aXG5V = parcelRequire("aXG5V");




/* eslint-disable jsdoc/require-jsdoc -- internal step helpers */ 





// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $d5988c5b4b1df67c$var$MEDIA_OR_MEDIA_SINGLE_REGEX = /media|mediaSingle/;
function $d5988c5b4b1df67c$export$aabc9b13a308cc43(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $d5988c5b4b1df67c$var$getNodeType = (element)=>element.dataset.nodeType;
function $d5988c5b4b1df67c$var$isPositionPointer(element) {
    return $d5988c5b4b1df67c$export$aabc9b13a308cc43(element) > -1;
}
function $d5988c5b4b1df67c$export$25245567f53f158f(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $d5988c5b4b1df67c$export$9d1d5d87ae7da22f(parentElement)) return null;
    if ($d5988c5b4b1df67c$var$isPositionPointer(parentElement)) return parentElement;
    return $d5988c5b4b1df67c$export$25245567f53f158f(parentElement);
}
function $d5988c5b4b1df67c$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $d5988c5b4b1df67c$export$9d1d5d87ae7da22f(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $d5988c5b4b1df67c$var$findMediaParent(parentElement);
}
function $d5988c5b4b1df67c$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($d5988c5b4b1df67c$export$9d1d5d87ae7da22f(parentElement) || !parentElement) return null;
    if ($d5988c5b4b1df67c$var$isPositionPointer(parentElement)) return element;
    return $d5988c5b4b1df67c$var$findParentBeforePointer(parentElement);
}
function $d5988c5b4b1df67c$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $d5988c5b4b1df67c$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $d5988c5b4b1df67c$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $d5988c5b4b1df67c$var$isNodeInlineMark(node) {
    return $d5988c5b4b1df67c$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $d5988c5b4b1df67c$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $d5988c5b4b1df67c$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $d5988c5b4b1df67c$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
   * This checks if the element has any descendents with the data-inline-card
   * attribute set to 'true'. If it does, we should not consider it as an
   * inline text mark.
   **/ if ($d5988c5b4b1df67c$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $d5988c5b4b1df67c$var$hasInlineNodeDescendant(node) {
    if ($d5988c5b4b1df67c$var$isElementNode(node)) {
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($d5988c5b4b1df67c$var$hasInlineNodeDescendant);
    }
    return false;
}
function $d5988c5b4b1df67c$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($d5988c5b4b1df67c$var$isTextNode(prev) || $d5988c5b4b1df67c$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($d5988c5b4b1df67c$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($d5988c5b4b1df67c$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $d5988c5b4b1df67c$export$9d1d5d87ae7da22f(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $d5988c5b4b1df67c$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
   * If anchor node is an element (e.g. after a triple click) the anchorOffset
   * is the number of child nodes preceding the anchor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
   *
   * For end pos we calculate the number of characters by stepping through
   * each of the node's children.
   */ if (node instanceof HTMLElement && $d5988c5b4b1df67c$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $d5988c5b4b1df67c$export$aabc9b13a308cc43(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $d5988c5b4b1df67c$export$aabc9b13a308cc43(node) + offset;
    }
    const parent = $d5988c5b4b1df67c$export$25245567f53f158f(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $d5988c5b4b1df67c$export$aabc9b13a308cc43(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $d5988c5b4b1df67c$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($d5988c5b4b1df67c$var$isNodeInlineTextMark(preParentPointer) || $d5988c5b4b1df67c$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($d5988c5b4b1df67c$var$isElementInlineMark(preParentPointer) || $d5988c5b4b1df67c$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $d5988c5b4b1df67c$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $d5988c5b4b1df67c$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $d5988c5b4b1df67c$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $d5988c5b4b1df67c$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $d5988c5b4b1df67c$export$25245567f53f158f(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && $d5988c5b4b1df67c$var$MEDIA_OR_MEDIA_SINGLE_REGEX.test($d5988c5b4b1df67c$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $d5988c5b4b1df67c$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $d5988c5b4b1df67c$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $d5988c5b4b1df67c$export$aabc9b13a308cc43(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $d5988c5b4b1df67c$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $d5988c5b4b1df67c$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $d5988c5b4b1df67c$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $aXG5V.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}



var $djzd2 = parcelRequire("djzd2");

function $dfb07954adffbc39$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $dfb07954adffbc39$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $dfb07954adffbc39$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $dfb07954adffbc39$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}






var $B9v3F = parcelRequire("B9v3F");

var $g4GD8 = parcelRequire("g4GD8");


const $be7bedbe4c954a25$export$3726c4866ce829b5 = ({ doc: doc, schema: schema })=>{
    if (!doc || !schema) return null;
    const selection = document.getSelection();
    if (!selection || selection.type !== 'Range' || selection.rangeCount !== 1) return null;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return null;
    const startNode = (0, $d5988c5b4b1df67c$export$25245567f53f158f)(range.startContainer);
    const endNode = (0, $d5988c5b4b1df67c$export$25245567f53f158f)(range.endContainer);
    if (!startNode || !endNode) return null;
    const startPos = (0, $d5988c5b4b1df67c$export$aabc9b13a308cc43)(startNode);
    const endPos = (0, $d5988c5b4b1df67c$export$aabc9b13a308cc43)(endNode);
    if (startPos === null || endPos === null) return null;
    const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
    if (!pos) return null;
    const from = Math.min(pos.from, pos.to);
    const to = Math.max(pos.from, pos.to);
    if (from === to) return null;
    let pmSelection;
    try {
        pmSelection = (0, $ks2lK.TextSelection).create(doc, from, to);
    } catch  {
        return null;
    }
    const startIndex = from - startPos;
    const endIndex = to - endPos;
    if (startIndex < 0 || endIndex < 0) return null;
    const selectionFragment = (0, $B9v3F.getFragmentsFromSelection)(pmSelection);
    const localIds = (0, $g4GD8.getLocalIdsFromSelection)(pmSelection);
    return {
        localIds: localIds,
        selectionFragment: selectionFragment,
        selectionMarkdown: null,
        startIndex: startIndex,
        endIndex: endIndex
    };
};


class $99cc0efe08aadb17$export$2e2bcd8739ae039 {
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
   * Validate whether we can create an annotation between two positions
   */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const currentSelection = (0, $ks2lK.TextSelection).create(this.doc, from, to);
        if ((0, $bYZ53.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
        const result = (0, $bYZ53.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $aXG5V.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $aXG5V.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $d925B.ACTION).DELETED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $aXG5V.RemoveMarkStep) ? (0, $djzd2.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, _annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * This is replaced by `isRangeAnnotatable`.
   *
   * @deprecated
   **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
   * Note: False indicates that the selection not able to be calculated.
   */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
    }
    getSelectionContext() {
        return (0, $be7bedbe4c954a25$export$3726c4866ce829b5)({
            doc: this.doc,
            schema: this.schema
        });
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
        if (!pos || !this.doc) return [];
        return (0, $bYZ53.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $aXG5V.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $d5988c5b4b1df67c$export$74899f7e5acb5cd3)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $dfb07954adffbc39$export$fb7dab895a0d310e)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $djzd2.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            ancestorNodeTypes: (0, $djzd2.getRendererRangeAncestorNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $dfb07954adffbc39$export$fb7dab895a0d310e)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $bYZ53.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.transformer = void 0;
        this.doc = void 0;
        this.schema = void 0;
        // Any kind of refence is allowed
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.ref = void 0;
        this.onAnalyticsEvent = void 0;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $h9yJL.JSONTransformer)();
    }
}


const $0a20e195094e2f97$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(new (0, $99cc0efe08aadb17$export$2e2bcd8739ae039)());
function $0a20e195094e2f97$export$66feffbad722f9d4({ children: children, context: context }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const actions = (0, $42omo.useMemo)(()=>new (0, $99cc0efe08aadb17$export$2e2bcd8739ae039)(true), []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) > 1 && (0, $dh538.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $3pfAb.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a20e195094e2f97$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions
    }, (0, $dh538.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(children) : children);
}
const $0a20e195094e2f97$export$d5fcf151601331bc = $0a20e195094e2f97$export$1e9ea4edb6d1bfe6.Consumer;
module.exports["RendererContext"] = $0a20e195094e2f97$export$1e9ea4edb6d1bfe6;
module.exports["RendererActionsContext"] = $0a20e195094e2f97$export$66feffbad722f9d4;
module.exports["RendererActionsContextConsumer"] = $0a20e195094e2f97$export$d5fcf151601331bc;

});

parcelRegister("bYZ53", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $cUycv = parcelRequire("cUycv");


var $dh538 = parcelRequire("dh538");

const $7620bc72075c20fa$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $7620bc72075c20fa$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $7620bc72075c20fa$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $7620bc72075c20fa$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $7620bc72075c20fa$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($7620bc72075c20fa$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $7620bc72075c20fa$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $7620bc72075c20fa$export$2a160f09551a3adc({ doc: doc, pos: pos }) {
    if (!(0, $dh538.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        // For a range, we can get ancestors at both from and to positions
        // or just use the from position if you want ancestors at the start
        const resolvedFromPos = doc.resolve(pos.from);
        const resolvedToPos = doc.resolve(pos.to);
        // Collect ancestors at the 'from' position
        for(let depth = resolvedFromPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedFromPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        // Use nodesBetween to collect parent types without additional resolve() calls
        // This isn't as precise as calling resolve() on each parent, but it's a lot faster
        // and should hopefully provide a good approximation of the ancestor nodes
        const seenParents = new Set();
        doc.nodesBetween(pos.from, pos.to, (_node, _nodePos, parent)=>{
            // Collect parent chain using the parent parameter
            const currentParent = parent;
            if (!!currentParent && !seenParents.has(currentParent)) {
                seenParents.add(currentParent);
                nodeNames.add(currentParent.type.name);
            // Note: We can't easily get the parent's parent from this context
            // without additional resolve calls, so this approach has limitations
            }
            return true;
        });
        // Optionally collect ancestors at the 'to' position if different
        // This ensures we capture all ancestor contexts across the range
        if (pos.from !== pos.to) for(let depth = resolvedToPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedToPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        return [
            ...nodeNames
        ];
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $7620bc72075c20fa$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, _pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $7620bc72075c20fa$export$bb1945a828f2864b(pos) {
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $7620bc72075c20fa$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $7620bc72075c20fa$export$a35880e7ecdcf47b(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}
module.exports["canApplyAnnotationOnRange"] = $7620bc72075c20fa$export$77ddf8216f9eb904;
module.exports["getAnnotationIdsFromRange"] = $7620bc72075c20fa$export$badbcc229c848aec;
module.exports["hasAnnotationMark"] = $7620bc72075c20fa$export$5fe1412b20386053;
module.exports["containsAnyAnnotations"] = $7620bc72075c20fa$export$1976770b876b2728;
module.exports["getRangeInlineNodeNames"] = $7620bc72075c20fa$export$35054451202ed5d9;
module.exports["getRangeAncestorNodeNames"] = $7620bc72075c20fa$export$2a160f09551a3adc;
module.exports["getAnnotationInlineNodeTypes"] = $7620bc72075c20fa$export$8261bc1f662f3f6e;
module.exports["getAnnotationMarksForPos"] = $7620bc72075c20fa$export$bb1945a828f2864b;
module.exports["isEmptyTextSelection"] = $7620bc72075c20fa$export$2efbc6d84ea0fbec;
module.exports["isEmptyTextSelectionRenderer"] = $7620bc72075c20fa$export$a35880e7ecdcf47b;

});

parcelRegister("B9v3F", function(module, exports) {

var $h9yJL = parcelRequire("h9yJL");


var $8qoeq = parcelRequire("8qoeq");

const $8375a04319214e76$export$dae3dcae007fe30 = (selection)=>{
    if (!selection || selection.empty) return null;
    const slice = (0, $8qoeq.getSliceFromSelection)(selection);
    const content = slice.content;
    const fragment = [];
    content.forEach((node)=>{
        fragment.push((0, $h9yJL.nodeToJSON)(node));
    });
    return fragment;
};
module.exports["getFragmentsFromSelection"] = $8375a04319214e76$export$dae3dcae007fe30;

});

parcelRegister("8qoeq", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");



const $66716f5bfeb7aaba$var$listDepth = 3;
const $66716f5bfeb7aaba$export$8701765a689d47ab = ($from, $to)=>{
    // Block level lists
    const listParents = [
        'bulletList',
        'orderedList'
    ];
    if ($from.depth >= $66716f5bfeb7aaba$var$listDepth && $to.depth >= $66716f5bfeb7aaba$var$listDepth && $from.depth === $to.depth) {
        // Get grandparents (from)
        const grandparentFrom = $from.node($from.depth - 1);
        const greatGrandparentFrom = $from.node($from.depth - 2);
        // Get grandparents (to)
        const grandparentTo = $to.node($from.depth - 1);
        const greatGrandparentTo = $to.node($from.depth - 2);
        if (greatGrandparentTo.eq(greatGrandparentFrom) && listParents.includes(greatGrandparentFrom.type.name) && // Selection covers entire list
        greatGrandparentFrom.firstChild?.eq(grandparentFrom) && greatGrandparentFrom.lastChild?.eq(grandparentTo)) return true;
    }
    return false;
};
const $66716f5bfeb7aaba$export$4fd509032ef7561b = (selection)=>{
    const { from: from, to: to } = selection;
    if (from === to) return (0, $5SAOw.Fragment).empty;
    let frag = (0, $5SAOw.Fragment).empty;
    const sortedRanges = [
        ...selection.ranges.slice()
    ].sort((a, b)=>a.$from.pos - b.$from.pos);
    for (const range of sortedRanges){
        const { $from: $from, $to: $to } = range;
        const to = $to.pos;
        const depth = // If we're in a text selection, and share the parent node across the anchor->head
        // make the depth the parent node
        selection instanceof (0, $ks2lK.TextSelection) && $from.parent.eq($to.parent) ? Math.max(0, $from.sharedDepth(to) - 1) : $from.sharedDepth(to);
        let finalDepth = depth;
        // For block-level lists (non-nested) specifically use the selection
        if ($66716f5bfeb7aaba$export$8701765a689d47ab($from, $to)) finalDepth = $from.depth - $66716f5bfeb7aaba$var$listDepth;
        const start = $from.start(finalDepth);
        const node = $from.node(finalDepth);
        const content = node.content.cut($from.pos - start, $to.pos - start);
        frag = frag.append(content);
    }
    return frag;
};
module.exports["getSliceFromSelection"] = $66716f5bfeb7aaba$export$4fd509032ef7561b;

});

parcelRegister("g4GD8", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");


var $dh538 = parcelRequire("dh538");


var $8qoeq = parcelRequire("8qoeq");

const $f5fff3bd04b515d6$export$9ce8378d786d4035 = (selection)=>{
    if (!selection) return null;
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        if ((0, $dh538.fg)('platform_editor_ai_selection_local_ids')) {
            const ids = [];
            const rootLocalId = selection.node.attrs?.localId;
            if (rootLocalId) ids.push(rootLocalId);
            selection.node.descendants((node)=>{
                if (node.isInline) return false;
                const localId = node.attrs?.localId;
                if (localId) ids.push(localId);
            });
            return ids;
        }
        return [
            selection.node.attrs.localId
        ];
    } else if (selection instanceof (0, $7XFGZ.CellSelection)) {
        if ((0, $dh538.fg)('platform_editor_ai_selection_local_ids')) {
            const ids = [];
            const ancestorIds = new Set();
            // Collect localIds from each selected cell and its descendants
            selection.forEachCell((cellNode, cellPos)=>{
                const cellLocalId = cellNode.attrs?.localId;
                if (cellLocalId) ids.push(cellLocalId);
                cellNode.descendants((node)=>{
                    if (node.isInline) return false;
                    const localId = node.attrs?.localId;
                    if (localId) ids.push(localId);
                });
                // Collect ancestor localIds (row, table) separately
                const $cell = selection.$anchorCell.doc.resolve(cellPos + 1);
                for(let depth = $cell.depth - 1; depth >= 1; depth--){
                    const ancestor = $cell.node(depth);
                    const localId = ancestor.attrs?.localId;
                    if (localId) ancestorIds.add(localId);
                }
            });
            const uniqueIds = new Set(ids);
            const uniqueAncestors = [
                ...ancestorIds
            ].filter((id)=>!uniqueIds.has(id));
            return [
                ...uniqueIds,
                ...uniqueAncestors
            ];
        }
    } else if (selection.empty) return [
        selection.$from.parent.attrs.localId
    ];
    const slice = (0, $8qoeq.getSliceFromSelection)(selection);
    const content = slice.content;
    const ids = [];
    content.forEach((node)=>{
        const localId = node.attrs?.localId;
        if (localId) ids.push(localId);
    });
    return ids;
};
module.exports["getLocalIdsFromSelection"] = $f5fff3bd04b515d6$export$9ce8378d786d4035;

});

parcelRegister("3h7Ko", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $ddde644a24a9c36e$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $ddde644a24a9c36e$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $ddde644a24a9c36e$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $42omo.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $ddde644a24a9c36e$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $42omo.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $ddde644a24a9c36e$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $42omo.useReducer)($ddde644a24a9c36e$var$reducer, $ddde644a24a9c36e$var$initialState);
    const clearSelectionRange = (0, $42omo.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $42omo.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $42omo.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setHoverTarget = (0, $42omo.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- range for media hover highlight
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $42omo.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $42omo.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $42omo.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $42omo.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $42omo.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $42omo.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ddde644a24a9c36e$export$145b9bb655c3d220.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ddde644a24a9c36e$export$efb0d1c8cbaac647.Provider, {
        value: dispatchData
    }, children));
};
const $ddde644a24a9c36e$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    /*
   * If this is a nested render, we do not provide the context
   * because it has already been provided higher up the component tree
   * and we need the original context to create annotations on extensions.
   */ return isNestedRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ddde644a24a9c36e$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia
    }, children);
};
const $ddde644a24a9c36e$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $42omo.useContext)($ddde644a24a9c36e$export$145b9bb655c3d220);
};
const $ddde644a24a9c36e$export$708fc397e2b6f08d = ()=>{
    return (0, $42omo.useContext)($ddde644a24a9c36e$export$efb0d1c8cbaac647);
};
module.exports["AnnotationRangeProvider"] = $ddde644a24a9c36e$export$30384a6aedd19fee;
module.exports["useAnnotationRangeState"] = $ddde644a24a9c36e$export$e07ee6d6cc95d9a0;
module.exports["useAnnotationRangeDispatch"] = $ddde644a24a9c36e$export$708fc397e2b6f08d;

});

parcelRegister("hFjCV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $adc627cbe56a02e2$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isWithinRange: false
});
const $adc627cbe56a02e2$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $adc627cbe56a02e2$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $42omo.useState)(false);
    const timeoutHandler = (0, $42omo.useRef)();
    const cancelTimeout = (0, $42omo.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $42omo.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $42omo.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $42omo.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($adc627cbe56a02e2$var$AnnotationHoverStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($adc627cbe56a02e2$var$AnnotationHoverDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $adc627cbe56a02e2$export$a02bfcbbbf920306 = ()=>{
    return (0, $42omo.useContext)($adc627cbe56a02e2$var$AnnotationHoverStateContext);
};
const $adc627cbe56a02e2$export$c288883964405c82 = ()=>{
    return (0, $42omo.useContext)($adc627cbe56a02e2$var$AnnotationHoverDispatchContext);
};
module.exports["AnnotationHoverContext"] = $adc627cbe56a02e2$export$b3db0feb20552fc3;
module.exports["useAnnotationHoverContext"] = $adc627cbe56a02e2$export$a02bfcbbbf920306;
module.exports["useAnnotationHoverDispatch"] = $adc627cbe56a02e2$export$c288883964405c82;

});

parcelRegister("iZq0X", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1d0afbb8858f32d4$export$d452675449e81987 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $1d0afbb8858f32d4$export$5b655fe45447a548 = $1d0afbb8858f32d4$export$d452675449e81987.Provider;
module.exports["ValidationContext"] = $1d0afbb8858f32d4$export$d452675449e81987;
module.exports["ValidationContextProvider"] = $1d0afbb8858f32d4$export$5b655fe45447a548;

});

parcelRegister("6uN0A", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1aa8eab29b174a45$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $1aa8eab29b174a45$export$2e2bcd8739ae039 = $1aa8eab29b174a45$var$AnalyticsContext;
module.exports["default"] = $1aa8eab29b174a45$export$2e2bcd8739ae039;

});

parcelRegister("kIphX", function(module, exports) {
const $d510f2e588a31a71$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });
module.exports["copyTextToClipboard"] = $d510f2e588a31a71$export$f980440e1ab4537d;

});

parcelRegister("48Use", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");




const $e087e0e2784d599e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    placeholder: {
        id: "fabric.editor.captionPlaceholder",
        defaultMessage: "Add a caption"
    }
});


function $c7d42479d13572a9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c7d42479d13572a9$var$captionWrapperStyle = {
    name: "4iruax",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #505258)"
};
const $c7d42479d13572a9$var$placeholderStyle = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $c7d42479d13572a9$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $c7d42479d13572a9$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            xcss: $c7d42479d13572a9$var$placeholderStyle
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), null, formatMessage((0, $e087e0e2784d599e$export$defe85febe8b728c).placeholder))) : null, children);
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $c7d42479d13572a9$var$_default_1 = (0, $aXWIB.injectIntl)($c7d42479d13572a9$export$f7feb87190a94c76);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c7d42479d13572a9$export$2e2bcd8739ae039 = $c7d42479d13572a9$var$_default_1;
module.exports["default"] = $c7d42479d13572a9$export$2e2bcd8739ae039;

});

parcelRegister("4mSjx", function(module, exports) {
const $34379dd11d589f9f$export$bafd6beec0797f87 = 24;
var $34379dd11d589f9f$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($34379dd11d589f9f$var$CSS_VAR_NAMES || {});
const $34379dd11d589f9f$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $34379dd11d589f9f$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $34379dd11d589f9f$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $34379dd11d589f9f$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $34379dd11d589f9f$var$stringifyStyle(style);
    return style;
}
module.exports["listItemCounterPadding"] = $34379dd11d589f9f$export$bafd6beec0797f87;
module.exports["getOrderedListInlineStyles"] = $34379dd11d589f9f$export$6d31fdb1d74cee3e;

});

parcelRegister("irKZA", function(module, exports) {
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.

var $dMNMt = parcelRequire("dMNMt");





const $775de8d03f6b80cd$export$8ef94ae42a3729bd = 1;
const $775de8d03f6b80cd$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return (0, $dMNMt.resolveOrder)(order) ?? $775de8d03f6b80cd$export$8ef94ae42a3729bd;
};
const $775de8d03f6b80cd$export$320582fc14ba1e0f = (options)=>{
    const order = (0, $dMNMt.resolveOrder)(options.order) ?? $775de8d03f6b80cd$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
module.exports["getOrderFromOrderedListNode"] = $775de8d03f6b80cd$export$cbefb5b89ef0719f;
module.exports["getItemCounterDigitsSize"] = $775de8d03f6b80cd$export$320582fc14ba1e0f;

});

parcelRegister("dMNMt", function(module, exports) {
// resolve "order" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveStart"
// in packages/editor/adf-schema/src/schema/nodes/ordered-list.ts
const $53a6958dc36273f1$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
module.exports["resolveOrder"] = $53a6958dc36273f1$export$d445360e2a3c026b;

});

parcelRegister("1zav4", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");

var $kPuBV = parcelRequire("kPuBV");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $d7ZU3 = parcelRequire("d7ZU3");


var $5MaNT = parcelRequire("5MaNT");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $jep17 = parcelRequire("jep17");

const $9afc1a6cc885e6cd$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $9K4OG.css)((0, $jep17.mapBackgroundColors)());



var $9Fl9f = parcelRequire("9Fl9f");


function $2799e2cdfcd8e59e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2799e2cdfcd8e59e$export$808015ab1dd6897a = 24;
const $2799e2cdfcd8e59e$export$afe1899c3eea9823 = 16;
const $2799e2cdfcd8e59e$export$910bf0d22c3d10f2 = 14;
const $2799e2cdfcd8e59e$export$a43e30915fab3ccf = 8;
const $2799e2cdfcd8e59e$export$531f77930bf508de = 48;
const $2799e2cdfcd8e59e$export$c60fae4049791eae = 140;
const $2799e2cdfcd8e59e$export$72aad729077aa0fb = 1;
const $2799e2cdfcd8e59e$export$e56b8ca552b280f6 = 8;
const $2799e2cdfcd8e59e$export$bba39e724bc39451 = 6;
const $2799e2cdfcd8e59e$export$e5ff276883773ffd = 8;
const $2799e2cdfcd8e59e$export$880976487022eb5 = $2799e2cdfcd8e59e$export$808015ab1dd6897a + $2799e2cdfcd8e59e$export$e5ff276883773ffd - $2799e2cdfcd8e59e$export$72aad729077aa0fb;
/* first block node has 0 top margin */ var $2799e2cdfcd8e59e$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $2799e2cdfcd8e59e$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $2799e2cdfcd8e59e$var$firstNodeWithNotMarginTop = ()=>(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $2799e2cdfcd8e59e$var$_ref2 : $2799e2cdfcd8e59e$var$_ref;
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * The style is mirrored in:
 * - packages/editor/renderer/src/ui/Renderer/RendererStyleContainer.tsx ( seems outdated )
 * - packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
 *
 * If you are updating this, please also update the above files.
 *
 * @deprecated This Emotion-based style function is being phased out as part of the
 * `platform_editor_core_static_css` experiment migration to Compiled CSS. While the experiment
 * is running, any changes here MUST also be reflected in `EditorContentContainer-compiled.tsx`
 * (look for `tableSharedStyle`, `tableSharedStyle_with_*`, `tableSharedStyle_without_*` entries
 * in the `editorContentStyles` cssMap). Failure to do so will cause visual regressions when the
 * compiled version is active.
 */ const $2799e2cdfcd8e59e$export$c2bf8eea75aa9302 = ()=>{
    const browser = (0, $d7ZU3.getBrowserInfo)();
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return /*#__PURE__*/ (0, $9K4OG.css)((0, $9afc1a6cc885e6cd$export$677e93f0f5f9623a)(), " .", (0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;", (0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Fake side borders are not needed when the rounded overlay owns the outer border. */
				.${(0, $9Fl9f.TableSharedCssClassName).TABLE_RIGHT_BORDER},
				.${(0, $9Fl9f.TableSharedCssClassName).TABLE_LEFT_BORDER} {
					display: none;
				}
					` : `.${(0, $9Fl9f.TableSharedCssClassName).TABLE_RIGHT_BORDER},
			.${(0, $9Fl9f.TableSharedCssClassName).TABLE_LEFT_BORDER} {
				display: block;
				width: 1px;
				height: calc(100% - ${"var(--ds-space-300, 24px)"});
				background: ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
				position: absolute;
				top: ${"var(--ds-space-300, 24px)"};
			}
			.${(0, $9Fl9f.TableSharedCssClassName).TABLE_RIGHT_BORDER} {
				right: 0;
			}
			.${(0, $9Fl9f.TableSharedCssClassName).TABLE_LEFT_BORDER} {
				left: 0;
			}
			.${(0, $9Fl9f.TableSharedCssClassName).TABLE_LEFT_BORDER}[data-with-numbered-table='true'] {
				left: ${(0, $aFUXX.akEditorTableNumberColumnWidth) - 1}px;
			}`, ";.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", (0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $aFUXX.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", (0, $9Fl9f.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", (0, $9Fl9f.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", (0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", (0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER, ">table,.", (0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $dh538.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"};
		}` : '', ".", (0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER, ">table,.", (0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER, ">table,.", (0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;", (0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Keep a transparent border so the collapsed border model reserves the same 1px slot
			   on the table edge; the ::after overlay draws the visible rounded border instead. */
			border: ${$2799e2cdfcd8e59e$export$72aad729077aa0fb}px solid transparent;` : `border: ${$2799e2cdfcd8e59e$export$72aad729077aa0fb}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
			border-left-color: transparent;
			border-right-color: transparent;`, " table-layout:fixed;font-size:1em;width:100%;", (0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `position: relative;

			/* Table-width outer-border owner for overflow-safe rounded corners. */
			&::after {
				content: '';
				position: absolute;
				inset: -0.5px;
				border: ${$2799e2cdfcd8e59e$export$72aad729077aa0fb}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
				border-radius: ${"var(--ds-radius-xlarge, 12px)"};
				pointer-events: none;
				z-index: 1;
			}` : '', " &[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, #00000000);}>tbody>tr>th,>tbody>tr>td{min-width:", $2799e2cdfcd8e59e$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;", (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) ? `&[data-valign='middle'] {
								vertical-align: middle;
							}
							&[data-valign='bottom'] {
								vertical-align: bottom;
							}` : '', " border:1px solid var(--ds-background-accent-gray-subtler, #DDDEE1);border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', " ", $2799e2cdfcd8e59e$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}", (0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Let the wrapper overlay own the outer table perimeter.
				   data-reaches-* attributes are set by the TableCell node view. */
				> tbody > tr > th[data-reaches-top],
				> tbody > tr > td[data-reaches-top] {
					border-top-color: transparent;
				}

				> tbody > tr > th[data-reaches-left],
				> tbody > tr > td[data-reaches-left] {
					border-left-color: transparent;
				}

				> tbody > tr > td[data-reaches-left]::after {
					border-left-color: transparent;
				}

				> tbody > tr > td[data-reaches-bottom]::after,
				> tbody > tr > th[data-reaches-bottom]::after {
					border-bottom-color: transparent;
				}

				/* The rounded-table overlay owns transparent perimeter borders.
				   Paint edge cell backgrounds into that reserved border area so coloured
				   first/last rows do not show the page background through 1px seams. */
				> tbody > tr > th[data-reaches-top],
				> tbody > tr > td[data-reaches-top],
				> tbody > tr > th[data-reaches-bottom],
				> tbody > tr > td[data-reaches-bottom] {
					background-clip: border-box;
				}` : '', " th{background-color:var(--ds-background-accent-gray-subtlest, #F0F1F2);text-align:left;", (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', "{.", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, #FFFFFF);:not(.", (0, $aFUXX.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, #0B120E24);}.", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $kPuBV.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, #0515240F);}.", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #0515240F);}>[data-ds--code--code-block]{background-image:", (0, $kPuBV.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, #0515240F)!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, #0515240F);}}}}}}", (0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* When the number column is enabled, the left visual edge belongs to the number column.
		   Remove the left border-radius and left border from the table's ::after overlay
		   so it doesn't double-up or round where the number column already provides that edge. */
		.${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true'] {
			> .${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table::after,
			> .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table::after {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
				border-left-color: transparent;
			}
		}` : '', ";");
};
module.exports["tableMarginTop"] = $2799e2cdfcd8e59e$export$808015ab1dd6897a;
module.exports["tableCellMinWidth"] = $2799e2cdfcd8e59e$export$531f77930bf508de;
module.exports["tableNewColumnMinWidth"] = $2799e2cdfcd8e59e$export$c60fae4049791eae;
module.exports["tableCellBorderWidth"] = $2799e2cdfcd8e59e$export$72aad729077aa0fb;
module.exports["tableCellPadding"] = $2799e2cdfcd8e59e$export$e56b8ca552b280f6;
module.exports["tableControlsSpacing"] = $2799e2cdfcd8e59e$export$880976487022eb5;
module.exports["tableSharedStyle"] = $2799e2cdfcd8e59e$export$c2bf8eea75aa9302;

});

parcelRegister("5MaNT", function(module, exports) {
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $f61fb812fe2d68f7$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
module.exports["CodeBlockSharedCssClassName"] = $f61fb812fe2d68f7$export$42659c26f026f6ea;

});

parcelRegister("jep17", function(module, exports) {

var $63Ztt = parcelRequire("63Ztt");


var $6icEc = parcelRequire("6icEc");

const $5cbfa887f9af513b$export$35c9e86e192acb85 = ()=>{
    let cssString = '';
    (0, $63Ztt.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $6icEc.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
module.exports["mapBackgroundColors"] = $5cbfa887f9af513b$export$35c9e86e192acb85;

});

parcelRegister("6icEc", function(module, exports) {
// This import will be stripped on build

var $1To4a = parcelRequire("1To4a");

function $76f1a9db98b6b1bf$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $76f1a9db98b6b1bf$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $76f1a9db98b6b1bf$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $76f1a9db98b6b1bf$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $76f1a9db98b6b1bf$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #669DF1)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E7F9FF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #C6EDFB)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #6CC3E0)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #DCFFF1)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #BAF3DB)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #4BCE97)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #F5E989)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FCA700)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFECEB)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFD5D2)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #F87168)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #F8EEFE)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #EED7FC)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #C97CF4)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F0F1F2)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #8C8F97)" // source for hex code was legacy token N60,
    }
};
module.exports["hexToEditorBackgroundPaletteColor"] = $76f1a9db98b6b1bf$export$5f6a44a42a4b38c2;
module.exports["hexToEditorBackgroundPaletteRawValue"] = $76f1a9db98b6b1bf$export$a270511a0e7fd61a;

});

parcelRegister("1To4a", function(module, exports) {


var $1vDIt = parcelRequire("1vDIt");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $cd5eb1a9b0824c7e$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $1vDIt.default)[tokenId];
    let tokenValue = fallback;
    typeof $kyRHQ;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $cd5eb1a9b0824c7e$export$2e2bcd8739ae039 = $cd5eb1a9b0824c7e$var$getTokenValue;
module.exports["default"] = $cd5eb1a9b0824c7e$export$2e2bcd8739ae039;

});

parcelRegister("9Fl9f", function(module, exports) {

var $63Ztt = parcelRequire("63Ztt");

const $33b4d1e6079045bd$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $63Ztt.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-wrapper`,
    TABLE_NODE_WRAPPER_NO_OVERFLOW: `${(0, $63Ztt.tablePrefixSelector)}-wrapper-no-overflow`,
    TABLE_SCROLL_INLINE_SHADOW: `${(0, $63Ztt.tablePrefixSelector)}-scroll-inline-shadow`,
    TABLE_RIGHT_BORDER: `${(0, $63Ztt.tablePrefixSelector)}-right-border`,
    TABLE_LEFT_BORDER: `${(0, $63Ztt.tablePrefixSelector)}-left-border`,
    TABLE_LEFT_SHADOW: `${(0, $63Ztt.tablePrefixSelector)}-with-left-shadow`,
    TABLE_NATIVE_STICKY: `${(0, $63Ztt.tablePrefixSelector)}-row-native-sticky`,
    TABLE_RIGHT_SHADOW: `${(0, $63Ztt.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $63Ztt.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $63Ztt.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $63Ztt.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $63Ztt.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $63Ztt.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $63Ztt.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $63Ztt.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $63Ztt.tablePrefixSelector)}-shadow-sentinel-right`,
    TABLE_STICKY: `${(0, $63Ztt.tablePrefixSelector)}-sticky`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $63Ztt.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $63Ztt.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $63Ztt.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $63Ztt.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $63Ztt.tablePrefixSelector)}-resizer-container`,
    TABLE_VIEW_CONTENT_WRAP: 'tableView-content-wrap'
};
module.exports["TableSharedCssClassName"] = $33b4d1e6079045bd$export$c096bca5477eb7ad;

});

parcelRegister("2CQVV", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $3d7dc9b28782bfb3$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    tableScrollRegion: {
        id: "fabric.editor.tableScrollRegion",
        defaultMessage: "Table scroll region"
    },
    tableOptions: {
        id: "fabric.editor.tableOptions",
        defaultMessage: "Table options"
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeIncreaseScreenReaderInformation",
        defaultMessage: "Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeDecreaseScreenReaderInformation",
        defaultMessage: "Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    headerRow: {
        id: "fabric.editor.headerRow",
        defaultMessage: "Header row"
    },
    headerColumn: {
        id: "fabric.editor.headerColumn",
        defaultMessage: "Header column"
    },
    numberedColumn: {
        id: "fabric.editor.numberedColumn",
        defaultMessage: "Numbered column"
    },
    collapseTable: {
        id: "fabric.editor.collapseTable",
        defaultMessage: "Collapse table"
    },
    resizeTable: {
        id: "fabric.editor.tables.resizeTable",
        defaultMessage: "Resize table"
    },
    insertColumn: {
        id: "fabric.editor.insertColumn",
        defaultMessage: "Insert column right"
    },
    addColumnLeft: {
        id: "fabric.editor.addColumnLeft",
        defaultMessage: "Add column left"
    },
    addColumnRight: {
        id: "fabric.editor.addColumnRight",
        defaultMessage: "Add column right"
    },
    insertColumnDrag: {
        id: "fabric.editor.insertColumnDrag",
        defaultMessage: "Insert column"
    },
    removeColumns: {
        id: "fabric.editor.removeColumns",
        defaultMessage: "Delete {0, plural, one {column} other {columns}}"
    },
    insertRow: {
        id: "fabric.editor.insertRow",
        defaultMessage: "Insert row below"
    },
    addRowAbove: {
        id: "fabric.editor.addRowAbove",
        defaultMessage: "Add row above"
    },
    addRowBelow: {
        id: "fabric.editor.addRowBelow",
        defaultMessage: "Add row below"
    },
    moveColumnLeft: {
        id: "fabric.editor.moveColumnLeft",
        defaultMessage: "Move {0, plural, one {column} other {columns}} left"
    },
    moveColumnLeftHelpDialogLabel: {
        id: "fabric.editor.moveColumnLeftHelpDialogLabel",
        defaultMessage: "Move column left"
    },
    moveColumnRight: {
        id: "fabric.editor.moveColumnRight",
        defaultMessage: "Move {0, plural, one {column} other {columns}} right"
    },
    moveColumnRightHelpDialogLabel: {
        id: "fabric.editor.moveColumnRightHelpDialogLabel",
        defaultMessage: "Move column right"
    },
    moveRowUp: {
        id: "fabric.editor.moveRowUp",
        defaultMessage: "Move {0, plural, one {row} other {rows}} up"
    },
    moveRowUpHelpDialogLabel: {
        id: "fabric.editor.moveRowUpHelpDialogLabel",
        defaultMessage: "Move row up"
    },
    moveRowDown: {
        id: "fabric.editor.moveDownDown",
        defaultMessage: "Move {0, plural, one {row} other {rows}} down"
    },
    moveRowDownHelpDialogLabel: {
        id: "fabric.editor.moveRowDownHelpDialogLabel",
        defaultMessage: "Move row down"
    },
    insertRowDrag: {
        id: "fabric.editor.insertRowDrag",
        defaultMessage: "Insert row"
    },
    removeRows: {
        id: "fabric.editor.removeRows",
        defaultMessage: "Delete {0, plural, one {row} other {rows}}"
    },
    rowNumbers: {
        id: "fabrid.editor.rowNumbers",
        defaultMessage: "Row numbers"
    },
    numberedRows: {
        id: "fabrid.editor.numberedRows",
        defaultMessage: "Numbered rows"
    },
    rowsAreInserted: {
        id: "fabric.editor.rowsAreInserted",
        defaultMessage: "{count, plural, one {A row has been} other {{count} rows have been}} inserted"
    },
    rowsAreRemoved: {
        id: "fabric.editor.rowsAreRemoved",
        defaultMessage: "{count, plural, one {The row has been} other {{count} rows have been}} removed"
    },
    rowSelected: {
        id: "fabric.editor.rowSelected",
        defaultMessage: "Row {index} of {total} selected"
    },
    rowMovedUp: {
        id: "fabric.editor.rowMovedUp",
        defaultMessage: "Row moved up to {index} of {total}"
    },
    rowMovedDown: {
        id: "fabric.editor.rowMovedDown",
        defaultMessage: "Row moved down to {index} of {total}"
    },
    columnsAreInserted: {
        id: "fabric.editor.columnsAreInserted",
        defaultMessage: "{count, plural, one {A column has been} other {{count} columns have been}} inserted"
    },
    columnsAreRemoved: {
        id: "fabric.editor.columnsAreRemoved",
        defaultMessage: "{count, plural, one {The column has been} other {{count} columns have been}} removed"
    },
    columnSelected: {
        id: "fabric.editor.columnSelected",
        defaultMessage: "Column {index} of {total} selected"
    },
    columnMovedLeft: {
        id: "fabric.editor.columnMovedLeft",
        defaultMessage: "Column moved left to {index} of {total}"
    },
    columnMovedRight: {
        id: "fabric.editor.columnMovedRight",
        defaultMessage: "Column moved right to {index} of {total}"
    },
    cellOptions: {
        id: "fabric.editor.cellOptions",
        defaultMessage: "Cell options"
    },
    confirmDeleteLinkedModalOKButton: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalOKButton",
        defaultMessage: "Delete"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix",
        defaultMessage: "Deleting"
    },
    confirmModalCheckboxLabel: {
        id: "fabric.editor.floatingToolbar.confirmModalCheckboxLabel",
        defaultMessage: "Also delete connected elements"
    },
    deleteElementTitle: {
        id: "fabric.editor.extension.deleteElementTitle",
        defaultMessage: "Delete element"
    },
    unnamedSource: {
        id: "fabric.editor.extension.sourceNoTitledName",
        defaultMessage: "this element"
    },
    adjustColumns: {
        id: "fabric.editor.tables.adjustColumn",
        defaultMessage: "Adjust column"
    },
    cornerControl: {
        id: "fabric.editor.cornerControl",
        defaultMessage: "Highlight table"
    },
    cellBackground: {
        id: "fabric.editor.cellBackground",
        defaultMessage: "Cell background"
    },
    cellAlignment: {
        id: "fabric.editor.table.cellAlignment",
        defaultMessage: "Alignment"
    },
    cellAlignmentTop: {
        id: "fabric.editor.table.cellAlignmentTop",
        defaultMessage: "Top"
    },
    cellAlignmentMiddle: {
        id: "fabric.editor.table.cellAlignmentMiddle",
        defaultMessage: "Middle"
    },
    cellAlignmentBottom: {
        id: "fabric.editor.table.cellAlignmentBottom",
        defaultMessage: "Bottom"
    },
    backgroundColor: {
        id: "fabric.editor.backgroundColor",
        defaultMessage: "Background color"
    },
    mergeCells: {
        id: "fabric.editor.mergeCells",
        defaultMessage: "Merge cells"
    },
    splitCell: {
        id: "fabric.editor.splitCell",
        defaultMessage: "Split cell"
    },
    clearCells: {
        id: "fabric.editor.clearCells",
        defaultMessage: "Clear {0, plural, one {cell} other {cells}}"
    },
    sortColumnASC: {
        id: "fabric.editor.sortColumnASC",
        defaultMessage: "Sort column A \u2192 Z"
    },
    sortColumnDESC: {
        id: "fabric.editor.sortColumnDESC",
        defaultMessage: "Sort column Z \u2192 A"
    },
    sortColumnIncreasing: {
        id: "fabric.editor.sortColumnIncreasing",
        defaultMessage: "Sort increasing"
    },
    sortColumnDecreasing: {
        id: "fabric.editor.sortColumnDecreasing",
        defaultMessage: "Sort decreasing"
    },
    canNotSortTable: {
        id: "fabric.editor.canNotSortTable",
        defaultMessage: "\u26A0\uFE0F You can't sort a table with merged cells"
    },
    canNotSortTableNoIcon: {
        id: "fabric.editor.canNotSortTableNoIcon",
        defaultMessage: "You can't sort a table with merged cells"
    },
    distributeColumns: {
        id: "fabric.editor.distributeColumns",
        defaultMessage: "Distribute columns"
    },
    fitToContent: {
        id: "fabric.editor.fitToContent",
        defaultMessage: "Fit to content"
    },
    lockColumnWidths: {
        id: "fabric.editor.lockColumns",
        defaultMessage: "Fixed column widths"
    },
    rowControl: {
        id: "fabric.editor.rowControl",
        defaultMessage: "Highlight row"
    },
    rowDragHandle: {
        id: "fabric.editor.rowDragHandle",
        defaultMessage: "Row options"
    },
    dragHandleZone: {
        id: "fabric.editor.dragHandleZone",
        defaultMessage: "Activate drag handle zone"
    },
    columnDragHandle: {
        id: "fabric.editor.columnDragHandle",
        defaultMessage: "Column options"
    },
    fullWidthLabel: {
        id: "fabric.editor.tableFullWidthLabel",
        defaultMessage: "Full-width"
    },
    startedColumnResize: {
        id: "fabric.editor.tables.startedColumnResize",
        defaultMessage: "Started column resize"
    },
    focusedOtherResize: {
        id: "fabric.editor.tables.otherResize",
        defaultMessage: "{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}"
    },
    changedColumnWidth: {
        id: "fabric.editor.tables.columnWidth",
        defaultMessage: "{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}"
    },
    columnResizeStop: {
        id: "fabric.editor.tables.resizeStop",
        defaultMessage: "Stopped resize"
    },
    columnResizeOverflow: {
        id: "fabric.editor.tables.columnResizeOverflow",
        defaultMessage: "You can only resize this column while the table has a scroll bar."
    },
    columnResizeLast: {
        id: "fabric.editor.tables.columnResizeLast",
        defaultMessage: "You can only resize this column to the left."
    },
    tableAlignmentOptions: {
        id: "fabric.editor.tableAlignmentOptions",
        defaultMessage: "Alignment options"
    },
    alignTableCenter: {
        id: "fabric.editor.alignTableCenter",
        defaultMessage: "Align center"
    },
    alignTableLeft: {
        id: "fabric.editor.alignTableLeft",
        defaultMessage: "Align left"
    }
});
module.exports["messages"] = $3d7dc9b28782bfb3$export$defe85febe8b728c;

});

parcelRegister("cN8vw", function(module, exports) {
/** Helper type for single arg function */ function $521e53eeebc4ccf3$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
module.exports["compose"] = $521e53eeebc4ccf3$export$f672e0b6f7222cd7;

});

parcelRegister("hyVjW", function(module, exports) {
function $78fb8962441d66a3$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
module.exports["convertProsemirrorTableNodeToArrayOfRows"] = $78fb8962441d66a3$export$69fbfaf01f2fd534;

});

parcelRegister("d4WtM", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $2QYOD = parcelRequire("2QYOD");


var $34hOD = parcelRequire("34hOD");

function $eff95bd9cb48403a$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $eff95bd9cb48403a$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $eff95bd9cb48403a$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(RegExp("\\p{Number}", "gu"), '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(RegExp("\\p{Number}", "gu"), '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $eff95bd9cb48403a$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $eff95bd9cb48403a$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $eff95bd9cb48403a$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: (0, $34hOD.ContentType).LINK,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: (0, $34hOD.ContentType).NUMBER,
        value: normalizedText
    };
    return {
        type: (0, $34hOD.ContentType).TEXT,
        value: normalizedText ?? text
    };
}
function $eff95bd9cb48403a$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
        Get Meta value from the first child if the cell is of type
          * Heading (Any cell where the text is set to a heading type)
          * Paragraph (Normal text)
       */ case 'heading':
        case 'paragraph':
            return $eff95bd9cb48403a$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: (0, $34hOD.ContentType).LINK,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: (0, $34hOD.ContentType).LINK,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $eff95bd9cb48403a$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: (0, $34hOD.ContentType).STATUS,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: (0, $34hOD.ContentType).DATE,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: (0, $34hOD.ContentType).MENTION,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $eff95bd9cb48403a$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $eff95bd9cb48403a$export$49215374a8bec29c = (options, order = (0, $2QYOD.SortOrder).ASC)=>{
    const normalizeTextParser = $eff95bd9cb48403a$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $eff95bd9cb48403a$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $eff95bd9cb48403a$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
        Donot switch the order (Asec or Desc) if either node is null.
        This will ensure that empty cells are always at the bottom during sorting.
      */ if (metaNodeA === null || metaNodeB === null) return $eff95bd9cb48403a$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $2QYOD.SortOrder).DESC ? -1 : 1) * $eff95bd9cb48403a$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $eff95bd9cb48403a$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if ((0, $dh538.fg)('platform_editor_fix_mixed_types_column_sort')) {
        if (metaNodeA.type === (0, $34hOD.ContentType).TEXT && metaNodeB.type === (0, $34hOD.ContentType).NUMBER || metaNodeA.type === (0, $34hOD.ContentType).NUMBER && metaNodeB.type === (0, $34hOD.ContentType).TEXT) return $eff95bd9cb48403a$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    }
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $eff95bd9cb48403a$var$compareValue(metaNodeA.value, metaNodeB.value);
}
module.exports["createCompareNodes"] = $eff95bd9cb48403a$export$49215374a8bec29c;

});

parcelRegister("2QYOD", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $21K7m = parcelRequire("21K7m");


var $frHf7 = parcelRequire("frHf7");


var $c5H67 = parcelRequire("c5H67");


var $9l1gh = parcelRequire("9l1gh");


var $28r5l = parcelRequire("28r5l");


var $9xMgv = parcelRequire("9xMgv");


var $ah4M9 = parcelRequire("ah4M9");

var $0829eaae2cd5a49f$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});
module.exports["SortOrder"] = $0829eaae2cd5a49f$export$7ae723045d45777a;

});

parcelRegister("frHf7", function(module, exports) {
var $d45587463a8dfb3c$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
module.exports["ToolbarSize"] = $d45587463a8dfb3c$export$ed55211407a9423;

});

parcelRegister("c5H67", function(module, exports) {
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of ToolbarWidthsNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ var $de07d4832fa6671f$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
module.exports["ToolbarWidths"] = $de07d4832fa6671f$export$423b5e8c92d477b9;

});

parcelRegister("9l1gh", function(module, exports) {
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of ToolbarWidthsFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ var $31b874c265ac341f$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
module.exports["ToolbarWidthsFullPage"] = $31b874c265ac341f$export$63ca43752be70b90;

});

parcelRegister("28r5l", function(module, exports) {
var $dd1215f12efccf1a$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});
module.exports["ToolbarWidthsFullPageNext"] = $dd1215f12efccf1a$export$501a79d885598191;

});

parcelRegister("9xMgv", function(module, exports) {
var $cd22c8ea446c06f3$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
module.exports["ToolbarWidthsNext"] = $cd22c8ea446c06f3$export$3f050002d3df641b;

});

parcelRegister("ah4M9", function(module, exports) {
var $0340026301a73b77$export$9106728c49045482 = /*#__PURE__*/ function(DIRECTION) {
    DIRECTION["UP"] = "up";
    DIRECTION["DOWN"] = "down";
    DIRECTION["LEFT"] = "left";
    DIRECTION["RIGHT"] = "right";
    return DIRECTION;
}({});
module.exports["DIRECTION"] = $0340026301a73b77$export$9106728c49045482;

});

parcelRegister("8l0kQ", function(module, exports) {
function $15b9f343b8c9157d$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
module.exports["hasMergedCell"] = $15b9f343b8c9157d$export$f9d610bfbb78949b;

});

parcelRegister("6fQl1", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $5Ev1b = parcelRequire("5Ev1b");


var $boKri = parcelRequire("boKri");


var $1zav4 = parcelRequire("1zav4");


var $fJNzZ = parcelRequire("fJNzZ");

const $2eab9b0df279d802$var$GRID_SIZE = 8;
const $2eab9b0df279d802$var$NESTED_DND_GUTTER_OFFSET = 8;
const $2eab9b0df279d802$var$NESTED_DND_MARGIN_OFFSET = 12;
const $2eab9b0df279d802$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $aFUXX.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $aFUXX.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $aFUXX.akEditorFullWidthLayoutWidth)
};
const $2eab9b0df279d802$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $2eab9b0df279d802$export$84f6ca4f6812e69a(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    const breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    let parentWidth = $2eab9b0df279d802$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $aFUXX.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                // margin between sections
                parentWidth -= (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $boKri.LAYOUT_SECTION_MARGIN) + $2eab9b0df279d802$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1) : ((0, $boKri.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $boKri.LAYOUT_COLUMN_PADDING) + $2eab9b0df279d802$var$NESTED_DND_GUTTER_OFFSET) * 2 : (0, $boKri.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $5Ev1b.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $5Ev1b.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $2eab9b0df279d802$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $2eab9b0df279d802$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $2eab9b0df279d802$var$GRID_SIZE;
            // padding left
            parentWidth -= $2eab9b0df279d802$var$GRID_SIZE * 4 - $2eab9b0df279d802$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $1zav4.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $2eab9b0df279d802$export$84f6ca4f6812e69a = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader,
        state.schema.nodes.bodiedSyncBlock
    ]);
    return parent ? parent.node : null;
};
const $2eab9b0df279d802$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled, breakoutWidth)=>{
    if (breakoutWidth) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // container width minus breakout padding
    // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $aFUXX.akEditorGutterPaddingDynamic)() * 2 + (0, $aFUXX.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $aFUXX.akEditorFullWidthLayoutWidth)) : (0, $fJNzZ.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $2eab9b0df279d802$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $2eab9b0df279d802$export$9b77d38feba5446[node?.attrs.layout] || (0, $aFUXX.akEditorDefaultLayoutWidth);
};
const $2eab9b0df279d802$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $2eab9b0df279d802$export$3930799be057b305(node) - offset;
    return $2eab9b0df279d802$export$3930799be057b305(node);
};
module.exports["layoutToWidth"] = $2eab9b0df279d802$export$9b77d38feba5446;
module.exports["getParentNodeWidth"] = $2eab9b0df279d802$export$d76cc081ce1449a8;
module.exports["getNestedParentNode"] = $2eab9b0df279d802$export$84f6ca4f6812e69a;
module.exports["getTableContainerWidth"] = $2eab9b0df279d802$export$3930799be057b305;

});

parcelRegister("5Ev1b", function(module, exports) {
const $12a95dac6e3e610f$export$f5ecdce4c60ff98b = 8;
const $12a95dac6e3e610f$export$5ac5087fe1217160 = $12a95dac6e3e610f$export$f5ecdce4c60ff98b * 2;
const $12a95dac6e3e610f$export$91624ec52c59c24c = 12;
module.exports["BODIED_EXT_PADDING"] = $12a95dac6e3e610f$export$5ac5087fe1217160;
module.exports["BODIED_EXT_MBE_MARGIN_TOP"] = $12a95dac6e3e610f$export$91624ec52c59c24c;

});

parcelRegister("boKri", function(module, exports) {
const $59f993087aaa984c$export$cd04f19842abff0 = 8;
const $59f993087aaa984c$export$a1bb91aa2d5fcce8 = $59f993087aaa984c$export$cd04f19842abff0 * 1.5;
const $59f993087aaa984c$export$e5ee675b2c7e739b = 50;
module.exports["LAYOUT_SECTION_MARGIN"] = $59f993087aaa984c$export$cd04f19842abff0;
module.exports["LAYOUT_COLUMN_PADDING"] = $59f993087aaa984c$export$a1bb91aa2d5fcce8;

});

parcelRegister("1zvWv", function(module, exports) {
const $fd0f66b4af830316$export$12fd658e5eef0d79 = 32;
const $fd0f66b4af830316$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
module.exports["FullPagePadding"] = $fd0f66b4af830316$export$12fd658e5eef0d79;
module.exports["TELEPOINTER_ID"] = $fd0f66b4af830316$export$74b525449cc7cbd1;

});

parcelRegister("7f6CO", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $1oCLl = parcelRequire("1oCLl");


var $3gadb = parcelRequire("3gadb");


var $2QYOD = parcelRequire("2QYOD");


var $1j8OE = parcelRequire("1j8OE");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4c0se = parcelRequire("4c0se");

var $dmsGX = parcelRequire("dmsGX");




const $b79b20e2975af7de$var$newIconWrapperStyles = {
    base: "_v5642l60 _1bsb7vkz _4t3i7vkz _1e0c1txw _1bah1h6o _4cvr1h6o _8hrz1qre",
    inactive: "_tzy415iw"
};
const $b79b20e2975af7de$export$4be21af7f864512e = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { sortOrdered: sortOrdered } = t0;
    const t1 = sortOrdered === (0, $2QYOD.SortOrder).NO_ORDER && $b79b20e2975af7de$var$newIconWrapperStyles.inactive;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $gMc0m.default)([
            $b79b20e2975af7de$var$newIconWrapperStyles.base,
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== sortOrdered) {
        t3 = sortOrdered === (0, $2QYOD.SortOrder).DESC ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4c0se))), {
            spacing: "none",
            label: ""
        }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmsGX))), {
            spacing: "none",
            label: ""
        });
        $[2] = sortOrdered;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t2
        }, t3);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ sortOrdered: sortOrdered })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $b79b20e2975af7de$var$newIconWrapperStyles.base,
            sortOrdered === (0, $2QYOD.SortOrder).NO_ORDER && $b79b20e2975af7de$var$newIconWrapperStyles.inactive
        ])
    }, sortOrdered === (0, $2QYOD.SortOrder).DESC ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4c0se))), {
        spacing: "none",
        label: ""
    }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmsGX))), {
        spacing: "none",
        label: ""
    }));
};





const $a7ee84fe2c4d07bd$export$f142573f51a67577 = (0, $aXWIB.defineMessages)({
    noOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.no",
        defaultMessage: "No sort applied to the column"
    },
    ascOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.asc",
        defaultMessage: "Ascending sort applied"
    },
    descOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.desc",
        defaultMessage: "Descending sort applied"
    },
    invalidLabel: {
        id: "fabric.editor.tableHeader.sorting.invalid",
        defaultMessage: "You can't sort a table with merged cells"
    },
    defaultLabel: {
        id: "fabric.editor.tableHeader.sorting.default",
        defaultMessage: "Sort the column"
    }
});





const $9bf6d501d80cd1f4$export$458c50917513cd1a = (0, $aXWIB.defineMessages)({
    noOrderLabel: {
        id: "fabric.editor.headingLink.noOrderLabel",
        defaultMessage: "Sort column A to Z"
    },
    ascOrderLabel: {
        id: "fabric.editor.headingLink.ascOrderLabel",
        defaultMessage: "Sort column Z to A"
    },
    descOrderLabel: {
        id: "fabric.editor.headingLink.descOrderLabel",
        defaultMessage: "Clear sorting"
    },
    invalidLabel: {
        id: "fabric.editor.headingLink.invalidLabel",
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: "\u26A0\uFE0F  You can't sort a table with merged cells"
    }
});



var $iqWD2 = parcelRequire("iqWD2");

function $cd5bbe471a3a63ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $cd5bbe471a3a63ba$var$buttonStyles = /*#__PURE__*/ (0, $9K4OG.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:var(--ds-border-width-selected, 2px) solid var(--ds-border, #0B120E24);border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F0F1F2);}&:active{background-color:var(--ds-surface-overlay-pressed, #DDDEE1);}&.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "__not-allowed{cursor:not-allowed;}");
// Keep the sort button above header content nodes that the editor's native-anchor DnD
// styles give a z-index in live docs, which otherwise cover the button's clickable body.
const $cd5bbe471a3a63ba$var$sortButtonElevatedStyles = {
    name: "1739oy8",
    styles: "z-index:1"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $cd5bbe471a3a63ba$var$iconWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", (0, $iqWD2.StatusClassNames).DESC, "{transform:rotate(-180deg);}&.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $cd5bbe471a3a63ba$var$iconStyles = {
    name: "3kmdk1",
    styles: "height:100%;width:2px;border-radius:var(--ds-radius-full, 9999px);background:var(--ds-icon, #292A2E);user-select:none;&::before, &::after{background:var(--ds-icon, #292A2E);content:'';height:2px;width:6px;position:absolute;border-radius:var(--ds-radius-full, 9999px);}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $cd5bbe471a3a63ba$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $2QYOD.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${(0, $iqWD2.StatusClassNames).SORTING_NOT_ALLOWED} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $2QYOD.SortOrder).ASC:
            return `${(0, $iqWD2.StatusClassNames).ASC} ${activeStatusClass}`;
        case (0, $2QYOD.SortOrder).DESC:
            return `${(0, $iqWD2.StatusClassNames).DESC} ${activeStatusClass}`;
        default:
            return `${(0, $iqWD2.StatusClassNames).NO_ORDER} ${activeStatusClass}`;
    }
};
const $cd5bbe471a3a63ba$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $9bf6d501d80cd1f4$export$458c50917513cd1a);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $2QYOD.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $2QYOD.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $cd5bbe471a3a63ba$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $a7ee84fe2c4d07bd$export$f142573f51a67577);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $2QYOD.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $2QYOD.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $cd5bbe471a3a63ba$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME)} ${sortOrdered !== (0, $2QYOD.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}__not-allowed `}`;
    const content = $cd5bbe471a3a63ba$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $cd5bbe471a3a63ba$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $cd5bbe471a3a63ba$var$buttonStyles,
            (0, $1oCLl.expValEquals)('confluence_live_doc_table_sort_bugfix', 'isEnabled', true) && $cd5bbe471a3a63ba$var$sortButtonElevatedStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, (0, $1oCLl.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $b79b20e2975af7de$export$4be21af7f864512e), {
        sortOrdered: sortOrdered
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $cd5bbe471a3a63ba$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $cd5bbe471a3a63ba$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $cd5bbe471a3a63ba$var$iconStyles
        ]
    }))));
};
const $cd5bbe471a3a63ba$var$_default_1 = (0, $aXWIB.injectIntl)($cd5bbe471a3a63ba$var$SortingIcon);
var $cd5bbe471a3a63ba$export$2e2bcd8739ae039 = $cd5bbe471a3a63ba$var$_default_1;
module.exports["default"] = $cd5bbe471a3a63ba$export$2e2bcd8739ae039;

});

parcelRegister("1j8OE", function(module, exports) {
const $9f6a2cabc4658788$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;
module.exports["SORTABLE_COLUMN_ICON_CLASSNAME"] = $9f6a2cabc4658788$export$bd4f24d8b1e86b23;

});

parcelRegister("bZfVt", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9a2cd2417c72e065$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(new Map());
const $9a2cd2417c72e065$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9a2cd2417c72e065$export$841858b892ce1f4c.Provider, {
        value: new Map()
    }, children);
};
const $9a2cd2417c72e065$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9a2cd2417c72e065$export$841858b892ce1f4c.Consumer, null, (storage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                    ...this.props,
                    smartCardStorage: storage
                }));
        }
    };
};
module.exports["Provider"] = $9a2cd2417c72e065$export$2881499e37b75b9a;
module.exports["withSmartCardStorage"] = $9a2cd2417c72e065$export$65e2d5a272a382b0;

});

parcelRegister("bBvs5", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $42omo = parcelRequire("42omo");

const $e8c8dd4eecc10576$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
const $e8c8dd4eecc10576$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($e8c8dd4eecc10576$var$RendererContext);
const $e8c8dd4eecc10576$export$ca5df47902194781 = $e8c8dd4eecc10576$var$RendererContext.Provider;
module.exports["useRendererContext"] = $e8c8dd4eecc10576$export$a906432540ed7ed8;
module.exports["RendererContextProvider"] = $e8c8dd4eecc10576$export$ca5df47902194781;

});

parcelRegister("ixUmr", function(module, exports) {

var $dZ8uq = parcelRequire("dZ8uq");


var $bGTfP = parcelRequire("bGTfP");

const $057b5225a27d09cb$export$8c07f44cea64e3c7 = (tableNode)=>tableNode.attrs.width !== null || (0, $bGTfP.hasTableColumnBeenResized)(tableNode);
const $057b5225a27d09cb$export$90b9840b2d94b80a = ({ tableNode: tableNode, isSupported: isSupported, isTableNested: isTableNested })=>{
    if (!(0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true)) return false;
    if (!tableNode || isTableNested) return false;
    return isSupported && !$057b5225a27d09cb$export$8c07f44cea64e3c7(tableNode) && tableNode.attrs.layout === 'align-start';
};
module.exports["hasTableBeenResized"] = $057b5225a27d09cb$export$8c07f44cea64e3c7;
module.exports["isTableInContentMode"] = $057b5225a27d09cb$export$90b9840b2d94b80a;

});

parcelRegister("5Njvm", function(module, exports) {

let $4380a89a2461a71c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4380a89a2461a71c$var$load("b9CA3"),
    $4380a89a2461a71c$var$load("6wr18"),
    $4380a89a2461a71c$var$load("2BBGM"),
    $4380a89a2461a71c$var$load("ffEVr"),
    $4380a89a2461a71c$var$load("2Yc7I")
]).then(()=>parcelRequire('4elbo'));

});

parcelRegister("apc9n", function(module, exports) {

let $7935a9fccb27c246$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7935a9fccb27c246$var$load("b9CA3"),
    $7935a9fccb27c246$var$load("6wr18"),
    $7935a9fccb27c246$var$load("2BBGM"),
    $7935a9fccb27c246$var$load("ffEVr"),
    $7935a9fccb27c246$var$load("37ldp"),
    $7935a9fccb27c246$var$load("9vWDd")
]).then(()=>parcelRequire('sc949'));

});

parcelRegister("jblE9", function(module, exports) {

let $df6fd5f5484060f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df6fd5f5484060f1$var$load("hri9L").then(()=>parcelRequire('b89xc'));

});

parcelRegister("2ve85", function(module, exports) {

let $1d296fdb291d1444$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d296fdb291d1444$var$load("6wr18"),
    $1d296fdb291d1444$var$load("ffEVr"),
    $1d296fdb291d1444$var$load("hjv2W")
]).then(()=>parcelRequire('8aT3t'));

});

parcelRegister("8DVsQ", function(module, exports) {

let $64ae8a77c8da5e33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64ae8a77c8da5e33$var$load("h3GJZ").then(()=>parcelRequire('jouXW'));

});

parcelRegister("gbCDG", function(module, exports) {

let $bc8ba55b6259265c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc8ba55b6259265c$var$load("6wr18"),
    $bc8ba55b6259265c$var$load("ffEVr"),
    $bc8ba55b6259265c$var$load("hAerp")
]).then(()=>parcelRequire('kGWTg'));

});

parcelRegister("gNkHO", function(module, exports) {

let $c3a148ae4675fad2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c3a148ae4675fad2$var$load("59K3I"),
    $c3a148ae4675fad2$var$load("ibYtB"),
    $c3a148ae4675fad2$var$load("cBo2a")
]).then(()=>parcelRequire('7xxJX'));

});

parcelRegister("cwpfK", function(module, exports) {

let $91dc0fe6f1d710e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $91dc0fe6f1d710e2$var$load("esOWw"),
    $91dc0fe6f1d710e2$var$load("hhss7"),
    $91dc0fe6f1d710e2$var$load("Wowvf"),
    $91dc0fe6f1d710e2$var$load("8m00X")
]).then(()=>parcelRequire('5xRci'));

});

parcelRegister("16xNn", function(module, exports) {

let $0ce0910c8fc9c115$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0ce0910c8fc9c115$var$load("esOWw"),
    $0ce0910c8fc9c115$var$load("59K3I"),
    $0ce0910c8fc9c115$var$load("ibYtB"),
    $0ce0910c8fc9c115$var$load("74D9u"),
    $0ce0910c8fc9c115$var$load("f9WnJ")
]).then(()=>parcelRequire('gVFlX'));

});

parcelRegister("8tFtj", function(module, exports) {

let $62c1339c4c938ed3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $62c1339c4c938ed3$var$load("6wr18"),
    $62c1339c4c938ed3$var$load("ffEVr"),
    $62c1339c4c938ed3$var$load("dMkP5"),
    $62c1339c4c938ed3$var$load("gBO6y"),
    $62c1339c4c938ed3$var$load("esOWw"),
    $62c1339c4c938ed3$var$load("59K3I"),
    $62c1339c4c938ed3$var$load("ibYtB"),
    $62c1339c4c938ed3$var$load("74D9u"),
    $62c1339c4c938ed3$var$load("f9WnJ"),
    $62c1339c4c938ed3$var$load("l50fY")
]).then(()=>parcelRequire('3ARr2'));

});

parcelRegister("gwvIa", function(module, exports) {

let $c0783bbe2cfa5861$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c0783bbe2cfa5861$var$load("esOWw"),
    $c0783bbe2cfa5861$var$load("59K3I"),
    $c0783bbe2cfa5861$var$load("ibYtB"),
    $c0783bbe2cfa5861$var$load("dMkP5"),
    $c0783bbe2cfa5861$var$load("gBO6y"),
    $c0783bbe2cfa5861$var$load("3K1dc"),
    $c0783bbe2cfa5861$var$load("RXMWr"),
    $c0783bbe2cfa5861$var$load("aMRFX"),
    $c0783bbe2cfa5861$var$load("396ld"),
    $c0783bbe2cfa5861$var$load("1F7LX"),
    $c0783bbe2cfa5861$var$load("7tyJj"),
    $c0783bbe2cfa5861$var$load("gknbb"),
    $c0783bbe2cfa5861$var$load("c9xEe"),
    $c0783bbe2cfa5861$var$load("csAUX"),
    $c0783bbe2cfa5861$var$load("36QeB"),
    $c0783bbe2cfa5861$var$load("kQSfw"),
    $c0783bbe2cfa5861$var$load("8PzH3"),
    $c0783bbe2cfa5861$var$load("2jJ1i"),
    $c0783bbe2cfa5861$var$load("bd77Q"),
    $c0783bbe2cfa5861$var$load("hnGEQ"),
    $c0783bbe2cfa5861$var$load("dek7I"),
    $c0783bbe2cfa5861$var$load("6SWFK"),
    $c0783bbe2cfa5861$var$load("9aQIt"),
    $c0783bbe2cfa5861$var$load("5zapo"),
    $c0783bbe2cfa5861$var$load("3MYQs"),
    $c0783bbe2cfa5861$var$load("XZauT"),
    $c0783bbe2cfa5861$var$load("4S1SF"),
    $c0783bbe2cfa5861$var$load("jiFtb"),
    $c0783bbe2cfa5861$var$load("lm9Lt"),
    $c0783bbe2cfa5861$var$load("9atVd"),
    $c0783bbe2cfa5861$var$load("9wPDc"),
    $c0783bbe2cfa5861$var$load("1MWOL"),
    $c0783bbe2cfa5861$var$load("6fQco"),
    $c0783bbe2cfa5861$var$load("dYtBN"),
    $c0783bbe2cfa5861$var$load("kNV5Y"),
    $c0783bbe2cfa5861$var$load("aOY32"),
    $c0783bbe2cfa5861$var$load("7jSfd"),
    $c0783bbe2cfa5861$var$load("4HZlX"),
    $c0783bbe2cfa5861$var$load("6wr18"),
    $c0783bbe2cfa5861$var$load("kDqHr"),
    $c0783bbe2cfa5861$var$load("jPuvo"),
    $c0783bbe2cfa5861$var$load("3GuOt"),
    $c0783bbe2cfa5861$var$load("7EorR"),
    $c0783bbe2cfa5861$var$load("ffEVr"),
    $c0783bbe2cfa5861$var$load("hhss7"),
    $c0783bbe2cfa5861$var$load("axFxW"),
    $c0783bbe2cfa5861$var$load("2jp1v"),
    $c0783bbe2cfa5861$var$load("Wowvf"),
    $c0783bbe2cfa5861$var$load("2zeg1")
]).then(()=>parcelRequire('f7Vk9'));

});

parcelRegister("5PMVm", function(module, exports) {

let $43f7aa7b7eade502$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $43f7aa7b7eade502$var$load("dMkP5"),
    $43f7aa7b7eade502$var$load("gBO6y"),
    $43f7aa7b7eade502$var$load("3K1dc"),
    $43f7aa7b7eade502$var$load("RXMWr"),
    $43f7aa7b7eade502$var$load("aMRFX"),
    $43f7aa7b7eade502$var$load("396ld"),
    $43f7aa7b7eade502$var$load("1F7LX"),
    $43f7aa7b7eade502$var$load("7tyJj"),
    $43f7aa7b7eade502$var$load("gknbb"),
    $43f7aa7b7eade502$var$load("c9xEe"),
    $43f7aa7b7eade502$var$load("csAUX"),
    $43f7aa7b7eade502$var$load("36QeB"),
    $43f7aa7b7eade502$var$load("kQSfw"),
    $43f7aa7b7eade502$var$load("8PzH3"),
    $43f7aa7b7eade502$var$load("2jJ1i"),
    $43f7aa7b7eade502$var$load("bd77Q"),
    $43f7aa7b7eade502$var$load("hnGEQ"),
    $43f7aa7b7eade502$var$load("dek7I"),
    $43f7aa7b7eade502$var$load("6SWFK"),
    $43f7aa7b7eade502$var$load("9aQIt"),
    $43f7aa7b7eade502$var$load("5zapo"),
    $43f7aa7b7eade502$var$load("3MYQs"),
    $43f7aa7b7eade502$var$load("XZauT"),
    $43f7aa7b7eade502$var$load("4S1SF"),
    $43f7aa7b7eade502$var$load("jiFtb"),
    $43f7aa7b7eade502$var$load("lm9Lt"),
    $43f7aa7b7eade502$var$load("9atVd"),
    $43f7aa7b7eade502$var$load("9wPDc"),
    $43f7aa7b7eade502$var$load("1MWOL"),
    $43f7aa7b7eade502$var$load("6fQco"),
    $43f7aa7b7eade502$var$load("dYtBN"),
    $43f7aa7b7eade502$var$load("kNV5Y"),
    $43f7aa7b7eade502$var$load("aOY32"),
    $43f7aa7b7eade502$var$load("7jSfd"),
    $43f7aa7b7eade502$var$load("4HZlX"),
    $43f7aa7b7eade502$var$load("6wr18"),
    $43f7aa7b7eade502$var$load("kDqHr"),
    $43f7aa7b7eade502$var$load("jPuvo"),
    $43f7aa7b7eade502$var$load("3GuOt"),
    $43f7aa7b7eade502$var$load("7EorR"),
    $43f7aa7b7eade502$var$load("ffEVr"),
    $43f7aa7b7eade502$var$load("hhss7"),
    $43f7aa7b7eade502$var$load("Wowvf"),
    $43f7aa7b7eade502$var$load("axFxW")
]).then(()=>parcelRequire('5Iqpa'));

});

parcelRegister("aegRE", function(module, exports) {

let $77284b18d9759418$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $77284b18d9759418$var$load("dMkP5"),
    $77284b18d9759418$var$load("gBO6y"),
    $77284b18d9759418$var$load("3K1dc"),
    $77284b18d9759418$var$load("RXMWr"),
    $77284b18d9759418$var$load("aMRFX"),
    $77284b18d9759418$var$load("396ld"),
    $77284b18d9759418$var$load("1F7LX"),
    $77284b18d9759418$var$load("7tyJj"),
    $77284b18d9759418$var$load("gknbb"),
    $77284b18d9759418$var$load("c9xEe"),
    $77284b18d9759418$var$load("csAUX"),
    $77284b18d9759418$var$load("36QeB"),
    $77284b18d9759418$var$load("kQSfw"),
    $77284b18d9759418$var$load("8PzH3"),
    $77284b18d9759418$var$load("2jJ1i"),
    $77284b18d9759418$var$load("bd77Q"),
    $77284b18d9759418$var$load("hnGEQ"),
    $77284b18d9759418$var$load("dek7I"),
    $77284b18d9759418$var$load("6SWFK"),
    $77284b18d9759418$var$load("9aQIt"),
    $77284b18d9759418$var$load("5zapo"),
    $77284b18d9759418$var$load("3MYQs"),
    $77284b18d9759418$var$load("XZauT"),
    $77284b18d9759418$var$load("4S1SF"),
    $77284b18d9759418$var$load("jiFtb"),
    $77284b18d9759418$var$load("lm9Lt"),
    $77284b18d9759418$var$load("9atVd"),
    $77284b18d9759418$var$load("9wPDc"),
    $77284b18d9759418$var$load("1MWOL"),
    $77284b18d9759418$var$load("6fQco"),
    $77284b18d9759418$var$load("dYtBN"),
    $77284b18d9759418$var$load("kNV5Y"),
    $77284b18d9759418$var$load("aOY32"),
    $77284b18d9759418$var$load("7jSfd"),
    $77284b18d9759418$var$load("4HZlX"),
    $77284b18d9759418$var$load("6wr18"),
    $77284b18d9759418$var$load("kDqHr"),
    $77284b18d9759418$var$load("jPuvo"),
    $77284b18d9759418$var$load("3GuOt"),
    $77284b18d9759418$var$load("7EorR"),
    $77284b18d9759418$var$load("ffEVr"),
    $77284b18d9759418$var$load("hhss7"),
    $77284b18d9759418$var$load("axFxW"),
    $77284b18d9759418$var$load("Wowvf"),
    $77284b18d9759418$var$load("2jp1v")
]).then(()=>parcelRequire('eQ05w'));

});

parcelRegister("kCV4q", function(module, exports) {

let $f043a041cb96162e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f043a041cb96162e$var$load("dMkP5"),
    $f043a041cb96162e$var$load("gBO6y"),
    $f043a041cb96162e$var$load("2AcoK"),
    $f043a041cb96162e$var$load("aVl1C"),
    $f043a041cb96162e$var$load("kUncb"),
    $f043a041cb96162e$var$load("esOWw"),
    $f043a041cb96162e$var$load("59K3I"),
    $f043a041cb96162e$var$load("ibYtB"),
    $f043a041cb96162e$var$load("hXbzh"),
    $f043a041cb96162e$var$load("f35QR"),
    $f043a041cb96162e$var$load("eVYW1"),
    $f043a041cb96162e$var$load("ls0Um"),
    $f043a041cb96162e$var$load("020xd"),
    $f043a041cb96162e$var$load("eTBsW"),
    $f043a041cb96162e$var$load("bYxCZ"),
    $f043a041cb96162e$var$load("6HBYC"),
    $f043a041cb96162e$var$load("eDqo1"),
    $f043a041cb96162e$var$load("lxiFd"),
    $f043a041cb96162e$var$load("1oiJ6"),
    $f043a041cb96162e$var$load("huUvS"),
    $f043a041cb96162e$var$load("6wr18"),
    $f043a041cb96162e$var$load("fsikk"),
    $f043a041cb96162e$var$load("8j9XC"),
    $f043a041cb96162e$var$load("fisfU"),
    $f043a041cb96162e$var$load("6vhrJ"),
    $f043a041cb96162e$var$load("fxC6e"),
    $f043a041cb96162e$var$load("kknf5"),
    $f043a041cb96162e$var$load("hPalR"),
    $f043a041cb96162e$var$load("jDjSj"),
    $f043a041cb96162e$var$load("8059b"),
    $f043a041cb96162e$var$load("3QZdB"),
    $f043a041cb96162e$var$load("3M4Om"),
    $f043a041cb96162e$var$load("4jPsO"),
    $f043a041cb96162e$var$load("72780"),
    $f043a041cb96162e$var$load("hszIA"),
    $f043a041cb96162e$var$load("fwuXj"),
    $f043a041cb96162e$var$load("ajMch"),
    $f043a041cb96162e$var$load("2fk6g"),
    $f043a041cb96162e$var$load("ffEVr"),
    $f043a041cb96162e$var$load("jPuvo"),
    $f043a041cb96162e$var$load("hhss7"),
    $f043a041cb96162e$var$load("7EorR"),
    $f043a041cb96162e$var$load("5jCVU")
]).then(()=>parcelRequire('4ebXC'));

});

parcelRegister("dlKx2", function(module, exports) {

let $9b8154ccb0d42576$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b8154ccb0d42576$var$load("esOWw"),
    $9b8154ccb0d42576$var$load("6wr18"),
    $9b8154ccb0d42576$var$load("ffEVr"),
    $9b8154ccb0d42576$var$load("4Kqu1")
]).then(()=>parcelRequire('i6jK3'));

});

parcelRegister("X850C", function(module, exports) {

let $0b1bc747ef3935c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0b1bc747ef3935c5$var$load("dMkP5"),
    $0b1bc747ef3935c5$var$load("gBO6y"),
    $0b1bc747ef3935c5$var$load("2AcoK"),
    $0b1bc747ef3935c5$var$load("9oODd"),
    $0b1bc747ef3935c5$var$load("aVl1C"),
    $0b1bc747ef3935c5$var$load("esOWw"),
    $0b1bc747ef3935c5$var$load("59K3I"),
    $0b1bc747ef3935c5$var$load("ibYtB"),
    $0b1bc747ef3935c5$var$load("hXbzh"),
    $0b1bc747ef3935c5$var$load("f35QR"),
    $0b1bc747ef3935c5$var$load("eVYW1"),
    $0b1bc747ef3935c5$var$load("ls0Um"),
    $0b1bc747ef3935c5$var$load("020xd"),
    $0b1bc747ef3935c5$var$load("eTBsW"),
    $0b1bc747ef3935c5$var$load("bYxCZ"),
    $0b1bc747ef3935c5$var$load("6HBYC"),
    $0b1bc747ef3935c5$var$load("eDqo1"),
    $0b1bc747ef3935c5$var$load("lxiFd"),
    $0b1bc747ef3935c5$var$load("1oiJ6"),
    $0b1bc747ef3935c5$var$load("huUvS"),
    $0b1bc747ef3935c5$var$load("6wr18"),
    $0b1bc747ef3935c5$var$load("fsikk"),
    $0b1bc747ef3935c5$var$load("8j9XC"),
    $0b1bc747ef3935c5$var$load("fwuXj"),
    $0b1bc747ef3935c5$var$load("kUncb"),
    $0b1bc747ef3935c5$var$load("fisfU"),
    $0b1bc747ef3935c5$var$load("6vhrJ"),
    $0b1bc747ef3935c5$var$load("fxC6e"),
    $0b1bc747ef3935c5$var$load("kknf5"),
    $0b1bc747ef3935c5$var$load("hPalR"),
    $0b1bc747ef3935c5$var$load("jDjSj"),
    $0b1bc747ef3935c5$var$load("8059b"),
    $0b1bc747ef3935c5$var$load("3QZdB"),
    $0b1bc747ef3935c5$var$load("3M4Om"),
    $0b1bc747ef3935c5$var$load("4jPsO"),
    $0b1bc747ef3935c5$var$load("72780"),
    $0b1bc747ef3935c5$var$load("hszIA"),
    $0b1bc747ef3935c5$var$load("ajMch"),
    $0b1bc747ef3935c5$var$load("2fk6g"),
    $0b1bc747ef3935c5$var$load("ffEVr"),
    $0b1bc747ef3935c5$var$load("jPuvo"),
    $0b1bc747ef3935c5$var$load("7EorR"),
    $0b1bc747ef3935c5$var$load("9YdHi")
]).then(()=>parcelRequire('9d6BC'));

});

parcelRegister("2kBsZ", function(module, exports) {

let $1b2a832041324bae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b2a832041324bae$var$load("esOWw"),
    $1b2a832041324bae$var$load("59K3I"),
    $1b2a832041324bae$var$load("ibYtB"),
    $1b2a832041324bae$var$load("75rSO")
]).then(()=>parcelRequire('1HlBH'));

});

parcelRegister("P4EZp", function(module, exports) {

let $099860f02b096a6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $099860f02b096a6a$var$load("7gkvG"),
    $099860f02b096a6a$var$load("b9CA3"),
    $099860f02b096a6a$var$load("aMRFX"),
    $099860f02b096a6a$var$load("396ld"),
    $099860f02b096a6a$var$load("74D9u"),
    $099860f02b096a6a$var$load("hhss7"),
    $099860f02b096a6a$var$load("6wr18"),
    $099860f02b096a6a$var$load("ffEVr"),
    $099860f02b096a6a$var$load("h9S8v"),
    $099860f02b096a6a$var$load("diCLj")
]).then(()=>parcelRequire('7peIa'));

});

parcelRegister("eilMb", function(module, exports) {

let $a683a36d5b3af7d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a683a36d5b3af7d2$var$load("esOWw"),
    $a683a36d5b3af7d2$var$load("6wr18"),
    $a683a36d5b3af7d2$var$load("ffEVr"),
    $a683a36d5b3af7d2$var$load("5xpVW")
]).then(()=>parcelRequire('babkf'));

});

parcelRegister("64LyH", function(module, exports) {

let $46c801f63bb419d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46c801f63bb419d2$var$load("8gytj").then(()=>parcelRequire('3UlV5'));

});

parcelRegister("dvtp1", function(module, exports) {

let $9d54fa5d7c6dc3c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9d54fa5d7c6dc3c0$var$load("2ksh5").then(()=>parcelRequire('3BDe4'));

});

parcelRegister("caYZ2", function(module, exports) {



function $56d4043887516d4a$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $56d4043887516d4a$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}
module.exports["getColumnWidths"] = $56d4043887516d4a$export$e54c9225ca52acc;
module.exports["calcTableColumnWidths"] = $56d4043887516d4a$export$98951d3cdcfd364b;

});

parcelRegister("bSXAs", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");
// eslint-disable-next-line import/no-namespace
var $8dd462732d984c7b$exports = {};
$parcel$export($8dd462732d984c7b$exports, "expandWithNestedExpand", () => (parcelRequire("4r9Pq")).expandWithNestedExpand);
$parcel$export($8dd462732d984c7b$exports, "expandWithNestedExpandLocalId", () => (parcelRequire("4r9Pq")).expandWithNestedExpandLocalId);
$parcel$export($8dd462732d984c7b$exports, "expandToJSON", () => (parcelRequire("4r9Pq")).toJSON);
$parcel$export($8dd462732d984c7b$exports, "confluenceJiraIssue", () => (parcelRequire("fsHCc")).confluenceJiraIssue);
$parcel$export($8dd462732d984c7b$exports, "confluenceUnsupportedBlock", () => (parcelRequire("aZa28")).confluenceUnsupportedBlock);
$parcel$export($8dd462732d984c7b$exports, "confluenceUnsupportedInline", () => (parcelRequire("fnSCn")).confluenceUnsupportedInline);
$parcel$export($8dd462732d984c7b$exports, "doc", () => (parcelRequire("jRrsu")).doc);
$parcel$export($8dd462732d984c7b$exports, "blockquote", () => (parcelRequire("iIGXo")).blockquote);
$parcel$export($8dd462732d984c7b$exports, "extendedBlockquote", () => (parcelRequire("iIGXo")).extendedBlockquote);
$parcel$export($8dd462732d984c7b$exports, "extendedBlockquoteWithLocalId", () => (parcelRequire("iIGXo")).extendedBlockquoteWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "bulletList", () => (parcelRequire("ghpxT")).bulletList);
$parcel$export($8dd462732d984c7b$exports, "bulletListSelector", () => (parcelRequire("ghpxT")).bulletListSelector);
$parcel$export($8dd462732d984c7b$exports, "bulletListWithLocalId", () => (parcelRequire("ghpxT")).bulletListWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "codeBlock", () => (parcelRequire("4HD7y")).codeBlock);
$parcel$export($8dd462732d984c7b$exports, "codeBlockWithLocalId", () => (parcelRequire("4HD7y")).codeBlockWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "codeBlockToJSON", () => (parcelRequire("4HD7y")).toJSON);
$parcel$export($8dd462732d984c7b$exports, "hardBreak", () => (parcelRequire("aFNbc")).hardBreak);
$parcel$export($8dd462732d984c7b$exports, "heading", () => (parcelRequire("j0UBv")).heading);
$parcel$export($8dd462732d984c7b$exports, "rule", () => (parcelRequire("bLhD4")).rule);
$parcel$export($8dd462732d984c7b$exports, "ruleWithLocalId", () => (parcelRequire("bLhD4")).ruleWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "ruleRootOnlyStage0", () => (parcelRequire("bLhD4")).ruleRootOnlyStage0);
$parcel$export($8dd462732d984c7b$exports, "orderedList", () => (parcelRequire("fGuiW")).orderedList);
$parcel$export($8dd462732d984c7b$exports, "orderedListSelector", () => (parcelRequire("fGuiW")).orderedListSelector);
$parcel$export($8dd462732d984c7b$exports, "orderedListWithLocalId", () => (parcelRequire("fGuiW")).orderedListWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "orderedListWithOrder", () => (parcelRequire("fGuiW")).orderedListWithOrder);
$parcel$export($8dd462732d984c7b$exports, "orderedListWithOrderAndLocalId", () => (parcelRequire("fGuiW")).orderedListWithOrderAndLocalId);
$parcel$export($8dd462732d984c7b$exports, "paragraph", () => (parcelRequire("eK2Ov")).paragraph);
$parcel$export($8dd462732d984c7b$exports, "emoji", () => (parcelRequire("bIZRt")).emoji);
$parcel$export($8dd462732d984c7b$exports, "emojiWithLocalId", () => (parcelRequire("bIZRt")).emojiWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "image", () => (parcelRequire("dupND")).image);
$parcel$export($8dd462732d984c7b$exports, "mention", () => (parcelRequire("CmplZ")).mention);
$parcel$export($8dd462732d984c7b$exports, "mentionToJSON", () => (parcelRequire("CmplZ")).toJSON);
$parcel$export($8dd462732d984c7b$exports, "listItem", () => (parcelRequire("jl5Qf")).listItem);
$parcel$export($8dd462732d984c7b$exports, "listItemWithLocalId", () => (parcelRequire("jl5Qf")).listItemWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "extendedPanel", () => (parcelRequire("dGKc1")).extendedPanel);
$parcel$export($8dd462732d984c7b$exports, "extendedPanelWithLocalId", () => (parcelRequire("dGKc1")).extendedPanelWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "extendedPanelRootOnlyStage0", () => (parcelRequire("dGKc1")).extendedPanelRootOnlyStage0);
$parcel$export($8dd462732d984c7b$exports, "extendedPanelC1RootOnlyStage0", () => (parcelRequire("dGKc1")).extendedPanelC1RootOnlyStage0);
$parcel$export($8dd462732d984c7b$exports, "extendedPanelC1", () => (parcelRequire("dGKc1")).extendedPanelC1);
$parcel$export($8dd462732d984c7b$exports, "extendedPanelC1WithLocalId", () => (parcelRequire("dGKc1")).extendedPanelC1WithLocalId);
$parcel$export($8dd462732d984c7b$exports, "PanelType", () => (parcelRequire("dGKc1")).PanelType);
$parcel$export($8dd462732d984c7b$exports, "text", () => (parcelRequire("bSuKu")).text);
$parcel$export($8dd462732d984c7b$exports, "unknownBlock", () => (parcelRequire("h3652")).default);
$parcel$export($8dd462732d984c7b$exports, "caption", () => (parcelRequire("kRG5M")).caption);
$parcel$export($8dd462732d984c7b$exports, "captionWithLocalId", () => (parcelRequire("kRG5M")).captionWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "media", () => (parcelRequire("kZ3vg")).media);
$parcel$export($8dd462732d984c7b$exports, "copyPrivateMediaAttributes", () => (parcelRequire("kZ3vg")).copyPrivateAttributes);
$parcel$export($8dd462732d984c7b$exports, "mediaToJSON", () => (parcelRequire("kZ3vg")).toJSON);
$parcel$export($8dd462732d984c7b$exports, "mediaGroup", () => (parcelRequire("6xrFZ")).mediaGroup);
$parcel$export($8dd462732d984c7b$exports, "mediaInline", () => (parcelRequire("bTc4a")).mediaInline);
$parcel$export($8dd462732d984c7b$exports, "mediaSingle", () => (parcelRequire("jblCI")).mediaSingle);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleSpec", () => (parcelRequire("jblCI")).mediaSingleSpec);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleWithCaption", () => (parcelRequire("jblCI")).mediaSingleWithCaption);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleWithWidthType", () => (parcelRequire("jblCI")).mediaSingleWithWidthType);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleFull", () => (parcelRequire("jblCI")).mediaSingleFull);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleFullWithLocalId", () => (parcelRequire("jblCI")).mediaSingleFullWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleToJSON", () => (parcelRequire("jblCI")).toJSON);
$parcel$export($8dd462732d984c7b$exports, "table", () => (parcelRequire("63Ztt")).table);
$parcel$export($8dd462732d984c7b$exports, "tableWithNestedTable", () => (parcelRequire("63Ztt")).tableWithNestedTable);
$parcel$export($8dd462732d984c7b$exports, "tableRowWithNestedTable", () => (parcelRequire("63Ztt")).tableRowWithNestedTable);
$parcel$export($8dd462732d984c7b$exports, "tableCellWithNestedTable", () => (parcelRequire("63Ztt")).tableCellWithNestedTable);
$parcel$export($8dd462732d984c7b$exports, "tableHeaderWithNestedTable", () => (parcelRequire("63Ztt")).tableHeaderWithNestedTable);
$parcel$export($8dd462732d984c7b$exports, "tableCellStage0", () => (parcelRequire("63Ztt")).tableCellStage0);
$parcel$export($8dd462732d984c7b$exports, "tableHeaderStage0", () => (parcelRequire("63Ztt")).tableHeaderStage0);
$parcel$export($8dd462732d984c7b$exports, "tableCellWithNestedTableStage0", () => (parcelRequire("63Ztt")).tableCellWithNestedTableStage0);
$parcel$export($8dd462732d984c7b$exports, "tableHeaderWithNestedTableStage0", () => (parcelRequire("63Ztt")).tableHeaderWithNestedTableStage0);
$parcel$export($8dd462732d984c7b$exports, "tableRowWithLocalId", () => (parcelRequire("63Ztt")).tableRowWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableCellWithLocalId", () => (parcelRequire("63Ztt")).tableCellWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableHeaderWithLocalId", () => (parcelRequire("63Ztt")).tableHeaderWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("63Ztt")).tableRowWithNestedTableWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("63Ztt")).tableCellWithNestedTableWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("63Ztt")).tableHeaderWithNestedTableWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableStage0", () => (parcelRequire("63Ztt")).tableStage0);
$parcel$export($8dd462732d984c7b$exports, "tableWithCustomWidth", () => (parcelRequire("63Ztt")).tableWithCustomWidth);
$parcel$export($8dd462732d984c7b$exports, "tableToJSON", () => (parcelRequire("63Ztt")).tableToJSON);
$parcel$export($8dd462732d984c7b$exports, "tableCell", () => (parcelRequire("63Ztt")).tableCell);
$parcel$export($8dd462732d984c7b$exports, "toJSONTableCell", () => (parcelRequire("63Ztt")).toJSONTableCell);
$parcel$export($8dd462732d984c7b$exports, "tableHeader", () => (parcelRequire("63Ztt")).tableHeader);
$parcel$export($8dd462732d984c7b$exports, "toJSONTableHeader", () => (parcelRequire("63Ztt")).toJSONTableHeader);
$parcel$export($8dd462732d984c7b$exports, "tableRow", () => (parcelRequire("63Ztt")).tableRow);
$parcel$export($8dd462732d984c7b$exports, "tableBackgroundColorPalette", () => (parcelRequire("63Ztt")).tableBackgroundColorPalette);
$parcel$export($8dd462732d984c7b$exports, "tableBackgroundBorderColor", () => (parcelRequire("63Ztt")).tableBackgroundBorderColor);
$parcel$export($8dd462732d984c7b$exports, "tableBackgroundColorNames", () => (parcelRequire("63Ztt")).tableBackgroundColorNames);
$parcel$export($8dd462732d984c7b$exports, "getCellAttrs", () => (parcelRequire("63Ztt")).getCellAttrs);
$parcel$export($8dd462732d984c7b$exports, "getCellDomAttrs", () => (parcelRequire("63Ztt")).getCellDomAttrs);
$parcel$export($8dd462732d984c7b$exports, "tablePrefixSelector", () => (parcelRequire("63Ztt")).tablePrefixSelector);
$parcel$export($8dd462732d984c7b$exports, "tableCellSelector", () => (parcelRequire("63Ztt")).tableCellSelector);
$parcel$export($8dd462732d984c7b$exports, "tableHeaderSelector", () => (parcelRequire("63Ztt")).tableHeaderSelector);
$parcel$export($8dd462732d984c7b$exports, "tableCellContentWrapperSelector", () => (parcelRequire("63Ztt")).tableCellContentWrapperSelector);
$parcel$export($8dd462732d984c7b$exports, "tableCellContentDomSelector", () => (parcelRequire("63Ztt")).tableCellContentDomSelector);
$parcel$export($8dd462732d984c7b$exports, "decisionList", () => (parcelRequire("gClzS")).decisionList);
$parcel$export($8dd462732d984c7b$exports, "decisionListSelector", () => (parcelRequire("gClzS")).decisionListSelector);
$parcel$export($8dd462732d984c7b$exports, "decisionItem", () => (parcelRequire("bpTLT")).decisionItem);
$parcel$export($8dd462732d984c7b$exports, "taskList", () => (parcelRequire("cXZ4C")).taskList);
$parcel$export($8dd462732d984c7b$exports, "taskListSelector", () => (parcelRequire("cXZ4C")).taskListSelector);
$parcel$export($8dd462732d984c7b$exports, "taskItem", () => (parcelRequire("5elS6")).taskItem);
$parcel$export($8dd462732d984c7b$exports, "blockTaskItem", () => (parcelRequire("5elS6")).blockTaskItem);
$parcel$export($8dd462732d984c7b$exports, "date", () => (parcelRequire("cAWza")).date);
$parcel$export($8dd462732d984c7b$exports, "dateWithLocalId", () => (parcelRequire("cAWza")).dateWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "placeholder", () => (parcelRequire("jEypY")).placeholder);
$parcel$export($8dd462732d984c7b$exports, "placeholderWithLocalId", () => (parcelRequire("jEypY")).placeholderWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "layoutSection", () => (parcelRequire("hVXQj")).layoutSection);
$parcel$export($8dd462732d984c7b$exports, "layoutSectionWithLocalId", () => (parcelRequire("hVXQj")).layoutSectionWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "layoutSectionWithSingleColumn", () => (parcelRequire("hVXQj")).layoutSectionWithSingleColumn);
$parcel$export($8dd462732d984c7b$exports, "layoutSectionWithSingleColumnLocalId", () => (parcelRequire("hVXQj")).layoutSectionWithSingleColumnLocalId);
$parcel$export($8dd462732d984c7b$exports, "layoutColumn", () => (parcelRequire("lifsC")).layoutColumn);
$parcel$export($8dd462732d984c7b$exports, "layoutColumnStage0", () => (parcelRequire("lifsC")).layoutColumnStage0);
$parcel$export($8dd462732d984c7b$exports, "layoutColumnWithLocalId", () => (parcelRequire("lifsC")).layoutColumnWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "inlineCard", () => (parcelRequire("aqHdD")).inlineCard);
$parcel$export($8dd462732d984c7b$exports, "inlineCardWithLocalId", () => (parcelRequire("aqHdD")).inlineCardWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "blockCard", () => (parcelRequire("aGTRk")).blockCard);
$parcel$export($8dd462732d984c7b$exports, "blockCardWithLocalId", () => (parcelRequire("aGTRk")).blockCardWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "unsupportedBlock", () => (parcelRequire("iSXnW")).unsupportedBlock);
$parcel$export($8dd462732d984c7b$exports, "unsupportedInline", () => (parcelRequire("cre7m")).unsupportedInline);
$parcel$export($8dd462732d984c7b$exports, "status", () => (parcelRequire("f4dR3")).status);
$parcel$export($8dd462732d984c7b$exports, "nestedExpand", () => (parcelRequire("iw2ID")).nestedExpand);
$parcel$export($8dd462732d984c7b$exports, "nestedExpandWithLocalId", () => (parcelRequire("iw2ID")).nestedExpandWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "embedCard", () => (parcelRequire("cfHGv")).embedCard);
$parcel$export($8dd462732d984c7b$exports, "embedCardWithLocalId", () => (parcelRequire("cfHGv")).embedCardWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "extension", () => (parcelRequire("2xxP6")).extension);
$parcel$export($8dd462732d984c7b$exports, "inlineExtension", () => (parcelRequire("u6ZFj")).inlineExtension);
$parcel$export($8dd462732d984c7b$exports, "bodiedExtension", () => (parcelRequire("4sfnB")).bodiedExtension);
$parcel$export($8dd462732d984c7b$exports, "extensionFrame", () => (parcelRequire("aotp7")).extensionFrame);
$parcel$export($8dd462732d984c7b$exports, "multiBodiedExtension", () => (parcelRequire("aotp7")).multiBodiedExtension);
$parcel$export($8dd462732d984c7b$exports, "syncBlock", () => (parcelRequire("8WAFY")).syncBlock);
$parcel$export($8dd462732d984c7b$exports, "bodiedSyncBlock", () => (parcelRequire("3EiOU")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4r9Pq = parcelRequire("4r9Pq");


var $fsHCc = parcelRequire("fsHCc");


var $aZa28 = parcelRequire("aZa28");


var $fnSCn = parcelRequire("fnSCn");


var $jRrsu = parcelRequire("jRrsu");


var $iIGXo = parcelRequire("iIGXo");


var $ghpxT = parcelRequire("ghpxT");


var $4HD7y = parcelRequire("4HD7y");


var $aFNbc = parcelRequire("aFNbc");


var $j0UBv = parcelRequire("j0UBv");


var $bLhD4 = parcelRequire("bLhD4");


var $fGuiW = parcelRequire("fGuiW");


var $eK2Ov = parcelRequire("eK2Ov");


var $bIZRt = parcelRequire("bIZRt");


var $dupND = parcelRequire("dupND");


var $CmplZ = parcelRequire("CmplZ");


var $jl5Qf = parcelRequire("jl5Qf");


var $dGKc1 = parcelRequire("dGKc1");


var $bSuKu = parcelRequire("bSuKu");


var $h3652 = parcelRequire("h3652");


var $kRG5M = parcelRequire("kRG5M");


var $kZ3vg = parcelRequire("kZ3vg");


var $6xrFZ = parcelRequire("6xrFZ");


var $bTc4a = parcelRequire("bTc4a");


var $jblCI = parcelRequire("jblCI");


var $63Ztt = parcelRequire("63Ztt");


var $gClzS = parcelRequire("gClzS");


var $bpTLT = parcelRequire("bpTLT");


var $cXZ4C = parcelRequire("cXZ4C");


var $5elS6 = parcelRequire("5elS6");


var $cAWza = parcelRequire("cAWza");


var $jEypY = parcelRequire("jEypY");


var $hVXQj = parcelRequire("hVXQj");


var $lifsC = parcelRequire("lifsC");


var $aqHdD = parcelRequire("aqHdD");


var $aGTRk = parcelRequire("aGTRk");


var $iSXnW = parcelRequire("iSXnW");


var $cre7m = parcelRequire("cre7m");


var $f4dR3 = parcelRequire("f4dR3");


var $iw2ID = parcelRequire("iw2ID");


var $cfHGv = parcelRequire("cfHGv");


var $2xxP6 = parcelRequire("2xxP6");


var $u6ZFj = parcelRequire("u6ZFj");


var $4sfnB = parcelRequire("4sfnB");


var $aotp7 = parcelRequire("aotp7");


var $8WAFY = parcelRequire("8WAFY");


var $3EiOU = parcelRequire("3EiOU");



// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0dbcfc79b71921e3$var$typedNodes = $8dd462732d984c7b$exports;
const $0dbcfc79b71921e3$export$b1f729c6af6f2a6e = new Set(Object.keys($0dbcfc79b71921e3$var$typedNodes).filter((key)=>$0dbcfc79b71921e3$var$typedNodes[key] && $0dbcfc79b71921e3$var$typedNodes[key].group === 'inline'));


var $81OAa = parcelRequire("81OAa");




var $iyDxB = parcelRequire("iyDxB");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $ahEBi = parcelRequire("ahEBi");


var $jv597 = parcelRequire("jv597");



const $b807d28bb87bffcf$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>(0, $jv597.markOrder).indexOf(a.type.name) - (0, $jv597.markOrder).indexOf(b.type.name));
};
const $b807d28bb87bffcf$export$fb80336a7e408cb3 = (doc, schema = (0, $iyDxB.defaultSchema), adfStage = 'final')=>{
    const node = $b807d28bb87bffcf$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $b807d28bb87bffcf$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $b807d28bb87bffcf$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $0dbcfc79b71921e3$export$b1f729c6af6f2a6e).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $b807d28bb87bffcf$export$fafd4f799ee68da0 = (content, schema = (0, $iyDxB.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$b807d28bb87bffcf$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b807d28bb87bffcf$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b807d28bb87bffcf$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b807d28bb87bffcf$var$ANCHOR_LINK = /^#/;
const $b807d28bb87bffcf$var$flattenUnknownBlockTree = (node, schema = (0, $iyDxB.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($b807d28bb87bffcf$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$b807d28bb87bffcf$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $b807d28bb87bffcf$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $81OAa.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
   * Find leaf nodes and join them. If leaf nodes' parent node is the same node
   * join with a blank space, otherwise they are children of different branches, i.e.
   * we need to join them with a hardBreak node
   */ return {
        type: 'unknownBlock',
        content: $b807d28bb87bffcf$var$flattenUnknownBlockTree(node)
    };
};
const $b807d28bb87bffcf$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $b807d28bb87bffcf$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $b807d28bb87bffcf$export$81b20b6c83a56bd = (originalNode, schema = (0, $iyDxB.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $b807d28bb87bffcf$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $81OAa.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $81OAa.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $81OAa.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $81OAa.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $81OAa.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $81OAa.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $b807d28bb87bffcf$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $b807d28bb87bffcf$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $b807d28bb87bffcf$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $b807d28bb87bffcf$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $b807d28bb87bffcf$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $dGKc1.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $fO7hX.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $fO7hX.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $fO7hX.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $fO7hX.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $fO7hX.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $fO7hX.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $b807d28bb87bffcf$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (attrs && attrs.resourceId && (0, $iu6m9.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $fO7hX.generateUuid)()
                },
                marks: marks
            };
            else return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (attrs && attrs.resourceId && Array.isArray(content) && content.length > 0 && (0, $iu6m9.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $fO7hX.generateUuid)()
                },
                marks: marks,
                content: content
            };
            else return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
    }
    return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
};
const $b807d28bb87bffcf$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$b807d28bb87bffcf$var$RELATIVE_LINK.test(linkHref) && !$b807d28bb87bffcf$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $81OAa.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ((0, $ahEBi.isSubSupType)(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $b807d28bb87bffcf$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $b807d28bb87bffcf$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};
module.exports["getMarksByOrder"] = $b807d28bb87bffcf$export$99a33ed044c278ae;
module.exports["getValidDocument"] = $b807d28bb87bffcf$export$fb80336a7e408cb3;
module.exports["getValidNode"] = $b807d28bb87bffcf$export$81b20b6c83a56bd;

});

parcelRegister("7nUdN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cUycv = parcelRequire("cUycv");








var $21K7m = parcelRequire("21K7m");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");





var $dh538 = parcelRequire("dh538");


var $aXWIB = parcelRequire("aXWIB");


var $3kBFe = parcelRequire("3kBFe");


var $jSHzw = parcelRequire("jSHzw");

const $7fcae4a13326e885$var$markStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cUycv.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
            cursor: 'pointer'
        }
    }
});
const $7fcae4a13326e885$var$markStylesLayeringFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cUycv.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cUycv.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cUycv.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cUycv.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7fcae4a13326e885$var$MOBILE_USER_AGENT_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const $7fcae4a13326e885$var$isMobile = ()=>{
    return $7fcae4a13326e885$var$MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
};
const $7fcae4a13326e885$var$accessibilityStylesNew = /*#__PURE__*/ (0, $9K4OG.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-startmarker)'
        ]
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-endmarker)'
        ]
    }
});
const $7fcae4a13326e885$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $aXWIB.useIntl)();
    const annotationIds = (0, $42omo.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $jSHzw.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $42omo.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $42omo.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $cUycv.AnnotationMarkStates).ACTIVE) return;
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- keyboard focus for mark / Enter handling
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $7fcae4a13326e885$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $cUycv.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $9K4OG.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $7fcae4a13326e885$var$markStyles,
                $7fcae4a13326e885$var$markStylesLayeringFix,
                (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') && $7fcae4a13326e885$var$markStylesWithInlineComments,
                $7fcae4a13326e885$var$markStylesWithCommentsPanel,
                !$7fcae4a13326e885$var$isMobile() && $7fcae4a13326e885$var$accessibilityStylesNew,
                $7fcae4a13326e885$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': `"${intl.formatMessage((0, $3kBFe.inlineCommentMessages).contentRendererInlineCommentMarkerStart)}"`,
                '--ak-renderer-annotation-endmarker': `"${intl.formatMessage((0, $3kBFe.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)}"`
            }
        }
    }, children);
};



var $ancN7 = parcelRequire("ancN7");


var $hXhSb = parcelRequire("hXhSb");


var $1lzbj = parcelRequire("1lzbj");


var $IcpgS = parcelRequire("IcpgS");




const $8711d9493341addc$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $hXhSb.useInlineCommentSubscriberContext)();
    const states = (0, $42omo.useContext)((0, $IcpgS.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $1lzbj.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $42omo.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const onClick = (0, $42omo.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager?.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((_error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $ancN7.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $cUycv.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fcae4a13326e885$export$4f5a51511304fdd0), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel
    }, children);
};


const $02b331d070d05b79$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $02b331d070d05b79$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $cUycv.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        id: id
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8711d9493341addc$export$f3069f755c1eba0b), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel
    }, children);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        id: id,
        ...data
    }, children));
};
var $02b331d070d05b79$export$2e2bcd8739ae039 = $02b331d070d05b79$var$AnnotationComponent;
module.exports["isAnnotationMark"] = $02b331d070d05b79$export$855795c145f03402;
module.exports["default"] = $02b331d070d05b79$export$2e2bcd8739ae039;

});

parcelRegister("ancN7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $IcpgS = parcelRequire("IcpgS");

const $5c4a32a3b8bea484$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $42omo.useContext)((0, $IcpgS.InlineCommentsStateContext));
    return (0, $42omo.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};
module.exports["useInlineCommentsFilter"] = $5c4a32a3b8bea484$export$8e7d47f9e38ad4f1;

});

parcelRegister("hXhSb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $IcpgS = parcelRequire("IcpgS");

const $667d06be2b39b9f1$export$b46737175cffd396 = ()=>{
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};
module.exports["useInlineCommentSubscriberContext"] = $667d06be2b39b9f1$export$b46737175cffd396;

});

parcelRegister("7Rcde", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $71e03d612e0cb7ab$export$42bb270d1224182 = (0, $aXWIB.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: "fabric.editor.codeBidiWarningLabel",
        defaultMessage: "Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code."
    }
});
module.exports["codeBidiWarningMessages"] = $71e03d612e0cb7ab$export$42bb270d1224182;

});

parcelRegister("iS6Uy", function(module, exports) {
// This import will be stripped on build

var $dh538 = parcelRequire("dh538");

function $874fb90bacae98d1$export$9c2f408d391feb93(hexColor) {
    const normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return normalizedHexColor ? $874fb90bacae98d1$export$57fa5089caad992[normalizedHexColor] : undefined;
}
const $874fb90bacae98d1$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #357DE8)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #1558BC)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #2898BD)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #206A83)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #22A06B)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #216E4E)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FCA700)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #E06C00)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #C9372C)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #AE2E24)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #AF59E1)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #803FA5)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #7D818A)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #292A2E)",
    // source for hex code was legacy token N800
    // lime
    /** lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** lime - medium */ ['#6A9A23']: "var(--ds-icon-accent-lime, #6A9A23)",
    /** lime - strong */ ['#4C6B1F']: "var(--ds-text-accent-lime, #4C6B1F)",
    // orange
    /** orange - light */ ['#FCE4A6']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** orange - medium */ ['#E06C00']: "var(--ds-icon-accent-orange, #E06C00)",
    /** orange - strong */ ['#9E4C00']: "var(--ds-text-accent-orange, #9E4C00)",
    // magenta
    /** magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** magenta - medium */ ['#CD519D']: "var(--ds-icon-accent-magenta, #CD519D)",
    /** magenta - strong */ ['#943D73']: "var(--ds-text-accent-magenta, #943D73)",
    // yellow
    /** yellow - medium */ get ['#B38600'] () {
        return (0, $dh538.fg)('platform_editor_lovability_text_bg_color_patch_1') ? "var(--ds-border-accent-yellow, #B38600)" : "var(--ds-icon-accent-yellow, #B38600)";
    },
    /** yellow - strong */ ['#7F5F01']: "var(--ds-text-accent-yellow, #7F5F01)"
};
module.exports["hexToEditorTextPaletteColor"] = $874fb90bacae98d1$export$9c2f408d391feb93;

});

parcelRegister("bWiTS", function(module, exports) {
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $9d897280e134968c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ ['#F8E6A0']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    /** Blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    /** Green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)"
};
function $9d897280e134968c$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $9d897280e134968c$export$12a518ff137dd389[hexColor.toUpperCase()];
}
module.exports["hexToEditorTextBackgroundPaletteColor"] = $9d897280e134968c$export$8b58ff1b36bb75e0;

});

parcelRegister("lf9Ji", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iyDxB = parcelRequire("iyDxB");


var $6jPem = parcelRequire("6jPem");


var $jqXx5 = parcelRequire("jqXx5");

const $a3f798d5a25f20e6$var$NATIVE_EMBED_EXTENSION_KEY = 'native-embed';
/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows an `embedCard` child. Returns an empty set if the
 * schema does not declare an `embedCard` node.
 */ const $a3f798d5a25f20e6$var$getEmbedCardAllowedParentTypes = (schema)=>{
    const embedCardType = schema.nodes.embedCard;
    if (!embedCardType) return new Set();
    const allowed = new Set();
    for (const nodeType of Object.values(schema.nodes))if (nodeType.contentMatch?.matchType(embedCardType)) allowed.add(nodeType.name);
    return allowed;
};
const $a3f798d5a25f20e6$export$fdee1e5f1664414c = (adf, schema)=>{
    const embedCardAllowedParentTypes = $a3f798d5a25f20e6$var$getEmbedCardAllowedParentTypes(schema);
    const isEmbedCardAllowedInParent = (parent)=>{
        const parentType = parent?.node?.type;
        return parentType ? embedCardAllowedParentTypes.has(parentType) : false;
    };
    let didTransform = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        extension: (node, parent)=>{
            if (node.attrs?.['extensionKey'].split(':')[0] !== $a3f798d5a25f20e6$var$NATIVE_EMBED_EXTENSION_KEY) return node;
            const url = node.attrs?.['parameters']?.macroParams?.url?.value;
            if (!url) {
                didTransform = true;
                return false;
            }
            didTransform = true;
            if (isEmbedCardAllowedInParent(parent)) return {
                type: 'embedCard',
                attrs: {
                    url: url,
                    layout: 'center'
                }
            };
            return {
                type: 'paragraph',
                content: [
                    {
                        type: 'inlineCard',
                        attrs: {
                            url: url
                        }
                    }
                ]
            };
        }
    });
    if (didTransform && transformedAdf) try {
        const validate = (0, $jqXx5.validator)();
        const { valid: valid } = validate(transformedAdf);
        if (!valid) // Transformed ADF is invalid – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    } catch  {
        // Validation threw – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    }
    return {
        transformedAdf: transformedAdf,
        hasValidTransform: didTransform
    };
};


var $1OR0A = parcelRequire("1OR0A");

var $1LHXq = parcelRequire("1LHXq");

var $dDZcC = parcelRequire("dDZcC");


var $d925B = parcelRequire("d925B");


var $juTiU = parcelRequire("juTiU");

var $6aq5c = parcelRequire("6aq5c");


var $bSXAs = parcelRequire("bSXAs");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $2XqLN = parcelRequire("2XqLN");


var $59U23 = parcelRequire("59U23");


var $fLvO8 = parcelRequire("fLvO8");

var $kOYZR = parcelRequire("kOYZR");







const $ac4164d5be644112$var$rendersMap = {};
const $ac4164d5be644112$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $kOYZR.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $fLvO8.getAnalyticsAppearance)(item.appearance),
                platform: (0, $59U23.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $ac4164d5be644112$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $ac4164d5be644112$var$DEFAULT_SAMPLING_RATE = 100;
const $ac4164d5be644112$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$ac4164d5be644112$var$rendersMap[appearance]) $ac4164d5be644112$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $ac4164d5be644112$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $ac4164d5be644112$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $ac4164d5be644112$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($ac4164d5be644112$var$rendersMap[appearance].size === 1) $ac4164d5be644112$var$schedule(()=>$ac4164d5be644112$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($ac4164d5be644112$var$rendersMap[appearance].size % sampleRate === 0) $ac4164d5be644112$var$rendersMap[appearance] = new Set();
};



var $1Qaul = parcelRequire("1Qaul");

const $bb293804104002a3$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $bb293804104002a3$var$withStopwatch = (cb)=>{
    const startTime = $bb293804104002a3$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $bb293804104002a3$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $bb293804104002a3$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1LHXq.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $6aq5c.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $bSXAs.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $dDZcC.transformNestedTablesIncomingDocument)(result);
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $d925B.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    // Upgrade panel → panel_c1 where the schema allows it
    if (result && (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed, transformedNodeTypes: transformedNodeTypes } = (0, $1OR0A.transformContainerNodes)(result, schema);
        if (isTransformed && transformedAdf) {
            dispatchAnalyticsEvent?.({
                action: (0, $d925B.ACTION).CONTAINER_NODE_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    transformedNodeTypes: transformedNodeTypes
                }
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform panel to panel_c1' : undefined}`
            }
        });
    }
    if (result && !(0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true) && !(0, $dh538.fg)('platform_native_embeds_rollout_non_maui_experience') && (0, $dh538.fg)('platform_editor_native_embeds_fallback_transform')) {
        const { transformedAdf: transformedAdf, hasValidTransform: hasValidTransform } = (0, $a3f798d5a25f20e6$export$fdee1e5f1664414c)(result, schema);
        if (hasValidTransform && transformedAdf) {
            dispatchAnalyticsEvent?.({
                action: (0, $d925B.ACTION).NATIVE_EMBEDS_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    }
    return result;
};
const $bb293804104002a3$var$memoValidation = (0, $2XqLN.default)($bb293804104002a3$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ newSkipValidation, newValidationOverrides] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ oldSkipValidation, oldValidationOverrides] = lastArgs;
    return $bb293804104002a3$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb293804104002a3$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $bb293804104002a3$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $bb293804104002a3$var$memoSerializeFragment = (0, $2XqLN.default)($bb293804104002a3$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $bb293804104002a3$var$areDocsEqual(newDoc, oldDoc);
});
const $bb293804104002a3$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $bb293804104002a3$var$memoCreateNodeAndCheck = (0, $2XqLN.default)($bb293804104002a3$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $bb293804104002a3$var$areDocsEqual(newDoc, oldDoc);
});
const $bb293804104002a3$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $iyDxB.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    if ((0, $dh538.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $bb293804104002a3$var$withStopwatch(()=>{
        return $bb293804104002a3$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $bb293804104002a3$var$withStopwatch(()=>{
        return $bb293804104002a3$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $bb293804104002a3$var$withStopwatch(()=>{
        return $bb293804104002a3$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $juTiU.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $ac4164d5be644112$export$a43de96edd8d0a0)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $1Qaul.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};
module.exports["renderDocument"] = $bb293804104002a3$export$59a54f98b9753d5c;

});

parcelRegister("1OR0A", function(module, exports) {

var $6jPem = parcelRequire("6jPem");


var $i6VeE = parcelRequire("i6VeE");

/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows a `panel_c1` child. Returns an empty set if the
 * schema does not declare a `panel_c1` node.
 */ const $3d4428dc2811f753$var$getPanelC1AllowedParentTypes = (schema)=>{
    const panelC1Type = schema.nodes['panel_c1'];
    if (!panelC1Type) return new Set();
    const allowed = new Set();
    for (const nodeType of Object.values(schema.nodes))if (nodeType.contentMatch?.matchType(panelC1Type)) allowed.add(nodeType.name);
    return allowed;
};
const $3d4428dc2811f753$export$62836639b6ded12a = (adf, schema)=>{
    let isTransformed = false;
    const transformedNodeTypes = new Set();
    let transformedAdf = adf;
    const panelC1FallbackResult = (0, $i6VeE.panelC1FallbackTransform)(schema, transformedAdf);
    if (panelC1FallbackResult.isTransformed && panelC1FallbackResult.transformedAdf) {
        isTransformed = true;
        transformedNodeTypes.add('panel_c1');
        transformedAdf = panelC1FallbackResult.transformedAdf;
    }
    const panelC1AllowedParents = $3d4428dc2811f753$var$getPanelC1AllowedParentTypes(schema);
    const promotedAdf = (0, $6jPem.traverse)(transformedAdf, {
        panel: (node, parent)=>{
            const parentType = parent.node?.type;
            if (parentType && panelC1AllowedParents.has(parentType)) {
                isTransformed = true;
                transformedNodeTypes.add('panel_c1');
                return {
                    ...node,
                    type: 'panel_c1'
                };
            }
            return;
        }
    });
    return {
        transformedAdf: promotedAdf,
        isTransformed: isTransformed,
        transformedNodeTypes: Array.from(transformedNodeTypes)
    };
};
module.exports["transformContainerNodes"] = $3d4428dc2811f753$export$62836639b6ded12a;

});

parcelRegister("i6VeE", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

// A Legacy Content Macro (LCM) is a Confluence macro stored as an ADF `extension`.
// Its handler renders an editable nested editor, so wrapping a table in an LCM keeps
// it visible/editable inside a plain `panel` (which permits `extension` children) —
// unlike `unsupportedBlock`, which only shows a placeholder.
// @see confluence/next/packages/experiment-legacy-content-macro
const $eeaaf80d63ad93d7$var$LCM_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $eeaaf80d63ad93d7$var$LCM_EXTENSION_KEY = 'legacy-content';
const $eeaaf80d63ad93d7$var$PANEL_C1_FALLBACK_MARKER = '__platformEditorPanelC1Fallback';
// Parents a wrapped table may be restored into. A plain `panel` doesn't yet allow a
// `table`, but it's the pre-promotion wrapper this transform emits: the shared
// container transform restores the table here, then promotes `panel` -> `panel_c1`.
// Restricting to panel-family parents avoids unwrapping tables wrapped elsewhere.
const $eeaaf80d63ad93d7$var$TABLE_RESTORE_PARENT_TYPES = new Set([
    'panel',
    'panel_c1'
]);
const $eeaaf80d63ad93d7$var$safeParseAdf = (adf)=>{
    if (typeof adf !== 'string') return undefined;
    try {
        return JSON.parse(adf);
    } catch  {
        return undefined;
    }
};
const $eeaaf80d63ad93d7$var$wrapAsLcm = (node)=>{
    const nestedContent = {
        version: 1,
        type: 'doc',
        content: [
            node
        ]
    };
    return {
        type: 'extension',
        attrs: {
            extensionType: $eeaaf80d63ad93d7$var$LCM_EXTENSION_TYPE,
            extensionKey: $eeaaf80d63ad93d7$var$LCM_EXTENSION_KEY,
            layout: 'default',
            parameters: {
                nestedContent: nestedContent,
                adf: JSON.stringify(nestedContent),
                [$eeaaf80d63ad93d7$var$PANEL_C1_FALLBACK_MARKER]: true
            }
        }
    };
};
const $eeaaf80d63ad93d7$var$isLcm = (node)=>node.type === 'extension' && node.attrs?.extensionType === $eeaaf80d63ad93d7$var$LCM_EXTENSION_TYPE && node.attrs?.extensionKey === $eeaaf80d63ad93d7$var$LCM_EXTENSION_KEY && node.attrs?.parameters?.[$eeaaf80d63ad93d7$var$PANEL_C1_FALLBACK_MARKER] === true;
/** Single wrapped block from an LCM, preferring `nestedContent` then parsed `adf`. */ const $eeaaf80d63ad93d7$var$getLcmWrappedNode = (node)=>{
    const params = node.attrs?.parameters;
    const nested = params?.nestedContent ?? $eeaaf80d63ad93d7$var$safeParseAdf(params?.adf);
    return nested?.content?.length === 1 ? nested.content[0] : undefined;
};
const $eeaaf80d63ad93d7$var$wrappedNodeIsTable = (node)=>$eeaaf80d63ad93d7$var$isLcm(node) && $eeaaf80d63ad93d7$var$getLcmWrappedNode(node)?.type === 'table' || node.type === 'unsupportedBlock' && node.attrs?.originalValue?.type === 'table';
const $eeaaf80d63ad93d7$var$isTableInPanelSupported = (schema)=>{
    const { table: table, panel_c1: panel_c1 } = schema.nodes;
    if (!table || !panel_c1) return false;
    return true;
};
const $eeaaf80d63ad93d7$export$9a4ff29f7abd9bcd = (schema, adf)=>{
    let isTransformed = false;
    const { extension: extension, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const tableInPanelSupported = $eeaaf80d63ad93d7$var$isTableInPanelSupported(schema);
    const shouldDowngrade = !tableInPanelSupported;
    const shouldRestore = tableInPanelSupported;
    const hasRelevantNode = (node)=>shouldDowngrade && node.type === 'panel_c1' || shouldRestore && $eeaaf80d63ad93d7$var$wrappedNodeIsTable(node) || Array.isArray(node.content) && node.content.some((c)=>!!c && hasRelevantNode(c));
    if (!hasRelevantNode(adf)) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    // Prefer the LCM (visible/editable); fall back to a preserved-but-hidden unsupportedBlock.
    const wrapTable = (tableNode)=>extension ? $eeaaf80d63ad93d7$var$wrapAsLcm(tableNode) : unsupportedBlock.createChecked({
            originalValue: tableNode
        }).toJSON();
    const downgradePanel = (node)=>{
        if (!Array.isArray(node.content)) return node;
        const hasTableChild = node.content.some((child)=>child?.type === 'table');
        if (hasTableChild && !extension && !unsupportedBlock) return node;
        const content = node.content.map((child)=>{
            if (child?.type === 'table') {
                isTransformed = true;
                return wrapTable(child);
            }
            return child;
        });
        isTransformed = true;
        return {
            ...node,
            type: 'panel',
            content: content
        };
    };
    const restoreWrappedTable = (node, parent)=>{
        if (!$eeaaf80d63ad93d7$var$TABLE_RESTORE_PARENT_TYPES.has(parent?.node?.type ?? '')) return node;
        const restored = $eeaaf80d63ad93d7$var$isLcm(node) ? $eeaaf80d63ad93d7$var$getLcmWrappedNode(node) : node.attrs?.originalValue;
        if (restored?.type === 'table') {
            isTransformed = true;
            return restored;
        }
        return node;
    };
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        // Unsupported schema: downgrade to a plain `panel`, wrapping table children.
        panel_c1: (node)=>shouldDowngrade ? downgradePanel(node) : node,
        // Supported schema: restore tables wrapped as an LCM / unsupportedBlock.
        extension: (node, parent)=>shouldRestore ? restoreWrappedTable(node, parent) : node,
        unsupportedBlock: (node, parent)=>shouldRestore ? restoreWrappedTable(node, parent) : node
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
module.exports["panelC1FallbackTransform"] = $eeaaf80d63ad93d7$export$9a4ff29f7abd9bcd;

});

parcelRegister("1LHXq", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

const $509946b00b1dc655$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
module.exports["transformMediaLinkMarks"] = $509946b00b1dc655$export$6528700f3fa2fe2a;

});

parcelRegister("kOYZR", function(module, exports) {

var $6jPem = parcelRequire("6jPem");


var $jPKxk = parcelRequire("jPKxk");


var $cOflS = parcelRequire("cOflS");

const $c9985f9e1fc7d853$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || (0, $cOflS.UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS).DEGRADED,
        blocking: customThresholds?.blocking || (0, $cOflS.UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS).BLOCKING
    };
};
const $c9985f9e1fc7d853$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $6jPem.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $6jPem.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $c9985f9e1fc7d853$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return (0, $jPKxk.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).DEGRADED;
    if (thresholds.blocking <= unsupportedContentLevelPercent) return (0, $jPKxk.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).BLOCKING;
    return (0, $jPKxk.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).NORMAL;
};
const $c9985f9e1fc7d853$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $c9985f9e1fc7d853$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $c9985f9e1fc7d853$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $c9985f9e1fc7d853$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};
module.exports["getUnsupportedContentLevelData"] = $c9985f9e1fc7d853$export$484b83e0462998d;

});

parcelRegister("jPKxk", function(module, exports) {
var $3e56bb322a88bc29$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
module.exports["UNSUPPORTED_CONTENT_LEVEL_SEVERITY"] = $3e56bb322a88bc29$export$6632e71a22d31bf1;

});

parcelRegister("cOflS", function(module, exports) {
const $ff1ab1bd733bb44c$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
module.exports["UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS"] = $ff1ab1bd733bb44c$export$f9f8a29778652c3e;

});

parcelRegister("9KIOh", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b77f3940744feba2$var$dest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $b77f3940744feba2$export$20439b49fdd0d26c = $b77f3940744feba2$var$dest.Provider;
const $b77f3940744feba2$var$Consumer = $b77f3940744feba2$var$dest.Consumer;
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $b77f3940744feba2$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $42omo.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b77f3940744feba2$var$Consumer, null, (newActiveHeaderId)=>{
        if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
        else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
            setActiveHeaderId(newActiveHeaderId);
            onNestedHeaderIdMatch();
        }
        return null;
    });
};
module.exports["ActiveHeaderIdProvider"] = $b77f3940744feba2$export$20439b49fdd0d26c;
module.exports["ActiveHeaderIdConsumer"] = $b77f3940744feba2$export$cddc3c6ebe2d2cec;

});

parcelRegister("fhm10", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $5gVJx = parcelRequire("5gVJx");

const $d6d0bc28331ae132$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $d6d0bc28331ae132$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $d6d0bc28331ae132$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $d6d0bc28331ae132$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $d6d0bc28331ae132$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $9K4OG.css)(">.mediaInlineView-content-wrap>.", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, ",>.", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $d6d0bc28331ae132$export$dee15762144889b7 = /*#__PURE__*/ (0, $9K4OG.css)(".", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, "{height:", (0, $5gVJx.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h1'], -3), ";}h2{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h2'], -3), ";}h3{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h3'], -2), ";}h4{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h4'], -2), ";}h5{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h5'], -2), ";}h6{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h6'], -2), ";}");
const $d6d0bc28331ae132$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$d6d0bc28331ae132$export$7ab34e219ce6eef}, ${(0, $5gVJx.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $d6d0bc28331ae132$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $9K4OG.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    outline: 'none'
});
const $d6d0bc28331ae132$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $9K4OG.css)({
    borderColor: `var(${$d6d0bc28331ae132$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$d6d0bc28331ae132$export$263a8a844c370a89}, ${(0, $5gVJx.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$d6d0bc28331ae132$export$263a8a844c370a89}, ${(0, $5gVJx.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});
module.exports["INLINE_IMAGE_WRAPPER_CLASS_NAME"] = $d6d0bc28331ae132$export$dd2e16f83ae6aa78;
module.exports["INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY"] = $d6d0bc28331ae132$export$7ab34e219ce6eef;
module.exports["INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY"] = $d6d0bc28331ae132$export$263a8a844c370a89;
module.exports["INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY"] = $d6d0bc28331ae132$export$b0d1f1e1fb3c4b46;
module.exports["wrapperStyle"] = $d6d0bc28331ae132$export$c4d4f06a25de97f;
module.exports["selectedStyle"] = $d6d0bc28331ae132$export$a7abb1b3dc25813f;
module.exports["borderStyle"] = $d6d0bc28331ae132$export$4d0a7f76ad443516;

});

parcelRegister("5gVJx", function(module, exports) {
const $34d61841b825d2c8$export$d722b7527b1834a8 = 250;
const $34d61841b825d2c8$export$da894f7669b4e67c = 200;
const $34d61841b825d2c8$export$286cf28b87ad4b4f = $34d61841b825d2c8$export$d722b7527b1834a8 / $34d61841b825d2c8$export$da894f7669b4e67c;
const $34d61841b825d2c8$export$64fe09732fb8680 = 0;
const $34d61841b825d2c8$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
module.exports["DEFAULT_IMAGE_WIDTH"] = $34d61841b825d2c8$export$d722b7527b1834a8;
module.exports["DEFAULT_IMAGE_HEIGHT"] = $34d61841b825d2c8$export$da894f7669b4e67c;
module.exports["DEFAULT_INLINE_IMAGE_ASPECT_RATIO"] = $34d61841b825d2c8$export$286cf28b87ad4b4f;
module.exports["DEFAULT_INLINE_IMAGE_BORDER_SIZE"] = $34d61841b825d2c8$export$64fe09732fb8680;
module.exports["referenceHeights"] = $34d61841b825d2c8$export$c1317a9224e4d798;

});

parcelRegister("7bDsi", function(module, exports) {
const $2d87519b5d393b3d$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
module.exports["DateSharedCssClassName"] = $2d87519b5d393b3d$export$99cdf122d0bb9f95;

});

parcelRegister("gnMzP", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");

const $1a978e7ea9233092$export$cfe6da7d522d87bb = 'rich-media-item';
const $1a978e7ea9233092$var$wrappedMediaBreakoutPoint = 410;
const $1a978e7ea9233092$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$1a978e7ea9233092$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $1a978e7ea9233092$export$b51dea84d928a378 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $aFUXX.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$1a978e7ea9233092$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
module.exports["richMediaClassName"] = $1a978e7ea9233092$export$cfe6da7d522d87bb;

});

parcelRegister("cV5SN", function(module, exports) {
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $2775743fdfdf82a1$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
module.exports["SmartCardSharedCssClassName"] = $2775743fdfdf82a1$export$4ccd31bf665a88f6;

});

parcelRegister("7iisy", function(module, exports) {
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $d23ce9b4e7735d18$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
module.exports["TaskDecisionSharedCssClassName"] = $d23ce9b4e7735d18$export$a7172b75d403a0e4;

});

parcelRegister("j2w4t", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");

var $kPuBV = parcelRequire("kPuBV");


var $5MaNT = parcelRequire("5MaNT");


var $1tRSs = parcelRequire("1tRSs");


var $jVL42 = parcelRequire("jVL42");

const $223f15bdc9399d28$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $aFUXX.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            display: 'flex',
            borderRadius: "var(--ds-radius-small, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #292A2E)",
                borderRadius: "var(--ds-radius-small, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #6B6E76)",
            boxSizing: 'content-box'
        }
    }
});
const $223f15bdc9399d28$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $223f15bdc9399d28$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $223f15bdc9399d28$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $jVL42.RendererCssClassName).DOCUMENT, ">.", $223f15bdc9399d28$export$afbde0e7339bed51.CONTAINER, " .", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $aFUXX.blockNodesVerticalMargin), ";}");
};
const $223f15bdc9399d28$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $42omo.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, hideLineNumbers: hideLineNumbers = false, className: className }, ref)=>{
    const textRows = (0, $42omo.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $1tRSs.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $223f15bdc9399d28$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $kPuBV.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $223f15bdc9399d28$var$codeBlockSharedStyles,
            $223f15bdc9399d28$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, !hideLineNumbers && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("code", null, renderBidiWarnings(text))))));
});
var $223f15bdc9399d28$export$2e2bcd8739ae039 = $223f15bdc9399d28$var$LightWeightCodeBlock;
module.exports["LightWeightCodeBlockCssClassName"] = $223f15bdc9399d28$export$afbde0e7339bed51;
module.exports["default"] = $223f15bdc9399d28$export$2e2bcd8739ae039;

});

parcelRegister("1tRSs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $g7Pc3 = parcelRequire("g7Pc3");


var $7Rcde = parcelRequire("7Rcde");


var $03WRT = parcelRequire("03WRT");


var $1oCLl = parcelRequire("1oCLl");

const $1ac1bf4a86d18ce4$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $aXWIB.useIntl)();
    const warningLabel = intl.formatMessage((0, $7Rcde.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return text;
        return (0, $03WRT.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g7Pc3.default), {
                bidiCharacter: bidiCharacter,
                key: index,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};
module.exports["useBidiWarnings"] = $1ac1bf4a86d18ce4$export$9fb9fe546a188c7b;

});

parcelRegister("ilPbq", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $9202133f4d3acb51$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $9202133f4d3acb51$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $9202133f4d3acb51$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body.small': 'normal 400 0.875em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};


function $cf904c6b16edcd21$var$editorUGCToken(path) {
    let tokens;
    if ((0, $dh538.fg)('platform_editor_typography_ugc')) tokens = (0, $9202133f4d3acb51$export$63adc0ebe3278d31);
    else tokens = (0, $9202133f4d3acb51$export$4a3637dc6e2ae29e);
    return tokens[path];
}
var $cf904c6b16edcd21$export$2e2bcd8739ae039 = $cf904c6b16edcd21$var$editorUGCToken;
module.exports["default"] = $cf904c6b16edcd21$export$2e2bcd8739ae039;

});

parcelRegister("98HrB", function(module, exports) {

var $8hpYf = parcelRequire("8hpYf");

const $200d6bd4f803d466$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $8hpYf.emojiNodeStyles),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $8hpYf.emojiSprite),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $8hpYf.emojiImage),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $8hpYf.placeholder),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_UNICODE: 'emoji-common-emoji-unicode'
};
module.exports["EmojiSharedCssClassName"] = $200d6bd4f803d466$export$ee47248f9a998789;

});

parcelRegister("e6n00", function(module, exports) {
const $e31affe2f363c0cc$var$prefix = 'ak-editor-sync-block';
const $e31affe2f363c0cc$export$84840734cffb342f = {
    prefix: $e31affe2f363c0cc$var$prefix,
    renderer: `${$e31affe2f363c0cc$var$prefix}__renderer`,
    error: `${$e31affe2f363c0cc$var$prefix}__error_state`,
    loading: `${$e31affe2f363c0cc$var$prefix}__loading_state`
};
const $e31affe2f363c0cc$export$8c57d8325d08218b = 'data-sync-block-renderer';
const $e31affe2f363c0cc$var$bodiedPrefix = 'ak-editor-bodied-sync-block';
const $e31affe2f363c0cc$export$628f41eb22ec9a2 = {
    prefix: $e31affe2f363c0cc$var$bodiedPrefix,
    renderer: `${$e31affe2f363c0cc$var$bodiedPrefix}__renderer`,
    content: `${$e31affe2f363c0cc$var$bodiedPrefix}__content`,
    selectionInside: `${$e31affe2f363c0cc$var$bodiedPrefix}__selection_inside`
};
// Constant labelClassName value here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $e31affe2f363c0cc$var$labelClassName = 'ak-editor-sync-block__label';
const $e31affe2f363c0cc$export$f75b6075afbd73af = {
    labelClassName: $e31affe2f363c0cc$var$labelClassName
};
const $e31affe2f363c0cc$export$7e44804769d54f36 = 'disabled';
const $e31affe2f363c0cc$export$da351099a95c41a2 = 'view-mode';
const $e31affe2f363c0cc$export$ddb90512ea536019 = 'creation-loading';
const $e31affe2f363c0cc$export$52ab9fe57e8e4c2e = 'user-is-dragging';
const $e31affe2f363c0cc$export$9b10dd4c500e3ce8 = {
    disabledClassName: $e31affe2f363c0cc$export$7e44804769d54f36,
    viewModeClassName: $e31affe2f363c0cc$export$da351099a95c41a2,
    creationLoadingClassName: $e31affe2f363c0cc$export$ddb90512ea536019,
    draggingClassName: $e31affe2f363c0cc$export$52ab9fe57e8e4c2e
};
module.exports["SyncBlockSharedCssClassName"] = $e31affe2f363c0cc$export$84840734cffb342f;
module.exports["SyncBlockRendererDataAttributeName"] = $e31affe2f363c0cc$export$8c57d8325d08218b;
module.exports["BodiedSyncBlockSharedCssClassName"] = $e31affe2f363c0cc$export$628f41eb22ec9a2;
module.exports["SyncBlockLabelSharedCssClassName"] = $e31affe2f363c0cc$export$f75b6075afbd73af;
module.exports["SyncBlockStateCssClassName"] = $e31affe2f363c0cc$export$9b10dd4c500e3ce8;

});

parcelRegister("eauJy", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc -- thin portal context helpers */ 
var $42omo = parcelRequire("42omo");

const $5e9b251857e7eb9b$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
function $5e9b251857e7eb9b$export$b1072f43c67b540c(props) {
    const portalFromContext = (0, $42omo.useContext)($5e9b251857e7eb9b$export$60d741e20e0aa309);
    return props?.portal || portalFromContext;
}
module.exports["PortalContext"] = $5e9b251857e7eb9b$export$60d741e20e0aa309;
module.exports["usePortal"] = $5e9b251857e7eb9b$export$b1072f43c67b540c;

});

parcelRegister("e2wMq", function(module, exports) {
var $c8d6368806133d17$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $c8d6368806133d17$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $c8d6368806133d17$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $c8d6368806133d17$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});
module.exports["PLATFORMS"] = $c8d6368806133d17$export$a8d23193462f2b63;
module.exports["MODE"] = $c8d6368806133d17$export$e48589d9e4824227;
module.exports["FULL_WIDTH_MODE"] = $c8d6368806133d17$export$57453495b81e2dde;
module.exports["BROWSER_FREEZE_INTERACTION_TYPE"] = $c8d6368806133d17$export$60a219cfaef9722;

});

parcelRegister("3824I", function(module, exports) {
var $fa05b1e32f887e46$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    TABLE_ACTION["DRAG_MENU_OPENED"] = "dragMenuOpened";
    /**
   * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
   * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
   */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    TABLE_ACTION["CHANGED_CELL_VERTICAL_ALIGNMENT"] = "changedVerticalAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    TABLE_ACTION["TABLE_EDITOR_HEIGHT_INFO"] = "tableEditorHeightInformation";
    TABLE_ACTION["TABLE_RENDERER_HEIGHT_INFO"] = "tableRendererHeightInformation";
    TABLE_ACTION["STICKY_HEADER_METHOD_TOGGLED"] = "stickyHeaderMethodToggled";
    TABLE_ACTION["FIT_TO_CONTENT_AUTO_CONVERTED"] = "fitToContentAutoConverted";
    TABLE_ACTION["FIT_TO_CONTENT_ON_DEMAND"] = "fitToContentOnDemand";
    return TABLE_ACTION;
}({});
var $fa05b1e32f887e46$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $fa05b1e32f887e46$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $fa05b1e32f887e46$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $fa05b1e32f887e46$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $fa05b1e32f887e46$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});
module.exports["TABLE_ACTION"] = $fa05b1e32f887e46$export$1627223e090990cf;
module.exports["TABLE_OVERFLOW_CHANGE_TRIGGER"] = $fa05b1e32f887e46$export$e0b2ad636c1c8ab4;
module.exports["TABLE_STATUS"] = $fa05b1e32f887e46$export$90dde066fa32cf2f;
module.exports["TABLE_DISPLAY_MODE"] = $fa05b1e32f887e46$export$a62a68f32aa71693;
module.exports["CHANGE_ALIGNMENT_REASON"] = $fa05b1e32f887e46$export$ba2dfc055a59d951;

});

parcelRegister("3RxtY", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $75232df246e43c97$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    url: {
        id: "fabric.editor.url",
        defaultMessage: "Display URL"
    },
    block: {
        id: "fabric.editor.displayBlock",
        defaultMessage: "Display card"
    },
    inline: {
        id: "fabric.editor.displayInline",
        defaultMessage: "Display inline"
    },
    embed: {
        id: "fabric.editor.displayEmbed",
        defaultMessage: "Display embed"
    },
    link: {
        id: "fabric.editor.displayLink",
        defaultMessage: "Display as text"
    },
    card: {
        id: "fabric.editor.cardFloatingControls",
        defaultMessage: "Card options"
    },
    blockCardUnavailable: {
        id: "fabric.editor.blockCardUnavailable",
        defaultMessage: "The inline link is inside {node} and cannot have its view changed"
    },
    displayOptionUnavailableInParentNode: {
        id: "fabric.editor.displayOptionUnavailableInParentNode",
        defaultMessage: "This display option isn't available inside {node}"
    },
    urlTitle: {
        id: "fabric.editor.urlTitle",
        defaultMessage: "URL"
    },
    blockTitle: {
        id: "fabric.editor.blockTitle",
        defaultMessage: "Card"
    },
    inlineTitle: {
        id: "fabric.editor.inlineTitle",
        defaultMessage: "Inline"
    },
    openButtonTitle: {
        id: "fabric.editor.openButtonTitle",
        defaultMessage: "Open"
    },
    panelButtonTitle: {
        id: "fabric.editor.panelButtonTitle",
        defaultMessage: "Panel"
    },
    previewButtonTitle: {
        id: "fabric.editor.previewButtonTitle",
        defaultMessage: "Preview"
    },
    embedTitle: {
        id: "fabric.editor.embedTitle",
        defaultMessage: "Embed"
    },
    urlDescription: {
        id: "fabric.editor.urlDescription",
        defaultMessage: "Display link as URL"
    },
    blockDescription: {
        id: "fabric.editor.blockDescription",
        defaultMessage: "Display more information about a link, including a summary and actions"
    },
    inlineDescription: {
        id: "fabric.editor.inlineDescription",
        defaultMessage: "Display link as inline text"
    },
    embedDescription: {
        id: "fabric.editor.ecombedDescription",
        defaultMessage: "Display an interactive preview of a link"
    },
    embedToBlockCardWarning: {
        id: "fabric.editor.embedToBlockCardWarning",
        defaultMessage: "Displays as a card on small screens"
    },
    editDropdownExpandIconLabel: {
        id: "fabric.editor.editDropdownExpandIconLabel",
        defaultMessage: "Expand dropdown menu"
    },
    editDropdownTriggerTitle: {
        id: "fabric.editor.editDropdownTriggerTitle",
        defaultMessage: "Edit"
    },
    editDropdownEditLinkTitle: {
        id: "fabric.editor.editDropdownEditLinkTitle",
        defaultMessage: "Edit link"
    },
    editDropdownEditDatasourceTitle: {
        id: "fabric.editor.editDropdownEditDatasourceTitle",
        defaultMessage: "Edit search query"
    },
    datasourceTitle: {
        id: "fabric.editor.datasourceTitle",
        defaultMessage: "Edit search query"
    },
    datasourceAppearanceTitle: {
        id: "fabric.editor.datasourceAppearanceTitle",
        defaultMessage: "List"
    },
    datasourceJiraIssue: {
        id: "fabric.editor.datasource.jiraIssue",
        defaultMessage: "Jira Issues"
    },
    datasourceJiraIssueDescription: {
        id: "fabric.editor.datasource.jiraIssue.description",
        defaultMessage: "Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration."
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: "fabric.editor.datasource.assetsObjectsGeneralAvailability",
        defaultMessage: "Assets"
    },
    datasourceAssetsObjectsDescription: {
        id: "fabric.editor.datasource.assetsObjects.description",
        defaultMessage: "Insert objects from Assets in Jira Service Management with search and filtering"
    },
    inlineOverlay: {
        id: "fabric.editor.inlineOverlay",
        defaultMessage: "Configure"
    },
    inlineConfigureLink: {
        id: "fabric.editor.inlineConfigureLink",
        defaultMessage: "Configure link"
    },
    inlineGoToLink: {
        id: "fabric.editor.inlineGoToLink",
        defaultMessage: "Go to link"
    },
    datasourceConfluenceSearch: {
        id: "fabric.editor.datasource.confluenceSearch",
        defaultMessage: "Insert Confluence list"
    },
    datasourceConfluenceSearchDescription: {
        id: "fabric.editor.datasource.confluenceSearch.description",
        defaultMessage: "Insert list of search results from Confluence with enhanced search, filtering, and configuration."
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: "fabric.editor.datasource.jiraIssue.issue-term-refresh",
        defaultMessage: "Jira Work Items"
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: "fabric.editor.datasource.jiraIssue.description.issue-term-refresh",
        defaultMessage: "Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration."
    }
});
module.exports["messages"] = $75232df246e43c97$export$defe85febe8b728c;

});

parcelRegister("61p3e", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $aXWIB = parcelRequire("aXWIB");


var $hkTaH = parcelRequire("hkTaH");


var $ahUGI = parcelRequire("ahUGI");


var $5duTD = parcelRequire("5duTD");


var $eKkkY = parcelRequire("eKkkY");


var $2UWDO = parcelRequire("2UWDO");


var $7Rcde = parcelRequire("7Rcde");


var $f3NsY = parcelRequire("f3NsY");



var $fpEzC = parcelRequire("fpEzC");


var $ckqYV = parcelRequire("ckqYV");



var $9c6e5 = parcelRequire("9c6e5");


var $f8J4a = parcelRequire("f8J4a");


var $4HWgE = parcelRequire("4HWgE");


var $gVDfZ = parcelRequire("gVDfZ");


var $3RxtY = parcelRequire("3RxtY");


var $8aWkM = parcelRequire("8aWkM");


var $2zaaI = parcelRequire("2zaaI");


var $2CQVV = parcelRequire("2CQVV");


var $5Ilz2 = parcelRequire("5Ilz2");


var $ocPnd = parcelRequire("ocPnd");


var $agX1m = parcelRequire("agX1m");


var $1moKB = parcelRequire("1moKB");


var $l51YQ = parcelRequire("l51YQ");


var $2REsZ = parcelRequire("2REsZ");


var $c5kBY = parcelRequire("c5kBY");


var $lzn6v = parcelRequire("lzn6v");



var $jOP6v = parcelRequire("jOP6v");


var $2iuib = parcelRequire("2iuib");


var $hdkJi = parcelRequire("hdkJi");


var $fHFVT = parcelRequire("fHFVT");


var $02xUP = parcelRequire("02xUP");


var $ePpFN = parcelRequire("ePpFN");


var $iesbi = parcelRequire("iesbi");


var $e0nFU = parcelRequire("e0nFU");


var $dwl7L = parcelRequire("dwl7L");


var $b0RMS = parcelRequire("b0RMS");


var $3NvMe = parcelRequire("3NvMe");


var $1o1Zn = parcelRequire("1o1Zn");


var $5dODy = parcelRequire("5dODy");


var $kofef = parcelRequire("kofef");


var $808tb = parcelRequire("808tb");


var $gA3OZ = parcelRequire("gA3OZ");


var $fzXn1 = parcelRequire("fzXn1");



var $9dV3t = parcelRequire("9dV3t");



var $36Wvq = parcelRequire("36Wvq");

const $deed4682d9d46c57$var$_default_1 = (0, $aXWIB.defineMessages)({
    layoutFixedWidth: {
        id: "fabric.editor.layoutFixedWidth",
        defaultMessage: "Back to center"
    },
    layoutStateFixedWidth: {
        id: "fabric.editor.layoutStateFixedWidth",
        defaultMessage: "Centered"
    },
    layoutWide: {
        id: "fabric.editor.layoutWide",
        defaultMessage: "Go wide"
    },
    layoutStateWide: {
        id: "fabric.editor.layoutStateWide",
        defaultMessage: "Wide"
    },
    layoutFullWidth: {
        id: "fabric.editor.layoutFullWidth",
        defaultMessage: "Go full width"
    },
    layoutStateFullWidth: {
        id: "fabric.editor.layoutStateFullWidth",
        defaultMessage: "Full width"
    },
    alignImageRight: {
        id: "fabric.editor.alignImageRight",
        defaultMessage: "Align right"
    },
    alignImageCenter: {
        id: "fabric.editor.alignImageCenter",
        defaultMessage: "Align center"
    },
    alignImageLeft: {
        id: "fabric.editor.alignImageLeft",
        defaultMessage: "Align left"
    },
    delete: {
        id: "fabric.editor.delete",
        defaultMessage: "Delete"
    },
    remove: {
        id: "fabric.editor.remove",
        defaultMessage: "Remove"
    },
    removeEmoji: {
        id: "fabric.editor.removeEmoji",
        defaultMessage: "Remove emoji"
    },
    visit: {
        id: "fabric.editor.visit",
        defaultMessage: "Open link in a new window"
    },
    inviteToEditButtonTitle: {
        id: "fabric.editor.editMode.inviteToEditButton.title",
        defaultMessage: "Invite to edit"
    },
    saveButton: {
        id: "fabric.editor.saveButton",
        defaultMessage: "Save"
    },
    cancelButton: {
        id: "fabric.editor.cancelButton",
        defaultMessage: "Cancel"
    },
    taskList: {
        id: "fabric.editor.tooltip.taskList",
        defaultMessage: "an action item"
    },
    bulletList: {
        id: "fabric.editor.tooltip.bulletList",
        defaultMessage: "a list"
    },
    nestedExpand: {
        id: "fabric.editor.tooltip.nestedExpand",
        defaultMessage: "a nested expand"
    },
    decisionList: {
        id: "fabric.editor.tooltip.decisionList",
        defaultMessage: "a decision list"
    },
    defaultBlockNode: {
        id: "fabric.editor.tooltip.defaultBlockNode",
        defaultMessage: "a block node"
    },
    panel: {
        id: "fabric.editor.tooltip.blockPanel",
        defaultMessage: "a panel"
    },
    blockquote: {
        id: "fabric.editor.blockquote",
        defaultMessage: "a quote"
    },
    timeUpdated: {
        id: "fabric.editor.time.updated",
        defaultMessage: "Updated"
    },
    timeViewed: {
        id: "fabric.editor.time.viewed",
        defaultMessage: "Viewed"
    },
    timeAgo: {
        id: "fabric.editor.time.ago",
        defaultMessage: "ago"
    },
    copyToClipboard: {
        id: "fabric.editor.copyToClipboard",
        defaultMessage: "Copy"
    },
    copiedToClipboard: {
        id: "fabric.editor.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    viewMore: {
        id: "fabric.editor.overflowMenuViewMore",
        defaultMessage: "View more"
    },
    imageEdit: {
        id: "fabric.editor.imageEdit",
        defaultMessage: "Edit image"
    },
    error: {
        id: "fabric.editor.error.message.label",
        defaultMessage: "Error"
    },
    success: {
        id: "fabric.editor.success.message.label",
        defaultMessage: "Success"
    }
});
var $deed4682d9d46c57$export$2e2bcd8739ae039 = $deed4682d9d46c57$var$_default_1;
module.exports["default"] = $deed4682d9d46c57$export$2e2bcd8739ae039;

});

parcelRegister("hkTaH", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $e57f64ef4f7fa472$export$5229ffea355cfdf6 = (0, $aXWIB.defineMessages)({
    alignment: {
        id: "fabric.editor.alignment",
        defaultMessage: "Text alignment"
    },
    alignLeft: {
        id: "fabric.editor.alignLeft",
        defaultMessage: "Align left"
    },
    alignCenter: {
        id: "fabric.editor.alignCenter",
        defaultMessage: "Align center"
    },
    alignRight: {
        id: "fabric.editor.alignRight",
        defaultMessage: "Align right"
    }
});
module.exports["alignmentMessages"] = $e57f64ef4f7fa472$export$5229ffea355cfdf6;

});

parcelRegister("ahUGI", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $48c5e4b8bf27ceee$export$ff612ca71703201d = (0, $aXWIB.defineMessages)({
    createComment: {
        id: "fabric.editor.createComment",
        defaultMessage: "Comment"
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: "fabric.editor.createCommentInvalid",
        defaultMessage: "You can only comment on text and headings"
    },
    createCommentDisabled: {
        id: "fabric.editor.createCommentDisabled",
        defaultMessage: "You can only comment on text, headings, emojis, dates, mentions, links, and statuses."
    },
    // Duplicated by Confluence's
    // highlight-actions.inline-comments.comment.no.permission
    noPermissionToAddComment: {
        id: "fabric.editor.noPermissionToAddComment",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}"
    },
    toolbar: {
        id: "fabric.editor.annotationToolbar",
        defaultMessage: "Annotation toolbar"
    }
});
module.exports["annotationMessages"] = $48c5e4b8bf27ceee$export$ff612ca71703201d;

});

parcelRegister("5duTD", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d91c973aee84789e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    maxWidthLabel: {
        id: "fabric.editor.breakoutMaxWidthLabel",
        defaultMessage: "Max-width"
    },
    fullWidthLabel: {
        id: "fabric.editor.breakoutFullWidthLabel",
        defaultMessage: "Full-width"
    },
    wideWidthLabel: {
        id: "fabric.editor.breakoutWideWidthLabel",
        defaultMessage: "Wide"
    },
    resizeHandle: {
        id: "fabric.editor.resizeHandle",
        defaultMessage: "Resize handle"
    },
    resizeExpand: {
        id: "fabric.editor.breakout.resizeExpand",
        defaultMessage: "Resize expand"
    },
    resizeCodeBlock: {
        id: "fabric.editor.breakout.resizeCodeBlock",
        defaultMessage: "Resize code snippet"
    },
    resizeLayout: {
        id: "fabric.editor.breakout.resizeLayout",
        defaultMessage: "Resize layout"
    },
    resizeElement: {
        id: "fabric.editor.breakout.resizeElement",
        defaultMessage: "Resize element"
    },
    resizeRule: {
        id: "fabric.editor.breakout.resizeRule",
        defaultMessage: "Resize divider"
    },
    resizePanel: {
        id: "fabric.editor.breakout.resizePanel",
        defaultMessage: "Resize panel"
    }
});
module.exports["messages"] = $d91c973aee84789e$export$defe85febe8b728c;

});

parcelRegister("eKkkY", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1029fcd095daaf54$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    moveUpBlock: {
        id: "fabric.editor.block.menu.move.up",
        defaultMessage: "Move up"
    },
    moveDownBlock: {
        id: "fabric.editor.block.menu.move.down",
        defaultMessage: "Move down"
    },
    copy: {
        id: "fabric.editor.block.menu.copy",
        defaultMessage: "Copy"
    },
    copyLink: {
        id: "fabric.editor.block.menu.copy.link",
        defaultMessage: "Copy link"
    },
    copyLinkToSelection: {
        id: "fabric.editor.block.menu.copy.link.to.selection",
        defaultMessage: "Copy link to selection"
    },
    linkCopiedToClipboard: {
        id: "fabric.editor.block.menu.link.copied.to.clipboard",
        defaultMessage: "Link copied to clipboard"
    },
    paragraph: {
        id: "fabric.editor.block.menu.paragraph",
        defaultMessage: "Paragraph"
    },
    codeBlock: {
        id: "fabric.editor.block.menu.codeblock",
        defaultMessage: "Code block"
    },
    layout: {
        id: "fabric.editor.block.menu.layout",
        defaultMessage: "Layout"
    },
    deleteBlock: {
        id: "fabric.editor.block.menu.delete.block",
        defaultMessage: "Delete"
    },
    turnInto: {
        id: "fabric.editor.block.menu.turn.into",
        defaultMessage: "Turn into"
    },
    changeFormat: {
        id: "fabric.editor.block.menu.change.format",
        defaultMessage: "Change format"
    },
    syncBlock: {
        id: "fabric.editor.block.menu.sync.block",
        defaultMessage: "Sync block"
    },
    copySyncedBlock: {
        id: "fabric.editor.block.menu.copy.synced.block",
        defaultMessage: "Copy synced block"
    },
    newLozenge: {
        id: "fabric.editor.block.menu.new.lozenge",
        defaultMessage: "New"
    },
    decisionList: {
        id: "fabric.editor.block.menu.decision",
        defaultMessage: "Decision"
    },
    wrapIcon: {
        id: "fabric.editor.block.menu.wrap.icon",
        defaultMessage: "Wrap"
    },
    create: {
        id: "fabric.editor.block.menu.create",
        defaultMessage: "Create"
    },
    headings: {
        id: "fabric.editor.block.menu.headings",
        defaultMessage: "Headings"
    },
    suggested: {
        id: "fabric.editor.block.menu.suggested",
        defaultMessage: "Suggested"
    },
    structure: {
        id: "fabric.editor.block.menu.structure",
        defaultMessage: "Structure"
    },
    fallbackNestedMenu: {
        id: "fabric.editor.block.menu.fallback.nested.menu",
        defaultMessage: "Nested Menu"
    },
    fallbackMenuItem: {
        id: "fabric.editor.block.menu.fallback.menu.item",
        defaultMessage: "Block Menu Item"
    }
});
module.exports["messages"] = $1029fcd095daaf54$export$defe85febe8b728c;

});

parcelRegister("2UWDO", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1be454cb3ba0e245$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    normal: {
        id: "fabric.editor.normal",
        defaultMessage: "Normal text"
    },
    smallText: {
        id: "fabric.editor.smallText",
        defaultMessage: "Small text"
    },
    heading1: {
        id: "fabric.editor.heading1",
        defaultMessage: "Heading 1"
    },
    heading1Description: {
        id: "fabric.editor.heading1Description",
        defaultMessage: "Use this for a top level heading"
    },
    heading2: {
        id: "fabric.editor.heading2",
        defaultMessage: "Heading 2"
    },
    heading2Description: {
        id: "fabric.editor.heading2Description",
        defaultMessage: "Use this for key sections"
    },
    heading3: {
        id: "fabric.editor.heading3",
        defaultMessage: "Heading 3"
    },
    heading3Description: {
        id: "fabric.editor.heading3Description",
        defaultMessage: "Use this for sub sections and group headings"
    },
    heading4: {
        id: "fabric.editor.heading4",
        defaultMessage: "Heading 4"
    },
    heading4Description: {
        id: "fabric.editor.heading4Description",
        defaultMessage: "Use this for deep headings"
    },
    heading5: {
        id: "fabric.editor.heading5",
        defaultMessage: "Heading 5"
    },
    heading5Description: {
        id: "fabric.editor.heading5Description",
        defaultMessage: "Use this for grouping list items"
    },
    heading6: {
        id: "fabric.editor.heading6",
        defaultMessage: "Heading 6"
    },
    heading6Description: {
        id: "fabric.editor.heading6Description",
        defaultMessage: "Use this for low level headings"
    },
    blockquote: {
        id: "fabric.editor.blockquote2",
        defaultMessage: "Quote"
    },
    blockquoteDescription: {
        id: "fabric.editor.blockquote.description",
        defaultMessage: "Insert a quote or citation"
    },
    codeblock: {
        id: "fabric.editor.codeblock",
        defaultMessage: "Code snippet"
    },
    codeblockDescription: {
        id: "fabric.editor.codeblock.description",
        defaultMessage: "Display code with syntax highlighting"
    },
    infoPanel: {
        id: "fabric.editor.infoPanel",
        defaultMessage: "Info panel"
    },
    infoPanelDescription: {
        id: "fabric.editor.infoPanel.description",
        defaultMessage: "Highlight information in a colored panel"
    },
    notePanel: {
        id: "fabric.editor.notePanel",
        defaultMessage: "Note panel"
    },
    notePanelDescription: {
        id: "fabric.editor.notePanel.description",
        defaultMessage: "Add a note in a colored panel"
    },
    successPanel: {
        id: "fabric.editor.successPanel",
        defaultMessage: "Success panel"
    },
    successPanelDescription: {
        id: "fabric.editor.successPanel.description",
        defaultMessage: "Add tips in a colored panel"
    },
    warningPanel: {
        id: "fabric.editor.warningPanel",
        defaultMessage: "Warning panel"
    },
    warningPanelDescription: {
        id: "fabric.editor.warningPanel.description",
        defaultMessage: "Add a note of caution in a colored panel"
    },
    errorPanel: {
        id: "fabric.editor.errorPanel",
        defaultMessage: "Error panel"
    },
    errorPanelDescription: {
        id: "fabric.editor.errorPanel.description",
        defaultMessage: "Call out errors in a colored panel"
    },
    customPanel: {
        id: "fabric.editor.customPanel",
        defaultMessage: "Custom panel"
    },
    customPanelDescription: {
        id: "fabric.editor.customPanel.description",
        defaultMessage: "Add a note with an emoji and colored background"
    },
    syncedBlock: {
        id: "fabric.editor.syncedBlock",
        defaultMessage: "Create synced block"
    },
    syncBlock: {
        id: "fabric.editor.syncBlock",
        defaultMessage: "Sync block"
    },
    syncedBlockDescription: {
        id: "fabric.editor.syncedBlock.description",
        defaultMessage: "Sync content across multiple locations"
    },
    newLozenge: {
        id: "fabric.editor.quickinsert.new.lozenge",
        defaultMessage: "New"
    },
    panel: {
        id: "fabric.editor.panel",
        defaultMessage: "Panel"
    },
    other: {
        id: "fabric.editor.other",
        defaultMessage: "Others..."
    }
});
module.exports["messages"] = $1be454cb3ba0e245$export$defe85febe8b728c;

});

parcelRegister("f3NsY", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $750f4fc57425afd4$export$df1842193ff5ba1e = (0, $aXWIB.defineMessages)({
    accessibility: {
        id: "fabric.editor.color.accessibility.accessibility",
        defaultMessage: "Accessibility"
    },
    accessibleLabel: {
        id: "fabric.editor.color.accessibility.accessibleLabel",
        defaultMessage: "Accessible"
    },
    accessibleTooltip: {
        id: "fabric.editor.color.accessibility.accessibleTooltip",
        defaultMessage: "Accessible color combination"
    },
    difficultToReadLabel: {
        id: "fabric.editor.color.accessibility.difficultToReadLabel",
        defaultMessage: "Difficult to read"
    },
    difficultToReadTooltip: {
        id: "fabric.editor.color.accessibility.difficultToReadTooltip",
        defaultMessage: "This color combination has low contrast. Select a different color to improve legibility."
    },
    inaccessibleLabel: {
        id: "fabric.editor.color.accessibility.inaccessibleLabel",
        defaultMessage: "Inaccessible"
    },
    inaccessibleTooltip: {
        id: "fabric.editor.color.accessibility.inaccessibleTooltip",
        defaultMessage: "This color combination is hard to read. Select a different color to improve legibility."
    }
});
module.exports["colorAccessibilityMessages"] = $750f4fc57425afd4$export$df1842193ff5ba1e;

});

parcelRegister("fpEzC", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8b2a73d924c824ef$export$4ce3884394d6d9 = (0, $aXWIB.defineMessages)({
    openLink: {
        id: "fabric.editor.openLink",
        defaultMessage: "Open link in a new tab"
    },
    openPreviewPanel: {
        id: "fabric.editor.openPreviewPanel",
        defaultMessage: "Open preview panel"
    }
});
module.exports["linkMessages"] = $8b2a73d924c824ef$export$4ce3884394d6d9;

});

parcelRegister("ckqYV", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f9584a45f41233ef$export$2d7676d841c8ae9 = (0, $aXWIB.defineMessages)({
    addLink: {
        id: "fabric.editor.mediaAddLink",
        defaultMessage: "Add link"
    },
    unableToOpenLink: {
        id: "fabric.editor.unableToOpenLink",
        defaultMessage: "Unable to open this link"
    },
    unlink: {
        id: "fabric.editor.unlink",
        defaultMessage: "Unlink"
    },
    editDatasourceStandalone: {
        id: "fabric.editor.editDatasourceStandalone",
        defaultMessage: "Edit"
    },
    editDatasourceStandaloneTooltip: {
        id: "fabric.editor.editDatasourceStandaloneTooltip",
        defaultMessage: "Edit search query"
    },
    editLink: {
        id: "fabric.editor.editLink",
        defaultMessage: "Edit link"
    },
    placeholder: {
        id: "fabric.editor.hyperlinkToolbarPlaceholder",
        defaultMessage: "Paste or search for link"
    },
    linkPlaceholder: {
        id: "fabric.editor.linkPlaceholder",
        defaultMessage: "Paste link"
    },
    linkAddress: {
        id: "fabric.editor.linkAddress",
        defaultMessage: "Link address"
    },
    invalidLink: {
        id: "fabric.editor.invalidLink",
        defaultMessage: "Please enter a valid link."
    },
    emptyLink: {
        id: "fabric.editor.emptyLink",
        defaultMessage: "Please enter a link."
    },
    settingsLink: {
        id: "fabric.editor.settingsLinks",
        defaultMessage: "Go to Link Preferences"
    },
    preferencesLink: {
        id: "fabric.editor.preferencesLink",
        defaultMessage: "Link preferences"
    },
    editDatasource: {
        id: "fabric.editor.edit.datasource",
        defaultMessage: "Edit search query"
    },
    searchInput: {
        id: "fabric.editor.edit.searchInput",
        defaultMessage: "Add a link"
    }
});
module.exports["linkToolbarMessages"] = $f9584a45f41233ef$export$2d7676d841c8ae9;

});

parcelRegister("9c6e5", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $0195961b2f3a7fe2$export$8bd807073e2c6716 = (0, $aXWIB.defineMessages)({
    codeblockLanguageAriaDescription: {
        id: "fabric.editor.codeBlock.languageAriaDescription",
        defaultMessage: "Code snippet language: {language}."
    },
    codeBlockLanguageNotSet: {
        id: "fabric.editor.codeBlock.languageNotSet",
        defaultMessage: "Code language not set."
    }
});
module.exports["codeBlockMessages"] = $0195961b2f3a7fe2$export$8bd807073e2c6716;

});

parcelRegister("4HWgE", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8db99cec71546e3d$export$70c8a7203d95247 = (0, $aXWIB.defineMessages)({
    action: {
        id: "fabric.editor.action",
        defaultMessage: "Action item"
    },
    actionDescription: {
        id: "fabric.editor.action.description",
        defaultMessage: "Create and assign action items"
    },
    closeInsertRightRail: {
        id: "fabric.editor.insertRightRail.close",
        defaultMessage: "Close"
    },
    link: {
        id: "fabric.editor.link",
        defaultMessage: "Link"
    },
    linkDescription: {
        id: "fabric.editor.link.description",
        defaultMessage: "Insert a link"
    },
    mediaFiles: {
        id: "fabric.editor.mediaFiles",
        defaultMessage: "Image, video, or file"
    },
    addMediaFiles: {
        id: "fabric.editor.addMediaFiles",
        defaultMessage: "Add image, video, or file"
    },
    insertRightRailTitle: {
        id: "fabric.editor.insertRightRail.title",
        defaultMessage: "Insert"
    },
    mediaFilesDescription: {
        id: "fabric.editor.mediaFiles.description",
        defaultMessage: "Add images and other files to your page"
    },
    image: {
        id: "fabric.editor.image",
        defaultMessage: "Image"
    },
    aiImageGeneration: {
        id: "fabric.editor.aiImageGeneration",
        defaultMessage: "Generate image"
    },
    aiImageGenerationDescription: {
        id: "fabric.editor.aiImageGeneration.description",
        defaultMessage: "Generate an image with AI"
    },
    aiImageGenerationPopupAriaLabel: {
        id: "fabric.editor.aiImageGeneration.popupAriaLabel",
        defaultMessage: "Generate image with AI"
    },
    mention: {
        id: "fabric.editor.mention",
        defaultMessage: "Mention"
    },
    mentionDescription: {
        id: "fabric.editor.mention.description",
        defaultMessage: "Mention someone to send them a notification"
    },
    emoji: {
        id: "fabric.editor.emoji",
        defaultMessage: "Emoji"
    },
    emojiDescription: {
        id: "fabric.editor.emoji.description",
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04"
    },
    table: {
        id: "fabric.editor.table",
        defaultMessage: "Table"
    },
    tableDescription: {
        id: "fabric.editor.table.description",
        defaultMessage: "Insert a table"
    },
    tableSelector: {
        id: "fabric.editor.tableSelector",
        defaultMessage: "Table size"
    },
    tableSelectorDescription: {
        id: "fabric.editor.tableSelector.description",
        defaultMessage: "Add a table using popup to select a custom size"
    },
    tableSizeSelectorButton: {
        id: "fabric.editor.tableSizeSelectorButton",
        defaultMessage: "{numberOfColumns} by {numberOfRows}"
    },
    tableSizeSelectorPopup: {
        id: "fabric.editor.tableSizeSelectorPopup",
        defaultMessage: "Table size selector"
    },
    expand: {
        id: "fabric.editor.expand",
        defaultMessage: "Expand"
    },
    expandDescription: {
        id: "fabric.editor.expand.description",
        defaultMessage: "Insert an expand"
    },
    decision: {
        id: "fabric.editor.decision",
        defaultMessage: "Decision"
    },
    decisionDescription: {
        id: "fabric.editor.decision.description",
        defaultMessage: "Capture decisions so they're easy to track"
    },
    feedbackDialog: {
        id: "fabric.editor.feedbackDialog",
        defaultMessage: "Give feedback"
    },
    feedbackDialogDescription: {
        id: "fabric.editor.feedbackDialog.description",
        defaultMessage: "Tell us about your experience using the cloud editor"
    },
    horizontalRule: {
        id: "fabric.editor.horizontalRule",
        defaultMessage: "Divider"
    },
    horizontalRuleDescription: {
        id: "fabric.editor.horizontalRule.description",
        defaultMessage: "Separate content with a horizontal line"
    },
    date: {
        id: "fabric.editor.date",
        defaultMessage: "Date"
    },
    dateDescription: {
        id: "fabric.editor.date.description",
        defaultMessage: "Add a date using a calendar"
    },
    placeholderText: {
        id: "fabric.editor.placeholderText",
        defaultMessage: "Placeholder text"
    },
    placeholderTextDescription: {
        id: "fabric.editor.placeholderText.description",
        defaultMessage: "Insert a text placeholder into the page"
    },
    columns: {
        id: "fabric.editor.columns",
        defaultMessage: "Layouts"
    },
    columnsDescription: {
        id: "fabric.editor.columns.description",
        defaultMessage: "Structure your page using sections"
    },
    columnsDescriptionAdvancedLayout: {
        id: "fabric.editor.columns.advanced.layout.description",
        defaultMessage: "Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}"
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: "fabric.editor.columns.advanced.layout.single.description",
        defaultMessage: "Insert a single column layout"
    },
    status: {
        id: "fabric.editor.status",
        defaultMessage: "Status"
    },
    statusDescription: {
        id: "fabric.editor.status.description",
        defaultMessage: "Add a custom status label"
    },
    askRovo: {
        id: "fabric.editor.askRovo",
        defaultMessage: "Ask Rovo"
    },
    viewMore: {
        id: "fabric.editor.viewMore",
        defaultMessage: "View more"
    },
    viewMoreAriaLabel: {
        id: "fabric.editor.viewMoreAriaLabel",
        defaultMessage: "View all elements"
    },
    insertMenu: {
        id: "fabric.editor.insertMenu",
        defaultMessage: "Insert elements"
    },
    help: {
        id: "fabric.editor.help",
        defaultMessage: "Help"
    },
    helpDescription: {
        id: "fabric.editor.help.description",
        defaultMessage: "Browse all the keyboard shortcuts and markdown options"
    },
    recordVideo: {
        id: "fabric.editor.recordVideo",
        defaultMessage: "Record a Loom video"
    },
    addLoomVideo: {
        id: "fabric.editor.addLoomVideo",
        defaultMessage: "Record a Loom video"
    },
    addLoomVideoComment: {
        id: "fabric.editor.addLoomVideoComment",
        defaultMessage: "Record a Loom video comment"
    },
    recordVideoDescription: {
        id: "fabric.editor.recordVideo.description",
        defaultMessage: "Record and share your screen and thoughts"
    },
    recordLoomShortTitle: {
        id: "fabric.editor.recordLoomShortTitle",
        defaultMessage: "Record"
    },
    turnInto: {
        id: "fabric.editor.turnInto",
        defaultMessage: "Turn into"
    }
});
module.exports["toolbarInsertBlockMessages"] = $8db99cec71546e3d$export$70c8a7203d95247;

});

parcelRegister("gVDfZ", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $0889ec8859f0b4df$export$81b075fd34c2f0bb = (0, $aXWIB.defineMessages)({
    wrapLeft: {
        id: "fabric.editor.wrapLeft",
        defaultMessage: "Wrap left"
    },
    wrapRight: {
        id: "fabric.editor.wrapRight",
        defaultMessage: "Wrap right"
    },
    changeToMediaSingle: {
        id: "fabric.editor.media_change_mediasingle",
        defaultMessage: "Original size"
    },
    changeToMediaInlineImage: {
        id: "fabric.editor.media_change_mediainline_default",
        defaultMessage: "Inline"
    },
    changeToMediaInlineImageCaptionWarning: {
        id: "fabric.editor.media_change_mediainline_caption_warn",
        defaultMessage: "Inline (caption will be removed)"
    },
    replaceMedia: {
        id: "fabric.editor.media.replace.non-final",
        defaultMessage: "Replace"
    }
});
module.exports["toolbarMessages"] = $0889ec8859f0b4df$export$81b075fd34c2f0bb;

});

parcelRegister("8aWkM", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $a1c0ccc91a87c11c$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    toolbarLabel: {
        id: "fabric.editor.toolbarLabel",
        defaultMessage: "Editor"
    },
    pageActionsLabel: {
        id: "fabric.editor.pageActionsLabel",
        defaultMessage: "Page actions"
    },
    editableContentLabel: {
        id: "fabric.editor.editableContentLabel",
        defaultMessage: "Editable content"
    }
});
module.exports["messages"] = $a1c0ccc91a87c11c$export$defe85febe8b728c;

});

parcelRegister("2zaaI", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $09bc4db4179d16d9$export$81b075fd34c2f0bb = (0, $aXWIB.defineMessages)({
    underline: {
        id: "fabric.editor.underline",
        defaultMessage: "Underline"
    },
    strike: {
        id: "fabric.editor.strike",
        defaultMessage: "Strikethrough"
    },
    code: {
        id: "fabric.editor.code",
        defaultMessage: "Code"
    },
    codeOn: {
        id: "fabric.editor.code.on",
        defaultMessage: "{textFormattingOff}, Code On"
    },
    subscript: {
        id: "fabric.editor.subscript",
        defaultMessage: "Subscript"
    },
    subscriptOffSuperscriptOn: {
        id: "fabric.editor.subscript.off.superscript.on",
        defaultMessage: "Subscript Off, Superscript On"
    },
    superscript: {
        id: "fabric.editor.superscript",
        defaultMessage: "Superscript"
    },
    superscriptOffSubscriptOn: {
        id: "fabric.editor.superscript.off.subscript.on",
        defaultMessage: "Superscript Off, Subscript On"
    },
    clearFormatting: {
        id: "fabric.editor.clearFormatting",
        defaultMessage: "Clear formatting"
    },
    moreFormatting: {
        id: "fabric.editor.moreFormatting",
        defaultMessage: "More formatting"
    },
    textFormatting: {
        id: "fabric.editor.textFormatting",
        defaultMessage: "Text formatting"
    },
    textFormat: {
        id: "fabric.editor.textFormat",
        defaultMessage: "Format text"
    },
    bold: {
        id: "fabric.editor.bold",
        defaultMessage: "Bold"
    },
    italic: {
        id: "fabric.editor.italic",
        defaultMessage: "Italic"
    },
    on: {
        id: "fabric.editor.on",
        defaultMessage: "{formattingType} On"
    },
    off: {
        id: "fabric.editor.off",
        defaultMessage: "{formattingType} Off"
    },
    textStyles: {
        id: "fabric.editor.textStyles",
        defaultMessage: "{blockTypeName} Text styles"
    },
    textStylesTooltip: {
        id: "fabric.editor.textStylesTooltip",
        defaultMessage: "Text styles"
    },
    textFormattingOff: {
        id: "fabric.editor.text.formatting.off",
        defaultMessage: "Text formatting Off"
    },
    navigateToEditorToolbar: {
        id: "fabric.editor.navigate.toolbar.editor",
        defaultMessage: "Navigate to editor toolbar"
    },
    navigateToFloatingToolbar: {
        id: "fabric.editor.navigate.toolbar.floating",
        defaultMessage: "Navigate to floating toolbar"
    },
    askAI: {
        id: "fabric.editor.navigate.toolbar.askAI",
        defaultMessage: "Ask AI"
    },
    selectionToolbarOverflowMenuTooltip: {
        id: "fabric.editor.selectionToolbarOverflowMenuTooltip",
        defaultMessage: "More options"
    }
});
module.exports["toolbarMessages"] = $09bc4db4179d16d9$export$81b075fd34c2f0bb;

});

parcelRegister("5Ilz2", function(module, exports) {
// Common Translations will live here

var $aXWIB = parcelRequire("aXWIB");

const $068e62ba641eb2d0$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    unorderedList: {
        id: "fabric.editor.unorderedList",
        defaultMessage: "Bullet list"
    },
    unorderedListDescription: {
        id: "fabric.editor.unorderedList.description",
        defaultMessage: "Create an unordered list"
    },
    bulletedList: {
        id: "fabric.editor.bulletedList",
        defaultMessage: "Bulleted list"
    },
    orderedList: {
        id: "fabric.editor.orderedList",
        defaultMessage: "Numbered list"
    },
    orderedListDescription: {
        id: "fabric.editor.orderedList.description",
        defaultMessage: "Create an ordered list"
    },
    lists: {
        id: "fabric.editor.lists",
        defaultMessage: "Lists"
    },
    listsFormat: {
        id: "fabric.editor.listsFormat",
        defaultMessage: "List formatting"
    }
});
module.exports["messages"] = $068e62ba641eb2d0$export$defe85febe8b728c;

});

parcelRegister("ocPnd", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $fdd67bada3df875e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    undo: {
        id: "fabric.editor.undo",
        defaultMessage: "Undo"
    },
    redo: {
        id: "fabric.editor.redo",
        defaultMessage: "Redo"
    }
});
module.exports["messages"] = $fdd67bada3df875e$export$defe85febe8b728c;

});

parcelRegister("agX1m", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $999917ff18060c14$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    statusEditorLabel: {
        id: "fabric.editor.statusEditorLabel",
        defaultMessage: "Status editor"
    },
    placeholder: {
        id: "fabric.editor.statusPlaceholder",
        defaultMessage: "Set a status"
    },
    editText: {
        id: "fabric.editor.editStatusText",
        defaultMessage: "Edit Status"
    },
    editColor: {
        id: "fabric.editor.editStatusColor",
        defaultMessage: "Edit Status Color"
    },
    statusPickerOpenedAlert: {
        id: "fabric.editor.statusPickerOpenedAlert",
        defaultMessage: "Status editor popup opened, press Tab to access popup"
    }
});
module.exports["messages"] = $999917ff18060c14$export$defe85febe8b728c;

});

parcelRegister("1moKB", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1cc68e0c29594f76$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    editText: {
        id: "fabric.editor.editDateText",
        defaultMessage: "Edit Date"
    },
    invalidDateError: {
        id: "fabric.editor.invalidDateError",
        defaultMessage: "Enter a valid date"
    },
    onKeyUpDownText: {
        id: "fabric.editor.upDown",
        defaultMessage: "On the use of up and down arrow keys into the following input field, the date will update below"
    },
    datePickerOpenedAlert: {
        id: "fabric.editor.datePickerOpenedAlert",
        defaultMessage: "Date editor popup opened, press Tab to access popup"
    }
});
module.exports["messages"] = $1cc68e0c29594f76$export$defe85febe8b728c;

});

parcelRegister("l51YQ", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d073017558d077cd$export$81b075fd34c2f0bb = (0, $aXWIB.defineMessages)({
    singleColumn: {
        id: "fabric.editor.single",
        defaultMessage: "Single column layout"
    },
    twoColumns: {
        id: "fabric.editor.twoColumns",
        defaultMessage: "Two columns layout"
    },
    singleColumnAdvancedLayout: {
        id: "fabric.editor.singleColumns",
        defaultMessage: "1 Column layout"
    },
    twoColumnsAdvancedLayout: {
        id: "fabric.editor.twoColumns",
        defaultMessage: "2 Column layout"
    },
    threeColumns: {
        id: "fabric.editor.threeColumns",
        defaultMessage: "Three columns layout"
    },
    threeColumnsAdvancedLayout: {
        id: "fabric.editor.threeColumns",
        defaultMessage: "3 Column layout"
    },
    fourColumns: {
        id: "fabric.editor.fourColumns",
        defaultMessage: "4 Column layout"
    },
    fiveColumns: {
        id: "fabric.editor.fiveColumns",
        defaultMessage: "5 Column layout"
    },
    rightSidebar: {
        id: "fabric.editor.rightSidebar",
        defaultMessage: "Right sidebar layout"
    },
    leftSidebar: {
        id: "fabric.editor.leftSidebar",
        defaultMessage: "Left sidebar layout"
    },
    threeColumnsWithSidebars: {
        id: "fabric.editor.threeColumnsWithSidebars",
        defaultMessage: "Three columns with sidebars layout"
    },
    threeColumnsWithLeftSidebars: {
        id: "fabric.editor.threeColumnsWithLeftSidebars",
        defaultMessage: "Three columns with left sidebar layout"
    },
    threeColumnsWithRightSidebars: {
        id: "fabric.editor.threeColumnsWithRightSidebars",
        defaultMessage: "Three columns with right sidebar layout"
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: "fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel",
        defaultMessage: "Layout options"
    },
    layoutPlaceholder: {
        id: "fabric.editor.layout.placeholder",
        defaultMessage: "Add content"
    },
    controlslayoutPlaceholder: {
        id: "fabric.editor.layout.controls.placeholder",
        defaultMessage: "/ to insert"
    },
    columnOption: {
        id: "fabric.editor.layout.columnOption",
        defaultMessage: "{count, plural, one {{count} Column} other {{count} Columns}}"
    },
    resizeLayout: {
        id: "fabric.editor.layout.resizeLayout",
        defaultMessage: "Resize layout"
    },
    distributeColumns: {
        id: "fabric.editor.layout.distributeColumns",
        defaultMessage: "Distribute columns"
    },
    addColumnLeft: {
        id: "fabric.editor.layout.addColumnLeft",
        defaultMessage: "Add column left"
    },
    addColumnRight: {
        id: "fabric.editor.layout.addColumnRight",
        defaultMessage: "Add column right"
    },
    insertColumnLeft: {
        id: "fabric.editor.layout.insertColumnLeft",
        defaultMessage: "Insert column left"
    },
    insertColumnRight: {
        id: "fabric.editor.layout.insertColumnRight",
        defaultMessage: "Insert column right"
    },
    alignColumn: {
        id: "fabric.editor.layout.alignColumn",
        defaultMessage: "Alignment"
    },
    alignColumnTop: {
        id: "fabric.editor.layout.alignColumnTop",
        defaultMessage: "Top"
    },
    alignColumnMiddle: {
        id: "fabric.editor.layout.alignColumnMiddle",
        defaultMessage: "Center"
    },
    alignColumnBottom: {
        id: "fabric.editor.layout.alignColumnBottom",
        defaultMessage: "Bottom"
    },
    deleteColumn: {
        id: "fabric.editor.layout.deleteColumn",
        defaultMessage: "{count, plural, one {Delete column} other {Delete columns}}"
    }
});
module.exports["toolbarMessages"] = $d073017558d077cd$export$81b075fd34c2f0bb;

});

parcelRegister("2REsZ", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $def49925be501c72$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    indent: {
        id: "fabric.editor.indent",
        defaultMessage: "Indent"
    },
    outdent: {
        id: "fabric.editor.outdent",
        defaultMessage: "Outdent"
    }
});
module.exports["messages"] = $def49925be501c72$export$defe85febe8b728c;

});

parcelRegister("c5kBY", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $42b8e02e0568f6fb$export$8a0e7c3f8f5b8868 = (0, $aXWIB.defineMessages)({
    editors: {
        id: "fabric.editor.editors",
        defaultMessage: "Editors"
    },
    anonymousCollaborator: {
        id: "fabric.editor.anonymous-collaborator",
        defaultMessage: "Anonymous collaborator"
    }
});
module.exports["avatarGroupMessages"] = $42b8e02e0568f6fb$export$8a0e7c3f8f5b8868;

});

parcelRegister("lzn6v", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $754e59d9d4a5571d$export$b46a930e1a386b2e = (0, $aXWIB.defineMessages)({
    find: {
        id: "fabric.editor.find",
        defaultMessage: "Find"
    },
    matchCase: {
        id: "fabric.editor.matchCase",
        defaultMessage: "Match case"
    },
    findNext: {
        id: "fabric.editor.findNext",
        defaultMessage: "Find next"
    },
    findPrevious: {
        id: "fabric.editor.findPrevious",
        defaultMessage: "Find previous"
    },
    findReplaceDialogAriaLabel: {
        id: "fabric.editor.findReplaceDialogAriaLabel",
        defaultMessage: "Find and Replace"
    },
    closeFindReplaceDialog: {
        id: "fabric.editor.closeFindReplaceDialog",
        defaultMessage: "Close"
    },
    noResultsFound: {
        id: "fabric.editor.noResultsFound",
        defaultMessage: "No results"
    },
    resultsCount: {
        id: "fabric.editor.resultsCount",
        defaultMessage: "{selectedMatchPosition} of {totalResultsCount}"
    },
    findReplaceToolbarButton: {
        id: "fabric.editor.findReplaceToolbarButton",
        defaultMessage: "Find and replace"
    },
    replaceWith: {
        id: "fabric.editor.replaceWith",
        defaultMessage: "Replace with"
    },
    replace: {
        id: "fabric.editor.replace",
        defaultMessage: "Replace"
    },
    replaceAll: {
        id: "fabric.editor.replaceAll",
        defaultMessage: "Replace all"
    },
    replaceSuccess: {
        id: "fabric.editor.replaceSuccess",
        defaultMessage: "{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}"
    }
});
module.exports["findReplaceMessages"] = $754e59d9d4a5571d$export$b46a930e1a386b2e;

});

parcelRegister("jOP6v", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $360b616eee27c764$export$effb4ee8b6f74abe = (0, $aXWIB.defineMessages)({
    textColor: {
        id: "fabric.editor.textColor",
        defaultMessage: "{selectedColorName} Text color"
    },
    textColorTooltip: {
        id: "fabric.editor.textColorTooltip",
        defaultMessage: "Text color"
    },
    textColorHighlightTooltip: {
        id: "fabric.editor.textColorHighlightTooltip",
        defaultMessage: "Text and highlight color"
    }
});
module.exports["textColorMessages"] = $360b616eee27c764$export$effb4ee8b6f74abe;

});

parcelRegister("2iuib", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $924758c132d4c526$export$273d864e9e6d0b1f = (0, $aXWIB.defineMessages)({
    taskPlaceholder: {
        id: "fabric.editor.taskPlaceholder",
        defaultMessage: "Type your action, use '@' to assign to someone."
    },
    decisionPlaceholder: {
        id: "fabric.editor.decisionPlaceholder",
        defaultMessage: "Add a decision\u2026"
    },
    editAccessTitle: {
        id: "fabric.editor.editAccessTitle",
        defaultMessage: "You need edit access"
    },
    requestToEditDescription: {
        id: "fabric.editor.requestToEditDescription",
        defaultMessage: "When you request access, the page owner will receive a notification."
    },
    requestToEdit: {
        id: "fabric.editor.requestToEdit",
        defaultMessage: "Request to edit"
    },
    dismiss: {
        id: "fabric.editor.requestToEditDismiss",
        defaultMessage: "Dismiss"
    },
    markTaskAsCompleted: {
        id: "fabric.editor.taskDecision.markTaskAsCompleted",
        defaultMessage: "Mark task as completed"
    },
    markTaskAsNotCompleted: {
        id: "fabric.editor.taskDecision.markTaskAsNotCompleted",
        defaultMessage: "Mark task as not completed"
    },
    taskList: {
        id: "fabric.editor.taskList",
        defaultMessage: "Task list"
    },
    decisionAriaLabel: {
        id: "fabric.editor.decisionAriaLabel",
        defaultMessage: "Decision"
    },
    undefinedDecisionAriaLabel: {
        id: "fabric.editor.undefinedDecisionAriaLabel",
        defaultMessage: "Undefined decision"
    }
});
module.exports["tasksAndDecisionsMessages"] = $924758c132d4c526$export$273d864e9e6d0b1f;

});

parcelRegister("hdkJi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $18e8afe4cc6854a5$export$ee8ab8a034b5a8bd = (0, $aXWIB.defineMessages)({
    placeholderTextPlaceholder: {
        id: "fabric.editor.placeholderTextPlaceholder",
        defaultMessage: "Add placeholder text"
    },
    shortEmptyNodePlaceholderText: {
        id: "fabric.editor.shortEmptyNodePlaceholderText",
        defaultMessage: "/ to insert"
    },
    shortEmptyNodePlaceholderADFSlashShortcut: {
        id: "fabric.editor.shortEmptyNodePlaceholderSlash",
        defaultMessage: "/"
    },
    shortEmptyNodePlaceholderADFSuffix: {
        id: "fabric.editor.shortEmptyNodePlaceholderSuffix",
        defaultMessage: " to insert"
    },
    longEmptyNodePlaceholderText: {
        id: "fabric.editor.longEmptyNodePlaceholderText",
        defaultMessage: "Type / to insert elements"
    },
    longEmptyNodePlaceholderADFPrefix: {
        id: "fabric.editor.longEmptyNodePlaceholderPrefix",
        defaultMessage: "Type "
    },
    longEmptyNodePlaceholderADFSlashShortcut: {
        id: "fabric.editor.longEmptyNodePlaceholderSlash",
        defaultMessage: "/"
    },
    longEmptyNodePlaceholderADFSuffix: {
        id: "fabric.editor.longEmptyNodePlaceholderSuffix",
        defaultMessage: " to insert elements"
    },
    sourceSyncBlockPlaceholderText: {
        id: "fabric.editor.sourceSyncBlockPlaceholderText",
        defaultMessage: "Add content you want to reuse. Copy and paste this block to sync in other locations."
    }
});
module.exports["placeholderTextMessages"] = $18e8afe4cc6854a5$export$ee8ab8a034b5a8bd;

});

parcelRegister("fHFVT", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $be64ff90a26bb531$export$703e803e9cb0cea4 = (0, $aXWIB.defineMessages)({
    pasteOptions: {
        id: "fabric.editor.pasteOptions",
        defaultMessage: "Paste options"
    },
    plainText: {
        id: "fabric.editor.plainText",
        defaultMessage: "Use plain text"
    },
    markdown: {
        id: "fabric.editor.useMarkdown",
        defaultMessage: "Use Markdown"
    },
    richText: {
        id: "fabric.editor.richText",
        defaultMessage: "Use rich text"
    },
    plainTextAction: {
        id: "fabric.editor.plainTextAction",
        defaultMessage: "Plain text"
    },
    markdownAction: {
        id: "fabric.editor.useMarkdownAction",
        defaultMessage: "Markdown"
    },
    richTextAction: {
        id: "fabric.editor.richTextAction",
        defaultMessage: "Rich text"
    },
    pasteMenuActionsTitle: {
        id: "fabric.editor.pasteMenuActionsTitle",
        defaultMessage: "Paste actions"
    },
    pasteMenuActionsPasteAs: {
        id: "fabric.editor.pasteMenuActionsPasteAs",
        defaultMessage: "Paste as"
    }
});
module.exports["pasteOptionsToolbarMessages"] = $be64ff90a26bb531$export$703e803e9cb0cea4;

});

parcelRegister("02xUP", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $32a348785e1147ed$export$7bb18eb6f9170174 = (0, $aXWIB.defineMessages)({
    info: {
        id: "fabric.editor.info",
        defaultMessage: "Info"
    },
    note: {
        id: "fabric.editor.note",
        defaultMessage: "Note"
    },
    success: {
        id: "fabric.editor.success",
        defaultMessage: "Success"
    },
    warning: {
        id: "fabric.editor.warning",
        defaultMessage: "Warning"
    },
    error: {
        id: "fabric.editor.error",
        defaultMessage: "Error"
    },
    emoji: {
        id: "fabric.editor.panel.emoji",
        defaultMessage: "Add emoji"
    },
    custom: {
        id: "fabric.editor.panel.custom",
        defaultMessage: "Custom"
    },
    backgroundColor: {
        id: "fabric.editor.panel.backgroundColor",
        defaultMessage: "Background color"
    },
    panelsGroup: {
        id: "fabric.editor.panel.panelsGroup",
        defaultMessage: "Panel Types"
    }
});
module.exports["panelMessages"] = $32a348785e1147ed$export$7bb18eb6f9170174;

});

parcelRegister("ePpFN", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $13a2e5f08644d69c$export$33aafd5ccbbbd00a = (0, $aXWIB.defineMessages)({
    inviteItemTitle: {
        id: "fabric.editor.inviteItem.title",
        defaultMessage: "{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}"
    },
    mentionsAddLabel: {
        id: "fabric.editor.mentionsAddLabel",
        defaultMessage: "add-icon"
    },
    mentionsIconLabel: {
        id: "fabric.editor.mentionsIconLabel",
        defaultMessage: "Mention"
    },
    mentionsNodeLabel: {
        id: "fabric.editor.mentionNode.label",
        defaultMessage: "Tagged user"
    },
    unknownLabel: {
        id: "fabric.editor.unknown.label",
        defaultMessage: "Unknown"
    },
    inviteTeammateInvalidEmail: {
        id: "fabric.editor.inviteItem.invalidEmail",
        defaultMessage: "Enter a valid email address"
    },
    sendInvite: {
        id: "fabric.editor.inviteItem.sendInvite",
        defaultMessage: "Send request to invite teammate"
    },
    inviteButton: {
        id: "fabric.editor.inviteItem.inviteButton",
        defaultMessage: "Invite"
    },
    typeAheadSectionPeople: {
        id: "fabric.editor.typeAhead.mentionSection.people",
        defaultMessage: "People"
    },
    typeAheadSectionAgents: {
        id: "fabric.editor.typeAhead.mentionSection.agents",
        defaultMessage: "Agents"
    },
    typeAheadSectionAgentsLabsLozengeLabel: {
        id: "editor-common.messages.mentions.typeAheadSectionAgentsLabsLozengeLabel",
        defaultMessage: "Labs"
    }
});
module.exports["mentionMessages"] = $13a2e5f08644d69c$export$33aafd5ccbbbd00a;

});

parcelRegister("iesbi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b210df4a90d17f4b$export$83c85447c71428ba = (0, $aXWIB.defineMessages)({
    editorHelp: {
        id: "fabric.editor.editorHelp",
        defaultMessage: "Editor help"
    },
    helpDialogTips: {
        id: "fabric.editor.helpDialogTips",
        defaultMessage: "Press {keyMap} to quickly open this dialog at any time"
    },
    keyboardShortcuts: {
        id: "fabric.editor.keyboardShortcuts",
        defaultMessage: "Keyboard shortcuts"
    },
    markdown: {
        id: "fabric.editor.markdown",
        defaultMessage: "Markdown"
    },
    pastePlainText: {
        id: "fabric.editor.pastePlainText",
        defaultMessage: "Paste plain text"
    },
    CheckUncheckActionItem: {
        id: "fabric.editor.checkUncheckActionItem",
        defaultMessage: "Toggle action item"
    },
    InsertTableColumn: {
        id: "fabric.editor.insertTableColumn",
        defaultMessage: "Insert table column"
    },
    InsertTableRow: {
        id: "fabric.editor.insertTableRow",
        defaultMessage: "Insert table row"
    },
    altText: {
        id: "fabric.editor.altText",
        defaultMessage: "Alt text"
    },
    selectTableRow: {
        id: "fabric.editor.selectTableRow",
        defaultMessage: "Select table row"
    },
    selectTableColumn: {
        id: "fabric.editor.selectTableColumn",
        defaultMessage: "Select table column"
    },
    selectColumnResize: {
        id: "fabric.editor.selectColumnResize",
        defaultMessage: "Select column resize"
    },
    increaseSize: {
        id: "fabric.editor.increaseSize",
        defaultMessage: "Increase table or media size"
    },
    increaseElementSize: {
        id: "fabric.editor.increaseElementSize",
        defaultMessage: "Increase element size"
    },
    decreaseSize: {
        id: "fabric.editor.decreaseSize",
        defaultMessage: "Decrease table or media size"
    },
    decreaseElementSize: {
        id: "fabric.editor.decreaseElementSize",
        defaultMessage: "Decrease element size"
    },
    openCellOptions: {
        id: "fabric.editor.openCellOptions",
        defaultMessage: "Open cell options"
    },
    focusTableResizeHandle: {
        id: "fabric.editor.focusTableResizeHandle",
        defaultMessage: "Focus table resize handle"
    },
    selectDragHandle: {
        id: "fabric.editor.selectDragHandle",
        defaultMessage: "Select drag handle"
    },
    moveSelectionUp: {
        id: "fabric.editor.moveSelectionUp",
        defaultMessage: "Move selection up"
    },
    moveSelectionDown: {
        id: "fabric.editor.moveSelectionDown",
        defaultMessage: "Move selection down"
    },
    moveSelectionLeft: {
        id: "fabric.editor.moveSelectionLeft",
        defaultMessage: "Move selection left"
    },
    moveSelectionRight: {
        id: "fabric.editor.moveSelectionRight",
        defaultMessage: "Move selection right"
    },
    closeHelpDialog: {
        id: "fabric.editor.closeHelpDialog",
        defaultMessage: "Close help dialog"
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: "fabric.editor.quickInsert",
        defaultMessage: "Quick insert"
    },
    highlightColor: {
        id: "fabric.editor.highlightColor",
        defaultMessage: "Toggle highlight color palette"
    }
});
module.exports["helpDialogMessages"] = $b210df4a90d17f4b$export$83c85447c71428ba;

});

parcelRegister("e0nFU", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $55d7177264572689$export$456100c8374b6011 = (0, $aXWIB.defineMessages)({
    clearColors: {
        id: "fabric.editor.highlight.clearColors",
        defaultMessage: "Clear all colors"
    },
    highlight: {
        id: "fabric.editor.highlight",
        defaultMessage: "Highlight color"
    },
    highlightFloatingToolbar: {
        id: "fabric.editor.highlightFloatingToolbar",
        defaultMessage: "Highlight"
    },
    removeColor: {
        id: "fabric.editor.highlight.removeColor",
        defaultMessage: "Remove color"
    },
    removeHighlight: {
        id: "fabric.editor.highlight.removeHighlight",
        defaultMessage: "Remove highlight"
    }
});
module.exports["highlightMessages"] = $55d7177264572689$export$456100c8374b6011;

});

parcelRegister("dwl7L", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $57e7b00f8aef02d8$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    dragToMove: {
        id: "fabric.editor.blockControlDragHandleMove",
        defaultMessage: "Drag to move"
    },
    dragToMoveClickToOpen: {
        id: "fabric.editor.blockControlDragHandleMoveOrOpen",
        defaultMessage: "Drag to move {br} Click to open menu"
    },
    dragToRearrange: {
        id: "fabric.editor.blockControlDragHandleRearrange",
        defaultMessage: "Drag to rearrange"
    },
    insert: {
        id: "fabric.editor.blockControlInsert",
        defaultMessage: "Insert"
    },
    moveUp: {
        id: "fabric.editor.blockControlMoveUp",
        defaultMessage: "Move up"
    },
    moveDown: {
        id: "fabric.editor.blockControlMoveDown",
        defaultMessage: "Move down"
    },
    movedup: {
        id: "fabric.editor.blockControlMovedUp",
        defaultMessage: "Content has been moved up"
    },
    movedDown: {
        id: "fabric.editor.blockControlMovedDown",
        defaultMessage: "Content has been moved down"
    },
    moveLeft: {
        id: "fabric.editor.blockControlMoveLeft",
        defaultMessage: "Move left"
    },
    moveRight: {
        id: "fabric.editor.blockControlMoveRight",
        defaultMessage: "Move right"
    },
    delete: {
        id: "fabric.editor.blockControlDelete",
        defaultMessage: "Delete"
    }
});
module.exports["messages"] = $57e7b00f8aef02d8$export$defe85febe8b728c;

});

parcelRegister("b0RMS", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $385543ae0341715d$export$7eb9dc59242bbc45 = (0, $aXWIB.defineMessages)({
    loadPreview: {
        id: "fabric.editor.media.insert.loadPreview",
        defaultMessage: "Load preview"
    },
    insert: {
        id: "fabric.editor.media.insert.insert",
        defaultMessage: "Insert"
    },
    pasteLinkToUpload: {
        id: "fabric.editor.media.insert.pasteLinkToUpload",
        defaultMessage: "Paste link to upload"
    },
    cancel: {
        id: "fabric.editor.media.insert.cancel",
        defaultMessage: "Cancel"
    },
    fromUrlErrorMessage: {
        id: "fabric.editor.media.insert.fromUrlErrorMessage",
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page."
    },
    fromUrlWarning: {
        id: "fabric.editor.media.insert.fromUrlWarning",
        defaultMessage: "This image might not be visible to others due to source restrictions. Consider uploading the file instead."
    },
    localFileNetworkErrorMessage: {
        id: "fabric.editor.media.insert.localFileNetworkErrorMessage",
        defaultMessage: "File upload error. Check file path or network."
    },
    localFileErrorMessage: {
        id: "fabric.editor.media.insert.localFileErrorMessage",
        defaultMessage: "This file couldn\u2019t be uploaded."
    },
    mediaAlt: {
        id: "fabric.editor.media.insert.mediaAlt",
        defaultMessage: "Preview for uploaded image or video file"
    },
    upload: {
        id: "fabric.editor.media.insert.upload",
        defaultMessage: "Upload"
    },
    linkTabTitle: {
        id: "fabric.editor.media.insert.linkTabTitle",
        defaultMessage: "Link"
    },
    fileTabTitle: {
        id: "fabric.editor.media.insert.fileTabTitle",
        defaultMessage: "File"
    },
    generateTabTitle: {
        id: "fabric.editor.media.insert.generateTabTitle",
        defaultMessage: "Create"
    },
    mediaPickerPopupAriaLabel: {
        id: "fabric.editor.media.insert.mediaPickerPopupAriaLabel",
        defaultMessage: "Media picker"
    },
    invalidUrlErrorMessage: {
        id: "fabric.editor.media.insert.invalidUrlErrorMessage",
        defaultMessage: "Invalid link"
    },
    uploadTabTitle: {
        id: "fabric.editor.media.insert.uploadTabTitle",
        defaultMessage: "Upload"
    },
    chooseFile: {
        id: "fabric.editor.media.insert.chooseFile",
        defaultMessage: "Choose a file"
    }
});
module.exports["mediaInsertMessages"] = $385543ae0341715d$export$7eb9dc59242bbc45;

});

parcelRegister("3NvMe", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b80caa4a3ffee1b9$export$423a6caa00ac48ec = (0, $aXWIB.defineMessages)({
    aspectRatioSelectionOriginal: {
        id: "editor.imageEditor.aspectRatio.original",
        defaultMessage: "Original"
    },
    aspectRatioSelectionCustom: {
        id: "editor.imageEditor.aspectRatio.custom",
        defaultMessage: "Custom"
    },
    aspectRatioSelectionSquare: {
        id: "editor.imageEditor.aspectRatio.square",
        defaultMessage: "Square"
    },
    aspectRatioSelectionCircle: {
        id: "editor.imageEditor.aspectRatio.circle",
        defaultMessage: "Circle"
    },
    aspectRatioSelectionLandscape: {
        id: "editor.imageEditor.aspectRatio.landscape",
        defaultMessage: "Landscape"
    },
    aspectRatioSelectionPortrait: {
        id: "editor.imageEditor.aspectRatio.portrait",
        defaultMessage: "Portrait"
    },
    aspectRatioSelectionWide: {
        id: "editor.imageEditor.aspectRatio.wide",
        defaultMessage: "Wide"
    },
    squareButton: {
        id: "editor.imageEditor.aspectRatio.squareButton",
        defaultMessage: "Square 1:1"
    },
    circleButton: {
        id: "editor.imageEditor.aspectRatio.circleButton",
        defaultMessage: "Circle 1:1"
    },
    landscapeButton: {
        id: "editor.imageEditor.aspectRatio.landscapeButton",
        defaultMessage: "Landscape 4:3"
    },
    portraitButton: {
        id: "editor.imageEditor.aspectRatio.portraitButton",
        defaultMessage: "Portrait 3:4"
    },
    wideButton: {
        id: "editor.imageEditor.aspectRatio.wideButton",
        defaultMessage: "Wide 16:9"
    },
    cancelButton: {
        id: "editor.imageEditor.cancel",
        defaultMessage: "Cancel"
    },
    doneButton: {
        id: "editor.imageEditor.done",
        defaultMessage: "Done"
    },
    savingButton: {
        id: "editor.imageEditor.saving",
        defaultMessage: "Saving..."
    }
});
module.exports["mediaEditingMessages"] = $b80caa4a3ffee1b9$export$423a6caa00ac48ec;

});

parcelRegister("1o1Zn", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $faa277178071abe8$export$6bc8062c04c761fa = (0, $aXWIB.defineMessages)({
    selectionExtensionDropdownButtonLabel: {
        id: "fabric.editor.selectionExtensionDropdownButtonLabel",
        defaultMessage: "Select app"
    },
    externalExtensionsHeading: {
        id: "fabric.editor.externalExtensionsHeading",
        defaultMessage: "Apps"
    }
});
module.exports["selectionExtensionMessages"] = $faa277178071abe8$export$6bc8062c04c761fa;

});

parcelRegister("5dODy", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $bb7725b6f12abdeb$export$b0226831bf5c0d3e = (0, $aXWIB.defineMessages)({
    toolbarAppears: {
        id: "fabric.editor.toolbarAppears",
        defaultMessage: "Toolbar appears"
    },
    toolbarPositionInline: {
        id: "fabric.editor.toolbarPositionInline",
        defaultMessage: "In-line with text"
    },
    toolbarPositionFixedAtTop: {
        id: "fabric.editor.toolbarPositionFixedAtTop",
        defaultMessage: "Fixed at top"
    },
    toolbarPositionUnpined: {
        id: "fabric.editor.toolbarPositionUnpined",
        defaultMessage: "Pin the toolbar at the top"
    },
    toolbarPositionPinedAtTop: {
        id: "fabric.editor.toolbarPositionPinedAtTop",
        defaultMessage: "Unpin the toolbar"
    },
    toolbarPositionUnpinnedConcise: {
        id: "fabric.editor.toolbarPositionUnpinnedConcise",
        defaultMessage: "Pin toolbar to top"
    }
});
module.exports["selectionToolbarMessages"] = $bb7725b6f12abdeb$export$b0226831bf5c0d3e;

});

parcelRegister("kofef", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $81a4f62f6d4935be$export$8ea7f7e979b71fa5 = (0, $aXWIB.defineMessages)({
    panelLabel: {
        id: "fabric.editor.contextPanel.panelLabel",
        defaultMessage: "Context panel"
    },
    panelContentLabel: {
        id: "fabric.editor.contextPanel.panelContentLabel",
        defaultMessage: "Scrollable context panel content"
    }
});
module.exports["contextPanelMessages"] = $81a4f62f6d4935be$export$8ea7f7e979b71fa5;

});

parcelRegister("808tb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $bda778c801e17725$export$8448461a71ae48a1 = (0, $aXWIB.defineMessages)({
    toolbarIconLabel: {
        id: "editor.trackChanges.toolbarIconLabel",
        defaultMessage: "View changes"
    },
    removed: {
        id: "editor.trackChanges.removed",
        defaultMessage: "Removed"
    },
    added: {
        id: "editor.trackChanges.added",
        defaultMessage: "Added"
    }
});
module.exports["trackChangesMessages"] = $bda778c801e17725$export$8448461a71ae48a1;

});

parcelRegister("gA3OZ", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $46cd2a98f2b1b2d8$export$29c5997a25e4779b = (0, $aXWIB.defineMessages)({
    codeSnippetTextBox: {
        id: "fabric.editor.ariaRoleDescription.codeSnippetTextBox",
        defaultMessage: "codesnippet textbox"
    }
});
module.exports["roleDescriptionMessages"] = $46cd2a98f2b1b2d8$export$29c5997a25e4779b;

});

parcelRegister("fzXn1", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f6c896072a7b1f2a$export$254768729b492c8b = (0, $aXWIB.defineMessages)({
    copySyncBlockLabel: {
        id: "fabric.editor.copySyncBlock",
        defaultMessage: "Copy"
    },
    copySyncedBlockTooltip: {
        id: "fabric.editor.copySyncedBlockTooltip",
        defaultMessage: "Copy synced block"
    },
    editSourceLabel: {
        id: "fabric.editor.editSourceLabel",
        defaultMessage: "Edit source"
    },
    editSourceTooltip: {
        id: "fabric.editor.editSourceTooltipEnabled",
        defaultMessage: "Edit synced content at source location"
    },
    editSourceTooltipDisabled: {
        id: "fabric.editor.editSourceTooltipDisabled",
        defaultMessage: "Source link is not currently available"
    },
    syncBlockGroup: {
        id: "fabric.editor.syncBlockGroup",
        defaultMessage: "Sync Block Types"
    },
    syncedBlockLabel: {
        id: "fabric.editor.syncedBlock.label.text",
        defaultMessage: "Synced block"
    },
    unsyncedBlockLabel: {
        id: "fabric.editor.unsyncedBlock.label.text",
        defaultMessage: "Unsynced block"
    },
    permissionDeniedHeading: {
        id: "fabric.editor.syncedBlockPermissionDeniedHeading",
        defaultMessage: "Request access to view synced block"
    },
    permissionDeniedDescription: {
        id: "fabric.editor.syncedBlockPermissionDeniedDescription",
        defaultMessage: "You don't have access to view the source content of this synced block."
    },
    permissionDeniedAltText: {
        id: "fabric.editor.syncedBlockPermissionDeniedIconAltText",
        defaultMessage: "Permission denied."
    },
    requestAccessButton: {
        id: "fabric.editor.requestAccessToSyncedBlock",
        defaultMessage: "Request access"
    },
    accessRequested: {
        id: "fabric.editor.accessToSyncedBlockRequested",
        defaultMessage: "Access requested"
    },
    requestAccessError: {
        id: "fabric.editor.requestAccessToSyncedBlockError",
        defaultMessage: "Something went wrong. Click to try again"
    },
    sourceSyncBlockTooltip: {
        id: "fabric.editor.sourceSyncBlockTooltip",
        defaultMessage: "When you edit this source block it will update across synced locations."
    },
    defaultSyncBlockTooltip: {
        id: "fabric.editor.sourceSyncBlockTooltip",
        defaultMessage: "Synced block"
    },
    referenceSyncBlockTooltip: {
        id: "fabric.editor.referenceSyncBlockTooltip",
        defaultMessage: "Synced from: {title}"
    },
    referenceSyncBlockLastEdited: {
        id: "fabric.editor.referenceSyncBlockLastEdited",
        defaultMessage: "Last edited:"
    },
    referenceSyncBlockSyncedFrom: {
        id: "fabric.editor.referenceSyncBlockSyncedFrom",
        defaultMessage: "Synced from:"
    },
    taskInDestinationSyncedBlockTooltip: {
        id: "fabric.editor.taskInDestinationSyncedBlockTooltip",
        defaultMessage: "This content is synced. Edit it at the source."
    },
    deletionConfirmationModalTitleSingle: {
        id: "fabric.editor.deletionConfirmationModalTitleSingle",
        defaultMessage: "Delete synced content?"
    },
    deleteConfirmationModalTitleMultiple: {
        id: "fabric.editor.deleteConfirmationModalTitleMultiple",
        defaultMessage: "Delete content in {count, plural, one {1 location} other {# locations}}?"
    },
    deleteConfirmationModalCancelButton: {
        id: "fabric.editor.deleteConfirmationModalCancelButton",
        defaultMessage: "Cancel"
    },
    deleteConfirmationModalDeleteButton: {
        id: "fabric.editor.deleteConfirmationModalDeleteButton",
        defaultMessage: "Delete"
    },
    deleteRetryButton: {
        id: "fabric.editor.deleteConfirmationModalRetryButton",
        defaultMessage: "Try again"
    },
    deletionConfirmationModalDescription: {
        id: "fabric.editor.deletionConfirmationModalDescription",
        defaultMessage: "If you delete this synced block, it will become an \u201CUnsynced block\u201D in other locations. This action is permanent and cannot be undone."
    },
    deletionConfirmationModalDescriptionNew: {
        id: "fabric.editor.deletionConfirmationModalDescriptionNew",
        defaultMessage: "If you delete this synced block, it will appear as an empty \"Unsynced block\" in {syncBlockCount, plural, one {1 other synced location} other {# locations}}. This action is permanent and cannot be undone."
    },
    deletionConfirmationModalDescriptionNoRef: {
        id: "fabric.editor.deletionConfirmationModalDescriptionNoRef",
        defaultMessage: "Your content will no longer appear, and the synced block will be deleted. This action is permanent and cannot be undone."
    },
    createSyncBlockLabel: {
        id: "fabric.editor.createSyncBlockLabel",
        defaultMessage: "Create synced block"
    },
    syncBlockLabel: {
        id: "fabric.editor.syncBlockLabel",
        defaultMessage: "Sync block"
    },
    newLozenge: {
        id: "fabric.editor.syncBlock.toolbar.newLozenge",
        defaultMessage: "New"
    },
    failToDeleteTitle: {
        id: "fabric.editor.error.title.failToDelete",
        defaultMessage: "Failed to delete"
    },
    failToDeleteWhenOfflineDescription: {
        id: "fabric.editor.error.description.failToDeleteWhenOffline",
        defaultMessage: "You appear to be offline. Please connect to the internet to delete synced content."
    },
    cannotDeleteTitle: {
        id: "fabric.editor.error.flag.title.cannotDelete",
        defaultMessage: "Failed to delete synced block"
    },
    cannotDeleteDescription: {
        id: "fabric.editor.error.description.cannotDelete",
        defaultMessage: "An error occurred while trying to delete this synced block. "
    },
    failToEditTitle: {
        id: "fabric.editor.error.title.failToEdit",
        defaultMessage: "Cannot edit synced content offline"
    },
    failToEditWhenOfflineDescription: {
        id: "fabric.editor.error.description.failToEditWhenOffline",
        defaultMessage: "You appear to be offline. Please connect to the internet to edit synced content."
    },
    failToCreateTitle: {
        id: "fabric.editor.error.title.failToCreate",
        defaultMessage: "Cannot create synced content offline"
    },
    failToCreateWhenOfflineDescription: {
        id: "fabric.editor.error.description.failToCreateWhenOffline",
        defaultMessage: "You appear to be offline. Please connect to the internet to create synced content."
    },
    loadingSyncedContent: {
        id: "fabric.editor.syncedBlockLoadingSyncedContent",
        defaultMessage: "Loading synced content"
    },
    generalErrorDescription: {
        id: "fabric.editor.syncedBlockGeneralErrorDescription",
        defaultMessage: "We're unable to display this content at the moment."
    },
    notFoundAltText: {
        id: "fabric.editor.syncedBlockNotFoundIconAltText",
        defaultMessage: "Synced block not found."
    },
    notFoundDescription: {
        id: "fabric.editor.syncedBlockNotFoundDescription.non-final",
        defaultMessage: "We're unable to display this content as its source has been deleted or archived."
    },
    sourceUnsyncedDescription: {
        id: "fabric.editor.syncedBlockSourceUnsyncedDescription",
        defaultMessage: "We're unable to display this content as it's been unsynced from <a>{title}</a>."
    },
    sourceDeletedDescription: {
        id: "fabric.editor.syncedBlockSourceDeletedDescription",
        defaultMessage: "We're unable to display this content as it's been deleted from <a>{title}</a>."
    },
    entityNotFoundDescription: {
        id: "fabric.editor.syncedBlockEntityNotFoundDescription",
        defaultMessage: "We're unable to display this synced block as it's not available on this site. <link>Learn more</link>"
    },
    genericNotFoundDescription: {
        id: "fabric.editor.syncedBlockGenericNotFoundDescription",
        defaultMessage: "We're unable to display this synced content as it's been deleted or unsynced."
    },
    retryButton: {
        id: "fabric.editor.retrySyncedBlock",
        defaultMessage: "Try again"
    },
    offlineError: {
        id: "fabric.editor.error.description.reference.offline",
        defaultMessage: "We're unable to display synced blocks when you're offline"
    },
    unpublishedError: {
        id: "fabric.editor.error.description.reference.unpublished",
        defaultMessage: "Synced content will display <link>when the page is published</link>"
    },
    unpublishedErrorJiraWorkItem: {
        id: "fabric.editor.error.description.reference.unpublished.jiraWorkItem",
        defaultMessage: "Synced content will display <link>when the item's description is saved</link>"
    },
    syncBlockCopiedTitle: {
        id: "fabric.editor.syncBlockCopiedTitle",
        defaultMessage: "Synced block copied to clipboard"
    },
    syncBlockCopiedDescription: {
        id: "fabric.editor.syncBlockCopiedDescription",
        defaultMessage: "Paste your synced block to keep content auto-updated. Permissions are the same."
    },
    syncBlockCopiedAction: {
        id: "fabric.editor.syncBlockCopiedAction",
        defaultMessage: "Learn more"
    },
    syncedLocationDropdownTitle: {
        id: "fabric.editor.syncedLocationDropdownTitle",
        defaultMessage: "Synced locations"
    },
    syncedLocationDropdownHeading: {
        id: "fabric.editor.syncedLocationDropdownHeading",
        defaultMessage: "{count} locations:"
    },
    syncedLocationDropdownError: {
        id: "fabric.editor.syncedLocationDropdownError",
        defaultMessage: "We can't load locations right now. Please wait a few minutes and refresh your browser."
    },
    syncedLocationDropdownNoResults: {
        id: "fabric.editor.syncedLocationDropdownNoResults",
        defaultMessage: "Copy and paste synced blocks to reuse in other locations."
    },
    syncedLocationDropdownLearnMoreLink: {
        id: "fabric.editor.syncedLocationDropdownLearnMoreLink",
        defaultMessage: "Learn more about synced blocks"
    },
    syncedLocationDropdownSamePage: {
        id: "fabric.editor.syncedLocationDropdownSamePage",
        defaultMessage: "This page"
    },
    syncedLocationDropdownTitleBlockIndex: {
        id: "fabric.editor.syncedLocationDropdownTitleNote",
        defaultMessage: "block {index}"
    },
    syncedLocationDropdownTitleNoteForConfluencePage: {
        id: "fabric.editor.syncedLocationDropdownTitleNoteForConfluencePage",
        defaultMessage: "This page"
    },
    syncedLocationDropdownTitleNoteForJiraWorkItem: {
        id: "fabric.editor.syncedLocationDropdownTitleNoteForJiraWorkItem",
        defaultMessage: "This work item"
    },
    syncedLocationDropdownSourceLozenge: {
        id: "fabric.editor.syncedLocationDropdownSourceLozenge",
        defaultMessage: "Source"
    },
    syncedLocationDropdownRequestAccess: {
        id: "fabric.editor.syncedLocationDropdownRequestAccess",
        defaultMessage: "Request access"
    },
    syncedLocationDropdownUntitledPage: {
        id: "fabric.editor.syncedLocationDropdownUntitledPage",
        defaultMessage: "Untitled"
    },
    // Accessible labels for the Jira issue-type icons rendered in the synced location
    // dropdown. Used as the `IconTile` `label` prop so screen readers announce the type.
    syncedLocationDropdownIssueTypeTask: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeTask",
        defaultMessage: "Task"
    },
    syncedLocationDropdownIssueTypeBug: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeBug",
        defaultMessage: "Bug"
    },
    syncedLocationDropdownIssueTypeStory: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeStory",
        defaultMessage: "Story"
    },
    syncedLocationDropdownIssueTypeEpic: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeEpic",
        defaultMessage: "Epic"
    },
    syncedLocationDropdownIssueTypeSubtask: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeSubtask",
        defaultMessage: "Subtask"
    },
    syncedLocationDropdownIssueTypeGeneric: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeGeneric",
        defaultMessage: "Jira work item"
    },
    unpublishedSyncBlockPastedTitle: {
        id: "fabric.editor.unpublishedSyncBlockPastedTitle",
        defaultMessage: "Pasted from unpublished page"
    },
    unpublishedSyncBlockPastedTitleJiraWorkItem: {
        id: "fabric.editor.unpublishedSyncBlockPastedTitle.jiraWorkItem",
        defaultMessage: "Pasted from unsaved item"
    },
    unpublishedSyncBlockPastedDescription: {
        id: "fabric.editor.unpublishedSyncBlockPastedDescription",
        defaultMessage: "When the page is published, the content will be displayed."
    },
    unpublishedSyncBlockPastedDescriptionJiraWorkItem: {
        id: "fabric.editor.unpublishedSyncBlockPastedDescription.jiraWorkItem",
        defaultMessage: "When the item's description is saved, the content will be displayed."
    },
    unsyncButton: {
        id: "fabric.editor.syncedBlock.unsync",
        defaultMessage: "Unsync"
    },
    deleteConfirmationModalUnsyncButton: {
        id: "fabric.editor.deleteConfirmationModalUnsyncButton",
        defaultMessage: "Unsync"
    },
    unsyncConfirmationModalTitle: {
        id: "fabric.editor.unsyncConfirmationModalTitle",
        defaultMessage: "Unsync this content?"
    },
    unsyncConfirmModalDescriptionSingle: {
        id: "fabric.editor.unsyncConfirmModalDescriptionSingle",
        defaultMessage: "Your content will stay here. It will no longer be a synced block. This action is permanent and cannot be undone."
    },
    unsyncConfirmModalDescriptionMultiple: {
        id: "fabric.editor.unsyncConfirmModalDescriptionMultiple",
        defaultMessage: "Your content will stay here. In {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}} it will appear as an \"Unsynced block\". This action is permanent and cannot be undone."
    },
    unsyncConfirmModalDescriptionMultipleNew: {
        id: "fabric.editor.unsyncConfirmModalDescriptionMultipleNew",
        defaultMessage: "Your content will stay here. In {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}} it will appear as an empty \"Unsynced block\". This action is permanent and cannot be undone."
    },
    cannotPasteSyncedBlockTitle: {
        id: "fabric.editor.cannotPasteSyncedBlockTitle",
        defaultMessage: "Unable to paste"
    },
    cannotPasteSyncedBlockDescription: {
        id: "fabric.editor.cannotPasteSyncedBlockDescription",
        defaultMessage: "We\u2019re still building this feature. Currently, you can only paste synced content once your work item has been created. "
    },
    cannotPasteSyncedBlockUnsupportedDescription: {
        id: "fabric.editor.cannotPasteSyncedBlockUnsupportedDescription",
        defaultMessage: "Sync blocks aren't supported here yet. "
    },
    cannotPasteSyncedBlockAction: {
        id: "fabric.editor.cannotPasteSyncedBlockAction",
        defaultMessage: "Learn more"
    },
    cannotCreateSyncBlockTitle: {
        id: "fabric.editor.cannotCreateSyncBlockTitle",
        defaultMessage: "Unable to create synced block"
    },
    CannotCreateSyncBlockDescription: {
        id: "fabric.editor.cannotCreateSyncBlockDescription",
        defaultMessage: "An error occurred while trying to create this synced block. "
    },
    inlineExtensionInSyncBlockTitle: {
        id: "fabric.editor.inlineExtensionInSyncBlockTitle",
        defaultMessage: "Some macros may not work when adding synced blocks to new locations"
    },
    inlineExtensionInSyncBlockDescription: {
        id: "fabric.editor.inlineExtensionInSyncBlockDescription",
        defaultMessage: "This may happen if your synced block is used in places that don't support certain macros."
    },
    extensionInSyncBlockTitle: {
        id: "fabric.editor.extensionInSyncBlockTitle",
        defaultMessage: "Some macros may not work when adding synced blocks to new locations"
    },
    extensionInSyncBlockDescription: {
        id: "fabric.editor.extensionInSyncBlockDescription",
        defaultMessage: "This may happen if your synced block is used in places that don't support certain macros."
    },
    duplicateSourceSyncBlockTitle: {
        id: "fabric.editor.duplicateSourceSyncBlockTitle",
        defaultMessage: "Duplicate synced block removed"
    },
    duplicateSourceSyncBlockDescription: {
        id: "fabric.editor.duplicateSourceSyncBlockDescription",
        defaultMessage: "Only one source synced block per source is allowed on a page. Use a reference synced block to reuse this content."
    }
});
module.exports["syncBlockMessages"] = $f6c896072a7b1f2a$export$254768729b492c8b;

});

parcelRegister("9dV3t", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $0cd509c669fd054b$export$8becdf1c29fc36cd = (0, $aXWIB.defineMessages)({
    colorPickerTitle: {
        id: "company-hub-text-color.color-picker-dropdown.picker-title",
        defaultMessage: "Text Color"
    }
});
module.exports["companyHubTextColorMessages"] = $0cd509c669fd054b$export$8becdf1c29fc36cd;

});

parcelRegister("36Wvq", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $a1a2b08714063863$export$a0fb5df03a49c723 = (0, $aXWIB.defineMessages)({
    groupLabel: {
        id: "fabric.editor.markdownMode.viewToggle.groupLabel",
        defaultMessage: "View mode"
    },
    source: {
        id: "fabric.editor.markdownMode.viewToggle.source",
        defaultMessage: "Syntax editor"
    },
    wysiwyg: {
        id: "fabric.editor.markdownMode.viewToggle.wysiwyg",
        defaultMessage: "Preview editor"
    },
    preview: {
        id: "fabric.editor.markdownMode.viewToggle.preview",
        defaultMessage: "Split view (coming soon)"
    },
    sourceAriaLabel: {
        id: "fabric.editor.markdownMode.sourceView.ariaLabel",
        defaultMessage: "Markdown source"
    },
    confirmDialogTitleToMarkdown: {
        id: "fabric.editor.markdownMode.confirmDialog.title.toMarkdown",
        defaultMessage: "Convert to markdown"
    },
    confirmDialogTitleToMarkdownLossy: {
        id: "fabric.editor.markdownMode.confirmDialog.title.toMarkdownLossy",
        defaultMessage: "Convert to markdown"
    },
    confirmDialogTitleToRichText: {
        id: "fabric.editor.markdownMode.confirmDialog.title.toRichText",
        defaultMessage: "Convert to rich text"
    },
    confirmDialogToMarkdownToolsRemoved: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdown.toolsRemoved",
        defaultMessage: "Use basic formatting"
    },
    confirmDialogToMarkdownToggle: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdown.toggle",
        defaultMessage: "Toggle between the syntax and preview editor"
    },
    confirmDialogToMarkdownVersionHistory: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdown.versionHistory",
        defaultMessage: "Restore previous drafts with version history"
    },
    confirmDialogToMarkdownLossyRichContent: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdownLossy.richContent",
        defaultMessage: "Your content may look different as converting removes rich text formatting"
    },
    confirmDialogToMarkdownLossyVersionHistory: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdownLossy.versionHistory",
        defaultMessage: "To restore formatting, access previous drafts from version history"
    },
    confirmDialogToMarkdownLossyCta: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdownLossy.cta",
        defaultMessage: "Convert"
    },
    confirmDialogToRichTextStandardTools: {
        id: "fabric.editor.markdownMode.confirmDialog.toRichText.standardTools",
        defaultMessage: "Use all rich text tools"
    },
    confirmDialogToRichTextVersionHistory: {
        id: "fabric.editor.markdownMode.confirmDialog.toRichText.versionHistory",
        defaultMessage: "Restore previous drafts with version history"
    },
    confirmDialogCancel: {
        id: "fabric.editor.markdownMode.confirmDialog.cancel",
        defaultMessage: "Cancel"
    },
    confirmDialogConfirm: {
        id: "fabric.editor.markdownMode.confirmDialog.confirm",
        defaultMessage: "Confirm"
    },
    confirmDialogError: {
        id: "fabric.editor.markdownMode.confirmDialog.error",
        defaultMessage: "Something went wrong while converting this page. Please try again."
    },
    unlinkSyncedBlocksTitle: {
        id: "fabric.editor.markdownMode.unlinkSyncedBlocks.title",
        defaultMessage: "Delete synced content?"
    },
    unlinkSyncedBlocksBody: {
        id: "fabric.editor.markdownMode.unlinkSyncedBlocks.body",
        defaultMessage: "Converting will delete synced blocks and their content. This cannot be restored in version history."
    },
    labsLozenge: {
        id: "fabric.editor.markdownMode.labsLozenge",
        defaultMessage: "LABS"
    }
});
module.exports["markdownModeMessages"] = $a1a2b08714063863$export$a0fb5df03a49c723;

});

parcelRegister("7fmpI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $hWRJP = parcelRequire("hWRJP");

class $5aeffb90025ca075$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}
module.exports["ErrorBoundary"] = $5aeffb90025ca075$export$e926676385687eaf;

});

parcelRegister("grmt9", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $8kPu1 = parcelRequire("8kPu1");

const $5636e430046d299b$export$180fe852598a23ab = {
    pending: [
        'started'
    ],
    started: [
        'aborted',
        'failed',
        'succeeded'
    ],
    aborted: [
        'started'
    ],
    failed: [
        'started'
    ],
    succeeded: [
        'started'
    ]
};


const $cc23084c386c6715$export$178881f329fdb81f = (fromState, toState)=>{
    return (0, $5636e430046d299b$export$180fe852598a23ab)[fromState]?.includes(toState) ?? false;
};


class $677a536053deeb18$export$fa331fd384051f6a {
    start(callback) {
        this.checks.forEach((check)=>check.start(callback));
    }
    stop() {
        this.checks.forEach((check)=>check.stop());
    }
    constructor(checks){
        this.checks = void 0;
        this.checks = checks;
    }
}


class $fd9e9a5afa72d596$export$c90b54e658fc4d7c {
    startCheck() {
        this.stopCheck();
        this.check.start(({ status: status, reason: reason, metadata: metadata })=>{
            if (status === 'success') this.success({
                reason: reason,
                metadata: metadata
            });
            else if (status === 'abort') this.abort({
                reason: reason,
                metadata: metadata
            });
            else if (status === 'failure') this.failure({
                reason: reason,
                metadata: metadata
            });
        });
    }
    stopCheck() {
        this.check.stop();
    }
    getEndStateMetadata(options = {}) {
        const metadata = {
            ...options.metadata
        };
        if (options.reason) metadata.experienceEndReason = options.reason;
        return metadata;
    }
    /**
   * Transitions to a new experience state and tracks analytics events.
   *
   * Upon transition to each state, two events are tracked:
   * - experienceMeasured: tracked on every successful transition, used for data analysis
   * - experienceSampled: tracked only on 1 out of every N transitions based on sample rate
   *
   * @param toState - The target state to transition to
   * @param metadata - Optional metadata to attach to the analytics events
   * @returns true if transition was successful, false if invalid transition
   */ transitionTo(toState, metadata) {
        if (!(0, $cc23084c386c6715$export$178881f329fdb81f)(this.currentState, toState)) return false;
        this.currentState = toState;
        if (toState === 'started') {
            this.isSampledTrackingEnabled = Math.random() < this.sampleRate;
            this.startTimeMs = Date.now();
            this.startMetadata = metadata;
        }
        this.trackTransition(toState, metadata);
        if (toState === 'started') this.startCheck();
        else {
            this.stopCheck();
            this.startMetadata = undefined;
        }
        this.statesSeen.add(toState);
        return true;
    }
    /**
   * Tracks analytics events for a state transition.
   *
   * Fires both experienceMeasured (always) and experienceSampled (sampled) events.
   *
   * @param toState - The state that was transitioned to
   * @param metadata - Metadata to include in the event, including firstInSession flag
   */ trackTransition(toState, metadata) {
        const attributes = {
            experienceKey: this.id,
            experienceStatus: toState,
            experienceStatusFirstSeen: !this.statesSeen.has(toState),
            experienceStartTime: this.startTimeMs || 0,
            experienceDuration: this.startTimeMs ? Date.now() - this.startTimeMs : 0,
            ...this.globalMetadata,
            ...this.startMetadata,
            ...metadata
        };
        const experienceMeasuredEvent = {
            action: (0, $d925B.ACTION).EXPERIENCE_MEASURED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            actionSubjectId: this.actionSubjectId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: attributes
        };
        this.dispatchAnalyticsEvent(experienceMeasuredEvent);
        if (this.isSampledTrackingEnabled) {
            const experienceSampledEvent = {
                action: (0, $d925B.ACTION).EXPERIENCE_SAMPLED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                actionSubjectId: this.actionSubjectId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            };
            this.dispatchAnalyticsEvent(experienceSampledEvent);
        }
    }
    /**
   * Starts tracking the experience and all checks which monitor for completion.
   *
   * Metadata from options will be merged with metadata provided in subsequent events.
   *
   * @param options - Configuration for starting the experience
   * @param options.metadata - Optional custom metadata attached to all subsequent events for this started experience
   * @param options.forceRestart - If true and experience already in progress will abort and restart
   * @param options.method - Optional method for experience start, e.g., how the experience was initiated
   */ start(options = {}) {
        if (options.forceRestart && this.currentState === 'started') this.abort({
            reason: (0, $8kPu1.EXPERIENCE_ABORT_REASON).RESTARTED
        });
        return this.transitionTo('started', {
            experienceStartMethod: options.method,
            ...options.metadata
        });
    }
    /**
   * Marks the experience as successful and stops any ongoing checks.
   *
   * @param options - Configuration for the success event
   * @param options.metadata - Optional custom metadata attached to the success event
   * @param options.reason - Optional reason for success
   * @returns false if transition to success state was not valid
   */ success(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('succeeded', metadata);
    }
    /**
   * Aborts the experience and stops any ongoing checks.
   *
   * Use this when a started experience terminates early due to user action or context change
   * (e.g., component unmount, navigation). This is neither success nor failure.
   *
   * @param options - Configuration for the abort event
   * @param options.metadata - Optional custom metadata attached to the abort event
   * @param options.reason - Optional reason for abort
   *
   * @example
   * // Abort on component unmount
   * useEffect(() => {
   *   return () => experience.abort({ reason: 'unmount', metadata: { someKey: 'someValue' } });
   * }, []);
   *
   * @returns false if transition to aborted state was not valid
   */ abort(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('aborted', metadata);
    }
    /**
   * Manually marks the experience as failed and stops any ongoing checks.
   *
   * Use this for actual failures in the experience flow (e.g., timeout, error conditions).
   *
   * @param options - Configuration for the failure event
   * @param options.metadata - Optional custom metadata attached to the failure event
   * @param options.reason - Optional reason for failure
   * @returns false if transition to failed state was not valid
   */ failure(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('failed', metadata);
    }
    /**
   * Creates a new Experience instance for tracking user experiences.
   *
   * @param id - Unique identifier for the experience e.g. 'toolbarOpen' 'menuAction'
   * @param options - Configuration options for the experience
   * @param options.checks - Experience checks to monitor for completion
   * @param options.dispatchAnalyticsEvent - Function to dispatch analytics events
   * @param options.sampleRate - Sample rate for experienceSampled events
   * @param options.metadata - Global metadata to attach to all events
   * @param options.action - Optional sub identifier for the specific experience action e.g. 'bold' 'insertTable'
   * @param options.actionSubjectId - Optional sub identifier for the experience action subject e.g. 'selectionToolbar' 'quickInsert'
   */ constructor(id, options){
        this.id = void 0;
        this.actionSubjectId = void 0;
        this.dispatchAnalyticsEvent = void 0;
        this.sampleRate = void 0;
        this.globalMetadata = void 0;
        this.check = void 0;
        this.currentState = 'pending';
        /**
     * Set of experience states that have been seen in the current session.
     *
     * Used to determine if experienceStatusFirstSeen flag should be set in events.
     */ this.statesSeen = new Set();
        /**
     * Indicates whether sampled tracking is enabled for this current experience session.
     *
     * Set to true | false upon transitioning to 'started' state.
     * When true, on subsequent transitions we fire experienceSampled events.
     * Ensures that every tracked start has corresponding abort/fail/success tracked.
     */ this.isSampledTrackingEnabled = void 0;
        /**
     * Timestamp (in milliseconds) when the experience transitioned to 'started' state.
     *
     * Used to calculate experience duration. Set via Date.now() when experience starts.
     */ this.startTimeMs = void 0;
        /**
     * Metadata provided at experience start time to merge into subsequent events.
     *
     * Used to retain experienceStartMethod and other start-specific metadata.
     */ this.startMetadata = void 0;
        this.id = id;
        this.actionSubjectId = options.actionSubjectId;
        this.dispatchAnalyticsEvent = options.dispatchAnalyticsEvent;
        this.sampleRate = options.sampleRate ?? (0, $8kPu1.DEFAULT_EXPERIENCE_SAMPLE_RATE);
        this.globalMetadata = {
            ...options.metadata,
            experienceAction: options.action
        };
        this.check = new (0, $677a536053deeb18$export$fa331fd384051f6a)(options.checks || []);
    }
}
module.exports["Experience"] = $fd9e9a5afa72d596$export$c90b54e658fc4d7c;

});

parcelRegister("8kPu1", function(module, exports) {
/**
 * Built-in failure reasons for experience checks
 *
 * These are used by the various ExperienceCheck implementations to
 * provide consistent, well-known failure reasons for analytics and debugging.
 */ const $d05112237b8e1d04$export$21dde0ac9b2abe83 = {
    /**
   * Experience timed out before completion
   */ TIMEOUT: 'timeout',
    /**
   * Target element could not be found when starting DOM mutation observation
   */ DOM_MUTATION_TARGET_NOT_FOUND: 'domMutationTargetNotFound',
    /**
   * Error occurred during DOM mutation check execution
   */ DOM_MUTATION_CHECK_ERROR: 'domMutationCheckError'
};
const $d05112237b8e1d04$export$e6589edd1f8a04af = {
    /**
   * Experience was aborted because it was restarted while already in progress
   */ RESTARTED: 'restarted'
};
const $d05112237b8e1d04$export$8e85905c8b6efc67 = 0.001;
const $d05112237b8e1d04$export$b110169935468339 = {
    ASYNC_OPERATION: 'asyncOperation',
    MENU_ACTION: 'menuAction',
    MENU_OPEN: 'menuOpen',
    TOOLBAR_ACTION: 'toolbarAction',
    TOOLBAR_OPEN: 'toolbarOpen'
};
module.exports["EXPERIENCE_FAILURE_REASON"] = $d05112237b8e1d04$export$21dde0ac9b2abe83;
module.exports["EXPERIENCE_ABORT_REASON"] = $d05112237b8e1d04$export$e6589edd1f8a04af;
module.exports["DEFAULT_EXPERIENCE_SAMPLE_RATE"] = $d05112237b8e1d04$export$8e85905c8b6efc67;
module.exports["EXPERIENCE_ID"] = $d05112237b8e1d04$export$b110169935468339;

});

parcelRegister("fo9p3", function(module, exports) {

var $8kPu1 = parcelRequire("8kPu1");

const $5240fd93cec52085$var$DEFAULT_FAILURE_RESULT = {
    status: 'failure',
    reason: (0, $8kPu1.EXPERIENCE_FAILURE_REASON).TIMEOUT
};
class $5240fd93cec52085$export$1a6fa509d14ac50 {
    start(callback) {
        this.stop();
        this.timeoutId = setTimeout(()=>{
            const result = this.onTimeout() || $5240fd93cec52085$var$DEFAULT_FAILURE_RESULT;
            callback(result);
        }, this.durationMs);
    }
    stop() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    }
    constructor({ durationMs: durationMs, onTimeout: onTimeout = ()=>$5240fd93cec52085$var$DEFAULT_FAILURE_RESULT }){
        this.timeoutId = void 0;
        this.durationMs = 0;
        this.onTimeout = void 0;
        this.durationMs = durationMs;
        this.onTimeout = onTimeout;
    }
}
module.exports["ExperienceCheckTimeout"] = $5240fd93cec52085$export$1a6fa509d14ac50;

});

parcelRegister("dtVue", function(module, exports) {

var $jubk3 = parcelRequire("jubk3");

function $c25f711fd5cdf3ef$export$72aeabfc882e7732(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    return (0, $jubk3.getMentionsConfig)(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents);
}
module.exports["createMentionsConfig"] = $c25f711fd5cdf3ef$export$72aeabfc882e7732;

});

parcelRegister("jubk3", function(module, exports) {

var $kN1ON = parcelRequire("kN1ON");

var $ly0vw = parcelRequire("ly0vw");


var $7lu50 = parcelRequire("7lu50");


var $f7B1p = parcelRequire("f7B1p");


var $04e9M = parcelRequire("04e9M");


var $6mYMS = parcelRequire("6mYMS");

/**
 * @generated SignedSource<<fa032903485ae14295b104237c524b04>>
 * @relayHash f1566d2dfc3b1c8e62dbd552d1d5ea7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f
const $2c3903aefb77a74c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "ids"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f1566d2dfc3b1c8e62dbd552d1d5ea7b",
            "id": "9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f",
            "metadata": {},
            "name": "preloadMentionsUsersUsersQuery",
            "operationKind": "query",
            "text": "query preloadMentionsUsersUsersQuery($ids:[ID!]!){users(accountIds:$ids){__typename,id,name}}"
        }
    };
}();
$2c3903aefb77a74c$var$node.hash = "3783fdf735e372b90adc93c9f8ad8005";
var $2c3903aefb77a74c$export$2e2bcd8739ae039 = $2c3903aefb77a74c$var$node;



var $dYU3e = parcelRequire("dYU3e");

const $ed0e2cb9f5186ade$var$ARI_PREFIX = 'ari:cloud:identity::user/';
const $ed0e2cb9f5186ade$export$7c5848ab9f90077b = 50;
const $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery = (0, $2c3903aefb77a74c$export$2e2bcd8739ae039);
const $ed0e2cb9f5186ade$var$getUserData = async (ids)=>{
    const { data: data } = await (0, $dYU3e.queryAgg)({
        query: $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery,
        variables: {
            ids: ids
        },
        __callerPackage__: "@confluence/fabric-media-support"
    });
    return data?.users;
};
const $ed0e2cb9f5186ade$export$3adfff745266e959 = async (userIds)=>{
    const ids = userIds.map((id)=>`${$ed0e2cb9f5186ade$var$ARI_PREFIX}${id}`);
    const users = await $ed0e2cb9f5186ade$var$getUserData(ids);
    return (users || []).map((user)=>({
            id: user?.id?.replace($ed0e2cb9f5186ade$var$ARI_PREFIX, ''),
            name: user?.name
        }));
};


class $71c2faaa98a432d0$export$82da878d725997a7 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return 0, $ed0e2cb9f5186ade$export$7c5848ab9f90077b;
    }
    async lookupMentionNames(ids) {
        // Allows to rely upon the preloaded mentions data when resolving mentions in the editor
        // both on the client and server side
        return (0, $ed0e2cb9f5186ade$export$3adfff745266e959)(ids).then((users)=>users.map((user)=>({
                    ...user,
                    status: (0, $6mYMS.MentionNameStatus).OK
                })));
    }
}



var $80Dol = parcelRequire("80Dol");


var $g2yI6 = parcelRequire("g2yI6");

const $b08c9dc0f73ff25f$export$7758cc57d736bc3e = '/gateway/api/mentions';
const $b08c9dc0f73ff25f$export$bcbcd41d6c96b319 = '/gateway/api/teams/mentions';
const $b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL = '/gateway/api/v3/invitations/invite';
async function $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    const userMentionConfig = {
        url: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        productId: 'micros-group/confluence',
        containerId: spaceId || undefined,
        shouldHighlightMention: (mention)=>mention.id === accountId,
        debounceTime: 150
    };
    const shouldEnableInvite = !!onInviteItemClick;
    if (shouldEnableInvite) {
        userMentionConfig.productName = 'Confluence';
        userMentionConfig.shouldEnableInvite = shouldEnableInvite;
        userMentionConfig.onInviteItemClick = onInviteItemClick;
        userMentionConfig.userRole = userRole;
    }
    userMentionConfig.inviteXProductUser = async (userId, mentionName)=>{
        let isSuccess = false;
        let client;
        try {
            if (accountId === userId || isEligibleXProductUserInvite && !await isEligibleXProductUserInvite()) return;
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const response = await (0, $f7B1p.cfetch)($b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    users: [
                        {
                            id: userId
                        }
                    ],
                    resources: [
                        `ari:cloud:confluence::site/${cloudId}`
                    ]
                })
            });
            if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
            const data = await response.json();
            const inviteResponseObj = data[0];
            const product = Object.keys(inviteResponseObj?.results || {})[0];
            const invitationStatus = inviteResponseObj?.results?.[product];
            isSuccess = product?.includes('confluence') && invitationStatus === 'INVITED';
            await client.sendTrackEvent({
                source: 'editor',
                action: 'invited',
                actionSubject: 'xProductUser',
                attributes: {
                    invitationStatus: invitationStatus,
                    inviteeId: userId
                }
            });
        } catch (error) {
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserInvite',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack,
                    inviteeId: userId
                }
            });
            isSuccess = false;
        }
        onXProductUserInviteClick?.(mentionName, isSuccess);
    };
    const teamMentionConfig = {
        url: $b08c9dc0f73ff25f$export$bcbcd41d6c96b319,
        productId: 'micros-group/confluence',
        shouldHighlightMention: (mention)=>mention.id === accountId
    };
    const scrollToMention = ()=>{
        if (focusedMentionId) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const mentionElement = document.querySelector(`[data-local-id="${focusedMentionId}"]`);
            if (mentionElement) mentionElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
        }
    };
    userMentionConfig.mentionNameResolver = new (0, $kN1ON.DefaultMentionNameResolver)(new (0, $71c2faaa98a432d0$export$82da878d725997a7)(), withAnalyticsEventProps, scrollToMention);
    return $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite, includeAgents);
}
async function $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite, includeAgents) {
    let includeExternalCollaborators = false;
    const data = await (0, $g2yI6.fetchMentionsProviderData)();
    // Entitlement check to determine if tenant is premium/enabled for Guests
    includeExternalCollaborators = data ? (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) === true : false;
    return new (0, $80Dol.UserTeamMentionProvider)('/gateway/api/v1/recommendations', userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents ?? false);
}
async function $b08c9dc0f73ff25f$export$86c3c7f166be321d(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    if (!cloudId) throw new Error('MentionResource cannot be configured without a cloud id');
    const spaceId = mentionContext?.spaceId || undefined;
    const mentionResource = await $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, undefined, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents);
    return {
        mentionResource: mentionResource,
        presenceResource: new (0, $ly0vw.default)({
            url: '/gateway/api/directory/graphql',
            cloudId: cloudId,
            productId: 'confluence'
        }),
        // Required for the TinyMCE mentions plugin, should be removed when TinyMCE is removed
        mentionServiceUrl: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        contextIdentifier: {
            containerId: spaceId || '',
            objectId: mentionContext?.contentId || '',
            childObjectId: mentionContext?.commentId || ''
        }
    };
}
module.exports["createFabricMentionResource"] = $b08c9dc0f73ff25f$export$395a616bfa7556a6;
module.exports["getMentionsConfig"] = $b08c9dc0f73ff25f$export$86c3c7f166be321d;

});

parcelRegister("8z3oB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $aD1SW = parcelRequire("aD1SW");


var $gqqjz = parcelRequire("gqqjz");

const $0ffa514f9611729c$export$723a1497b2536563 = ({ showFlag: showFlag, hideFlag: hideFlag })=>{
    const createFlag = (flagOptions)=>{
        const { isAutoDismiss: isAutoDismiss, ...restOptions } = flagOptions;
        const { type: type, appearance: appearance, actions: actions } = flagOptions;
        const shouldAutoDismiss = isAutoDismiss ?? (appearance === 'info' || appearance === 'success');
        showFlag({
            ...restOptions,
            type: appearance ?? type,
            actions: actions?.map(({ text: content, onClick: onClick })=>({
                    onClick: ()=>onClick(),
                    content: content
                })),
            customComponent: shouldAutoDismiss ? (0, $aD1SW.default) : undefined
        });
        return true;
    };
    const closeFlag = ({ id: id })=>{
        hideFlag(id);
        return true;
    };
    return {
        showFlag: createFlag,
        closeFlag: closeFlag
    };
};
const $0ffa514f9611729c$export$b0063bae72b769ca = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, children);
module.exports["getFlagProvider"] = $0ffa514f9611729c$export$723a1497b2536563;
module.exports["FlagProvider"] = $0ffa514f9611729c$export$b0063bae72b769ca;

});

parcelRegister("eLUTa", function(module, exports) {
"use strict";
var $ac11956e102a58e7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ac11956e102a58e7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ac11956e102a58e7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ac11956e102a58e7$var$__exportStar((parcelRequire("fYnqe")), module.exports);

});

parcelRegister("fYnqe", function(module, exports) {
"use strict";
var $ba0ea0bb4cfa0c5b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba0ea0bb4cfa0c5b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ba0ea0bb4cfa0c5b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ba0ea0bb4cfa0c5b$var$__exportStar((parcelRequire("3b0vC")), module.exports);

});

parcelRegister("3b0vC", function(module, exports) {
"use strict";
var $2502cb3fa9925066$var$__assign = module.exports && module.exports.__assign || function() {
    $2502cb3fa9925066$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2502cb3fa9925066$var$__assign.apply(this, arguments);
};
var $2502cb3fa9925066$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2502cb3fa9925066$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2502cb3fa9925066$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.postRobotOn = module.exports.postRobotSend = module.exports.createIframeBridge = void 0;

var $eMRIC = parcelRequire("eMRIC");

Object.defineProperty(module.exports, "postRobotOn", {
    enumerable: true,
    get: function() {
        return $eMRIC.on;
    }
});
Object.defineProperty(module.exports, "postRobotSend", {
    enumerable: true,
    get: function() {
        return $eMRIC.send;
    }
});

var $8tWYx = parcelRequire("8tWYx");

var $2502cb3fa9925066$var$setupMessageListeners = function(window1, domain, listeners) {
    return Object.entries(listeners).map(function(_a) {
        var eventKey = _a[0], eventHandler = _a[1];
        return (0, $eMRIC.on)(eventKey, {
            window: window1,
            domain: domain
        }, function(event) {
            if (eventHandler && event.origin === domain) return eventHandler(event);
            return Promise.resolve();
        });
    });
};
var $2502cb3fa9925066$var$createIframeBridge = function(options) {
    if (!options.withWindow) throw new Error('Target window to setup the bridge with is not defined');
    var bridge = {
        open: function() {
            var withWindow = options.withWindow, withDomain = options.withDomain, features = options.features, theme = options.theme, surfaceColor = options.surfaceColor, sendHandshakeMetric = options.sendHandshakeMetric, metadata = options.metadata, shouldReceiveEmbeddedMacroMessages = options.shouldReceiveEmbeddedMacroMessages;
            var listeners = $2502cb3fa9925066$var$setupMessageListeners(withWindow, withDomain, features);
            var cancelEmbeddedMacroHandler;
            var localId = metadata === null || metadata === void 0 ? void 0 : metadata.localId;
            if (shouldReceiveEmbeddedMacroMessages && localId) try {
                var productHostname_1 = window.location.hostname;
                var handler = (0, $eMRIC.on)("messageFromEmbeddedFAUS_".concat(localId), {}, function(event) {
                    var originUrl = new URL(event.origin);
                    if (originUrl.hostname !== productHostname_1) return Promise.resolve();
                    var _a = event.data || {}, eventKey = _a.eventKey, payload = $2502cb3fa9925066$var$__rest(_a, [
                        "eventKey"
                    ]);
                    var handler = features[eventKey];
                    if (handler) return handler($2502cb3fa9925066$var$__assign($2502cb3fa9925066$var$__assign({}, event), {
                        data: payload
                    }));
                    return Promise.resolve();
                });
                cancelEmbeddedMacroHandler = handler.cancel;
            } catch (error) {
                console.error("Failed to set up messageFromEmbeddedFAUS listener for localId ".concat(localId, ":"), error);
            }
            var cancelReadyHandler = (0, $eMRIC.on)($8tWYx.READY_EVENT, {
                window: withWindow,
                domain: withDomain
            }, function() {
                return $2502cb3fa9925066$var$__awaiter(void 0, void 0, void 0, function() {
                    return $2502cb3fa9925066$var$__generator(this, function(_a) {
                        return [
                            2,
                            true
                        ];
                    });
                });
            }).cancel;
            (0, $eMRIC.send)(withWindow, $8tWYx.READY_EVENT, $2502cb3fa9925066$var$__assign({
                theme: theme,
                surfaceColor: surfaceColor
            }, options.metadata || {}), {
                timeout: $8tWYx.BRIDGE_HANDSHAKE_TIMEOUT_MS
            }).then(function() {
                sendHandshakeMetric(true);
            }).catch(function(error) {
                sendHandshakeMetric(false, error);
                return (0, $8tWYx.handleMissingHandlerError)(error);
            });
            return {
                enableTheming: function() {
                    (0, $eMRIC.send)(withWindow, $8tWYx.THEME_ENABLE_EVENT).catch($8tWYx.handleMissingHandlerError);
                },
                setTheme: function(theme, surfaceColor, env) {
                    (0, $eMRIC.send)(withWindow, $8tWYx.THEME_CHANGE_EVENT, {
                        theme: theme,
                        surfaceColor: surfaceColor,
                        env: env,
                        isFedRamp: metadata === null || metadata === void 0 ? void 0 : metadata.isFedRamp
                    }).catch($8tWYx.handleMissingHandlerError);
                },
                close: function() {
                    cancelReadyHandler();
                    cancelEmbeddedMacroHandler === null || cancelEmbeddedMacroHandler === void 0 || cancelEmbeddedMacroHandler();
                    listeners.forEach(function(_a) {
                        var cancel = _a.cancel;
                        return cancel();
                    });
                }
            };
        }
    };
    return bridge;
};
module.exports.createIframeBridge = $2502cb3fa9925066$var$createIframeBridge;

});

parcelRegister("p8f0R", function(module, exports) {

var $iA9co = parcelRequire("iA9co");

var $04b8ba6eff8b7085$require$Buffer = $iA9co.Buffer;
!function(root, factory) {
    module.exports = factory();
}("undefined" != typeof self ? self : module.exports, function() {
    return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module1 = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            module1.l = !0;
            return module1.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.r = function(exports) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
        };
        __webpack_require__.t = function(value, mode) {
            1 & mode && (value = __webpack_require__(value));
            if (8 & mode) return value;
            if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: !0,
                value: value
            });
            if (2 & mode && "string" != typeof value) for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            return ns;
        };
        __webpack_require__.n = function(module1) {
            var getter = module1 && module1.__esModule ? function() {
                return module1.default;
            } : function() {
                return module1;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return ({}).hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 0);
    }([
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Promise", function() {
                return promise_ZalgoPromise;
            });
            __webpack_require__.d(__webpack_exports__, "TYPES", function() {
                return src_types_TYPES_0;
            });
            __webpack_require__.d(__webpack_exports__, "ProxyWindow", function() {
                return window_ProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "setup", function() {
                return setup;
            });
            __webpack_require__.d(__webpack_exports__, "destroy", function() {
                return destroy;
            });
            __webpack_require__.d(__webpack_exports__, "serializeMessage", function() {
                return setup_serializeMessage;
            });
            __webpack_require__.d(__webpack_exports__, "deserializeMessage", function() {
                return setup_deserializeMessage;
            });
            __webpack_require__.d(__webpack_exports__, "createProxyWindow", function() {
                return createProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "toProxyWindow", function() {
                return setup_toProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "on", function() {
                return on_on;
            });
            __webpack_require__.d(__webpack_exports__, "once", function() {
                return on_once;
            });
            __webpack_require__.d(__webpack_exports__, "send", function() {
                return send_send;
            });
            __webpack_require__.d(__webpack_exports__, "markWindowKnown", function() {
                return markWindowKnown;
            });
            __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() {
                return cleanUpWindow;
            });
            __webpack_require__.d(__webpack_exports__, "bridge", function() {});
            function isRegex(item) {
                return "[object RegExp]" === ({}).toString.call(item);
            }
            var IE_WIN_ACCESS_ERROR = "Call was rejected by callee.\r\n";
            function isAboutProtocol(win) {
                void 0 === win && (win = window);
                return "about:" === win.location.protocol;
            }
            function getParent(win) {
                void 0 === win && (win = window);
                if (win) try {
                    if (win.parent && win.parent !== win) return win.parent;
                } catch (err) {}
            }
            function getOpener(win) {
                void 0 === win && (win = window);
                if (win && !getParent(win)) try {
                    return win.opener;
                } catch (err) {}
            }
            function canReadFromWindow(win) {
                try {
                    return !0;
                } catch (err) {}
                return !1;
            }
            function getActualDomain(win) {
                void 0 === win && (win = window);
                var location = win.location;
                if (!location) throw new Error("Can not read window location");
                var protocol = location.protocol;
                if (!protocol) throw new Error("Can not read window protocol");
                if ("file:" === protocol) return "file://";
                if ("about:" === protocol) {
                    var parent = getParent(win);
                    return parent && canReadFromWindow() ? getActualDomain(parent) : "about://";
                }
                var host = location.host;
                if (!host) throw new Error("Can not read window host");
                return protocol + "//" + host;
            }
            function getDomain(win) {
                void 0 === win && (win = window);
                var domain = getActualDomain(win);
                return domain && win.mockDomain && 0 === win.mockDomain.indexOf("mock:") ? win.mockDomain : domain;
            }
            function isSameDomain(win) {
                if (!function(win) {
                    try {
                        if (win === window) return !0;
                    } catch (err) {}
                    try {
                        var desc = Object.getOwnPropertyDescriptor(win, "location");
                        if (desc && !1 === desc.enumerable) return !1;
                    } catch (err) {}
                    try {
                        if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                    } catch (err) {}
                    try {
                        if (getActualDomain(win) === getActualDomain(window)) return !0;
                    } catch (err) {}
                    return !1;
                }(win)) return !1;
                try {
                    if (win === window) return !0;
                    if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                    if (getDomain(window) === getDomain(win)) return !0;
                } catch (err) {}
                return !1;
            }
            function assertSameDomain(win) {
                if (!isSameDomain(win)) throw new Error("Expected window to be same domain");
                return win;
            }
            function isAncestorParent(parent, child) {
                if (!parent || !child) return !1;
                var childParent = getParent(child);
                return childParent ? childParent === parent : -1 !== (function(win) {
                    var result = [];
                    try {
                        for(; win.parent !== win;){
                            result.push(win.parent);
                            win = win.parent;
                        }
                    } catch (err) {}
                    return result;
                })(child).indexOf(parent);
            }
            function getFrames(win) {
                var result = [];
                var frames;
                try {
                    frames = win.frames;
                } catch (err) {
                    frames = win;
                }
                var len;
                try {
                    len = frames.length;
                } catch (err) {}
                if (0 === len) return result;
                if (len) {
                    for(var i = 0; i < len; i++){
                        var frame = void 0;
                        try {
                            frame = frames[i];
                        } catch (err) {
                            continue;
                        }
                        result.push(frame);
                    }
                    return result;
                }
                for(var _i = 0; _i < 100; _i++){
                    var _frame = void 0;
                    try {
                        _frame = frames[_i];
                    } catch (err) {
                        return result;
                    }
                    if (!_frame) return result;
                    result.push(_frame);
                }
                return result;
            }
            var iframeWindows = [];
            var iframeFrames = [];
            function isWindowClosed(win, allowMock) {
                void 0 === allowMock && (allowMock = !0);
                try {
                    if (win === window) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if (!win) return !0;
                } catch (err) {
                    return !0;
                }
                try {
                    if (win.closed) return !0;
                } catch (err) {
                    return !err || err.message !== IE_WIN_ACCESS_ERROR;
                }
                if (allowMock && isSameDomain(win)) try {
                    if (win.mockclosed) return !0;
                } catch (err) {}
                try {
                    if (!win.parent || !win.top) return !0;
                } catch (err) {}
                var iframeIndex = function(collection, item) {
                    for(var i = 0; i < collection.length; i++)try {
                        if (collection[i] === item) return i;
                    } catch (err) {}
                    return -1;
                }(iframeWindows, win);
                if (-1 !== iframeIndex) {
                    var frame = iframeFrames[iframeIndex];
                    if (frame && function(frame) {
                        if (!frame.contentWindow) return !0;
                        if (!frame.parentNode) return !0;
                        var doc = frame.ownerDocument;
                        if (doc && doc.documentElement && !doc.documentElement.contains(frame)) {
                            var parent = frame;
                            for(; parent.parentNode && parent.parentNode !== parent;)parent = parent.parentNode;
                            if (!parent.host || !doc.documentElement.contains(parent.host)) return !0;
                        }
                        return !1;
                    }(frame)) return !0;
                }
                return !1;
            }
            function getAncestor(win) {
                void 0 === win && (win = window);
                return getOpener(win = win || window) || getParent(win) || void 0;
            }
            function matchDomain(pattern, origin) {
                if ("string" == typeof pattern) {
                    if ("string" == typeof origin) return "*" === pattern || origin === pattern;
                    if (isRegex(origin)) return !1;
                    if (Array.isArray(origin)) return !1;
                }
                return isRegex(pattern) ? isRegex(origin) ? pattern.toString() === origin.toString() : !Array.isArray(origin) && Boolean(origin.match(pattern)) : !!Array.isArray(pattern) && (Array.isArray(origin) ? JSON.stringify(pattern) === JSON.stringify(origin) : !isRegex(origin) && pattern.some(function(subpattern) {
                    return matchDomain(subpattern, origin);
                }));
            }
            function isWindow(obj) {
                try {
                    if (obj === window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if ("[object Window]" === ({}).toString.call(obj)) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (window.Window && obj instanceof window.Window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.self === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.parent === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.top === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && "__unlikely_value__" === obj.__cross_domain_utils_window_check__) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if ("postMessage" in obj && "self" in obj && "location" in obj) return !0;
                } catch (err) {}
                return !1;
            }
            function closeWindow(win) {
                try {
                    win.close();
                } catch (err) {}
            }
            function utils_isPromise(item) {
                try {
                    if (!item) return !1;
                    if ("undefined" != typeof Promise && item instanceof Promise) return !0;
                    if ("undefined" != typeof window && "function" == typeof window.Window && item instanceof window.Window) return !1;
                    if ("undefined" != typeof window && "function" == typeof window.constructor && item instanceof window.constructor) return !1;
                    var _toString = {}.toString;
                    if (_toString) {
                        var name = _toString.call(item);
                        if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                    }
                    if ("function" == typeof item.then) return !0;
                } catch (err) {
                    return !1;
                }
                return !1;
            }
            var dispatchedErrors = [];
            var possiblyUnhandledPromiseHandlers = [];
            var activeCount = 0;
            var flushPromise;
            function flushActive() {
                if (!activeCount && flushPromise) {
                    var promise = flushPromise;
                    flushPromise = null;
                    promise.resolve();
                }
            }
            function startActive() {
                activeCount += 1;
            }
            function endActive() {
                activeCount -= 1;
                flushActive();
            }
            var promise_ZalgoPromise = function() {
                function ZalgoPromise(handler) {
                    var _this = this;
                    this.resolved = void 0;
                    this.rejected = void 0;
                    this.errorHandled = void 0;
                    this.value = void 0;
                    this.error = void 0;
                    this.handlers = void 0;
                    this.dispatching = void 0;
                    this.stack = void 0;
                    this.resolved = !1;
                    this.rejected = !1;
                    this.errorHandled = !1;
                    this.handlers = [];
                    if (handler) {
                        var _result;
                        var _error;
                        var resolved = !1;
                        var rejected = !1;
                        var isAsync = !1;
                        startActive();
                        try {
                            handler(function(res) {
                                if (isAsync) _this.resolve(res);
                                else {
                                    resolved = !0;
                                    _result = res;
                                }
                            }, function(err) {
                                if (isAsync) _this.reject(err);
                                else {
                                    rejected = !0;
                                    _error = err;
                                }
                            });
                        } catch (err) {
                            endActive();
                            this.reject(err);
                            return;
                        }
                        endActive();
                        isAsync = !0;
                        resolved ? this.resolve(_result) : rejected && this.reject(_error);
                    }
                }
                var _proto = ZalgoPromise.prototype;
                _proto.resolve = function(result) {
                    if (this.resolved || this.rejected) return this;
                    if (utils_isPromise(result)) throw new Error("Can not resolve promise with another promise");
                    this.resolved = !0;
                    this.value = result;
                    this.dispatch();
                    return this;
                };
                _proto.reject = function(error) {
                    var _this2 = this;
                    if (this.resolved || this.rejected) return this;
                    if (utils_isPromise(error)) throw new Error("Can not reject promise with another promise");
                    if (!error) {
                        var _err = error && "function" == typeof error.toString ? error.toString() : ({}).toString.call(error);
                        error = new Error("Expected reject to be called with Error, got " + _err);
                    }
                    this.rejected = !0;
                    this.error = error;
                    this.errorHandled || setTimeout(function() {
                        _this2.errorHandled || function(err, promise) {
                            if (-1 === dispatchedErrors.indexOf(err)) {
                                dispatchedErrors.push(err);
                                setTimeout(function() {
                                    throw err;
                                }, 1);
                                for(var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++)possiblyUnhandledPromiseHandlers[j](err, promise);
                            }
                        }(error, _this2);
                    }, 1);
                    this.dispatch();
                    return this;
                };
                _proto.asyncReject = function(error) {
                    this.errorHandled = !0;
                    this.reject(error);
                    return this;
                };
                _proto.dispatch = function() {
                    var resolved = this.resolved, rejected = this.rejected, handlers = this.handlers;
                    if (!this.dispatching && (resolved || rejected)) {
                        this.dispatching = !0;
                        startActive();
                        var chain = function(firstPromise, secondPromise) {
                            return firstPromise.then(function(res) {
                                secondPromise.resolve(res);
                            }, function(err) {
                                secondPromise.reject(err);
                            });
                        };
                        for(var i = 0; i < handlers.length; i++){
                            var _handlers$i = handlers[i], onSuccess = _handlers$i.onSuccess, onError = _handlers$i.onError, promise = _handlers$i.promise;
                            var _result2 = void 0;
                            if (resolved) try {
                                _result2 = onSuccess ? onSuccess(this.value) : this.value;
                            } catch (err) {
                                promise.reject(err);
                                continue;
                            }
                            else if (rejected) {
                                if (!onError) {
                                    promise.reject(this.error);
                                    continue;
                                }
                                try {
                                    _result2 = onError(this.error);
                                } catch (err) {
                                    promise.reject(err);
                                    continue;
                                }
                            }
                            if (_result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected)) {
                                _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error);
                                _result2.errorHandled = !0;
                            } else utils_isPromise(_result2) ? _result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected) ? _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error) : chain(_result2, promise) : promise.resolve(_result2);
                        }
                        handlers.length = 0;
                        this.dispatching = !1;
                        endActive();
                    }
                };
                _proto.then = function(onSuccess, onError) {
                    if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                    if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                    var promise = new ZalgoPromise;
                    this.handlers.push({
                        promise: promise,
                        onSuccess: onSuccess,
                        onError: onError
                    });
                    this.errorHandled = !0;
                    this.dispatch();
                    return promise;
                };
                _proto.catch = function(onError) {
                    return this.then(void 0, onError);
                };
                _proto.finally = function(onFinally) {
                    if (onFinally && "function" != typeof onFinally && !onFinally.call) throw new Error("Promise.finally expected a function");
                    return this.then(function(result) {
                        return ZalgoPromise.try(onFinally).then(function() {
                            return result;
                        });
                    }, function(err) {
                        return ZalgoPromise.try(onFinally).then(function() {
                            throw err;
                        });
                    });
                };
                _proto.timeout = function(time, err) {
                    var _this3 = this;
                    if (this.resolved || this.rejected) return this;
                    var timeout = setTimeout(function() {
                        _this3.resolved || _this3.rejected || _this3.reject(err || new Error("Promise timed out after " + time + "ms"));
                    }, time);
                    return this.then(function(result) {
                        clearTimeout(timeout);
                        return result;
                    });
                };
                _proto.toPromise = function() {
                    if ("undefined" == typeof Promise) throw new TypeError("Could not find Promise");
                    return Promise.resolve(this);
                };
                ZalgoPromise.resolve = function(value) {
                    return value instanceof ZalgoPromise ? value : utils_isPromise(value) ? new ZalgoPromise(function(resolve, reject) {
                        return value.then(resolve, reject);
                    }) : (new ZalgoPromise).resolve(value);
                };
                ZalgoPromise.reject = function(error) {
                    return (new ZalgoPromise).reject(error);
                };
                ZalgoPromise.asyncReject = function(error) {
                    return (new ZalgoPromise).asyncReject(error);
                };
                ZalgoPromise.all = function(promises) {
                    var promise = new ZalgoPromise;
                    var count = promises.length;
                    var results = [];
                    if (!count) {
                        promise.resolve(results);
                        return promise;
                    }
                    var chain = function(i, firstPromise, secondPromise) {
                        return firstPromise.then(function(res) {
                            results[i] = res;
                            0 == (count -= 1) && promise.resolve(results);
                        }, function(err) {
                            secondPromise.reject(err);
                        });
                    };
                    for(var i = 0; i < promises.length; i++){
                        var prom = promises[i];
                        if (prom instanceof ZalgoPromise) {
                            if (prom.resolved) {
                                results[i] = prom.value;
                                count -= 1;
                                continue;
                            }
                        } else if (!utils_isPromise(prom)) {
                            results[i] = prom;
                            count -= 1;
                            continue;
                        }
                        chain(i, ZalgoPromise.resolve(prom), promise);
                    }
                    0 === count && promise.resolve(results);
                    return promise;
                };
                ZalgoPromise.hash = function(promises) {
                    var result = {};
                    var awaitPromises = [];
                    var _loop = function(key) {
                        if (promises.hasOwnProperty(key)) {
                            var value = promises[key];
                            utils_isPromise(value) ? awaitPromises.push(value.then(function(res) {
                                result[key] = res;
                            })) : result[key] = value;
                        }
                    };
                    for(var key in promises)_loop(key);
                    return ZalgoPromise.all(awaitPromises).then(function() {
                        return result;
                    });
                };
                ZalgoPromise.map = function(items, method) {
                    return ZalgoPromise.all(items.map(method));
                };
                ZalgoPromise.onPossiblyUnhandledException = function(handler) {
                    return function(handler) {
                        possiblyUnhandledPromiseHandlers.push(handler);
                        return {
                            cancel: function() {
                                possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                            }
                        };
                    }(handler);
                };
                ZalgoPromise.try = function(method, context, args) {
                    if (method && "function" != typeof method && !method.call) throw new Error("Promise.try expected a function");
                    var result;
                    startActive();
                    try {
                        result = method.apply(context, args || []);
                    } catch (err) {
                        endActive();
                        return ZalgoPromise.reject(err);
                    }
                    endActive();
                    return ZalgoPromise.resolve(result);
                };
                ZalgoPromise.delay = function(_delay) {
                    return new ZalgoPromise(function(resolve) {
                        setTimeout(resolve, _delay);
                    });
                };
                ZalgoPromise.isPromise = function(value) {
                    return !!(value && value instanceof ZalgoPromise) || utils_isPromise(value);
                };
                ZalgoPromise.flush = function() {
                    return function(Zalgo) {
                        var promise = flushPromise = flushPromise || new Zalgo;
                        flushActive();
                        return promise;
                    }(ZalgoPromise);
                };
                return ZalgoPromise;
            }();
            function util_safeIndexOf(collection, item) {
                for(var i = 0; i < collection.length; i++)try {
                    if (collection[i] === item) return i;
                } catch (err) {}
                return -1;
            }
            var weakmap_CrossDomainSafeWeakMap = function() {
                function CrossDomainSafeWeakMap() {
                    this.name = void 0;
                    this.weakmap = void 0;
                    this.keys = void 0;
                    this.values = void 0;
                    this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__";
                    if (function() {
                        if ("undefined" == typeof WeakMap) return !1;
                        if (void 0 === Object.freeze) return !1;
                        try {
                            var testWeakMap = new WeakMap;
                            var testKey = {};
                            Object.freeze(testKey);
                            testWeakMap.set(testKey, "__testvalue__");
                            return "__testvalue__" === testWeakMap.get(testKey);
                        } catch (err) {
                            return !1;
                        }
                    }()) try {
                        this.weakmap = new WeakMap;
                    } catch (err) {}
                    this.keys = [];
                    this.values = [];
                }
                var _proto = CrossDomainSafeWeakMap.prototype;
                _proto._cleanupClosedWindows = function() {
                    var weakmap = this.weakmap;
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++){
                        var value = keys[i];
                        if (isWindow(value) && isWindowClosed(value)) {
                            if (weakmap) try {
                                weakmap.delete(value);
                            } catch (err) {}
                            keys.splice(i, 1);
                            this.values.splice(i, 1);
                            i -= 1;
                        }
                    }
                };
                _proto.isSafeToReadWrite = function(key) {
                    return !isWindow(key);
                };
                _proto.set = function(key, value) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.set(key, value);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var name = this.name;
                        var entry = key[name];
                        entry && entry[0] === key ? entry[1] = value : Object.defineProperty(key, name, {
                            value: [
                                key,
                                value
                            ],
                            writable: !0
                        });
                        return;
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var keys = this.keys;
                    var values = this.values;
                    var index = util_safeIndexOf(keys, key);
                    if (-1 === index) {
                        keys.push(key);
                        values.push(value);
                    } else values[index] = value;
                };
                _proto.get = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return weakmap.get(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        return entry && entry[0] === key ? entry[1] : void 0;
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var index = util_safeIndexOf(this.keys, key);
                    if (-1 !== index) return this.values[index];
                };
                _proto.delete = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.delete(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var keys = this.keys;
                    var index = util_safeIndexOf(keys, key);
                    if (-1 !== index) {
                        keys.splice(index, 1);
                        this.values.splice(index, 1);
                    }
                };
                _proto.has = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return !0;
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        return !(!entry || entry[0] !== key);
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    return -1 !== util_safeIndexOf(this.keys, key);
                };
                _proto.getOrSet = function(key, getter) {
                    if (this.has(key)) return this.get(key);
                    var value = getter();
                    this.set(key, value);
                    return value;
                };
                return CrossDomainSafeWeakMap;
            }();
            function getFunctionName(fn) {
                return fn.name || fn.__name__ || fn.displayName || "anonymous";
            }
            function setFunctionName(fn, name) {
                try {
                    delete fn.name;
                    fn.name = name;
                } catch (err) {}
                fn.__name__ = fn.displayName = name;
                return fn;
            }
            function uniqueID() {
                var chars = "0123456789abcdef";
                return "xxxxxxxxxx".replace(/./g, function() {
                    return chars.charAt(Math.floor(Math.random() * chars.length));
                }) + "_" + (function(str) {
                    if ("function" == typeof btoa) return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(m, p1) {
                        return String.fromCharCode(parseInt(p1, 16));
                    }));
                    if ("undefined" != typeof $04b8ba6eff8b7085$require$Buffer) return $04b8ba6eff8b7085$require$Buffer.from(str, "utf8").toString("base64");
                    throw new Error("Can not find window.btoa or Buffer");
                })((new Date).toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            }
            var objectIDs;
            function serializeArgs(args) {
                try {
                    return JSON.stringify([].slice.call(args), function(subkey, val) {
                        return "function" == typeof val ? "memoize[" + function(obj) {
                            objectIDs = objectIDs || new weakmap_CrossDomainSafeWeakMap;
                            if (null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
                            var uid = objectIDs.get(obj);
                            if (!uid) {
                                uid = typeof obj + ":" + uniqueID();
                                objectIDs.set(obj, uid);
                            }
                            return uid;
                        }(val) + "]" : val;
                    });
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
            }
            var memoizedFunctions = [];
            function memoize(method, options) {
                var _this = this;
                void 0 === options && (options = {});
                var cacheMap = new weakmap_CrossDomainSafeWeakMap;
                var memoizedFunction = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var cache = cacheMap.getOrSet(options.thisNamespace ? this : method, function() {
                        return {};
                    });
                    var key = serializeArgs(args);
                    var cacheTime = options.time;
                    cache[key] && cacheTime && Date.now() - cache[key].time < cacheTime && delete cache[key];
                    if (cache[key]) return cache[key].value;
                    var time = Date.now();
                    var value = method.apply(this, arguments);
                    cache[key] = {
                        time: time,
                        value: value
                    };
                    return cache[key].value;
                };
                memoizedFunction.reset = function() {
                    cacheMap.delete(options.thisNamespace ? _this : method);
                };
                memoizedFunctions.push(memoizedFunction);
                return setFunctionName(memoizedFunction, (options.name || getFunctionName(method)) + "::memoized");
            }
            memoize.clear = function() {
                for(var _i2 = 0; _i2 < memoizedFunctions.length; _i2++)memoizedFunctions[_i2].reset();
            };
            function memoizePromise(method) {
                var cache = {};
                function memoizedPromiseFunction() {
                    var _arguments = arguments, _this2 = this;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    var key = serializeArgs(args);
                    if (cache.hasOwnProperty(key)) return cache[key];
                    cache[key] = promise_ZalgoPromise.try(function() {
                        return method.apply(_this2, _arguments);
                    }).finally(function() {
                        delete cache[key];
                    });
                    return cache[key];
                }
                memoizedPromiseFunction.reset = function() {
                    cache = {};
                };
                return setFunctionName(memoizedPromiseFunction, getFunctionName(method) + "::promiseMemoized");
            }
            function src_util_noop() {}
            function stringifyError(err, level) {
                void 0 === level && (level = 1);
                if (level >= 3) return "stringifyError stack overflow";
                try {
                    if (!err) return "<unknown error: " + ({}).toString.call(err) + ">";
                    if ("string" == typeof err) return err;
                    if (err instanceof Error) {
                        var stack = err && err.stack;
                        var message = err && err.message;
                        if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                        if (stack) return stack;
                        if (message) return message;
                    }
                    return err && err.toString && "function" == typeof err.toString ? err.toString() : ({}).toString.call(err);
                } catch (newErr) {
                    return "Error while stringifying error: " + stringifyError(newErr, level + 1);
                }
            }
            function stringify(item) {
                return "string" == typeof item ? item : item && item.toString && "function" == typeof item.toString ? item.toString() : ({}).toString.call(item);
            }
            memoize(function(obj) {
                if (Object.values) return Object.values(obj);
                var result = [];
                for(var key in obj)obj.hasOwnProperty(key) && result.push(obj[key]);
                return result;
            });
            function util_isRegex(item) {
                return "[object RegExp]" === ({}).toString.call(item);
            }
            function util_getOrSet(obj, key, getter) {
                if (obj.hasOwnProperty(key)) return obj[key];
                var val = getter();
                obj[key] = val;
                return val;
            }
            Error;
            function isDocumentReady() {
                return Boolean(document.body) && "complete" === document.readyState;
            }
            function isDocumentInteractive() {
                return Boolean(document.body) && "interactive" === document.readyState;
            }
            memoize(function() {
                return new promise_ZalgoPromise(function(resolve) {
                    if (isDocumentReady() || isDocumentInteractive()) return resolve();
                    var interval = setInterval(function() {
                        if (isDocumentReady() || isDocumentInteractive()) {
                            clearInterval(interval);
                            return resolve();
                        }
                    }, 10);
                });
            });
            var currentScript = "undefined" != typeof document ? document.currentScript : null;
            var getCurrentScript = memoize(function() {
                if (currentScript) return currentScript;
                if (currentScript = function() {
                    try {
                        var stack = function() {
                            try {
                                throw new Error("_");
                            } catch (err) {
                                return err.stack || "";
                            }
                        }();
                        var stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(stack);
                        var scriptLocation = stackDetails && stackDetails[1];
                        if (!scriptLocation) return;
                        for(var _i20 = 0, _Array$prototype$slic2 = [].slice.call(document.getElementsByTagName("script")).reverse(); _i20 < _Array$prototype$slic2.length; _i20++){
                            var script = _Array$prototype$slic2[_i20];
                            if (script.src && script.src === scriptLocation) return script;
                        }
                    } catch (err) {}
                }()) return currentScript;
                throw new Error("Can not determine current script");
            });
            var currentUID = uniqueID();
            memoize(function() {
                var script;
                try {
                    script = getCurrentScript();
                } catch (err) {
                    return currentUID;
                }
                var uid = script.getAttribute("data-uid");
                if (uid && "string" == typeof uid) return uid;
                uid = uniqueID();
                script.setAttribute("data-uid", uid);
                return uid;
            });
            function global_getGlobal(win) {
                void 0 === win && (win = window);
                var globalKey = "__post_robot_10_0_41__";
                return win !== window ? win[globalKey] : win[globalKey] = win[globalKey] || {};
            }
            var getObj = function() {
                return {};
            };
            function globalStore(key, defStore) {
                void 0 === key && (key = "store");
                void 0 === defStore && (defStore = getObj);
                return util_getOrSet(global_getGlobal(), key, function() {
                    var store = defStore();
                    return {
                        has: function(storeKey) {
                            return store.hasOwnProperty(storeKey);
                        },
                        get: function(storeKey, defVal) {
                            return store.hasOwnProperty(storeKey) ? store[storeKey] : defVal;
                        },
                        set: function(storeKey, val) {
                            store[storeKey] = val;
                            return val;
                        },
                        del: function(storeKey) {
                            delete store[storeKey];
                        },
                        getOrSet: function(storeKey, getter) {
                            return util_getOrSet(store, storeKey, getter);
                        },
                        reset: function() {
                            store = defStore();
                        },
                        keys: function() {
                            return Object.keys(store);
                        }
                    };
                });
            }
            var WildCard = function() {};
            function getWildcard() {
                var global = global_getGlobal();
                global.WINDOW_WILDCARD = global.WINDOW_WILDCARD || new WildCard;
                return global.WINDOW_WILDCARD;
            }
            function windowStore(key, defStore) {
                void 0 === key && (key = "store");
                void 0 === defStore && (defStore = getObj);
                return globalStore("windowStore").getOrSet(key, function() {
                    var winStore = new weakmap_CrossDomainSafeWeakMap;
                    var getStore = function(win) {
                        return winStore.getOrSet(win, defStore);
                    };
                    return {
                        has: function(win) {
                            return getStore(win).hasOwnProperty(key);
                        },
                        get: function(win, defVal) {
                            var store = getStore(win);
                            return store.hasOwnProperty(key) ? store[key] : defVal;
                        },
                        set: function(win, val) {
                            getStore(win)[key] = val;
                            return val;
                        },
                        del: function(win) {
                            delete getStore(win)[key];
                        },
                        getOrSet: function(win, getter) {
                            return util_getOrSet(getStore(win), key, getter);
                        }
                    };
                });
            }
            function getInstanceID() {
                return globalStore("instance").getOrSet("instanceID", uniqueID);
            }
            function resolveHelloPromise(win, _ref) {
                var domain = _ref.domain;
                var helloPromises = windowStore("helloPromises");
                var existingPromise = helloPromises.get(win);
                existingPromise && existingPromise.resolve({
                    domain: domain
                });
                var newPromise = promise_ZalgoPromise.resolve({
                    domain: domain
                });
                helloPromises.set(win, newPromise);
                return newPromise;
            }
            function sayHello(win, _ref4) {
                return (0, _ref4.send)(win, "postrobot_hello", {
                    instanceID: getInstanceID()
                }, {
                    domain: "*",
                    timeout: -1
                }).then(function(_ref5) {
                    var origin = _ref5.origin, instanceID = _ref5.data.instanceID;
                    resolveHelloPromise(win, {
                        domain: origin
                    });
                    return {
                        win: win,
                        domain: origin,
                        instanceID: instanceID
                    };
                });
            }
            function getWindowInstanceID(win, _ref6) {
                var send = _ref6.send;
                return windowStore("windowInstanceIDPromises").getOrSet(win, function() {
                    return sayHello(win, {
                        send: send
                    }).then(function(_ref7) {
                        return _ref7.instanceID;
                    });
                });
            }
            function markWindowKnown(win) {
                windowStore("knownWindows").set(win, !0);
            }
            function isSerializedType(item) {
                return "object" == typeof item && null !== item && "string" == typeof item.__type__;
            }
            function determineType(val) {
                return void 0 === val ? "undefined" : null === val ? "null" : Array.isArray(val) ? "array" : "function" == typeof val ? "function" : "object" == typeof val ? val instanceof Error ? "error" : "function" == typeof val.then ? "promise" : "[object RegExp]" === ({}).toString.call(val) ? "regex" : "[object Date]" === ({}).toString.call(val) ? "date" : "object" : "string" == typeof val ? "string" : "number" == typeof val ? "number" : "boolean" == typeof val ? "boolean" : void 0;
            }
            function serializeType(type, val) {
                return {
                    __type__: type,
                    __val__: val
                };
            }
            var _SERIALIZER;
            var SERIALIZER = ((_SERIALIZER = {}).function = function() {}, _SERIALIZER.error = function(_ref) {
                return serializeType("error", {
                    message: _ref.message,
                    stack: _ref.stack,
                    code: _ref.code,
                    data: _ref.data
                });
            }, _SERIALIZER.promise = function() {}, _SERIALIZER.regex = function(val) {
                return serializeType("regex", val.source);
            }, _SERIALIZER.date = function(val) {
                return serializeType("date", val.toJSON());
            }, _SERIALIZER.array = function(val) {
                return val;
            }, _SERIALIZER.object = function(val) {
                return val;
            }, _SERIALIZER.string = function(val) {
                return val;
            }, _SERIALIZER.number = function(val) {
                return val;
            }, _SERIALIZER.boolean = function(val) {
                return val;
            }, _SERIALIZER.null = function(val) {
                return val;
            }, _SERIALIZER);
            var defaultSerializers = {};
            var _DESERIALIZER;
            var DESERIALIZER = ((_DESERIALIZER = {}).function = function() {
                throw new Error("Function serialization is not implemented; nothing to deserialize");
            }, _DESERIALIZER.error = function(_ref2) {
                var stack = _ref2.stack, code = _ref2.code, data = _ref2.data;
                var error = new Error(_ref2.message);
                error.code = code;
                data && (error.data = data);
                error.stack = stack + "\n\n" + error.stack;
                return error;
            }, _DESERIALIZER.promise = function() {
                throw new Error("Promise serialization is not implemented; nothing to deserialize");
            }, _DESERIALIZER.regex = function(val) {
                return new RegExp(val);
            }, _DESERIALIZER.date = function(val) {
                return new Date(val);
            }, _DESERIALIZER.array = function(val) {
                return val;
            }, _DESERIALIZER.object = function(val) {
                return val;
            }, _DESERIALIZER.string = function(val) {
                return val;
            }, _DESERIALIZER.number = function(val) {
                return val;
            }, _DESERIALIZER.boolean = function(val) {
                return val;
            }, _DESERIALIZER.null = function(val) {
                return val;
            }, _DESERIALIZER);
            var defaultDeserializers = {};
            new promise_ZalgoPromise(function(resolve) {
                if (window.document && window.document.body) return resolve(window.document.body);
                var interval = setInterval(function() {
                    if (window.document && window.document.body) {
                        clearInterval(interval);
                        return resolve(window.document.body);
                    }
                }, 10);
            });
            function cleanupProxyWindows() {
                var idToProxyWindow = globalStore("idToProxyWindow");
                for(var _i2 = 0, _idToProxyWindow$keys2 = idToProxyWindow.keys(); _i2 < _idToProxyWindow$keys2.length; _i2++){
                    var id = _idToProxyWindow$keys2[_i2];
                    idToProxyWindow.get(id).shouldClean() && idToProxyWindow.del(id);
                }
            }
            function getSerializedWindow(winPromise, _ref) {
                var send = _ref.send, _ref$id = _ref.id, id = void 0 === _ref$id ? uniqueID() : _ref$id;
                var windowNamePromise = winPromise.then(function(win) {
                    if (isSameDomain(win)) return assertSameDomain(win).name;
                });
                var windowTypePromise = winPromise.then(function(window1) {
                    if (isWindowClosed(window1)) throw new Error("Window is closed, can not determine type");
                    return getOpener(window1) ? "popup" : "iframe";
                });
                windowNamePromise.catch(src_util_noop);
                windowTypePromise.catch(src_util_noop);
                return {
                    id: id,
                    getType: function() {
                        return windowTypePromise;
                    },
                    getInstanceID: memoizePromise(function() {
                        return winPromise.then(function(win) {
                            return getWindowInstanceID(win, {
                                send: send
                            });
                        });
                    }),
                    close: function() {
                        return winPromise.then(closeWindow);
                    },
                    getName: function() {
                        return winPromise.then(function(win) {
                            if (!isWindowClosed(win)) return isSameDomain(win) ? assertSameDomain(win).name : windowNamePromise;
                        });
                    },
                    focus: function() {
                        return winPromise.then(function(win) {
                            win.focus();
                        });
                    },
                    isClosed: function() {
                        return winPromise.then(function(win) {
                            return isWindowClosed(win);
                        });
                    },
                    setLocation: function(href) {
                        return winPromise.then(function(win) {
                            var domain = window.location.protocol + "//" + window.location.host;
                            if (0 === href.indexOf("/")) href = "" + domain + href;
                            else if (!href.match(/^https?:\/\//) && 0 !== href.indexOf(domain)) throw new Error("Expected url to be http or https url, or absolute path, got " + JSON.stringify(href));
                            if (isSameDomain(win)) try {
                                if (win.location && "function" == typeof win.location.replace) {
                                    win.location.replace(href);
                                    return;
                                }
                            } catch (err) {}
                            win.location = href;
                        });
                    },
                    setName: function(name) {
                        return winPromise.then(function(win) {
                            var sameDomain = isSameDomain(win);
                            var frame = function(win) {
                                if (isSameDomain(win)) return assertSameDomain(win).frameElement;
                                for(var _i21 = 0, _document$querySelect2 = document.querySelectorAll("iframe"); _i21 < _document$querySelect2.length; _i21++){
                                    var frame = _document$querySelect2[_i21];
                                    if (frame && frame.contentWindow && frame.contentWindow === win) return frame;
                                }
                            }(win);
                            if (!sameDomain) throw new Error("Can not set name for cross-domain window: " + name);
                            assertSameDomain(win).name = name;
                            frame && frame.setAttribute("name", name);
                            windowNamePromise = promise_ZalgoPromise.resolve(name);
                        });
                    }
                };
            }
            var window_ProxyWindow = function() {
                function ProxyWindow(_ref2) {
                    var send = _ref2.send, win = _ref2.win, serializedWindow = _ref2.serializedWindow;
                    this.id = void 0;
                    this.isProxyWindow = !0;
                    this.serializedWindow = void 0;
                    this.actualWindow = void 0;
                    this.actualWindowPromise = void 0;
                    this.send = void 0;
                    this.name = void 0;
                    this.actualWindowPromise = new promise_ZalgoPromise;
                    this.serializedWindow = serializedWindow || getSerializedWindow(this.actualWindowPromise, {
                        send: send
                    });
                    globalStore("idToProxyWindow").set(this.getID(), this);
                    win && this.setWindow(win, {
                        send: send
                    });
                }
                var _proto = ProxyWindow.prototype;
                _proto.getID = function() {
                    return this.serializedWindow.id;
                };
                _proto.getType = function() {
                    return this.serializedWindow.getType();
                };
                _proto.isPopup = function() {
                    return this.getType().then(function(type) {
                        return "popup" === type;
                    });
                };
                _proto.setLocation = function(href) {
                    var _this = this;
                    return this.serializedWindow.setLocation(href).then(function() {
                        return _this;
                    });
                };
                _proto.getName = function() {
                    return this.serializedWindow.getName();
                };
                _proto.setName = function(name) {
                    var _this2 = this;
                    return this.serializedWindow.setName(name).then(function() {
                        return _this2;
                    });
                };
                _proto.close = function() {
                    var _this3 = this;
                    return this.serializedWindow.close().then(function() {
                        return _this3;
                    });
                };
                _proto.focus = function() {
                    var _this4 = this;
                    var isPopupPromise = this.isPopup();
                    var getNamePromise = this.getName();
                    var reopenPromise = promise_ZalgoPromise.hash({
                        isPopup: isPopupPromise,
                        name: getNamePromise
                    }).then(function(_ref3) {
                        var name = _ref3.name;
                        _ref3.isPopup && name && window.open("", name);
                    });
                    var focusPromise = this.serializedWindow.focus();
                    return promise_ZalgoPromise.all([
                        reopenPromise,
                        focusPromise
                    ]).then(function() {
                        return _this4;
                    });
                };
                _proto.isClosed = function() {
                    return this.serializedWindow.isClosed();
                };
                _proto.getWindow = function() {
                    return this.actualWindow;
                };
                _proto.setWindow = function(win, _ref4) {
                    var send = _ref4.send;
                    this.actualWindow = win;
                    this.actualWindowPromise.resolve(this.actualWindow);
                    this.serializedWindow = getSerializedWindow(this.actualWindowPromise, {
                        send: send,
                        id: this.getID()
                    });
                    windowStore("winToProxyWindow").set(win, this);
                };
                _proto.awaitWindow = function() {
                    return this.actualWindowPromise;
                };
                _proto.matchWindow = function(win, _ref5) {
                    var _this5 = this;
                    var send = _ref5.send;
                    return promise_ZalgoPromise.try(function() {
                        return _this5.actualWindow ? win === _this5.actualWindow : promise_ZalgoPromise.hash({
                            proxyInstanceID: _this5.getInstanceID(),
                            knownWindowInstanceID: getWindowInstanceID(win, {
                                send: send
                            })
                        }).then(function(_ref6) {
                            var match = _ref6.proxyInstanceID === _ref6.knownWindowInstanceID;
                            match && _this5.setWindow(win, {
                                send: send
                            });
                            return match;
                        });
                    });
                };
                _proto.unwrap = function() {
                    return this.actualWindow || this;
                };
                _proto.getInstanceID = function() {
                    return this.serializedWindow.getInstanceID();
                };
                _proto.shouldClean = function() {
                    return Boolean(this.actualWindow && isWindowClosed(this.actualWindow));
                };
                _proto.serialize = function() {
                    return this.serializedWindow;
                };
                ProxyWindow.unwrap = function(win) {
                    return ProxyWindow.isProxyWindow(win) ? win.unwrap() : win;
                };
                ProxyWindow.serialize = function(win, _ref7) {
                    var send = _ref7.send;
                    cleanupProxyWindows();
                    return ProxyWindow.toProxyWindow(win, {
                        send: send
                    }).serialize();
                };
                ProxyWindow.deserialize = function(serializedWindow, _ref8) {
                    var send = _ref8.send;
                    cleanupProxyWindows();
                    return globalStore("idToProxyWindow").get(serializedWindow.id) || new ProxyWindow({
                        serializedWindow: serializedWindow,
                        send: send
                    });
                };
                ProxyWindow.isProxyWindow = function(obj) {
                    return Boolean(obj && !isWindow(obj) && obj.isProxyWindow);
                };
                ProxyWindow.toProxyWindow = function(win, _ref9) {
                    var send = _ref9.send;
                    cleanupProxyWindows();
                    if (ProxyWindow.isProxyWindow(win)) return win;
                    var actualWindow = win;
                    return windowStore("winToProxyWindow").get(actualWindow) || new ProxyWindow({
                        win: actualWindow,
                        send: send
                    });
                };
                return ProxyWindow;
            }();
            function addMethod(id, val, name, source, domain) {
                var methodStore = windowStore("methodStore");
                var proxyWindowMethods = globalStore("proxyWindowMethods");
                if (window_ProxyWindow.isProxyWindow(source)) proxyWindowMethods.set(id, {
                    val: val,
                    name: name,
                    domain: domain,
                    source: source
                });
                else {
                    proxyWindowMethods.del(id);
                    methodStore.getOrSet(source, function() {
                        return {};
                    })[id] = {
                        domain: domain,
                        name: name,
                        val: val,
                        source: source
                    };
                }
            }
            function lookupMethod(source, id) {
                var methodStore = windowStore("methodStore");
                var proxyWindowMethods = globalStore("proxyWindowMethods");
                return methodStore.getOrSet(source, function() {
                    return {};
                })[id] || proxyWindowMethods.get(id);
            }
            function function_serializeFunction(destination, domain, val, key, _ref3) {
                on = (_ref = {
                    on: _ref3.on,
                    send: _ref3.send
                }).on, send = _ref.send, globalStore("builtinListeners").getOrSet("functionCalls", function() {
                    return on("postrobot_method", {
                        domain: "*"
                    }, function(_ref2) {
                        var source = _ref2.source, origin = _ref2.origin, data = _ref2.data;
                        var id = data.id, name = data.name;
                        var meth = lookupMethod(source, id);
                        if (!meth) throw new Error("Could not find method '" + name + "' with id: " + data.id + " in " + getDomain(window));
                        var methodSource = meth.source, domain = meth.domain, val = meth.val;
                        return promise_ZalgoPromise.try(function() {
                            if (!matchDomain(domain, origin)) throw new Error("Method '" + data.name + "' domain " + JSON.stringify(util_isRegex(meth.domain) ? meth.domain.source : meth.domain) + " does not match origin " + origin + " in " + getDomain(window));
                            if (window_ProxyWindow.isProxyWindow(methodSource)) return methodSource.matchWindow(source, {
                                send: send
                            }).then(function(match) {
                                if (!match) throw new Error("Method call '" + data.name + "' failed - proxy window does not match source in " + getDomain(window));
                            });
                        }).then(function() {
                            return val.apply({
                                source: source,
                                origin: origin
                            }, data.args);
                        }, function(err) {
                            return promise_ZalgoPromise.try(function() {
                                if (val.onError) return val.onError(err);
                            }).then(function() {
                                err.stack && (err.stack = "Remote call to " + name + "(" + function(args) {
                                    void 0 === args && (args = []);
                                    var item;
                                    return (item = args, [].slice.call(item)).map(function(arg) {
                                        return "string" == typeof arg ? "'" + arg + "'" : void 0 === arg ? "undefined" : null === arg ? "null" : "boolean" == typeof arg ? arg.toString() : Array.isArray(arg) ? "[ ... ]" : "object" == typeof arg ? "{ ... }" : "function" == typeof arg ? "() => { ... }" : "<" + typeof arg + ">";
                                    }).join(", ");
                                }(data.args) + ") failed\n\n" + err.stack);
                                throw err;
                            });
                        }).then(function(result) {
                            return {
                                result: result,
                                id: id,
                                name: name
                            };
                        });
                    });
                });
                var _ref, on, send;
                var id = val.__id__ || uniqueID();
                destination = window_ProxyWindow.unwrap(destination);
                var name = val.__name__ || val.name || key;
                "string" == typeof name && "function" == typeof name.indexOf && 0 === name.indexOf("anonymous::") && (name = name.replace("anonymous::", key + "::"));
                if (window_ProxyWindow.isProxyWindow(destination)) {
                    addMethod(id, val, name, destination, domain);
                    destination.awaitWindow().then(function(win) {
                        addMethod(id, val, name, win, domain);
                    });
                } else addMethod(id, val, name, destination, domain);
                return serializeType("cross_domain_function", {
                    id: id,
                    name: name
                });
            }
            function serializeMessage(destination, domain, obj, _ref) {
                var _serialize;
                var on = _ref.on, send = _ref.send;
                return function(obj, serializers) {
                    void 0 === serializers && (serializers = defaultSerializers);
                    var result = JSON.stringify(obj, function(key) {
                        var val = this[key];
                        if (isSerializedType(this)) return val;
                        var type = determineType(val);
                        if (!type) return val;
                        var serializer = serializers[type] || SERIALIZER[type];
                        return serializer ? serializer(val, key) : val;
                    });
                    return void 0 === result ? "undefined" : result;
                }(obj, ((_serialize = {}).promise = function(val, key) {
                    return function(destination, domain, val, key, _ref) {
                        return serializeType("cross_domain_zalgo_promise", {
                            then: function_serializeFunction(destination, domain, function(resolve, reject) {
                                return val.then(resolve, reject);
                            }, key, {
                                on: _ref.on,
                                send: _ref.send
                            })
                        });
                    }(destination, domain, val, key, {
                        on: on,
                        send: send
                    });
                }, _serialize.function = function(val, key) {
                    return function_serializeFunction(destination, domain, val, key, {
                        on: on,
                        send: send
                    });
                }, _serialize.object = function(val) {
                    return isWindow(val) || window_ProxyWindow.isProxyWindow(val) ? serializeType("cross_domain_window", window_ProxyWindow.serialize(val, {
                        send: send
                    })) : val;
                }, _serialize));
            }
            function deserializeMessage(source, origin, message, _ref2) {
                var _deserialize;
                var send = _ref2.send;
                return function(str, deserializers) {
                    void 0 === deserializers && (deserializers = defaultDeserializers);
                    if ("undefined" !== str) return JSON.parse(str, function(key, val) {
                        if (isSerializedType(this)) return val;
                        var type;
                        var value;
                        if (isSerializedType(val)) {
                            type = val.__type__;
                            value = val.__val__;
                        } else {
                            type = determineType(val);
                            value = val;
                        }
                        if (!type) return value;
                        var deserializer = deserializers[type] || DESERIALIZER[type];
                        return deserializer ? deserializer(value, key) : value;
                    });
                }(message, ((_deserialize = {}).cross_domain_zalgo_promise = function(serializedPromise) {
                    return function(source, origin, _ref2) {
                        return new promise_ZalgoPromise(_ref2.then);
                    }(0, 0, serializedPromise);
                }, _deserialize.cross_domain_function = function(serializedFunction) {
                    return function(source, origin, _ref4, _ref5) {
                        var id = _ref4.id, name = _ref4.name;
                        var send = _ref5.send;
                        var getDeserializedFunction = function(opts) {
                            void 0 === opts && (opts = {});
                            function crossDomainFunctionWrapper() {
                                var _arguments = arguments;
                                return window_ProxyWindow.toProxyWindow(source, {
                                    send: send
                                }).awaitWindow().then(function(win) {
                                    var meth = lookupMethod(win, id);
                                    if (meth && meth.val !== crossDomainFunctionWrapper) return meth.val.apply({
                                        source: window,
                                        origin: getDomain()
                                    }, _arguments);
                                    var _args = [].slice.call(_arguments);
                                    return opts.fireAndForget ? send(win, "postrobot_method", {
                                        id: id,
                                        name: name,
                                        args: _args
                                    }, {
                                        domain: origin,
                                        fireAndForget: !0
                                    }) : send(win, "postrobot_method", {
                                        id: id,
                                        name: name,
                                        args: _args
                                    }, {
                                        domain: origin,
                                        fireAndForget: !1
                                    }).then(function(res) {
                                        return res.data.result;
                                    });
                                }).catch(function(err) {
                                    throw err;
                                });
                            }
                            crossDomainFunctionWrapper.__name__ = name;
                            crossDomainFunctionWrapper.__origin__ = origin;
                            crossDomainFunctionWrapper.__source__ = source;
                            crossDomainFunctionWrapper.__id__ = id;
                            crossDomainFunctionWrapper.origin = origin;
                            return crossDomainFunctionWrapper;
                        };
                        var crossDomainFunctionWrapper = getDeserializedFunction();
                        crossDomainFunctionWrapper.fireAndForget = getDeserializedFunction({
                            fireAndForget: !0
                        });
                        return crossDomainFunctionWrapper;
                    }(source, origin, serializedFunction, {
                        send: send
                    });
                }, _deserialize.cross_domain_window = function(serializedWindow) {
                    return window_ProxyWindow.deserialize(serializedWindow, {
                        send: send
                    });
                }, _deserialize));
            }
            var SEND_MESSAGE_STRATEGIES = {};
            SEND_MESSAGE_STRATEGIES.postrobot_post_message = function(win, serializedMessage, domain) {
                0 === domain.indexOf("file:") && (domain = "*");
                win.postMessage(serializedMessage, domain);
            };
            function send_sendMessage(win, domain, message, _ref2) {
                var on = _ref2.on, send = _ref2.send;
                return promise_ZalgoPromise.try(function() {
                    var domainBuffer = windowStore().getOrSet(win, function() {
                        return {};
                    });
                    domainBuffer.buffer = domainBuffer.buffer || [];
                    domainBuffer.buffer.push(message);
                    domainBuffer.flush = domainBuffer.flush || promise_ZalgoPromise.flush().then(function() {
                        if (isWindowClosed(win)) throw new Error("Window is closed");
                        var serializedMessage = serializeMessage(win, domain, ((_ref = {}).__post_robot_10_0_41__ = domainBuffer.buffer || [], _ref), {
                            on: on,
                            send: send
                        });
                        var _ref;
                        delete domainBuffer.buffer;
                        var strategies = Object.keys(SEND_MESSAGE_STRATEGIES);
                        var errors = [];
                        for(var _i2 = 0; _i2 < strategies.length; _i2++){
                            var strategyName = strategies[_i2];
                            try {
                                SEND_MESSAGE_STRATEGIES[strategyName](win, serializedMessage, domain);
                            } catch (err) {
                                errors.push(err);
                            }
                        }
                        if (errors.length === strategies.length) throw new Error("All post-robot messaging strategies failed:\n\n" + errors.map(function(err, i) {
                            return i + ". " + stringifyError(err);
                        }).join("\n\n"));
                    });
                    return domainBuffer.flush.then(function() {
                        delete domainBuffer.flush;
                    });
                }).then(src_util_noop);
            }
            function getResponseListener(hash) {
                return globalStore("responseListeners").get(hash);
            }
            function deleteResponseListener(hash) {
                globalStore("responseListeners").del(hash);
            }
            function isResponseListenerErrored(hash) {
                return globalStore("erroredResponseListeners").has(hash);
            }
            function getRequestListener(_ref) {
                var name = _ref.name, win = _ref.win, domain = _ref.domain;
                var requestListeners = windowStore("requestListeners");
                "*" === win && (win = null);
                "*" === domain && (domain = null);
                if (!name) throw new Error("Name required to get request listener");
                for(var _i4 = 0, _ref3 = [
                    win,
                    getWildcard()
                ]; _i4 < _ref3.length; _i4++){
                    var winQualifier = _ref3[_i4];
                    if (winQualifier) {
                        var nameListeners = requestListeners.get(winQualifier);
                        if (nameListeners) {
                            var domainListeners = nameListeners[name];
                            if (domainListeners) {
                                if (domain && "string" == typeof domain) {
                                    if (domainListeners[domain]) return domainListeners[domain];
                                    if (domainListeners.__domain_regex__) for(var _i6 = 0, _domainListeners$__DO2 = domainListeners.__domain_regex__; _i6 < _domainListeners$__DO2.length; _i6++){
                                        var _domainListeners$__DO3 = _domainListeners$__DO2[_i6], listener = _domainListeners$__DO3.listener;
                                        if (matchDomain(_domainListeners$__DO3.regex, domain)) return listener;
                                    }
                                }
                                if (domainListeners["*"]) return domainListeners["*"];
                            }
                        }
                    }
                }
            }
            function handleRequest(source, origin, message, _ref) {
                var on = _ref.on, send = _ref.send;
                var options = getRequestListener({
                    name: message.name,
                    win: source,
                    domain: origin
                });
                var logName = "postrobot_method" === message.name && message.data && "string" == typeof message.data.name ? message.data.name + "()" : message.name;
                function sendResponse(ack, data, error) {
                    return promise_ZalgoPromise.flush().then(function() {
                        if (!message.fireAndForget && !isWindowClosed(source)) try {
                            return send_sendMessage(source, origin, {
                                id: uniqueID(),
                                origin: getDomain(window),
                                type: "postrobot_message_response",
                                hash: message.hash,
                                name: message.name,
                                ack: ack,
                                data: data,
                                error: error
                            }, {
                                on: on,
                                send: send
                            });
                        } catch (err) {
                            throw new Error("Send response message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                        }
                    });
                }
                return promise_ZalgoPromise.all([
                    promise_ZalgoPromise.flush().then(function() {
                        if (!message.fireAndForget && !isWindowClosed(source)) try {
                            return send_sendMessage(source, origin, {
                                id: uniqueID(),
                                origin: getDomain(window),
                                type: "postrobot_message_ack",
                                hash: message.hash,
                                name: message.name
                            }, {
                                on: on,
                                send: send
                            });
                        } catch (err) {
                            throw new Error("Send ack message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                        }
                    }),
                    promise_ZalgoPromise.try(function() {
                        if (!options) throw new Error("No handler found for post message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                        if (!matchDomain(options.domain, origin)) throw new Error("Request origin " + origin + " does not match domain " + options.domain.toString());
                        return options.handler({
                            source: source,
                            origin: origin,
                            data: message.data
                        });
                    }).then(function(data) {
                        return sendResponse("success", data);
                    }, function(error) {
                        return sendResponse("error", null, error);
                    })
                ]).then(src_util_noop).catch(function(err) {
                    if (options && options.handleError) return options.handleError(err);
                    throw err;
                });
            }
            function handleAck(source, origin, message) {
                if (!isResponseListenerErrored(message.hash)) {
                    var options = getResponseListener(message.hash);
                    if (!options) throw new Error("No handler found for post message ack for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    try {
                        if (!matchDomain(options.domain, origin)) throw new Error("Ack origin " + origin + " does not match domain " + options.domain.toString());
                        if (source !== options.win) throw new Error("Ack source does not match registered window");
                    } catch (err) {
                        options.promise.reject(err);
                    }
                    options.ack = !0;
                }
            }
            function handleResponse(source, origin, message) {
                if (!isResponseListenerErrored(message.hash)) {
                    var options = getResponseListener(message.hash);
                    if (!options) throw new Error("No handler found for post message response for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    if (!matchDomain(options.domain, origin)) throw new Error("Response origin " + origin + " does not match domain " + (pattern = options.domain, Array.isArray(pattern) ? "(" + pattern.join(" | ") + ")" : isRegex(pattern) ? "RegExp(" + pattern.toString() : pattern.toString()));
                    var pattern;
                    if (source !== options.win) throw new Error("Response source does not match registered window");
                    deleteResponseListener(message.hash);
                    "error" === message.ack ? options.promise.reject(message.error) : "success" === message.ack && options.promise.resolve({
                        source: source,
                        origin: origin,
                        data: message.data
                    });
                }
            }
            function receive_receiveMessage(event, _ref2) {
                var on = _ref2.on, send = _ref2.send;
                var receivedMessages = globalStore("receivedMessages");
                try {
                    if (!window || window.closed || !event.source) return;
                } catch (err) {
                    return;
                }
                var source = event.source, origin = event.origin;
                var messages = function(message, source, origin, _ref) {
                    var on = _ref.on, send = _ref.send;
                    var parsedMessage;
                    try {
                        parsedMessage = deserializeMessage(source, origin, message, {
                            on: on,
                            send: send
                        });
                    } catch (err) {
                        return;
                    }
                    if (parsedMessage && "object" == typeof parsedMessage && null !== parsedMessage) {
                        var parseMessages = parsedMessage.__post_robot_10_0_41__;
                        if (Array.isArray(parseMessages)) return parseMessages;
                    }
                }(event.data, source, origin, {
                    on: on,
                    send: send
                });
                if (messages) {
                    markWindowKnown(source);
                    for(var _i2 = 0; _i2 < messages.length; _i2++){
                        var message = messages[_i2];
                        if (receivedMessages.has(message.id)) return;
                        receivedMessages.set(message.id, !0);
                        if (isWindowClosed(source) && !message.fireAndForget) return;
                        0 === message.origin.indexOf("file:") && (origin = "file://");
                        try {
                            "postrobot_message_request" === message.type ? handleRequest(source, origin, message, {
                                on: on,
                                send: send
                            }) : "postrobot_message_response" === message.type ? handleResponse(source, origin, message) : "postrobot_message_ack" === message.type && handleAck(source, origin, message);
                        } catch (err) {
                            setTimeout(function() {
                                throw err;
                            }, 0);
                        }
                    }
                }
            }
            function on_on(name, options, handler) {
                if (!name) throw new Error("Expected name");
                if ("function" == typeof (options = options || {})) {
                    handler = options;
                    options = {};
                }
                if (!handler) throw new Error("Expected handler");
                (options = options || {}).name = name;
                options.handler = handler || options.handler;
                var win = options.window;
                var domain = options.domain;
                var requestListener = function addRequestListener(_ref4, listener) {
                    var name = _ref4.name, win = _ref4.win, domain = _ref4.domain;
                    var requestListeners = windowStore("requestListeners");
                    if (!name || "string" != typeof name) throw new Error("Name required to add request listener");
                    if (Array.isArray(win)) {
                        var listenersCollection = [];
                        for(var _i8 = 0, _win2 = win; _i8 < _win2.length; _i8++)listenersCollection.push(addRequestListener({
                            name: name,
                            domain: domain,
                            win: _win2[_i8]
                        }, listener));
                        return {
                            cancel: function() {
                                for(var _i10 = 0; _i10 < listenersCollection.length; _i10++)listenersCollection[_i10].cancel();
                            }
                        };
                    }
                    if (Array.isArray(domain)) {
                        var _listenersCollection = [];
                        for(var _i12 = 0, _domain2 = domain; _i12 < _domain2.length; _i12++)_listenersCollection.push(addRequestListener({
                            name: name,
                            win: win,
                            domain: _domain2[_i12]
                        }, listener));
                        return {
                            cancel: function() {
                                for(var _i14 = 0; _i14 < _listenersCollection.length; _i14++)_listenersCollection[_i14].cancel();
                            }
                        };
                    }
                    var existingListener = getRequestListener({
                        name: name,
                        win: win,
                        domain: domain
                    });
                    win && "*" !== win || (win = getWildcard());
                    domain = domain || "*";
                    if (existingListener) throw win && domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString() + " for " + (win === getWildcard() ? "wildcard" : "specified") + " window") : win ? new Error("Request listener already exists for " + name + " for " + (win === getWildcard() ? "wildcard" : "specified") + " window") : domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString()) : new Error("Request listener already exists for " + name);
                    var nameListeners = requestListeners.getOrSet(win, function() {
                        return {};
                    });
                    var domainListeners = util_getOrSet(nameListeners, name, function() {
                        return {};
                    });
                    var strDomain = domain.toString();
                    var regexListeners;
                    var regexListener;
                    util_isRegex(domain) ? (regexListeners = util_getOrSet(domainListeners, "__domain_regex__", function() {
                        return [];
                    })).push(regexListener = {
                        regex: domain,
                        listener: listener
                    }) : domainListeners[strDomain] = listener;
                    return {
                        cancel: function() {
                            delete domainListeners[strDomain];
                            if (regexListener) {
                                regexListeners.splice(regexListeners.indexOf(regexListener, 1));
                                regexListeners.length || delete domainListeners.__domain_regex__;
                            }
                            Object.keys(domainListeners).length || delete nameListeners[name];
                            win && !Object.keys(nameListeners).length && requestListeners.del(win);
                        }
                    };
                }({
                    name: name,
                    win: win,
                    domain: domain
                }, {
                    handler: options.handler,
                    handleError: options.errorHandler || function(err) {
                        throw err;
                    },
                    window: win,
                    domain: domain || "*",
                    name: name
                });
                return {
                    cancel: function() {
                        requestListener.cancel();
                    }
                };
            }
            function on_once(name, options, handler) {
                if ("function" == typeof (options = options || {})) {
                    handler = options;
                    options = {};
                }
                var promise = new promise_ZalgoPromise;
                var listener;
                options.errorHandler = function(err) {
                    listener.cancel();
                    promise.reject(err);
                };
                listener = on_on(name, options, function(event) {
                    listener.cancel();
                    promise.resolve(event);
                    if (handler) return handler(event);
                });
                promise.cancel = listener.cancel;
                return promise;
            }
            var send_send = function send(win, name, data, options) {
                var domainMatcher = (options = options || {}).domain || "*";
                var responseTimeout = options.timeout || -1;
                var childTimeout = options.timeout || 5e3;
                var fireAndForget = options.fireAndForget || !1;
                return promise_ZalgoPromise.try(function() {
                    !function(name, win, domain) {
                        if (!name) throw new Error("Expected name");
                        if (domain && "string" != typeof domain && !Array.isArray(domain) && !util_isRegex(domain)) throw new TypeError("Can not send " + name + ". Expected domain " + JSON.stringify(domain) + " to be a string, array, or regex");
                        if (isWindowClosed(win)) throw new Error("Can not send " + name + ". Target window is closed");
                    }(name, win, domainMatcher);
                    if (function(parent, child) {
                        var actualParent = getAncestor(child);
                        if (actualParent) return actualParent === parent;
                        if (child === parent) return !1;
                        if (function(win) {
                            void 0 === win && (win = window);
                            try {
                                if (win.top) return win.top;
                            } catch (err) {}
                            if (getParent(win) === win) return win;
                            try {
                                if (isAncestorParent(window, win) && window.top) return window.top;
                            } catch (err) {}
                            try {
                                if (isAncestorParent(win, window) && window.top) return window.top;
                            } catch (err) {}
                            for(var _i7 = 0, _getAllChildFrames4 = function getAllChildFrames(win) {
                                var result = [];
                                for(var _i3 = 0, _getFrames2 = getFrames(win); _i3 < _getFrames2.length; _i3++){
                                    var frame = _getFrames2[_i3];
                                    result.push(frame);
                                    for(var _i5 = 0, _getAllChildFrames2 = getAllChildFrames(frame); _i5 < _getAllChildFrames2.length; _i5++)result.push(_getAllChildFrames2[_i5]);
                                }
                                return result;
                            }(win); _i7 < _getAllChildFrames4.length; _i7++){
                                var frame = _getAllChildFrames4[_i7];
                                try {
                                    if (frame.top) return frame.top;
                                } catch (err) {}
                                if (getParent(frame) === frame) return frame;
                            }
                        }(child) === child) return !1;
                        for(var _i15 = 0, _getFrames8 = getFrames(parent); _i15 < _getFrames8.length; _i15++)if (_getFrames8[_i15] === child) return !0;
                        return !1;
                    }(window, win)) return function(win, timeout, name) {
                        void 0 === timeout && (timeout = 5e3);
                        void 0 === name && (name = "Window");
                        var promise = function(win) {
                            return windowStore("helloPromises").getOrSet(win, function() {
                                return new promise_ZalgoPromise;
                            });
                        }(win);
                        -1 !== timeout && (promise = promise.timeout(timeout, new Error(name + " did not load after " + timeout + "ms")));
                        return promise;
                    }(win, childTimeout);
                }).then(function(_temp) {
                    return function(win, targetDomain, actualDomain, _ref) {
                        var send = _ref.send;
                        return promise_ZalgoPromise.try(function() {
                            return "string" == typeof targetDomain ? targetDomain : promise_ZalgoPromise.try(function() {
                                return actualDomain || sayHello(win, {
                                    send: send
                                }).then(function(_ref2) {
                                    return _ref2.domain;
                                });
                            }).then(function(normalizedDomain) {
                                if (!matchDomain(targetDomain, targetDomain)) throw new Error("Domain " + stringify(targetDomain) + " does not match " + stringify(targetDomain));
                                return normalizedDomain;
                            });
                        });
                    }(win, domainMatcher, (void 0 === _temp ? {} : _temp).domain, {
                        send: send
                    });
                }).then(function(targetDomain) {
                    var domain = targetDomain;
                    var logName = "postrobot_method" === name && data && "string" == typeof data.name ? data.name + "()" : name;
                    var promise = new promise_ZalgoPromise;
                    var hash = name + "_" + uniqueID();
                    if (!fireAndForget) {
                        var responseListener = {
                            name: name,
                            win: win,
                            domain: domain,
                            promise: promise
                        };
                        !function(hash, listener) {
                            globalStore("responseListeners").set(hash, listener);
                        }(hash, responseListener);
                        var reqPromises = windowStore("requestPromises").getOrSet(win, function() {
                            return [];
                        });
                        reqPromises.push(promise);
                        promise.catch(function() {
                            !function(hash) {
                                globalStore("erroredResponseListeners").set(hash, !0);
                            }(hash);
                            deleteResponseListener(hash);
                        });
                        var totalAckTimeout = function(win) {
                            return windowStore("knownWindows").get(win, !1);
                        }(win) ? 1e4 : 2e3;
                        var totalResTimeout = responseTimeout;
                        var ackTimeout = totalAckTimeout;
                        var resTimeout = totalResTimeout;
                        var interval = function(method, time) {
                            var timeout;
                            !function loop() {
                                timeout = setTimeout(function() {
                                    !function() {
                                        if (isWindowClosed(win)) return promise.reject(new Error("Window closed for " + name + " before " + (responseListener.ack ? "response" : "ack")));
                                        if (responseListener.cancelled) return promise.reject(new Error("Response listener was cancelled for " + name));
                                        ackTimeout = Math.max(ackTimeout - 500, 0);
                                        -1 !== resTimeout && (resTimeout = Math.max(resTimeout - 500, 0));
                                        responseListener.ack || 0 !== ackTimeout ? 0 === resTimeout && promise.reject(new Error("No response for postMessage " + logName + " in " + getDomain() + " in " + totalResTimeout + "ms")) : promise.reject(new Error("No ack for postMessage " + logName + " in " + getDomain() + " in " + totalAckTimeout + "ms"));
                                    }();
                                    loop();
                                }, 500);
                            }();
                            return {
                                cancel: function() {
                                    clearTimeout(timeout);
                                }
                            };
                        }();
                        promise.finally(function() {
                            interval.cancel();
                            reqPromises.splice(reqPromises.indexOf(promise, 1));
                        }).catch(src_util_noop);
                    }
                    return send_sendMessage(win, domain, {
                        id: uniqueID(),
                        origin: getDomain(window),
                        type: "postrobot_message_request",
                        hash: hash,
                        name: name,
                        data: data,
                        fireAndForget: fireAndForget
                    }, {
                        on: on_on,
                        send: send
                    }).then(function() {
                        return fireAndForget ? promise.resolve() : promise;
                    }, function(err) {
                        throw new Error("Send request message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                    });
                });
            };
            function setup_serializeMessage(destination, domain, obj) {
                return serializeMessage(destination, domain, obj, {
                    on: on_on,
                    send: send_send
                });
            }
            function setup_deserializeMessage(source, origin, message) {
                return deserializeMessage(source, origin, message, {
                    on: on_on,
                    send: send_send
                });
            }
            function createProxyWindow(win) {
                return new window_ProxyWindow({
                    send: send_send,
                    win: win
                });
            }
            function setup_toProxyWindow(win) {
                return window_ProxyWindow.toProxyWindow(win, {
                    send: send_send
                });
            }
            function setup() {
                if (!global_getGlobal().initialized) {
                    global_getGlobal().initialized = !0;
                    on = (_ref3 = {
                        on: on_on,
                        send: send_send
                    }).on, send = _ref3.send, (global = global_getGlobal()).receiveMessage = global.receiveMessage || function(message) {
                        return receive_receiveMessage(message, {
                            on: on,
                            send: send
                        });
                    };
                    !function(_ref5) {
                        var on = _ref5.on, send = _ref5.send;
                        globalStore().getOrSet("postMessageListener", function() {
                            return function(obj, event, handler) {
                                obj.addEventListener("message", handler);
                                return {
                                    cancel: function() {
                                        obj.removeEventListener("message", handler);
                                    }
                                };
                            }(window, 0, function(event) {
                                !function(event, _ref4) {
                                    var on = _ref4.on, send = _ref4.send;
                                    promise_ZalgoPromise.try(function() {
                                        var source = event.source || event.sourceElement;
                                        var origin = event.origin || event.originalEvent && event.originalEvent.origin;
                                        var data = event.data;
                                        "null" === origin && (origin = "file://");
                                        if (source) {
                                            if (!origin) throw new Error("Post message did not have origin domain");
                                            receive_receiveMessage({
                                                source: source,
                                                origin: origin,
                                                data: data
                                            }, {
                                                on: on,
                                                send: send
                                            });
                                        }
                                    });
                                }(event, {
                                    on: on,
                                    send: send
                                });
                            });
                        });
                    }({
                        on: on_on,
                        send: send_send
                    });
                    !function(_ref8) {
                        var on = _ref8.on, send = _ref8.send;
                        globalStore("builtinListeners").getOrSet("helloListener", function() {
                            var listener = on("postrobot_hello", {
                                domain: "*"
                            }, function(_ref3) {
                                resolveHelloPromise(_ref3.source, {
                                    domain: _ref3.origin
                                });
                                return {
                                    instanceID: getInstanceID()
                                };
                            });
                            var parent = getAncestor();
                            parent && sayHello(parent, {
                                send: send
                            }).catch(function(err) {});
                            return listener;
                        });
                    }({
                        on: on_on,
                        send: send_send
                    });
                }
                var _ref3, on, send, global;
            }
            function destroy() {
                !function() {
                    var responseListeners = globalStore("responseListeners");
                    for(var _i2 = 0, _responseListeners$ke2 = responseListeners.keys(); _i2 < _responseListeners$ke2.length; _i2++){
                        var hash = _responseListeners$ke2[_i2];
                        var listener = responseListeners.get(hash);
                        listener && (listener.cancelled = !0);
                        responseListeners.del(hash);
                    }
                }();
                (listener = globalStore().get("postMessageListener")) && listener.cancel();
                var listener;
                delete window.__post_robot_10_0_41__;
            }
            var src_types_TYPES_0 = !0;
            function cleanUpWindow(win) {
                for(var _i2 = 0, _requestPromises$get2 = windowStore("requestPromises").get(win, []); _i2 < _requestPromises$get2.length; _i2++)_requestPromises$get2[_i2].reject(new Error("Window " + (isWindowClosed(win) ? "closed" : "cleaned up") + " before response")).catch(src_util_noop);
            }
            setup();
        }
    ]);
});

});

parcelRegister("4ZTaE", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $aoVih = parcelRequire("aoVih");


var $ccHMk = parcelRequire("ccHMk");


var $i35rc = parcelRequire("i35rc");

const $e24cf88a4f07ee68$var$styles = {
    box: "_1h6d1xiv _1dqonqa1 _189e1dm9"
};
const $e24cf88a4f07ee68$var$ThreeLOPrompt = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(13);
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $i35rc.useAuth)(props);
    const { authUrl: authUrl, onInitialization: onInitialization } = props;
    let t0;
    let t1;
    if ($[0] !== onInitialization) {
        t0 = ()=>{
            if (onInitialization) onInitialization();
        };
        t1 = [
            onInitialization
        ];
        $[0] = onInitialization;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
    if (!authUrl || authUrl === "") {
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
                appearance: "error"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e24cf88a4f07ee68$var$messages.noAuthURLErrorMessage));
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t2;
    if ($[4] !== promptMessage) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, promptMessage);
        $[4] = promptMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== buttonText || $[7] !== loading || $[8] !== startAuth) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: startAuth,
            isLoading: loading
        }, buttonText);
        $[6] = buttonText;
        $[7] = loading;
        $[8] = startAuth;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t2 || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            onPointerDown: $e24cf88a4f07ee68$var$_temp,
            padding: "space.250",
            xcss: $e24cf88a4f07ee68$var$styles.box
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            alignInline: "start",
            space: "space.250",
            grow: "hug",
            testId: "three-lo-prompt"
        }, t2, t3)));
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : (props)=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $i35rc.useAuth)(props);
    const { authUrl: authUrl, onInitialization: onInitialization } = props;
    (0, $42omo.useEffect)(()=>{
        if (onInitialization) onInitialization();
    }, [
        onInitialization
    ]);
    if (!authUrl || authUrl === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e24cf88a4f07ee68$var$messages.noAuthURLErrorMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onPointerDown: (e)=>e.stopPropagation(),
        padding: "space.250",
        xcss: $e24cf88a4f07ee68$var$styles.box
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignInline: "start",
        space: "space.250",
        grow: "hug",
        testId: "three-lo-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, promptMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: startAuth,
        isLoading: loading
    }, buttonText))));
};
var $e24cf88a4f07ee68$export$2e2bcd8739ae039 = $e24cf88a4f07ee68$var$ThreeLOPrompt;
const $e24cf88a4f07ee68$export$92dadb4ff2941f34 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { forgeDoc: forgeDoc, dispatch: dispatch } = t0;
    const { message: message, authUrl: authUrl, promptText: promptText } = forgeDoc.props;
    let t1;
    if ($[0] !== dispatch) {
        t1 = ()=>dispatch({
                type: "render",
                extensionData: {}
            });
        $[0] = dispatch;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== authUrl || $[3] !== message || $[4] !== promptText || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e24cf88a4f07ee68$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            onSuccess: t1
        });
        $[2] = authUrl;
        $[3] = message;
        $[4] = promptText;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { message: message, authUrl: authUrl, promptText: promptText } = forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e24cf88a4f07ee68$var$ThreeLOPrompt, {
        message: message,
        authUrl: authUrl,
        promptText: promptText,
        onSuccess: ()=>dispatch({
                type: 'render',
                extensionData: {}
            })
    });
};
const $e24cf88a4f07ee68$export$388ff2bd3ce4e348 = ({ appName: appName, onSuccess: onSuccess })=>{
    return function threeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e24cf88a4f07ee68$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return dispatch({
                    type: 'render',
                    extensionData: {}
                });
            }
        });
    };
};
const $e24cf88a4f07ee68$export$7519b5f6e74be543 = ({ appName: appName, onSuccess: onSuccess, message: message, onInitialization: onInitialization })=>{
    return function threeLOPrompt(props) {
        const { authUrl: authUrl, promptText: promptText, onSuccess: onSuccessFromIframeComponent } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e24cf88a4f07ee68$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return Promise.resolve(onSuccessFromIframeComponent);
            },
            onInitialization: onInitialization
        });
    };
};
const $e24cf88a4f07ee68$var$messages = (0, $aXWIB.defineMessages)({
    noAuthURLErrorMessage: {
        id: "confluence.threeLOPrompt.no.authURL.error-message",
        defaultMessage: "Consent URL not found. Please refresh the page and try again."
    }
});
function $e24cf88a4f07ee68$var$_temp(e) {
    return e.stopPropagation();
}
module.exports["default"] = $e24cf88a4f07ee68$export$2e2bcd8739ae039;
module.exports["ThreeLOPromptRenderFn"] = $e24cf88a4f07ee68$export$92dadb4ff2941f34;
module.exports["makeThreeLOPromptForCustomUI"] = $e24cf88a4f07ee68$export$7519b5f6e74be543;

});

parcelRegister("jLYRk", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iXCQx = parcelRequire("iXCQx");


var $gGmck = parcelRequire("gGmck");


var $1nSBE = parcelRequire("1nSBE");

const $a08eb7c3df84467c$var$useDeprecationWarning = (0, $4pOgL.isReactCompilerActivePlatform)() ? (componentName)=>{
    const $ = (0, $frIzR.c)(4);
    const { forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    let t0;
    let t1;
    if ($[0] !== componentName || $[1] !== forgeEnvironment) {
        t0 = ()=>{
            if (forgeEnvironment !== "PRODUCTION") (0, $1nSBE.default)(`[@forge/react: ${componentName}] Warning: The "${componentName}" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
        };
        t1 = [
            forgeEnvironment,
            componentName
        ];
        $[0] = componentName;
        $[1] = forgeEnvironment;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t0, t1);
} : (componentName)=>{
    const { forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (forgeEnvironment !== 'PRODUCTION') (0, $1nSBE.default)(`[@forge/react: ${componentName}] Warning: The "${componentName}" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
    }, [
        forgeEnvironment,
        componentName
    ]);
};
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $a08eb7c3df84467c$var$PROTOCOL_ALLOWLIST = [
    'http:',
    'https:',
    'ftp:',
    'ftps:',
    'mailto:',
    'skype:',
    'callto:',
    'facetime:',
    'git:',
    'irc:',
    'irc6:',
    'news:',
    'nntp:',
    'feed:',
    'cvs:',
    'svn:',
    'mvn:',
    'ssh:',
    'scp:',
    'sftp:',
    'itms:',
    'notes:',
    'hipchat:',
    'sourcetree:',
    'urn:',
    'tel:',
    'xmpp:',
    'telnet:',
    'vnc:',
    'rdp:',
    'whatsapp:',
    'slack:',
    'sip:',
    'sips:',
    'magnet:',
    'tds:'
];
const $a08eb7c3df84467c$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    if ($a08eb7c3df84467c$var$PROTOCOL_ALLOWLIST.includes(url.protocol)) return url.toString();
    else return 'about:blank';
};
const $a08eb7c3df84467c$export$e7bdca014c19fc5c = (0, $4pOgL.isReactCompilerActivePlatform)() ? function Em(t0) {
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    $a08eb7c3df84467c$var$useDeprecationWarning("Em");
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "em"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function Em({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Em');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "em"
    }, children);
};
const $a08eb7c3df84467c$export$97176b8d51d2058f = (0, $4pOgL.isReactCompilerActivePlatform)() ? function Strike(t0) {
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    $a08eb7c3df84467c$var$useDeprecationWarning("Strike");
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("s", null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function Strike({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Strike');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("s", null, children);
};
const $a08eb7c3df84467c$export$89b8e0fa65f6a914 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function String(t0) {
    const $ = (0, $frIzR.c)(2);
    const { text: text } = t0;
    let t1;
    if ($[0] !== text) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, text);
        $[0] = text;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function String({ text: text }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, text);
};
const $a08eb7c3df84467c$export$f301627d437cff88 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function Strong(t0) {
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    $a08eb7c3df84467c$var$useDeprecationWarning("Strong");
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "strong"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function Strong({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Strong');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "strong"
    }, children);
};
function $a08eb7c3df84467c$var$wrap(Component) {
    return function WrappedComponent({ Components: Components, children: children, props: propsAny, render: render, renderChildren: renderChildren, dispatch: dispatch }) {
        const props = propsAny;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props, renderChildren({
            Components: Components,
            children: children,
            render: render,
            dispatch: dispatch
        }));
    };
}
const $a08eb7c3df84467c$export$fec26b2d751c6d95 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$e7bdca014c19fc5c);
const $a08eb7c3df84467c$export$e9e7c187aef6a83a = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$97176b8d51d2058f);
const $a08eb7c3df84467c$export$11a9c970dcafffc0 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$89b8e0fa65f6a914);
const $a08eb7c3df84467c$export$566c617eb72a5976 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$f301627d437cff88);
module.exports["sanitizeUrl"] = $a08eb7c3df84467c$export$300bd6d67c49dbfc;
module.exports["EmFn"] = $a08eb7c3df84467c$export$fec26b2d751c6d95;
module.exports["StrikeFn"] = $a08eb7c3df84467c$export$e9e7c187aef6a83a;
module.exports["StringFn"] = $a08eb7c3df84467c$export$11a9c970dcafffc0;
module.exports["StrongFn"] = $a08eb7c3df84467c$export$566c617eb72a5976;

});

parcelRegister("gGmck", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4a7ba83bf95919d5$export$1e9ea4edb6d1bfe6 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["RendererContext"] = $4a7ba83bf95919d5$export$1e9ea4edb6d1bfe6;

});

parcelRegister("1nSBE", function(module, exports) {
$parcel$export(module.exports, "default", () => $da27ee5222cf5f14$export$2e2bcd8739ae039);
// Displays a warning message only once per message to avoid spamming the console with the same message multiple times.
const $da27ee5222cf5f14$var$messages = new Set();
function $da27ee5222cf5f14$export$2e2bcd8739ae039(message) {
    if ($da27ee5222cf5f14$var$messages.has(message)) return;
    $da27ee5222cf5f14$var$messages.add(message);
    if (typeof window !== 'undefined') // eslint-disable-next-line no-console
    console.warn(message);
}

});

parcelRegister("kO2Re", function(module, exports) {
/* CustomUIRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $h6bEF = parcelRequire("h6bEF");


var $gj7hi = parcelRequire("gj7hi");


var $8CZUH = parcelRequire("8CZUH");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $hnPaP = parcelRequire("hnPaP");


var $5k6WH = parcelRequire("5k6WH");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $1c598 = parcelRequire("1c598");


var $i9F01 = parcelRequire("i9F01");













var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $jdPfT = parcelRequire("jdPfT");







const $24512c570241c19f$export$8350d65d9a3785ef = ({ isBridgeModal: isBridgeModal, isMacroExtension: isMacroExtension, modalSize: modalSize, title: title, icon: icon, extension: extension, modalExtension: modalExtension, onClose: onClose, closeModalExtension: closeModalExtension, executeViewOnCloseCallback: executeViewOnCloseCallback })=>{
    /* Title/icon source priority:
   * - Bridge modals:
   *     - Use title/icon props (passed in from bridge call)
   *     - Fallback to extension.properties.title for fullscreen modals with empty title
   *     - For non-fullscreen modals, we won't render the header if the title prop is not provided
   * - Modal extension points: Use modalExtension.title and extensionIcon, defaults to extension name if not provided
   */ const modalTitle = isBridgeModal ? modalSize === 'fullscreen' && !title ? extension.properties.title : title : modalExtension?.title || extension.properties.title;
    /**
   * Icon rendering logic:
   * - Bridge modals: show icon section only if icon prop is provided
   * - Macro extension points: always show icon section (uses extension icon or AddonIcon fallback)
   * - Other modals: no icon section
   */ const shouldShowIcon = isBridgeModal ? !!icon : isMacroExtension;
    const modalIcon = isBridgeModal ? icon : (0, $i9F01.getExtensionIcon)(extension);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, shouldShowIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, modalIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: modalIcon,
        alt: "",
        width: "24px",
        height: "24px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, modalTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, modalTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: "Close Modal",
        onClick: isBridgeModal ? onClose : async ()=>{
            try {
                await executeViewOnCloseCallback();
            } finally{
                closeModalExtension?.();
            }
        }
    }));
};



var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");








const $dabc5de6ec4f71e9$export$7844aa44752a3a21 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { closeProps: closeProps, modalContent: modalContent, headerProps: headerProps } = t0;
    let t1;
    if ($[0] !== headerProps) {
        t1 = headerProps.isMacroExtension || headerProps.isBridgeModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $24512c570241c19f$export$8350d65d9a3785ef), headerProps) : null;
        $[0] = headerProps;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== closeProps || $[3] !== modalContent || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnPaP.FullScreenModalDialog), {
            ...closeProps,
            testId: "custom-ui-fullscreen-modal-dialog"
        }, t1, modalContent);
        $[2] = closeProps;
        $[3] = modalContent;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ closeProps: closeProps, modalContent: modalContent, headerProps: headerProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnPaP.FullScreenModalDialog), {
        ...closeProps,
        testId: "custom-ui-fullscreen-modal-dialog"
    }, headerProps.isMacroExtension || headerProps.isBridgeModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $24512c570241c19f$export$8350d65d9a3785ef), headerProps) : null, modalContent);
};



var $amyZ5 = parcelRequire("amyZ5");











var $6oQb1 = parcelRequire("6oQb1");


var $jc2GP = parcelRequire("jc2GP");


var $37B9X = parcelRequire("37B9X");











var $jed12 = parcelRequire("jed12");


var $9ZQdx = parcelRequire("9ZQdx");

const $ed3dec07128042c6$export$95197f008126b1a1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(19);
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, extension: extension, forgeDoc: forgeDoc, loadingComponent: loadingComponent, mentionProvider: mentionProvider, modalExtension: modalExtension, onAppError: onAppError, onError: onError, onSuccess: onSuccess, product: product } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    let t0;
    if ($[0] !== accountId || $[1] !== bridge || $[2] !== cloudId || $[3] !== components || $[4] !== mentionProvider || $[5] !== product || $[6] !== workspaceId) {
        t0 = {
            accountId: accountId,
            bridge: bridge,
            cloudId: cloudId,
            workspaceId: workspaceId,
            mentionProvider: mentionProvider,
            product: product,
            components: components
        };
        $[0] = accountId;
        $[1] = bridge;
        $[2] = cloudId;
        $[3] = components;
        $[4] = mentionProvider;
        $[5] = product;
        $[6] = workspaceId;
        $[7] = t0;
    } else t0 = $[7];
    const getComponents = (0, $9ZQdx.useUIKitComponents)(t0);
    let t1;
    if ($[8] !== onAppError || $[9] !== onError) {
        t1 = (err)=>{
            onError?.(err.message);
            onAppError?.(err.message);
        };
        $[8] = onAppError;
        $[9] = onError;
        $[10] = t1;
    } else t1 = $[10];
    const handleError = t1;
    if (!forgeDoc) return null;
    let t2;
    if ($[11] !== extension || $[12] !== forgeDoc || $[13] !== getComponents || $[14] !== handleError || $[15] !== loadingComponent || $[16] !== modalExtension || $[17] !== onSuccess) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
            forgeDoc: forgeDoc,
            extension: extension,
            components: getComponents,
            modalExtension: modalExtension,
            extensionType: "xen:macro",
            loading: true,
            loadingComponent: loadingComponent,
            onError: handleError,
            onSuccess: onSuccess
        });
        $[11] = extension;
        $[12] = forgeDoc;
        $[13] = getComponents;
        $[14] = handleError;
        $[15] = loadingComponent;
        $[16] = modalExtension;
        $[17] = onSuccess;
        $[18] = t2;
    } else t2 = $[18];
    return t2;
} : (props)=>{
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, extension: extension, forgeDoc: forgeDoc, loadingComponent: loadingComponent, mentionProvider: mentionProvider, modalExtension: modalExtension, onAppError: onAppError, onError: onError, onSuccess: onSuccess, product: product } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const getComponents = (0, $9ZQdx.useUIKitComponents)({
        accountId: accountId,
        bridge: bridge,
        cloudId: cloudId,
        workspaceId: workspaceId,
        mentionProvider: mentionProvider,
        product: product,
        components: components
    });
    const handleError = (0, $42omo.useCallback)((err)=>{
        onError?.(err.message);
        onAppError?.(err.message);
    }, [
        onError,
        onAppError
    ]);
    if (!forgeDoc) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
        forgeDoc: forgeDoc,
        extension: extension,
        components: getComponents,
        modalExtension: modalExtension,
        extensionType: 'xen:macro',
        loading: true,
        loadingComponent: loadingComponent,
        onError: handleError,
        onSuccess: onSuccess
    });
};



var $artsb = parcelRequire("artsb");


var $b4nol = parcelRequire("b4nol");


var $hBtmC = parcelRequire("hBtmC");


var $80yqV = parcelRequire("80yqV");

const $8537409554582c9d$var$styles = {
    modalDeprecationMessage: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $8537409554582c9d$export$17d9f1e4832027c9 = ({ accountId: accountId, bridge: bridge, contextIds: contextIds, contextChangeListeners: contextChangeListeners, coreData: coreData, customBridgeMethods: customBridgeMethods, customBridge: customBridge, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, iframeRef: iframeRef, isInModal: isInModal, loadingComponent: loadingComponent, locale: locale, localId: localId, modalStyles: modalStyles, modalProvider: modalProvider, onIframeLoad: onIframeLoad, onModalCustomUIRendererClose: onModalCustomUIRendererClose, product: product, timezone: timezone, getModalWidth: getModalWidth, setIsLoading: setIsLoading, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId })=>{
    const [error, setError] = (0, $42omo.useState)(null); // modalOptions is null when no modal is open is non null when opened
    // Uses InternalModalState to allow extension property from FAUS forwarding
    const [modalOptions, setModalOptions] = (0, $42omo.useState)(null);
    const [viewOnClose, setViewOnClose] = (0, $42omo.useState)();
    const [embeddedUIKitModalContext, setEmbeddedUIKitModalContext] = (0, $42omo.useState)(null);
    const onCloseFromModalClass = modalOptions?.onClose;
    const embeddedMacroModalProps = modalOptions?.isEmbeddedMacroModal ? {
        extensionPayload: modalOptions?.extensionPayload,
        // Extension view data in macro module is only reserved for bodied macro content.
        // Since we don't support embedded bodied macros, extensionViewData will always be undefined.
        extensionViewData: undefined,
        coreData: {
            ...coreData,
            localId: modalOptions?.embeddedMacroLocalId || ''
        }
    } : {};
    const iframeProps = {
        accountId: accountId,
        contextIds: contextIds,
        contextChangeListeners: contextChangeListeners,
        components: getThreeLOPrompt,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        customBridge: customBridge,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        isHidden: isIframeHidden,
        isResizable: isIframeResizable,
        locale: locale,
        timezone: timezone,
        loadingComponent: loadingComponent,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedParentLocalId: embeddedParentLocalId,
        ...(0, $dh538.fg)('platform_faus_navigate_to_product') ? {} : embeddedMacroModalProps
    };
    const modalIframeProps = {
        ...iframeProps,
        ...embeddedMacroModalProps
    };
    const isBodiedMacro = extension.properties?.layout === 'bodied';
    const extensionInModal = (0, $42omo.useMemo)(()=>{
        // Use the embedded macro's extension if provided (for modals opened from embedded macros)
        const baseExtension = modalOptions?.extension || extension; // `openModal`'s resource is optional; only override when one is explicitly provided. When it is
        // omitted the modal defaults to the current resource, so we inherit it (and its entry) untouched.
        let resourceOverride = {};
        if (modalOptions?.resource) resourceOverride = (0, $dh538.fg)('forge-ui-multi-entry-resource-macro-config-fix') ? (0, $37B9X.resolveDynamicResource)(modalOptions.resource) : {
            resource: modalOptions.resource
        };
        return {
            ...baseExtension,
            // Pass a type that is not included in the dimensions presets so that it falls back to default
            type: `${baseExtension.type}::dynamic-modal`,
            properties: {
                ...baseExtension.properties,
                ...resourceOverride
            }
        };
    }, [
        extension,
        modalOptions?.resource,
        modalOptions?.extension
    ]);
    const onError = (error)=>{
        // Under bridge v2 the runtime overlay owns error display, so don't take over the
        // surface here — setting error would unmount the iframe and the overlay with it.
        if (error && !(0, $dh538.fg)('forge-ui-bridge-core-reset')) setError(error);
    };
    const extensionDataInModal = (0, $42omo.useMemo)(()=>{
        // Use the embedded macro's extensionData if provided (for modals opened from embedded macros)
        const baseExtensionData = modalOptions?.extensionData || extensionData;
        return {
            ...baseExtensionData,
            ...modalOptions?.context ? {
                modal: modalOptions?.context
            } : {},
            // This is to handle an incompatibility issue with Compass and JSM where they are incorrectly currently spreading the context object on the top level instead of in the `modal` object.
            // Remove once Compass apps have been updated https://softwareteams.atlassian.net/browse/COMPASS-22051 and a notice to app developers have been sent out
            ...(product === 'compass' || extension.type.startsWith('jiraServiceManagement')) && modalOptions?.context ? {
                ...modalOptions?.context
            } : {}
        };
    }, [
        extension.type,
        extensionData,
        modalOptions?.context,
        modalOptions?.extensionData,
        product
    ]);
    const handleModalTearDown = (0, $42omo.useCallback)(()=>{
        setModalOptions(null);
    }, [
        setModalOptions
    ]);
    const isReducedMotion = (0, $5k6WH.useIsReducedMotion)();
    const handleModalClose = (0, $42omo.useCallback)(()=>{
        onCloseFromModalClass?.(); // if reduced motion is enabled, we need to call handleModalTearDown here as it no longer calls `onCloseComplete` in `ModalCustomUIRenderer`
        if (isReducedMotion) handleModalTearDown();
    }, [
        isReducedMotion,
        onCloseFromModalClass,
        handleModalTearDown
    ]); // Confluence specific feature
    // Needed to show Forge modals in live pages. dialogs won't be passed in if the page isn't live.
    (0, $42omo.useEffect)(()=>{
        if (product !== 'confluence') return;
        if (dialogs && modalOptions) dialogs.showDialog($8537409554582c9d$export$5d28a207fd7621f6, {
            extension: extensionInModal,
            extensionData: extensionDataInModal,
            localId: localId,
            onTearDown: handleModalTearDown,
            bridge: bridge,
            size: modalOptions.size,
            closeOnEscape: modalOptions.closeOnEscape,
            closeOnOverlayClick: modalOptions.closeOnOverlayClick
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        modalOptions,
        dialogs
    ]); // Only reachable without bridge-core-reset; under it `error` stays null and the runtime overlay
    // renders ForgeAppErrorMessage instead.
    // TODO: remove once forge-ui-bridge-core-reset is fully rolled out.
    if (error && (0, $80yqV.shouldRenderForgeAppErrorMessage)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hBtmC.ForgeAppErrorMessage), {
        extension: extension,
        error: error
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isBodiedMacro && embeddedUIKitModalContext?.forgeDoc && embeddedUIKitModalContext?.extension && (0, $dh538.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed3dec07128042c6$export$95197f008126b1a1), {
        accountId: accountId,
        bridge: bridge,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        forgeDoc: embeddedUIKitModalContext.forgeDoc,
        extension: embeddedUIKitModalContext.extension,
        getThreeLOPrompt: getThreeLOPrompt,
        loadingComponent: loadingComponent,
        product: product,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h6bEF.Iframe), {
        ...iframeProps,
        entryPoint: entryPoint,
        isResizable: isIframeResizable,
        customBridge: {
            ...customBridge,
            ...isBodiedMacro && (0, $dh538.fg)('forge-ui-bridge-core-reset') ? {
                setEmbeddedMacroModalForgeDoc: (_ctx, payload)=>{
                    setEmbeddedUIKitModalContext(payload?.embeddedUIKitModalContext ?? null);
                }
            } : {}
        },
        bridge: {
            ...bridge,
            openModal: (opts)=>{
                setModalOptions(opts.data);
                return true;
            },
            ...onModalCustomUIRendererClose ? {
                close: (payload)=>{
                    onModalCustomUIRendererClose().then(()=>{
                        bridge?.close?.(payload);
                    }).finally(()=>{
                        return true;
                    });
                }
            } : {}
        },
        customBridgeMethods: {
            ...customBridgeMethods,
            ...isBodiedMacro && (0, $dh538.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent') ? {
                setEmbeddedMacroModalForgeDoc: (payload)=>{
                    setEmbeddedUIKitModalContext(payload?.embeddedUIKitModalContext);
                }
            } : {}
        },
        height: height,
        width: width,
        isInModal: isInModal,
        ref: iframeRef,
        onLoad: onIframeLoad,
        setIsLoading: setIsLoading,
        onError: onError
    }), modalOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8537409554582c9d$export$5d28a207fd7621f6, {
        ...(0, $dh538.fg)('platform_faus_navigate_to_product') ? modalIframeProps : iframeProps,
        product: product,
        getThreeLOPrompt: getThreeLOPrompt,
        dialogs: dialogs,
        extension: extensionInModal,
        extensionData: extensionDataInModal,
        localId: modalOptions?.embeddedMacroLocalId || localId,
        onTearDown: handleModalTearDown,
        bridge: {
            ...bridge,
            onClose: (callback)=>{
                setViewOnClose(()=>callback.data); // stores the callback for when modal is closed
                return true;
            },
            close: (payload)=>{
                onCloseFromModalClass?.(payload.data);
                return true;
            }
        },
        modalOnClose: handleModalClose,
        size: modalOptions.size,
        title: modalOptions.title,
        icon: modalOptions.icon,
        closeOnEscape: modalOptions.closeOnEscape,
        closeOnOverlayClick: modalOptions.closeOnOverlayClick,
        modalStyles: modalStyles,
        modalProvider: modalProvider,
        getModalWidth: getModalWidth,
        isIframeResizable: isIframeResizable,
        viewOnClose: viewOnClose,
        customBridge: customBridge
    }) : null);
};
const $8537409554582c9d$export$5d28a207fd7621f6 = ({ accountId: accountId, bridge: bridge, coreData: coreData, closeOnEscape: closeOnEscape, closeOnOverlayClick: closeOnOverlayClick, consentMessage: consentMessage, contextChangeListeners: contextChangeListeners, contextIds: contextIds, customBridgeMethods: customBridgeMethods, customBridge: customBridge, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, isIframeHidden: isIframeHidden = false, isIframeResizable: isIframeResizable = false, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: ModalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onTearDown: onTearDown, product: product, size: size, title: title, icon: icon, timezone: timezone, getModalWidth: getModalWidth, modalOnClose: // onClose from `Modal`
modalOnClose, viewOnClose: // onClose from `view`
viewOnClose })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true); // This is for preventing inline dialog apps from being closed by an esc key press when a
    // modal is open until https://product-fabric.atlassian.net/browse/DSP-3552 is resolved.
    (0, $42omo.useEffect)(()=>{
        if (product !== 'confluence' || modalExtension?.type === 'macroConfig' || product === 'confluence' && modalExtension?.type === 'bylineItem') return;
        function dismissEscape(e) {
            if (e.key === 'Escape') {
                e.stopPropagation();
                if (closeOnEscape) {
                    modalOnClose?.();
                    setIsOpen(false);
                }
            }
        }
        if (isOpen) document.addEventListener('keydown', dismissEscape, {
            capture: true
        });
        return ()=>document.removeEventListener('keydown', dismissEscape, {
                capture: true
            });
    }, [
        isOpen,
        closeOnEscape,
        product,
        modalOnClose,
        modalExtension?.type
    ]);
    const { trackExtensionLoaded: trackExtensionLoaded, trackBridgeSucceed: trackBridgeSucceed, trackBridgeFailed: trackBridgeFailed } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const extensionType = (0, $jc2GP.getExtensionType)(extension?.properties);
    const environmentType = extension?.environmentType;
    const isMacroExtension = extension?.type === (0, $1c598.ConfluenceExtension).MACRO; // Only tracking fullscreen modals
    (0, $42omo.useEffect)(()=>{
        if (modalExtension?.modalWidth === 'fullscreen') trackExtensionLoaded({
            forgeEnvironment: environmentType,
            renderType: 'CustomUI',
            extensionType: extensionType,
            viewportSize: 'fullscreen'
        });
    }, [
        modalExtension?.modalWidth,
        environmentType,
        extensionType,
        trackExtensionLoaded
    ]); // TODO: Delete on forge-ui-refactor-custom-ui-modal flag cleanup
    const modalWidthForMacroCustomConfig = extension.type === (0, $1c598.ConfluenceExtension).MACRO && modalExtension?.modalWidth !== undefined && (0, $b4nol.isNamedSize)(modalExtension.modalWidth) ? modalExtension.modalWidth : undefined;
    const sizeString = typeof size === 'object' ? undefined : size; // TODO: Delete modalSize and modalWidth on forge-ui-refactor-custom-ui-modal flag cleanup (replaced by resolvedDimensions)
    const modalSize = modalWidthForMacroCustomConfig ?? sizeString ?? // safeguards old logic against custom sizes
    extension.properties.viewportSize ?? 'medium';
    const modalWidth = getModalWidth ? getModalWidth(sizeString) : (0, $i9F01.getAtlasKitModalWidth)(modalSize); // If size is defined, iframe modal should not be resizable.
    // In JSM ONLY, iframe modal should ALWAYS be resizable.
    // Iframe should scale to 100% of the modal so that Select drop downs are not cut off
    // If developer is using Modal() from bridge and they pick 'resizable' size, the modal will always be resizable.
    const isJsmModule = extension.type.startsWith('jiraServiceManagement');
    const isResizableSize = modalSize === 'resizable' && (0, $dh538.fg)('forge-ui-enable-resizable-custom-ui-modal');
    const isModalResizable = isResizableSize || isJsmModule || (size !== undefined ? false : isIframeResizable);
    const shouldShowFCFModalDeprecationMessage = (extension.type === (0, $1c598.JiraExtension).CUSTOM_FIELD || extension.type === (0, $1c598.JiraExtension).CUSTOM_FIELD_TYPE) && !(0, $dh538.fg)('forge_disable_fcf_modal_experience_on_issue_view');
    const executeViewOnCloseCallback = async ()=>{
        if (viewOnClose) try {
            await viewOnClose();
            trackBridgeSucceed({
                method: 'onClose',
                forgeEnvironment: extension.environmentType
            });
        } catch (error) {
            trackBridgeFailed({
                method: 'onClose',
                errorName: error instanceof Error ? error.name : 'UnknownError',
                forgeEnvironment: extension.environmentType
            });
        }
    };
    const renderModal = ()=>{
        const closeProps = {
            onClose: async ()=>{
                try {
                    await executeViewOnCloseCallback();
                } finally{
                    modalOnClose?.();
                    setIsOpen(false);
                }
            },
            onCloseComplete: onTearDown,
            ...(0, $dh538.fg)('forge-ui-refactor-custom-ui-modal') ? {
                shouldCloseOnEscapePress: closeOnEscape
            } : {}
        }; // Moved up from below as needed for ModalContentWrapper
        const isBridgeModal = !modalExtension;
        const supportsFullscreenModal = modalSize === 'fullscreen' && (isBridgeModal || (0, $artsb.FULLSCREEN_SUPPORTED_EXTENSION_TYPES).has(extension.type));
        const resolvedDimensions = (0, $dh538.fg)('forge-ui-refactor-custom-ui-modal') ? (0, $i9F01.resolveModalDimensions)({
            size: modalExtension?.modalWidth ?? size ?? extension.properties.viewportSize,
            getModalWidth: getModalWidth,
            shouldFallbackFromFullscreen: modalSize === 'fullscreen' && !supportsFullscreenModal,
            isResizableSize: isResizableSize
        }) : undefined;
        const modalContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldShowFCFModalDeprecationMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $8537409554582c9d$var$styles.modalDeprecationMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amyZ5.ForgeModalDeprecationMessage), {
            extension: extension
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i9F01.ModalContentWrapper), {
            size: resolvedDimensions?.contentSize ?? modalSize,
            styles: modalStyles,
            isResizable: isModalResizable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8537409554582c9d$export$17d9f1e4832027c9, {
            product: product,
            coreData: coreData,
            getThreeLOPrompt: getThreeLOPrompt,
            dialogs: dialogs,
            accountId: accountId,
            contextChangeListeners: contextChangeListeners,
            contextIds: contextIds,
            extension: extension,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            customBridge: customBridge,
            consentMessage: consentMessage,
            entryPoint: entryPoint,
            getContextToken: getContextToken,
            height: "100%",
            isIframeHidden: isIframeHidden,
            isIframeResizable: isModalResizable,
            locale: locale,
            localId: localId,
            mentionProvider: mentionProvider,
            modalExtension: modalExtension,
            onConsentSuccess: onConsentSuccess,
            onForgeDocUpdated: onForgeDocUpdated,
            timezone: timezone,
            onConsentModalClose: onConsentModalClose,
            onError: onError,
            onIframeLoad: onIframeLoad,
            loadingComponent: loadingComponent,
            extensionPayload: extensionPayload,
            modalStyles: modalStyles,
            onModalCustomUIRendererClose: async ()=>{
                try {
                    await executeViewOnCloseCallback();
                } finally{
                    setIsOpen(false); // If is a modal extension point, call modalOnClose to reset state from product
                    // This is required to reset the state of the modal in the product when view.close is called
                    if (modalExtension) modalOnClose?.();
                }
            },
            isInModal: true
        }))); // Shared header props for the extracted ModalCustomUIRendererHeader component
        const headerProps = {
            isBridgeModal: isBridgeModal,
            isMacroExtension: isMacroExtension,
            modalSize: resolvedDimensions?.contentSize ?? modalSize,
            title: title,
            icon: icon,
            extension: extension,
            modalExtension: modalExtension,
            onClose: closeProps.onClose,
            closeModalExtension: modalExtension?.closeModalExtension,
            executeViewOnCloseCallback: executeViewOnCloseCallback
        };
        const renderModalHeader = ()=>{
            if ((0, $dh538.fg)('forge-ui-refactor-custom-ui-modal')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $24512c570241c19f$export$8350d65d9a3785ef), headerProps);
             // DO NOT ADD NEW LOGIC HERE - Add to ModalCustomUIRendererHeader instead
            // TODO: Delete the rest of this on forge-ui-refactor-custom-ui-modal flag cleanup
            /* Title/icon source priority:
       * - Bridge modals:
       *     - Use title/icon props (passed in from bridge call)
       *     - Fallback to extension.properties.title for fullscreen modals with empty title
       *     - For non-fullscreen modals, we won't render the header if the title prop is not provided
       * - Modal extension points: Use modalExtension.title and extensionIcon, defaults to extension name if not provided
       */ const modalTitle = isBridgeModal ? modalSize === 'fullscreen' && !title ? extension.properties.title : title : modalExtension?.title || extension.properties.title; /**
                                                                                                                                                                           * Icon rendering logic:
                                                                                                                                                                           * - Bridge modals: show icon section only if icon prop is provided
                                                                                                                                                                           * - Macro extension points: always show icon section (uses extension icon or AddonIcon fallback)
                                                                                                                                                                           * - Other modals: no icon section
                                                                                                                                                                           */ 
            const shouldShowIcon = isBridgeModal ? !!icon : isMacroExtension;
            const modalIcon = isBridgeModal ? icon : (0, $i9F01.getExtensionIcon)(extension);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, shouldShowIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center"
            }, modalIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                src: modalIcon,
                alt: "",
                width: "24px",
                height: "24px"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: "",
                color: "var(--ds-icon-accent-gray, #7D818A)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, modalTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, modalTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                label: "Close Modal",
                onClick: isBridgeModal ? closeProps.onClose : async ()=>{
                    try {
                        await executeViewOnCloseCallback();
                    } finally{
                        modalExtension?.closeModalExtension();
                    }
                }
            }));
        };
        if (supportsFullscreenModal) {
            if ((0, $dh538.fg)('forge-ui-refactor-custom-ui-modal')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dabc5de6ec4f71e9$export$7844aa44752a3a21), {
                closeProps: closeProps,
                isMacroExtension: isMacroExtension,
                isBridgeModal: isBridgeModal,
                modalContent: modalContent,
                headerProps: headerProps
            });
             // DO NOT ADD NEW LOGIC HERE - Add to FullscreenModal instead
            // TODO: Delete the rest of this on forge-ui-refactor-custom-ui-modal flag cleanup
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnPaP.FullScreenModalDialog), {
                ...closeProps,
                testId: "custom-ui-fullscreen-modal-dialog",
                shouldCloseOnEscapePress: closeOnEscape
            }, isMacroExtension || isBridgeModal ? renderModalHeader() : null, modalContent);
        } else {
            // Fallback to 'max' if modalSize is 'fullscreen' but fullscreen is not supported
            const shouldFallbackFromFullscreen = modalSize === 'fullscreen' && !supportsFullscreenModal; // TODO: Delete and move directly into Modal props on forge-ui-refactor-custom-ui-modal flag cleanup — use resolvedDimensions directly
            // resolvedDimensions only defined when fg('forge-ui-refactor-custom-ui-modal') is true
            const resolvedWidth = resolvedDimensions ? resolvedDimensions.width : shouldFallbackFromFullscreen ? '100%' : modalWidth;
            const resolvedHeight = resolvedDimensions ? resolvedDimensions.height : modalSize === 'max' || shouldFallbackFromFullscreen ? '100%' : undefined;
            if (shouldFallbackFromFullscreen) // eslint-disable-next-line no-console
            console.warn('Forge fullscreen modal is only supported in the forge/bridge modal and specific extension points. Refer to https://developer.atlassian.com/platform/forge/manifest-reference/modules/ for more guidance. The modal will be rendered with max width instead.');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
                ...closeProps,
                width: resolvedWidth,
                height: resolvedHeight,
                testId: "custom-ui-modal-dialog",
                shouldCloseOnOverlayClick: closeOnOverlayClick,
                shouldCloseOnEscapePress: closeOnEscape,
                shouldScrollInViewport: isResizableSize
            }, isBridgeModal && title ? renderModalHeader() : null, modalContent);
        }
    };
    if (ModalProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ModalProvider, null, renderModal()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && renderModal());
};
module.exports["CustomUIRenderer"] = $8537409554582c9d$export$17d9f1e4832027c9;
module.exports["ModalCustomUIRenderer"] = $8537409554582c9d$export$5d28a207fd7621f6;

});

parcelRegister("6oQb1", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $7TH2w = parcelRequire("7TH2w");


var $inPa6 = parcelRequire("inPa6");


var $5U2YR = parcelRequire("5U2YR");


var $3Spjc = parcelRequire("3Spjc");


var $hQK66 = parcelRequire("hQK66");


var $dh538 = parcelRequire("dh538");


var $7oKJR = parcelRequire("7oKJR");


var $ly9ul = parcelRequire("ly9ul");

const $eccfed1aa8771b08$export$43835e9acf248a15 = (createAnalyticsEvent, { action: action, actionSubject: actionSubject, source: source, attributes: attributes }, options)=>{
    const { sampleRate: sampleRate, filter: filter } = options ?? {};
    // If a sample rate is provided, we can use it to determine whether to fire the event
    if (sampleRate) {
        const randomValue = Math.random();
        if (randomValue > sampleRate) return; // Don't fire the event
    }
    const event = createAnalyticsEvent({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        data: {
            action: action,
            actionSubject: actionSubject,
            attributes: attributes,
            source: source,
            tags: [
                'forge'
            ]
        }
    });
    // Don't fire the event if there's a filter and event does not pass it
    if (filter && !filter(event)) return;
    event.fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
};
const $eccfed1aa8771b08$export$7eca133280843f9e = (createAnalyticsEvent, { action: action, actionSubject: actionSubject, attributes: attributes })=>{
    createAnalyticsEvent({
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        data: {
            action: action,
            actionSubject: actionSubject,
            attributes: attributes
        }
    }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
};
// Ideally this should be removed entirely in the future.
// see: https://hello.atlassian.net/wiki/spaces/ECO/pages/5687458412/Why+is+GASv3+Event+Costs+and+Volumes+Climbing+Cost+Saving+Proposal
const $eccfed1aa8771b08$var$legacyTrackBridgeSucceed = (createAnalyticsEvent, { source: source, method: method, additionalAttributes: additionalAttributes, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
// We limit the type of bridge methods we track to only the ones we are analysing in databricks to avoid sending too many events
const $eccfed1aa8771b08$var$allowedBridgeMethods = {
    navigate: {
        allowed: true,
        options: {
            sampleRate: 0.1
        }
    },
    openRovo: {
        allowed: true
    },
    isRovoEnabled: {
        allowed: true
    },
    // PIR-30455: The following three methods (openModal, close, onClose) are temporarily tracked as we have a high frequency of changes to the modal extension points
    // TODO cleanup: https://ecosystem-platform.atlassian.net/browse/EXT-4533
    openModal: {
        allowed: true
    },
    close: {
        allowed: true
    },
    onClose: {
        allowed: true
    }
};
const $eccfed1aa8771b08$var$optimisedTrackBridgeSucceed = (createAnalyticsEvent, { source: source, method: method, additionalAttributes: additionalAttributes, forgeEnvironment: forgeEnvironment })=>{
    if ($eccfed1aa8771b08$var$allowedBridgeMethods[method]?.allowed) $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    }, $eccfed1aa8771b08$var$allowedBridgeMethods[method]?.options);
};
const $eccfed1aa8771b08$var$trackForgeFeatureFlagEvent = (createAnalyticsEvent, { source: source, appType: appType, baseUrl: baseUrl, appId: appId, flagName: flagName, eventType: eventType, success: success, featureFlagEnv: featureFlagEnv, forgeEnvironment: forgeEnvironment })=>{
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: eventType,
        actionSubject: 'forge.ui.feature_flag',
        source: source,
        attributes: {
            appType: appType,
            baseUrl: baseUrl,
            appId: appId,
            flagName: flagName,
            eventType: eventType,
            success: success,
            featureFlagEnv: featureFlagEnv,
            forgeEnvironment: forgeEnvironment
        }
    });
};
const $eccfed1aa8771b08$var$trackObjectStoreAction = (createAnalyticsEvent, { source: source, appType: appType, appId: appId, action: action, forgeEnvironment: forgeEnvironment })=>{
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: action,
        actionSubject: 'forge.ui.object_store',
        source: source,
        attributes: {
            appType: appType,
            appId: appId,
            forgeEnvironment: forgeEnvironment
        }
    });
};
const $eccfed1aa8771b08$var$trackPermissionAction = (createAnalyticsEvent, { source: source, appId: appId, installationId: installationId, action: action })=>{
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: action,
        actionSubject: 'forge.ui.permission',
        source: source,
        attributes: {
            appId: appId,
            installationId: installationId
        }
    });
};
const $eccfed1aa8771b08$export$f4ca3aaa7a36404 = (createAnalyticsEvent, payload)=>(0, $dh538.fg)('forge-ui-event-cost-optimisation') ? $eccfed1aa8771b08$var$optimisedTrackBridgeSucceed(createAnalyticsEvent, payload) : $eccfed1aa8771b08$var$legacyTrackBridgeSucceed(createAnalyticsEvent, payload);
const $eccfed1aa8771b08$export$5c425ded9b0e7602 = (createAnalyticsEvent, { source: source, errorName: errorName, method: method, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'failed',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            error: errorName,
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
const $eccfed1aa8771b08$export$d84d2f0ce1c82c0 = (createAnalyticsEvent, { source: source, forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.analytics.component_usage',
        source: source,
        attributes: {
            forgeEnvironment: forgeEnvironment,
            components: components,
            forgeReactMajorVersion: forgeReactMajorVersion
        }
    });
const $eccfed1aa8771b08$export$7e97f0f47f75f097 = (createAnalyticsEvent, { source: source, target: target })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.renderer',
        source: source,
        attributes: {
            target: target
        }
    });
const $eccfed1aa8771b08$var$trackExtensionLoaded = (createAnalyticsEvent, { source: source, forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting, viewportSize: viewportSize })=>{
    const options = (0, $dh538.fg)('forge-ui-event-cost-optimisation') ? {
        filter: (0, $7oKJR.extensionLoadedEventFilter)
    } : undefined;
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'loaded',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            forgeEnvironment: forgeEnvironment,
            renderType: renderType,
            extensionType: extensionType,
            isConfiguring: isConfiguring,
            isInserting: isInserting,
            viewportSize: viewportSize
        }
    }, options);
};
const $eccfed1aa8771b08$var$trackExtensionRemounted = (createAnalyticsEvent, { source: source, mountCount: mountCount, isUseBridgeReinit: isUseBridgeReinit })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'remounted',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            mountCount: mountCount,
            isUseBridgeReinit: isUseBridgeReinit
        }
    });
const $eccfed1aa8771b08$var$trackHandShakeMetric = (createAnalyticsEvent, { source: source, success: success, error: error })=>{
    if (error) $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'failed',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            target: 'handshake',
            success: success,
            reason: error instanceof Error ? error.message : 'Unknown error',
            isUnrecoverable: (0, $ly9ul.isUnrecoverableError)(error)
        }
    });
    else // Sample 10% of the events to reduce the costs
    // We only need 10% of the good events for the same SLO target
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            target: 'handshake',
            success: success
        }
    }, {
        sampleRate: 0.1
    });
};
const $eccfed1aa8771b08$export$b6445106a2f749a7 = (createAnalyticsEvent, { source: source, extensionId: extensionId, reason: reason })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rejected',
        actionSubject: 'forge.ui.embedded_macro',
        source: source,
        attributes: {
            extensionId: extensionId,
            extensionType: 'xen:macro',
            reason: reason
        }
    });
const $eccfed1aa8771b08$var$createForgeUiAnalyticsEventTrackers = ({ createAnalyticsEvent: createAnalyticsEvent, source: source })=>{
    return {
        trackHandShakeMetric: ({ source: source, success: success, error: error })=>$eccfed1aa8771b08$var$trackHandShakeMetric(createAnalyticsEvent, {
                source: source,
                success: success,
                error: error
            }),
        trackComponentUsageRendered: ({ forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$eccfed1aa8771b08$export$d84d2f0ce1c82c0(createAnalyticsEvent, {
                source: source,
                forgeEnvironment: forgeEnvironment,
                components: components,
                forgeReactMajorVersion: forgeReactMajorVersion
            }),
        trackRendererRendered: ({ target: target })=>$eccfed1aa8771b08$export$7e97f0f47f75f097(createAnalyticsEvent, {
                source: source,
                target: target
            }),
        trackExtensionLoaded: ({ forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting, viewportSize: viewportSize })=>$eccfed1aa8771b08$var$trackExtensionLoaded(createAnalyticsEvent, {
                source: source,
                forgeEnvironment: forgeEnvironment,
                renderType: renderType,
                extensionType: extensionType,
                isConfiguring: isConfiguring,
                isInserting: isInserting,
                viewportSize: viewportSize
            }),
        trackExtensionRemounted: ({ mountCount: mountCount })=>$eccfed1aa8771b08$var$trackExtensionRemounted(createAnalyticsEvent, {
                source: source,
                mountCount: mountCount
            }),
        trackBridgeSucceed: ({ method: method, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$eccfed1aa8771b08$export$f4ca3aaa7a36404(createAnalyticsEvent, {
                source: source,
                method: method,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: additionalAttributes
            }),
        trackBridgeFailed: ({ method: method, errorName: errorName, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$eccfed1aa8771b08$export$5c425ded9b0e7602(createAnalyticsEvent, {
                source: source,
                errorName: errorName,
                method: method,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: additionalAttributes
            }),
        trackForgeFeatureFlagEvent: ({ appType: appType, baseUrl: baseUrl, appId: appId, flagName: flagName, eventType: eventType, success: success, featureFlagEnv: featureFlagEnv, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$var$trackForgeFeatureFlagEvent(createAnalyticsEvent, {
                source: source,
                appType: appType,
                baseUrl: baseUrl,
                appId: appId,
                flagName: flagName,
                eventType: eventType,
                success: success,
                featureFlagEnv: featureFlagEnv,
                forgeEnvironment: forgeEnvironment
            }),
        trackObjectStoreAction: ({ appType: appType, appId: appId, action: action, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$var$trackObjectStoreAction(createAnalyticsEvent, {
                source: source,
                appType: appType,
                appId: appId,
                action: action,
                forgeEnvironment: forgeEnvironment
            }),
        trackPermissionAction: ({ appId: appId, installationId: installationId, action: action })=>$eccfed1aa8771b08$var$trackPermissionAction(createAnalyticsEvent, {
                source: source,
                appId: appId,
                installationId: installationId,
                action: action
            })
    };
};
const $eccfed1aa8771b08$export$4b165c4db6e19dc5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    let t0;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t0 = ()=>$eccfed1aa8771b08$var$createForgeUiAnalyticsEventTrackers({
                createAnalyticsEvent: createAnalyticsEvent,
                source: source
            });
        t1 = [
            createAnalyticsEvent,
            source
        ];
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    const cachedTrackers = (0, $hQK66.useMemoOne)(t0, t1);
    return cachedTrackers;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    const cachedTrackers = (0, $hQK66.useMemoOne)(()=>$eccfed1aa8771b08$var$createForgeUiAnalyticsEventTrackers({
            createAnalyticsEvent: createAnalyticsEvent,
            source: source
        }), [
        createAnalyticsEvent,
        source
    ]);
    return cachedTrackers;
};
module.exports["fireEvent"] = $eccfed1aa8771b08$export$43835e9acf248a15;
module.exports["fireUIEvent"] = $eccfed1aa8771b08$export$7eca133280843f9e;
module.exports["trackBridgeSucceed"] = $eccfed1aa8771b08$export$f4ca3aaa7a36404;
module.exports["trackBridgeFailed"] = $eccfed1aa8771b08$export$5c425ded9b0e7602;
module.exports["trackComponentUsageRendered"] = $eccfed1aa8771b08$export$d84d2f0ce1c82c0;
module.exports["trackRendererRendered"] = $eccfed1aa8771b08$export$7e97f0f47f75f097;
module.exports["trackEmbeddedMacroRejected"] = $eccfed1aa8771b08$export$b6445106a2f749a7;
module.exports["useForgeUiAnalyticsEvent"] = $eccfed1aa8771b08$export$4b165c4db6e19dc5;

});

parcelRegister("dj2Gr", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<aab4c21b77461656be8e7f55fdded6ff>>
 * @relayHash 88ed8af64ac7185a0999b8c6bf0f12bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 17357ad13472c97d7073c2a1eb4b600d98011b17893ba0a316e9e5de283bfc82
const $ec5b20105029ea69$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "InvocationResponsePayload",
        "kind": "LinkedField",
        "name": "response",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "body"
            }
        ]
    }, v4 = {
        "concreteType": "ForgeContextToken",
        "kind": "LinkedField",
        "name": "contextToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jwt"
            },
            {
                "kind": "ScalarField",
                "name": "expiresAt"
            }
        ]
    }, v5 = {
        "concreteType": "RateLimitProperties",
        "kind": "LinkedField",
        "name": "rateLimitProperties",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "rateLimitRemaining"
            },
            {
                "kind": "ScalarField",
                "name": "rateLimitReset"
            },
            {
                "kind": "ScalarField",
                "name": "rateLimitValue"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InvokeExtensionPayloadErrorExtensionFields",
                "kind": "LinkedField",
                "name": "fields",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "authInfoUrl"
                    }
                ]
            }
        ],
        "type": "InvokeExtensionPayloadErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInvokeExtensionRelayMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "InvokeExtensionResponse",
                    "kind": "LinkedField",
                    "name": "invokeExtension",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInvokeExtensionRelayMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "InvokeExtensionResponse",
                    "kind": "LinkedField",
                    "name": "invokeExtension",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "17357ad13472c97d7073c2a1eb4b600d98011b17893ba0a316e9e5de283bfc82",
            "metadata": {},
            "name": "useInvokeExtensionRelayMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ec5b20105029ea69$var$node.hash = "7da04c6e6467fec1087d3d61ffac8358";
var $ec5b20105029ea69$export$2e2bcd8739ae039 = $ec5b20105029ea69$var$node;



var $hQK66 = parcelRequire("hQK66");


var $eSUdr = parcelRequire("eSUdr");


var $irOoi = parcelRequire("irOoi");


var $1Igmn = parcelRequire("1Igmn");

const $7569106fed376473$export$46af696e5313090f = (0, $eSUdr.default)`mutation forge_ui_invokeExtension($input:InvokeExtensionInput!){invokeExtension(input:$input){success response{body}contextToken{jwt expiresAt}rateLimitProperties{rateLimitRemaining rateLimitReset rateLimitValue}errors{message extensions{errorType statusCode ...on InvokeExtensionPayloadErrorExtension{fields{authInfoUrl}}}}}}`;
const $7569106fed376473$export$19d283d2f5a7d3c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (contextIds, extensionId)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    let t1;
    if ($[0] !== contextIds) {
        t0 = (environment, config)=>(0, $irOoi.commitMutation)(environment, {
                ...config,
                cacheConfig: {
                    metadata: {
                        headers: {
                            "atl-attribution": (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                        }
                    }
                }
            });
        t1 = [
            contextIds
        ];
        $[0] = contextIds;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    const customCommitFn = (0, $hQK66.useCallbackOne)(t0, t1);
    const [commit] = (0, $irOoi.useMutation)((0, $ec5b20105029ea69$export$2e2bcd8739ae039), customCommitFn);
    let t2;
    let t3;
    if ($[3] !== commit || $[4] !== contextIds || $[5] !== extensionId) {
        t2 = (payload, t4)=>{
            const entryPoint = t4 === undefined ? "resolver" : t4;
            return new Promise((resolve, reject)=>{
                commit({
                    variables: {
                        input: {
                            contextIds: contextIds,
                            extensionId: extensionId,
                            payload: payload,
                            entryPoint: entryPoint
                        }
                    },
                    onCompleted: (data, errors)=>{
                        if (Array.isArray(errors) && errors.length > 0) resolve({
                            data: {
                                invokeExtension: {
                                    errors: errors,
                                    success: false,
                                    response: null,
                                    contextToken: null
                                }
                            }
                        });
                        resolve({
                            data: data
                        });
                    },
                    onError: reject
                });
            });
        };
        t3 = [
            contextIds,
            extensionId,
            commit
        ];
        $[3] = commit;
        $[4] = contextIds;
        $[5] = extensionId;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    return (0, $hQK66.useCallbackOne)(t2, t3);
} : (contextIds, extensionId)=>{
    const customCommitFn = (0, $hQK66.useCallbackOne)((environment, config)=>(0, $irOoi.commitMutation)(environment, {
            ...config,
            cacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                    }
                }
            }
        }), [
        contextIds
    ]);
    const [commit] = (0, $irOoi.useMutation)((0, $ec5b20105029ea69$export$2e2bcd8739ae039), customCommitFn);
    return (0, $hQK66.useCallbackOne)((payload, entryPoint = 'resolver')=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        contextIds: contextIds,
                        extensionId: extensionId,
                        payload: payload,
                        entryPoint: entryPoint
                    }
                },
                onCompleted: (data, errors)=>{
                    if (Array.isArray(errors) && errors.length > 0) // We pass the error to `resolve` here so it can goes through the error handling logic found in packages/forge/forge-ui/src/custom-ui/iframe/InnerIframe.tsx - onInvoke
                    resolve({
                        data: {
                            invokeExtension: {
                                errors: errors,
                                success: false,
                                response: null,
                                contextToken: null
                            }
                        }
                    });
                    resolve({
                        data: data
                    });
                },
                onError: reject
            });
        }), [
        contextIds,
        extensionId,
        commit
    ]);
};
module.exports["useInvokeExtension"] = $7569106fed376473$export$19d283d2f5a7d3c;

});

parcelRegister("1BqC1", function(module, exports) {
$parcel$export(module.exports, "iframeResize", () => $12ade3c53ffa5233$export$e284ab1b3bcdabe6, (v) => $12ade3c53ffa5233$export$e284ab1b3bcdabe6 = v);
$parcel$export(module.exports, "iframeResizer", () => $12ade3c53ffa5233$export$b6962bfb5a91d43, (v) => $12ade3c53ffa5233$export$b6962bfb5a91d43 = v);
$parcel$export(module.exports, "iframeResizerContentWindow", () => $12ade3c53ffa5233$export$1aafc108bc1f168c, (v) => $12ade3c53ffa5233$export$1aafc108bc1f168c = v);
var $12ade3c53ffa5233$export$e284ab1b3bcdabe6;
var $12ade3c53ffa5233$export$b6962bfb5a91d43// Backwards compatability
;
var $12ade3c53ffa5233$export$1aafc108bc1f168c;

var $9wL22 = parcelRequire("9wL22");

$12ade3c53ffa5233$export$e284ab1b3bcdabe6 = $9wL22;
$12ade3c53ffa5233$export$b6962bfb5a91d43 = $9wL22;

$12ade3c53ffa5233$export$1aafc108bc1f168c = (parcelRequire("hAXmP"));

});

parcelRegister("hAXmP", function(module, exports) {
/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 *
 */ // eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    var autoResize = true, base = 10, bodyBackground = '', bodyMargin = 0, bodyMarginStr = '', bodyObserver = null, bodyPadding = '', calculateWidth = false, doubleEventList = {
        resize: 1,
        click: 1
    }, eventCancelTimer = 128, firstRun = true, height = 1, heightCalcModeDefault = 'bodyOffset', heightCalcMode = heightCalcModeDefault, initLock = true, initMsg = '', inPageLinks = {}, interval = 32, intervalTimer = null, logging = false, mouseEvents = false, msgID = '[iFrameSizer]', msgIdLen = msgID.length, myID = '', resetRequiredMethods = {
        max: 1,
        min: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, resizeFrom = 'child', sendPermit = true, target = window.parent, targetOriginDefault = '*', tolerance = 0, triggerLocked = false, triggerLockedTimer = null, throttledTimer = 16, width = 1, widthCalcModeDefault = 'scroll', widthCalcMode = widthCalcModeDefault, win = window, onMessage = function() {
        warn('onMessage function not defined');
    }, onReady = function() {}, onPageInfo = function() {}, customCalcMethods = {
        height: function() {
            warn('Custom height calculation function not defined');
            return document.documentElement.offsetHeight;
        },
        width: function() {
            warn('Custom width calculation function not defined');
            return document.body.scrollWidth;
        }
    }, eventHandlersByName = {}, passiveSupported = false;
    function noop() {}
    try {
        var options = Object.create({}, {
            passive: {
                get: function() {
                    passiveSupported = true;
                }
            }
        });
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop, options);
    } catch (error) {
    /* */ }
    function addEventListener(el, evt, func, options) {
        el.addEventListener(evt, func, passiveSupported ? options || {} : false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    // Based on underscore.js
    function throttle(func) {
        var context, args, result, timeout = null, previous = 0, later = function() {
            previous = Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) // eslint-disable-next-line no-multi-assign
            context = args = null;
        };
        return function() {
            var now = Date.now();
            if (!previous) previous = now;
            var remaining = throttledTimer - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > throttledTimer) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) // eslint-disable-next-line no-multi-assign
                context = args = null;
            } else if (!timeout) timeout = setTimeout(later, remaining);
            return result;
        };
    }
    function formatLogMsg(msg) {
        return msgID + '[' + myID + '] ' + msg;
    }
    function log(msg) {
        if (logging && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console.log(formatLogMsg(msg));
    }
    function warn(msg) {
        if ('object' === typeof window.console) // eslint-disable-next-line no-console
        console.warn(formatLogMsg(msg));
    }
    function init() {
        readDataFromParent();
        log('Initialising iFrame (' + window.location.href + ')');
        readDataFromPage();
        setMargin();
        setBodyStyle('background', bodyBackground);
        setBodyStyle('padding', bodyPadding);
        injectClearFixIntoBodyElement();
        checkHeightMode();
        checkWidthMode();
        stopInfiniteResizingOfIFrame();
        setupPublicMethods();
        setupMouseEvents();
        startEventListeners();
        inPageLinks = setupInPageLinks();
        sendSize('init', 'Init message from host page');
        onReady();
    }
    function readDataFromParent() {
        function strBool(str) {
            return 'true' === str;
        }
        var data = initMsg.substr(msgIdLen).split(':');
        myID = data[0];
        bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin; // For V1 compatibility
        calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth;
        logging = undefined !== data[3] ? strBool(data[3]) : logging;
        interval = undefined !== data[4] ? Number(data[4]) : interval;
        autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize;
        bodyMarginStr = data[7];
        heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode;
        bodyBackground = data[9];
        bodyPadding = data[10];
        tolerance = undefined !== data[11] ? Number(data[11]) : tolerance;
        inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false;
        resizeFrom = undefined !== data[13] ? data[13] : resizeFrom;
        widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode;
        mouseEvents = undefined !== data[15] ? Boolean(data[15]) : mouseEvents;
    }
    function depricate(key) {
        var splitName = key.split('Callback');
        if (splitName.length === 2) {
            var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
            this[name] = this[key];
            delete this[key];
            warn("Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
        }
    }
    function readDataFromPage() {
        function readData() {
            var data = window.iFrameResizer;
            log('Reading data from page: ' + JSON.stringify(data));
            Object.keys(data).forEach(depricate, data);
            onMessage = 'onMessage' in data ? data.onMessage : onMessage;
            onReady = 'onReady' in data ? data.onReady : onReady;
            targetOriginDefault = 'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
            heightCalcMode = 'heightCalculationMethod' in data ? data.heightCalculationMethod : heightCalcMode;
            widthCalcMode = 'widthCalculationMethod' in data ? data.widthCalculationMethod : widthCalcMode;
        }
        function setupCustomCalcMethods(calcMode, calcFunc) {
            if ('function' === typeof calcMode) {
                log('Setup custom ' + calcFunc + 'CalcMethod');
                customCalcMethods[calcFunc] = calcMode;
                calcMode = 'custom';
            }
            return calcMode;
        }
        if ('iFrameResizer' in window && Object === window.iFrameResizer.constructor) {
            readData();
            heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
            widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
        }
        log('TargetOrigin for parent set to: ' + targetOriginDefault);
    }
    function chkCSS(attr, value) {
        if (-1 !== value.indexOf('-')) {
            warn('Negative CSS value ignored for ' + attr);
            value = '';
        }
        return value;
    }
    function setBodyStyle(attr, value) {
        if (undefined !== value && '' !== value && 'null' !== value) {
            document.body.style[attr] = value;
            log('Body ' + attr + ' set to "' + value + '"');
        }
    }
    function setMargin() {
        // If called via V1 script, convert bodyMargin from int to str
        if (undefined === bodyMarginStr) bodyMarginStr = bodyMargin + 'px';
        setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
    }
    function stopInfiniteResizingOfIFrame() {
        document.documentElement.style.height = '';
        document.body.style.height = '';
        log('HTML & body height set to "auto"');
    }
    function manageTriggerEvent(options) {
        var listener = {
            add: function(eventName) {
                function handleEvent() {
                    sendSize(options.eventName, options.eventType);
                }
                eventHandlersByName[eventName] = handleEvent;
                addEventListener(window, eventName, handleEvent, {
                    passive: true
                });
            },
            remove: function(eventName) {
                var handleEvent = eventHandlersByName[eventName];
                delete eventHandlersByName[eventName];
                removeEventListener(window, eventName, handleEvent);
            }
        };
        if (options.eventNames && Array.prototype.map) {
            options.eventName = options.eventNames[0];
            options.eventNames.map(listener[options.method]);
        } else listener[options.method](options.eventName);
        log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
    }
    function manageEventListeners(method) {
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Start',
            eventNames: [
                'animationstart',
                'webkitAnimationStart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Iteration',
            eventNames: [
                'animationiteration',
                'webkitAnimationIteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation End',
            eventNames: [
                'animationend',
                'webkitAnimationEnd'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Input',
            eventName: 'input'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Up',
            eventName: 'mouseup'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Down',
            eventName: 'mousedown'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Orientation Change',
            eventName: 'orientationchange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Print',
            eventName: [
                'afterprint',
                'beforeprint'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Ready State Change',
            eventName: 'readystatechange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Start',
            eventName: 'touchstart'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch End',
            eventName: 'touchend'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Cancel',
            eventName: 'touchcancel'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Start',
            eventNames: [
                'transitionstart',
                'webkitTransitionStart',
                'MSTransitionStart',
                'oTransitionStart',
                'otransitionstart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Iteration',
            eventNames: [
                'transitioniteration',
                'webkitTransitionIteration',
                'MSTransitionIteration',
                'oTransitionIteration',
                'otransitioniteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition End',
            eventNames: [
                'transitionend',
                'webkitTransitionEnd',
                'MSTransitionEnd',
                'oTransitionEnd',
                'otransitionend'
            ]
        });
        if ('child' === resizeFrom) manageTriggerEvent({
            method: method,
            eventType: 'IFrame Resized',
            eventName: 'resize'
        });
    }
    function checkCalcMode(calcMode, calcModeDefault, modes, type) {
        if (calcModeDefault !== calcMode) {
            if (!(calcMode in modes)) {
                warn(calcMode + ' is not a valid option for ' + type + 'CalculationMethod.');
                calcMode = calcModeDefault;
            }
            log(type + ' calculation method set to "' + calcMode + '"');
        }
        return calcMode;
    }
    function checkHeightMode() {
        heightCalcMode = checkCalcMode(heightCalcMode, heightCalcModeDefault, getHeight, 'height');
    }
    function checkWidthMode() {
        widthCalcMode = checkCalcMode(widthCalcMode, widthCalcModeDefault, getWidth, 'width');
    }
    function startEventListeners() {
        if (true === autoResize) {
            manageEventListeners('add');
            setupMutationObserver();
        } else log('Auto Resize disabled');
    }
    //   function stopMsgsToParent() {
    //     log('Disable outgoing messages')
    //     sendPermit = false
    //   }
    //   function removeMsgListener() {
    //     log('Remove event listener: Message')
    //     removeEventListener(window, 'message', receiver)
    //   }
    function disconnectMutationObserver() {
        if (null !== bodyObserver) /* istanbul ignore next */ // Not testable in PhantonJS
        bodyObserver.disconnect();
    }
    function stopEventListeners() {
        manageEventListeners('remove');
        disconnectMutationObserver();
        clearInterval(intervalTimer);
    }
    //   function teardown() {
    //     stopMsgsToParent()
    //     removeMsgListener()
    //     if (true === autoResize) stopEventListeners()
    //   }
    function injectClearFixIntoBodyElement() {
        var clearFix = document.createElement('div');
        clearFix.style.clear = 'both';
        // Guard against the following having been globally redefined in CSS.
        clearFix.style.display = 'block';
        clearFix.style.height = '0';
        document.body.appendChild(clearFix);
    }
    function setupInPageLinks() {
        function getPagePosition() {
            return {
                x: window.pageXOffset !== undefined ? window.pageXOffset : document.documentElement.scrollLeft,
                y: window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop
            };
        }
        function getElementPosition(el) {
            var elPosition = el.getBoundingClientRect(), pagePosition = getPagePosition();
            return {
                x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
                y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
            };
        }
        function findTarget(location) {
            function jumpToTarget(target) {
                var jumpPosition = getElementPosition(target);
                log('Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
            }
            var hash = location.split('#')[1] || location, hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (undefined !== target) jumpToTarget(target);
            else {
                log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
                sendMsg(0, 0, 'inPageLink', '#' + hash);
            }
        }
        function checkLocationHash() {
            var hash = window.location.hash;
            var href = window.location.href;
            if ('' !== hash && '#' !== hash) findTarget(href);
        }
        function bindAnchors() {
            function setupLink(el) {
                function linkClicked(e) {
                    e.preventDefault();
                    /* jshint validthis:true */ findTarget(this.getAttribute('href'));
                }
                if ('#' !== el.getAttribute('href')) addEventListener(el, 'click', linkClicked);
            }
            Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), setupLink);
        }
        function bindLocationHash() {
            addEventListener(window, 'hashchange', checkLocationHash);
        }
        function initCheck() {
            // Check if page loaded with location hash after init resize
            setTimeout(checkLocationHash, eventCancelTimer);
        }
        function enableInPageLinks() {
            /* istanbul ignore else */ // Not testable in phantonJS
            if (Array.prototype.forEach && document.querySelectorAll) {
                log('Setting up location.hash handlers');
                bindAnchors();
                bindLocationHash();
                initCheck();
            } else warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
        }
        if (inPageLinks.enable) enableInPageLinks();
        else log('In page linking not enabled');
        return {
            findTarget: findTarget
        };
    }
    function setupMouseEvents() {
        if (mouseEvents !== true) return;
        function sendMouse(e) {
            sendMsg(0, 0, e.type, e.screenY + ':' + e.screenX);
        }
        function addMouseListener(evt, name) {
            log('Add event listener: ' + name);
            addEventListener(window.document, evt, sendMouse);
        }
        addMouseListener('mouseenter', 'Mouse Enter');
        addMouseListener('mouseleave', 'Mouse Leave');
    }
    function setupPublicMethods() {
        log('Enable public methods');
        win.parentIFrame = {
            autoResize: function autoResizeF(resize) {
                if (true === resize && false === autoResize) {
                    autoResize = true;
                    startEventListeners();
                } else if (false === resize && true === autoResize) {
                    autoResize = false;
                    stopEventListeners();
                }
                sendMsg(0, 0, 'autoResize', JSON.stringify(autoResize));
                return autoResize;
            },
            close: function closeF() {
                sendMsg(0, 0, 'close');
            // teardown()
            },
            getId: function getIdF() {
                return myID;
            },
            getPageInfo: function getPageInfoF(callback) {
                if ('function' === typeof callback) {
                    onPageInfo = callback;
                    sendMsg(0, 0, 'pageInfo');
                } else {
                    onPageInfo = function() {};
                    sendMsg(0, 0, 'pageInfoStop');
                }
            },
            moveToAnchor: function moveToAnchorF(hash) {
                inPageLinks.findTarget(hash);
            },
            reset: function resetF() {
                resetIFrame('parentIFrame.reset');
            },
            scrollTo: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollTo'); // X&Y reversed at sendMsg uses height/width
            },
            scrollToOffset: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
            },
            sendMessage: function sendMessageF(msg, targetOrigin) {
                sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
            },
            setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod) {
                heightCalcMode = heightCalculationMethod;
                checkHeightMode();
            },
            setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod) {
                widthCalcMode = widthCalculationMethod;
                checkWidthMode();
            },
            setTargetOrigin: function setTargetOriginF(targetOrigin) {
                log('Set targetOrigin: ' + targetOrigin);
                targetOriginDefault = targetOrigin;
            },
            size: function sizeF(customHeight, customWidth) {
                var valString = '' + (customHeight || '') + (customWidth ? ',' + customWidth : '');
                sendSize('size', 'parentIFrame.size(' + valString + ')', customHeight, customWidth);
            }
        };
    }
    function initInterval() {
        if (0 !== interval) {
            log('setInterval: ' + interval + 'ms');
            intervalTimer = setInterval(function() {
                sendSize('interval', 'setInterval: ' + interval);
            }, Math.abs(interval));
        }
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function setupBodyMutationObserver() {
        function addImageLoadListners(mutation) {
            function addImageLoadListener(element) {
                if (false === element.complete) {
                    log('Attach listeners to ' + element.src);
                    element.addEventListener('load', imageLoaded, false);
                    element.addEventListener('error', imageError, false);
                    elements.push(element);
                }
            }
            if (mutation.type === 'attributes' && mutation.attributeName === 'src') addImageLoadListener(mutation.target);
            else if (mutation.type === 'childList') Array.prototype.forEach.call(mutation.target.querySelectorAll('img'), addImageLoadListener);
        }
        function removeFromArray(element) {
            elements.splice(elements.indexOf(element), 1);
        }
        function removeImageLoadListener(element) {
            log('Remove listeners from ' + element.src);
            element.removeEventListener('load', imageLoaded, false);
            element.removeEventListener('error', imageError, false);
            removeFromArray(element);
        }
        function imageEventTriggered(event, type, typeDesc) {
            removeImageLoadListener(event.target);
            sendSize(type, typeDesc + ': ' + event.target.src);
        }
        function imageLoaded(event) {
            imageEventTriggered(event, 'imageLoad', 'Image loaded');
        }
        function imageError(event) {
            imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
        }
        function mutationObserved(mutations) {
            sendSize('mutationObserver', 'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);
            // Deal with WebKit / Blink asyncing image loading when tags are injected into the page
            mutations.forEach(addImageLoadListners);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            };
            observer = new MutationObserver(mutationObserved);
            log('Create body MutationObserver');
            observer.observe(target, config);
            return observer;
        }
        var elements = [], MutationObserver = window.MutationObserver || window.WebKitMutationObserver, observer = createMutationObserver();
        return {
            disconnect: function() {
                if ('disconnect' in observer) {
                    log('Disconnect body MutationObserver');
                    observer.disconnect();
                    elements.forEach(removeImageLoadListener);
                }
            }
        };
    }
    function setupMutationObserver() {
        var forceIntervalTimer = 0 > interval;
        // Not testable in PhantomJS
        /* istanbul ignore if */ if (window.MutationObserver || window.WebKitMutationObserver) {
            if (forceIntervalTimer) initInterval();
            else bodyObserver = setupBodyMutationObserver();
        } else {
            log('MutationObserver not supported in this browser!');
            initInterval();
        }
    }
    // document.documentElement.offsetHeight is not reliable, so
    // we have to jump through hoops to get a better value.
    function getComputedStyle(prop, el) {
        var retVal = 0;
        el = el || document.body; // Not testable in phantonJS
        retVal = document.defaultView.getComputedStyle(el, null);
        retVal = null !== retVal ? retVal[prop] : 0;
        return parseInt(retVal, base);
    }
    function chkEventThottle(timer) {
        if (timer > throttledTimer / 2) {
            throttledTimer = 2 * timer;
            log('Event throttle increased to ' + throttledTimer + 'ms');
        }
    }
    // Idea from https://github.com/guardian/iframe-messenger
    function getMaxElement(side, elements) {
        var elementsLength = elements.length, elVal = 0, maxVal = 0, Side = capitalizeFirstLetter(side), timer = Date.now();
        for(var i = 0; i < elementsLength; i++){
            elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin' + Side, elements[i]);
            if (elVal > maxVal) maxVal = elVal;
        }
        timer = Date.now() - timer;
        log('Parsed ' + elementsLength + ' HTML elements');
        log('Element position calculated in ' + timer + 'ms');
        chkEventThottle(timer);
        return maxVal;
    }
    function getAllMeasurements(dimensions) {
        return [
            dimensions.bodyOffset(),
            dimensions.bodyScroll(),
            dimensions.documentElementOffset(),
            dimensions.documentElementScroll()
        ];
    }
    function getTaggedElements(side, tag) {
        function noTaggedElementsFound() {
            warn('No tagged elements (' + tag + ') found on page');
            return document.querySelectorAll('body *');
        }
        var elements = document.querySelectorAll('[' + tag + ']');
        if (elements.length === 0) noTaggedElementsFound();
        return getMaxElement(side, elements);
    }
    function getAllElements() {
        return document.querySelectorAll('body *');
    }
    var getHeight = {
        bodyOffset: function getBodyOffsetHeight() {
            return document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
        },
        offset: function() {
            return getHeight.bodyOffset() // Backwards compatability
            ;
        },
        bodyScroll: function getBodyScrollHeight() {
            return document.body.scrollHeight;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.height();
        },
        documentElementOffset: function getDEOffsetHeight() {
            return document.documentElement.offsetHeight;
        },
        documentElementScroll: function getDEScrollHeight() {
            return document.documentElement.scrollHeight;
        },
        max: function getMaxHeight() {
            return Math.max.apply(null, getAllMeasurements(getHeight));
        },
        min: function getMinHeight() {
            return Math.min.apply(null, getAllMeasurements(getHeight));
        },
        grow: function growHeight() {
            return getHeight.max() // Run max without the forced downsizing
            ;
        },
        lowestElement: function getBestHeight() {
            return Math.max(getHeight.bodyOffset() || getHeight.documentElementOffset(), getMaxElement('bottom', getAllElements()));
        },
        taggedElement: function getTaggedElementsHeight() {
            return getTaggedElements('bottom', 'data-iframe-height');
        }
    }, getWidth = {
        bodyScroll: function getBodyScrollWidth() {
            return document.body.scrollWidth;
        },
        bodyOffset: function getBodyOffsetWidth() {
            return document.body.offsetWidth;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.width();
        },
        documentElementScroll: function getDEScrollWidth() {
            return document.documentElement.scrollWidth;
        },
        documentElementOffset: function getDEOffsetWidth() {
            return document.documentElement.offsetWidth;
        },
        scroll: function getMaxWidth() {
            return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
        },
        max: function getMaxWidth() {
            return Math.max.apply(null, getAllMeasurements(getWidth));
        },
        min: function getMinWidth() {
            return Math.min.apply(null, getAllMeasurements(getWidth));
        },
        rightMostElement: function rightMostElement() {
            return getMaxElement('right', getAllElements());
        },
        taggedElement: function getTaggedElementsWidth() {
            return getTaggedElements('right', 'data-iframe-width');
        }
    };
    function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function resizeIFrame() {
            height = currentHeight;
            width = currentWidth;
            sendMsg(height, width, triggerEvent);
        }
        function isSizeChangeDetected() {
            function checkTolarance(a, b) {
                var retVal = Math.abs(a - b) <= tolerance;
                return !retVal;
            }
            currentHeight = undefined !== customHeight ? customHeight : getHeight[heightCalcMode]();
            currentWidth = undefined !== customWidth ? customWidth : getWidth[widthCalcMode]();
            return checkTolarance(height, currentHeight) || calculateWidth && checkTolarance(width, currentWidth);
        }
        function isForceResizableEvent() {
            return !(triggerEvent in {
                init: 1,
                interval: 1,
                size: 1
            });
        }
        function isForceResizableCalcMode() {
            return heightCalcMode in resetRequiredMethods || calculateWidth && widthCalcMode in resetRequiredMethods;
        }
        function logIgnored() {
            log('No change in size detected');
        }
        function checkDownSizing() {
            if (isForceResizableEvent() && isForceResizableCalcMode()) resetIFrame(triggerEventDesc);
            else if (!(triggerEvent in {
                interval: 1
            })) logIgnored();
        }
        var currentHeight, currentWidth;
        if (isSizeChangeDetected() || 'init' === triggerEvent) {
            lockTrigger();
            resizeIFrame();
        } else checkDownSizing();
    }
    var sizeIFrameThrottled = throttle(sizeIFrame);
    function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function recordTrigger() {
            if (!(triggerEvent in {
                reset: 1,
                resetPage: 1,
                init: 1
            })) log('Trigger event: ' + triggerEventDesc);
        }
        function isDoubleFiredEvent() {
            return triggerLocked && triggerEvent in doubleEventList;
        }
        if (!isDoubleFiredEvent()) {
            recordTrigger();
            if (triggerEvent === 'init') sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
            else sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
        } else log('Trigger event cancelled: ' + triggerEvent);
    }
    function lockTrigger() {
        if (!triggerLocked) {
            triggerLocked = true;
            log('Trigger event lock on');
        }
        clearTimeout(triggerLockedTimer);
        triggerLockedTimer = setTimeout(function() {
            triggerLocked = false;
            log('Trigger event lock off');
            log('--');
        }, eventCancelTimer);
    }
    function triggerReset(triggerEvent) {
        height = getHeight[heightCalcMode]();
        width = getWidth[widthCalcMode]();
        sendMsg(height, width, triggerEvent);
    }
    function resetIFrame(triggerEventDesc) {
        var hcm = heightCalcMode;
        heightCalcMode = heightCalcModeDefault;
        log('Reset trigger event: ' + triggerEventDesc);
        lockTrigger();
        triggerReset('reset');
        heightCalcMode = hcm;
    }
    function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
        function setTargetOrigin() {
            if (undefined === targetOrigin) targetOrigin = targetOriginDefault;
            else log('Message targetOrigin: ' + targetOrigin);
        }
        function sendToParent() {
            var size = height + ':' + width, message = myID + ':' + size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');
            log('Sending message to host page (' + message + ')');
            target.postMessage(msgID + message, targetOrigin);
        }
        if (true === sendPermit) {
            setTargetOrigin();
            sendToParent();
        }
    }
    function receiver(event) {
        var processRequestFromParent = {
            init: function initFromParent() {
                initMsg = event.data;
                target = event.source;
                init();
                firstRun = false;
                setTimeout(function() {
                    initLock = false;
                }, eventCancelTimer);
            },
            reset: function resetFromParent() {
                if (!initLock) {
                    log('Page size reset by host page');
                    triggerReset('resetPage');
                } else log('Page reset ignored by init');
            },
            resize: function resizeFromParent() {
                sendSize('resizeParent', 'Parent window requested size check');
            },
            moveToAnchor: function moveToAnchorF() {
                inPageLinks.findTarget(getData());
            },
            inPageLink: function inPageLinkF() {
                this.moveToAnchor();
            },
            pageInfo: function pageInfoFromParent() {
                var msgBody = getData();
                log('PageInfoFromParent called from parent: ' + msgBody);
                onPageInfo(JSON.parse(msgBody));
                log(' --');
            },
            message: function messageFromParent() {
                var msgBody = getData();
                log('onMessage called from parent: ' + msgBody);
                // eslint-disable-next-line sonarjs/no-extra-arguments
                onMessage(JSON.parse(msgBody));
                log(' --');
            }
        };
        function isMessageForUs() {
            return msgID === ('' + event.data).substr(0, msgIdLen) // ''+ Protects against non-string messages
            ;
        }
        function getMessageType() {
            return event.data.split(']')[1].split(':')[0];
        }
        function getData() {
            return event.data.substr(event.data.indexOf(':') + 1);
        }
        function isMiddleTier() {
            return !module.exports && 'iFrameResize' in window || 'jQuery' in window && 'iFrameResize' in window.jQuery.prototype;
        }
        function isInitMsg() {
            // Test if this message is from a child below us. This is an ugly test, however, updating
            // the message format would break backwards compatibity.
            return event.data.split(':')[2] in {
                true: 1,
                false: 1
            };
        }
        function callFromParent() {
            var messageType = getMessageType();
            if (messageType in processRequestFromParent) processRequestFromParent[messageType]();
            else if (!isMiddleTier() && !isInitMsg()) warn('Unexpected message (' + event.data + ')');
        }
        function processMessage() {
            if (false === firstRun) callFromParent();
            else if (isInitMsg()) processRequestFromParent.init();
            else log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
        }
        if (isMessageForUs()) processMessage();
    }
    // Normally the parent kicks things off when it detects the iFrame has loaded.
    // If this script is async-loaded, then tell parent page to retry init.
    function chkLateLoaded() {
        if ('loading' !== document.readyState) window.parent.postMessage('[iFrameResizerChild]Ready', '*');
    }
    addEventListener(window, 'message', receiver);
    addEventListener(window, 'readystatechange', chkLateLoaded);
    chkLateLoaded();
})();

});

parcelRegister("7KMPr", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $dh538 = parcelRequire("dh538");


var $ijfiP = parcelRequire("ijfiP");


var $kaOT1 = parcelRequire("kaOT1");

const $9de26c8889125530$var$packageVersion = "0.0.0-use.local";
const $9de26c8889125530$export$bb9823fd3fb51f9c = 'https://1210cfc4338849588134f2c80b99f75c@o55978.ingest.sentry.io/5988824';
const $9de26c8889125530$export$b7f7efe8cd791eed = 'https://a377d38318350e08236b26b7b13c8016@sentry.atlassian-us-gov-mod.com/23';

const $9de26c8889125530$export$faf06bc0661c564c = async ({ error: error, environment: environment, errorExtensionDetails: errorExtensionDetails, page: page, errorInfo: errorInfo, runtime: runtime, tracing: tracing })=>{
    try {
        const module = await Promise.resolve((parcelRequire("7hGsm")));
        const { BrowserClient: BrowserClient, Hub: Hub } = module;
        // From https://sentry.io/settings/atlassian-2y/projects/forge-ui/keys/ and https://sentry.prod.services.kitt-inf-us-gov-mod.net/settings/sentry/projects/forge-ui/keys
        const dsn = (0, $lzcvT.isFedRamp)() ? $9de26c8889125530$export$b7f7efe8cd791eed : $9de26c8889125530$export$bb9823fd3fb51f9c;
        const client = new BrowserClient({
            environment: environment,
            dsn: dsn,
            release: `forge-ui@${$9de26c8889125530$var$packageVersion}`
        });
        const hub = new Hub(client);
        hub.withScope(async (scope)=>{
            if (tracing) {
                const breadcrumbs = tracing.getBreadcrumbs();
                breadcrumbs.forEach((bc)=>scope.addBreadcrumb(bc, 20));
            }
            if (errorInfo) scope.setExtra('componentTrace', {
                errorInfo: errorInfo,
                componentStack: errorInfo?.componentStack?.substring(0, 1000)
            });
            scope.setTag('extensionPoint', page);
            if (runtime && (0, $dh538.fg)('forge-ui-bridge-core-reset')) scope.setTag('forgeRuntime', runtime);
            if (errorExtensionDetails) {
                scope.setExtra('extensionProperties', errorExtensionDetails.properties);
                try {
                    const appIdFromId = (0, $ijfiP.parseExtensionId)(errorExtensionDetails.id ?? '').appId;
                    if (appIdFromId) scope.setTag('appId', appIdFromId);
                } catch (e) {
                // parseExtensionId() uses parse() form @atlassian/cs-ari, which throws an error if the ID is not valid
                }
                if (errorExtensionDetails.environmentType) scope.setTag('forgeEnvironment', errorExtensionDetails.environmentType);
                if (errorExtensionDetails.type) scope.setTag('extensionType', errorExtensionDetails.type);
                if (errorExtensionDetails.appOwnerAccountId) scope.setTag('appOwner', errorExtensionDetails.appOwnerAccountId);
            }
            hub.captureException(error);
        });
        return client.close();
    } catch (e) {
    // Error reporting failed, we don't want to cause a unhandledrejection event
    }
};
module.exports["captureAndReportError"] = $9de26c8889125530$export$faf06bc0661c564c;

});

parcelRegister("b4nol", function(module, exports) {
const $32cb6d3cd1e17c5c$export$6f54f2843389780e = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',
    MAX: 'max',
    FULLSCREEN: 'fullscreen',
    RESIZABLE: 'resizable'
};
const $32cb6d3cd1e17c5c$export$a1ac1511402c8dbf = (size)=>typeof size === 'string' && Object.values($32cb6d3cd1e17c5c$export$6f54f2843389780e).includes(size);
const $32cb6d3cd1e17c5c$export$e0b8baa8b7ed82d1 = (size)=>typeof size === 'object';
var $32cb6d3cd1e17c5c$export$d0163c7b07301739 = /*#__PURE__*/ function(FeatureFlagEnv) {
    FeatureFlagEnv["development"] = "development";
    FeatureFlagEnv["staging"] = "staging";
    FeatureFlagEnv["production"] = "production";
    return FeatureFlagEnv;
}({});
var $32cb6d3cd1e17c5c$export$35879154c49e2b67 = /*#__PURE__*/ function(FeatureFlagEventTypes) {
    FeatureFlagEventTypes["INITIALIZATION"] = "initialization";
    FeatureFlagEventTypes["CHECKFLAG"] = "checkFlag";
    return FeatureFlagEventTypes;
}({});
module.exports["isNamedSize"] = $32cb6d3cd1e17c5c$export$a1ac1511402c8dbf;
module.exports["isCustomDimensions"] = $32cb6d3cd1e17c5c$export$e0b8baa8b7ed82d1;
module.exports["FeatureFlagEnv"] = $32cb6d3cd1e17c5c$export$d0163c7b07301739;
module.exports["FeatureFlagEventTypes"] = $32cb6d3cd1e17c5c$export$35879154c49e2b67;

});

parcelRegister("luNHV", function(module, exports) {
// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
const $6d065658f7ab57e8$var$EVENT_PREFIX = 'forge.bridge.';
function $6d065658f7ab57e8$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
    };
    window.document.addEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
const $6d065658f7ab57e8$export$2b8594f1cc80daad = (event, callback, extension)=>{
    const wrappedCallback = (e)=>{
        const allowedRecipients = e.detail?.allowedRecipients || [];
        if (allowedRecipients.includes('*') || allowedRecipients.includes(extension.appId)) callback(e.detail?.payload);
    };
    window.document.addEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
};
function $6d065658f7ab57e8$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
} // emitPublic is implemented in useEmitPublicEvent hook
module.exports["on"] = $6d065658f7ab57e8$export$af631764ddc44097;
module.exports["onPublic"] = $6d065658f7ab57e8$export$2b8594f1cc80daad;
module.exports["emit"] = $6d065658f7ab57e8$export$8f35fbd5db0f3634;

});

parcelRegister("iqcSr", function(module, exports) {
const $017ffa7c15d62dd2$export$4c5241daa4566af8 = (extension, entryPoint)=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        return entryPointResource != null && entryPointRender !== 'native';
    }
    return resource != null && render !== 'native';
};
module.exports["isCustomUI"] = $017ffa7c15d62dd2$export$4c5241daa4566af8;

});

parcelRegister("fYGGr", function(module, exports) {
/**
 * @generated SignedSource<<337e64ff40a64fb18043a346c5087694>>
 * @relayHash 10bf7b8f8a0a27b56d7488a90abd1f4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15591e3b366a8b1e0b52de49b0cb781b2c83797c2deaf3b53bc2216d78467042
const $4a1f59567f907cdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contextIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dataClassificationTags"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "environmentId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "environmentType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "environmentKey"
    }, v13 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "concreteType": "AppInstallationLicense",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "active"
            },
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "supportEntitlementNumber"
            },
            {
                "kind": "ScalarField",
                "name": "trialEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "subscriptionEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "isEvaluation"
            },
            {
                "kind": "ScalarField",
                "name": "billingPeriod"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementSlug"
            },
            {
                "kind": "ScalarField",
                "name": "capabilitySet"
            },
            {
                "kind": "ScalarField",
                "name": "modes"
            }
        ]
    }, v16 = {
        "concreteType": "UserAccess",
        "kind": "LinkedField",
        "name": "userAccess",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "enabled"
            },
            {
                "kind": "ScalarField",
                "name": "hasAccess"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "appVersion"
    }, v18 = {
        "kind": "ScalarField",
        "name": "installationId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "migrationKey"
    }, v20 = {
        "concreteType": "EcosystemAppInstallationConfigExtension",
        "kind": "LinkedField",
        "name": "installationConfig",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v21 = {
        "concreteType": "AppNetworkEgressPermissionExtension",
        "kind": "LinkedField",
        "name": "egress",
        "plural": true,
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "addresses"
            },
            {
                "kind": "ScalarField",
                "name": "category"
            },
            {
                "kind": "ScalarField",
                "name": "inScopeEUD"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "scopes"
    }, v23 = {
        "kind": "ScalarField",
        "name": "consentUrl"
    }, v24 = {
        "concreteType": "UserConsentExtension",
        "kind": "LinkedField",
        "name": "currentUserConsent",
        "plural": false,
        "selections": [
            {
                "concreteType": "UserConsentExtensionUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "aaid"
                    }
                ]
            },
            {
                "concreteType": "UserConsentExtensionAppEnvironmentVersion",
                "kind": "LinkedField",
                "name": "appEnvironmentVersion",
                "plural": false,
                "selections": [
                    v5 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "consentedAt"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "requiresUserConsent"
    }, v26 = {
        "args": [
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "dataClassificationTags",
                        "variableName": "dataClassificationTags"
                    }
                ],
                "kind": "ObjectValue",
                "name": "input"
            }
        ],
        "concreteType": "DataClassificationPolicyDecision",
        "kind": "LinkedField",
        "name": "dataClassificationPolicyDecision",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "getForgeUIExtensionsAsync_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getForgeUIExtensionsAsync_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v9 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "15591e3b366a8b1e0b52de49b0cb781b2c83797c2deaf3b53bc2216d78467042",
            "metadata": {},
            "name": "getForgeUIExtensionsAsync_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4a1f59567f907cdf$var$node.hash = "0d2f8184c249f6d367df44b3d6f390eb";
var $4a1f59567f907cdf$export$2e2bcd8739ae039 = $4a1f59567f907cdf$var$node;


/**
 * @generated SignedSource<<1ece58a0fdf8038d853493f7fbae3763>>
 * @relayHash 5d987a62c02b64e7e7a5988082fb62f2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 890af040690b65aacfb01bbd1fe559d9974962954f4033400b4cc47cbb56e0ae
const $985615f75add3776$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getForgeUIExtensionsAsync_prefetchedQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getForgeUIExtensionsAsync_prefetchedQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "890af040690b65aacfb01bbd1fe559d9974962954f4033400b4cc47cbb56e0ae",
            "metadata": {},
            "name": "getForgeUIExtensionsAsync_prefetchedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$985615f75add3776$var$node.hash = "28b01d2e9aae97b40422b2e1e799d7e9";
var $985615f75add3776$export$2e2bcd8739ae039 = $985615f75add3776$var$node;



var $irOoi = parcelRequire("irOoi");


var $bsX2q = parcelRequire("bsX2q");

var $7zIsq = parcelRequire("7zIsq");


var $39Ajm = parcelRequire("39Ajm");


var $1Igmn = parcelRequire("1Igmn");

const $cf16612a3c00cd2e$export$f276dc1a7d0b17c5 = async ({ client: client, contextIds: contextIds, moduleType: moduleType, context: context, queryOptions: queryOptions, expandAppOwner: expandAppOwner, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, cloudId: cloudId, includeHidden: includeHidden, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall = false })=>{
    if (bypassNewForgeExtensionListCall === false) {
        const types = moduleType ? [
            moduleType
        ] : [];
        const requestOptions = (0, $7zIsq.createUsePrefilteredExtensionListQueryOptions)(cloudId ?? contextIds[0], context ?? {}, client, types, locale, includeHidden, queryOptions, contextIds);
        const { fetchPolicy: fetchPolicy, ...rest } = requestOptions;
        const { loading: loading, data: data, errors: errors } = await client.query({
            ...rest,
            query: (0, $39Ajm.FetchPreFilteredForgeAppsQuery),
            fetchPolicy: fetchPolicy === 'cache-and-network' ? 'network-only' : fetchPolicy
        });
        const extensions = (0, $7zIsq.getPrefilteredExtensionsGQLResult)({
            loading: loading,
            data: data
        });
        return {
            extensions: extensions,
            errors: errors
        };
    } else {
        const requestOptions = (0, $bsX2q.createExtensionListQueryOptions)(client, contextIds, queryOptions, expandAppOwner, extensionsFilter, moduleType, dataClassificationTagIds, locale);
        const queryResult = await client.query(requestOptions);
        return {
            extensions: (0, $bsX2q.getExtensionsFromGQLResult)(queryResult),
            errors: queryResult.errors
        };
    }
};
const $cf16612a3c00cd2e$export$d9a2a57bbfd1461b = async ({ contextIds: contextIds, moduleType: moduleType, context: context, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, cloudId: cloudId, includeHidden: includeHidden, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall = false, relayEnvironment: relayEnvironment })=>{
    if (!relayEnvironment) return {
        extensions: null,
        errors: [
            new Error('Relay environment is required for getForgeUIExtensionsRelayAsync')
        ]
    };
    if (!bypassNewForgeExtensionListCall) {
        const types = moduleType ? [
            moduleType
        ] : [];
        return new Promise((resolve)=>{
            (0, $irOoi.fetchQuery)(relayEnvironment, (0, $985615f75add3776$export$2e2bcd8739ae039), {
                cloudId: cloudId ?? contextIds[0],
                // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                context: context ?? {},
                includeHidden: includeHidden,
                locale: locale,
                types: types
            }, {
                networkCacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(cloudId)
                        },
                        allowOnExternalPage: true
                    }
                }
            }).subscribe({
                next: (data)=>{
                    const extensions = (0, $7zIsq.getPrefilteredExtensionsGQLResult)({
                        data: data,
                        loading: false
                    });
                    resolve({
                        extensions: extensions
                    });
                },
                error: (error)=>{
                    resolve({
                        errors: [
                            error
                        ],
                        extensions: null
                    });
                }
            });
        });
    }
    const filter = extensionsFilter ?? [
        {
            type: 'EXTENSION_TYPE',
            value: [
                moduleType
            ]
        }
    ];
    return new Promise((resolve)=>{
        (0, $irOoi.fetchQuery)(relayEnvironment, (0, $4a1f59567f907cdf$export$2e2bcd8739ae039), {
            contextIds: contextIds,
            locale: locale,
            filter: filter,
            dataClassificationTags: dataClassificationTagIds || []
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                    }
                }
            }
        }).subscribe({
            next: (data)=>{
                const extensions = (0, $bsX2q.getExtensionsFromGQLResult)({
                    data: data,
                    loading: false
                });
                resolve({
                    extensions: extensions
                });
            },
            error: (error)=>{
                resolve({
                    errors: [
                        error
                    ],
                    extensions: null
                });
            }
        });
    });
};
module.exports["getForgeUIExtensionsRelayAsync"] = $cf16612a3c00cd2e$export$d9a2a57bbfd1461b;

});

parcelRegister("bsX2q", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<29c00fa3b7c007b185432f931ba2456c>>
 * @relayHash 0335332109c787dc4b91ad6ee3894ceb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43e7393e2b1dd4daa4f22d1c50da6e90c43cb68701111912458e4f4d7d7f6af0
const $da23282f06eaa55d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contextIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dataClassificationTags"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "environmentId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "environmentType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "environmentKey"
    }, v13 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "concreteType": "AppInstallationLicense",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "active"
            },
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "supportEntitlementNumber"
            },
            {
                "kind": "ScalarField",
                "name": "trialEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "subscriptionEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "isEvaluation"
            },
            {
                "kind": "ScalarField",
                "name": "billingPeriod"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementSlug"
            },
            {
                "kind": "ScalarField",
                "name": "capabilitySet"
            },
            {
                "kind": "ScalarField",
                "name": "modes"
            }
        ]
    }, v16 = {
        "concreteType": "UserAccess",
        "kind": "LinkedField",
        "name": "userAccess",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "enabled"
            },
            {
                "kind": "ScalarField",
                "name": "hasAccess"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "appVersion"
    }, v18 = {
        "kind": "ScalarField",
        "name": "installationId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "migrationKey"
    }, v20 = {
        "concreteType": "EcosystemAppInstallationConfigExtension",
        "kind": "LinkedField",
        "name": "installationConfig",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v21 = {
        "concreteType": "AppNetworkEgressPermissionExtension",
        "kind": "LinkedField",
        "name": "egress",
        "plural": true,
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "addresses"
            },
            {
                "kind": "ScalarField",
                "name": "category"
            },
            {
                "kind": "ScalarField",
                "name": "inScopeEUD"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "scopes"
    }, v23 = {
        "kind": "ScalarField",
        "name": "consentUrl"
    }, v24 = {
        "concreteType": "UserConsentExtension",
        "kind": "LinkedField",
        "name": "currentUserConsent",
        "plural": false,
        "selections": [
            {
                "concreteType": "UserConsentExtensionUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "aaid"
                    }
                ]
            },
            {
                "concreteType": "UserConsentExtensionAppEnvironmentVersion",
                "kind": "LinkedField",
                "name": "appEnvironmentVersion",
                "plural": false,
                "selections": [
                    v5 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "consentedAt"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "requiresUserConsent"
    }, v26 = {
        "args": [
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "dataClassificationTags",
                        "variableName": "dataClassificationTags"
                    }
                ],
                "kind": "ObjectValue",
                "name": "input"
            }
        ],
        "concreteType": "DataClassificationPolicyDecision",
        "kind": "LinkedField",
        "name": "dataClassificationPolicyDecision",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useExtensionList_forge_ui_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useExtensionList_forge_ui_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v9 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "43e7393e2b1dd4daa4f22d1c50da6e90c43cb68701111912458e4f4d7d7f6af0",
            "metadata": {},
            "name": "useExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$da23282f06eaa55d$var$node.hash = "f4550c57b587a03d152e887674cfab78";
var $da23282f06eaa55d$export$2e2bcd8739ae039 = $da23282f06eaa55d$var$node;



var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $xQxzY = parcelRequire("xQxzY");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");

const $0f17c7f20af36c2d$export$73c0408abd298d1b = (client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, ssr = false)=>{
    const variables = filter ? {
        contextIds: contextIds,
        locale: locale,
        filter: filter
    } : {
        contextIds: contextIds,
        locale: locale,
        type: extensionType
    };
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner, dataClassificationTagIds) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner, undefined, dataClassificationTagIds);
    // In SSR mode render and fetch is one-pass we can't do cache-and-network
    if (ssr && queryOptions?.fetchPolicy === 'cache-and-network') queryOptions.fetchPolicy = 'cache-first';
    return {
        variables: variables,
        ...queryOptions,
        query: query,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            }
        }
    };
};
const $0f17c7f20af36c2d$export$1e6dc3c07340999 = ({ loading: loading, data: data })=>{
    if (!loading && data && data.extensionContexts && data.extensionContexts[0]) {
        if ('extensions' in data.extensionContexts[0]) // @ts-ignore
        return data.extensionContexts[0].extensions ?? null;
        else if ('extensionsByType' in data.extensionContexts[0]) return data.extensionContexts[0].extensionsByType ?? null;
    }
    return null;
};
const $0f17c7f20af36c2d$export$cab421e039d23b2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(32);
    const { contextIds: contextIds, type: extensionType, filter: filter, client: client, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale } = t0;
    let t1;
    if ($[0] !== client || $[1] !== contextIds || $[2] !== dataClassificationTagIds || $[3] !== expandAppOwner || $[4] !== extensionType || $[5] !== filter || $[6] !== locale || $[7] !== queryOptions) {
        t1 = $0f17c7f20af36c2d$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale);
        $[0] = client;
        $[1] = contextIds;
        $[2] = dataClassificationTagIds;
        $[3] = expandAppOwner;
        $[4] = extensionType;
        $[5] = filter;
        $[6] = locale;
        $[7] = queryOptions;
        $[8] = t1;
    } else t1 = $[8];
    const requestOptions = t1;
    let t2;
    if ($[9] !== expandAppOwner || $[10] !== filter) {
        t2 = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner);
        $[9] = expandAppOwner;
        $[10] = filter;
        $[11] = t2;
    } else t2 = $[11];
    const query = t2;
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)(requestOptions.query || query, requestOptions);
    let t3;
    if ($[12] !== data || $[13] !== loading) {
        t3 = $0f17c7f20af36c2d$export$1e6dc3c07340999({
            loading: loading,
            data: data
        });
        $[12] = data;
        $[13] = loading;
        $[14] = t3;
    } else t3 = $[14];
    const extensions = t3;
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t4;
    let t5;
    if ($[15] !== createAnalyticsEvent || $[16] !== extensions || $[17] !== page) {
        t4 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "useExtensionList"
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t5 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[15] = createAnalyticsEvent;
        $[16] = extensions;
        $[17] = page;
        $[18] = t4;
        $[19] = t5;
    } else {
        t4 = $[18];
        t5 = $[19];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[20] !== createAnalyticsEvent || $[21] !== error || $[22] !== extensions || $[23] !== page) {
        t6 = ()=>{
            if (!extensions && error && error.graphQLErrors.length > 0) {
                const err_0 = error.graphQLErrors.find($0f17c7f20af36c2d$var$_temp);
                createAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "useExtensionList",
                            errorName: err_0 ? (0, $grQpA.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t7 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[20] = createAnalyticsEvent;
        $[21] = error;
        $[22] = extensions;
        $[23] = page;
        $[24] = t6;
        $[25] = t7;
    } else {
        t6 = $[24];
        t7 = $[25];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[26] !== extensions) {
        t8 = extensions || [];
        $[26] = extensions;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== error || $[29] !== loading || $[30] !== t8) {
        t9 = {
            error: error,
            extensions: t8,
            loading: loading
        };
        $[28] = error;
        $[29] = loading;
        $[30] = t8;
        $[31] = t9;
    } else t9 = $[31];
    return t9;
} : ({ contextIds: contextIds, type: extensionType, filter: filter, client: client, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale })=>{
    const requestOptions = $0f17c7f20af36c2d$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale);
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)(requestOptions.query || query, requestOptions);
    const extensions = $0f17c7f20af36c2d$export$1e6dc3c07340999({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'useExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err_0 = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err_0 ? (0, $grQpA.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $0f17c7f20af36c2d$export$73b3e0afa63af44a = ({ contextIds: contextIds, type: extensionType, filter: extensionFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, queryOptions: queryOptions })=>{
    const [extensions, setExtensions] = (0, $42omo.useState)(null);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const environment = (0, $irOoi.useRelayEnvironment)();
    // Context ids only ever contains a single id.
    // Extract out the id so that the useEffect dependency is a string instead of an array
    const contextId = contextIds[0];
    const shouldSkip = queryOptions?.skip;
    const stringifiedFilter = JSON.stringify(extensionFilter);
    const filter = (0, $42omo.useMemo)(()=>{
        return extensionFilter ?? [
            {
                type: 'EXTENSION_TYPE',
                value: [
                    extensionType
                ]
            }
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stringifiedFilter,
        extensionType
    ]);
    (0, $42omo.useEffect)(()=>{
        const contextIds = [
            contextId
        ];
        if (!shouldSkip) (0, $irOoi.fetchQuery)(environment, (0, $da23282f06eaa55d$export$2e2bcd8739ae039), {
            contextIds: contextIds,
            locale: locale,
            filter: filter,
            dataClassificationTags: dataClassificationTagIds || []
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                    }
                }
            }
        }).subscribe({
            next: (data)=>{
                const extensions = $0f17c7f20af36c2d$export$1e6dc3c07340999({
                    data: data,
                    loading: false
                });
                if (extensions) createAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: 'succeeded',
                        actionSubject: 'forge.ui.webClient',
                        source: page,
                        tags: [
                            'forge'
                        ],
                        attributes: {
                            target: 'useExtensionList'
                        }
                    }
                }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                setExtensions(extensions);
                setLoading(false);
            },
            error: (error)=>{
                setError(error);
                setLoading(false);
            }
        });
    }, [
        shouldSkip,
        contextId,
        filter,
        extensionType,
        locale,
        dataClassificationTagIds,
        environment,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $grQpA.isRelayNetworkError)(error)) {
            const err = error.source.errors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
function $0f17c7f20af36c2d$var$_temp(err) {
    return (0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err);
}
module.exports["createExtensionListQueryOptions"] = $0f17c7f20af36c2d$export$73c0408abd298d1b;
module.exports["getExtensionsFromGQLResult"] = $0f17c7f20af36c2d$export$1e6dc3c07340999;
module.exports["useExtensionListRelay"] = $0f17c7f20af36c2d$export$73b3e0afa63af44a;

});

parcelRegister("1uzCd", function(module, exports) {
const $3034561136ba9291$export$a728e3e4d9df1392 = ()=>{
    if (!performance) return 0;
    return Math.trunc(performance.now());
};
module.exports["getPerformanceMark"] = $3034561136ba9291$export$a728e3e4d9df1392;

});

parcelRegister("iUjrf", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eI4ye = parcelRequire("eI4ye");


var $dh538 = parcelRequire("dh538");


var $jLeRZ = parcelRequire("jLeRZ");

const $169953af4b6e4ccf$export$8da39d297b8df514 = (0, $jLeRZ.z).object({
    event: (0, $jLeRZ.z).literal('click')
}).strip();
const $169953af4b6e4ccf$export$1226cd123c17e5c1 = (0, $jLeRZ.z).object({
    event: (0, $jLeRZ.z).literal('navigation-timing'),
    transferSize: (0, $jLeRZ.z).number().nonnegative().finite(),
    duration: (0, $jLeRZ.z).number().nonnegative().finite()
}).strict();
const $169953af4b6e4ccf$var$initiatorTypeValues = (0, $jLeRZ.z).enum([
    'script',
    'fetch',
    'css',
    'link',
    'iframe',
    'img',
    'image',
    'xmlhttprequest',
    'other'
]);
const $169953af4b6e4ccf$export$53d51f558d70545c = (0, $jLeRZ.z).object({
    event: (0, $jLeRZ.z).literal('resource-timing'),
    start: (0, $jLeRZ.z).number().nonnegative().finite(),
    duration: (0, $jLeRZ.z).number().nonnegative().finite(),
    transferSize: (0, $jLeRZ.z).number().nonnegative().finite(),
    initiatorType: (0, $jLeRZ.z).string().pipe($169953af4b6e4ccf$var$initiatorTypeValues.catch($169953af4b6e4ccf$var$initiatorTypeValues.Values.other)).pipe((0, $jLeRZ.z).string())
}).strict();
const $169953af4b6e4ccf$export$dcaedcbfb2a9bf04 = (0, $jLeRZ.z).object({
    event: (0, $jLeRZ.z).literal('dcls-score'),
    score: (0, $jLeRZ.z).number().nonnegative().finite(),
    timestamp: (0, $jLeRZ.z).number().nonnegative().finite(),
    inputFlag: (0, $jLeRZ.z).boolean()
}).strict();
const $169953af4b6e4ccf$export$ea631521a752c0a8 = (0, $jLeRZ.z).object({
    event: (0, $jLeRZ.z).literal('fcp-snapshot'),
    start: (0, $jLeRZ.z).number().nonnegative().finite()
}).strict();
const $169953af4b6e4ccf$export$23e438485c66108 = (0, $jLeRZ.z).object({
    event: (0, $jLeRZ.z).literal('lcp-snapshot'),
    size: (0, $jLeRZ.z).number().nonnegative().finite(),
    start: (0, $jLeRZ.z).number().nonnegative().finite()
}).strict();
const $169953af4b6e4ccf$var$serialisableValueSchema = (0, $jLeRZ.z).lazy(()=>(0, $jLeRZ.z).union([
        (0, $jLeRZ.z).string(),
        (0, $jLeRZ.z).number().finite(),
        (0, $jLeRZ.z).boolean(),
        (0, $jLeRZ.z).null(),
        (0, $jLeRZ.z).array($169953af4b6e4ccf$var$serialisableValueSchema),
        (0, $jLeRZ.z).record((0, $jLeRZ.z).string(), $169953af4b6e4ccf$var$serialisableValueSchema)
    ]));
const $169953af4b6e4ccf$export$a4b565c65b9cd65 = (0, $jLeRZ.z).object({
    event: (0, $jLeRZ.z).literal('ufo-event'),
    name: (0, $jLeRZ.z).string().min(1).max(256),
    payload: (0, $jLeRZ.z).record((0, $jLeRZ.z).string(), $169953af4b6e4ccf$var$serialisableValueSchema)
}).strict();
const $169953af4b6e4ccf$export$d659b0ed364a2533 = (0, $jLeRZ.z).discriminatedUnion('event', [
    $169953af4b6e4ccf$export$8da39d297b8df514,
    $169953af4b6e4ccf$export$1226cd123c17e5c1,
    $169953af4b6e4ccf$export$53d51f558d70545c,
    $169953af4b6e4ccf$export$dcaedcbfb2a9bf04,
    $169953af4b6e4ccf$export$ea631521a752c0a8,
    $169953af4b6e4ccf$export$23e438485c66108,
    $169953af4b6e4ccf$export$a4b565c65b9cd65
]);



var $1uzCd = parcelRequire("1uzCd");

const $e9d25c3abed1c1e7$var$ClickedProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$8da39d297b8df514).transform((_)=>{
    return {
        type: 'user-interacted',
        elapsed: (0, $1uzCd.getPerformanceMark)()
    };
});
const $e9d25c3abed1c1e7$var$NavigationTimingProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$1226cd123c17e5c1).transform((e)=>{
    return {
        type: 'navigation-timing',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        duration: Math.trunc(e.duration),
        transferSize: e.transferSize
    };
});
const $e9d25c3abed1c1e7$var$ResourceTimingProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$53d51f558d70545c).transform((e)=>{
    return {
        type: 'resource-timing',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        start: Math.trunc(e.start),
        duration: Math.trunc(e.duration),
        transferSize: Math.trunc(e.transferSize),
        initiatorType: e.initiatorType
    };
});
const $e9d25c3abed1c1e7$var$LayoutShiftProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$dcaedcbfb2a9bf04).transform((e)=>{
    return {
        type: 'dcls-score',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        timestamp: Math.trunc(e.timestamp),
        // Transport 2dp truncated to avoid precision errors.
        score: Math.trunc(e.score * 100),
        inputFlag: e.inputFlag
    };
});
const $e9d25c3abed1c1e7$var$FCPProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$ea631521a752c0a8).transform((e)=>{
    return {
        type: 'fcp-snapshot',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        start: Math.trunc(e.start)
    };
});
const $e9d25c3abed1c1e7$var$LCPProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$23e438485c66108).transform((e)=>{
    return {
        type: 'lcp-snapshot',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        start: Math.trunc(e.start),
        size: Math.trunc(e.size)
    };
});
const $e9d25c3abed1c1e7$var$UFOFrameCapturableEventTransform = (0, $169953af4b6e4ccf$export$a4b565c65b9cd65).transform((e)=>({
        type: 'ufo-event',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        name: e.name,
        payload: e.payload
    }));
// For each in-frame event type, there should be a transformer to a safely ingestible event.
const $e9d25c3abed1c1e7$var$transformers = {
    'navigation-timing': $e9d25c3abed1c1e7$var$NavigationTimingProfilingCapturableEventTransform,
    'resource-timing': $e9d25c3abed1c1e7$var$ResourceTimingProfilingCapturableEventTransform,
    'dcls-score': $e9d25c3abed1c1e7$var$LayoutShiftProfilingCapturableEventTransform,
    click: $e9d25c3abed1c1e7$var$ClickedProfilingCapturableEventTransform,
    'fcp-snapshot': $e9d25c3abed1c1e7$var$FCPProfilingCapturableEventTransform,
    'lcp-snapshot': $e9d25c3abed1c1e7$var$LCPProfilingCapturableEventTransform,
    'ufo-event': $e9d25c3abed1c1e7$var$UFOFrameCapturableEventTransform
};
const $e9d25c3abed1c1e7$export$d85e1d6e65aaba29 = (0, $169953af4b6e4ccf$export$d659b0ed364a2533).transform((e)=>$e9d25c3abed1c1e7$var$transformers[e.event].parse(e));


const $031ec269e4b6a566$export$a8c9835719b09864 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    let t0;
    if ($[0] !== timelineRef) {
        t0 = (event)=>{
            if (!(0, $dh538.fg)("forge-ui-app-perf-tracking-enabled") || !timelineRef?.current) return;
            if (event.type === "ufo-event" && !(0, $dh538.fg)("platform_ufo_3p_segment_timings")) return;
            timelineRef.current.events.push(event);
            timelineRef.current.listeners.forEach((listener)=>listener(event));
        };
        $[0] = timelineRef;
        $[1] = t0;
    } else t0 = $[1];
    const captureEvent = t0;
    let t1;
    if ($[2] !== captureEvent) {
        t1 = (event_0)=>{
            if (!(0, $dh538.fg)("forge-ui-app-perf-tracking-enabled")) return;
            const result = (0, $e9d25c3abed1c1e7$export$d85e1d6e65aaba29).safeParse(event_0);
            if (!result.success) return;
            captureEvent(result.data);
        };
        $[2] = captureEvent;
        $[3] = t1;
    } else t1 = $[3];
    const captureUntrustedEvent = t1;
    let t2;
    if ($[4] !== captureEvent || $[5] !== captureUntrustedEvent) {
        t2 = {
            captureEvent: captureEvent,
            captureUntrustedEvent: captureUntrustedEvent
        };
        $[4] = captureEvent;
        $[5] = captureUntrustedEvent;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    // Use for out-of-frame capture in platform code.
    const captureEvent = (0, $42omo.useCallback)((event)=>{
        if (!(0, $dh538.fg)('forge-ui-app-perf-tracking-enabled') || !timelineRef?.current) return;
        if (event.type === 'ufo-event' && !(0, $dh538.fg)('platform_ufo_3p_segment_timings')) return;
        timelineRef.current.events.push(event);
        timelineRef.current.listeners.forEach((listener)=>listener(event));
    }, [
        timelineRef
    ]);
    // Use for capturing events from untrusted sources (e.g. in-frame via bridge).
    const captureUntrustedEvent = (0, $42omo.useCallback)((event_0)=>{
        if (!(0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')) return;
        const result = (0, $e9d25c3abed1c1e7$export$d85e1d6e65aaba29).safeParse(event_0);
        if (!result.success) // TODO: log failed validations to detect contract mismatches/tampering.
        return;
        captureEvent(result.data);
    }, [
        captureEvent
    ]);
    return {
        captureEvent: captureEvent,
        captureUntrustedEvent: captureUntrustedEvent
    };
};
module.exports["usePerformanceAnalytics"] = $031ec269e4b6a566$export$a8c9835719b09864;

});

parcelRegister("3qMxz", function(module, exports) {

var $luNHV = parcelRequire("luNHV");

const $b8ca2562eeb0d9e1$var$EMIT_READY_EVENT_NAME = 'EXTENSION_READY';
const $b8ca2562eeb0d9e1$var$UPDATE_BYLINE_ITEM_EVENT_NAME = 'FORGE_CONTENT_PROPERTY_UPDATED';
const $b8ca2562eeb0d9e1$export$7691e780388a0497 = (eventKey, eventName)=>{
    if (!eventName) return false;
    return eventKey === 'emit' && !(eventName === $b8ca2562eeb0d9e1$var$EMIT_READY_EVENT_NAME || eventName === $b8ca2562eeb0d9e1$var$UPDATE_BYLINE_ITEM_EVENT_NAME);
};
const $b8ca2562eeb0d9e1$export$b0842aa1e96f4de = (eventKey, dataToForward, postRobotSend, embeddedParentLocalId, extensionDetails)=>async ({ data: data })=>{
        // emitReadyEvent method calls the event method and also the actual emitReadyEvent method.
        // In use bridge we have 'emit' method and 'emitReadyEvent' method
        // This is referring to the former. For the latter, event key will be 'emitReadyEvent'
        if ($b8ca2562eeb0d9e1$export$7691e780388a0497(eventKey, data?.event)) {
            // Emit event as usual unless it is emitReadyEvent or updateBylineProperties event
            (0, $luNHV.emit)(data?.event, data?.payload, extensionDetails);
            return;
        }
        if (!postRobotSend || !embeddedParentLocalId) return;
        // This would need to be changed if we want to support multiple nesting levels
        const targetWindow = window.parent?.parent;
        if (!targetWindow || targetWindow === window) return;
        // Only forward to same hostname as FAUS for security (allow different ports for local dev)
        const targetDomain = `${window.location.protocol}//${window.location.hostname}`;
        // Check if data is an object or not.
        // E.g. updateMacroContent method's data is a type string.
        const originalPayload = typeof data === 'object' ? data : {
            data: data
        };
        const forwardedData = {
            eventKey: eventKey,
            ...dataToForward,
            ...originalPayload
        };
        try {
            const { data: data } = await postRobotSend(targetWindow, `messageFromEmbeddedFAUS_${embeddedParentLocalId}`, forwardedData, {
                domain: targetDomain
            });
            return data;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Failed to forward ${eventKey} to product:`, error);
        }
    };
module.exports["createMessageForwarder"] = $b8ca2562eeb0d9e1$export$b0842aa1e96f4de;

});

parcelRegister("kZjf5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Faxc = parcelRequire("3Faxc");


var $6xdDU = parcelRequire("6xdDU");


var $3Spjc = parcelRequire("3Spjc");


var $kxKUs = parcelRequire("kxKUs");


var $i5CVI = parcelRequire("i5CVI");


var $2kGKp = parcelRequire("2kGKp");


var $lMJg3 = parcelRequire("lMJg3");


var $kTcrU = parcelRequire("kTcrU");


var $9v4R2 = parcelRequire("9v4R2");

const $c92260a0208e3eb8$export$d0fd4b7106de2769 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useNavigation(t0) {
    const $ = (0, $frIzR.c)(11);
    const { extension: extension, push: push } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            state: "closed"
        };
        $[0] = t1;
    } else t1 = $[0];
    const [modalState, setModalState] = (0, $42omo.useState)(t1);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const egressService = (0, $lMJg3.useEgressPermissionService)("FETCH_CLIENT_SIDE", extension.egress);
    let t2;
    if ($[1] !== createAnalyticsEvent || $[2] !== egressService || $[3] !== push) {
        t2 = async (t3)=>{
            const { type: type, url: urlString } = t3;
            const url = (0, $kTcrU.makeUrl)(urlString);
            const linkType = $c92260a0208e3eb8$export$8071740a02e53ce2(url, egressService);
            if (linkType === "invalid" || !url) throw new (0, $kxKUs.BridgeClientError)(`link is invalid: ${urlString}`);
            if (linkType === "trusted") {
                (0, $i5CVI.navigate)(url.href, type, push);
                return;
            }
            const analyticsAttributes = $c92260a0208e3eb8$export$e748b6351ba5f204(url);
            return new Promise((resolve, reject)=>{
                createAnalyticsEvent({
                    eventType: (0, $7TH2w.UI_EVENT_TYPE),
                    data: {
                        action: "viewed",
                        actionSubject: "externalLinkModal",
                        attributes: analyticsAttributes
                    }
                }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                setModalState({
                    state: "open",
                    url: url,
                    onConfirm: ()=>{
                        (0, $i5CVI.navigate)(url.href, type, push);
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.UI_EVENT_TYPE),
                            data: {
                                action: "approved",
                                actionSubject: "externalLinkModal",
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        resolve();
                    },
                    onCancel: ()=>{
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.UI_EVENT_TYPE),
                            data: {
                                action: "cancelled",
                                actionSubject: "externalLinkModal",
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        reject(new (0, $kxKUs.BridgeClientError)("cancelled"));
                    }
                });
            });
        };
        $[1] = createAnalyticsEvent;
        $[2] = egressService;
        $[3] = push;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== extension.properties?.title || $[6] !== modalState) {
        t3 = ()=>{
            if (modalState.state === "closed") return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null);
            return /*#__PURE__*/ $42omo.createElement((0, $3Faxc.ExternalLinkModal), {
                url: modalState.url,
                extensionTitle: extension.properties?.title,
                onCancel: ()=>{
                    setModalState({
                        state: "closed"
                    });
                    modalState.onCancel();
                },
                onConfirm: ()=>{
                    modalState.onConfirm();
                    setModalState({
                        state: "closed"
                    });
                }
            });
        };
        $[5] = extension.properties?.title;
        $[6] = modalState;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t2 || $[9] !== t3) {
        t4 = {
            onNavigate: t2,
            getModalJsx: t3
        };
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : function useNavigation({ extension: extension, push: push }) {
    const [modalState, setModalState] = (0, $42omo.useState)({
        state: 'closed'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const egressService = (0, $lMJg3.useEgressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
    return {
        onNavigate: async ({ type: type, url: urlString })=>{
            const url = (0, $kTcrU.makeUrl)(urlString);
            const linkType = $c92260a0208e3eb8$export$8071740a02e53ce2(url, egressService);
            if (linkType === 'invalid' || !url) throw new (0, $kxKUs.BridgeClientError)(`link is invalid: ${urlString}`);
            if (linkType === 'trusted') {
                (0, $i5CVI.navigate)(url.href, type, push);
                return;
            }
            const analyticsAttributes = $c92260a0208e3eb8$export$e748b6351ba5f204(url);
            return new Promise((resolve, reject)=>{
                // TODO: remove this event once we have switched over to the new event schema
                // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                createAnalyticsEvent({
                    eventType: (0, $7TH2w.UI_EVENT_TYPE),
                    data: {
                        action: 'viewed',
                        actionSubject: 'externalLinkModal',
                        attributes: analyticsAttributes
                    }
                }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                setModalState({
                    state: 'open',
                    url: url,
                    onConfirm: ()=>{
                        (0, $i5CVI.navigate)(url.href, type, push); // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.UI_EVENT_TYPE),
                            data: {
                                action: 'approved',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        resolve();
                    },
                    onCancel: ()=>{
                        // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.UI_EVENT_TYPE),
                            data: {
                                action: 'cancelled',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        reject(new (0, $kxKUs.BridgeClientError)('cancelled'));
                    }
                });
            });
        },
        getModalJsx: ()=>{
            if (modalState.state === 'closed') return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null);
            return /*#__PURE__*/ $42omo.createElement((0, $3Faxc.ExternalLinkModal), {
                url: modalState.url,
                extensionTitle: extension.properties?.title,
                onCancel: ()=>{
                    setModalState({
                        state: 'closed'
                    });
                    modalState.onCancel();
                },
                onConfirm: ()=>{
                    modalState.onConfirm();
                    setModalState({
                        state: 'closed'
                    });
                }
            });
        }
    };
};
const $c92260a0208e3eb8$var$getRootDomain = (url)=>{
    const hostnameParts = url.hostname.split('.'); // Root domain consists of the last two parts of the hostname
    if (hostnameParts.length > 1) return hostnameParts.slice(-2).join('.');
    else // If there's only one part, return it (e.g., 'localhost')
    return url.hostname;
};
function $c92260a0208e3eb8$export$8071740a02e53ce2(url, egressService) {
    if (!url) return 'invalid';
    if (url.protocol === 'mailto:') return 'trusted';
    if (url.protocol === 'tel:') return 'trusted';
    try {
        // URL is listed under permissions in manifest
        if (egressService.isValidUrl(url.href)) return 'trusted';
         // URL is from same origin
        if (url.origin === (0, $2kGKp.getOrigin)()) return 'trusted';
         // URL is under a trusted atlassian domain
        const rootDomain = $c92260a0208e3eb8$var$getRootDomain(url);
        if ((0, $9v4R2.TRUSTED_ROOT_DOMAINS).includes(rootDomain)) return 'trusted';
        if ([
            'https:',
            'http:'
        ].includes(url.protocol)) return 'external';
    } catch  {}
    return 'invalid';
}
function $c92260a0208e3eb8$export$e748b6351ba5f204(url) {
    // Don't count the initial `?` in the query string length.
    const queryStringSize = url.search.length > 1 ? url.search.length - 1 : 0;
    return {
        url: url.href,
        queryStringSize: queryStringSize
    };
}
module.exports["useNavigation"] = $c92260a0208e3eb8$export$d0fd4b7106de2769;
module.exports["getLinkType"] = $c92260a0208e3eb8$export$8071740a02e53ce2;
module.exports["getAnalyticsAttributes"] = $c92260a0208e3eb8$export$e748b6351ba5f204;

});

parcelRegister("lMJg3", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $471wb = parcelRequire("471wb");

const $462f7dce88626787$export$440f6339165c68d2 = (permissionType, egress)=>{
    const egressUrls = (egress || []).find((permission)=>permission.type === permissionType);
    const allowedUrls = egressUrls ? egressUrls.addresses : [];
    return new (0, $471wb.EgressFilteringService)(allowedUrls);
};
const $462f7dce88626787$export$8a0b6b45ac3015d5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (permissionType, egress)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] !== egress || $[1] !== permissionType) {
        t0 = $462f7dce88626787$export$440f6339165c68d2(permissionType, egress);
        $[0] = egress;
        $[1] = permissionType;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (permissionType, egress)=>{
    return (0, $42omo.useMemo)(()=>{
        return $462f7dce88626787$export$440f6339165c68d2(permissionType, egress);
    }, [
        permissionType,
        egress
    ]);
};
module.exports["egressPermissionService"] = $462f7dce88626787$export$440f6339165c68d2;
module.exports["useEgressPermissionService"] = $462f7dce88626787$export$8a0b6b45ac3015d5;

});

parcelRegister("kRUUL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("5ExMm")), module.exports);

$hXuPC.__exportStar((parcelRequire("bJnpv")), module.exports);

$hXuPC.__exportStar((parcelRequire("fgfHi")), module.exports);

});

parcelRegister("5ExMm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EgressFilteringService = void 0;

var $bJnpv = parcelRequire("bJnpv");


var $fgfHi = parcelRequire("fgfHi");

class $41dae3f6a51269f4$var$EgressFilteringService {
    parseUrl(url) {
        return (0, $bJnpv.parseUrl)(url);
    }
    containsWildCardEgress() {
        return this.allowsEverything;
    }
    isValidUrl(url) {
        if (this.allowsEverything) return true;
        const parsedUrl = this.parseUrl(url);
        return this.allowedDomainExact(parsedUrl, this.URLs) || this.allowedDomainPattern(parsedUrl, this.wildcardDomains);
    }
    allowedDomainExact(domain, allowList) {
        return allowList.filter((allowed)=>allowed.protocol === domain.protocol).some((url)=>url.hostname === domain.hostname);
    }
    allowedDomainPattern(domain, allowList) {
        return allowList.filter((allowed)=>allowed.protocol === domain.protocol).some((pattern)=>pattern.regex.test(domain.hostname));
    }
    constructor(allowList){
        this.URLs = allowList.filter((domainOrURL)=>!domainOrURL.startsWith('*')).map((url)=>this.parseUrl(url));
        this.wildcardDomains = allowList.filter((domainOrURL)=>domainOrURL !== '*').map((url)=>this.parseUrl(url)).filter((url)=>decodeURIComponent(url.hostname).startsWith('*')).map((url)=>({
                ...url,
                regex: (0, $fgfHi.globToRegex)(decodeURIComponent(url.hostname))
            }));
        this.allowsEverything = allowList.includes('*');
    }
}
module.exports.EgressFilteringService = $41dae3f6a51269f4$var$EgressFilteringService;

});

parcelRegister("bJnpv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUrl = void 0;
function $88a60e7f5ad1cf39$var$parseUrl(url) {
    var _a, _b;
    const protocol = (_b = (_a = url.match(/^(.*?:)/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : 'https:';
    const hostname = url.replace(protocol, '').replace(/^\/*/, '').replace(/^\\*/, '').split(/[\?\/]/)[0];
    return {
        protocol: protocol,
        hostname: hostname
    };
}
module.exports.parseUrl = $88a60e7f5ad1cf39$var$parseUrl;

});

parcelRegister("fgfHi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEgressesBasedOnToggles = module.exports.sortAndGroupEgressPermissionsByDomain = module.exports.EgressCategory = module.exports.EgressType = module.exports.globToRegex = void 0;

var $bJnpv = parcelRequire("bJnpv");

function $b1c486d357da07ae$var$globToRegex(pattern) {
    const escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
    const regexPattern = escaped.replace(/\*/g, '.*');
    return new RegExp(`^${regexPattern}$`);
}
module.exports.globToRegex = $b1c486d357da07ae$var$globToRegex;
const $b1c486d357da07ae$var$sortAndGroupEgressPermissionsByDomain = (egressAddresses)=>{
    if ((egressAddresses === null || egressAddresses === void 0 ? void 0 : egressAddresses.length) === 0) return [];
    const protocolRegex = /^(.*?:\/\/)/;
    const domains = new Set();
    const wildcardDomains = [];
    egressAddresses.forEach((item)=>{
        const itemWithProtocol = protocolRegex.test(item) ? item : `https://${item}`;
        const url = (0, $bJnpv.parseUrl)(itemWithProtocol);
        if (url.hostname.startsWith('*')) {
            domains.add(url.hostname.substring(2));
            wildcardDomains.push($b1c486d357da07ae$var$globToRegex(url.hostname));
        } else domains.add(url.hostname);
    });
    return [
        ...domains
    ].sort().reduce((grouped, domain)=>{
        if (!wildcardDomains.some((pattern)=>pattern.test(domain))) grouped.push(domain);
        return grouped;
    }, []);
};
module.exports.sortAndGroupEgressPermissionsByDomain = $b1c486d357da07ae$var$sortAndGroupEgressPermissionsByDomain;
var $b1c486d357da07ae$var$EgressType;
(function(EgressType) {
    EgressType["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    EgressType["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    EgressType["Fonts"] = "FONTS";
    EgressType["Frames"] = "FRAMES";
    EgressType["Images"] = "IMAGES";
    EgressType["Media"] = "MEDIA";
    EgressType["Navigation"] = "NAVIGATION";
    EgressType["Scripts"] = "SCRIPTS";
    EgressType["Styles"] = "STYLES";
})($b1c486d357da07ae$var$EgressType = module.exports.EgressType || (module.exports.EgressType = {}));
var $b1c486d357da07ae$var$EgressCategory;
(function(EgressCategory) {
    EgressCategory["ANALYTICS"] = "ANALYTICS";
})($b1c486d357da07ae$var$EgressCategory = module.exports.EgressCategory || (module.exports.EgressCategory = {}));
const $b1c486d357da07ae$var$getEgressesBasedOnToggles = (input)=>{
    const filteredEgresses = input.egress.filter((egress)=>{
        var _a;
        if (((_a = egress.category) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === $b1c486d357da07ae$var$EgressCategory.ANALYTICS) {
            if (input.installationConfig) {
                const analyticsConfig = input.installationConfig.find((config)=>config.key.toUpperCase() === 'ALLOW_EGRESS_ANALYTICS');
                return (analyticsConfig === null || analyticsConfig === void 0 ? void 0 : analyticsConfig.value) !== false;
            } else return input.overrides.ALLOW_EGRESS_ANALYTICS !== false;
        }
        return true;
    });
    const egressByType = new Map();
    for (const egress of filteredEgresses){
        if (!egressByType.has(egress.type)) egressByType.set(egress.type, egress.addresses);
        egressByType.set(egress.type, [
            ...egressByType.get(egress.type),
            ...egress.addresses
        ]);
    }
    return [
        ...egressByType.entries()
    ].map(([type, egresses])=>({
            type: type,
            addresses: [
                ...new Set(egresses)
            ]
        }));
};
module.exports.getEgressesBasedOnToggles = $b1c486d357da07ae$var$getEgressesBasedOnToggles;

});

parcelRegister("CMcde", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $a7bb558f45760cd7$export$3b0d6d7590275603 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            testId: "forge-app-loading-spinner",
            size: "large"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        testId: "forge-app-loading-spinner",
        size: "large"
    }));
};
module.exports["Loader"] = $a7bb558f45760cd7$export$3b0d6d7590275603;

});

parcelRegister("jc2GP", function(module, exports) {
const $45b69e870d2a465f$export$45b306f42e1402e5 = (extension)=>{
    const { properties: properties } = extension;
    if (properties?.layout === 'bodied') return 'bodiedExtension';
    else if (properties?.layout === 'inline') return 'inlineExtension';
    return 'extension';
};
module.exports["getExtensionType"] = $45b69e870d2a465f$export$45b306f42e1402e5;

});

parcelRegister("37B9X", function(module, exports) {
// A dynamic resource (a runtime-supplied `openModal`/frame resource, not declared in `manifest.yml`)
// may select a multi-entry bundle's entry via a `<resourceKey>/<entryKey>` form. The entry maps to
// `${entryKey}.html` (the UIKit2 build output). Segments are limited to these characters.
const $c43bf45c5259414f$var$RESOURCE_SEGMENT_PATTERN = /^[a-zA-Z0-9_-]+$/;
const $c43bf45c5259414f$export$28bf3ed89c90d749 = (rawResource)=>{
    // No (or empty) resource — e.g. a UIKit extension with no resource — has nothing to parse, so
    // return it as-is with no entry rather than calling `.split` on an undefined value.
    if (!rawResource) return {
        resource: rawResource,
        resolvedResourceEntry: undefined
    };
    const [resource, entryKey, ...rest] = rawResource.split('/');
    // Only a single `<resourceKey>/<entryKey>` split with safe segments selects an entry. Anything
    // else (no slash, multiple slashes, or an unsafe entry) yields no entry — which also clears any
    // entry inherited from a parent extension so it can't bleed. The resource is always the first
    // segment, so e.g. "a/b/c" resolves to resource "a" with no entry.
    if (rest.length === 0 && $c43bf45c5259414f$var$RESOURCE_SEGMENT_PATTERN.test(resource) && $c43bf45c5259414f$var$RESOURCE_SEGMENT_PATTERN.test(entryKey ?? '')) return {
        resource: resource,
        resolvedResourceEntry: `${entryKey}.html`
    };
    return {
        resource: resource,
        resolvedResourceEntry: undefined
    };
};
module.exports["resolveDynamicResource"] = $c43bf45c5259414f$export$28bf3ed89c90d749;

});

parcelRegister("jed12", function(module, exports) {
$parcel$export(module.exports, "default", () => $9248c53ed364f1d5$export$2e2bcd8739ae039);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hWJfj = parcelRequire("hWJfj");










var $1c598 = parcelRequire("1c598");


var $gvvHu = parcelRequire("gvvHu");


var $5U2YR = parcelRequire("5U2YR");


var $7KMPr = parcelRequire("7KMPr");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $dQZ64 = parcelRequire("dQZ64");

class $3a7e2bde20e8f4eb$export$a707936a384f62f9 extends Error {
    constructor(error){
        super(error.logMessage);
        this.logMessage = void 0;
        this.errorTitle = void 0;
        this.errorBody = void 0;
        this.errorTitle = error.errorTitle;
        this.logMessage = error.logMessage;
        this.errorBody = error.errorBody;
    }
}
class $3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent extends (0, $42omo.Component) {
    componentDidCatch(error, errorInfo) {
        const { page: page, environment: environment } = this.context;
        const { createAnalyticsEvent: createAnalyticsEvent, extension: extension, runtime: runtime } = this.props;
        (0, $7KMPr.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            runtime: runtime,
            environment: environment || (0, $1c598.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: error.name
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        if (error instanceof $3a7e2bde20e8f4eb$export$a707936a384f62f9) this.setState({
            thrownError: {
                error: {
                    name: 'error',
                    message: error.errorTitle,
                    errorMessage: error.errorBody
                },
                errorInfo: errorInfo
            }
        });
        else this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvvHu.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            thrownError: undefined
        };
    }
}
$3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent.contextType = (0, $5U2YR.MetricsContext);
const $3a7e2bde20e8f4eb$var$GenericErrorBoundary = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const runtime = (0, $dQZ64.useForgeUIRuntime)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props || $[2] !== runtime) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent, {
            ...props,
            createAnalyticsEvent: createAnalyticsEvent,
            runtime: runtime
        });
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = runtime;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const runtime = (0, $dQZ64.useForgeUIRuntime)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        runtime: runtime
    });
};
var $3a7e2bde20e8f4eb$export$2e2bcd8739ae039 = $3a7e2bde20e8f4eb$var$GenericErrorBoundary;




class $49e1d4758686470f$var$IntegrationErrorHandlerBoundary extends (0, $42omo.Component) {
    componentDidCatch(error) {
        if (this.props.onError) this.props.onError(error);
        throw error;
    }
    render() {
        return this.props.children;
    }
}
var $49e1d4758686470f$export$2e2bcd8739ae039 = $49e1d4758686470f$var$IntegrationErrorHandlerBoundary;



var $JmaBh = parcelRequire("JmaBh");


var $jIiuI = parcelRequire("jIiuI");

var $gGmck = parcelRequire("gGmck");










var $4JDbp = parcelRequire("4JDbp");

const $e15251f056a7fc02$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(0);
const $e15251f056a7fc02$var$SCROLLBAR_WIDTH = 30;
const $e15251f056a7fc02$export$7921e18173e8c666 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [width, setWidth] = (0, $42omo.useState)(0);
    let t1;
    if ($[0] !== width) {
        const handleWidthChange = (newWidth)=>{
            if (!newWidth || Math.abs(width - newWidth) < $e15251f056a7fc02$var$SCROLLBAR_WIDTH) return;
            setWidth(newWidth);
        };
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.default), {
            setWidth: handleWidthChange
        });
        $[0] = width;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== width) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e15251f056a7fc02$export$27e39f636459b9f.Provider, {
            value: width
        }, children);
        $[2] = children;
        $[3] = width;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children })=>{
    const [width, setWidth] = (0, $42omo.useState)(0);
    const handleWidthChange = (newWidth)=>{
        // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
        if (!newWidth || Math.abs(width - newWidth) < $e15251f056a7fc02$var$SCROLLBAR_WIDTH) return;
        setWidth(newWidth);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.default), {
        setWidth: handleWidthChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e15251f056a7fc02$export$27e39f636459b9f.Provider, {
        value: width
    }, children));
};
const $e15251f056a7fc02$export$5d8538aa831b6ebb = $e15251f056a7fc02$export$27e39f636459b9f.Consumer;



var $CMcde = parcelRequire("CMcde");







class $cec67f48175aa836$export$51ac3312edef55d7 extends Error {
    get issue() {
        return this._issue;
    }
    get property() {
        return this._property;
    }
    set property(value) {
        this._property = value;
    }
    constructor({ issue: issue, message: message }){
        super(message);
        this._issue = void 0;
        this._property = void 0;
        this._issue = issue;
        this._property = '';
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $cec67f48175aa836$export$51ac3312edef55d7.prototype);
    }
}
class $cec67f48175aa836$var$StyleErrorBoundary extends (0, $42omo.Component) {
    componentDidCatch(error) {
        if (!(error instanceof $cec67f48175aa836$export$51ac3312edef55d7)) throw error;
        this.setState({
            error: error
        });
    }
    render() {
        const { error: error } = this.state;
        if (!error) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvvHu.default), {
            error: {
                name: 'style-error',
                message: `Error was thrown on style property: ${error.property}`,
                errorMessage: `${error.issue}\n${error.message}`
            },
            isReloadPage: true
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: null
        };
    }
}
var $cec67f48175aa836$export$2e2bcd8739ae039 = $cec67f48175aa836$var$StyleErrorBoundary;



var $69400 = parcelRequire("69400");


var $ijfiP = parcelRequire("ijfiP");


var $5oEbs = parcelRequire("5oEbs");














var $6oQb1 = parcelRequire("6oQb1");




const $fbc50d5752c05105$export$1e4237f96323a8a1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t0 = ()=>{
            (0, $6oQb1.trackRendererRendered)(createAnalyticsEvent, {
                source: source,
                target: "renderer"
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t0;
    } else t0 = $[2];
    (0, $42omo.useEffect)(t0);
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    (0, $42omo.useEffect)(()=>{
        (0, $6oQb1.trackRendererRendered)(createAnalyticsEvent, {
            source: source,
            target: 'renderer'
        });
    });
};



var $ahOA5 = parcelRequire("ahOA5");


var $hBtmC = parcelRequire("hBtmC");


var $80yqV = parcelRequire("80yqV");

const $9248c53ed364f1d5$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) // Wrapping loadingComponent in a valid react element (fragment)
    // ReactNode type is not necessarily a valid React element, unable to change this type as different extension points pass in various loadingComponent types
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, loadingComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CMcde.Loader), null);
};
const $9248c53ed364f1d5$var$getAppDomainName = (extension, environment)=>{
    const parsedExtension = extension && extension?.id ? (0, $ijfiP.parseExtensionId)(extension.id) : undefined;
    if (parsedExtension) {
        const iframeSrc = (0, $5oEbs.createSrcFromExtension)(parsedExtension.appId, extension, environment, '');
        const iframeUrl = new URL(iframeSrc);
        return iframeUrl.host;
    }
    return;
};

const $9248c53ed364f1d5$var$RendererNextLatest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>/* webpackChunkName: "forge-ui-renderer-with-components" */ (parcelRequire("iFzpL")).then((module)=>({
            default: module.RendererNextLatest
        })));
// This extra component exists so errors from the "render" function are caught in the an error boundary
// Also the error boundary requires a suspense fallback
const $9248c53ed364f1d5$var$RendererNextWithProviders = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(41);
    const { extension: extension, forgeDoc: forgeDoc, dispatch: dispatch, locale: locale, error: error } = props;
    const defaultDispatch = $9248c53ed364f1d5$var$_temp;
    const forgeReactMajorVersion = forgeDoc?.forgeReactMajorVersion;
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    let t0;
    if ($[0] !== environment || $[1] !== extension) {
        t0 = $9248c53ed364f1d5$var$getAppDomainName(extension, environment);
        $[0] = environment;
        $[1] = extension;
        $[2] = t0;
    } else t0 = $[2];
    const domainName = t0;
    if (props.loading && !forgeDoc) {
        let t1;
        if ($[3] !== props.loadingComponent) {
            t1 = $9248c53ed364f1d5$var$getLoadingComponent(props.loadingComponent);
            $[3] = props.loadingComponent;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    if (error && (0, $80yqV.shouldRenderForgeAppErrorMessage)(error)) {
        let t1;
        if ($[5] !== error || $[6] !== extension || $[7] !== props.modalExtension) {
            t1 = props.modalExtension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahOA5.ForgeExtensionPointModal), {
                modalExtension: props.modalExtension
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hBtmC.ForgeAppErrorMessage), {
                extension: extension,
                error: error
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hBtmC.ForgeAppErrorMessage), {
                extension: extension,
                error: error
            });
            $[5] = error;
            $[6] = extension;
            $[7] = props.modalExtension;
            $[8] = t1;
        } else t1 = $[8];
        return t1;
    }
    let t1;
    if ($[9] !== props.loadingComponent) {
        t1 = $9248c53ed364f1d5$var$getLoadingComponent(props.loadingComponent);
        $[9] = props.loadingComponent;
        $[10] = t1;
    } else t1 = $[10];
    const t2 = locale ?? "en";
    const t3 = extension?.egress;
    const t4 = extension?.properties;
    const t5 = extension?.environmentType;
    const t6 = extension?.type;
    let t7;
    if ($[11] !== domainName || $[12] !== forgeReactMajorVersion || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
        t7 = {
            egress: t3,
            properties: t4,
            forgeEnvironment: t5,
            forgeReactMajorVersion: forgeReactMajorVersion,
            appDomainName: domainName,
            extensionType: t6
        };
        $[11] = domainName;
        $[12] = forgeReactMajorVersion;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    const t8 = dispatch ?? defaultDispatch;
    let t9;
    if ($[18] !== props || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $69400.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RenderTrackingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RendererNextLatest, {
            ...props,
            dispatch: t8
        })));
        $[18] = props;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t7 || $[22] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JmaBh.PortalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gGmck.RendererContext).Provider, {
            value: t7
        }, t9));
        $[21] = t7;
        $[22] = t9;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== t10 || $[25] !== t2) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e15251f056a7fc02$export$7921e18173e8c666), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            locale: t2,
            defaultLocale: "en"
        }, t10));
        $[24] = t10;
        $[25] = t2;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== props.onError || $[28] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cec67f48175aa836$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49e1d4758686470f$export$2e2bcd8739ae039), {
            onError: props.onError
        }, t11));
        $[27] = props.onError;
        $[28] = t11;
        $[29] = t12;
    } else t12 = $[29];
    let t13;
    if ($[30] !== dispatch || $[31] !== extension || $[32] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hWJfj.default), {
            dispatch: dispatch,
            extension: extension
        }, t12);
        $[30] = dispatch;
        $[31] = extension;
        $[32] = t12;
        $[33] = t13;
    } else t13 = $[33];
    let t14;
    if ($[34] !== dispatch || $[35] !== extension || $[36] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3a7e2bde20e8f4eb$export$2e2bcd8739ae039), {
            dispatch: dispatch,
            extension: extension
        }, t13);
        $[34] = dispatch;
        $[35] = extension;
        $[36] = t13;
        $[37] = t14;
    } else t14 = $[37];
    let t15;
    if ($[38] !== t1 || $[39] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: t1
        }, t14);
        $[38] = t1;
        $[39] = t14;
        $[40] = t15;
    } else t15 = $[40];
    return t15;
} : (props)=>{
    const { extension: extension, forgeDoc: forgeDoc, dispatch: dispatch, locale: locale, error: error } = props;
    const defaultDispatch = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async ()=>{}, []);
    const forgeReactMajorVersion = forgeDoc?.forgeReactMajorVersion;
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const domainName = $9248c53ed364f1d5$var$getAppDomainName(extension, environment);
    // true while fetching initial forgeDoc
    if (props.loading && !forgeDoc) return $9248c53ed364f1d5$var$getLoadingComponent(props.loadingComponent);
    // TODO: This can be removed when to move over to the new InnerIframeV2 as the ForgeAppErrorMessage component is rendered within
    // packages/forge/forge-ui/src/bridge/methods/core.tsx
    if (error && (0, $80yqV.shouldRenderForgeAppErrorMessage)(error)) return props.modalExtension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahOA5.ForgeExtensionPointModal), {
        modalExtension: props.modalExtension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hBtmC.ForgeAppErrorMessage), {
        extension: extension,
        error: error
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hBtmC.ForgeAppErrorMessage), {
        extension: extension,
        error: error
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: $9248c53ed364f1d5$var$getLoadingComponent(props.loadingComponent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3a7e2bde20e8f4eb$export$2e2bcd8739ae039), {
        dispatch: dispatch,
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hWJfj.default), {
        dispatch: dispatch,
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cec67f48175aa836$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49e1d4758686470f$export$2e2bcd8739ae039), {
        onError: props.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e15251f056a7fc02$export$7921e18173e8c666), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: locale ?? 'en',
        defaultLocale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JmaBh.PortalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gGmck.RendererContext).Provider, {
        value: {
            egress: extension?.egress,
            properties: extension?.properties,
            forgeEnvironment: extension?.environmentType,
            forgeReactMajorVersion: forgeReactMajorVersion,
            appDomainName: domainName,
            extensionType: extension?.type
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $69400.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RenderTrackingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RendererNextLatest, {
        ...props,
        dispatch: dispatch ?? defaultDispatch
    }))))))))))));
};
const $9248c53ed364f1d5$var$RenderTrackingWrapper = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    (0, $fbc50d5752c05105$export$1e4237f96323a8a1)();
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    (0, $fbc50d5752c05105$export$1e4237f96323a8a1)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
var $9248c53ed364f1d5$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RendererNextWithProviders, props);
};
async function $9248c53ed364f1d5$var$_temp() {}

});

parcelRegister("hWJfj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1c598 = parcelRequire("1c598");


var $gvvHu = parcelRequire("gvvHu");


var $7KMPr = parcelRequire("7KMPr");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $5U2YR = parcelRequire("5U2YR");


var $dQZ64 = parcelRequire("dQZ64");

class $2104b77b1f0c0326$export$925737f92c0570a1 extends Error {
    constructor(message, component){
        super(message);
        this.component = void 0;
        this.component = component;
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2104b77b1f0c0326$export$925737f92c0570a1.prototype);
    }
}
class $2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent extends (0, $42omo.Component) {
    componentDidCatch(error, errorInfo) {
        // Filters out reporting errors for components that are not valid e.g. <Buton/>
        if (!(error instanceof $2104b77b1f0c0326$export$925737f92c0570a1)) throw error;
        const { extension: extension, runtime: runtime } = this.props;
        const { page: page, environment: environment } = this.context;
        (0, $7KMPr.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            runtime: runtime,
            environment: environment ?? (0, $1c598.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        this.props.createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: 'componentError',
                    component: error.component
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvvHu.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            thrownError: undefined
        };
    }
}
$2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent.contextType = (0, $5U2YR.MetricsContext);
const $2104b77b1f0c0326$var$ComponentErrorBoundary = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const runtime = (0, $dQZ64.useForgeUIRuntime)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props || $[2] !== runtime) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent, {
            ...props,
            createAnalyticsEvent: createAnalyticsEvent,
            runtime: runtime
        });
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = runtime;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const runtime = (0, $dQZ64.useForgeUIRuntime)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        runtime: runtime
    });
};
var $2104b77b1f0c0326$export$2e2bcd8739ae039 = $2104b77b1f0c0326$var$ComponentErrorBoundary;
module.exports["ComponentError"] = $2104b77b1f0c0326$export$925737f92c0570a1;
module.exports["default"] = $2104b77b1f0c0326$export$2e2bcd8739ae039;

});

parcelRegister("hcdJZ", function(module, exports) {

let $c84e374759cab121$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c84e374759cab121$var$load("Wowvf"),
    $c84e374759cab121$var$load("cjJTJ")
]).then(()=>parcelRequire('iV9t7'));

});

parcelRegister("fLmnB", function(module, exports) {

let $b79c9af6b2d86be8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b79c9af6b2d86be8$var$load("Wowvf"),
    $b79c9af6b2d86be8$var$load("cjJTJ")
]).then(()=>parcelRequire('hkbHJ'));

});

parcelRegister("JmaBh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $caX7N = parcelRequire("caX7N");


var $g5lKx = parcelRequire("g5lKx");

const $f76408e65cd851d4$var$dest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $f76408e65cd851d4$var$Provider = $f76408e65cd851d4$var$dest.Provider;
const $f76408e65cd851d4$export$7d41556b227a95c9 = $f76408e65cd851d4$var$dest.Consumer;
const $f76408e65cd851d4$export$6df4068a17305b10 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { children: children } = t0;
    const [portal, setPortal] = (0, $42omo.useState)();
    const [isPortalReady, setIsPortalReady] = (0, $42omo.useState)(false);
    let t1;
    let t2;
    if ($[0] !== portal) {
        t1 = ()=>{
            if (portal !== null) setIsPortalReady(true);
        };
        t2 = [
            portal
        ];
        $[0] = portal;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children || $[4] !== isPortalReady || $[5] !== portal) {
        t3 = isPortalReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f76408e65cd851d4$var$Provider, {
            value: portal
        }, children);
        $[3] = children;
        $[4] = isPortalReady;
        $[5] = portal;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
            zIndex: (0, $g5lKx.layers).modal() + 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "forge-ui-portal",
            ref: setPortal
        }));
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3, t4);
        $[8] = t3;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children })=>{
    const [portal, setPortal] = (0, $42omo.useState)();
    const [isPortalReady, setIsPortalReady] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (portal !== null) setIsPortalReady(true);
    }, [
        portal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isPortalReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f76408e65cd851d4$var$Provider, {
        value: portal
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: (0, $g5lKx.layers).modal() + 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "forge-ui-portal",
        ref: setPortal
    })));
};
module.exports["PortalConsumer"] = $f76408e65cd851d4$export$7d41556b227a95c9;
module.exports["PortalProvider"] = $f76408e65cd851d4$export$6df4068a17305b10;

});

parcelRegister("ahOA5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $jdPfT = parcelRequire("jdPfT");


var $gj7hi = parcelRequire("gj7hi");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $hnPaP = parcelRequire("hnPaP");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $amyZ5 = parcelRequire("amyZ5");


var $gIr1J = parcelRequire("gIr1J");


var $i9F01 = parcelRequire("i9F01");


var $dh538 = parcelRequire("dh538");


var $1c598 = parcelRequire("1c598");


var $6oQb1 = parcelRequire("6oQb1");


var $jc2GP = parcelRequire("jc2GP");


var $artsb = parcelRequire("artsb");


var $b4nol = parcelRequire("b4nol");

const $10efe874cdee2bbf$var$styles = {
    modalWrapper: "_n3td1ejb"
};
const $10efe874cdee2bbf$var$getExtensionIcon = (extension)=>{
    return extension?.properties?.config?.icon ?? extension?.properties?.icon;
};
const $10efe874cdee2bbf$var$ModalWrapper = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(18);
    const { closeModalExtension: closeModalExtension, extensionType: extensionType, modalSize: modalSize, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = props;
    let t0;
    if ($[0] !== extensionType) {
        t0 = extensionType && (0, $artsb.FULLSCREEN_SUPPORTED_EXTENSION_TYPES).has(extensionType);
        $[0] = extensionType;
        $[1] = t0;
    } else t0 = $[1];
    const isFullscreenAllowed = t0;
    const isFullscreenModal = modalSize === "fullscreen";
    if (isFullscreenModal && isFullscreenAllowed) {
        let t1;
        if ($[2] !== closeModalExtension || $[3] !== props.children || $[4] !== shouldCloseOnEscapePress) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnPaP.FullScreenModalDialog), {
                shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                onClose: closeModalExtension
            }, props.children);
            $[2] = closeModalExtension;
            $[3] = props.children;
            $[4] = shouldCloseOnEscapePress;
            $[5] = t1;
        } else t1 = $[5];
        return t1;
    }
    const shouldFallbackFromFullscreen = isFullscreenModal && !isFullscreenAllowed;
    let t1;
    if ($[6] !== modalSize || $[7] !== shouldFallbackFromFullscreen) {
        t1 = (0, $dh538.fg)("forge-ui-ui-kit-modal-resize-proj") ? (0, $i9F01.resolveModalDimensions)({
            size: modalSize,
            shouldFallbackFromFullscreen: shouldFallbackFromFullscreen,
            isResizableSize: modalSize === "resizable"
        }) : undefined;
        $[6] = modalSize;
        $[7] = shouldFallbackFromFullscreen;
        $[8] = t1;
    } else t1 = $[8];
    const resolvedDimensions = t1;
    const namedSize = modalSize !== undefined && (0, $b4nol.isNamedSize)(modalSize) ? modalSize : undefined;
    let t2;
    if ($[9] !== namedSize) {
        t2 = namedSize ? (0, $gIr1J.getADSModalWidth)(namedSize) : undefined;
        $[9] = namedSize;
        $[10] = t2;
    } else t2 = $[10];
    const ADSModalWidth = t2;
    const widthWithFallback = shouldFallbackFromFullscreen ? "x-large" : ADSModalWidth;
    const width = resolvedDimensions ? resolvedDimensions.width : widthWithFallback;
    const height = resolvedDimensions?.height;
    if (shouldFallbackFromFullscreen) console.warn("Forge fullscreen extension point modal is only supported in specific extension points. Refer to https://developer.atlassian.com/platform/forge/manifest-reference/modules/ for more guidance. The modal will be rendered with x-large width instead.");
    let t3;
    if ($[11] !== closeModalExtension || $[12] !== height || $[13] !== props.children || $[14] !== shouldCloseOnEscapePress || $[15] !== shouldCloseOnOverlayClick || $[16] !== width) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
            shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress,
            onClose: closeModalExtension,
            width: width,
            height: height
        }, props.children);
        $[11] = closeModalExtension;
        $[12] = height;
        $[13] = props.children;
        $[14] = shouldCloseOnEscapePress;
        $[15] = shouldCloseOnOverlayClick;
        $[16] = width;
        $[17] = t3;
    } else t3 = $[17];
    return t3;
} : (props)=>{
    const { closeModalExtension: closeModalExtension, extensionType: extensionType, modalSize: modalSize, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = props;
    const isFullscreenAllowed = extensionType && (0, $artsb.FULLSCREEN_SUPPORTED_EXTENSION_TYPES).has(extensionType);
    const isFullscreenModal = modalSize === 'fullscreen';
    if (isFullscreenModal && isFullscreenAllowed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnPaP.FullScreenModalDialog), {
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension
    }, props.children);
     // Fallback to 'x-large' if width is 'fullscreen' but not supported
    const shouldFallbackFromFullscreen = isFullscreenModal && !isFullscreenAllowed;
    const resolvedDimensions = (0, $dh538.fg)('forge-ui-ui-kit-modal-resize-proj') ? (0, $i9F01.resolveModalDimensions)({
        size: modalSize,
        shouldFallbackFromFullscreen: shouldFallbackFromFullscreen,
        isResizableSize: modalSize === 'resizable'
    }) : undefined; // TODO: Delete on forge-ui-ui-kit-modal-resize-proj flag cleanup - we just need resolvedDimensions.
    const namedSize = modalSize !== undefined && (0, $b4nol.isNamedSize)(modalSize) ? modalSize : undefined;
    const ADSModalWidth = namedSize ? (0, $gIr1J.getADSModalWidth)(namedSize) : undefined;
    const widthWithFallback = shouldFallbackFromFullscreen ? 'x-large' : ADSModalWidth;
    const width = resolvedDimensions ? resolvedDimensions.width : widthWithFallback;
    const height = resolvedDimensions?.height;
    if (shouldFallbackFromFullscreen) // eslint-disable-next-line no-console
    console.warn('Forge fullscreen extension point modal is only supported in specific extension points. Refer to https://developer.atlassian.com/platform/forge/manifest-reference/modules/ for more guidance. The modal will be rendered with x-large width instead.');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension,
        width: width,
        height: height
    }, props.children);
};
const $10efe874cdee2bbf$export$bf4fcca1fb0dca1e = ({ children: children, modalExtension: modalExtension, shouldShowFCFModalDeprecationMessage: shouldShowFCFModalDeprecationMessage, extension: extension })=>{
    const { closeModalExtension: closeModalExtension, title: title, modalWidth: modalSize, shouldCloseOnOverlayClick: // TODO: rename this prop on the product side
    shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, viewOnClose: viewOnClose } = modalExtension;
    const environmentType = extension?.environmentType;
    const extensionType = extension ? (0, $jc2GP.getExtensionType)(extension?.properties) : 'extension';
    const isMacroExtension = extensionType === 'extension' && extension?.type === (0, $1c598.ConfluenceExtension).MACRO;
    const isFullscreenModal = modalSize === 'fullscreen';
    const extensionIcon = isMacroExtension ? $10efe874cdee2bbf$var$getExtensionIcon(extension) : undefined;
    const { trackExtensionLoaded: trackExtensionLoaded, trackBridgeSucceed: trackBridgeSucceed, trackBridgeFailed: trackBridgeFailed } = (0, $6oQb1.useForgeUiAnalyticsEvent)(); // Only tracking fullscreen modals
    (0, $42omo.useEffect)(()=>{
        if (isFullscreenModal) trackExtensionLoaded({
            forgeEnvironment: environmentType,
            renderType: 'UIKit',
            extensionType: extensionType,
            viewportSize: 'fullscreen'
        });
    }, [
        isFullscreenModal,
        extensionType,
        environmentType,
        trackExtensionLoaded
    ]);
    const handleClose = async ()=>{
        if (viewOnClose) try {
            await viewOnClose();
            trackBridgeSucceed({
                method: 'onClose',
                forgeEnvironment: extension?.environmentType
            });
        } catch (error) {
            // Track failure but still close the modal
            trackBridgeFailed({
                method: 'onClose',
                errorName: error instanceof Error ? error.name : 'UnknownError',
                forgeEnvironment: extension?.environmentType
            });
        } finally{
            closeModalExtension();
        }
        else closeModalExtension();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10efe874cdee2bbf$var$ModalWrapper, {
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        closeModalExtension: handleClose,
        extensionType: extension?.type,
        modalSize: modalSize,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, isMacroExtension && isFullscreenModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, extensionIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: extensionIcon,
        alt: "Macro custom config icon",
        width: "24px",
        height: "24px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: "Close Modal",
        onClick: handleClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), {
        hasInlinePadding: isFullscreenModal && (0, $dh538.fg)('forge-ui-kit-fullscreen-modal') ? false : true
    }, shouldShowFCFModalDeprecationMessage && extension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amyZ5.ForgeModalDeprecationMessage), {
        extension: extension
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $10efe874cdee2bbf$var$styles.modalWrapper
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $10efe874cdee2bbf$var$styles.modalWrapper
    }, children)));
};
module.exports["ForgeExtensionPointModal"] = $10efe874cdee2bbf$export$bf4fcca1fb0dca1e;

});

parcelRegister("gIr1J", function(module, exports) {
const $6740a775674ef88d$export$2d5db5bd91fc0e = (modalSize)=>{
    switch(modalSize){
        case 'xlarge':
            return 'x-large';
        case 'max':
            return '100%';
        case 'resizable':
            // 'resizable' has not yet been implemented in this extension point modal (UI Kit) path, but return auto for now.
            // We must accommodate for this in the types because the ModalWidths type in this file is used for the overarching ModalExtension type in the renderer props.
            // TLDR: The types in this file are for when viewportSize: 'resizable' AS WELL AS Modal({ size: 'resizable' })
            return 'auto';
        default:
            return modalSize;
    }
};
module.exports["getADSModalWidth"] = $6740a775674ef88d$export$2d5db5bd91fc0e;

});

parcelRegister("iFzpL", function(module, exports) {

let $d97786edbf10a257$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d97786edbf10a257$var$load("aMRFX"),
    $d97786edbf10a257$var$load("396ld"),
    $d97786edbf10a257$var$load("jDjSj"),
    $d97786edbf10a257$var$load("6wr18"),
    $d97786edbf10a257$var$load("cf5vC"),
    $d97786edbf10a257$var$load("4JAC8"),
    $d97786edbf10a257$var$load("6uCgj"),
    $d97786edbf10a257$var$load("khyhL"),
    $d97786edbf10a257$var$load("1tzsM"),
    $d97786edbf10a257$var$load("llxGi"),
    $d97786edbf10a257$var$load("7EorR"),
    $d97786edbf10a257$var$load("kHOMt"),
    $d97786edbf10a257$var$load("hhss7"),
    $d97786edbf10a257$var$load("ffEVr"),
    $d97786edbf10a257$var$load("37ldp"),
    $d97786edbf10a257$var$load("Wowvf"),
    $d97786edbf10a257$var$load("9ftJe"),
    $d97786edbf10a257$var$load("9Ozjy")
]).then(()=>parcelRequire('2Jivw'));

});

parcelRegister("9UyM5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");

const $d399cb7128821634$export$75ab56226e2d3efd = /*#__PURE__*/ (0, $42omo.createContext)({
    inline: false
});
const $d399cb7128821634$export$3828d4e780bd54a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($d399cb7128821634$export$75ab56226e2d3efd);
} : ()=>(0, $42omo.useContext)($d399cb7128821634$export$75ab56226e2d3efd);
module.exports["InlineContext"] = $d399cb7128821634$export$75ab56226e2d3efd;
module.exports["useInlineContext"] = $d399cb7128821634$export$3828d4e780bd54a;

});

parcelRegister("durRy", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<3509cab6dd90f1cdb1ca06db692800f9>>
 * @relayHash 31980ab6c38bae595f082e75d7d0e4e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae24380b92626cb5b9d090bf5964371d7239e6db55abf05be39369ed495e6702
const $063fedceddcc0e64$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "userpicker_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "userpicker_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ae24380b92626cb5b9d090bf5964371d7239e6db55abf05be39369ed495e6702",
            "metadata": {},
            "name": "userpicker_forge_ui_usersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$063fedceddcc0e64$var$node.hash = "bfc99cc46adea62c7037b11c133b2a46";
var $063fedceddcc0e64$export$2e2bcd8739ae039 = $063fedceddcc0e64$var$node;



var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");










// Key for registering and unregistering the subscriber
const $d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY = 'forge-ui-user-select';
const $d0f49770ff4f5279$var$mentionResultsToUsers = (results)=>{
    return results.map((result)=>({
            id: result.id,
            name: result.name,
            avatarUrl: result.avatarUrl || '',
            type: 'user'
        })).filter((user)=>typeof user.name !== 'undefined');
};
const $d0f49770ff4f5279$export$f4d09562dcb13ab = (0, $4pOgL.isReactCompilerActivePlatform)() ? (mentionProvider)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== mentionProvider) {
        t0 = async (search)=>{
            const provider = await mentionProvider;
            if (provider && search) return new Promise((resolve)=>{
                provider.filter(search);
                provider.subscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY, (results)=>{
                    provider.unsubscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY);
                    resolve($d0f49770ff4f5279$var$mentionResultsToUsers(results));
                }, ()=>{
                    provider.unsubscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY);
                    resolve([]);
                });
            });
            return Promise.resolve([]);
        };
        $[0] = mentionProvider;
        $[1] = t0;
    } else t0 = $[1];
    const query = t0;
    if (mentionProvider) return query;
} : (mentionProvider)=>{
    const query = (0, $42omo.useCallback)(async (search)=>{
        const provider = await mentionProvider;
        if (provider && search) return new Promise((resolve)=>{
            provider.filter(search);
            provider.subscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY, (results)=>{
                provider.unsubscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY);
                resolve($d0f49770ff4f5279$var$mentionResultsToUsers(results));
            }, ()=>{
                provider.unsubscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY);
                resolve([]);
            });
        });
        return Promise.resolve([]);
    }, [
        mentionProvider
    ]);
    if (mentionProvider) return query;
};












var $kSKAi = parcelRequire("kSKAi");


var $7rus4 = parcelRequire("7rus4");


var $a4qga = parcelRequire("a4qga");


var $JmaBh = parcelRequire("JmaBh");











var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


const $4dadbd8988869e85$var$AKLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("jB0qt")).then((module)=>({
            default: module.Label
        })));
const $4dadbd8988869e85$export$b04be29aa201d4f5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { isRequired: isRequired, label: label, name: name } = t0;
    const t1 = `${name}-label`;
    let t2;
    if ($[0] !== isRequired) {
        t2 = isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "strong",
            color: "color.text.danger",
            size: "small"
        }, "*");
        $[0] = isRequired;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== label || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.025"
        }, label, t2);
        $[2] = label;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== name || $[6] !== t1 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dadbd8988869e85$var$AKLabel, {
            htmlFor: name,
            id: t1
        }, t3);
        $[5] = name;
        $[6] = t1;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ isRequired: isRequired, label: label, name: name })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dadbd8988869e85$var$AKLabel, {
        htmlFor: name,
        id: `${name}-label`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.025"
    }, label, isRequired && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "strong",
        color: "color.text.danger",
        size: "small"
    }, "*")));
};


const $a8c4b840c9ca4704$var$BITBUCKET_FIELD_ID = 'BitbucketMentions';
// the value prop in UserPicker component can only take undefined for empty value.
// null is not allowed and will resulted in unexpected behavior.
const $a8c4b840c9ca4704$var$ensureUserPickerValue = (value)=>{
    if (!value || Array.isArray(value) && value.length === 0) return undefined;
    return value;
};
// by forcing a key update when defaultValue is present, we force the SmartUserPicker to re-render.
// this is because the SmartUserPicker does not re-render when the defaultValue changes in its
// current implementation.
const $a8c4b840c9ca4704$var$makeUserPickerKey = (id, defaultValue)=>{
    if (!defaultValue || Array.isArray(defaultValue) && defaultValue.length === 0) return id;
    return `${id}-with-default`;
};
const $a8c4b840c9ca4704$var$RawUserPicker = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { id: id, name: name, description: description, placeholder: placeholder, isMulti: isMulti, includeUsers: t1, includeGroups: t2, accountId: currentAccountId, cloudId: suppliedCloudId, productKey: productKey, baseUrl: baseUrl, onChange: onChange, query: query, defaultValue: defaultValue, value: providedValue, width: width, productAttributes: productAttributes } = t0;
    const includeUsers = t1 === undefined ? true : t1;
    const includeGroups = t2 === undefined ? false : t2;
    const [value, setValue] = (0, $42omo.useState)(defaultValue);
    let t3;
    if ($[0] !== baseUrl || $[1] !== currentAccountId || $[2] !== defaultValue || $[3] !== description || $[4] !== id || $[5] !== includeGroups || $[6] !== includeUsers || $[7] !== isMulti || $[8] !== name || $[9] !== onChange || $[10] !== placeholder || $[11] !== productAttributes || $[12] !== productKey || $[13] !== providedValue || $[14] !== query || $[15] !== suppliedCloudId || $[16] !== value || $[17] !== width) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JmaBh.PortalConsumer), null, (portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, suppliedCloudId && productKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
                key: $a8c4b840c9ca4704$var$makeUserPickerKey(id, defaultValue),
                onChange: (user)=>onChange?.(user),
                isMulti: isMulti,
                menuPortalTarget: portal || undefined,
                noOptionsMessage: $a8c4b840c9ca4704$var$_temp,
                placeholder: placeholder,
                width: width,
                fieldId: productKey === "bitbucket" ? $a8c4b840c9ca4704$var$BITBUCKET_FIELD_ID : id,
                debounceTime: 400,
                includeUsers: includeUsers,
                includeGroups: includeGroups,
                siteId: suppliedCloudId,
                productAttributes: productAttributes,
                principalId: currentAccountId ?? "Context",
                productKey: productKey,
                baseUrl: baseUrl,
                inputId: name || id,
                defaultValue: defaultValue,
                styles: {
                    control: $a8c4b840c9ca4704$var$_temp2
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
                value: $a8c4b840c9ca4704$var$ensureUserPickerValue(providedValue ?? value),
                onChange: (user_0)=>{
                    setValue(user_0);
                    onChange?.(user_0);
                },
                styles: {
                    control: $a8c4b840c9ca4704$var$_temp3
                },
                isMulti: isMulti,
                menuPortalTarget: portal || undefined,
                noOptionsMessage: $a8c4b840c9ca4704$var$_temp4,
                placeholder: placeholder,
                width: width,
                loadOptions: query,
                fieldId: null,
                inputId: id,
                defaultValue: defaultValue
            }), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a4qga.HelperMessage), null, description)));
        $[0] = baseUrl;
        $[1] = currentAccountId;
        $[2] = defaultValue;
        $[3] = description;
        $[4] = id;
        $[5] = includeGroups;
        $[6] = includeUsers;
        $[7] = isMulti;
        $[8] = name;
        $[9] = onChange;
        $[10] = placeholder;
        $[11] = productAttributes;
        $[12] = productKey;
        $[13] = providedValue;
        $[14] = query;
        $[15] = suppliedCloudId;
        $[16] = value;
        $[17] = width;
        $[18] = t3;
    } else t3 = $[18];
    return t3;
} : ({ id: id, name: name, description: description, placeholder: placeholder, isMulti: isMulti, includeUsers: includeUsers = true, includeGroups: includeGroups = false, accountId: currentAccountId, cloudId: suppliedCloudId, productKey: productKey, baseUrl: baseUrl, onChange: onChange, query: query, defaultValue: defaultValue, value: providedValue, width: width, productAttributes: productAttributes })=>{
    const [value, setValue] = (0, $42omo.useState)(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JmaBh.PortalConsumer), null, (portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, suppliedCloudId && productKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
            key: $a8c4b840c9ca4704$var$makeUserPickerKey(id, defaultValue),
            onChange: (user)=>onChange?.(user),
            isMulti: isMulti,
            menuPortalTarget: portal || undefined,
            noOptionsMessage: ()=>null,
            placeholder: placeholder,
            width: width,
            fieldId: // Bitbucket User Recommendations does not support generic contextType
            productKey === 'bitbucket' ? $a8c4b840c9ca4704$var$BITBUCKET_FIELD_ID : id,
            debounceTime: 400,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            siteId: suppliedCloudId,
            productAttributes: productAttributes,
            // If principalId === 'Context', upstream attempts to use other context
            // to discover the principal ID
            principalId: currentAccountId ?? 'Context',
            productKey: productKey,
            baseUrl: baseUrl,
            inputId: name || id,
            defaultValue: defaultValue,
            // Override the default height of user picker so that it aligns with other input components from design system
            styles: {
                control: (base)=>({
                        ...base,
                        minHeight: '40px',
                        height: '40px'
                    })
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
            value: $a8c4b840c9ca4704$var$ensureUserPickerValue(providedValue ?? value),
            onChange: (user_0)=>{
                setValue(user_0);
                onChange?.(user_0);
            },
            // Override the default height of user picker so that it aligns with other input components from design system
            styles: {
                control: (base_0)=>({
                        ...base_0,
                        minHeight: '40px',
                        height: '40px'
                    })
            },
            isMulti: isMulti,
            menuPortalTarget: portal || undefined,
            noOptionsMessage: ()=>null,
            placeholder: placeholder,
            width: width,
            loadOptions: query,
            fieldId: null,
            inputId: id,
            defaultValue: defaultValue
        }), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a4qga.HelperMessage), null, description)));
};
const $a8c4b840c9ca4704$export$83e0c73b09b3a9cd = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(10);
    const uid = (0, $42omo.useId)();
    const { name: name, isRequired: isRequired, label: label } = props;
    const id = name || uid;
    let t0;
    if ($[0] !== isRequired || $[1] !== label || $[2] !== name) {
        t0 = label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dadbd8988869e85$export$b04be29aa201d4f5), {
            name: name,
            isRequired: isRequired,
            label: label
        });
        $[0] = isRequired;
        $[1] = label;
        $[2] = name;
        $[3] = t0;
    } else t0 = $[3];
    let t1;
    if ($[4] !== id || $[5] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a8c4b840c9ca4704$var$RawUserPicker, {
            id: id,
            width: "100%",
            ...props
        });
        $[4] = id;
        $[5] = props;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== t0 || $[8] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t0, t1);
        $[7] = t0;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : (props)=>{
    const uid = (0, $42omo.useId)();
    const { name: name, isRequired: isRequired, label: label } = props;
    const id = name || uid;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dadbd8988869e85$export$b04be29aa201d4f5), {
        name: name,
        isRequired: isRequired,
        label: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a8c4b840c9ca4704$var$RawUserPicker, {
        id: id,
        width: "100%",
        ...props
    }));
};
function $a8c4b840c9ca4704$var$_temp() {
    return null;
}
function $a8c4b840c9ca4704$var$_temp2(base) {
    return {
        ...base,
        minHeight: "40px",
        height: "40px"
    };
}
function $a8c4b840c9ca4704$var$_temp3(base_0) {
    return {
        ...base_0,
        minHeight: "40px",
        height: "40px"
    };
}
function $a8c4b840c9ca4704$var$_temp4() {
    return null;
}



// Format the values(UserData) returned from useUsers hook, to pass to defaultValue prop
const $482c9d0ed1050096$var$hydrateDefaultValue = (users, isMulti = false)=>{
    const defaultValues = [];
    for(const userId in users){
        const { name: name, picture: picture } = users[userId];
        // Only grabbing the values where user name exist
        if (name) defaultValues.push({
            name: name,
            avatarUrl: picture,
            id: userId,
            type: 'user'
        });
    }
    return isMulti ? defaultValues : defaultValues[0];
};
const $482c9d0ed1050096$var$extractUsers = (data)=>{
    let users = {};
    if (data && data.users) users = data.users.reduce((prev, user)=>{
        if (user.accountId) prev[user.accountId] = {
            picture: user.picture,
            accountId: user.accountId,
            name: user.name
        };
        return prev;
    }, {});
    return users;
};
const $482c9d0ed1050096$var$UserPickerFn = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productAttributes: productAttributes, productKey: productKey, baseUrl: baseUrl, props: props } = t0;
    const { name: name, label: label, placeholder: placeholder, description: description, defaultValue: t1, isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange } = props;
    const defaultUserValue = t1 === undefined ? "" : t1;
    const query = (0, $d0f49770ff4f5279$export$f4d09562dcb13ab)(mentionProvider);
    let t2;
    if ($[0] !== defaultUserValue) {
        t2 = Array.isArray(defaultUserValue) ? defaultUserValue : [
            defaultUserValue
        ];
        $[0] = defaultUserValue;
        $[1] = t2;
    } else t2 = $[1];
    const accountIds = t2;
    let t3;
    if ($[2] !== accountIds) {
        t3 = {
            accountIds: accountIds
        };
        $[2] = accountIds;
        $[3] = t3;
    } else t3 = $[3];
    const data = (0, $irOoi.useLazyLoadQuery)((0, $063fedceddcc0e64$export$2e2bcd8739ae039), t3);
    let t4;
    if ($[4] !== data || $[5] !== isMulti) {
        const users = $482c9d0ed1050096$var$extractUsers(data);
        t4 = $482c9d0ed1050096$var$hydrateDefaultValue(users, isMulti);
        $[4] = data;
        $[5] = isMulti;
        $[6] = t4;
    } else t4 = $[6];
    const hydratedDefaultValue = t4;
    let t5;
    if ($[7] !== accountId || $[8] !== baseUrl || $[9] !== cloudId || $[10] !== description || $[11] !== hydratedDefaultValue || $[12] !== includeGroups || $[13] !== includeUsers || $[14] !== isMulti || $[15] !== isRequired || $[16] !== label || $[17] !== mentionProvider || $[18] !== name || $[19] !== onChange || $[20] !== placeholder || $[21] !== productAttributes || $[22] !== productKey || $[23] !== query) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8c4b840c9ca4704$export$83e0c73b09b3a9cd), {
            accountId: accountId,
            cloudId: cloudId,
            productAttributes: productAttributes,
            productKey: productKey,
            mentionProvider: mentionProvider,
            name: name,
            label: label,
            placeholder: placeholder,
            description: description,
            defaultValue: hydratedDefaultValue,
            isRequired: isRequired,
            isMulti: isMulti,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            baseUrl: baseUrl,
            onChange: onChange,
            query: query
        });
        $[7] = accountId;
        $[8] = baseUrl;
        $[9] = cloudId;
        $[10] = description;
        $[11] = hydratedDefaultValue;
        $[12] = includeGroups;
        $[13] = includeUsers;
        $[14] = isMulti;
        $[15] = isRequired;
        $[16] = label;
        $[17] = mentionProvider;
        $[18] = name;
        $[19] = onChange;
        $[20] = placeholder;
        $[21] = productAttributes;
        $[22] = productKey;
        $[23] = query;
        $[24] = t5;
    } else t5 = $[24];
    return t5;
} : ({ mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productAttributes: productAttributes, productKey: productKey, baseUrl: baseUrl, props: props })=>{
    const { name: name, label: label, placeholder: placeholder, description: description, // Warning: Smart user picker ONLY supports default value hydration
    // of *users*, not groups!
    defaultValue: defaultUserValue = '', isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange } = props;
    const query = (0, $d0f49770ff4f5279$export$f4d09562dcb13ab)(mentionProvider);
    const accountIds = Array.isArray(defaultUserValue) ? defaultUserValue : [
        defaultUserValue
    ];
    const data = (0, $irOoi.useLazyLoadQuery)((0, $063fedceddcc0e64$export$2e2bcd8739ae039), {
        accountIds: accountIds
    });
    // Hydrate the default value ourselves, since we are controlling value from <Field>
    // component value. It will get passed into the user picker as simply `value`.
    const users = $482c9d0ed1050096$var$extractUsers(data);
    const hydratedDefaultValue = $482c9d0ed1050096$var$hydrateDefaultValue(users, isMulti);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8c4b840c9ca4704$export$83e0c73b09b3a9cd), {
        accountId: accountId,
        cloudId: cloudId,
        productAttributes: productAttributes,
        productKey: productKey,
        mentionProvider: mentionProvider,
        name: name,
        label: label,
        placeholder: placeholder,
        description: description,
        defaultValue: hydratedDefaultValue,
        isRequired: isRequired,
        isMulti: isMulti,
        includeUsers: includeUsers,
        includeGroups: includeGroups,
        baseUrl: baseUrl,
        onChange: onChange,
        query: query
    });
};
const $482c9d0ed1050096$export$89c0f5a165dc562a = ({ query: query, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        const { name: name, label: label, placeholder: placeholder, description: description, isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange, defaultValue: defaultUserId } = props;
        const [defaultValueLoaded, setDefaultValueLoaded] = (0, $42omo.useState)(!defaultUserId);
        const [defaultValue, setDefaultValue] = (0, $42omo.useState)();
        (0, $42omo.useEffect)(()=>{
            if (defaultUserId && !defaultValueLoaded) query().then((users)=>{
                const targetUsers = users.filter(({ id: id })=>Array.isArray(defaultUserId) ? defaultUserId.includes(id) : defaultUserId === id);
                if (targetUsers.length === 0) setDefaultValue(undefined);
                else if (isMulti) setDefaultValue(targetUsers);
                else setDefaultValue(targetUsers[0]);
                setDefaultValueLoaded(true);
            });
        }, [
            isMulti,
            defaultUserId,
            defaultValueLoaded,
            setDefaultValue,
            setDefaultValueLoaded
        ]);
        if (!defaultValueLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8c4b840c9ca4704$export$83e0c73b09b3a9cd), {
            accountId: accountId,
            cloudId: cloudId,
            productKey: productKey,
            baseUrl: baseUrl,
            name: name,
            label: label,
            placeholder: placeholder,
            description: description,
            isRequired: isRequired,
            isMulti: isMulti,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            onChange: onChange,
            query: query,
            defaultValue: defaultValue
        });
    };
};
const $482c9d0ed1050096$export$57fb7dc1c2438e62 = ({ mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl, productAttributes: productAttributes })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($482c9d0ed1050096$var$UserPickerFn, {
            props: props,
            mentionProvider: mentionProvider,
            accountId: accountId,
            cloudId: cloudId,
            productAttributes: productAttributes,
            productKey: productKey,
            baseUrl: baseUrl
        });
    };
};
module.exports["makeMockUserPicker"] = $482c9d0ed1050096$export$89c0f5a165dc562a;
module.exports["makeNativeUserPicker"] = $482c9d0ed1050096$export$57fb7dc1c2438e62;

});

parcelRegister("jB0qt", function(module, exports) {

let $e441cd9fa4dc2e64$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e441cd9fa4dc2e64$var$load("kHOMt"),
    $e441cd9fa4dc2e64$var$load("hhss7"),
    $e441cd9fa4dc2e64$var$load("2BKk9")
]).then(()=>parcelRequire('aDVvJ'));

});

parcelRegister("dx0OV", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $67O0h = parcelRequire("67O0h");


var $6jPem = parcelRequire("6jPem");


var $lspPP = parcelRequire("lspPP");


var $jRNsq = parcelRequire("jRNsq");


var $er4dw = parcelRequire("er4dw");


var $gGmck = parcelRequire("gGmck");


var $lMJg3 = parcelRequire("lMJg3");


var $kS0x0 = parcelRequire("kS0x0");


var $kZjf5 = parcelRequire("kZjf5");


var $clpPd = parcelRequire("clpPd");


var $fgm2d = parcelRequire("fgm2d");

const $d2c1e8bb42c60a10$var$EMPTY_EXTENSION_VIEW_DATA = Object.freeze({});
const $d2c1e8bb42c60a10$var$filterInvalidMediaUrls = (appDomainName, egressServices, document)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $kS0x0.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $6jPem.traverse)(document, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : document,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $d2c1e8bb42c60a10$var$useSupportsMedia = ()=>{
    try {
        (0, $jRNsq.useMediaClient)();
        return true;
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
};
const $d2c1e8bb42c60a10$export$a504d7ec22d4b3f4 = ({ bridge: bridge })=>{
    return function ADFRendererNext(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d2c1e8bb42c60a10$export$c334f442ba514f7d, {
            bridge: bridge,
            ...props
        });
    };
};
const $d2c1e8bb42c60a10$export$c334f442ba514f7d = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(24);
    const supportsMedia = $d2c1e8bb42c60a10$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const imagesEgressService = (0, $lMJg3.useEgressPermissionService)("IMAGES", egress);
    const mediaEgressService = (0, $lMJg3.useEgressPermissionService)("MEDIA", egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const bridge = props.bridge;
    let t0;
    if ($[0] !== egress || $[1] !== properties) {
        t0 = {
            extension: {
                egress: egress,
                properties: properties
            }
        };
        $[0] = egress;
        $[1] = properties;
        $[2] = t0;
    } else t0 = $[2];
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)(t0);
    const t1 = props.forgeDoc.props;
    let adfRendererProps;
    let document;
    let documentWithoutMedia;
    if ($[3] !== t1) {
        ({ document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = t1);
        $[3] = t1;
        $[4] = adfRendererProps;
        $[5] = document;
        $[6] = documentWithoutMedia;
    } else {
        adfRendererProps = $[4];
        document = $[5];
        documentWithoutMedia = $[6];
    }
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    if (!doc) {
        let t2;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
            $[7] = t2;
        } else t2 = $[7];
        return t2;
    }
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $d2c1e8bb42c60a10$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    const t2 = forgeEnvironment === "DEVELOPMENT" && invalidUrls.map($d2c1e8bb42c60a10$var$_temp);
    let t3;
    if ($[8] !== getModalJsx) {
        t3 = getModalJsx();
        $[8] = getModalJsx;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== adfRendererProps?.eventHandlers?.link || $[11] !== onNavigate) {
        t4 = {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: "same-tab",
                        url: (0, $clpPd.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        };
        $[10] = adfRendererProps?.eventHandlers?.link;
        $[11] = onNavigate;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== bridge) {
        t5 = {
            "com.atlassian.ecosystem": (props_0)=>{
                const { localId: localId, parameters: parameters } = props_0;
                const { extension: extension, extensionData: extensionData, accountId: accountId, cloudId: cloudId, contextIds: contextIds } = parameters.extensionProperties;
                const config = parameters.guestParams || parameters.config;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgm2d.ForgeUIRenderer), {
                    accountId: accountId,
                    cloudId: cloudId,
                    contextIds: contextIds,
                    extension: extension,
                    extensionData: extensionData,
                    extensionPayload: config ? {
                        config: config
                    } : undefined,
                    localId: localId,
                    product: "confluence",
                    bridge: bridge,
                    extensionViewData: $d2c1e8bb42c60a10$var$EMPTY_EXTENSION_VIEW_DATA,
                    isEmbeddedMacro: true
                });
            }
        };
        $[13] = bridge;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== adfRendererProps || $[16] !== filteredDocument || $[17] !== t4 || $[18] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
            ...adfRendererProps,
            eventHandlers: t4,
            document: filteredDocument,
            extensionHandlers: t5
        }));
        $[15] = adfRendererProps;
        $[16] = filteredDocument;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== t2 || $[21] !== t3 || $[22] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t2, t3, t6);
        $[20] = t2;
        $[21] = t3;
        $[22] = t6;
        $[23] = t7;
    } else t7 = $[23];
    return t7;
} : (props)=>{
    const supportsMedia = $d2c1e8bb42c60a10$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const imagesEgressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $lMJg3.useEgressPermissionService)('MEDIA', egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const bridge = props.bridge;
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        }
    });
    const { document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    if (!doc) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $d2c1e8bb42c60a10$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $er4dw.EgressErrorMessage), {
            key: url,
            url: url
        })), getModalJsx(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
        ...adfRendererProps,
        eventHandlers: {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: 'same-tab',
                        url: (0, $clpPd.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        },
        document: filteredDocument,
        extensionHandlers: {
            'com.atlassian.ecosystem': (props_0)=>{
                const { localId: localId, parameters: parameters } = props_0;
                const { extension: extension, extensionData: extensionData, accountId: accountId, cloudId: cloudId, contextIds: contextIds } = parameters.extensionProperties;
                // Extract config from extension parameters (can be in guestParams or config)
                const config = parameters.guestParams || parameters.config;
                // ForgeUIRenderer will fetch fresh extension data from XLS when isEmbeddedMacro is true
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgm2d.ForgeUIRenderer), {
                    accountId: accountId,
                    cloudId: cloudId,
                    contextIds: contextIds,
                    extension: extension,
                    extensionData: extensionData,
                    // Pass config via extensionPayload so it's available in context.extension.config
                    extensionPayload: config ? {
                        config: config
                    } : undefined,
                    localId: localId,
                    product: 'confluence',
                    bridge: bridge,
                    // Only required for bodied macros. Since we are currently not supporting embedded bodied macros, this should be empty.
                    extensionViewData: $d2c1e8bb42c60a10$var$EMPTY_EXTENSION_VIEW_DATA,
                    isEmbeddedMacro: true
                });
            }
        }
    })));
};
function $d2c1e8bb42c60a10$var$_temp(url) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $er4dw.EgressErrorMessage), {
        key: url,
        url: url
    });
}
module.exports["makeADFRenderer"] = $d2c1e8bb42c60a10$export$a504d7ec22d4b3f4;
module.exports["AdfRenderer"] = $d2c1e8bb42c60a10$export$c334f442ba514f7d;

});

parcelRegister("er4dw", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gGmck = parcelRequire("gGmck");


var $iXCQx = parcelRequire("iXCQx");


var $aoVih = parcelRequire("aoVih");


var $2Nwuj = parcelRequire("2Nwuj");


var $aXWIB = parcelRequire("aXWIB");

const $4da241c59eddfab6$var$messages = (0, $aXWIB.defineMessages)({
    pleaseUseThe: {
        id: "forge-ui.egressErrorMessage.please-use-the",
        defaultMessage: "Please use the"
    },
    dataImage: {
        id: "forge-ui.egressErrorMessage.data-image",
        defaultMessage: "data:image"
    },
    schemeForAnImageSource: {
        id: "forge-ui.egressErrorMessage.scheme-for-an-image-source",
        defaultMessage: "scheme for an image source"
    },
    egressPermissionsFor: {
        id: "forge-ui.egressErrorMessage.egress-permissions-for",
        defaultMessage: "Egress permissions for"
    },
    missingInTheManifestForMoreInformation: {
        id: "forge-ui.egressErrorMessage.missing-in-the-manifest-for-more-information",
        defaultMessage: "missing in the manifest. For more information"
    },
    seeReferenceDocs: {
        id: "forge-ui.egressErrorMessage.see-reference-docs",
        defaultMessage: "see reference docs"
    },
    unableToDisplayDueToImageLinkIssue: {
        id: "forge-ui.egressErrorMessage.unableToDisplayDueToImageLinkIssue",
        defaultMessage: "Unable to display due to an image link issue."
    }
});
const $4da241c59eddfab6$export$5cfbc54f19d7d1a4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { url: url } = t0;
    const { forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /^data/;
        $[0] = t1;
    } else t1 = $[0];
    const dataUriRegex = t1;
    let t2;
    if ($[1] !== url) {
        t2 = dataUriRegex.test(url);
        $[1] = url;
        $[2] = t2;
    } else t2 = $[2];
    const isDataUri = t2;
    const intl = (0, $aXWIB.useIntl)();
    if (forgeEnvironment === "DEVELOPMENT") {
        let t3;
        if ($[3] !== intl || $[4] !== isDataUri || $[5] !== url) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
                appearance: "error",
                testId: "egress-error-message"
            }, isDataUri ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($4da241c59eddfab6$var$messages.pleaseUseThe), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                as: "strong"
            }, intl.formatMessage($4da241c59eddfab6$var$messages.dataImage)), " ", intl.formatMessage($4da241c59eddfab6$var$messages.schemeForAnImageSource)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($4da241c59eddfab6$var$messages.egressPermissionsFor), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: url,
                target: "_blank"
            }, url), " ", intl.formatMessage($4da241c59eddfab6$var$messages.missingInTheManifestForMoreInformation), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: "https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images",
                target: "_blank"
            }, intl.formatMessage($4da241c59eddfab6$var$messages.seeReferenceDocs)), "."));
            $[3] = intl;
            $[4] = isDataUri;
            $[5] = url;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    let t3;
    if ($[7] !== intl) {
        t3 = intl.formatMessage($4da241c59eddfab6$var$messages.unableToDisplayDueToImageLinkIssue);
        $[7] = intl;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            appearance: "error"
        }, t3);
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ url: url })=>{
    const { forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const dataUriRegex = /^data/;
    const isDataUri = dataUriRegex.test(url);
    const intl = (0, $aXWIB.useIntl)();
    if (forgeEnvironment === 'DEVELOPMENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error",
        testId: "egress-error-message"
    }, isDataUri ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($4da241c59eddfab6$var$messages.pleaseUseThe), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "strong"
    }, intl.formatMessage($4da241c59eddfab6$var$messages.dataImage)), ' ', intl.formatMessage($4da241c59eddfab6$var$messages.schemeForAnImageSource)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($4da241c59eddfab6$var$messages.egressPermissionsFor), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: url,
        target: "_blank"
    }, url), ' ', intl.formatMessage($4da241c59eddfab6$var$messages.missingInTheManifestForMoreInformation), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: "https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images",
        target: "_blank"
    }, intl.formatMessage($4da241c59eddfab6$var$messages.seeReferenceDocs)), "."));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error"
    }, intl.formatMessage($4da241c59eddfab6$var$messages.unableToDisplayDueToImageLinkIssue));
};
module.exports["EgressErrorMessage"] = $4da241c59eddfab6$export$5cfbc54f19d7d1a4;

});

parcelRegister("kS0x0", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $1c598 = parcelRequire("1c598");


var $lMJg3 = parcelRequire("lMJg3");


var $jIiuI = parcelRequire("jIiuI");

var $gGmck = parcelRequire("gGmck");


var $b7qxC = parcelRequire("b7qxC");


var $dh538 = parcelRequire("dh538");


var $dRFAM = parcelRequire("dRFAM");

// --------------------------------------------------------------------------------------------------------------------
//
// NOTE: any changes to these hosts MUST BE applied to the Forge Monorepo -- and vice versa.
// See packages/forge-csp/src/csp/csp-injection-service.ts for the original source code.
//
// --------------------------------------------------------------------------------------------------------------------
/**
 * Media API is used to store product attachments.
 * URLs are defined here: https://developer.atlassian.com/platform/media/support/faq/#which-environment-should-i-use-
 */ const $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST = {
    dev: 'https://api.dev.atlassian.com',
    stg: 'https://api.stg.atlassian.com',
    prod: 'https://api.atlassian.com',
    'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST = {
    dev: 'https://media.dev.atl-paas.net',
    stg: 'https://media.staging.atl-paas.net',
    prod: 'https://api.media.atlassian.com',
    'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST = {
    dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
    'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST = {
    dev: 'https://pf-emoji-service.ddev.frontend.public.atl-paas.net',
    stg: 'https://pf-emoji-service.stg-east.frontend.public.atl-paas.net',
    prod: 'https://pf-emoji-service.prod-east.frontend.public.atl-paas.net',
    'fedramp-stg': 'https://pf-emoji-service.frontend.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://pf-emoji-service.frontend.cdn.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/gradients/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
const $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
const $576cfccaadb64755$var$ATLASSIAN_FOS_HOST = {
    dev: 'https://tdp-os.dev.services.atlassian.com',
    stg: 'https://tdp-os.stg.services.atlassian.com',
    prod: 'https://tdp-os.services.atlassian.com',
    'fedramp-stg': 'https://tdp-os.stg.services.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://tdp-os.services.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$FOS_CDN_STANDARD_HOST = {
    dev: 'https://object-store.stg.atlassian.com',
    stg: 'https://object-store.stg.atlassian.com',
    prod: 'https://object-store.atlassian.com'
};
const $576cfccaadb64755$var$getFOSHosts = (env)=>{
    const tdpOsHosts = [
        `${$576cfccaadb64755$var$ATLASSIAN_FOS_HOST[env]}/fos-eap/download/*`,
        `${$576cfccaadb64755$var$ATLASSIAN_FOS_HOST[env]}/fos/app/download/*`,
        `${$576cfccaadb64755$var$ATLASSIAN_FOS_HOST[env]}/fos/cdn/download/*`
    ];
    // TODO: Add FedRAMP support for FOS CDN Standard Host when determined
    if (env in $576cfccaadb64755$var$FOS_CDN_STANDARD_HOST) {
        const cdnBase = $576cfccaadb64755$var$FOS_CDN_STANDARD_HOST[env];
        return [
            ...tdpOsHosts,
            `${cdnBase}/os/ecosystem/installation/*`
        ];
    }
    return tdpOsHosts;
};
/**
 * Atlassian products use Wordpress as a proxy to serve avatar images in certain conditions.
 * Not allowing them by default forces developers to add the `*.wp.com` domain to the CSP image policy.
 * See: https://hello.atlassian.net/wiki/x/XJpuCgE
 */ const $576cfccaadb64755$var$ATLASSIAN_IMAGES_HOSTS = {
    dev: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['dev']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['dev']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['dev']
    ],
    stg: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['stg']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['stg']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['stg']
    ],
    prod: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['prod']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['prod']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['prod']
    ],
    'fedramp-stg': [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-stg']
    ],
    'fedramp-prod': [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-prod']
    ]
};
// --------------------------------------------------------------------------------------------------------------------
/**
 * Gravatar is still used internally to serve legacy Atlassian avatars.
 * Unsplash is integrated by default in Confluence to the header image picker functionality.
 */ const $576cfccaadb64755$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
const $576cfccaadb64755$export$189ea7794c50ff15 = (url, iframeDomainName)=>{
    if (!iframeDomainName) return false;
    let imageSrcUrl;
    try {
        imageSrcUrl = new URL(url);
        // Image is valid if it comes from the same domain as the iframe OR if it's being served from localhost (when using forge tunnel)
        return iframeDomainName === imageSrcUrl.host || imageSrcUrl.hostname === 'localhost';
    } catch (e) {
        return false;
    }
};
const $576cfccaadb64755$var$getImageHostsEnvironment = (environment)=>{
    if ((0, $lzcvT.isFedRamp)()) {
        if (environment === (0, $1c598.ProductEnvironment).STAGING) return 'fedramp-stg';
        return 'fedramp-prod';
    }
    return (0, $b7qxC.getCDNEnvironment)(environment);
};
const $576cfccaadb64755$var$getImageHostsEnvironmentForIC = (environment)=>{
    return environment === (0, $1c598.ProductEnvironment).PRODUCTION ? 'ic-prod' : 'ic-stg';
};
const $576cfccaadb64755$var$getAtlassianImageHosts = (environment)=>{
    if ((0, $dh538.fg)('forge-ui-oasis-enabled')) {
        if ((0, $T9xHm.isIsolatedCloud)()) {
            const icImageHostsEnvironment = $576cfccaadb64755$var$getImageHostsEnvironmentForIC(environment);
            return (0, $dRFAM.getAtlassianImageHost)(icImageHostsEnvironment, {
                getICDomain: ()=>(0, $T9xHm.isolatedCloudDomain)()
            });
        }
        const imageHostsEnvironment = $576cfccaadb64755$var$getImageHostsEnvironment(environment);
        return (0, $dRFAM.getAtlassianImageHost)(imageHostsEnvironment);
    }
    return $576cfccaadb64755$var$getAtlassianImageHostsForCommercialAndFedRamp(environment);
};
const $576cfccaadb64755$var$getAtlassianImageHostsForCommercialAndFedRamp = (environment)=>{
    const imageHostsEnvironment = $576cfccaadb64755$var$getImageHostsEnvironment(environment);
    return [
        ...$576cfccaadb64755$var$ATLASSIAN_IMAGES_HOSTS[imageHostsEnvironment],
        ...$576cfccaadb64755$var$getFOSHosts(imageHostsEnvironment)
    ];
};
const $576cfccaadb64755$export$3a08b61b3ed9a4da = (0, $4pOgL.isReactCompilerActivePlatform)() ? (url)=>{
    const $ = (0, $frIzR.c)(13);
    const { egress: egress, appDomainName: appDomainName } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    let t0;
    if ($[0] !== environment) {
        t0 = [
            window.location.hostname,
            ...$576cfccaadb64755$var$getAtlassianImageHosts(environment),
            ...$576cfccaadb64755$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS
        ];
        $[0] = environment;
        $[1] = t0;
    } else t0 = $[1];
    const allowListedImageHosts = t0;
    let t1;
    if ($[2] !== egress) {
        t1 = egress || [];
        $[2] = egress;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== allowListedImageHosts) {
        t2 = {
            type: "IMAGES",
            addresses: allowListedImageHosts
        };
        $[4] = allowListedImageHosts;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = [
            ...t1,
            t2
        ];
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    const egressService = (0, $lMJg3.useEgressPermissionService)("IMAGES", t3);
    let t4;
    if ($[9] !== appDomainName || $[10] !== egressService || $[11] !== url) {
        t4 = $576cfccaadb64755$export$6e0a24fd7459483a(url, egressService, appDomainName);
        $[9] = appDomainName;
        $[10] = egressService;
        $[11] = url;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : (url)=>{
    const { egress: egress, appDomainName: appDomainName } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const allowListedImageHosts = [
        window.location.hostname,
        ...$576cfccaadb64755$var$getAtlassianImageHosts(environment),
        ...$576cfccaadb64755$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS
    ];
    const egressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', [
        ...egress || [],
        {
            type: 'IMAGES',
            addresses: allowListedImageHosts
        }
    ]);
    return $576cfccaadb64755$export$6e0a24fd7459483a(url, egressService, appDomainName);
};
const $576cfccaadb64755$export$6e0a24fd7459483a = (url, egressService, appDomainName)=>{
    const dataImageUrlRegex = /^data:image/;
    try {
        const isValidUrl = $576cfccaadb64755$export$189ea7794c50ff15(url, appDomainName) || dataImageUrlRegex.test(url) || egressService.isValidUrl(url);
        return isValidUrl;
    } catch (e) {
        return false;
    }
};
module.exports["useIsValidImageUrl"] = $576cfccaadb64755$export$3a08b61b3ed9a4da;
module.exports["isValidImageUrl"] = $576cfccaadb64755$export$6e0a24fd7459483a;

});

parcelRegister("9FlsF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("3kxyJ")), module.exports);

$hXuPC.__exportStar((parcelRequire("3HJQU")), module.exports);

});

parcelRegister("3kxyJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSPInjectionService = module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = module.exports.getAtlassianImageHost = void 0;

var $87m1m = parcelRequire("87m1m");

const $26cd45857053dc7c$var$isICEnvKey = (env)=>env === 'ic-prod' || env === 'ic-stg';
const $26cd45857053dc7c$var$makeICDomain = (env, icLabel)=>`${icLabel}.${env === 'ic-prod' ? 'atlassian-isolated.net' : 'oasis-stg.com'}`;
const $26cd45857053dc7c$var$getICDomain = (env, icOptions)=>{
    if ('getICDomain' in icOptions) return icOptions.getICDomain();
    return $26cd45857053dc7c$var$makeICDomain(env, icOptions.icLabel);
};
const $26cd45857053dc7c$var$makeICHosts = (targetHostFunction)=>{
    return {
        'ic-stg': (icOptions)=>targetHostFunction('ic-stg', icOptions),
        'ic-prod': (icOptions)=>targetHostFunction('ic-prod', icOptions)
    };
};
const $26cd45857053dc7c$var$ATLASSIAN_HOST = {
    ATLASSIAN_API_GATEWAY_HOST: {
        dev: 'https://api.dev.atlassian.com',
        stg: 'https://api.stg.atlassian.com',
        prod: 'https://api.atlassian.com',
        'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://api.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://api.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_MEDIA_GATEWAY_HOST: {
        dev: 'https://media.dev.atl-paas.net',
        stg: 'https://media.staging.atl-paas.net',
        prod: 'https://api.media.atlassian.com',
        'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://media-api.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_ANALYTICS_GATEWAY_HOST: {
        dev: 'https://as.dev.atl-paas.net',
        stg: 'https://as.staging.atl-paas.net',
        prod: 'https://as.atlassian.com',
        'fedramp-stg': 'https://as.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://as.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://as.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_AVATAR_HOST: {
        dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
        'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com',
        'ic-stg': (_icOptions)=>'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        'ic-prod': (_icOptions)=>'avatar-management--avatars.us-west-2.prod.public.atl-paas.net'
    },
    ATLASSIAN_TEAM_HEADER_HOST: {
        dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
        stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
        prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/gradients/',
        'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://teams-directory-frontend.services.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}/bfa/`)
    },
    ATLASSIAN_TEAM_AVATAR_HOST: {
        dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
        stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
        prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
        'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://teams-directory-frontend.services.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}/bfa/`)
    },
    ATLASSIAN_EMOJIS_HOST: {
        dev: 'https://pf-emoji-service.ddev.frontend.public.atl-paas.net',
        stg: 'https://pf-emoji-service.stg-east.frontend.public.atl-paas.net',
        prod: 'https://pf-emoji-service.prod-east.frontend.public.atl-paas.net',
        'fedramp-stg': 'https://pf-emoji-service.frontend.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://pf-emoji-service.frontend.cdn.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://pf-emoji-service.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}/bfa/emoji-service/`)
    },
    ATLASSIAN_FOP_GE_HOST: {
        dev: 'https://forge-outbound-proxy.dev.services.atlassian.com',
        stg: 'https://forge-outbound-proxy.stg.services.atlassian.com',
        prod: 'https://forge-outbound-proxy.services.atlassian.com',
        'fedramp-stg': '',
        'fedramp-prod': '',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>'')
    },
    ATLASSIAN_FOS_HOST: {
        dev: 'https://tdp-os.dev.services.atlassian.com',
        stg: 'https://tdp-os.stg.services.atlassian.com',
        prod: 'https://tdp-os.services.atlassian.com',
        'fedramp-stg': 'https://tdp-os.stg.services.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://tdp-os.services.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://tdp-os.services.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    }
};
const $26cd45857053dc7c$var$getAtlassianHost = (hostType, microsEnv, icOptions)=>{
    const hostMap = $26cd45857053dc7c$var$ATLASSIAN_HOST[hostType];
    if ($26cd45857053dc7c$var$isICEnvKey(microsEnv)) {
        if (!icOptions) throw new Error('Missing IC label');
        return hostMap[microsEnv](icOptions);
    }
    return hostMap[microsEnv];
};
const $26cd45857053dc7c$var$FOS_CDN_STANDARD_HOST = {
    dev: 'https://object-store.stg.atlassian.com',
    stg: 'https://object-store.stg.atlassian.com',
    prod: 'https://object-store.atlassian.com'
};
const $26cd45857053dc7c$var$FOS_CDN_IC_HOST = $26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://object-store.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`);
const $26cd45857053dc7c$var$FOS_CDN_PATH = '/os/ecosystem/installation/';
const $26cd45857053dc7c$var$getFOSCDNHost = (microsEnv, icOptions)=>{
    if ($26cd45857053dc7c$var$isICEnvKey(microsEnv)) return icOptions ? $26cd45857053dc7c$var$FOS_CDN_IC_HOST[microsEnv](icOptions) : undefined;
    return $26cd45857053dc7c$var$FOS_CDN_STANDARD_HOST[microsEnv];
};
const $26cd45857053dc7c$var$getFOSHostDownload = (microsEnv, icOptions)=>{
    const fosHost = $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_FOS_HOST', microsEnv, icOptions);
    return $26cd45857053dc7c$var$isICEnvKey(microsEnv) ? [
        `${fosHost}/fos/app/download/`,
        `${fosHost}/fos/cdn/download/`
    ] : [
        `${fosHost}/fos-eap/download/`,
        `${fosHost}/fos/app/download/`,
        `${fosHost}/fos/cdn/download/`
    ];
};
const $26cd45857053dc7c$var$getFOSHostUpload = (microsEnv, icOptions)=>{
    const fosHost = $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_FOS_HOST', microsEnv, icOptions);
    return $26cd45857053dc7c$var$isICEnvKey(microsEnv) ? [
        `${fosHost}/fos/app/upload/`,
        `${fosHost}/fos/cdn/upload/`
    ] : [
        `${fosHost}/fos-eap/upload/`,
        `${fosHost}/fos/app/upload/`,
        `${fosHost}/fos/cdn/upload/`
    ];
};
const $26cd45857053dc7c$var$getFOSCDNUrls = (microsEnv, icOptions)=>{
    const fosCDNHost = $26cd45857053dc7c$var$getFOSCDNHost(microsEnv, icOptions);
    return fosCDNHost ? [
        `${fosCDNHost}${$26cd45857053dc7c$var$FOS_CDN_PATH}`
    ] : [];
};
const $26cd45857053dc7c$var$getAtlassianImageHost = (microsEnv, icOptions)=>{
    return [
        `https://${$26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_AVATAR_HOST', microsEnv, icOptions)}`,
        `https://*.wp.com/${$26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_AVATAR_HOST', microsEnv, icOptions)}/`,
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_EMOJIS_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_TEAM_AVATAR_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_TEAM_HEADER_HOST', microsEnv, icOptions),
        ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
        ...$26cd45857053dc7c$var$getFOSCDNUrls(microsEnv, icOptions)
    ];
};
module.exports.getAtlassianImageHost = $26cd45857053dc7c$var$getAtlassianImageHost;
module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
class $26cd45857053dc7c$var$CSPInjectionService {
    getCSPReportUri(microsEnv, icOptions) {
        const serviceName = $26cd45857053dc7c$var$isICEnvKey(microsEnv) && icOptions ? icOptions.serviceName : 'forge-cdn';
        if (microsEnv === 'dev' || microsEnv === 'stg') return `https://web-security-reports.stg.services.atlassian.com/csp-report/${serviceName}`;
        return `https://web-security-reports.services.atlassian.com/csp-report/${serviceName}`;
    }
    getForgeGlobalCSP(microsEnv, isFedRAMP = false, icOptions) {
        if ($26cd45857053dc7c$var$isICEnvKey(microsEnv) && icOptions) return `https://forge.forge-cdn.${$26cd45857053dc7c$var$getICDomain(microsEnv, icOptions)}`;
        return isFedRAMP ? `https://forge.cdn.${microsEnv.split('-')[1]}.atlassian-dev-us-gov-mod.net` : `https://forge.cdn.${microsEnv}.atlassian-dev.net`;
    }
    getMetalClientCSP(microsEnv, icOptions) {
        if ($26cd45857053dc7c$var$isICEnvKey(microsEnv) && icOptions) return `https://api.${$26cd45857053dc7c$var$getICDomain(microsEnv, icOptions)}/metal/ingest`;
        return `https://api.${microsEnv === 'prod' ? '' : 'stg.'}atlassian.com/metal/ingest`;
    }
    getExistingCSPDetails(cspType, cspDetails) {
        var _a;
        return (_a = cspDetails[cspType]) !== null && _a !== void 0 ? _a : [];
    }
    getConnectSrc(microsEnv, isTunnelling, icOptions) {
        const allowed = [];
        if (isTunnelling) allowed.push(...[
            'ws://localhost:*',
            'http://localhost:*'
        ]);
        const metalClientCSP = this.getMetalClientCSP(microsEnv, icOptions);
        allowed.push(metalClientCSP);
        allowed.push(`${$26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions)}/gateway/api/emoji/`);
        allowed.push($26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions));
        allowed.push($26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_ANALYTICS_GATEWAY_HOST', microsEnv, icOptions));
        const fopGeHost = $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_FOP_GE_HOST', microsEnv, icOptions);
        if (fopGeHost) allowed.push(fopGeHost);
        allowed.push(...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions));
        allowed.push(...$26cd45857053dc7c$var$getFOSHostUpload(microsEnv, icOptions));
        allowed.push(...$26cd45857053dc7c$var$getFOSCDNUrls(microsEnv, icOptions));
        return allowed;
    }
    getFrameAncestors(microsEnv, hostname, icOptions, macroParentHost, connectMacroParentDomain) {
        let frameAncestors = [];
        const localhostWithPortRegex = /^localhost:\d+$/;
        switch(microsEnv){
            case 'dev':
            case 'stg':
                frameAncestors = [
                    '*.jira-dev.com',
                    'http://localhost:*',
                    'http://devbucket.localhost',
                    'https://integration.bb-inf.net',
                    '*.atl-paas.net',
                    '*.stg.atlassian.com'
                ];
                if (macroParentHost && !localhostWithPortRegex.test(macroParentHost)) frameAncestors.push(`${macroParentHost}.cdn.stg.atlassian-dev.net`);
                break;
            case 'fedramp-stg':
                frameAncestors = [
                    '*.atlassian-stg-fedm.net'
                ];
                break;
            case 'fedramp-prod':
                frameAncestors = [
                    '*.atlassian-us-gov-mod.net'
                ];
                break;
            case 'ic-stg':
            case 'ic-prod':
                if (icOptions) frameAncestors = [
                    `*.${$26cd45857053dc7c$var$getICDomain(microsEnv, icOptions)}`
                ];
                break;
            case 'prod':
            default:
                frameAncestors = [
                    '*.atlassian.net',
                    'bitbucket.org',
                    '*.jira.com',
                    '*.atlassian.com',
                    '*.frontend.public.atl-paas.net'
                ];
                if (macroParentHost) {
                    if (localhostWithPortRegex.test(macroParentHost)) frameAncestors.push(`http://${macroParentHost}`);
                    else frameAncestors.push(`${macroParentHost}.cdn.prod.atlassian-dev.net`);
                }
                break;
        }
        if (connectMacroParentDomain) frameAncestors.push(connectMacroParentDomain);
        if (hostname) frameAncestors.push(hostname);
        return frameAncestors;
    }
    constructor(){
        this.getInjectableCSP = ({ existingCSPDetails: existingCSPDetails, microsEnv: microsEnv, tunnelCSPReporterUri: tunnelCSPReporterUri, hostname: hostname, isFedRAMP: isFedRAMP, icOptions: icOptions, macroParentHost: macroParentHost, connectMacroParentDomain: connectMacroParentDomain })=>{
            const reportUri = tunnelCSPReporterUri || this.getCSPReportUri(microsEnv, icOptions);
            const fosCDNUrls = $26cd45857053dc7c$var$getFOSCDNUrls(microsEnv, icOptions);
            const defaultSrc = [
                "'self'",
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls
            ].join(' ');
            const frameAncestors = [
                "'self'",
                ...this.getFrameAncestors(microsEnv, hostname, icOptions, macroParentHost, connectMacroParentDomain),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls
            ].join(' ');
            const frameSrc = [
                "'self'",
                hostname,
                $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.FRAME_SRC, existingCSPDetails),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls
            ].filter((a)=>a).join(' ');
            const fontSrc = [
                "'self'",
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls,
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.FONT_SRC, existingCSPDetails)
            ].join(' ');
            const imgSrc = [
                "'self'",
                'data:',
                'blob:',
                hostname,
                ...module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS,
                ...(0, module.exports.getAtlassianImageHost)(microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.IMG_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            const mediaSrc = [
                "'self'",
                'data:',
                'blob:',
                hostname,
                $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.MEDIA_SRC, existingCSPDetails),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls
            ].filter((a)=>a).join(' ');
            const connectSrc = [
                "'self'",
                hostname,
                ...this.getConnectSrc(microsEnv, !!tunnelCSPReporterUri, icOptions),
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.CONNECT_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            const scriptSrc = [
                "'self'",
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls,
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.SCRIPT_SRC, existingCSPDetails)
            ].join(' ');
            const styleSrc = [
                "'self'",
                hostname,
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...fosCDNUrls,
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.STYLE_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            return [
                `default-src ${defaultSrc}`,
                `frame-ancestors ${frameAncestors}`,
                `frame-src ${frameSrc}`,
                `font-src ${fontSrc}`,
                `img-src ${imgSrc}`,
                `media-src ${mediaSrc}`,
                `connect-src ${connectSrc}`,
                `script-src ${scriptSrc}`,
                `style-src ${styleSrc}`,
                `form-action 'self'`,
                `sandbox allow-popups allow-popups-to-escape-sandbox allow-downloads allow-forms allow-modals allow-pointer-lock allow-same-origin allow-scripts`,
                `report-uri ${reportUri}`
            ];
        };
    }
}
module.exports.CSPInjectionService = $26cd45857053dc7c$var$CSPInjectionService;

});

parcelRegister("87m1m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExternalCspType = void 0;
var $5e900f11265deb7e$var$ExternalCspType;
(function(ExternalCspType) {
    ExternalCspType["IMG_SRC"] = "img-src";
    ExternalCspType["MEDIA_SRC"] = "media-src";
    ExternalCspType["SCRIPT_SRC"] = "script-src";
    ExternalCspType["STYLE_SRC"] = "style-src";
    ExternalCspType["CONNECT_SRC"] = "connect-src";
    ExternalCspType["FONT_SRC"] = "font-src";
    ExternalCspType["FRAME_SRC"] = "frame-src";
})($5e900f11265deb7e$var$ExternalCspType = module.exports.ExternalCspType || (module.exports.ExternalCspType = {}));

});

parcelRegister("3HJQU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSPProcessingService = module.exports.InvalidConnectSrc = void 0;

var $hXuPC = parcelRequire("hXuPC");


const $2b28f4994d3f7e47$var$content_security_policy_parser_1 = $hXuPC.__importDefault((parcelRequire("1BOKq")));

const $2b28f4994d3f7e47$var$crypto_1 = $hXuPC.__importDefault((parcelRequire("7UOIm")));
class $2b28f4994d3f7e47$var$InvalidConnectSrc extends Error {
    constructor(){
        super('fetch.client should be an array of strings');
    }
}
module.exports.InvalidConnectSrc = $2b28f4994d3f7e47$var$InvalidConnectSrc;
class $2b28f4994d3f7e47$var$CSPProcessingService {
    getCspDetails(body, permissions) {
        var _a, _b;
        const { scripts: scripts, styles: styles } = (_a = permissions === null || permissions === void 0 ? void 0 : permissions.content) !== null && _a !== void 0 ? _a : {
            scripts: [],
            styles: []
        };
        const external = (_b = permissions === null || permissions === void 0 ? void 0 : permissions.external) !== null && _b !== void 0 ? _b : {};
        const $ = this.cheerioLoader(body, {
            xml: {
                xmlMode: false
            }
        });
        const { 'script-src': scriptSrc, 'style-src': styleSrc, ...mappedExternalCsp } = this.mapExternalPermissionsToCsp(external);
        return {
            'style-src': [
                ...this.getStyleSrc($, styles),
                ...styleSrc
            ],
            'script-src': [
                ...this.getScriptSrc($, scripts),
                ...scriptSrc
            ],
            ...mappedExternalCsp
        };
    }
    getInvalidCspPermissions(contentPermissions) {
        var _a, _b;
        const { styles: styles, scripts: scripts } = contentPermissions;
        const invalidStyles = (_a = styles === null || styles === void 0 ? void 0 : styles.filter((styleSrc)=>!this.isValidUserStyleSrc(`'${styleSrc}'`))) !== null && _a !== void 0 ? _a : [];
        const invalidScripts = (_b = scripts === null || scripts === void 0 ? void 0 : scripts.filter((scriptSrc)=>!this.isValidUserScriptSrc(scriptSrc))) !== null && _b !== void 0 ? _b : [];
        return [
            ...invalidStyles,
            ...invalidScripts
        ];
    }
    assertValidFetchClient(fetch) {
        if (fetch === null || fetch === void 0 ? void 0 : fetch.client) for (const client of fetch === null || fetch === void 0 ? void 0 : fetch.client){
            if (typeof client !== 'string') throw new $2b28f4994d3f7e47$var$InvalidConnectSrc();
        }
    }
    egressesToStringMap(externalPermissions) {
        return externalPermissions === null || externalPermissions === void 0 ? void 0 : externalPermissions.map((egress)=>typeof egress === 'object' ? egress.address : egress);
    }
    mapExternalPermissionsToCsp(externalPermissions) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { images: images, media: media, scripts: scripts, fetch: fetch, styles: styles, fonts: fonts, frames: frames } = externalPermissions;
        this.assertValidFetchClient(fetch);
        return {
            'img-src': (_a = this.egressesToStringMap(images)) !== null && _a !== void 0 ? _a : [],
            'media-src': (_b = this.egressesToStringMap(media)) !== null && _b !== void 0 ? _b : [],
            'script-src': (_c = this.egressesToStringMap(scripts)) !== null && _c !== void 0 ? _c : [],
            'style-src': (_d = this.egressesToStringMap(styles)) !== null && _d !== void 0 ? _d : [],
            'connect-src': (_e = fetch === null || fetch === void 0 ? void 0 : fetch.client) !== null && _e !== void 0 ? _e : [],
            'font-src': (_f = this.egressesToStringMap(fonts)) !== null && _f !== void 0 ? _f : [],
            'frame-src': (_g = this.egressesToStringMap(frames)) !== null && _g !== void 0 ? _g : []
        };
    }
    getStyleSrc($, userStyleSrc) {
        var _a, _b;
        const quotedUserStyleSrc = (_a = userStyleSrc === null || userStyleSrc === void 0 ? void 0 : userStyleSrc.map((x)=>`'${x}'`)) !== null && _a !== void 0 ? _a : [];
        const deprecatedUserStyleSrc = (_b = this.getDeprecatedUserCsp($)['style-src']) !== null && _b !== void 0 ? _b : [];
        const uniqueStyleSrc = [
            ...new Set([
                ...deprecatedUserStyleSrc,
                ...quotedUserStyleSrc
            ])
        ];
        return uniqueStyleSrc.filter((x)=>this.isValidUserStyleSrc(x));
    }
    getScriptSrc($, userScriptSrc) {
        var _a;
        const validUserScriptSrc = (_a = userScriptSrc === null || userScriptSrc === void 0 ? void 0 : userScriptSrc.filter((x)=>this.isValidUserScriptSrc(x))) !== null && _a !== void 0 ? _a : [];
        const generatedScriptHashes = validUserScriptSrc.includes('unsafe-inline') ? [] : this.getInlineScriptHashes($);
        const { scriptSrc: scriptSrc, userScriptHashes: userScriptHashes } = this.extractUniqueHashes(validUserScriptSrc, generatedScriptHashes);
        return [
            ...scriptSrc,
            ...generatedScriptHashes,
            ...userScriptHashes
        ].map((x)=>this.formatScriptSrc(x));
    }
    extractUniqueHashes(userScriptSrc, existingScriptHashes) {
        var _a;
        const userScriptHashes = [];
        const scriptSrc = (_a = userScriptSrc === null || userScriptSrc === void 0 ? void 0 : userScriptSrc.filter((scriptSrc)=>{
            const isValidHash = this.isValidHash(scriptSrc);
            if (isValidHash && !existingScriptHashes.includes(scriptSrc)) userScriptHashes.push(scriptSrc);
            return !isValidHash;
        })) !== null && _a !== void 0 ? _a : [];
        return {
            scriptSrc: scriptSrc,
            userScriptHashes: userScriptHashes
        };
    }
    getInlineScriptHashes($) {
        return $('script:not([src])').map((_index, script)=>{
            const html = $(script).html();
            return html && `sha256-${this.hashScript(html)}`;
        }).get();
    }
    hashScript(content) {
        const sha256 = $2b28f4994d3f7e47$var$crypto_1.default.createHash('sha256');
        return sha256.update(content).digest('base64');
    }
    formatScriptSrc(scriptSrc) {
        if (this.UNQUOTED_SCRIPT_SRC_ALLOWLIST.includes(scriptSrc)) return scriptSrc;
        return `'${scriptSrc}'`;
    }
    isValidUserScriptSrc(scriptSrc) {
        if (!this.isSafeCsp(scriptSrc)) return false;
        return this.isValidHash(scriptSrc) || this.SCRIPT_SRC_ALLOWLIST.includes(scriptSrc);
    }
    isValidUserStyleSrc(styleSrc) {
        if (!this.isSafeCsp(styleSrc)) {
            this.logger.info('discarding potentially-malicious CSP');
            return false;
        }
        return this.STYLE_SRC_ALLOWLIST.includes(styleSrc);
    }
    isSafeCsp(cspString) {
        return /^([a-zA-Z0-9='"+\/ -]|blob:)*$/.test(cspString);
    }
    isValidHash(cspString) {
        return this.BASE_64_HASH_PATTERNS.some((pattern)=>pattern.test(cspString));
    }
    getDeprecatedUserCsp($) {
        const cspContent = $('meta[http-equiv="Content-Security-Policy"]').attr('content');
        if (!cspContent) return {};
        if (!this.isSafeCsp(cspContent)) {
            this.logger.info('discarding potentially-malicious CSP');
            return {};
        }
        return Object.fromEntries((0, $2b28f4994d3f7e47$var$content_security_policy_parser_1.default)(cspContent));
    }
    constructor(logger, cheerioLoader){
        this.logger = logger;
        this.cheerioLoader = cheerioLoader;
        this.STYLE_SRC_ALLOWLIST = [
            `'unsafe-inline'`
        ];
        this.QUOTED_SCRIPT_SRC_ALLOWLIST = [
            'unsafe-inline',
            'unsafe-eval',
            'unsafe-hashes'
        ];
        this.UNQUOTED_SCRIPT_SRC_ALLOWLIST = [
            'blob:'
        ];
        this.SCRIPT_SRC_ALLOWLIST = [
            ...this.QUOTED_SCRIPT_SRC_ALLOWLIST,
            ...this.UNQUOTED_SCRIPT_SRC_ALLOWLIST
        ];
        this.BASE_64_HASH_PATTERNS = [
            /^sha256-[a-zA-Z0-9=+/]{44}$/,
            /^sha384-[a-zA-Z0-9=+/]{64}$/,
            /^sha512-[a-zA-Z0-9=+/]{88}$/
        ];
    }
}
module.exports.CSPProcessingService = $2b28f4994d3f7e47$var$CSPProcessingService;

});

parcelRegister("1BOKq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// "ASCII whitespace is U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, or
// U+0020 SPACE."
//
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $12c09c945b62217a$var$ASCII_WHITESPACE_CHARS = "\t\n\f\r ";
const $12c09c945b62217a$var$ASCII_WHITESPACE = RegExp(`[${$12c09c945b62217a$var$ASCII_WHITESPACE_CHARS}]+`);
const $12c09c945b62217a$var$ASCII_WHITESPACE_AT_START = RegExp(`^[${$12c09c945b62217a$var$ASCII_WHITESPACE_CHARS}]+`);
const $12c09c945b62217a$var$ASCII_WHITESPACE_AT_END = RegExp(`[${$12c09c945b62217a$var$ASCII_WHITESPACE_CHARS}]+$`);
// "An ASCII code point is a code point in the range U+0000 NULL to
// U+007F DELETE, inclusive." See <https://infra.spec.whatwg.org/#ascii-string>.
// deno-lint-ignore no-control-regex
const $12c09c945b62217a$var$ASCII = /^[\x00-\x7f]*$/;
/**
 * Parse a serialized Content Security Policy via [the spec][0].
 *
 * [0]: https://w3c.github.io/webappsec-csp/#parse-serialized-policy
 *
 * @param policy The serialized Content Security Policy to parse.
 * @returns A Map of Content Security Policy directives.
 * @example
 * parseContentSecurityPolicy(
 *   "default-src 'self'; script-src 'unsafe-eval' scripts.example; object-src; style-src styles.example",
 * );
 * // => Map(4) {
 * //      "default-src" => ["'self'"],
 * //      "script-src" => ["'unsafe-eval'", "scripts.example"],
 * //      "object-src" => [],
 * //      "style-src" => ["styles.example"],
 * //    }
 */ function $12c09c945b62217a$var$parseContentSecurityPolicy(policy) {
    const result = new Map();
    // "For each token returned by strictly splitting serialized on the
    // U+003B SEMICOLON character (;):"
    for (let token of policy.split(";")){
        // "1. Strip leading and trailing ASCII whitespace from token."
        token = token.replace($12c09c945b62217a$var$ASCII_WHITESPACE_AT_START, "").replace($12c09c945b62217a$var$ASCII_WHITESPACE_AT_END, "");
        // "2. If token is an empty string, or if token is not an ASCII string,
        //     continue."
        if (!token || !$12c09c945b62217a$var$ASCII.test(token)) continue;
        // We do these at the same time:
        // "3. Let directive name be the result of collecting a sequence of
        //     code points from token which are not ASCII whitespace."
        // "6. Let directive value be the result of splitting token on
        //     ASCII whitespace."
        const [rawDirectiveName, ...directiveValue] = token.split($12c09c945b62217a$var$ASCII_WHITESPACE);
        // "4. Set directive name to be the result of running ASCII lowercase on
        //     directive name."
        const directiveName = rawDirectiveName.toLowerCase();
        // "5. If policy's directive set contains a directive whose name is
        //     directive name, continue."
        if (result.has(directiveName)) continue;
        // "7. Let directive be a new directive whose name is directive name, and
        //     value is directive value."
        // "8. Append directive to policy's directive set."
        result.set(directiveName, directiveValue);
    }
    return result;
}
module.exports.default = $12c09c945b62217a$var$parseContentSecurityPolicy;

});

parcelRegister("clpPd", function(module, exports) {
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $1501019f8cb42aef$export$4da13fcc37d580b4 = [
    'javascript:',
    'data:',
    'vbscript:',
    'view-source:',
    'resource:',
    'about:',
    'chrome:',
    'livescript:',
    'mocha:',
    'file:',
    'mhtml:',
    'smb:'
];
const $1501019f8cb42aef$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    return $1501019f8cb42aef$export$4da13fcc37d580b4.includes(url.protocol) ? 'about:blank' : url.toString();
};
module.exports["sanitizeUrl"] = $1501019f8cb42aef$export$300bd6d67c49dbfc;

});

parcelRegister("fgm2d", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $iRRvH = parcelRequire("iRRvH");


var $gWF6I = parcelRequire("gWF6I");


var $kO2Re = parcelRequire("kO2Re");











var $9JpPs = parcelRequire("9JpPs");





var $jed12 = parcelRequire("jed12");


var $hEvav = parcelRequire("hEvav");

var $durRy = parcelRequire("durRy");


var $dx0OV = parcelRequire("dx0OV");


var $keDkq = parcelRequire("keDkq");














var $539Bm = parcelRequire("539Bm");

const $b3ac0804570f3b11$export$aab0d259c363afda = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, viewportDimensions: viewportDimensions } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $dh538.fg)("forge-ui-app-perf-tracking-enabled");
        $[0] = t1;
    } else t1 = $[0];
    const isEnabled = t1;
    let t2;
    if ($[1] !== viewportDimensions) {
        t2 = {
            isEnabled: isEnabled,
            viewportDimensions: viewportDimensions
        };
        $[1] = viewportDimensions;
        $[2] = t2;
    } else t2 = $[2];
    const { containerRef: containerRef } = (0, $539Bm.useResizeAnalytics)(t2);
    if (isEnabled) {
        let t3;
        if ($[3] !== children || $[4] !== containerRef) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ref: containerRef,
                id: "forge-ui-height-observer-wrapper"
            }, children);
            $[3] = children;
            $[4] = containerRef;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    let t3;
    if ($[6] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[6] = children;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, viewportDimensions: viewportDimensions })=>{
    const isEnabled = (0, $dh538.fg)('forge-ui-app-perf-tracking-enabled');
    const { containerRef: containerRef } = (0, $539Bm.useResizeAnalytics)({
        isEnabled: isEnabled,
        viewportDimensions: viewportDimensions
    });
    if (isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        id: "forge-ui-height-observer-wrapper"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};



var $9ZQdx = parcelRequire("9ZQdx");











var $h6bEF = parcelRequire("h6bEF");


var $hQK66 = parcelRequire("hQK66");














var $4ZTaE = parcelRequire("4ZTaE");










/**
 * Module-level singleton for a shared, lazily-created sandboxed iframe.
 *
 * A single hidden <iframe> is appended to document.body on first access and
 * reused by every WorkerWebRuntime instance in the same page. The iframe is
 * intentionally managed imperatively (outside of React) so that the React
 * reconciler can never unmount or reorder it.
 *
 * Usage:
 *   const iframe = getOrCreateSandboxIframe();
 *   destroySandboxIframe();                    // teardown / test cleanup
 */ 
var $aVZM7 = parcelRequire("aVZM7");


var $cqiXo = parcelRequire("cqiXo");


var $5oEbs = parcelRequire("5oEbs");

const $be0caa192fddc075$export$610aba4956682285 = (environment)=>{
    return `https://forge.${(0, $aVZM7.getForgeCDNBaseDomain)(environment)}`;
};
const $be0caa192fddc075$export$b13327eb43ebc8bd = (environment)=>{
    return `${$be0caa192fddc075$export$610aba4956682285(environment)}/runtime/sandbox.html`;
};
const $be0caa192fddc075$export$93ff7914791b9d75 = (extension)=>{
    return (0, $5oEbs.urlSafeB64)((0, $cqiXo.getEncodedAppContext)(extension));
};


const $462ad2a2c2816f62$export$6646fca33a54bb24 = '__forge-worker-sandbox__';
let $462ad2a2c2816f62$var$iframe = null;
const $462ad2a2c2816f62$var$createSandboxIframe = (document1, environment)=>{
    const iframeEl = document1.createElement('iframe');
    iframeEl.id = $462ad2a2c2816f62$export$6646fca33a54bb24;
    // technically we could remove 'allow-same-origin' and this will ensure all
    // worker runtime code is completely isolated (not able to read cookies or localStorage)
    // but this could prevent potential future features that require same-origin access,
    // (e.g. service-worker, indexdb etc.), so we'll keep it in place for now and revisit if needed.
    //
    // in order to secure the worker runtime, we will be utilising the security shim
    // script suggested in: https://hello.atlassian.net/wiki/x/dDy-hAE
    iframeEl.setAttribute('sandbox', 'allow-scripts allow-same-origin');
    iframeEl.src = (0, $be0caa192fddc075$export$b13327eb43ebc8bd)(environment);
    // Keep the iframe invisible but laid out so the browser doesn't defer script
    // execution inside it. `display:none` can suspend execution in some browsers.
    Object.assign(iframeEl.style, {
        position: 'absolute',
        width: '0',
        height: '0',
        border: 'none',
        top: '-9999px',
        left: '-9999px',
        visibility: 'hidden'
    });
    iframeEl.setAttribute('tabindex', '-1');
    iframeEl.setAttribute('aria-hidden', 'true');
    return iframeEl;
};
const $462ad2a2c2816f62$export$174dd467067cc3dc = (environment)=>{
    if (typeof document === 'undefined') // SSR guard — no DOM available
    return null;
    // Fast path: module-level cache (same module instance, same call).
    if ($462ad2a2c2816f62$var$iframe !== null) return $462ad2a2c2816f62$var$iframe;
    // Recovery path: find an existing iframe created by a different module
    // instance (Module Federation) or a previous module load (HMR).
    const existing = document.getElementById($462ad2a2c2816f62$export$6646fca33a54bb24);
    if (existing !== null) {
        $462ad2a2c2816f62$var$iframe = existing;
        return $462ad2a2c2816f62$var$iframe;
    }
    // First-ever creation: build the element and stamp it with the stable id.
    const iframeEl = $462ad2a2c2816f62$var$createSandboxIframe(document, environment);
    document.body.appendChild(iframeEl);
    $462ad2a2c2816f62$var$iframe = iframeEl;
    return $462ad2a2c2816f62$var$iframe;
};
const $462ad2a2c2816f62$export$dce981fb8c927a47 = ()=>{
    // Query the DOM directly rather than relying solely on the module variable.
    // A different module instance may have been the one to create the iframe,
    // so `iframeEl` could be null here even if the element exists in the DOM.
    const el = $462ad2a2c2816f62$var$iframe ?? (typeof document !== 'undefined' ? document.getElementById($462ad2a2c2816f62$export$6646fca33a54bb24) : null);
    if (el !== null) el.remove();
    $462ad2a2c2816f62$var$iframe = null;
};



var $4GQnE = parcelRequire("4GQnE");


/**
 * Well-known key used to attach the connection promise directly to the iframe
 * DOM element.
 *
 * Storing it on the element means Module Federation / HMR cannot cause a
 * second handshake: any module instance that receives the same DOM node will
 * find the already-initiated promise.
 */ const $36d60b6a72d0a950$var$SANDBOX_CONNECTION_KEY = '__forge-sandbox-connection-promise__';
const $36d60b6a72d0a950$export$dd439767100c493e = (iframe)=>{
    const el = iframe;
    el[$36d60b6a72d0a950$var$SANDBOX_CONNECTION_KEY]?.then((conn)=>conn.destroy()).catch(()=>{});
    delete el[$36d60b6a72d0a950$var$SANDBOX_CONNECTION_KEY];
};
/**
 * Returns (and lazily initiates) the single shared sandbox connection promise.
 * The promise is stored on the iframe element so it survives across module
 * instances — only the first caller triggers the handshake.
 */ const $36d60b6a72d0a950$var$getOrCreateConnectionPromise = (iframe, contentWindow, environment)=>{
    const el = iframe;
    const existing = el[$36d60b6a72d0a950$var$SANDBOX_CONNECTION_KEY];
    if (existing) return existing;
    const promise = (0, $4GQnE.setupSandboxController)(contentWindow, (0, $be0caa192fddc075$export$610aba4956682285)(environment));
    el[$36d60b6a72d0a950$var$SANDBOX_CONNECTION_KEY] = promise;
    return promise;
};
const $36d60b6a72d0a950$export$e888e640efbbe682 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (environment)=>{
    const $ = (0, $frIzR.c)(10);
    const [connection, setConnection] = (0, $42omo.useState)(null);
    let t0;
    let t1;
    if ($[0] !== environment) {
        t0 = ()=>{
            const iframe = (0, $462ad2a2c2816f62$export$174dd467067cc3dc)(environment);
            if (iframe === null) return;
            let cancelled = false;
            const initConnection = ()=>{
                const { contentWindow: contentWindow } = iframe;
                if (!contentWindow) return;
                $36d60b6a72d0a950$var$getOrCreateConnectionPromise(iframe, contentWindow, environment).then((conn)=>{
                    if (!cancelled) setConnection(conn);
                }).catch($36d60b6a72d0a950$var$_temp);
            };
            if (iframe.contentDocument === null) initConnection();
            else iframe.addEventListener("load", initConnection, {
                once: true
            });
            return ()=>{
                cancelled = true;
                iframe.removeEventListener("load", initConnection);
                setConnection(null);
            };
        };
        t1 = [
            environment
        ];
        $[0] = environment;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[3] !== environment) {
        t2 = (0, $462ad2a2c2816f62$export$174dd467067cc3dc)(environment);
        $[3] = environment;
        $[4] = t2;
    } else t2 = $[4];
    const iframeEl = t2;
    if (iframeEl && connection !== null) {
        let t3;
        if ($[5] !== connection || $[6] !== iframeEl) {
            t3 = {
                ready: true,
                connection: connection,
                iframeEl: iframeEl
            };
            $[5] = connection;
            $[6] = iframeEl;
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    let t3;
    if ($[8] !== iframeEl) {
        t3 = {
            ready: false,
            connection: null,
            iframeEl: iframeEl
        };
        $[8] = iframeEl;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : (environment)=>{
    const [connection, setConnection] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        const iframe = (0, $462ad2a2c2816f62$export$174dd467067cc3dc)(environment);
        if (iframe === null) // Non-browser environment (SSR) — nothing to do.
        return;
        let cancelled = false;
        const initConnection = ()=>{
            const { contentWindow: contentWindow } = iframe;
            if (!contentWindow) // Should not happen after the load event — guard for detached iframe edge case.
            return;
            $36d60b6a72d0a950$var$getOrCreateConnectionPromise(iframe, contentWindow, environment).then((conn)=>{
                if (!cancelled) setConnection(conn);
            }).catch(()=>{
            // Handshake failed — connection remains null.
            });
        };
        // TODO: Will need a better way or API to detect when the sadbox is ready.
        if (iframe.contentDocument === null) // contentDocument is null when the iframe has navigated to a cross-origin
        // page (i.e. the CDN sandbox has already loaded) — safe to connect now.
        initConnection();
        else // Still at about:blank (same-origin, contentDocument accessible) —
        // wait for the actual CDN src to load before attempting the handshake.
        iframe.addEventListener('load', initConnection, {
            once: true
        });
        return ()=>{
            cancelled = true;
            iframe.removeEventListener('load', initConnection);
            // Do NOT destroy the shared connection on cleanup — other mounted
            // hook instances are still using it.
            setConnection(null);
        };
    }, [
        environment
    ]);
    const iframeEl = (0, $462ad2a2c2816f62$export$174dd467067cc3dc)(environment);
    if (iframeEl && connection !== null) return {
        ready: true,
        connection: connection,
        iframeEl: iframeEl
    };
    return {
        ready: false,
        connection: null,
        iframeEl: iframeEl
    };
};
function $36d60b6a72d0a950$var$_temp() {}




var $jIiuI = parcelRequire("jIiuI");

var $5U2YR = parcelRequire("5U2YR");






var $6hkBe = parcelRequire("6hkBe");


var $lwhTs = parcelRequire("lwhTs");


var $i7d45 = parcelRequire("i7d45");


var $1qkDW = parcelRequire("1qkDW");


var $jIrI4 = parcelRequire("jIrI4");


var $45XLP = parcelRequire("45XLP");


var $kaOT1 = parcelRequire("kaOT1");


var $4k05I = parcelRequire("4k05I");

/**
 * Renders a Forge app using the worker-based runtime.
 *
 * Instead of an `<iframe>` per app (as the classic {@link Iframe} renderer does),
 * this component runs all app code inside dedicated module Workers spawned from a
 * single shared hidden sandbox `<iframe>`. This improves isolation and reduces
 * browser resource usage when multiple Forge apps are on the same page.
 *
 * **Lifecycle**
 * 1. On mount, waits for the shared sandbox connection to be established
 *    (see {@link useSharedSandbox}).
 * 2. Calls `connection.controller.createApp()` to spin up a Worker for this app
 *    and receives a `workerId`.
 * 3. Opens a {@link createWorkerBridge} channel to the Worker for bridge
 *    communication (UI events, resolver calls, etc.).
 * 4. On unmount, closes the bridge and calls `terminateApp(workerId)` to tear
 *    down the Worker.
 * 5. On page unload (`beforeunload`), destroys the shared sandbox connection and
 *    removes the singleton iframe from the DOM.
 *
 * This component renders `null` — it has no visible DOM output of its own.
 * The sandbox `<iframe>` is managed imperatively outside React so the reconciler
 * can never unmount or reorder it.
 */ const $94d639994bfb2178$var$WorkerWebRuntimeBase = (props)=>{
    const { appId: appId, extension: extension, entryPoint: entryPoint } = props;
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    // Shared, lazily-created sandbox iframe — a single <iframe> in document.body
    // is reused across all WorkerWebRuntime instances on the same page.
    const sandbox = (0, $36d60b6a72d0a950$export$e888e640efbbe682)(environment);
    // Tracks the active worker id so the unmount cleanup can terminate it.
    const workerIdRef = (0, $42omo.useRef)(null);
    const { getBridgeFeatures: getBridgeFeatures, destroy: cleanupBridgeFeatures, overlay: overlay } = $94d639994bfb2178$var$useBridgeFeatures(props);
    // Worker lifecycle: create on mount (once sandbox is ready), terminate on unmount.
    (0, $42omo.useEffect)(()=>{
        if (!sandbox.ready) return;
        const { connection: connection, iframeEl: iframeEl } = sandbox;
        const encodedAppContext = (0, $be0caa192fddc075$export$93ff7914791b9d75)(extension);
        // Resolve both the resource and its resolvedResourceEntry from the active entry point
        // together, matching the iframe runtime, so a top-level resource's HTML filename does not
        // bleed into a sub-entry-point's (config/edit/view/create/contextConfig) module URL.
        const { resource: resource, resolvedResourceEntry: resolvedResourceEntry } = (0, $6hkBe.getExtensionEntryPoint)(extension, entryPoint);
        // [TODO] we will need to review if it is possible that appContext can be changed during the lifecyle of the component.
        // If that is case, we might need to add appContext in the dependency array of useEffect and handle the update of appContext accordingly.
        const appContext = {
            appId: appId,
            extension: {
                installationId: extension.installationId,
                environmentId: extension.environmentId,
                appVersion: extension.appVersion,
                properties: {
                    resourceUploadId: extension.properties.resourceUploadId,
                    resource: resource,
                    resolvedResourceEntry: resolvedResourceEntry
                },
                type: extension.type
            },
            environment: environment,
            encodedAppContext: encodedAppContext
        };
        let bridgeClose = null;
        let cancelled = false;
        connection.controller.createApp(appContext).then((workerId)=>{
            // If the component unmounted while createApp() was in-flight, immediately
            // tear down the spawned worker so it isn't leaked.
            if (cancelled) {
                connection.controller.terminateApp(workerId).catch(()=>{});
                return;
            }
            workerIdRef.current = workerId;
            const bridge = (0, $4GQnE.createWorkerBridge)({
                workerId: workerId,
                withWindow: iframeEl.contentWindow,
                withDomain: (0, $be0caa192fddc075$export$610aba4956682285)(environment),
                features: getBridgeFeatures(),
                sendHandshakeMetric: (...args)=>{
                    // TODO: implement proper metrics here. For now we just log to console to verify that the bridge is working.
                    // eslint-disable-next-line no-console
                    console.log('[worker] Handshake metric', ...args);
                }
            });
            return bridge.open();
        }).then((result)=>{
            if (result) bridgeClose = result.close;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Failed to create worker app', err);
        });
        return ()=>{
            cancelled = true;
            cleanupBridgeFeatures();
            bridgeClose?.();
            if (workerIdRef.current !== null) {
                connection.controller.terminateApp(workerIdRef.current).catch((err_0)=>{
                    // eslint-disable-next-line no-console
                    console.error(`Failed to terminate worker with id ${workerIdRef.current}`, err_0);
                });
                workerIdRef.current = null;
            }
        };
    }, [
        sandbox.ready
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Page-level cleanup — fires when the tab/window is closed or navigated away.
    // Destroys the shared connection and removes the singleton iframe entirely.
    (0, $42omo.useEffect)(()=>{
        const handleUnload = ()=>{
            const iframe = (0, $462ad2a2c2816f62$export$174dd467067cc3dc)(environment);
            if (iframe !== null) {
                (0, $36d60b6a72d0a950$export$dd439767100c493e)(iframe);
                (0, $462ad2a2c2816f62$export$dce981fb8c927a47)();
            }
        };
        window.addEventListener('beforeunload', handleUnload);
        return ()=>window.removeEventListener('beforeunload', handleUnload);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // Note that we intentionally do NOT include `environment` in the dependency array here.
    // The unload handler should be added only once and always refer to the same shared iframe,
    // The iframe is appended imperatively to document.body by the singleton —
    // overlay is null by default and populated only when a bridge method
    // calls overlayController.show().
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, overlay);
};
const $94d639994bfb2178$export$62283308bb95b4ba = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kaOT1.TracingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($94d639994bfb2178$var$WorkerWebRuntimeBase, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kaOT1.TracingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($94d639994bfb2178$var$WorkerWebRuntimeBase, props));
});
const $94d639994bfb2178$export$a84c406ba9bc5e09 = (extension, entryPoint)=>{
    // renderRuntimeType describes how a specific resource bundle is executed, so it travels with the
    // resource. Read it from the entry point only when that entry point owns its own resource bundle;
    // otherwise the entry point shares the module's top-level bundle (and its runtime type). This keeps
    // the runtime decision aligned with the bundle `getExtensionEntryPoint` resolves — a worker-built
    // bundle is never forced into an iframe (or vice versa) by inheriting an unrelated runtime type.
    const entryPointProperties = entryPoint ? extension.properties?.[entryPoint] : extension.properties;
    const resolvedProperties = entryPointProperties?.resource ? entryPointProperties : extension.properties;
    return resolvedProperties?.renderRuntimeType === 'webworker';
};
const $94d639994bfb2178$var$useBridgeFeatures = (props)=>{
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    // Single overlay slot — bridge methods call overlayController.show()/hide() to
    // render overlay UI into this slot. Animated mode (default) wraps in
    // <ModalTransition> for ADS modals; inline mode (animated=false) renders
    // ThreeLOPrompt directly without transition.
    const { overlay: overlay, overlayController: overlayController } = (0, $jIrI4.useRuntimeOverlayController)();
    // Shared presenter: Forge app error overlay + host-renderer suppression + i18n.
    // Exposed as the `showAppError` bridge service for the withErrorDisplay middleware.
    const showAppError = (0, $45XLP.useRuntimeErrorOverlay)({
        overlayController: overlayController,
        extension: props.extension,
        setShouldShowRenderer: props.setShouldShowRenderer,
        onError: props.onError
    });
    // WorkerWebRuntime has no iframe to hide and no setIsThreeLOPromptVisible prop
    // (IframeProps vs InnerIframeProps), so renderThreeLOPrompt is a minimal
    // implementation — retry queue only, no visibility side-effects.
    const invokeRetriesRef = (0, $42omo.useRef)([]);
    const latestRef = (0, $42omo.useRef)({
        overlayController: overlayController,
        extension: props.extension
    });
    latestRef.current = {
        overlayController: overlayController,
        extension: props.extension
    };
    const renderThreeLOPrompt = (0, $hQK66.useCallbackOne)((authUrl, retry)=>new Promise((resolve)=>{
            const { overlayController: overlayController_0, extension: extension } = latestRef.current;
            invokeRetriesRef.current.push(retry);
            overlayController_0.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ZTaE.default), {
                authUrl: authUrl,
                onSuccess: async ()=>{
                    resolve();
                    overlayController_0.hide();
                    try {
                        await Promise.all(invokeRetriesRef.current.map((r)=>r()));
                    } finally{
                        invokeRetriesRef.current = [];
                    }
                },
                metadata: {
                    moduleType: extension.type
                }
            }), true);
        }), []);
    // Assembles host-side capabilities (invoker, tracing, token, modal) for bridge methods.
    // Returns a getter rather than a snapshot so services are always current at call time.
    const { getServices: getServices } = (0, $1qkDW.useBridgeServices)(props, overlayController, renderThreeLOPrompt, showAppError);
    const { customBridgeMethods: legacyCustomBridgeMethods, customBridge: customBridge, ...bridgeContextProps } = props;
    // Captured once at mount — custom bridge methods are not supported to change after initial render.
    const legacyCustomBridgeMethodsRef = (0, $42omo.useRef)(legacyCustomBridgeMethods);
    const customBridgeRef = (0, $42omo.useRef)(customBridge);
    // [Important] the implementation of getBridgeContext is stable and does not change across the lifecycle of the component, so it is safe to include it in the dependency array of createBridgeFeatures
    // without causing unnecessary re-renders or re-creations of the bridge features.
    const { getBridgeContext: getBridgeContext, destroy: destroy } = (0, $i7d45.useBridgeContext)({
        ...bridgeContextProps,
        environment: environment,
        page: page,
        runtime: 'webworker'
    }, getServices, props.contextChangeListeners);
    const getBridgeFeatures = (0, $hQK66.useCallbackOne)(()=>{
        return (0, $lwhTs.createBridgeFeatures)(getBridgeContext, (baseBridgeMethods)=>(0, $4k05I.consolidateCustomBridge)(baseBridgeMethods, legacyCustomBridgeMethodsRef.current, customBridgeRef.current));
    }, []);
    return {
        overlay: overlay,
        destroy: destroy,
        getBridgeFeatures: getBridgeFeatures
    };
};





const $6f2f66284b5f7b02$export$c9565324b088e0b8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(70);
    let accountId;
    let bridge;
    let components;
    let contextIds;
    let coreData;
    let embeddedMacroParentType;
    let entryPoint;
    let extension;
    let extensionData;
    let extensionPayload;
    let extensionViewData;
    let getContextToken;
    let isEmbeddedMacro;
    let locale;
    let restProps;
    let setError;
    let setForgeDoc;
    let timezone;
    if ($[0] !== t0) {
        ({ setForgeDoc: setForgeDoc, setError: setError, accountId: accountId, contextIds: contextIds, extension: extension, components: components, coreData: coreData, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, timezone: timezone, locale: locale, bridge: bridge, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, entryPoint: entryPoint, ...restProps } = t0);
        $[0] = t0;
        $[1] = accountId;
        $[2] = bridge;
        $[3] = components;
        $[4] = contextIds;
        $[5] = coreData;
        $[6] = embeddedMacroParentType;
        $[7] = entryPoint;
        $[8] = extension;
        $[9] = extensionData;
        $[10] = extensionPayload;
        $[11] = extensionViewData;
        $[12] = getContextToken;
        $[13] = isEmbeddedMacro;
        $[14] = locale;
        $[15] = restProps;
        $[16] = setError;
        $[17] = setForgeDoc;
        $[18] = timezone;
    } else {
        accountId = $[1];
        bridge = $[2];
        components = $[3];
        contextIds = $[4];
        coreData = $[5];
        embeddedMacroParentType = $[6];
        entryPoint = $[7];
        extension = $[8];
        extensionData = $[9];
        extensionPayload = $[10];
        extensionViewData = $[11];
        getContextToken = $[12];
        isEmbeddedMacro = $[13];
        locale = $[14];
        restProps = $[15];
        setError = $[16];
        setForgeDoc = $[17];
        timezone = $[18];
    }
    const forgeReactMajorVersion = (0, $42omo.useRef)(null);
    let t1;
    if ($[19] !== setError) {
        t1 = (t2)=>{
            const { error: error } = t2;
            if (setError) setError(error);
        };
        $[19] = setError;
        $[20] = t1;
    } else t1 = $[20];
    let t2;
    if ($[21] !== setForgeDoc) {
        t2 = (t3)=>{
            const { forgeDoc: forgeDoc } = t3;
            Object.freeze(forgeDoc);
            setForgeDoc(forgeDoc);
            if (forgeReactMajorVersion.current === null && forgeDoc.forgeReactMajorVersion) forgeReactMajorVersion.current = forgeDoc.forgeReactMajorVersion;
        };
        $[21] = setForgeDoc;
        $[22] = t2;
    } else t2 = $[22];
    let t3;
    if ($[23] !== bridge || $[24] !== t1 || $[25] !== t2) {
        t3 = {
            onError: t1,
            ...bridge,
            reconcile: t2
        };
        $[23] = bridge;
        $[24] = t1;
        $[25] = t2;
        $[26] = t3;
    } else t3 = $[26];
    const combinedBridge = t3;
    let t4;
    let t5;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>forgeReactMajorVersion.current;
        t5 = [
            forgeReactMajorVersion
        ];
        $[27] = t4;
        $[28] = t5;
    } else {
        t4 = $[27];
        t5 = $[28];
    }
    const getCurrentForgeReactMajorVersion = (0, $hQK66.useCallbackOne)(t4, t5);
    if ((0, $94d639994bfb2178$export$a84c406ba9bc5e09)(extension, entryPoint) && (0, $dh538.fg)("forge-ui-worker-runtime")) {
        let t6;
        if ($[29] !== setError) {
            t6 = (err)=>setError && setError(new Error(err));
            $[29] = setError;
            $[30] = t6;
        } else t6 = $[30];
        let t7;
        if ($[31] !== accountId || $[32] !== combinedBridge || $[33] !== components || $[34] !== contextIds || $[35] !== coreData || $[36] !== entryPoint || $[37] !== extension || $[38] !== extensionData || $[39] !== extensionPayload || $[40] !== extensionViewData || $[41] !== getContextToken || $[42] !== getCurrentForgeReactMajorVersion || $[43] !== locale || $[44] !== restProps || $[45] !== t6 || $[46] !== timezone) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94d639994bfb2178$export$62283308bb95b4ba), {
                accountId: accountId,
                contextIds: contextIds,
                extension: extension,
                coreData: coreData,
                components: components,
                extensionData: extensionData,
                extensionPayload: extensionPayload,
                extensionViewData: extensionViewData,
                getContextToken: getContextToken,
                getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
                timezone: timezone,
                locale: locale,
                bridge: combinedBridge,
                appId: extension.appId,
                entryPoint: entryPoint,
                ...restProps,
                onError: t6
            });
            $[31] = accountId;
            $[32] = combinedBridge;
            $[33] = components;
            $[34] = contextIds;
            $[35] = coreData;
            $[36] = entryPoint;
            $[37] = extension;
            $[38] = extensionData;
            $[39] = extensionPayload;
            $[40] = extensionViewData;
            $[41] = getContextToken;
            $[42] = getCurrentForgeReactMajorVersion;
            $[43] = locale;
            $[44] = restProps;
            $[45] = t6;
            $[46] = timezone;
            $[47] = t7;
        } else t7 = $[47];
        return t7;
    }
    const t6 = ((0, $dh538.fg)("platform_forge_ui_refactor_macro_parent_type") ? !!embeddedMacroParentType : isEmbeddedMacro) && (0, $dh538.fg)("platform_forge_ui_embedded_inline_macro") ? "0px" : undefined;
    let t7;
    if ($[48] !== setError) {
        t7 = (err_0)=>setError && setError(new Error(err_0));
        $[48] = setError;
        $[49] = t7;
    } else t7 = $[49];
    let t8;
    if ($[50] !== accountId || $[51] !== combinedBridge || $[52] !== components || $[53] !== contextIds || $[54] !== coreData || $[55] !== embeddedMacroParentType || $[56] !== entryPoint || $[57] !== extension || $[58] !== extensionData || $[59] !== extensionPayload || $[60] !== extensionViewData || $[61] !== getContextToken || $[62] !== getCurrentForgeReactMajorVersion || $[63] !== isEmbeddedMacro || $[64] !== locale || $[65] !== restProps || $[66] !== t6 || $[67] !== t7 || $[68] !== timezone) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h6bEF.Iframe), {
            accountId: accountId,
            contextIds: contextIds,
            extension: extension,
            coreData: coreData,
            components: components,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            getContextToken: getContextToken,
            timezone: timezone,
            locale: locale,
            bridge: combinedBridge,
            isHidden: true,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedMacroParentType: embeddedMacroParentType,
            entryPoint: entryPoint,
            getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
            ...restProps,
            height: t6,
            onError: t7
        });
        $[50] = accountId;
        $[51] = combinedBridge;
        $[52] = components;
        $[53] = contextIds;
        $[54] = coreData;
        $[55] = embeddedMacroParentType;
        $[56] = entryPoint;
        $[57] = extension;
        $[58] = extensionData;
        $[59] = extensionPayload;
        $[60] = extensionViewData;
        $[61] = getContextToken;
        $[62] = getCurrentForgeReactMajorVersion;
        $[63] = isEmbeddedMacro;
        $[64] = locale;
        $[65] = restProps;
        $[66] = t6;
        $[67] = t7;
        $[68] = timezone;
        $[69] = t8;
    } else t8 = $[69];
    return t8;
} : ({ setForgeDoc: setForgeDoc, setError: setError, accountId: accountId, contextIds: contextIds, extension: extension, components: components, coreData: coreData, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, timezone: timezone, locale: locale, bridge: bridge, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, entryPoint: entryPoint, ...restProps })=>{
    const forgeReactMajorVersion = (0, $42omo.useRef)(null);
    const combinedBridge = {
        onError: ({ error: error })=>{
            if (setError) setError(error);
        },
        ...bridge,
        reconcile: ({ forgeDoc: forgeDoc })=>{
            Object.freeze(forgeDoc);
            setForgeDoc(forgeDoc);
            if (forgeReactMajorVersion.current === null && forgeDoc.forgeReactMajorVersion) forgeReactMajorVersion.current = forgeDoc.forgeReactMajorVersion;
        }
    };
    const getCurrentForgeReactMajorVersion = (0, $hQK66.useCallbackOne)(()=>{
        return forgeReactMajorVersion.current;
    }, [
        forgeReactMajorVersion
    ]);
    // this is essential based on feature gate for now.
    // In the future, this check should inspect extension / manifest prop to
    // determine whether to use the worker runtime or not.
    if ((0, $94d639994bfb2178$export$a84c406ba9bc5e09)(extension, entryPoint) && (0, $dh538.fg)('forge-ui-worker-runtime')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94d639994bfb2178$export$62283308bb95b4ba), {
        accountId: accountId,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        components: components,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        timezone: timezone,
        locale: locale,
        bridge: combinedBridge,
        appId: extension.appId,
        entryPoint: entryPoint,
        ...restProps,
        onError: (err)=>setError && setError(new Error(err))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h6bEF.Iframe), {
        accountId: accountId,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        components: components,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        timezone: timezone,
        locale: locale,
        bridge: combinedBridge,
        isHidden: true,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedMacroParentType: embeddedMacroParentType,
        entryPoint: entryPoint,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        ...restProps,
        // The hidden UI Kit iframe defaults to height: '100%' when viewportSize is set
        // (because viewportSize makes isResizable false which disables iframeResizer, falling back to height: 100%).
        // For embedded UI Kit macros, this inflates the iframe's bodyScroll measurement,
        // causing the outer faus adf-renderer iframe to grow unexpectedly. Setting '0px' prevents this.
        height: ((0, $dh538.fg)('platform_forge_ui_refactor_macro_parent_type') ? !!embeddedMacroParentType : isEmbeddedMacro) && (0, $dh538.fg)('platform_forge_ui_embedded_inline_macro') ? '0px' : undefined,
        onError: (err_0)=>setError && setError(new Error(err_0))
    });
};



var $gwUcI = parcelRequire("gwUcI");

const $e892f186f061f3fc$var$UIKitRendererOld = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(66);
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, contextIds: contextIds, contextChangeListeners: contextChangeListeners, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, customBridge: customBridge, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, viewOnClose: viewOnClose } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $42omo.useState)(true);
    const isMacro = extension.type === "xen:macro";
    let t0;
    if ($[0] !== components) {
        t0 = components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
        $[0] = components;
        $[1] = t0;
    } else t0 = $[1];
    const injectedComponentsWithKey = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hEvav.makeUser)();
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== accountId || $[4] !== cloudId || $[5] !== mentionProvider || $[6] !== product || $[7] !== workspaceId) {
        t2 = (0, $durRy.makeNativeUserPicker)({
            mentionProvider: mentionProvider,
            accountId: accountId,
            ...workspaceId ? {
                cloudId: "bitbucket"
            } : {
                cloudId: cloudId
            },
            productAttributes: workspaceId ? {
                workspaceIds: [
                    (0, $gwUcI.uncurlyUuid)(workspaceId)
                ]
            } : undefined,
            productKey: product
        });
        $[3] = accountId;
        $[4] = cloudId;
        $[5] = mentionProvider;
        $[6] = product;
        $[7] = workspaceId;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== bridge) {
        t3 = (0, $dx0OV.makeADFRenderer)({
            bridge: bridge
        });
        $[9] = bridge;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== t3) {
        t4 = {
            AdfRenderer: t3
        };
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t2 || $[14] !== t4) {
        t5 = {
            Avatar: t1,
            AvatarStack: (0, $keDkq.UserGroup),
            UserPicker: t2,
            ...t4
        };
        $[13] = t2;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    const wiredComponents = t5;
    let t6;
    if ($[16] !== injectedComponentsWithKey || $[17] !== wiredComponents) {
        t6 = (defaults)=>({
                ...defaults,
                ...wiredComponents,
                ...injectedComponentsWithKey
            });
        $[16] = injectedComponentsWithKey;
        $[17] = wiredComponents;
        $[18] = t6;
    } else t6 = $[18];
    const getComponents = t6;
    let t7;
    if ($[19] !== onAppError || $[20] !== onError) {
        t7 = (error_0)=>{
            if (onError) onError(error_0.message);
            if (onAppError) onAppError(error_0.message);
        };
        $[19] = onAppError;
        $[20] = onError;
        $[21] = t7;
    } else t7 = $[21];
    const handleError = t7;
    let t8;
    let t9;
    if ($[22] !== error || $[23] !== onAppError || $[24] !== onError) {
        t8 = ()=>{
            if (onError && error) onError(error.message);
            if (onAppError && error) onAppError(error.message);
        };
        t9 = [
            error,
            onError,
            onAppError
        ];
        $[22] = error;
        $[23] = onAppError;
        $[24] = onError;
        $[25] = t8;
        $[26] = t9;
    } else {
        t8 = $[25];
        t9 = $[26];
    }
    (0, $42omo.useEffect)(t8, t9);
    const t10 = isMacro ? viewportDimensions : undefined;
    let t11;
    if ($[27] !== error?.message || $[28] !== extension || $[29] !== extensionData || $[30] !== extensionPayload || $[31] !== forgeDoc || $[32] !== getComponents || $[33] !== handleError || $[34] !== loadingComponent || $[35] !== modalExtension || $[36] !== onSuccess || $[37] !== shouldShowRenderer || $[38] !== viewOnClose) {
        t11 = shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
            forgeDoc: forgeDoc,
            extension: extension,
            error: error?.message,
            components: getComponents,
            modalExtension: modalExtension ? {
                ...modalExtension,
                viewOnClose: viewOnClose
            } : modalExtension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionType: extensionData.type,
            loading: true,
            loadingComponent: loadingComponent,
            onError: handleError,
            onSuccess: onSuccess
        });
        $[27] = error?.message;
        $[28] = extension;
        $[29] = extensionData;
        $[30] = extensionPayload;
        $[31] = forgeDoc;
        $[32] = getComponents;
        $[33] = handleError;
        $[34] = loadingComponent;
        $[35] = modalExtension;
        $[36] = onSuccess;
        $[37] = shouldShowRenderer;
        $[38] = viewOnClose;
        $[39] = t11;
    } else t11 = $[39];
    let t12;
    if ($[40] !== onForgeDocUpdated) {
        t12 = (forgeDoc_0)=>{
            if (forgeDoc_0.type !== "MacroConfig") setForgeDoc(forgeDoc_0);
            onForgeDocUpdated?.(forgeDoc_0);
        };
        $[40] = onForgeDocUpdated;
        $[41] = t12;
    } else t12 = $[41];
    let t13;
    if ($[42] !== accountId || $[43] !== bridge || $[44] !== contextChangeListeners || $[45] !== contextIds || $[46] !== coreData || $[47] !== customBridge || $[48] !== customBridgeMethods || $[49] !== embeddedMacroParentType || $[50] !== embeddedParentLocalId || $[51] !== entryPoint || $[52] !== extension || $[53] !== extensionData || $[54] !== extensionPayload || $[55] !== extensionViewData || $[56] !== getContextToken || $[57] !== getThreeLOPrompt || $[58] !== isEmbeddedMacro || $[59] !== locale || $[60] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f2f66284b5f7b02$export$c9565324b088e0b8), {
            accountId: accountId,
            setForgeDoc: t12,
            setError: setError,
            components: getThreeLOPrompt,
            contextIds: contextIds,
            extension: extension,
            coreData: coreData,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            locale: locale,
            bridge: bridge,
            getContextToken: getContextToken,
            entryPoint: entryPoint,
            customBridgeMethods: customBridgeMethods,
            customBridge: customBridge,
            setShouldShowRenderer: setShouldShowRenderer,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedParentLocalId: embeddedParentLocalId,
            contextChangeListeners: contextChangeListeners
        });
        $[42] = accountId;
        $[43] = bridge;
        $[44] = contextChangeListeners;
        $[45] = contextIds;
        $[46] = coreData;
        $[47] = customBridge;
        $[48] = customBridgeMethods;
        $[49] = embeddedMacroParentType;
        $[50] = embeddedParentLocalId;
        $[51] = entryPoint;
        $[52] = extension;
        $[53] = extensionData;
        $[54] = extensionPayload;
        $[55] = extensionViewData;
        $[56] = getContextToken;
        $[57] = getThreeLOPrompt;
        $[58] = isEmbeddedMacro;
        $[59] = locale;
        $[60] = t12;
        $[61] = t13;
    } else t13 = $[61];
    let t14;
    if ($[62] !== t10 || $[63] !== t11 || $[64] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3ac0804570f3b11$export$aab0d259c363afda), {
            viewportDimensions: t10
        }, t11, t13);
        $[62] = t10;
        $[63] = t11;
        $[64] = t13;
        $[65] = t14;
    } else t14 = $[65];
    return t14;
} : (props)=>{
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, contextIds: contextIds, contextChangeListeners: contextChangeListeners, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, customBridge: customBridge, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, viewOnClose: viewOnClose } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $42omo.useState)(true);
    const isMacro = extension.type === 'xen:macro';
    const injectedComponentsWithKey = (0, $42omo.useMemo)(()=>{
        return components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                // A key is required to ensure React creates new component instances when forgeDoc.key changes.
                // Without this key, React reuses the same component instance across different forgeDoc updates,
                // causing hook call order violations when the component structure changes between renders.
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
    }, [
        components
    ]);
    const wiredComponents = (0, $42omo.useMemo)(()=>({
            Avatar: (0, $hEvav.makeUser)(),
            AvatarStack: (0, $keDkq.UserGroup),
            UserPicker: (0, $durRy.makeNativeUserPicker)({
                mentionProvider: mentionProvider,
                accountId: accountId,
                ...workspaceId ? {
                    cloudId: 'bitbucket'
                } : {
                    cloudId: cloudId
                },
                productAttributes: workspaceId ? {
                    workspaceIds: [
                        (0, $gwUcI.uncurlyUuid)(workspaceId)
                    ]
                } : undefined,
                productKey: product
            }),
            AdfRenderer: (0, $dx0OV.makeADFRenderer)({
                bridge: bridge
            })
        }), [
        accountId,
        cloudId,
        mentionProvider,
        product,
        workspaceId,
        bridge
    ]);
    const getComponents = (0, $42omo.useCallback)((defaults)=>({
            ...defaults,
            ...wiredComponents,
            ...injectedComponentsWithKey
        }), [
        injectedComponentsWithKey,
        wiredComponents
    ]);
    const handleError = (0, $42omo.useCallback)((error_0)=>{
        if (onError) onError(error_0.message);
        if (onAppError) onAppError(error_0.message);
    }, [
        onError,
        onAppError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onError && error) onError(error.message);
        if (onAppError && error) onAppError(error.message);
    }, [
        error,
        onError,
        onAppError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3ac0804570f3b11$export$aab0d259c363afda), {
        viewportDimensions: isMacro ? viewportDimensions : undefined
    }, shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
        forgeDoc: forgeDoc,
        extension: extension,
        error: error?.message,
        components: getComponents,
        modalExtension: modalExtension ? {
            ...modalExtension,
            viewOnClose: viewOnClose
        } : modalExtension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionType: extensionData.type,
        loading: true,
        loadingComponent: loadingComponent,
        onError: handleError,
        onSuccess: onSuccess
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f2f66284b5f7b02$export$c9565324b088e0b8), {
        accountId: accountId,
        setForgeDoc: (forgeDoc_0)=>{
            if (forgeDoc_0.type !== 'MacroConfig') setForgeDoc(forgeDoc_0);
            onForgeDocUpdated?.(forgeDoc_0);
        },
        setError: setError,
        components: getThreeLOPrompt,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        locale: locale,
        bridge: bridge,
        getContextToken: getContextToken,
        entryPoint: entryPoint,
        customBridgeMethods: customBridgeMethods,
        customBridge: customBridge,
        setShouldShowRenderer: setShouldShowRenderer,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedParentLocalId: embeddedParentLocalId,
        contextChangeListeners: contextChangeListeners
    }));
};
const $e892f186f061f3fc$var$UIKitRendererNew = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(56);
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, contextIds: contextIds, contextChangeListeners: contextChangeListeners, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, customBridge: customBridge, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, viewOnClose: viewOnClose, isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $42omo.useState)(true);
    const isMacro = extension.type === "xen:macro";
    let t0;
    if ($[0] !== accountId || $[1] !== bridge || $[2] !== cloudId || $[3] !== components || $[4] !== mentionProvider || $[5] !== product || $[6] !== workspaceId) {
        t0 = {
            accountId: accountId,
            bridge: bridge,
            cloudId: cloudId,
            workspaceId: workspaceId,
            mentionProvider: mentionProvider,
            product: product,
            components: components
        };
        $[0] = accountId;
        $[1] = bridge;
        $[2] = cloudId;
        $[3] = components;
        $[4] = mentionProvider;
        $[5] = product;
        $[6] = workspaceId;
        $[7] = t0;
    } else t0 = $[7];
    const getComponents = (0, $9ZQdx.useUIKitComponents)(t0);
    let t1;
    if ($[8] !== onAppError || $[9] !== onError) {
        t1 = (error_0)=>{
            if (onError) onError(error_0.message);
            if (onAppError) onAppError(error_0.message);
        };
        $[8] = onAppError;
        $[9] = onError;
        $[10] = t1;
    } else t1 = $[10];
    const handleError = t1;
    let t2;
    let t3;
    if ($[11] !== error || $[12] !== onAppError || $[13] !== onError) {
        t2 = ()=>{
            if (onError && error) onError(error.message);
            if (onAppError && error) onAppError(error.message);
        };
        t3 = [
            error,
            onError,
            onAppError
        ];
        $[11] = error;
        $[12] = onAppError;
        $[13] = onError;
        $[14] = t2;
        $[15] = t3;
    } else {
        t2 = $[14];
        t3 = $[15];
    }
    (0, $42omo.useEffect)(t2, t3);
    const t4 = isMacro ? viewportDimensions : undefined;
    let t5;
    if ($[16] !== error?.message || $[17] !== extension || $[18] !== extensionData || $[19] !== extensionPayload || $[20] !== forgeDoc || $[21] !== getComponents || $[22] !== handleError || $[23] !== isEmbeddedUIKitInCustomUI || $[24] !== loadingComponent || $[25] !== modalExtension || $[26] !== onSuccess || $[27] !== shouldShowRenderer || $[28] !== viewOnClose) {
        t5 = shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
            forgeDoc: forgeDoc,
            extension: extension,
            error: error?.message,
            components: getComponents,
            modalExtension: modalExtension ? {
                ...modalExtension,
                viewOnClose: viewOnClose
            } : modalExtension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionType: extensionData.type,
            loading: true,
            loadingComponent: loadingComponent,
            onError: handleError,
            onSuccess: onSuccess,
            isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI
        });
        $[16] = error?.message;
        $[17] = extension;
        $[18] = extensionData;
        $[19] = extensionPayload;
        $[20] = forgeDoc;
        $[21] = getComponents;
        $[22] = handleError;
        $[23] = isEmbeddedUIKitInCustomUI;
        $[24] = loadingComponent;
        $[25] = modalExtension;
        $[26] = onSuccess;
        $[27] = shouldShowRenderer;
        $[28] = viewOnClose;
        $[29] = t5;
    } else t5 = $[29];
    let t6;
    if ($[30] !== onForgeDocUpdated) {
        t6 = (forgeDoc_0)=>{
            if (forgeDoc_0.type !== "MacroConfig") setForgeDoc(forgeDoc_0);
            onForgeDocUpdated?.(forgeDoc_0);
        };
        $[30] = onForgeDocUpdated;
        $[31] = t6;
    } else t6 = $[31];
    let t7;
    if ($[32] !== accountId || $[33] !== bridge || $[34] !== contextChangeListeners || $[35] !== contextIds || $[36] !== coreData || $[37] !== customBridge || $[38] !== customBridgeMethods || $[39] !== embeddedMacroParentType || $[40] !== embeddedParentLocalId || $[41] !== entryPoint || $[42] !== extension || $[43] !== extensionData || $[44] !== extensionPayload || $[45] !== extensionViewData || $[46] !== getContextToken || $[47] !== getThreeLOPrompt || $[48] !== isEmbeddedMacro || $[49] !== locale || $[50] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f2f66284b5f7b02$export$c9565324b088e0b8), {
            accountId: accountId,
            setForgeDoc: t6,
            setError: setError,
            components: getThreeLOPrompt,
            contextIds: contextIds,
            extension: extension,
            coreData: coreData,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            locale: locale,
            bridge: bridge,
            getContextToken: getContextToken,
            entryPoint: entryPoint,
            customBridgeMethods: customBridgeMethods,
            customBridge: customBridge,
            setShouldShowRenderer: setShouldShowRenderer,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedParentLocalId: embeddedParentLocalId,
            contextChangeListeners: contextChangeListeners
        });
        $[32] = accountId;
        $[33] = bridge;
        $[34] = contextChangeListeners;
        $[35] = contextIds;
        $[36] = coreData;
        $[37] = customBridge;
        $[38] = customBridgeMethods;
        $[39] = embeddedMacroParentType;
        $[40] = embeddedParentLocalId;
        $[41] = entryPoint;
        $[42] = extension;
        $[43] = extensionData;
        $[44] = extensionPayload;
        $[45] = extensionViewData;
        $[46] = getContextToken;
        $[47] = getThreeLOPrompt;
        $[48] = isEmbeddedMacro;
        $[49] = locale;
        $[50] = t6;
        $[51] = t7;
    } else t7 = $[51];
    let t8;
    if ($[52] !== t4 || $[53] !== t5 || $[54] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3ac0804570f3b11$export$aab0d259c363afda), {
            viewportDimensions: t4
        }, t5, t7);
        $[52] = t4;
        $[53] = t5;
        $[54] = t7;
        $[55] = t8;
    } else t8 = $[55];
    return t8;
} : (props)=>{
    const { accountId: accountId, bridge: bridge, components: components, coreData: coreData, contextIds: contextIds, contextChangeListeners: contextChangeListeners, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, customBridge: customBridge, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, viewOnClose: viewOnClose, isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $42omo.useState)(true);
    const isMacro = extension.type === 'xen:macro';
    const getComponents = (0, $9ZQdx.useUIKitComponents)({
        accountId: accountId,
        bridge: bridge,
        cloudId: cloudId,
        workspaceId: workspaceId,
        mentionProvider: mentionProvider,
        product: product,
        components: components
    });
    const handleError = (0, $42omo.useCallback)((error_0)=>{
        if (onError) onError(error_0.message);
        if (onAppError) onAppError(error_0.message);
    }, [
        onError,
        onAppError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onError && error) onError(error.message);
        if (onAppError && error) onAppError(error.message);
    }, [
        error,
        onError,
        onAppError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3ac0804570f3b11$export$aab0d259c363afda), {
        viewportDimensions: isMacro ? viewportDimensions : undefined
    }, shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
        forgeDoc: forgeDoc,
        extension: extension,
        error: error?.message,
        components: getComponents,
        modalExtension: modalExtension ? {
            ...modalExtension,
            viewOnClose: viewOnClose
        } : modalExtension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionType: extensionData.type,
        loading: true,
        loadingComponent: loadingComponent,
        onError: handleError,
        onSuccess: onSuccess,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f2f66284b5f7b02$export$c9565324b088e0b8), {
        accountId: accountId,
        setForgeDoc: (forgeDoc_0)=>{
            if (forgeDoc_0.type !== 'MacroConfig') setForgeDoc(forgeDoc_0);
            onForgeDocUpdated?.(forgeDoc_0);
        },
        setError: setError,
        components: getThreeLOPrompt,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        locale: locale,
        bridge: bridge,
        getContextToken: getContextToken,
        entryPoint: entryPoint,
        customBridgeMethods: customBridgeMethods,
        customBridge: customBridge,
        setShouldShowRenderer: setShouldShowRenderer,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedParentLocalId: embeddedParentLocalId,
        contextChangeListeners: contextChangeListeners
    }));
};
const $e892f186f061f3fc$export$9ca39743052e068e = (0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent'), $e892f186f061f3fc$var$UIKitRendererNew, $e892f186f061f3fc$var$UIKitRendererOld);












var $69400 = parcelRequire("69400");


var $g7rOD = parcelRequire("g7rOD");

const $acc8ad845a033cd1$var$Frame = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { forgeDoc: forgeDoc, IframeRenderer: IframeRenderer } = t0;
    const { setFrameCount: setFrameCount } = (0, $42omo.useContext)((0, $69400.FrameCount));
    let t1;
    let t2;
    if ($[0] !== setFrameCount) {
        t1 = ()=>{
            setFrameCount($acc8ad845a033cd1$var$_temp);
            return ()=>setFrameCount($acc8ad845a033cd1$var$_temp2);
        };
        t2 = [
            setFrameCount
        ];
        $[0] = setFrameCount;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    const { dispatch: dispatch, resource: resource, height: height, width: width } = forgeDoc.props;
    let t3;
    if ($[3] !== IframeRenderer || $[4] !== dispatch || $[5] !== height || $[6] !== resource || $[7] !== width) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IframeRenderer, {
            dispatch: dispatch,
            resource: resource,
            height: height,
            width: width
        });
        $[3] = IframeRenderer;
        $[4] = dispatch;
        $[5] = height;
        $[6] = resource;
        $[7] = width;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ forgeDoc: forgeDoc, IframeRenderer: IframeRenderer })=>{
    const { setFrameCount: setFrameCount } = (0, $42omo.useContext)((0, $69400.FrameCount));
    (0, $42omo.useEffect)(()=>{
        setFrameCount((prevCount)=>prevCount + 1);
        return ()=>setFrameCount((prevCount_0)=>prevCount_0 - 1);
    }, [
        setFrameCount
    ]);
    const { dispatch: dispatch, resource: resource, height: height, width: width } = forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IframeRenderer, {
        dispatch: dispatch,
        resource: resource,
        height: height,
        width: width
    });
};
const $acc8ad845a033cd1$var$FrameMemo = /*#__PURE__*/ (0, $42omo.memo)($acc8ad845a033cd1$var$Frame, (0, $g7rOD.forgePropsAreEqual));
const $acc8ad845a033cd1$export$1f1ebfe6da5b177c = (IframeRenderer)=>{
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($acc8ad845a033cd1$var$FrameMemo, {
            ...props,
            IframeRenderer: IframeRenderer
        });
};
function $acc8ad845a033cd1$var$_temp(prevCount) {
    return prevCount + 1;
}
function $acc8ad845a033cd1$var$_temp2(prevCount_0) {
    return prevCount_0 - 1;
}


var $2Fl4v = parcelRequire("2Fl4v");




var $HEA67 = parcelRequire("HEA67");


var $45DA9 = parcelRequire("45DA9");


var $dQZ64 = parcelRequire("dQZ64");





const $e59a0c07872a17e7$export$2faef82157961d5 = (extension, entryPoint)=>{
    if ((0, $94d639994bfb2178$export$a84c406ba9bc5e09)(extension, entryPoint) && (0, $dh538.fg)('forge-ui-worker-runtime')) return 'webworker';
    if ((0, $dh538.fg)('forge-ui-bridge-core-reset')) return 'iframev2';
    return 'iframe';
};



var $iqcSr = parcelRequire("iqcSr");


var $37B9X = parcelRequire("37B9X");


var $eI4ye = parcelRequire("eI4ye");














var $1uzCd = parcelRequire("1uzCd");





var $iUjrf = parcelRequire("iUjrf");





var $fwDOR = parcelRequire("fwDOR");

// Maximum time we would expect an app initialization to take.
const $f6ee5ed4b27f8132$var$HOLD_MS_APP_INIT_TIMEOUT = 6000;
const $f6ee5ed4b27f8132$var$HOLD_MS_FRAME_INITIALISED = 2000;
const $f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT = 5000;
const $f6ee5ed4b27f8132$var$HOLD_MS_CATCH_LATENT_REQUESTS = 350;
const $f6ee5ed4b27f8132$var$holdResourceStartEvents = new Set([
    'product-api-request-initiated',
    'resolver-invoke-initiated'
]);
const $f6ee5ed4b27f8132$var$holdResourceEndEvents = new Set([
    'product-api-requested',
    'resolver-invoked'
]);
const $f6ee5ed4b27f8132$var$holdAffectingEvents = new Set([
    ...$f6ee5ed4b27f8132$var$holdResourceStartEvents,
    ...$f6ee5ed4b27f8132$var$holdResourceEndEvents,
    'navigation-timing',
    'user-interacted'
]);
const $f6ee5ed4b27f8132$export$e286348a1f2b0a60 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { children: children } = t0;
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const appRuntimeInitiated = (0, $42omo.useRef)(false);
    const [holdState, setHoldState] = (0, $42omo.useState)("holding");
    const releaseTimeoutRef = (0, $42omo.useRef)();
    const holdResourcesStartedCountRef = (0, $42omo.useRef)(0);
    const holdResourcesFinishedCountRef = (0, $42omo.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            clearTimeout(releaseTimeoutRef.current);
            setHoldState("released");
        };
        $[0] = t1;
    } else t1 = $[0];
    const releaseHold = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (holdFor)=>{
            clearTimeout(releaseTimeoutRef.current);
            releaseTimeoutRef.current = setTimeout(releaseHold, holdFor);
        };
        $[1] = t2;
    } else t2 = $[1];
    const retainHoldFor = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (event)=>{
            if (!$f6ee5ed4b27f8132$var$holdAffectingEvents.has(event.type)) return;
            if (event.type === "user-interacted") {
                releaseHold();
                return;
            }
            const resourceHoldStarted = $f6ee5ed4b27f8132$var$holdResourceStartEvents.has(event.type);
            const resourceHoldFinished = $f6ee5ed4b27f8132$var$holdResourceEndEvents.has(event.type);
            if (resourceHoldStarted) holdResourcesStartedCountRef.current = holdResourcesStartedCountRef.current + 1;
            else if (resourceHoldFinished) holdResourcesFinishedCountRef.current = holdResourcesFinishedCountRef.current + 1;
            const activeResourceRequests = holdResourcesStartedCountRef.current - holdResourcesFinishedCountRef.current;
            if (!appRuntimeInitiated.current) {
                if (event.type === "navigation-timing") {
                    appRuntimeInitiated.current = true;
                    retainHoldFor(activeResourceRequests > 0 ? $f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT : $f6ee5ed4b27f8132$var$HOLD_MS_FRAME_INITIALISED);
                }
                return;
            }
            if (resourceHoldStarted) retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT);
            if (activeResourceRequests > 0) return;
            retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_CATCH_LATENT_REQUESTS);
        };
        $[2] = t3;
    } else t3 = $[2];
    const handleEvent = t3;
    let t4;
    let t5;
    if ($[3] !== timelineRef) {
        t4 = ()=>{
            retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_APP_INIT_TIMEOUT);
            const { listeners: listeners } = timelineRef.current;
            listeners.add(handleEvent);
            return ()=>{
                clearTimeout(releaseTimeoutRef.current);
                listeners.delete(handleEvent);
            };
        };
        t5 = [
            timelineRef,
            handleEvent,
            retainHoldFor
        ];
        $[3] = timelineRef;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[6] !== captureEvent || $[7] !== holdState) {
        t6 = ()=>()=>{
                if (holdState === "holding") captureEvent({
                    type: "page-hold-released",
                    elapsed: (0, $1uzCd.getPerformanceMark)()
                });
            };
        t7 = [
            holdState,
            captureEvent
        ];
        $[6] = captureEvent;
        $[7] = holdState;
        $[8] = t6;
        $[9] = t7;
    } else {
        t6 = $[8];
        t7 = $[9];
    }
    (0, $42omo.useEffect)(t6, t7);
    const t8 = holdState === "holding";
    let t9;
    if ($[10] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "forge-ui-app-content-ttai-wait-v2",
            hold: t8
        });
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== children || $[13] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t9, children);
        $[12] = children;
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    return t10;
} : ({ children: children })=>{
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const appRuntimeInitiated = (0, $42omo.useRef)(false);
    const [holdState, setHoldState] = (0, $42omo.useState)('holding');
    const releaseTimeoutRef = (0, $42omo.useRef)();
    const holdResourcesStartedCountRef = (0, $42omo.useRef)(0);
    const holdResourcesFinishedCountRef = (0, $42omo.useRef)(0);
    const releaseHold = (0, $42omo.useCallback)(()=>{
        clearTimeout(releaseTimeoutRef.current);
        setHoldState('released');
    }, [
        setHoldState
    ]);
    const retainHoldFor = (0, $42omo.useCallback)((holdFor)=>{
        clearTimeout(releaseTimeoutRef.current);
        releaseTimeoutRef.current = setTimeout(releaseHold, holdFor);
    }, [
        releaseHold
    ]);
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        if (!$f6ee5ed4b27f8132$var$holdAffectingEvents.has(event.type)) return;
        // Drop holds on user interaction (timeline invalidated).
        if (event.type === 'user-interacted') {
            releaseHold();
            return;
        }
        // Keep track of requests starting and finished, don't consider in holding
        // logic until the app has initialised.
        const resourceHoldStarted = $f6ee5ed4b27f8132$var$holdResourceStartEvents.has(event.type);
        const resourceHoldFinished = $f6ee5ed4b27f8132$var$holdResourceEndEvents.has(event.type);
        if (resourceHoldStarted) holdResourcesStartedCountRef.current += 1;
        else if (resourceHoldFinished) holdResourcesFinishedCountRef.current += 1;
        const activeResourceRequests = holdResourcesStartedCountRef.current - holdResourcesFinishedCountRef.current;
        // Retain unconditional hold until 'navigation-timing' is received to indicate
        // that the frame runtime has initialised correctly.
        if (!appRuntimeInitiated.current) {
            if (event.type === 'navigation-timing') {
                appRuntimeInitiated.current = true;
                retainHoldFor(activeResourceRequests > 0 ? $f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT : $f6ee5ed4b27f8132$var$HOLD_MS_FRAME_INITIALISED);
            }
            return;
        }
        // On new resource holds, reset to default resource request timeout.
        if (resourceHoldStarted) retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT);
        // Retain hold until all active requests are finished.
        if (activeResourceRequests > 0) return;
        // No active resource requests, wait a moment to catch any new resource
        // requests initiated by the app runtime.
        retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_CATCH_LATENT_REQUESTS);
    }, [
        releaseHold,
        retainHoldFor
    ]);
    // Event listener management.
    (0, $42omo.useEffect)(()=>{
        // Default timeout for app init, so we don't indefinitely on e.g. for
        // unhandled app errors.
        retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_APP_INIT_TIMEOUT);
        const { listeners: listeners } = timelineRef.current;
        listeners.add(handleEvent);
        return ()=>{
            clearTimeout(releaseTimeoutRef.current);
            listeners.delete(handleEvent);
        };
    }, [
        timelineRef,
        handleEvent,
        retainHoldFor
    ]);
    (0, $42omo.useEffect)(()=>{
        // On hold state change or component dismount: flag release in timeline.
        return ()=>{
            if (holdState === 'holding') captureEvent({
                type: 'page-hold-released',
                elapsed: (0, $1uzCd.getPerformanceMark)()
            });
        };
    }, [
        holdState,
        captureEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "forge-ui-app-content-ttai-wait-v2",
        hold: holdState === 'holding'
    }), children);
};
const $f6ee5ed4b27f8132$export$4304f91d6e983d05 = (0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('forge-ui-app-perf-tracking-enabled'), $f6ee5ed4b27f8132$export$e286348a1f2b0a60, (0, $42omo.Fragment));



var $9c0Ac = parcelRequire("9c0Ac");

/**
 * Inner wrapper rendered inside PerformanceAnalyticsProviderRollout so it can
 * access PerformanceAnalyticsContext and wire up UFOThirdPartySegment's iframe
 * behavior via onRegisterIframeEventListener.
 */ const $e2fd6b5eb27bb420$var$UFOThirdPartySegmentWithPerfTimeline = (0, $4pOgL.isReactCompilerActivePlatform)() ? function UFOThirdPartySegmentWithPerfTimeline(t0) {
    const $ = (0, $frIzR.c)(7);
    const { children: children, name: name, extraData: extraData } = t0;
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    let t1;
    if ($[0] !== timelineRef) {
        t1 = (listener)=>{
            const timeline = timelineRef?.current;
            if (!timeline) return $e2fd6b5eb27bb420$var$_temp;
            timeline.listeners.add(listener);
            return ()=>{
                timeline.listeners.delete(listener);
            };
        };
        $[0] = timelineRef;
        $[1] = t1;
    } else t1 = $[1];
    const onRegisterIframeEventListener = t1;
    let t2;
    if ($[2] !== children || $[3] !== extraData || $[4] !== name || $[5] !== onRegisterIframeEventListener) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: name,
            onRegisterIframeEventListener: onRegisterIframeEventListener,
            extraData: extraData
        }, children);
        $[2] = children;
        $[3] = extraData;
        $[4] = name;
        $[5] = onRegisterIframeEventListener;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : function UFOThirdPartySegmentWithPerfTimeline({ children: children, name: name, extraData: extraData }) {
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    const onRegisterIframeEventListener = (0, $42omo.useCallback)((listener)=>{
        const timeline = timelineRef?.current;
        if (!timeline) return ()=>{};
        timeline.listeners.add(listener);
        return ()=>{
            timeline.listeners.delete(listener);
        };
    }, [
        timelineRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: name,
        onRegisterIframeEventListener: onRegisterIframeEventListener,
        extraData: extraData
    }, children);
};
function $e2fd6b5eb27bb420$var$_temp() {}
const $e2fd6b5eb27bb420$export$b89b612df1c715da = (props)=>{
    const { accountId: accountId, bridge: bridge, components: components, consentMessage: consentMessage, contextIds: contextIds, contextChangeListeners: contextChangeListeners, customBridgeMethods: customBridgeMethods, customBridge: customBridge, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, hasModalConsentPrompt: hasModalConsentPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, getContextToken: getContextToken, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: modalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onConsentInitialization: onConsentInitialization, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onInitialRender: onInitialRender, product: product, timezone: timezone, getModalWidth: getModalWidth, onModalExtensionClose: onModalExtensionClose, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId, isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI } = props;
    let cloudId;
    let workspaceId;
    if ('cloudId' in props) cloudId = props.cloudId;
    else if ('workspaceId' in props) workspaceId = props.workspaceId;
    const cloudOrWorkspaceId = cloudId ? {
        cloudId: cloudId
    } : {
        workspaceId: workspaceId
    };
    const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = extension;
    (0, $42omo.useEffect)(()=>{
        onInitialRender?.();
    }, [
        onInitialRender
    ]);
    const coreData = (0, $42omo.useMemo)(()=>({
            workspaceId: workspaceId,
            cloudId: cloudId,
            localId: localId || extensionId,
            environmentId: environmentId,
            environmentType: environmentType
        }), [
        cloudId,
        environmentId,
        environmentType,
        extensionId,
        localId,
        workspaceId
    ]);
    const getThreeLOPrompt = (0, $42omo.useCallback)(()=>({
            ThreeLOPrompt: modalExtension || hasModalConsentPrompt ? (0, $2Fl4v.makeModalThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                isBlanketHidden: true,
                onClose: onConsentModalClose
            }) : (0, $4ZTaE.makeThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                onSuccess: onConsentSuccess,
                message: consentMessage,
                onInitialization: onConsentInitialization
            })
        }), [
        extension.properties.title,
        consentMessage,
        hasModalConsentPrompt,
        modalExtension,
        onConsentSuccess,
        onConsentModalClose,
        onConsentInitialization
    ]);
    const customUIProps = {
        accountId: accountId,
        bridge: bridge,
        consentMessage: consentMessage,
        contextIds: contextIds,
        contextChangeListeners: contextChangeListeners,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        customBridge: customBridge,
        dialogs: dialogs,
        entryPoint: entryPoint,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        getThreeLOPrompt: getThreeLOPrompt,
        height: height,
        loadingComponent: loadingComponent,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        modalStyles: modalStyles,
        modalProvider: modalProvider,
        onConsentModalClose: onConsentModalClose,
        onConsentSuccess: onConsentSuccess,
        onError: onError,
        onForgeDocUpdated: onForgeDocUpdated,
        onIframeLoad: onIframeLoad,
        product: product,
        timezone: timezone,
        isIframeHidden: isIframeHidden,
        isIframeResizable: isIframeResizable,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    };
    const uiKitEmbeddedMacroProps = {
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    };
    const [viewOnClose, setViewOnClose] = (0, $42omo.useState)();
    // this function has known deps listed already in deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const FrameResizable = (0, $42omo.useCallback)((0, $acc8ad845a033cd1$export$1f1ebfe6da5b177c)((inputProps)=>{
        const { height: height, width: width, dispatch: dispatch } = inputProps;
        // If height or width is provided by app code, the iframe does not automatically resize to contents
        const isIframeResizable = height || width ? false : true;
        // A Frame resource is supplied at runtime by app code, so it supports the same
        // `<resourceKey>/<entryKey>` multi-entry convention as dynamic modal resources.
        const { resource: resource, resolvedResourceEntry: resolvedResourceEntry } = (0, $dh538.fg)('forge-ui-multi-entry-resource-macro-config-fix') ? (0, $37B9X.resolveDynamicResource)(inputProps.resource) : {
            resource: inputProps.resource,
            resolvedResourceEntry: inputProps.resolvedResourceEntry
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO2Re.CustomUIRenderer), {
            ...customUIProps,
            bridge: {
                ...customUIProps.bridge,
                getFrameDispatch: ()=>dispatch
            },
            extension: {
                ...extension,
                properties: {
                    ...extension.properties,
                    resource: resource,
                    ...(0, $dh538.fg)('forge-ui-multi-entry-resource') ? {
                        resolvedResourceEntry: resolvedResourceEntry
                    } : {}
                }
            },
            // Ensure extensions that are rendered as entryPoints aren't passing through the very same entryPoint to the Frame
            entryPoint: undefined,
            // Ensures Frame is always resized to the full height of the content
            // Required because Jira leaves isIframeResizable as false
            isIframeResizable: isIframeResizable,
            height: height,
            width: width
        });
    }), // need eslint here as re-render only depends on extensionData & extensionPayload
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customUIProps.extensionData,
        customUIProps.extensionPayload,
        extension
    ]);
    const ufoSegmentExtraData = (0, $42omo.useMemo)(()=>{
        const idParts = (0, $45DA9.extensionIdToAnalyticsAttributes)(props.extension.id);
        return {
            appType: (0, $iqcSr.isCustomUI)(props.extension, props.entryPoint) ? 'CustomUI' : 'UIKit',
            extensionKey: idParts?.extensionKey,
            appId: idParts?.appId ?? props.extension.appId,
            envId: idParts?.environmentId ?? props.extension.environmentId,
            envType: props.extension.environmentType,
            installationId: props.extension.installationId,
            moduleType: props.extension.type,
            appVersion: props.extension.appVersion
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.extension.id,
        props.extension.environmentId,
        props.extension.environmentType,
        props.extension.installationId,
        props.extension.type,
        props.extension.appVersion,
        props.entryPoint
    ]);
    // Derived at render time from the extension + feature gates. ForgeUIRenderer is an ancestor of
    // every runtime terminal (WorkerWebRuntime / InnerIframe v1/v2 via WebRuntime/Iframe), so this
    // single context tags all events fired below it — both renderer-level events (forge.ui.renderer,
    // forge.ui.extension/loaded) and the terminal bridge/app events. Keep getForgeRuntimeType in sync
    // with the gate decisions in WebRuntime and Iframe.
    const runtimeType = (0, $e59a0c07872a17e7$export$2faef82157961d5)(props.extension, props.entryPoint);
    if ((0, $dh538.fg)('platform_ufo_3p_segment_timings')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $HEA67.ForgeUIExtensionAnalyticsContext), {
        extensionId: props.extension.id,
        localId: props.localId || props.extension.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dQZ64.ForgeUIRuntimeAnalyticsContext), {
        runtime: runtimeType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eI4ye.PerformanceAnalyticsProviderRollout), {
        profileKey: `${props.extension.id}-${props.extension.key}-${props.entryPoint}`,
        appType: (0, $iqcSr.isCustomUI)(props.extension, props.entryPoint) ? 'CustomUI' : 'UIKit',
        forgeEnvironment: props.extension.environmentType,
        extensionType: props.extension.type,
        appVersion: props.extension.appVersion
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e2fd6b5eb27bb420$var$UFOThirdPartySegmentWithPerfTimeline, {
        name: "forge-ui-app-content-root",
        extraData: ufoSegmentExtraData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6ee5ed4b27f8132$export$4304f91d6e983d05), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c0Ac.UserAccessProvider), {
        accountId: accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        hidden: true,
        id: "forge-ui-renderer"
    }), !(0, $iqcSr.isCustomUI)(extension, entryPoint) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e892f186f061f3fc$export$9ca39743052e068e), {
        coreData: coreData,
        getThreeLOPrompt: getThreeLOPrompt,
        accountId: accountId,
        contextIds: contextIds,
        customBridge: customBridge,
        extension: extension,
        extensionData: extensionData,
        extensionViewData: extensionViewData,
        product: product,
        bridge: {
            // spread down here so product can override the default onClose
            ...modalExtension ? {
                onClose: (callback)=>{
                    if (extension.environmentType === 'PRODUCTION') {
                        // eslint-disable-next-line no-console
                        console.warn('Forge view.onClose (EAP) is not available for production apps. The callback will not be registered.');
                        return false;
                    }
                    setViewOnClose(()=>callback.data);
                    return true;
                }
            } : {},
            ...bridge
        },
        customBridgeMethods: customBridgeMethods,
        components: {
            Frame: FrameResizable,
            ...components
        },
        consentMessage: consentMessage,
        entryPoint: entryPoint,
        getContextToken: getContextToken,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        onConsentSuccess: onConsentSuccess,
        onForgeDocUpdated: onForgeDocUpdated,
        timezone: timezone,
        onConsentModalClose: onConsentModalClose,
        onError: onError,
        loadingComponent: loadingComponent,
        extensionPayload: extensionPayload,
        onSuccess: onSuccess,
        ...cloudOrWorkspaceId,
        onAppError: onAppError,
        viewportDimensions: viewportDimensions,
        viewOnClose: viewOnClose,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        contextChangeListeners: contextChangeListeners,
        ...uiKitEmbeddedMacroProps
    }) : modalExtension ? // getModalWidth not applied here since all modal extensions are defaulted to medium width
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO2Re.ModalCustomUIRenderer), {
        ...customUIProps,
        bridge: {
            ...modalExtension ? {
                onClose: (callback)=>{
                    if (extension.environmentType === 'PRODUCTION') {
                        // eslint-disable-next-line no-console
                        console.warn('Forge view.onClose is not available for production apps during EAP. The callback will not be registered.');
                        return false;
                    }
                    setViewOnClose(()=>callback.data);
                    // stores the callback for when modal is closed
                    return true;
                }
            } : {},
            // spread down here so product can override the default onClose
            ...customUIProps.bridge
        },
        modalOnClose: onModalExtensionClose,
        closeOnEscape: modalExtension?.shouldCloseOnEscapePress ?? true,
        closeOnOverlayClick: modalExtension?.shouldCloseOnOverlayClick ?? true,
        viewOnClose: viewOnClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO2Re.CustomUIRenderer), {
        ...customUIProps,
        getModalWidth: getModalWidth,
        width: width
    }))))))));
    // TODO: Delete after cleaning up 'platform_ufo_3p_segment_timings' flag
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $HEA67.ForgeUIExtensionAnalyticsContext), {
        extensionId: props.extension.id,
        localId: props.localId || props.extension.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dQZ64.ForgeUIRuntimeAnalyticsContext), {
        runtime: runtimeType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: "forge-ui-app-content-root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eI4ye.PerformanceAnalyticsProviderRollout), {
        profileKey: `${props.extension.id}-${props.extension.key}-${props.entryPoint}`,
        appType: (0, $iqcSr.isCustomUI)(props.extension, props.entryPoint) ? 'CustomUI' : 'UIKit',
        forgeEnvironment: props.extension.environmentType,
        extensionType: props.extension.type,
        appVersion: props.extension.appVersion
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6ee5ed4b27f8132$export$4304f91d6e983d05), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c0Ac.UserAccessProvider), {
        accountId: accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        hidden: true,
        id: "forge-ui-renderer"
    }), !(0, $iqcSr.isCustomUI)(extension, entryPoint) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e892f186f061f3fc$export$9ca39743052e068e), {
        coreData: coreData,
        getThreeLOPrompt: getThreeLOPrompt,
        accountId: accountId,
        contextIds: contextIds,
        extension: extension,
        extensionData: extensionData,
        extensionViewData: extensionViewData,
        product: product,
        bridge: {
            // spread down here so product can override the default onClose
            ...modalExtension ? {
                onClose: (callback)=>{
                    if (extension.environmentType === 'PRODUCTION') {
                        // eslint-disable-next-line no-console
                        console.warn('Forge view.onClose (EAP) is not available for production apps. The callback will not be registered.');
                        return false;
                    }
                    setViewOnClose(()=>callback.data);
                    return true;
                }
            } : {},
            ...bridge
        },
        customBridgeMethods: customBridgeMethods,
        customBridge: customBridge,
        components: {
            Frame: FrameResizable,
            ...components
        },
        consentMessage: consentMessage,
        entryPoint: entryPoint,
        getContextToken: getContextToken,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        onConsentSuccess: onConsentSuccess,
        onForgeDocUpdated: onForgeDocUpdated,
        timezone: timezone,
        onConsentModalClose: onConsentModalClose,
        onError: onError,
        loadingComponent: loadingComponent,
        extensionPayload: extensionPayload,
        onSuccess: onSuccess,
        ...cloudOrWorkspaceId,
        onAppError: onAppError,
        viewportDimensions: viewportDimensions,
        viewOnClose: viewOnClose,
        ...uiKitEmbeddedMacroProps,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        contextChangeListeners: contextChangeListeners
    }) : modalExtension ? // getModalWidth not applied here since all modal extensions are defaulted to medium width
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO2Re.ModalCustomUIRenderer), {
        ...customUIProps,
        bridge: {
            ...modalExtension ? {
                onClose: (callback)=>{
                    if (extension.environmentType === 'PRODUCTION') {
                        // eslint-disable-next-line no-console
                        console.warn('Forge view.onClose is not available for production apps during EAP. The callback will not be registered.');
                        return false;
                    }
                    setViewOnClose(()=>callback.data);
                    // stores the callback for when modal is closed
                    return true;
                }
            } : {},
            // spread down here so product can override the default onClose
            ...customUIProps.bridge
        },
        modalOnClose: onModalExtensionClose,
        closeOnEscape: modalExtension?.shouldCloseOnEscapePress ?? true,
        closeOnOverlayClick: modalExtension?.shouldCloseOnOverlayClick ?? true,
        viewOnClose: viewOnClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO2Re.CustomUIRenderer), {
        ...customUIProps,
        getModalWidth: getModalWidth,
        width: width
    }))))))));
};
module.exports["ForgeUIRenderer"] = $e2fd6b5eb27bb420$export$b89b612df1c715da;

});

parcelRegister("g7rOD", function(module, exports) {
/**
 * this function assume the inputs are not same object, and hence
 * it doesn't check for reference equality.
 *
 * Additionally, it check keys of the object and then check the values
 * for better performance.
 */ const $9678c1c47c1b0bc2$var$objectValuesAreEqual = (prev, next, valuesAreEqual)=>{
    const keys = Object.keys(prev);
    const length = keys.length;
    if (length !== Object.keys(next).length) return false;
    // there are two small optimization techniques used in this file:
    // 1. using decrementing for loop instead of incrementing for loop,
    //    to reduce 1 instruction per iteration.
    // 2. for object equality check, we check the key match first and then
    //    the value match. This is to identify the inequality as soon as possible.
    for(let i = length; i-- !== 0;){
        if (!(keys[i] in next)) return false;
    }
    for(let i = length; i-- !== 0;){
        const key = keys[i];
        if (!valuesAreEqual(prev[key], next[key])) return false;
    }
    return true;
};
/**
 * Some of the ideas are based on https://github.com/FormidableLabs/react-fast-compare
 */ const $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    else if (typeof prev === 'function' && typeof next === 'function') // if the function is a crossDomainFunctionWrapper (i.e. post-bot),
    // then we can check if the function is the same by looking at the
    // __id__ property.
    return prev.__id__ === next.__id__;
    else if (typeof prev === 'object' && typeof next === 'object') {
        if (prev.constructor !== next.constructor) return false;
        else if (Array.isArray(prev)) {
            const length = prev.length;
            if (length !== next.length) return false;
            for(let i = length; i-- !== 0;){
                if (!$9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual(prev[i], next[i])) return false;
            }
            return true;
        } else if (prev.valueOf !== Object.prototype.valueOf && typeof prev.valueOf === 'function' && typeof next.valueOf === 'function') return prev.valueOf() === next.valueOf();
        else if (prev.toString !== Object.prototype.toString && typeof prev.toString === 'function' && typeof next.toString === 'function') return prev.toString() === next.toString();
        return $9678c1c47c1b0bc2$var$objectValuesAreEqual(prev, next, $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual);
    }
    return false;
};
const $9678c1c47c1b0bc2$var$forgeDocPropsAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    return $9678c1c47c1b0bc2$var$objectValuesAreEqual(prev, next, $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual);
};
/**
 * the function is used to cache the hasChanged value in the ForgeDoc.
 * Please note, the cached result need to be stored in the next prop not the prev prop.
 * This is because react internally caches the props, and the cache become stale
 * at every render, if the calculation depends on the prev prop, the stale cache
 * will impact the accuracy of the result.
 */ const $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged = (nextDoc, hasChanged)=>{
    nextDoc.hasChanged = hasChanged;
    return !hasChanged;
};
const $9678c1c47c1b0bc2$var$forgeDocsAreEqual = (prev, next)=>{
    if (next.hasChanged !== undefined) return !next.hasChanged;
    else if (prev === next) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, false);
    else if (!prev || !next) return next ? $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true) : false;
    if (prev.type !== next.type || prev.key !== next.key) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
    else if (prev.children !== next.children) {
        if (prev.children?.length !== next.children?.length) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
        const length = prev.children?.length ?? 0;
        for(let i = length; i-- !== 0;){
            if (!$9678c1c47c1b0bc2$var$forgeDocsAreEqual(prev.children[i], next.children[i])) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
        }
    }
    return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, !$9678c1c47c1b0bc2$var$forgeDocPropsAreEqual(prev.props, next.props));
};
const $9678c1c47c1b0bc2$export$5d1c9ea31ee6a28f = (prev, next)=>$9678c1c47c1b0bc2$var$forgeDocsAreEqual(prev.forgeDoc, next.forgeDoc);
module.exports["forgePropsAreEqual"] = $9678c1c47c1b0bc2$export$5d1c9ea31ee6a28f;

});

parcelRegister("2Fl4v", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $i35rc = parcelRequire("i35rc");


var $iXCQx = parcelRequire("iXCQx");


const $65f5939ddad688eb$var$AKModalDialog = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eGvdC")));

const $65f5939ddad688eb$var$AKModalTransition = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eGvdC")).then((module)=>({
            default: module.ModalTransition
        })));

const $65f5939ddad688eb$var$AKModalHeader = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9ot3w"))));

const $65f5939ddad688eb$var$AKModalTitle = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("d8eRd"))));

const $65f5939ddad688eb$var$AKModalBody = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("1DHa6"))));

const $65f5939ddad688eb$var$AKModalFooter = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("8o1lj"))));

const $65f5939ddad688eb$var$AKButton = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1cCuI")));

const $65f5939ddad688eb$var$SectionMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hcdJZ")));
const $65f5939ddad688eb$var$ModalThreeLOPrompt = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    let isBlanketHidden;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ onClose: t1, isBlanketHidden: isBlanketHidden, ...props } = t0);
        $[0] = t0;
        $[1] = isBlanketHidden;
        $[2] = props;
        $[3] = t1;
    } else {
        isBlanketHidden = $[1];
        props = $[2];
        t1 = $[3];
    }
    const onClose = t1 === undefined ? $65f5939ddad688eb$var$_temp : t1;
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $i35rc.useAuth)(props);
    const { authUrl: authUrl } = props;
    const isAuthUrlEmpty = !authUrl || authUrl === "";
    const intl = (0, $aXWIB.useIntl)();
    let t2;
    if ($[4] !== intl || $[5] !== isAuthUrlEmpty || $[6] !== promptMessage) {
        t2 = isAuthUrlEmpty ? {
            modalTitle: intl.formatMessage($65f5939ddad688eb$var$messages.modalErrorTitle),
            modalBody: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$SectionMessage, {
                appearance: "error"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                as: "p"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $65f5939ddad688eb$var$messages.noAuthURLErrorMessage)))
        } : {
            modalTitle: intl.formatMessage($65f5939ddad688eb$var$messages.modalAccessRequiredTitle),
            modalBody: promptMessage
        };
        $[4] = intl;
        $[5] = isAuthUrlEmpty;
        $[6] = promptMessage;
        $[7] = t2;
    } else t2 = $[7];
    const { modalTitle: modalTitle, modalBody: modalBody } = t2;
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(true);
    let t3;
    if ($[8] !== buttonText || $[9] !== intl || $[10] !== isAuthUrlEmpty || $[11] !== isBlanketHidden || $[12] !== isModalOpen || $[13] !== loading || $[14] !== modalBody || $[15] !== modalTitle || $[16] !== onClose || $[17] !== startAuth) {
        t3 = isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalDialog, {
            onClose: ()=>{
                setIsModalOpen(false);
                onClose();
            },
            isBlanketHidden: isBlanketHidden
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalTitle, null, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalBody, null, modalBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKButton, {
            appearance: "subtle",
            onClick: ()=>{
                setIsModalOpen(false);
                onClose();
            }
        }, intl.formatMessage($65f5939ddad688eb$var$messages.cancelButtonLabel)), !isAuthUrlEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKButton, {
            appearance: "primary",
            autoFocus: true,
            isLoading: loading,
            onClick: startAuth
        }, buttonText)));
        $[8] = buttonText;
        $[9] = intl;
        $[10] = isAuthUrlEmpty;
        $[11] = isBlanketHidden;
        $[12] = isModalOpen;
        $[13] = loading;
        $[14] = modalBody;
        $[15] = modalTitle;
        $[16] = onClose;
        $[17] = startAuth;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalTransition, null, t3);
        $[19] = t3;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ onClose: onClose = ()=>{}, isBlanketHidden: isBlanketHidden, ...props })=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $i35rc.useAuth)(props);
    const { authUrl: authUrl } = props;
    const isAuthUrlEmpty = !authUrl || authUrl === '';
    const intl = (0, $aXWIB.useIntl)();
    const { modalTitle: modalTitle, modalBody: modalBody } = isAuthUrlEmpty ? {
        modalTitle: intl.formatMessage($65f5939ddad688eb$var$messages.modalErrorTitle),
        modalBody: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$SectionMessage, {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $65f5939ddad688eb$var$messages.noAuthURLErrorMessage)))
    } : {
        modalTitle: intl.formatMessage($65f5939ddad688eb$var$messages.modalAccessRequiredTitle),
        modalBody: promptMessage
    };
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalTransition, null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalDialog, {
        onClose: ()=>{
            setIsModalOpen(false);
            onClose();
        },
        isBlanketHidden: isBlanketHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalTitle, null, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalBody, null, modalBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKButton, {
        appearance: "subtle",
        onClick: ()=>{
            setIsModalOpen(false);
            onClose();
        }
    }, intl.formatMessage($65f5939ddad688eb$var$messages.cancelButtonLabel)), !isAuthUrlEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKButton, {
        appearance: "primary",
        autoFocus: true,
        isLoading: loading,
        onClick: startAuth
    }, buttonText))));
};
var $65f5939ddad688eb$export$2e2bcd8739ae039 = $65f5939ddad688eb$var$ModalThreeLOPrompt;
const $65f5939ddad688eb$export$ee02671eeeecd75 = ({ onClose: onClose, appName: appName })=>{
    return function modalThreeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$ModalThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            onSuccess: ()=>dispatch({
                    type: 'render',
                    extensionData: {}
                }),
            appName: appName,
            onClose: onClose
        });
    };
};
const $65f5939ddad688eb$export$85a504818a81117d = ({ onClose: onClose, appName: appName, isBlanketHidden: isBlanketHidden = false })=>{
    return (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$ModalThreeLOPrompt, {
            ...props,
            appName: appName,
            onClose: onClose,
            isBlanketHidden: isBlanketHidden
        });
    };
};
const $65f5939ddad688eb$var$messages = (0, $aXWIB.defineMessages)({
    noAuthURLErrorMessage: {
        id: "confluence.threeLOPrompt.modal.no.authURL.error-message",
        defaultMessage: "Consent URL not found. Please refresh the page and try again."
    },
    modalErrorTitle: {
        id: "confluence.threeLOPrompt.modal.error.title",
        defaultMessage: "Error"
    },
    modalAccessRequiredTitle: {
        id: "confluence.threeLOPrompt.modal.access.required.title",
        defaultMessage: "Access required"
    },
    cancelButtonLabel: {
        id: "forge-ui.threeLOPrompt.modal.cancel.button.label",
        defaultMessage: "Cancel"
    }
});
function $65f5939ddad688eb$var$_temp() {}
module.exports["makeModalThreeLOPrompt"] = $65f5939ddad688eb$export$ee02671eeeecd75;
module.exports["makeModalThreeLOPromptForCustomUI"] = $65f5939ddad688eb$export$85a504818a81117d;

});

parcelRegister("eGvdC", function(module, exports) {

let $ab0d344adaa80ec0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab0d344adaa80ec0$var$load("bf0yj").then(()=>parcelRequire('3yfJl'));

});

parcelRegister("1cCuI", function(module, exports) {

let $0e04c59be6084a94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0e04c59be6084a94$var$load("hhss7"),
    $0e04c59be6084a94$var$load("eMbal")
]).then(()=>parcelRequire('eAAnv'));

});

parcelRegister("HEA67", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $45DA9 = parcelRequire("45DA9");


var $7oKJR = parcelRequire("7oKJR");

const $5a707b7422677cdc$export$5c431bb5ef7d7900 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { extensionId: extensionId, localId: localId, children: children } = t0;
    (0, $7oKJR.setupContextKeysFromSessionStorage)();
    let t1;
    if ($[0] !== extensionId) {
        t1 = (0, $45DA9.extensionIdToAnalyticsAttributes)(extensionId);
        $[0] = extensionId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== localId || $[3] !== t1) {
        t2 = {
            forgeUIAttributes: {
                localId: localId,
                ...t1
            }
        };
        $[2] = localId;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ extensionId: extensionId, localId: localId, children: children })=>{
    (0, $7oKJR.setupContextKeysFromSessionStorage)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: {
            forgeUIAttributes: {
                localId: localId,
                ...(0, $45DA9.extensionIdToAnalyticsAttributes)(extensionId)
            }
        }
    }, children);
};
module.exports["ForgeUIExtensionAnalyticsContext"] = $5a707b7422677cdc$export$5c431bb5ef7d7900;

});

parcelRegister("45DA9", function(module, exports) {

var $7MEO5 = parcelRequire("7MEO5");

function $4b306a2ad8292411$export$d4650cd03b563908(extensionId) {
    if (!extensionId) return {};
    try {
        const ari = (0, $7MEO5.parse)(extensionId);
        if (!ari.resourceId) return {};
        const [appId, environmentId, groupId, extensionKey] = ari.resourceId.split('/');
        return {
            appId: appId,
            environmentId: environmentId,
            groupId: groupId,
            extensionKey: extensionKey
        };
    } catch  {
        return {};
    }
}
module.exports["extensionIdToAnalyticsAttributes"] = $4b306a2ad8292411$export$d4650cd03b563908;

});

parcelRegister("1JyKZ", function(module, exports) {
/**
 * @generated SignedSource<<4bede525d0687c753b663c93f3e819e2>>
 * @relayHash bfc43724fd2fc3a6f132a6d5f7e9da68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aebc4ac6f19efb4f09e20cf9c09e3afa223b9374353fd6d698d7b653144dd21f
const $dc4f7aee3cccfa96$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceForgeContextTokenPayload",
            "kind": "LinkedField",
            "name": "confluence_generateForgeContextToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceForgeContextToken",
                    "kind": "LinkedField",
                    "name": "forgeContextToken",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "jwt"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "expiresAt"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "extensionId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useGetContextTokenMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useGetContextTokenMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "bfc43724fd2fc3a6f132a6d5f7e9da68",
            "id": "aebc4ac6f19efb4f09e20cf9c09e3afa223b9374353fd6d698d7b653144dd21f",
            "metadata": {},
            "name": "useGetContextTokenMutation",
            "operationKind": "mutation",
            "text": "mutation useGetContextTokenMutation($cloudId:ID!,$input:ConfluenceForgeContextTokenRequestInput!){confluence_generateForgeContextToken(cloudId:$cloudId,input:$input){success,errors{message},forgeContextToken{jwt,expiresAt,extensionId}}}"
        }
    };
}();
$dc4f7aee3cccfa96$var$node.hash = "881cc660c7be5fb9164424934214d110";
var $dc4f7aee3cccfa96$export$2e2bcd8739ae039 = $dc4f7aee3cccfa96$var$node;



var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $8a9Dm = parcelRequire("8a9Dm");

var $765515c26d11d063$var$_ContextTokenCache;
class $765515c26d11d063$var$ContextTokenCache {
    static getInstance() {
        if (!$765515c26d11d063$var$ContextTokenCache.instance) $765515c26d11d063$var$ContextTokenCache.instance = new $765515c26d11d063$var$ContextTokenCache();
        return $765515c26d11d063$var$ContextTokenCache.instance;
    }
    get(key) {
        return this.promiseCache.get(key);
    }
    set(key, value) {
        this.promiseCache.set(key, value);
    }
    delete(key) {
        this.promiseCache.delete(key);
    }
    constructor(){
        this.promiseCache = void 0;
        this.promiseCache = new Map();
    }
}
$765515c26d11d063$var$_ContextTokenCache = $765515c26d11d063$var$ContextTokenCache;
$765515c26d11d063$var$ContextTokenCache.instance = void 0;
const $765515c26d11d063$var$EXTRA_BUFFER_MS = 30000; // extra 30 seconds buffer for clock skew
// GraphQL mutation to get context token
const $765515c26d11d063$var$UseGetContextTokenMutation = (0, $dc4f7aee3cccfa96$export$2e2bcd8739ae039);
const $765515c26d11d063$export$42cd66ed92f75ea0 = ({ extension: extension, extensionData: extensionData, localId: localId, contextIds: contextIds, cachingEnabled: cachingEnabled = false })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [runMutation] = (0, $308Wd.useMutationInterop)($765515c26d11d063$var$UseGetContextTokenMutation, {
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/forge-ui"
    });
    return (0, $42omo.useMemo)(()=>{
        const fetchTokenFromServer = async (effectiveContextIds, effectiveExtension, effectiveLocalId, cache, cacheKey)=>{
            try {
                // Build the input according to the schema
                const input = {
                    contextIds: effectiveContextIds,
                    extensionSpecificContexts: {
                        appVersion: effectiveExtension.appVersion ?? '',
                        context: {
                            appVersion: effectiveExtension.appVersion,
                            environmentId: effectiveExtension.environmentId,
                            environmentType: effectiveExtension.environmentType,
                            siteUrl: window?.location?.origin,
                            extension: {
                                location: undefined,
                                content: extensionData?.content ? {
                                    id: extensionData.content.id,
                                    type: extensionData.content.type,
                                    subtype: extensionData.content.subtype,
                                    version: extensionData.content?.version,
                                    ...(0, $9wGTI.fg)('forge-context-token-input-additional-parameters') && {
                                        status: extensionData.content.status
                                    }
                                } : undefined,
                                isEditing: extensionData?.isEditing,
                                macro: extensionData?.macro ? {
                                    isConfiguring: extensionData.macro.isConfiguring,
                                    isInserting: extensionData.macro.isInserting,
                                    layout: extensionData.macro.layout
                                } : undefined,
                                space: extensionData?.space ? {
                                    id: extensionData.space.id,
                                    key: extensionData.space.key
                                } : undefined,
                                ...extensionData?.template?.id && {
                                    template: {
                                        id: extensionData.template.id
                                    }
                                },
                                type: extensionData.type,
                                selectedText: extensionData?.selectedText
                            },
                            localId: effectiveLocalId,
                            moduleKey: (0, $8a9Dm.getModuleKey)(effectiveExtension),
                            ...(0, $9wGTI.fg)('forge-context-token-input-additional-parameters') && {
                                isConfig: extensionData?.isConfig,
                                spaceKey: extensionData?.space?.key,
                                contentId: extensionData?.content?.id,
                                type: extensionData.type,
                                content: extensionData?.content ? {
                                    id: extensionData.content.id,
                                    type: extensionData.content.type,
                                    subtype: extensionData.content.subtype,
                                    status: extensionData.content.status,
                                    version: extensionData.content.version
                                } : undefined,
                                space: extensionData?.space ? {
                                    id: extensionData.space.id,
                                    key: extensionData.space.key
                                } : undefined,
                                macro: effectiveExtension.properties?.body ? {
                                    body: JSON.stringify(effectiveExtension.properties.body)
                                } : null
                            }
                        },
                        extensionId: effectiveExtension.id,
                        extensionType: effectiveExtension.type,
                        installationId: effectiveExtension.installationId
                    }
                };
                const { data: data } = await runMutation({
                    variables: {
                        cloudId: cloudId,
                        input: input
                    }
                });
                if (!data?.confluence_generateForgeContextToken?.success) {
                    const errors = data?.confluence_generateForgeContextToken?.errors || [];
                    const errorMessage = errors.map((e)=>e.message).join(', ') || 'Unknown error';
                    throw new Error(`Token generation failed: ${errorMessage}`);
                }
                const forgeContextToken = data.confluence_generateForgeContextToken.forgeContextToken;
                if (!forgeContextToken?.jwt) throw new Error('No JWT token received from GraphQL endpoint');
                // Update cache with expiry info if available
                if (cachingEnabled) {
                    const cachedEntry = cache.get(cacheKey);
                    if (cachedEntry && forgeContextToken.expiresAt) cachedEntry.expiresAt = Number(forgeContextToken.expiresAt);
                }
                return forgeContextToken.jwt;
            } catch (error) {
                // Remove from cache on error so next call will retry
                if (cachingEnabled) cache.delete(cacheKey);
                throw new Error(`Failed to get context token: ${error.message}`);
            }
        };
        // Supports both contextIdsOverride and extensionOverride for embedded macros
        async function getForgeContextToken(options) {
            if (!cloudId) throw new Error('CloudId is required but not available');
            const { contextIdsOverride: contextIdsOverride, extensionOverride: extensionOverride } = options ?? {};
            // Use override values if provided (for embedded macros), otherwise use parent values
            const effectiveExtension_0 = extensionOverride?.extension ?? extension;
            const effectiveLocalId_0 = extensionOverride?.localId ?? localId;
            const effectiveContextIds_0 = contextIdsOverride ?? contextIds;
            const cacheKey_0 = JSON.stringify({
                id: effectiveLocalId_0 || effectiveExtension_0.id,
                data: extensionData,
                contextIds: effectiveContextIds_0
            });
            const cache_0 = $765515c26d11d063$var$ContextTokenCache.getInstance();
            const cached = cache_0.get(cacheKey_0);
            if (cachingEnabled) {
                if (cached) {
                    if (typeof cached.expiresAt !== 'number') return cached.promise;
                    if (Date.now() + $765515c26d11d063$var$EXTRA_BUFFER_MS < cached.expiresAt) return cached.promise;
                }
                const issuedAt = Date.now();
                const tokenPromise = fetchTokenFromServer(effectiveContextIds_0, effectiveExtension_0, effectiveLocalId_0, cache_0, cacheKey_0);
                cache_0.set(cacheKey_0, {
                    promise: tokenPromise,
                    expiresAt: undefined,
                    issuedAt: issuedAt
                });
                return tokenPromise;
            }
            return fetchTokenFromServer(effectiveContextIds_0, effectiveExtension_0, effectiveLocalId_0, cache_0, cacheKey_0);
        }
        return getForgeContextToken;
    }, [
        extension,
        extensionData,
        localId,
        cloudId,
        runMutation,
        contextIds,
        cachingEnabled
    ]);
};
module.exports["useGetContextToken"] = $765515c26d11d063$export$42cd66ed92f75ea0;

});

parcelRegister("aF5bm", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $bQm3c = parcelRequire("bQm3c");

const $3217b30f8fcccab4$export$c922e8420e7a46c9 = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $3217b30f8fcccab4$export$3c417c5065f4ac35 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== activationId || $[1] !== cloudId) {
        t0 = $3217b30f8fcccab4$export$c922e8420e7a46c9({
            cloudId: cloudId,
            activationId: activationId
        });
        $[0] = activationId;
        $[1] = cloudId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    return $3217b30f8fcccab4$export$c922e8420e7a46c9({
        cloudId: cloudId,
        activationId: activationId
    });
};
module.exports["getWorkspaceARI"] = $3217b30f8fcccab4$export$c922e8420e7a46c9;
module.exports["useWorkspaceARI"] = $3217b30f8fcccab4$export$3c417c5065f4ac35;

});

parcelRegister("iop2R", function(module, exports) {

var $dtVue = parcelRequire("dtVue");

const $73be7110bebeb936$export$6742408d91365687 = (cloudId, environment, userId)=>{
    return (0, $dtVue.createMentionsConfig)(cloudId, userId).then((config)=>config.mentionResource).catch((err)=>{
        if (environment !== 'PRODUCTION') // eslint-disable-next-line no-console
        console.error`Failed to initialise mention resource ${err}`;
        return Promise.reject();
    });
};
module.exports["getMentionProvider"] = $73be7110bebeb936$export$6742408d91365687;

});

parcelRegister("4jM0A", function(module, exports) {
function $a3329c10946e05c1$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}
module.exports["wrapWithUnsupported"] = $a3329c10946e05c1$export$87b732fa69cdf16e;

});

parcelRegister("bONsc", function(module, exports) {
/**
 * Expand a collapsed expand node by clicking its toggle button.
 *
 * This function finds the toggle button with aria-expanded="false" and programmatically
 * clicks it to expand the node. It does not wait for the expansion to complete.
 *
 * @param expandContainer - The expand container element.
 * @returns True if the toggle button was found and clicked, false otherwise.
 */ const $592aeb04efff58e8$export$280ec17414a50cdd = (expandContainer)=>{
    // Find and click the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded="false"]');
    if (toggleButton && toggleButton instanceof HTMLElement) {
        toggleButton.click();
        return true;
    }
    return false;
};
module.exports["expandElement"] = $592aeb04efff58e8$export$280ec17414a50cdd;

});

parcelRegister("czJBF", function(module, exports) {
/**
 * Check if an expand node is currently collapsed.
 *
 * Uses two methods to determine collapse state:
 * 1. First checks aria-expanded attribute on the toggle button (most reliable).
 * 2. Falls back to checking content div visibility via computed styles.
 *
 * @param expandContainer - The expand container element.
 * @returns True if the expand is collapsed, false if expanded or state cannot be determined.
 */ const $b351d41663ac6977$export$785b8bfd794fa7b6 = (expandContainer)=>{
    // Check for aria-expanded attribute on the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded]');
    if (toggleButton && toggleButton instanceof HTMLElement) return toggleButton.getAttribute('aria-expanded') === 'false';
    // Fallback: check if content div is hidden using the actual class name
    const contentDiv = expandContainer.querySelector('.ak-editor-expand__content');
    if (contentDiv && contentDiv instanceof HTMLElement) {
        const computedStyle = window.getComputedStyle(contentDiv);
        return computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || contentDiv.hidden;
    }
    return false;
};
module.exports["isExpandCollapsed"] = $b351d41663ac6977$export$785b8bfd794fa7b6;

});

parcelRegister("i0VQt", function(module, exports) {
const $7a472fadf16a5ff9$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
module.exports["shadowObserverClassNames"] = $7a472fadf16a5ff9$export$1cbe0bb16052178d;

});

parcelRegister("2jkq1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1zav4 = parcelRequire("1zav4");

var $9Fl9f = parcelRequire("9Fl9f");


var $2CQVV = parcelRequire("2CQVV");


var $frt7o = parcelRequire("frt7o");

var $bWRlG = parcelRequire("bWRlG");


var $dh538 = parcelRequire("dh538");


var $cN8vw = parcelRequire("cN8vw");

var $hyVjW = parcelRequire("hyVjW");

var $d4WtM = parcelRequire("d4WtM");

var $8l0kQ = parcelRequire("8l0kQ");


var $2QYOD = parcelRequire("2QYOD");


var $aFUXX = parcelRequire("aFUXX");


var $6fQl1 = parcelRequire("6fQl1");


var $iu6m9 = parcelRequire("iu6m9");


var $1zvWv = parcelRequire("1zvWv");


var $iKFPk = parcelRequire("iKFPk");


var $bZfVt = parcelRequire("bZfVt");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");











var $1oCLl = parcelRequire("1oCLl");



















/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $bBvs5 = parcelRequire("bBvs5");

const $a5ed469e3634fc57$export$90335b3ff08f335 = ()=>(0, $bBvs5.useRendererContext)()?.featureFlags;











// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $90b28d79aa634748$var$MAX_SCALING_PERCENT = 0.3;
const $90b28d79aa634748$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $90b28d79aa634748$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $90b28d79aa634748$var$fixColumnWidth = ({ columnWidth: columnWidth, zeroWidthColumnsCount: zeroWidthColumnsCount, scaleDownPercent: scaleDownPercent, skipMinWidth: skipMinWidth })=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) {
        const scaled = Math.floor((1 - scaleDownPercent) * columnWidth);
        return skipMinWidth ? scaled : Math.max(scaled, (0, $1zav4.tableCellMinWidth));
    }
    const adjusted = columnWidth - (0, $1zav4.tableCellBorderWidth);
    if (skipMinWidth) return adjusted;
    return Math.max(adjusted, zeroWidthColumnsCount ? (0, $aFUXX.akEditorTableLegacyCellMinWidth) : (0, $1zav4.tableCellMinWidth));
};
const $90b28d79aa634748$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $aFUXX.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $aFUXX.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $90b28d79aa634748$export$2d9bdaa5b8cd99f0 = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
/**
 * Returns the data-column available width: total width minus the fixed number column if enabled.
 */ const $90b28d79aa634748$var$getDataColumnWidth = (totalWidth, isNumberColumnEnabled)=>isNumberColumnEnabled ? totalWidth - (0, $aFUXX.akEditorTableNumberColumnWidth) : totalWidth;
/**
 * Scales column widths proportionally to fit within availableWidth, matching the editor's
 * scaleTableTo(): floors each column to the nearest pixel, then redistributes any rounding
 * remainder to the first column that can absorb it without going below tableCellMinWidth.
 */ const $90b28d79aa634748$var$scaleColumnsToWidth = (columnWidths, availableWidth)=>{
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    const scaleFactor = availableWidth / rawTotalWidth;
    const scaledWidths = columnWidths.map((colWidth)=>Math.max(Math.floor(colWidth * scaleFactor), (0, $1zav4.tableCellMinWidth)));
    const totalScaled = scaledWidths.reduce((sum, w)=>sum + w, 0);
    const diff = availableWidth - totalScaled;
    if (diff !== 0 && Math.abs(diff) < (0, $1zav4.tableCellMinWidth)) {
        for(let i = 0; i < scaledWidths.length; i++)if (scaledWidths[i] + diff > (0, $1zav4.tableCellMinWidth)) {
            scaledWidths[i] += diff;
            break;
        }
    }
    return scaledWidths.map((width)=>({
            width: `${width}px`
        }));
};
/**
 * Computes column widths for tables inside sync blocks, matching the editor's scaleTableTo() exactly.
 * Returns null if not inside a sync block.
 *
 * For nested tables (isInsideOfTable=true), we use getTableContainerWidth(tableNode) as the
 * reference — the width the editor saved, which already accounts for the parent cell's available
 * space (colwidth minus tableCellPadding * 2). This matches bodiedSyncBlock where isRendererNested=false,
 * so renderScaleDownColgroup uses getTableContainerWidth(tableNode). For syncBlock the nested
 * renderer has isRendererNested=true, which incorrectly overrides tableContainerWidth with renderWidth
 * (the full container), causing overflow by 2 * tableCellPadding (16px).
 */ const $90b28d79aa634748$var$renderSyncBlockColgroup = ({ isInsideOfSyncBlock: isInsideOfSyncBlock, isInsideOfTable: isInsideOfTable, tableNode: tableNode, columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidthProp, contextWidth: contextWidth })=>{
    if (!isInsideOfSyncBlock) return null;
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    if (isInsideOfTable) return null;
    // SSR / first client render before WidthObserver measures. Output % of original ADF
    // proportions so columns are stable — the CSS container query (100cqw) handles actual
    // scaling width. We key off renderWidthProp alone because WidthProvider initialises with
    // document.body.offsetWidth (non-zero on the client), so contextWidth > 0 even before
    // WidthObserver has measured the real container, which would skip this branch and produce
    // column widths scaled to the full viewport.
    if (renderWidthProp <= 0) {
        const fullTableWidth = isNumberColumnEnabled ? rawTotalWidth + (0, $aFUXX.akEditorTableNumberColumnWidth) : rawTotalWidth;
        return columnWidths.map((colWidth)=>({
                width: `${colWidth / fullTableWidth * 100}%`
            }));
    }
    // contextWidth measures the sync block content area. Subtract 2 to match the editor's
    // getParentNodeWidth() border offset. Fall back to renderWidthProp for the non-CSS path.
    const effectiveRenderWidth = contextWidth > 0 ? contextWidth - 2 : renderWidthProp;
    const availableWidth = $90b28d79aa634748$var$getDataColumnWidth(effectiveRenderWidth, isNumberColumnEnabled);
    // Only scale down if the table is actually wider than the available space.
    // If the table fits, return original widths with the same tableCellBorderWidth (2px) adjustment
    // that renderScaleDownColgroup applies via fixColumnWidth's no-scale path.
    if (availableWidth >= rawTotalWidth) return columnWidths.map((colWidth)=>({
            width: `${Math.max(colWidth - (0, $1zav4.tableCellBorderWidth), (0, $1zav4.tableCellMinWidth))}px`
        }));
    // Cap scaling at MAX_SCALING_PERCENT (30%), matching renderScaleDownColgroup's calcScalePercent.
    //
    // Both `availableWidth` and `rawTotalWidth` are already in data-column space (number column
    // excluded via getDataColumnWidth), so `diffPercent = 1 - availableWidth / rawTotalWidth` is
    // equivalent to calcScalePercent's `numColumnScalePercent` path when isNumberColumnEnabled,
    // and to the `noNumColumnScalePercent` path otherwise. We express the cap as a target width
    // (clampedAvailableWidth) rather than a scale-down percentage, but the result is the same:
    // columns are scaled by at most MAX_SCALING_PERCENT (30%).
    const diffPercent = 1 - availableWidth / rawTotalWidth;
    const clampedAvailableWidth = diffPercent <= $90b28d79aa634748$var$MAX_SCALING_PERCENT ? availableWidth : Math.floor(rawTotalWidth * (1 - $90b28d79aa634748$var$MAX_SCALING_PERCENT));
    return $90b28d79aa634748$var$scaleColumnsToWidth(columnWidths, clampedAvailableWidth);
};
const $90b28d79aa634748$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, isInsideOfSyncBlock: isInsideOfSyncBlock } = props;
    const skipMinWidth = !!(isInsideOfTable && isInsideOfSyncBlock);
    if (!columnWidths || columnWidths.every((width)=>width === 0) && (0, $dh538.fg)('platform_editor_numbered_column_in_include')) return [];
    const tableColumnResized = $90b28d79aa634748$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested && (!(0, $dh538.fg)('platform_fix_nested_num_column_scaling') || !isNumberColumnEnabled) ? renderWidth : (0, $6fQl1.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $90b28d79aa634748$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        const scalePercentage = +((calculatedTableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        const targetMaxWidth = calculatedTableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $1zav4.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $1zav4.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $aFUXX.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $aFUXX.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $90b28d79aa634748$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $90b28d79aa634748$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $aFUXX.akEditorTableLegacyCellMinWidth) ? (0, $aFUXX.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $90b28d79aa634748$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: (0, $dh538.fg)('platform-ssr-table-resize') ? maxScalingPercent : shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0)) {
        const fixedColWidths = targetWidths.map((width)=>$90b28d79aa634748$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent,
                skipMinWidth: skipMinWidth
            }) || cellMinWidth);
        const sumFixedColumnWidths = $90b28d79aa634748$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map((colWidth)=>{
            const width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $aFUXX.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: `${width / sumFixedColumnWidths * 100}%`
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                const style = width ? {
                    width: `${width}px`
                } : {};
                return style;
            }
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $90b28d79aa634748$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent,
            skipMinWidth: skipMinWidth
        }) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $90b28d79aa634748$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer, nestedRendererType: nestedRendererType } = (0, $bBvs5.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const { width: contextWidth } = (0, $42omo.useContext)((0, $bWRlG.WidthContext));
    const flags = (0, $a5ed469e3634fc57$export$90335b3ff08f335)();
    if (!columnWidths) return null;
    const isTableFixedColumnWidthsOptionEnabled = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? props.allowFixedColumnWidthOption : flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) ?? false;
    // For referenced sync blocks, nestedRendererType='syncedBlock' is set via RendererContextProvider
    // in AKRendererWrapper. ReactSerializer is a class and cannot read React context, so we detect
    // it here in the Colgroup component via useRendererContext() instead of prop-drilling.
    const isInsideOfSyncBlock = nestedRendererType === 'syncedBlock';
    // renderSyncBlockColgroup returns null when not applicable (flag off, SSR, not a sync block),
    // in which case ?? falls back to the standard renderScaleDownColgroup path.
    const colStyles = $90b28d79aa634748$var$renderSyncBlockColgroup({
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isInsideOfTable: !!props.isInsideOfTable,
        tableNode: props.tableNode,
        columnWidths: columnWidths,
        isNumberColumnEnabled: !!isNumberColumnEnabled,
        renderWidth: props.renderWidth,
        contextWidth: contextWidth
    }) ?? $90b28d79aa634748$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) || props.rendererAppearance === 'comment',
        isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)))
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("colgroup", null, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("col", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $aFUXX.akEditorTableNumberColumnWidth)
        },
        "data-test-id": 'num'
    }), colStyles.map((style, idx)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("col", {
            key: idx,
            style: style
        })));
};















var $ixUmr = parcelRequire("ixUmr");

const $25b30cdeab44ce04$export$e217d2a535d6ae45 = ({ allowTableResizing: allowTableResizing, rendererAppearance: rendererAppearance })=>{
    return !!allowTableResizing && (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max');
};


const $f71f60011122dddb$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption = false })=>{
    let tableWidth = tableNode ? (0, $6fQl1.getTableContainerWidth)(tableNode) : (0, $aFUXX.akEditorDefaultLayoutWidth);
    let tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $dh538.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') {
        if ((0, $dh538.fg)('platform-ssr-table-resize')) tableColumnWidths = columnWidths && (0, $90b28d79aa634748$export$2d9bdaa5b8cd99f0)(columnWidths) ? columnWidths : undefined;
    }
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    const isContentMode = (0, $ixUmr.isTableInContentMode)({
        tableNode: tableNode,
        isSupported: (0, $25b30cdeab44ce04$export$e217d2a535d6ae45)({
            allowTableResizing: allowTableResizing,
            rendererAppearance: rendererAppearance
        }),
        isTableNested: isInsideOfBlockNode || isInsideOfTable
    }) && (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("table", {
        ...(0, $dh538.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        "data-initial-width-mode": isContentMode ? 'content' : undefined,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90b28d79aa634748$export$89efc2d0ceeaa030), {
        columnWidths: tableColumnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        isInsideOfTable: isInsideOfTable,
        isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
        allowTableResizing: allowTableResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("tbody", null, children));
});





function $5b4b0ffc2cc8f5f6$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            children: $5b4b0ffc2cc8f5f6$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, propsToInject);
    });
}


function $a9ad1d399ee36b19$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a9ad1d399ee36b19$export$3de6413b528017ca = 8;
const $a9ad1d399ee36b19$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// increasing specificity to override external renderer wrapper styles targeting div[mode='stick']
const $a9ad1d399ee36b19$var$suppressExternalStickStylesOld = {
    name: "1uqt4xf",
    styles: "&.fixed-table-div-custom-table-resizing[mode='stick']{background:var(--ds-surface-overlay, #FFFFFF);}"
};
const $a9ad1d399ee36b19$var$suppressExternalStickStyles = {
    name: "1hdnnda",
    styles: "&.fixed-table-div-custom-table-resizing[mode='stick']{background:var(--ds-surface, #FFFFFF);}"
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $a9ad1d399ee36b19$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, #FFFFFF)"
        }
    },
    borderTop: `${$a9ad1d399ee36b19$export$3de6413b528017ca}px solid ${"var(--ds-surface, #FFFFFF)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    boxShadow: `0 6px 4px -4px ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $a9ad1d399ee36b19$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $aFUXX.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $a9ad1d399ee36b19$var$fixedTableDivStaticStyles,
            $a9ad1d399ee36b19$var$modeSpecficStyles?.[mode],
            (0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && ((0, $dh538.fg)('platform_editor_table_q4_patch_1') ? $a9ad1d399ee36b19$var$suppressExternalStickStyles : $a9ad1d399ee36b19$var$suppressExternalStickStylesOld)
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: typeof top === 'number' ? `${top}px` : undefined
        }
    }, props.children);
};
const $a9ad1d399ee36b19$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($a9ad1d399ee36b19$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f71f60011122dddb$export$54ec01a60f47d33d), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $5b4b0ffc2cc8f5f6$export$40e12ce8e0a76b0c)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $a9ad1d399ee36b19$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $a9ad1d399ee36b19$export$e97bc6692974bd0b {
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $a9ad1d399ee36b19$export$e97bc6692974bd0b($a9ad1d399ee36b19$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    addEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    removeEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
}



const $32a0d933940b97cc$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $32a0d933940b97cc$export$ab050440a1241762 = (appearance)=>appearance === 'max';
const $32a0d933940b97cc$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $32a0d933940b97cc$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $32a0d933940b97cc$export$33331a99fac775a1 = (appearance)=>$32a0d933940b97cc$export$a64737a81cde10b4(appearance) || $32a0d933940b97cc$export$c0112b8340d4924b(appearance) || $32a0d933940b97cc$export$ab050440a1241762(appearance);








class $f6f7c885cc4b0838$export$8c072780619cfc83 {
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        const scrollbarContainers = this.wrapper.parentElement?.querySelectorAll(`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @atlaskit/platform/valid-gate-name
        this.stickyScrollbarContainerElement = (0, $dh538.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers?.item(scrollbarContainers.length - 1) : this.wrapper.parentElement?.querySelector(`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/platform/valid-gate-name
        this.sentinels.bottom = (0, $dh538.fg)('platform_editor_querySelector_fix_table_renderer') ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        bottomSentinels?.item(bottomSentinels.length - 1) : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.wrapper?.parentElement?.getElementsByClassName((0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
    constructor(wrapper){
        this.wrapper = void 0;
        this.rendererScrollableElement = void 0;
        this.intersectionObserver = void 0;
        this.stickyScrollbarContainerElement = void 0;
        this.sentinels = {};
        this.topSentinelState = void 0;
        this.bottomSentinelState = void 0;
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
}


/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 

















var $jVL42 = parcelRequire("jVL42");




































const $24d26e13c81033f3$var$stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
const $24d26e13c81033f3$var$stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $24d26e13c81033f3$export$eec82c0a93aa66d9 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) || (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(appearance);
const $24d26e13c81033f3$export$bdb2dadcb04aad50 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) && (0, $iu6m9.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $24d26e13c81033f3$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $2QYOD.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $d4WtM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $hyVjW.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $24d26e13c81033f3$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $24d26e13c81033f3$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $24d26e13c81033f3$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $24d26e13c81033f3$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $24d26e13c81033f3$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $24d26e13c81033f3$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $iKFPk.TableHeader);
    return children.every((node)=>node.type === (0, $iKFPk.TableHeader));
};
const $24d26e13c81033f3$export$940095e914312886 = (node, children)=>{
    return $24d26e13c81033f3$export$28daf78feed5098c(children) && node && node.firstChild && !$24d26e13c81033f3$export$42f5658c8e0092da(node.firstChild);
};
/**
 * Fake left/right borders rendered as direct children of TABLE_CONTAINER
 * (the non-scrolling parent of the horizontally scrolling TABLE_NODE_WRAPPER).
 *
 * The visible styling for these divs lives in `tableFakeBorderStyles`
 * (`renderer/src/ui/Renderer/RendererStyleContainer.tsx`), which is itself
 * gated on `editorExperiment('platform_synced_block', true)` AND
 * `isInsideSyncBlock`.
 *
 * Shared between `renderer/src/react/nodes/table.tsx` and
 * `renderer/src/react/nodes/tableNew.tsx` so the two stay in sync.
 */ const $24d26e13c81033f3$var$TableFakeBorders = ({ isNumberColumnEnabled: isNumberColumnEnabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $9Fl9f.TableSharedCssClassName).TABLE_LEFT_BORDER,
        "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
        "data-testid": "table-left-border"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $9Fl9f.TableSharedCssClassName).TABLE_RIGHT_BORDER,
        "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
        "data-testid": "table-right-border"
    }));
const $24d26e13c81033f3$export$c8a6e9aeff774364 = ({ isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const { nestedRendererType: nestedRendererType } = (0, $bBvs5.useRendererContext)();
    const isInsideOfRefSyncBlock = nestedRendererType === 'syncedBlock';
    if (!isInsideOfRefSyncBlock || !(0, $iu6m9.editorExperiment)('platform_synced_block', true)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24d26e13c81033f3$var$TableFakeBorders, {
        isNumberColumnEnabled: isNumberColumnEnabled
    });
};
class $24d26e13c81033f3$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   * Checks if this table is inside a nested renderer (e.g. Include Page macro)
   * by looking for multiple .ak-renderer-document ancestors in the DOM.
   * The result is cached since a table's position in the DOM tree is stable after mount.
   */ isInsideNestedRenderer() {
        if (this._isInsideNestedRenderer !== null) return this._isInsideNestedRenderer;
        if (!this.containerRef) return false;
        let docAncestorCount = 0;
        let el = this.containerRef.parentElement;
        while(el){
            if (el.classList.contains((0, $jVL42.RendererCssClassName).DOCUMENT)) {
                docAncestorCount++;
                if (docAncestorCount >= 2) {
                    this._isInsideNestedRenderer = true;
                    return true;
                }
            }
            el = el.parentElement;
        }
        this._isInsideNestedRenderer = false;
        return false;
    }
    /**
   * Checks if this table is inside a table cell in the DOM. The result is cached
   * since a table's position in the DOM tree is stable after mount.
   */ isInsideTableCell() {
        if (this._isInsideTableCell !== null) return this._isInsideTableCell;
        if (!this.containerRef) return false;
        this._isInsideTableCell = Boolean(this.containerRef.closest('td, th'));
        return this._isInsideTableCell;
    }
    isInsideTableContext() {
        return Boolean(this.props.isInsideOfTable || this.isInsideTableCell());
    }
    /**
   * For tables inside nested renderers (e.g. Include Page macro), the parent
   * renderer's CSS override forces width:100%!important and left:0!important
   * which overrides the inline styles set by this component. Using
   * style.setProperty with 'important' priority on inline styles beats
   * stylesheet !important rules per the CSS cascade.
   *
   * Tables that are nested inside another table need to remain constrained by
   * their table-cell context. Do not promote their width to inline !important,
   * otherwise nested tables rendered through macros such as Excerpt Include can
   * overflow and overlap adjacent cells.
   *
   * Top-level tables in nested renderers still preserve their saved width, but
   * are capped to their containing block so wide tables do not escape constrained
   * macro bodies such as Excerpt Include panels.
   *
   * Uses lastComputedStyle (populated during render) rather than reading from
   * element.style, because React may remove properties from the DOM when their
   * values transition to undefined between renders.
   */ applyNestedRendererTableFix() {
        if (!this.containerRef || !(0, $dh538.fg)('platform_nested_table_style_override')) return;
        if (!this.isInsideNestedRenderer() || this.isInsideTableContext()) return;
        const { width: width, left: left, marginLeft: marginLeft } = this.lastComputedStyle;
        const style = this.containerRef.style;
        style.setProperty('width', width || 'auto', 'important');
        style.setProperty('max-width', '100%', 'important');
        style.setProperty('left', left || 'auto', 'important');
        style.setProperty('margin-left', marginLeft || '0', 'important');
    }
    /**
   * Starts observing table dimensions and wires sticky header/scrollbar behavior after mount.
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $f6f7c885cc4b0838$export$8c072780619cfc83)(this.wrapperRef.current);
        this.applyNestedRendererTableFix();
    }
    /**
   * Updates sticky header wiring and scroll synchronization after prop or state changes.
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
        // React re-applies the style prop on every render, which overwrites the
        // !important priorities set at mount time. Re-apply after each update.
        this.applyNestedRendererTableFix();
    }
    /**
   * Calculates the top offset used when the sticky header is pinned to the table bottom.
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $1zav4.tableMarginTop) - (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
    }
    /**
   * Determines whether sticky header positioning should include the default scroll root offset.
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   * Resolves the top position for the sticky header based on the current sticky mode.
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   * Renders the table container, sticky header, table content, sticky scrollbar, and synced block borders.
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $aFUXX.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const fullPageRendererWidthCSS = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $1zvWv.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'max' && !tableNode?.attrs.width && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) return `min(${0, $aFUXX.akEditorMaxWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return `min(${0, $aFUXX.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLengthCSS = `min(${(0, $aFUXX.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $32a0d933940b97cc$export$ab050440a1241762)(rendererAppearance) && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $6fQl1.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) || (0, $32a0d933940b97cc$export$ab050440a1241762)(rendererAppearance) && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $aFUXX.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const isContentModeTable = (0, $ixUmr.isTableInContentMode)({
            tableNode: tableNode,
            isSupported: (0, $25b30cdeab44ce04$export$e217d2a535d6ae45)({
                allowTableResizing: allowTableResizing,
                rendererAppearance: rendererAppearance
            }),
            isTableNested: isInsideOfBlockNode || isInsideOfTable
        }) && (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
        const style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': renderWidthCSS
            },
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        // Store computed style values for applyNestedRendererTableFix() to use.
        // Reading from props rather than the DOM ensures correctness when React
        // removes properties (transitions from set to undefined) between renders.
        this.lastComputedStyle = {
            width: typeof style.width === 'number' ? `${style.width}px` : style.width,
            left: style.left,
            marginLeft: style.marginLeft
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            "data-testid": "table-container",
            ref: this.setContainerRef,
            style: style
        }, $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
            "data-testid": "sticky-scrollbar-sentinel-top"
        }), stickyHeaders && tableNode && !isContentModeTable && $24d26e13c81033f3$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9ad1d399ee36b19$export$fd9654fc359d55a3), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: "inherit",
            renderWidth: 0,
            layout: layout,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            allowTableResizing: allowTableResizing,
            fixTableSSRResizing: true,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER,
            ref: this.wrapperRef,
            "data-number-column": tableNode?.attrs.isNumberColumnEnabled,
            "data-layout": tableNode?.attrs.layout,
            "data-autosize": tableNode?.attrs.__autoSize,
            "data-table-local-id": tableNode?.attrs.localId,
            "data-table-width": tableNode?.attrs.width,
            "data-vc": "table-node-wrapper",
            onScroll: this.props.stickyHeaders && this.onWrapperScrolled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f71f60011122dddb$export$54ec01a60f47d33d), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            renderWidth: 0,
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing,
            isPresentational: isPresentational,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, this.grabFirstRowRef(children))), $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}${(0, $dh538.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''}`,
            ref: this.stickyScrollbarRef,
            "data-vc": "table-sticky-scrollbar-container",
            style: (0, $dh538.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? {
                ...$24d26e13c81033f3$var$stickyContainerBaseStyles,
                ...$24d26e13c81033f3$var$stickyContainerAdditionalStyles
            } : $24d26e13c81033f3$var$stickyContainerBaseStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                width: (0, $dh538.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : this.tableRef.current?.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            }
        })), $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
            "data-testid": "sticky-scrollbar-sentinel-bottom"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24d26e13c81033f3$export$c8a6e9aeff774364, {
            isNumberColumnEnabled: isNumberColumnEnabled
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        };
        this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbar = void 0;
        this.nextFrame = void 0;
        this.overflowParent = null;
        this.updatedLayout = 'custom';
        this.containerRef = null;
        this._isInsideNestedRenderer = null;
        this._isInsideTableCell = null;
        // Stores the last computed style values from render() for use by applyNestedRendererTableFix().
        // This avoids reading from the DOM which can be stale when React removes properties between renders.
        this.lastComputedStyle = {};
        this.resizeObserver = null;
        this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        };
        /**
     * Callback ref that captures the container DOM element and also forwards
     * to the handleRef prop from the overflow shadow HOC.
     */ this.setContainerRef = (el)=>{
            if (this.containerRef !== el) {
                this._isInsideNestedRenderer = null;
                this._isInsideTableCell = null;
            }
            this.containerRef = el;
            const { handleRef: handleRef } = this.props;
            if (typeof handleRef === 'function') handleRef(el);
            else if (handleRef && typeof handleRef === 'object') // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            handleRef.current = el;
        };
        this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        };
        this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        };
        this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
            const tableTop = $24d26e13c81033f3$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $24d26e13c81033f3$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $24d26e13c81033f3$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        };
        this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        };
        this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        };
        this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
const $24d26e13c81033f3$var$getCellEdgePropsByCellOffset = (tableNode, isNumberColumnEnabled)=>{
    const cellEdgePropsByCellOffset = new Map();
    const cellRightByCellOffset = new Map();
    const occupiedGrid = [];
    let tableWidth = 0;
    let cellOffset = 0;
    tableNode.forEach((rowNode, _rowOffset, rowIndex)=>{
        occupiedGrid[rowIndex] = occupiedGrid[rowIndex] ?? [];
        let columnIndex = 0;
        cellOffset += 1;
        rowNode.forEach((cellNode)=>{
            while(occupiedGrid[rowIndex][columnIndex])columnIndex += 1;
            const colspan = cellNode.attrs.colspan || 1;
            const rowspan = cellNode.attrs.rowspan || 1;
            const cellLeft = columnIndex;
            const cellRight = cellLeft + colspan;
            const cellTop = rowIndex;
            const cellBottom = cellTop + rowspan;
            for(let row = cellTop; row < cellBottom; row += 1){
                occupiedGrid[row] = occupiedGrid[row] ?? [];
                for(let column = cellLeft; column < cellRight; column += 1)occupiedGrid[row][column] = true;
            }
            tableWidth = Math.max(tableWidth, cellRight);
            cellRightByCellOffset.set(cellOffset, cellRight);
            cellEdgePropsByCellOffset.set(cellOffset, {
                reachesBottom: cellBottom >= tableNode.childCount,
                // With number column enabled, PM column 0 is not visually leftmost and must not get `data-reaches-left`.
                reachesLeft: cellLeft === 0 && !isNumberColumnEnabled,
                reachesRight: false,
                reachesTop: cellTop === 0
            });
            columnIndex = cellRight;
            cellOffset += cellNode.nodeSize;
        });
        cellOffset += 1;
    });
    cellRightByCellOffset.forEach((cellRight, currentCellOffset)=>{
        const edgeProps = cellEdgePropsByCellOffset.get(currentCellOffset);
        if (edgeProps) edgeProps.reachesRight = cellRight >= tableWidth;
    });
    return cellEdgePropsByCellOffset;
};
const $24d26e13c81033f3$var$addTableCellEdgeProps = (rows, tableNode, isNumberColumnEnabled)=>{
    try {
        if (!tableNode) return rows;
        const cellEdgePropsByCellOffset = $24d26e13c81033f3$var$getCellEdgePropsByCellOffset(tableNode, isNumberColumnEnabled);
        let cellOffset = 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, rowIndex)=>{
            const rowNode = tableNode.child(rowIndex);
            cellOffset += 1;
            let cellIndex = 0;
            const rowChildren = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(row.props.children, (child)=>{
                if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return child;
                const cellNode = rowNode.child(cellIndex);
                const edgeProps = cellEdgePropsByCellOffset.get(cellOffset);
                cellIndex += 1;
                cellOffset += cellNode.nodeSize;
                return edgeProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, edgeProps) : child;
            });
            cellOffset += 1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(row, undefined, rowChildren);
        });
    } catch  {
        // Renderer can receive malformed historical ADF. If the table shape cannot
        // be described safely, keep rendering without rounded edge metadata.
        return rows;
    }
};
class $24d26e13c81033f3$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   * Renders processed table children inside the table container.
   *
   * @example
   */ render() {
        const { allowColumnSorting: allowColumnSorting, allowFixedColumnWidthOption: allowFixedColumnWidthOption, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, children: children, columnWidths: columnWidths, disableTableOverflowShadow: disableTableOverflowShadow, handleRef: handleRef, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isNumberColumnEnabled: isNumberColumnEnabled, isPresentational: isPresentational, layout: layout, rendererAppearance: rendererAppearance, renderWidth: renderWidth, shadowClassNames: shadowClassNames, smartCardStorage: smartCardStorage, stickyHeaders: stickyHeaders, tabIndex: tabIndex, tableNode: tableNode } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children);
        const childrenWithTableEdgeProps = (0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $24d26e13c81033f3$var$addTableCellEdgeProps(childrenArray, tableNode, isNumberColumnEnabled) : childrenArray;
        const orderedChildren = (0, $cN8vw.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenWithTableEdgeProps);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24d26e13c81033f3$export$f2c3aea42b2a048f, {
            allowColumnSorting: allowColumnSorting,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
            allowTableAlignment: allowTableAlignment,
            allowTableResizing: allowTableResizing,
            columnWidths: columnWidths,
            disableTableOverflowShadow: disableTableOverflowShadow,
            handleRef: handleRef,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isNumberColumnEnabled: isNumberColumnEnabled,
            isPresentational: isPresentational,
            layout: layout,
            rendererAppearance: rendererAppearance,
            renderWidth: renderWidth,
            shadowClassNames: shadowClassNames,
            smartCardStorage: smartCardStorage,
            stickyHeaders: stickyHeaders,
            tabIndex: tabIndex,
            tableNode: tableNode
        }, orderedChildren);
    }
    constructor(...args){
        super(...args);
        this.state = {
            tableOrderStatus: undefined
        };
        // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $24d26e13c81033f3$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $8l0kQ.hasMergedCell)(tableNode)) return $24d26e13c81033f3$export$100baa0f10804e6e($24d26e13c81033f3$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        };
        this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $24d26e13c81033f3$export$28daf78feed5098c(rows);
            const lastRowIndex = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(rows) - 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1,
                    isFirstRow: index === 0,
                    isLastRow: index === lastRowIndex
                });
            });
        };
    }
}









const $8cb6dda2f8b04521$export$eec82c0a93aa66d9 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) || (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(appearance);
const $8cb6dda2f8b04521$export$bdb2dadcb04aad50 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) && (0, $iu6m9.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $8cb6dda2f8b04521$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $2QYOD.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $d4WtM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $hyVjW.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $8cb6dda2f8b04521$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $8cb6dda2f8b04521$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $8cb6dda2f8b04521$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $8cb6dda2f8b04521$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $8cb6dda2f8b04521$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $8cb6dda2f8b04521$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $iKFPk.TableHeader);
    return children.every((node)=>node.type === (0, $iKFPk.TableHeader));
};
/**
 * This TableWrapper component was created to make sure that the aria-label can be
 * internationalized without needing to add `intl` to the TableContainer.
 *
 * <TableWrapper wrapperRef={ref} onScroll={handleScroll} stickyHeaders={config}>
 *   <Table>...</Table>
 * </TableWrapper>
 */ const $8cb6dda2f8b04521$var$TableWrapper = ({ children: children, wrapperRef: wrapperRef, onScroll: onScroll, stickyHeaders: stickyHeaders, tabIndex: tabIndex })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isScrollableRegion = tabIndex !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER,
        ref: wrapperRef,
        onScroll: stickyHeaders ? onScroll : undefined,
        // Adding tabIndex here because this is a scrollable container and it needs to be focusable so keyboard users can scroll it.
        // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
        tabIndex: tabIndex,
        role: isScrollableRegion ? 'region' : undefined,
        "aria-label": isScrollableRegion ? formatMessage((0, $2CQVV.messages).tableScrollRegion) : undefined
    }, children);
};
const $8cb6dda2f8b04521$export$940095e914312886 = (node, children)=>{
    return $8cb6dda2f8b04521$export$28daf78feed5098c(children) && node && node.firstChild && !$8cb6dda2f8b04521$export$42f5658c8e0092da(node.firstChild);
};
class $8cb6dda2f8b04521$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $f6f7c885cc4b0838$export$8c072780619cfc83)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $1zav4.tableMarginTop) - (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $aFUXX.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const fullPageRendererWidthCSS = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $1zvWv.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $aFUXX.akEditorFullWidthLayoutWidth), renderWidth) : (0, $aFUXX.akEditorFullWidthLayoutWidth),
                `min(${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'max' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $aFUXX.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $aFUXX.akEditorMaxWidthLayoutWidth),
                `min(${(0, $aFUXX.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $aFUXX.akEditorFullWidthLayoutWidth), renderWidth) : (0, $aFUXX.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLength = isRenderWidthValid ? Math.min((0, $aFUXX.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $aFUXX.akEditorMaxWidthLayoutWidth);
        const maxWidthLineLengthCSS = `min(${(0, $aFUXX.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLength : (0, $32a0d933940b97cc$export$ab050440a1241762)(rendererAppearance) && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $32a0d933940b97cc$export$ab050440a1241762)(rendererAppearance) && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $6fQl1.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) || ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && (0, $32a0d933940b97cc$export$ab050440a1241762)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $aFUXX.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        const isContentModeTable = (0, $ixUmr.isTableInContentMode)({
            tableNode: tableNode,
            isSupported: (0, $25b30cdeab44ce04$export$e217d2a535d6ae45)({
                allowTableResizing: allowTableResizing,
                rendererAppearance: rendererAppearance
            }),
            isTableNested: isInsideOfBlockNode || isInsideOfTable
        }) && (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
        let style;
        if (fixTableSSRResizing) style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': renderWidthCSS
            },
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': `${renderWidth}px`
            },
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            ref: this.props.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
            "data-testid": "sticky-scrollbar-sentinel-top"
        }), stickyHeaders && $8cb6dda2f8b04521$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9ad1d399ee36b19$export$fd9654fc359d55a3), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: tableWidth,
            layout: layout,
            renderWidth: renderWidth,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            allowTableResizing: allowTableResizing,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8cb6dda2f8b04521$var$TableWrapper, {
            wrapperRef: this.wrapperRef,
            onScroll: this.props.stickyHeaders ? this.onWrapperScrolled : undefined,
            stickyHeaders: stickyHeaders,
            tabIndex: this.props.tabIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f71f60011122dddb$export$54ec01a60f47d33d), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing,
            isPresentational: isPresentational,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, this.grabFirstRowRef(children))), $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
            ref: this.stickyScrollbarRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)",
                // MAX_BROWSER_SCROLLBAR_HEIGHT
                // Follow editor to hide by default so it does not show empty gap in SSR
                // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: fixTableSSRResizing ? 'none' : 'block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                width: '100%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                width: this.tableRef.current?.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            }
        })), $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $9Fl9f.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
            "data-testid": "sticky-scrollbar-sentinel-bottom"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $24d26e13c81033f3$export$c8a6e9aeff774364), {
            isNumberColumnEnabled: isNumberColumnEnabled
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        };
        this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbar = void 0;
        this.nextFrame = void 0;
        this.overflowParent = null;
        this.resizeObserver = null;
        this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        };
        this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        };
        this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        };
        this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
            const tableTop = $8cb6dda2f8b04521$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $8cb6dda2f8b04521$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $8cb6dda2f8b04521$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        };
        this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        };
        this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        };
        this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $8cb6dda2f8b04521$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children);
        const orderedChildren = (0, $cN8vw.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8cb6dda2f8b04521$export$f2c3aea42b2a048f, this.props, orderedChildren);
    }
    constructor(...args){
        super(...args);
        this.state = {
            tableOrderStatus: undefined
        };
        // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $8cb6dda2f8b04521$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $8l0kQ.hasMergedCell)(tableNode)) return $8cb6dda2f8b04521$export$100baa0f10804e6e($8cb6dda2f8b04521$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        };
        this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $8cb6dda2f8b04521$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cb6dda2f8b04521$var$TableWithShadowsAndContainerStyles = (0, $frt7o.default)((0, $24d26e13c81033f3$export$827f89182557f335), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cb6dda2f8b04521$var$TableWithShadows = (0, $frt7o.default)($8cb6dda2f8b04521$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $9Fl9f.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $8cb6dda2f8b04521$var$TableWithWidth = (props)=>{
    if ((0, $dh538.fg)('platform-ssr-table-resize')) {
        const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8cb6dda2f8b04521$var$TableWithShadowsAndContainerStyles, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $24d26e13c81033f3$export$827f89182557f335), props);
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bWRlG.WidthConsumer), null, ({ width: width })=>{
        const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $1zvWv.FullPagePadding) * 2 : width;
        const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8cb6dda2f8b04521$var$TableWithShadows, {
            renderWidth: renderWidth,
            ...props
        });
        // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8cb6dda2f8b04521$export$91e0997fd3f75d56, {
            renderWidth: renderWidth,
            ...props
        });
    });
};
const $8cb6dda2f8b04521$var$_default_1 = (0, $bZfVt.withSmartCardStorage)($8cb6dda2f8b04521$var$TableWithWidth);
var $8cb6dda2f8b04521$export$2e2bcd8739ae039 = $8cb6dda2f8b04521$var$_default_1;
module.exports["isTableResizingEnabled"] = $8cb6dda2f8b04521$export$eec82c0a93aa66d9;
module.exports["isStickyScrollbarEnabled"] = $8cb6dda2f8b04521$export$bdb2dadcb04aad50;
module.exports["default"] = $8cb6dda2f8b04521$export$2e2bcd8739ae039;

});

parcelRegister("c7dWI", function(module, exports) {
/**
 * Timing constants for expand animation and DOM update delays.
 * These values are tuned for the expand component's behavior and React's update cycle.
 */ const $d18eb7b2cc591b79$export$7f8747c9df4cadcb = {
    /** Minimal delay for DOM/React updates after expanding (no animation in expand component). */ DOM_UPDATE_DELAY: 50,
    /** Delay when expand operation fails and needs retry. */ RETRY_DELAY: 100,
    /** Maximum number of retry attempts before giving up and scrolling anyway. */ MAX_ATTEMPTS: 5,
    /** Maximum depth of nested expands to search (prevents infinite loops). */ MAX_EXPAND_DEPTH: 2
};
module.exports["SCROLL_TO_BLOCK_TIMING"] = $d18eb7b2cc591b79$export$7f8747c9df4cadcb;

});

parcelRegister("iNqGB", function(module, exports) {
function $44e243c4cf2c5688$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $44e243c4cf2c5688$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$44e243c4cf2c5688$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}
module.exports["isNestedHeaderLinksEnabled"] = $44e243c4cf2c5688$export$7aa7587d1ce9583c;
module.exports["getActiveHeadingId"] = $44e243c4cf2c5688$export$acb253d79d72af92;

});

parcelRegister("GH4gU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lwZHY = parcelRequire("lwZHY");


var $7Rcde = parcelRequire("7Rcde");

const $37d44366a8af079c$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $37d44366a8af079c$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $7Rcde.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lwZHY.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes
    }, props.children);
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $37d44366a8af079c$var$_default_1 = (0, $aXWIB.injectIntl)($37d44366a8af079c$export$7cea6ffa7022e85f);
var $37d44366a8af079c$export$2e2bcd8739ae039 = $37d44366a8af079c$var$_default_1;
module.exports["isCodeMark"] = $37d44366a8af079c$export$86390c02c110ec2f;
module.exports["default"] = $37d44366a8af079c$export$2e2bcd8739ae039;

});

parcelRegister("hMQQ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaea92635c0e0d50$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $eaea92635c0e0d50$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("em", props.dataAttributes, props.children);
}

});

parcelRegister("g5cj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a08d476a56fd0b1$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $9JpPs = parcelRequire("9JpPs");


var $b7FrM = parcelRequire("b7FrM");


var $59U23 = parcelRequire("59U23");


var $d925B = parcelRequire("d925B");


var $1oCLl = parcelRequire("1oCLl");


var $bYRk6 = parcelRequire("bYRk6");

/* link-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Compiled branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `link.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 



var $gMc0m = parcelRequire("gMc0m");


var $hn4RR = parcelRequire("hn4RR");

const $2ee48106daa7207a$var$anchorStyles = null;
const $2ee48106daa7207a$export$10ae7cf734c9da69 = (props)=>/*#__PURE__*/ $42omo.createElement((0, $hn4RR.default), {
        ...props,
        className: (0, $gMc0m.default)([
            "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
        ])
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `link.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $9K4OG = parcelRequire("9K4OG");




function $45afe941ea675551$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $45afe941ea675551$var$anchorStyles = {
    name: "sa5fy1",
    styles: "color:var(--ds-link, #1868DB);&:hover{color:var(--ds-link, #1868DB);text-decoration:underline;}&:active{color:var(--ds-link-pressed, #1558BC);}"
};
const $45afe941ea675551$export$bcc8540ceca8fa1c = (props)=>// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hn4RR.default), {
        css: $45afe941ea675551$var$anchorStyles,
        ...props
    });


const $0a08d476a56fd0b1$var$LinkUrlMigration = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_renderer_static_css', 'isEnabled', true), (0, $2ee48106daa7207a$export$10ae7cf734c9da69), (0, $45afe941ea675551$export$bcc8540ceca8fa1c));
function $0a08d476a56fd0b1$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, onSetLinkTarget: onSetLinkTarget, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    let actualTarget = target;
    if (onSetLinkTarget && href) try {
        actualTarget = onSetLinkTarget(href) ?? actualTarget;
    } catch (error) {
    // eslint-disable-line no-unused-vars
    // If URL parsing fails, use the original target
    }
    const anchorProps = {
        href: href,
        target: actualTarget,
        title: href
    };
    if (actualTarget === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $b7FrM.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a08d476a56fd0b1$var$LinkUrlMigration, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $d925B.ACTION).VISITED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).LINK,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    mode: (0, $59U23.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        isLinkComponent: true,
        enableResolve: true
    }, props.children));
}

});

parcelRegister("jyYl7", function(module, exports) {
$parcel$export(module.exports, "default", () => $91cd5902b10cc40d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $91cd5902b10cc40d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        }
    }, props.children);
}

});

parcelRegister("cHFH7", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfc5c059d1a31794$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $dfc5c059d1a31794$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("strong", props.dataAttributes, props.children);
}

});

parcelRegister("2KFEz", function(module, exports) {
$parcel$export(module.exports, "default", () => $5be0c346e0e6a7c7$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

const $5be0c346e0e6a7c7$var$isSub = (type)=>{
    return type === 'sub';
};
function $5be0c346e0e6a7c7$export$2e2bcd8739ae039(props) {
    if ($5be0c346e0e6a7c7$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("sub", props.dataAttributes, props.children);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("sup", props.dataAttributes, props.children);
}

});

parcelRegister("6wVZ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $e65feb0aaa1b4075$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $aDU6C = parcelRequire("aDU6C");


var $iS6Uy = parcelRequire("iS6Uy");


var $cOrQJ = parcelRequire("cOrQJ");

function $e65feb0aaa1b4075$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $iS6Uy.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $iS6Uy.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $aDU6C.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $42omo.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});

parcelRegister("4XjCW", function(module, exports) {
$parcel$export(module.exports, "default", () => $477b09df0a03f691$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $aDU6C = parcelRequire("aDU6C");


var $bWiTS = parcelRequire("bWiTS");


var $cOrQJ = parcelRequire("cOrQJ");

function $477b09df0a03f691$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $aDU6C.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $42omo.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    if (props.isStandalone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "background-color-padding-left background-color-padding-right"
    }, props.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});

parcelRegister("6ObvC", function(module, exports) {
$parcel$export(module.exports, "default", () => $94828f1f255f279b$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $94828f1f255f279b$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("u", props.dataAttributes, props.children);
}

});

parcelRegister("hJ84o", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3ec42e144727e1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");


var $1oCLl = parcelRequire("1oCLl");


var $jVL42 = parcelRequire("jVL42");

function $c3ec42e144727e1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Legacy centering (breaks position: sticky in nested content).
const $c3ec42e144727e1e$var$legacyWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
const $c3ec42e144727e1e$var$flexWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0`
});
// Flex item: no vertical margin so flex container height = content height (matches legacy single-wrapper height).
// flexShrink: 0 so the inner div keeps its width (matches legacy behaviour; flex items default to flex-shrink: 1).
const $c3ec42e144727e1e$var$innerWrapperStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $c3ec42e144727e1e$var$getWidth = (width, mode)=>{
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true) && width) return `min(${width}px, var(--ak-editor--breakout-container-without-gutter-width))`;
    else {
        if ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) {
            if (mode === 'max' || typeof width === 'number' && width >= (0, $aFUXX.akEditorFullWidthLayoutWidth)) return `min(${0, $aFUXX.akEditorMaxLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        }
        if (mode === 'full-width') return `min(${0, $aFUXX.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        if (mode === 'wide') return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))`;
    }
};
function $c3ec42e144727e1e$export$2e2bcd8739ae039(props) {
    const width = $c3ec42e144727e1e$var$getWidth('width' in props ? props.width : null, props.mode);
    const useStickySafeCentering = (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
    if (useStickySafeCentering) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER,
        css: $c3ec42e144727e1e$var$flexWrapperStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $c3ec42e144727e1e$var$innerWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} fabric-editor-breakout-mark fabric-editor-block-mark`,
        "data-mode": props.mode,
        ...(0, $iu6m9.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: width
        }
    }, props.children));
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $c3ec42e144727e1e$var$legacyWrapperStyles,
        "data-mode": props.mode,
        ...(0, $iu6m9.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: $c3ec42e144727e1e$var$getWidth('width' in props ? props.width : null, props.mode)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-breakout-mark fabric-editor-block-mark"
    }, props.children);
}

});

parcelRegister("9DaqG", function(module, exports) {
$parcel$export(module.exports, "default", () => $624960bf79edb235$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $624960bf79edb235$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("gwCgB", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb8a383b3d03d76f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fb8a383b3d03d76f$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("118BP", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bcfe8463d12ab19$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $0bcfe8463d12ab19$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrapperElement, {
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("a6ktG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cff835241e99f05$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $0cff835241e99f05$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("5UG0R", function(module, exports) {
$parcel$export(module.exports, "default", () => $3be8fe9cdede03f9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9K4OG = parcelRequire("9K4OG");

function $3be8fe9cdede03f9$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("kzW3z", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bc77e7590ca73fa$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $0bc77e7590ca73fa$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-font-size",
        "data-font-size": props.fontSize
    }, props.children);
}

});

parcelRegister("8FDtv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce0be8c2097fd490$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $ce0be8c2097fd490$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("blockquote", {
        "data-local-id": props.localId
    }, props.children);
}

});

parcelRegister("bHs3B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $k8515 = parcelRequire("k8515");


var $fZRom = parcelRequire("fZRom");


var $5VmpF = parcelRequire("5VmpF");


var $gi5bC = parcelRequire("gi5bC");


var $d925B = parcelRequire("d925B");


var $d7o2V = parcelRequire("d7o2V");


var $iZq0X = parcelRequire("iZq0X");

const $10ef4e12f0998137$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes, localId: localId, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline, fireAnalyticsEvent: fireAnalyticsEvent } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const validationContextValue = (0, $42omo.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fZRom.ErrorBoundary), {
        component: (0, $gi5bC.ACTION_SUBJECT).RENDERER,
        componentId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d7o2V.AnnotationsPositionContext).Provider, {
        value: {
            startPos: props.startPos + 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iZq0X.ValidationContextProvider), {
        value: validationContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5VmpF.default), {
        ...props,
        type: "bodiedExtension"
    }, ({ node: node, result: result })=>{
        try {
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
            return (0, $k8515.renderExtension)(result, layout, {
                isTopLevel: path.length < 1,
                rendererAppearance: props.rendererAppearance,
                fireAnalyticsEvent: fireAnalyticsEvent
            }, removeOverflow, parameters?.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
        } catch  {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return (0, $k8515.renderExtension)(children, layout, {
            isTopLevel: path.length < 1,
            rendererAppearance: props.rendererAppearance,
            fireAnalyticsEvent: fireAnalyticsEvent
        }, removeOverflow, parameters?.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
    }))));
};
var $10ef4e12f0998137$export$2e2bcd8739ae039 = $10ef4e12f0998137$var$BodiedExtension;
module.exports["default"] = $10ef4e12f0998137$export$2e2bcd8739ae039;

});

parcelRegister("1acNj", function(module, exports) {
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $bWRlG = parcelRequire("bWRlG");


var $jVL42 = parcelRequire("jVL42");


var $fJNzZ = parcelRequire("fJNzZ");





var $d925B = parcelRequire("d925B");


var $dh538 = parcelRequire("dh538");

const $412f9b1c55f8103a$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer, extensionKey: extensionKey = '', extensionType: extensionType = '', fireAnalyticsEvent: fireAnalyticsEvent })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                if ((0, $dh538.fg)('confluence_frontend_native_tabs_extension')) fireAnalyticsEvent?.({
                    action: (0, $d925B.ACTION).CHANGE_ACTIVE,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
                    attributes: {
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                });
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            removeChild (_index) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            reorderChildren (_fromIndex, _toIndex) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer,
        extensionKey,
        extensionType,
        fireAnalyticsEvent
    ]);
};






var $2XqLN = parcelRequire("2XqLN");


var $heH5c = parcelRequire("heH5c");


var $6mbqi = parcelRequire("6mbqi");


var $2diEG = parcelRequire("2diEG");




const $f289f2207b4baf8b$var$getExtensionHandlerNode = (extensionHandler)=>{
    return ({ node: node, doc: doc, actions: actions })=>{
        return extensionHandler(node, doc, actions);
    };
};
const $f289f2207b4baf8b$export$e55394818db35473 = ({ extensionHandlers: extensionHandlers, extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $2XqLN.default)((0, $heH5c.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerPromise = (0, $6mbqi.useProvider)('extensionProvider');
    const ExtensionHandlerNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        const extensionHandler = extensionHandlers && extensionHandlers[extensionType] && (0, $2diEG.getExtensionRenderer)(extensionHandlers[extensionType]);
        if (extensionHandler) return $f289f2207b4baf8b$var$getExtensionHandlerNode(extensionHandler);
        return null;
    }, [
        extensionHandlers,
        extensionType
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $heH5c.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const ExtensionProviderNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (ExtensionHandlerNode && (0, $dh538.fg)('confluence_frontend_native_tabs_extension')) return {
            extensionContext: {
                NodeRenderer: ExtensionHandlerNode,
                privateProps: {
                    __allowBodiedOverride: true
                }
            },
            loading: false
        };
        if (!provider || !ExtensionProviderNode || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: ExtensionProviderNode,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        ExtensionHandlerNode,
        provider,
        ExtensionProviderNode,
        privateProps
    ]);
};



var $1oCLl = parcelRequire("1oCLl");


var $2W3B8 = parcelRequire("2W3B8");


var $6uN0A = parcelRequire("6uN0A");

function $001e619277309332$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $001e619277309332$var$containerStyles = {
    name: "hwppun",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}&:first-child > .ak-renderer-sticky-safe-center-wrapper{margin-top:0;}"
};
const $001e619277309332$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $001e619277309332$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $001e619277309332$var$MultiBodiedExtensionWrapperLegacy = ({ width: width, path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $fJNzZ.calcBreakoutWidth)(layout, width) : (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer",
        "data-top-level": isTopLevel || undefined
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $001e619277309332$var$MultiBodiedExtensionWrapperNext = ({ path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2W3B8.calcBreakoutWidthCss)(layout) : (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer",
        "data-top-level": isTopLevel || undefined
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $001e619277309332$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, extensionHandlers: extensionHandlers, content: content, marks: marks, localId: localId, rendererAppearance: rendererAppearance } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $42omo.useState)(0);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $42omo.useContext)((0, $6uN0A.default));
    const { loading: loading, extensionContext: extensionContext } = (0, $f289f2207b4baf8b$export$e55394818db35473)({
        extensionHandlers: extensionHandlers,
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $412f9b1c55f8103a$export$3c7139d93ecb4f1f)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext?.privateProps?.__allowBodiedOverride,
        extensionKey: extensionKey,
        extensionType: extensionType,
        fireAnalyticsEvent: fireAnalyticsEvent
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $9K4OG.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    if ((0, $1oCLl.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        const isTopLevel = path.length < 1;
        const useCenterWrapper = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) && (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const wrapper = /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionWrapperNext, {
            layout: layout,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return /*#__PURE__*/ (0, $9K4OG.jsx)("section", {
            css: [
                $001e619277309332$var$containerStyles,
                containerActiveFrameStyles
            ],
            "data-testid": "multiBodiedExtension--container",
            "data-multiBodiedExtension-container": true,
            "data-active-child-index": activeChildIndex,
            "data-layout": layout,
            "data-local-id": localId,
            "data-node-type": "multiBodiedExtension"
        }, useCenterWrapper ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper);
    }
    const isTopLevel = path.length < 1;
    const useCenterWrapper = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("section", {
        css: [
            $001e619277309332$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>{
        const wrapper = /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionWrapperLegacy, {
            layout: layout,
            width: width,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return useCenterWrapper ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper;
    }));
};
var $001e619277309332$export$2e2bcd8739ae039 = $001e619277309332$var$MultiBodiedExtension;
module.exports["default"] = $001e619277309332$export$2e2bcd8739ae039;

});

parcelRegister("l5RsK", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9K4OG = parcelRequire("9K4OG");

const $ef229c57415fc2fe$var$containerCSS = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $ef229c57415fc2fe$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $ef229c57415fc2fe$var$containerCSS
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $ef229c57415fc2fe$export$2e2bcd8739ae039 = $ef229c57415fc2fe$var$ExtensionFrame;
module.exports["default"] = $ef229c57415fc2fe$export$2e2bcd8739ae039;

});

parcelRegister("4aPtv", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a60824ddd9f14a5$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $ghpxT = parcelRequire("ghpxT");


var $drJ23 = parcelRequire("drJ23");

function $6a60824ddd9f14a5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ghpxT.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $drJ23.getListIndentLevel)(props.path) : 1
    }, props.children);
}

});

parcelRegister("8jc2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $61eb98cf96d6d9e9$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $jVL42 = parcelRequire("jVL42");


var $d925B = parcelRequire("d925B");





var $6uN0A = parcelRequire("6uN0A");

class $6ae1df30d2a89e31$export$6e6724d89f27411 {
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $6ae1df30d2a89e31$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $6ae1df30d2a89e31$export$6e6724d89f27411(win.getSelection());
    }
    constructor(selection){
        this.type = void 0;
        this.range = void 0;
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
}


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $24fdc3f18020be27$var$MAC_PLATFORM_REGEX = /Mac/;
const $24fdc3f18020be27$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $6uN0A.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const mac = typeof navigator !== 'undefined' ? $24fdc3f18020be27$var$MAC_PLATFORM_REGEX.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $6ae1df30d2a89e31$export$6e6724d89f27411).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                action: (0, $d925B.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                action: (0, $d925B.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};


function $61eb98cf96d6d9e9$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $jVL42.RendererCssClassName).DOCUMENT
    }, props.children);
}
function $61eb98cf96d6d9e9$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: (0, $24fdc3f18020be27$export$98871b245ee25215)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jVL42.RendererCssClassName).DOCUMENT
    }, props.children);
}
module.exports["DocWithSelectAllTrap"] = $61eb98cf96d6d9e9$export$41121a410ca2f650;

});

parcelRegister("k8515", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $5VmpF = parcelRequire("5VmpF");


var $frt7o = parcelRequire("frt7o");

var $bWRlG = parcelRequire("bWRlG");


var $fJNzZ = parcelRequire("fJNzZ");


var $jVL42 = parcelRequire("jVL42");


var $1oCLl = parcelRequire("1oCLl");


var $2W3B8 = parcelRequire("2W3B8");


var $dh538 = parcelRequire("dh538");

function $eb61561689376623$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $eb61561689376623$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $eb61561689376623$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $eb61561689376623$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $eb61561689376623$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $eb61561689376623$var$macroHeights[viewportSize];
    }
};
const $eb61561689376623$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
/**
 * Fires an analytics event once on mount when a bodied extension is rendered as an inline element.
 * The node is stored in a ref to avoid re-firing if the node reference changes.
 */ const $eb61561689376623$var$FireExtensionAsInlineAnalytics = ({ fireAnalyticsEvent: fireAnalyticsEvent, node: node })=>{
    const nodeRef = (0, $42omo.useRef)(node);
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent({
            action: (0, $d925B.ACTION).RENDERED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION_AS_INLINE,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            attributes: {
                extensionKey: nodeRef.current.extensionKey,
                extensionType: nodeRef.current.extensionType
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    }, [
        fireAnalyticsEvent
    ]);
    return null;
};
const $eb61561689376623$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes, nodeHeight, localId, shouldDisplayExtensionAsInline, node, isInsideOfInlineExtension)=>{
    const overflowContainerClass = !removeOverflow ? (0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true, rendererAppearance: rendererAppearance, fireAnalyticsEvent: fireAnalyticsEvent } = options || {};
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
   * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
   * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
   * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
   * as the extension handler in CFE for legacy macros and Connect.
   */ const viewportSize = $eb61561689376623$var$getViewportSize(extensionId, extensionViewportSizes);
    const extensionHeight = nodeHeight || viewportSize;
    const isInline = shouldDisplayExtensionAsInline?.(node) && (0, $1oCLl.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true);
    const inlineClassName = isInline ? (0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE : '';
    const asInlineAnalytics = isInline && fireAnalyticsEvent && node ? /*#__PURE__*/ (0, $9K4OG.jsx)($eb61561689376623$var$FireExtensionAsInlineAnalytics, {
        fireAnalyticsEvent: fireAnalyticsEvent,
        node: node
    }) : null;
    if ((0, $1oCLl.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        const extensionDiv = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                width: isInline ? undefined : ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $2W3B8.calcBreakoutWidthCss)(layout) : (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : extensionHeight && `${extensionHeight}px`
            },
            "data-layout": layout,
            "data-local-id": localId,
            "data-testid": "extension--wrapper",
            "data-node-type": "extension",
            "data-top-level": isTopLevel || undefined
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            tabIndex: options.tabIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: `${(0, $jVL42.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
            css: [
                !isInsideOfInlineExtension && (0, $dh538.fg)('platform_fix_macro_renders_in_layouts') && $eb61561689376623$var$containerStyle
            ]
        }, asInlineAnalytics, content));
        return centerAlignClass && (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    }
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>{
        const extensionDiv = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isInline ? undefined : ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $fJNzZ.calcBreakoutWidth)(layout, width) : (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : `${extensionHeight}px`
            },
            "data-layout": layout,
            "data-local-id": localId,
            "data-top-level": isTopLevel || undefined
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            tabIndex: options.tabIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: `${(0, $jVL42.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
            css: [
                !isInsideOfInlineExtension && (0, $dh538.fg)('platform_fix_macro_renders_in_layouts') && $eb61561689376623$var$containerStyle
            ]
        }, asInlineAnalytics, content));
        return centerAlignClass && (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    });
};
const $eb61561689376623$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters, nodeHeight: nodeHeight, localId: localId, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5VmpF.default), {
        ...props,
        type: "extension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(result)) return $eb61561689376623$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames,
                tabIndex: props.tabIndex,
                rendererAppearance: props.rendererAppearance
            }, undefined, parameters?.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return $eb61561689376623$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames,
            tabIndex: props.tabIndex,
            rendererAppearance: props.rendererAppearance
        }, undefined, parameters?.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
    });
};
const $eb61561689376623$var$_default_1 = (0, $frt7o.default)($eb61561689376623$var$Extension, {
    overflowSelector: `.${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});
var $eb61561689376623$export$2e2bcd8739ae039 = $eb61561689376623$var$_default_1;
module.exports["renderExtension"] = $eb61561689376623$export$b7482bdc8aff85e4;
module.exports["default"] = $eb61561689376623$export$2e2bcd8739ae039;

});

parcelRegister("8dFG8", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $502b94a4b5302811$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null);
};
var $502b94a4b5302811$export$2e2bcd8739ae039 = $502b94a4b5302811$var$HardBreak;
module.exports["default"] = $502b94a4b5302811$export$2e2bcd8739ae039;

});

parcelRegister("9IIii", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $d925B = parcelRequire("d925B");


var $6F6hl = parcelRequire("6F6hl");


var $1oCLl = parcelRequire("1oCLl");


var $6uN0A = parcelRequire("6uN0A");


var $kIphX = parcelRequire("kIphX");


var $3HdsG = parcelRequire("3HdsG");


var $9K4OG = parcelRequire("9K4OG");

function $af6844859e3a51a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af6844859e3a51a3$var$RENDERER_HEADING_WRAPPER = 'renderer-heading-wrapper';
const $af6844859e3a51a3$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $af6844859e3a51a3$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
const $af6844859e3a51a3$var$wrapperStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $af6844859e3a51a3$var$getHeadingAnchorLinksConfig = (allowHeadingAnchorLinks)=>typeof allowHeadingAnchorLinks === 'object' ? allowHeadingAnchorLinks : undefined;
function $af6844859e3a51a3$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, getHeadingLink: getHeadingLink, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6uN0A.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $3HdsG.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onCopyText: ()=>{
                fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).CLICKED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $d925B.EVENT_TYPE).UI
                });
                return (0, $kIphX.copyTextToClipboard)(getHeadingLink?.(headingId) ?? $af6844859e3a51a3$var$getCurrentUrlWithHash(headingId));
            },
            hideFromScreenReader: hideFromScreenReader,
            headingId: headingId
        }));
}
/**
 * Old heading structure (before a11y fix):
 * - headning anchor is rendered INSIDE the heading element
 * - A duplicate anchor is rendered in VisuallyHidden for screen readers
 * - The visible button has hideFromScreenReader={true}
 *
 */ function $af6844859e3a51a3$var$HeadingWithDuplicateAnchor(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $af6844859e3a51a3$var$hasRightAlignmentMark(marks);
    const headingAnchorLinksConfig = $af6844859e3a51a3$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    const enableNestedHeaderLinks = headingAnchorLinksConfig?.allowNestedHeaderLinks;
    const getHeadingLink = headingAnchorLinksConfig?.getHeadingLink;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $4u5NT.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: mouseEnterHandler,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: true
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: true
    }))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6F6hl.default), {
        testId: "visually-hidden-heading-anchor"
    }, showAnchorLink && headingId && /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId
    })));
}
/**
 * New heading structure (a11y fix):
 * - Heading anchor is rendered OUTSIDE the heading element in a .renderer-heading-wrapper div
 * - Uses data-level attribute for CSS styling
 * - Better accessibility: heading contains only text, button is a sibling
 */ function $af6844859e3a51a3$var$HeadingWithWrapper(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $af6844859e3a51a3$var$hasRightAlignmentMark(marks);
    const headingAnchorLinksConfig = $af6844859e3a51a3$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    const enableNestedHeaderLinks = headingAnchorLinksConfig?.allowNestedHeaderLinks;
    const getHeadingLink = headingAnchorLinksConfig?.getHeadingLink;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $4u5NT.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: $af6844859e3a51a3$var$RENDERER_HEADING_WRAPPER,
        "data-testid": $af6844859e3a51a3$var$RENDERER_HEADING_WRAPPER,
        "data-level": props.level,
        css: $af6844859e3a51a3$var$wrapperStyles
    }, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: false
    }), /*#__PURE__*/ (0, $9K4OG.jsx)(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: mouseEnterHandler,
        tabIndex: -1
    }, props.children), showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: false
    }));
}
/**
 * Gated Heading component:
 * - When platform_editor_copy_link_a11y_inconsistency_fix experiment is enabled,
 *   returns HeadingWithWrapper (new a11y-improved structure)
 * - Otherwise returns HeadingWithDuplicateAnchor (old structure)
 */ function $af6844859e3a51a3$var$Heading({ allowHeadingAnchorLinks: allowHeadingAnchorLinks, children: children, dataAttributes: dataAttributes, headingId: headingId, invisible: invisible, level: level, localId: localId, marks: marks, nodeType: nodeType, showAnchorLink: showAnchorLink, serializer: serializer, asInline: asInline }) {
    if ((0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$HeadingWithWrapper, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline
    }, children);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$HeadingWithDuplicateAnchor, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline
    }, children);
}
var $af6844859e3a51a3$export$2e2bcd8739ae039 = $af6844859e3a51a3$var$Heading;
module.exports["default"] = $af6844859e3a51a3$export$2e2bcd8739ae039;

});

parcelRegister("AXP6M", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5VmpF = parcelRequire("5VmpF");

const $7ae9d43d02a0afce$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5VmpF.default), {
        ...props,
        type: "inlineExtension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(result)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, result);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, text || 'inlineExtension');
    }));
};
var $7ae9d43d02a0afce$export$2e2bcd8739ae039 = $7ae9d43d02a0afce$var$InlineExtension;
module.exports["default"] = $7ae9d43d02a0afce$export$2e2bcd8739ae039;

});

parcelRegister("iPgHB", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e32ab0c2bcbe4a4$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $iu6m9 = parcelRequire("iu6m9");

function $3e32ab0c2bcbe4a4$export$2e2bcd8739ae039(props) {
    return (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: "layout-section-container",
        "data-local-id": props.localId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-layout-section": true,
        "data-layout-columns": props?.content?.length
    }, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-layout-section": true,
        "data-local-id": props.localId
    }, props.children);
}

});

parcelRegister("gaxtd", function(module, exports) {
$parcel$export(module.exports, "default", () => $7119b81e1329ee77$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $9JpPs = parcelRequire("9JpPs");


var $1oCLl = parcelRequire("1oCLl");

/* layoutColumn-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Compiled branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $gMc0m = parcelRequire("gMc0m");





var $bWRlG = parcelRequire("bWRlG");


var $dh538 = parcelRequire("dh538");




const $ea0ce9011164d7ca$var$clearNextSiblingMarginTopStyle = null;
const $ea0ce9011164d7ca$var$verticalAlignMiddleStyles = null;
const $ea0ce9011164d7ca$var$verticalAlignBottomStyles = null;
const $ea0ce9011164d7ca$var$multipleWrappedImagesStyle = null; // localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $ea0ce9011164d7ca$var$clearNextSiblingBlockMarkMarginTopStyle = null;
const $ea0ce9011164d7ca$export$417b5700bb65fae1 = (props)=>{
    const isLayoutColumnMenuEnabled = (0, $1oCLl.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true);
    const isLayoutColumnValignRenderingEnabled = (0, $1oCLl.expValEquals)('platform_editor_layout_column_valign_rendering', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        style: {
            flexBasis: `${props.width}%`
        },
        className: (0, $gMc0m.default)([
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'middle' && "_1e0c1txw _2lx21bp4 _1bah1h6o",
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'bottom' && "_1e0c1txw _2lx21bp4 _1bahesu3",
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && "_1tihidpf _12kpidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bWRlG.WidthProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1skbgrf3",
            "_19segrf3 _1ki1grf3 _bmdegrf3 _166hgrf3 _7g1ogrf3 _sk2jgrf3 _hgeogrf3"
        ])
    }), props.children));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");










function $be76e6cae54d918b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $be76e6cae54d918b$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $be76e6cae54d918b$var$verticalAlignMiddleStyles = {
    name: "16mmcnu",
    styles: "display:flex;flex-direction:column;justify-content:center"
};
const $be76e6cae54d918b$var$verticalAlignBottomStyles = {
    name: "igeqly",
    styles: "display:flex;flex-direction:column;justify-content:flex-end"
};
const $be76e6cae54d918b$var$multipleWrappedImagesStyle = {
    name: "y2yz5o",
    styles: "& [class*=\"image-wrap-\"] + [class*=\"image-wrap-\"], & [class*=\"image-wrap-\"]:has( + [class*=\"image-wrap-\"]){margin-top:0;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $be76e6cae54d918b$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
const $be76e6cae54d918b$export$2cc1a43fb56df180 = (props)=>{
    const isLayoutColumnMenuEnabled = (0, $1oCLl.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true);
    const isLayoutColumnValignRenderingEnabled = (0, $1oCLl.expValEquals)('platform_editor_layout_column_valign_rendering', 'isEnabled', true);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- flexBasis is dynamic
        style: {
            flexBasis: `${props.width}%`
        },
        css: [
            // Keep separate: Compiled crashes on ternary/object lookup here.
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'middle' && $be76e6cae54d918b$var$verticalAlignMiddleStyles,
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'bottom' && $be76e6cae54d918b$var$verticalAlignBottomStyles,
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $be76e6cae54d918b$var$multipleWrappedImagesStyle
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthProvider), null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $be76e6cae54d918b$var$clearNextSiblingMarginTopStyle,
            $be76e6cae54d918b$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
};


const $7119b81e1329ee77$var$LayoutSectionMigration = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_renderer_static_css', 'isEnabled', true), (0, $ea0ce9011164d7ca$export$417b5700bb65fae1), (0, $be76e6cae54d918b$export$2cc1a43fb56df180));
function $7119b81e1329ee77$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7119b81e1329ee77$var$LayoutSectionMigration, props);
}

});

parcelRegister("2y2LK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d550833e818bebdd$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $d550833e818bebdd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, props.children);
}

});

parcelRegister("e3xiQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $48Use = parcelRequire("48Use");

const $60e49dc64205ce7a$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48Use.default), {
        hasContent: true,
        dataAttributes: dataAttributes
    }, children);
};
var $60e49dc64205ce7a$export$2e2bcd8739ae039 = $60e49dc64205ce7a$var$RenderCaption;
module.exports["default"] = $60e49dc64205ce7a$export$2e2bcd8739ae039;

});

parcelRegister("iKbB3", function(module, exports) {
$parcel$export(module.exports, "default", () => $380dd188db062d07$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fGuiW = parcelRequire("fGuiW");


var $4mSjx = parcelRequire("4mSjx");


var $irKZA = parcelRequire("irKZA");

var $dMNMt = parcelRequire("dMNMt");


var $drJ23 = parcelRequire("drJ23");

function $380dd188db062d07$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $irKZA.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $4mSjx.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $dMNMt.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fGuiW.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $drJ23.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps
    }, props.children);
}

});

parcelRegister("4AYMa", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5d919d33f5d798a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");




function $08993800855619e3$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, "\xa0");
    return children;
}


function $c5d919d33f5d798a$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes, localId: localId, asInline: asInline }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("p", {
        ...dataAttributes,
        "data-local-id": localId,
        "data-as-inline": asInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $08993800855619e3$export$2e2bcd8739ae039), null, children)));
}

});

parcelRegister("12YDi", function(module, exports) {
$parcel$export(module.exports, "default", () => $120764912de8ad63$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $120764912de8ad63$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-placeholder": `${props.text}`
    }, props.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null);
}

});

parcelRegister("40qpT", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ea7ab564e9f0cf2$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $5ea7ab564e9f0cf2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
        role: "presentation"
    });
}

});

parcelRegister("iKFPk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aDU6C = parcelRequire("aDU6C");

var $63Ztt = parcelRequire("63Ztt");


var $cOrQJ = parcelRequire("cOrQJ");


var $2QYOD = parcelRequire("2QYOD");


var $6icEc = parcelRequire("6icEc");


var $7f6CO = parcelRequire("7f6CO");


var $59U23 = parcelRequire("59U23");


var $d925B = parcelRequire("d925B");


var $jVL42 = parcelRequire("jVL42");


var $aXWIB = parcelRequire("aXWIB");


var $3kBFe = parcelRequire("3kBFe");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");

const $22c24c997e66799c$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $22c24c997e66799c$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return (0, $2QYOD.SortOrder).ASC;
        case (0, $2QYOD.SortOrder).ASC:
            return (0, $2QYOD.SortOrder).DESC;
        case (0, $2QYOD.SortOrder).DESC:
            return (0, $2QYOD.SortOrder).NO_ORDER;
    }
    return (0, $2QYOD.SortOrder).NO_ORDER;
};
const $22c24c997e66799c$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $3kBFe.tableCellMessages);
    switch(currentSortOrder){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $2QYOD.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $2QYOD.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
const $22c24c997e66799c$var$getDataAttributes = (colwidth, background, cellEdgeProps, valign)=>{
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    if ((0, $1oCLl.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) {
        if (cellEdgeProps?.reachesTop) attrs['data-reaches-top'] = true;
        if (cellEdgeProps?.reachesBottom) attrs['data-reaches-bottom'] = true;
        if (cellEdgeProps?.reachesLeft) attrs['data-reaches-left'] = true;
        if (cellEdgeProps?.reachesRight) attrs['data-reaches-right'] = true;
    }
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    if (valign && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) attrs['data-valign'] = valign;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $22c24c997e66799c$var$cssVariablePattern = /^var\(--.*\)$/;
const $22c24c997e66799c$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode, valign: valign })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $6icEc.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $22c24c997e66799c$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $aDU6C.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    if (valign && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) style.verticalAlign = valign;
    return style;
};
const $22c24c997e66799c$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $cOrQJ.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort, reachesTop: reachesTop, reachesBottom: reachesBottom, reachesLeft: reachesLeft, reachesRight: reachesRight, valign: valign } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $63Ztt.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $22c24c997e66799c$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode,
                valign: valign
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$22c24c997e66799c$var$getDataAttributes(colwidth, background, {
                reachesTop: reachesTop,
                reachesBottom: reachesBottom,
                reachesLeft: reachesLeft,
                reachesRight: reachesRight
            }, valign),
            "aria-sort": ariaSort
        }, children);
    };
};
const $22c24c997e66799c$var$TH = $22c24c997e66799c$var$getWithCellProps('th');
const $22c24c997e66799c$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $aXWIB.useIntl)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $2QYOD.SortOrder).NO_ORDER ? (0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrapperComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $22c24c997e66799c$var$getSortOrderLabel(intl, sortOrdered)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $jVL42.RendererCssClassName).SORTABLE_COLUMN
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("figure", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f6CO.default), {
            isSortingAllowed: !!onSorting,
            sortOrdered: sortOrdered,
            onClick: sort,
            onKeyDown: onKeyPress
        }))));
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$22c24c997e66799c$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $22c24c997e66799c$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).SORT_COLUMN,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $59U23.PLATFORM).WEB,
                        mode: (0, $59U23.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $d925B.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    mode: (0, $59U23.MODE).RENDERER
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            });
        }
    };
};
const $22c24c997e66799c$export$f850895b287ef28e = $22c24c997e66799c$export$cfca40ca5c56a38e($22c24c997e66799c$var$TH);
const $22c24c997e66799c$var$TD = $22c24c997e66799c$var$getWithCellProps('td');
const $22c24c997e66799c$export$1e4baea7053fc0e3 = $22c24c997e66799c$var$TD;
module.exports["TableHeader"] = $22c24c997e66799c$export$f850895b287ef28e;
module.exports["TableCell"] = $22c24c997e66799c$export$1e4baea7053fc0e3;

});

parcelRegister("a78Ri", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cN8vw = parcelRequire("cN8vw");


var $2QYOD = parcelRequire("2QYOD");


var $jVL42 = parcelRequire("jVL42");

class $f7e5733ad19fb3c4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children, innerRef: innerRef, isFirstRow: isFirstRow, isLastRow: isLastRow } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("tr", {
            ref: innerRef
        }, this.props.isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("td", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jVL42.RendererCssClassName).NUMBER_COLUMN,
            "data-reaches-left": true,
            "data-reaches-top": isFirstRow || undefined,
            "data-reaches-bottom": isLastRow || undefined
        }, this.props.index), (0, $cN8vw.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
    }
    constructor(...args){
        super(...args);
        this.state = {
            colGroupWidths: []
        };
        this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && isHeaderRow) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $2QYOD.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $2QYOD.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        };
        this.addColGroupWidth = (childrenArray)=>{
            if (this.state.colGroupWidths?.length) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}
module.exports["default"] = $f7e5733ad19fb3c4$export$2e2bcd8739ae039;

});

parcelRegister("cCNNZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8295e31785de4f76$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $8295e31785de4f76$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: "UnknownBlock"
    }, props.children);
}

});

parcelRegister("iCOwP", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c789bfafac09dd18$export$32ec96484dd3ba39 = (0, $aXWIB.defineMessages)({
    unsupportedInlineContent: {
        id: "fabric.editor.unsupportedInlineContent",
        defaultMessage: "Unsupported content"
    },
    unsupportedBlockContent: {
        id: "fabric.editor.unsupportedBlockContent",
        defaultMessage: "This editor does not support displaying this content"
    },
    unsupportedContentTooltip: {
        id: "fabric.editor.unsupportedContentTooltip",
        defaultMessage: "Content is not available in this editor, this will be preserved when you edit and save"
    }
});
module.exports["unsupportedContentMessages"] = $c789bfafac09dd18$export$32ec96484dd3ba39;

});

parcelRegister("1QdLR", function(module, exports) {
function $0688bb6895de1706$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}
module.exports["getUnsupportedContent"] = $0688bb6895de1706$export$d4ded51d0f0bd2df;

});

parcelRegister("9XfBK", function(module, exports) {
const $ad7c0463f334173f$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
module.exports["resolveImportSync"] = $ad7c0463f334173f$export$dca2026e63034304;

});

parcelRegister("WaLVU", function(module, exports) {
const $6549cc6fb4a1fa36$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
module.exports["buildExtensionKeyAndNodeKey"] = $6549cc6fb4a1fa36$export$5f3eb042babacbbd;

});

parcelRegister("jHS8C", function(module, exports) {
var $ec8bf358ec87ad61$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
module.exports["ShadowKeys"] = $ec8bf358ec87ad61$export$ebeea2fe2e93862e;

});

parcelRegister("4BBKV", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6dGgK = parcelRequire("6dGgK");


var $aFUXX = parcelRequire("aFUXX");


var $bWRlG = parcelRequire("bWRlG");

function $194645e6da8b5697$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
const $194645e6da8b5697$export$3de34996b814f0f0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BaseThemeWrapper(t0) {
    const $ = (0, $frIzR.c)(5);
    const { baseFontSize: baseFontSize, children: children } = t0;
    const t1 = baseFontSize || 14;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            baseFontSize: t1,
            layoutMaxWidth: (0, $aFUXX.akEditorDefaultLayoutWidth)
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const memoizedTheme = t2;
    let t3;
    if ($[2] !== children || $[3] !== memoizedTheme) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6dGgK.a), {
            theme: memoizedTheme
        }, children);
        $[2] = children;
        $[3] = memoizedTheme;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function BaseThemeWrapper({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $42omo.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $aFUXX.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6dGgK.a), {
        theme: memoizedTheme
    }, children);
};
const $194645e6da8b5697$export$a1a213d350ca51ca = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BaseTheme(t0) {
    const $ = (0, $frIzR.c)(3);
    const { children: children, baseFontSize: baseFontSize } = t0;
    let t1;
    if ($[0] !== baseFontSize || $[1] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bWRlG.WidthConsumer), null, (t2)=>{
            const { breakpoint: breakpoint } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($194645e6da8b5697$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children));
        });
        $[0] = baseFontSize;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function BaseTheme({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bWRlG.WidthConsumer), null, ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($194645e6da8b5697$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children)));
};
module.exports["mapBreakpointToLayoutMaxWidth"] = $194645e6da8b5697$export$b5ccf4d25d2c5af1;
module.exports["BaseTheme"] = $194645e6da8b5697$export$a1a213d350ca51ca;

});

parcelRegister("jSHzw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cUycv = parcelRequire("cUycv");


var $21K7m = parcelRequire("21K7m");


var $lspPP = parcelRequire("lspPP");

const $83d34ca77d432476$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $83d34ca77d432476$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $42omo.createContext)($83d34ca77d432476$var$initState);
const $83d34ca77d432476$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $83d34ca77d432476$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$83d34ca77d432476$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && state.annotations[id]?.markState === (0, $cUycv.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $cUycv.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!loadedAnnotation?.markState && state.annotations[id]?.markState !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current?.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $cUycv.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if (current?.markState !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $cUycv.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $cUycv.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $83d34ca77d432476$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $42omo.useReducer)($83d34ca77d432476$var$reducer, $83d34ca77d432476$var$initState);
    const actionContext = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    (0, $42omo.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager?.hook('getDraft', getDraft);
        return ()=>{
            annotationManager?.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $42omo.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $42omo.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- resolve mark node by id in the document
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager?.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $42omo.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $42omo.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager?.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $42omo.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $cUycv.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager?.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager?.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
   * This is a temporary solution to ensure that the annotation manager state is in sync with the
   * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
   * by the annotation manager itself.
   */ (0, $42omo.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $cUycv.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: _eventTargetType, viewMethod: _viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $42omo.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($83d34ca77d432476$var$AnnotationManagerStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($83d34ca77d432476$var$AnnotationManagerDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $83d34ca77d432476$export$654a1fb45487f838 = ()=>{
    return (0, $42omo.useContext)($83d34ca77d432476$var$AnnotationManagerStateContext);
};
const $83d34ca77d432476$export$12cbbb89fb7702d0 = ()=>{
    return (0, $42omo.useContext)($83d34ca77d432476$var$AnnotationManagerDispatchContext);
};
module.exports["AnnotationManagerProvider"] = $83d34ca77d432476$export$f21fb05766361bb3;
module.exports["useAnnotationManagerState"] = $83d34ca77d432476$export$654a1fb45487f838;
module.exports["useAnnotationManagerDispatch"] = $83d34ca77d432476$export$12cbbb89fb7702d0;

});

parcelRegister("jZG1P", function(module, exports) {
/* eslint-disable @atlaskit/platform/no-direct-document-usage -- draft selection uses document range APIs */ const $5f034ae8d7da98e3$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $5f034ae8d7da98e3$var$buildDataAttributesQuery = (pos)=>{
    const a = $5f034ae8d7da98e3$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $5f034ae8d7da98e3$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($5f034ae8d7da98e3$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};
module.exports["dataAttributes"] = $5f034ae8d7da98e3$export$15d6ddc168d35719;
module.exports["updateWindowSelectionAroundDraft"] = $5f034ae8d7da98e3$export$e14699d956e87e73;

});

parcelRegister("djzd2", function(module, exports) {

var $bYZ53 = parcelRequire("bYZ53");


var $dh538 = parcelRequire("dh538");

function $981298672e79c67e$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}
function $981298672e79c67e$export$1726c23d64498b6({ actions: actions, pos: pos }) {
    if (!(0, $dh538.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const ancestorNodeNames = (0, $bYZ53.getRangeAncestorNodeNames)({
        doc: doc,
        pos: pos
    });
    return ancestorNodeNames;
}
module.exports["getRendererRangeInlineNodeNames"] = $981298672e79c67e$export$b0ea72d31617ccea;
module.exports["getRendererRangeAncestorNodeNames"] = $981298672e79c67e$export$1726c23d64498b6;

});

parcelRegister("34hOD", function(module, exports) {
var $9da8c256688b103f$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
module.exports["ContentType"] = $9da8c256688b103f$export$e2e108cbe2e4f865;

});

parcelRegister("iqWD2", function(module, exports) {
var $894b2420ab82c887$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
module.exports["StatusClassNames"] = $894b2420ab82c887$export$c3618f310f725028;

});

parcelRegister("bGTfP", function(module, exports) {
const $af42dd92eeea9512$export$b44a013e4f554514 = (tableNode)=>{
    const firstRow = tableNode.content.firstChild;
    if (!firstRow) return false;
    for(let i = 0; i < firstRow.childCount; i++){
        if (firstRow.child(i).attrs.colwidth) return true;
    }
    return false;
};
module.exports["hasTableColumnBeenResized"] = $af42dd92eeea9512$export$b44a013e4f554514;

});

parcelRegister("ahEBi", function(module, exports) {
const $9355ae6af5f63ecf$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
module.exports["isSubSupType"] = $9355ae6af5f63ecf$export$30f8aa4cc1f8c1cb;

});

parcelRegister("jv597", function(module, exports) {
/*
 * It's important that this order follows the marks rank defined here:
 * https://product-fabric.atlassian.net/wiki/spaces/ETEMP/pages/11174043/Atlassian+Document+Format+-+Internal+documentation#Rank
 */ const $dcff930d07f5eb28$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
module.exports["markOrder"] = $dcff930d07f5eb28$export$62d5811a2955c1d8;

});

parcelRegister("ew9YK", function(module, exports) {
const $26060048277411a3$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
module.exports["isSameMark"] = $26060048277411a3$export$b1304404bdc42b7a;

});

parcelRegister("3kBFe", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $aXWIB = parcelRequire("aXWIB");

const $ff40fa5e20831b0c$export$74bada844422036d = (0, $aXWIB.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: "fabric.editor.headingLink.copyAnchorLink",
        defaultMessage: "Copy link to heading"
    },
    copyLinkToClipboard: {
        id: "fabric.editor.headingLink.copyAnchorLinkTo",
        defaultMessage: "Copy link to"
    },
    copyHeadingLinkLabelledBy: {
        id: "fabric.editor.headingLink.copyAnchorLinkLabelledBy",
        defaultMessage: "{copyLink} {heading}"
    },
    copiedHeadingLinkToClipboard: {
        id: "fabric.editor.headingLink.copied",
        defaultMessage: "Copied!"
    },
    failedToCopyHeadingLink: {
        id: "fabric.editor.headingLink.failedToCopy",
        defaultMessage: "Copy failed"
    },
    copyAriaLabel: {
        id: "fabric.editor.headingLink.copyAriaLabel",
        defaultMessage: "Copy"
    }
});
const $ff40fa5e20831b0c$export$c79ebc36348824d1 = (0, $aXWIB.defineMessages)({
    noneSortingLabel: {
        id: "fabric.editor.headingLink.noneSortingLabel",
        defaultMessage: "none"
    },
    ascSortingLabel: {
        id: "fabric.editor.headingLink.ascSortingLabel",
        defaultMessage: "ascending"
    },
    descSortingLabel: {
        id: "fabric.editor.headingLink.descSortingLabel",
        defaultMessage: "descending"
    }
});
const $ff40fa5e20831b0c$export$9f52c375a6ef34fc = (0, $aXWIB.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: "fabric.editor.inlineComment.marker.start",
        defaultMessage: "inline comment start"
    },
    contentRendererInlineCommentMarkerEnd: {
        id: "fabric.editor.inlineComment.marker.end",
        defaultMessage: "inline comment end"
    }
});
module.exports["headingAnchorLinkMessages"] = $ff40fa5e20831b0c$export$74bada844422036d;
module.exports["tableCellMessages"] = $ff40fa5e20831b0c$export$c79ebc36348824d1;
module.exports["inlineCommentMessages"] = $ff40fa5e20831b0c$export$9f52c375a6ef34fc;

});

parcelRegister("1lzbj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $d925B = parcelRequire("d925B");


var $k7eoe = parcelRequire("k7eoe");


var $jSHzw = parcelRequire("jSHzw");

const $bf54d68c492d222f$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $42omo.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $jSHzw.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $42omo.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $42omo.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $bf54d68c492d222f$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $42omo.useState)(false);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $jSHzw.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $42omo.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $bf54d68c492d222f$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $bf54d68c492d222f$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $42omo.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $jSHzw.useAnnotationManagerState)();
    const selectedAnnotation = (0, $42omo.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $bf54d68c492d222f$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).VIEWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $k7eoe.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};
module.exports["useAnnotationStateByTypeEvent"] = $bf54d68c492d222f$export$95f9f9045e92d283;
module.exports["useHasFocusEvent"] = $bf54d68c492d222f$export$48f5d7f6702be07c;
module.exports["useAnnotationClickEvent"] = $bf54d68c492d222f$export$26cf539704e444c1;

});

parcelRegister("IcpgS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $fcecf936ee660f14$export$6a26b015ac619737 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $fcecf936ee660f14$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["ProvidersContext"] = $fcecf936ee660f14$export$6a26b015ac619737;
module.exports["InlineCommentsStateContext"] = $fcecf936ee660f14$export$aafe46a36ef535ba;

});

parcelRegister("1Qaul", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $1A9t2 = parcelRequire("1A9t2");

function $c1722af477a6914e$export$1daf15cbaf649dad(adfDocument) {
    return (0, $1A9t2.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}
module.exports["countNodes"] = $c1722af477a6914e$export$1daf15cbaf649dad;

});

parcelRegister("kPuBV", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

const $b1b93f863d38edeb$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)();
};
module.exports["overflowShadow"] = $b1b93f863d38edeb$export$c5c1e4f4640336fb;

});

parcelRegister("eMRIC", function(module, exports) {
/* @flow */ // $FlowFixMe

module.exports = (parcelRequire("p8f0R")); // eslint-disable-line import/no-commonjs
// $FlowFixMe
module.exports.default = module.exports; // eslint-disable-line import/no-commonjs

});

parcelRegister("8tWYx", function(module, exports) {
"use strict";
var $62cec777db13e7d3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $62cec777db13e7d3$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SANDBOX_CONNECTION_TIMEOUT_MS = module.exports.SANDBOX_HANDSHAKE_TIMEOUT_MS = module.exports.SANDBOX_CONTROLLER_REQUEST_EVENT = module.exports.BRIDGE_ACK_TIMEOUT_MS = module.exports.BRIDGE_HANDSHAKE_TIMEOUT_MS = module.exports.THEME_CHANGE_EVENT = module.exports.THEME_ENABLE_EVENT = module.exports.READY_EVENT = module.exports.handleMissingHandlerError = module.exports.firstToResolve = void 0;
var $62cec777db13e7d3$var$invertPromise = function(p) {
    return new Promise(function(resolve, reject) {
        return p.then(reject, resolve);
    });
};
var $62cec777db13e7d3$var$firstToResolve = function(promises) {
    return $62cec777db13e7d3$var$__awaiter(void 0, void 0, void 0, function() {
        var err_1;
        return $62cec777db13e7d3$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $62cec777db13e7d3$var$invertPromise(Promise.all(promises.map($62cec777db13e7d3$var$invertPromise)))
                    ];
                case 1:
                    return [
                        2,
                        _a.sent()
                    ];
                case 2:
                    err_1 = _a.sent();
                    throw err_1[0];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
};
module.exports.firstToResolve = $62cec777db13e7d3$var$firstToResolve;
var $62cec777db13e7d3$var$PORT_RPC_HANDLER_NOT_FOUND_CODE = 'HANDLER_NOT_FOUND';
var $62cec777db13e7d3$var$handleMissingHandlerError = function(error) {
    if ((error === null || error === void 0 ? void 0 : error.code) === $62cec777db13e7d3$var$PORT_RPC_HANDLER_NOT_FOUND_CODE || (error === null || error === void 0 ? void 0 : error.message.startsWith('No handler found for post message:'))) return Promise.resolve();
    else return Promise.reject("Error while sending bridge message: ".concat(error === null || error === void 0 ? void 0 : error.message));
};
module.exports.handleMissingHandlerError = $62cec777db13e7d3$var$handleMissingHandlerError;
module.exports.READY_EVENT = '__ready';
module.exports.THEME_ENABLE_EVENT = '__theme_enable';
module.exports.THEME_CHANGE_EVENT = '__theme_change';
module.exports.BRIDGE_HANDSHAKE_TIMEOUT_MS = 20000;
module.exports.BRIDGE_ACK_TIMEOUT_MS = 10000;
module.exports.SANDBOX_CONTROLLER_REQUEST_EVENT = '__sandbox_controller_request';
module.exports.SANDBOX_HANDSHAKE_TIMEOUT_MS = 10000;
module.exports.SANDBOX_CONNECTION_TIMEOUT_MS = 10000;

});

parcelRegister("kaOT1", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");

const $74f9941a52315579$export$e775b9769343d051 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $74f9941a52315579$export$73f470ced5fdc319 = (props)=>{
    const breadCrumbs = (0, $42omo.useRef)([]);
    const tracingService = (0, $42omo.useRef)({
        getBreadcrumbs: ()=>breadCrumbs.current,
        recordBridgeCall: (description)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `forge.bridge`,
                    message: description,
                    timestamp: new Date().toISOString()
                }
            ],
        recordGqlCall: (description_0)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    type: 'http',
                    category: 'gql',
                    timestamp: new Date().toISOString(),
                    data: {
                        url: description_0
                    }
                }
            ],
        recordConsentFlow: (description_1, result)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `user.consent`,
                    message: description_1,
                    timestamp: new Date().toISOString(),
                    ...result ? {
                        data: {
                            result: result
                        }
                    } : {}
                }
            ]
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($74f9941a52315579$export$e775b9769343d051.Provider, {
        value: tracingService.current
    }, props.children);
};
const $74f9941a52315579$export$1bd6b93107e60cf1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const tracingContext = (0, $42omo.useContext)($74f9941a52315579$export$e775b9769343d051);
    return tracingContext;
} : ()=>{
    const tracingContext = (0, $42omo.useContext)($74f9941a52315579$export$e775b9769343d051);
    return tracingContext;
};
module.exports["TracingProvider"] = $74f9941a52315579$export$73f470ced5fdc319;
module.exports["useTracingContext"] = $74f9941a52315579$export$1bd6b93107e60cf1;

});

parcelRegister("5oEbs", function(module, exports) {

var $T9xHm = parcelRequire("T9xHm");


var $1c598 = parcelRequire("1c598");


var $dh538 = parcelRequire("dh538");


var $aVZM7 = parcelRequire("aVZM7");


var $cqiXo = parcelRequire("cqiXo");

const $83c738174c625218$var$SAFE_RESOURCE_ENTRY_PATTERN = /^[\w][\w.-]*$/;
const $83c738174c625218$export$71a53c8753c032be = (baseUrl, resolvedResourceEntry)=>{
    if (!(0, $dh538.fg)('forge-ui-multi-entry-resource') || resolvedResourceEntry === undefined) return baseUrl;
    if (!$83c738174c625218$var$SAFE_RESOURCE_ENTRY_PATTERN.test(resolvedResourceEntry)) throw new Error('Invalid resource entry specified.');
    return `${baseUrl}${resolvedResourceEntry}`;
};
const $83c738174c625218$export$9b5c32eaf7c2ac3d = {
    [(0, $1c598.ProductEnvironment).PRODUCTION]: 'prod',
    [(0, $1c598.ProductEnvironment).STAGING]: 'stg',
    [(0, $1c598.ProductEnvironment).DEVELOPMENT]: 'stg'
};
const $83c738174c625218$export$158d41afab8f2af8 = (appId, extension, environment, entryPoint, extensionViewData, resolvedResourceEntry)=>{
    if ((0, $dh538.fg)('forge-ui-oasis-enabled')) return (0, $T9xHm.isIsolatedCloud)() ? $83c738174c625218$export$d68551323b971eed(appId, extension, entryPoint, extensionViewData, resolvedResourceEntry) : $83c738174c625218$export$b1a4a6ad329e6bd2(appId, extension, environment, entryPoint, extensionViewData, resolvedResourceEntry);
    return $83c738174c625218$export$b1a4a6ad329e6bd2(appId, extension, environment, entryPoint, extensionViewData, resolvedResourceEntry);
};
const $83c738174c625218$export$b1a4a6ad329e6bd2 = (appId, extension, environment, entryPoint, extensionViewData, resolvedResourceEntry)=>{
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const domain = `${$83c738174c625218$export$d4a94ef9062fefbf(installationId)}--${$83c738174c625218$export$d4a94ef9062fefbf(appId)}.${(0, $aVZM7.getForgeCDNBaseDomain)(environment)}`;
    /**
   * The appId is also included in the subdomain so that it can be compared against the appId in the
   * resource path. This comparison is performed by the routing Lambda@ Edge to prevent a malicious
   * developer from appending their malicious app path to a legitimate installation id.
   */ const encodedAppContext = (0, $cqiXo.getEncodedAppContext)(extension, extensionViewData);
    const urlSafeContext = $83c738174c625218$export$223741b87b7c6af6(encodedAppContext);
    const baseUrl = `https://${domain}/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/_ctx_${urlSafeContext}/`;
    return $83c738174c625218$export$71a53c8753c032be(baseUrl, resolvedResourceEntry);
};
const $83c738174c625218$export$d68551323b971eed = (appId, extension, entryPoint, extensionViewData, resolvedResourceEntry)=>{
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const icDomain = (0, $T9xHm.isolatedCloudDomain)();
    const domain = `${$83c738174c625218$export$d4a94ef9062fefbf(installationId)}--${$83c738174c625218$export$d4a94ef9062fefbf(appId)}.forge-cdn.${icDomain}`;
    const encodedAppContext = (0, $cqiXo.getEncodedAppContext)(extension, extensionViewData);
    const urlSafeContext = $83c738174c625218$export$223741b87b7c6af6(encodedAppContext);
    const baseUrl = `https://${domain}/forge-cdn/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/_ctx_${urlSafeContext}/`;
    return $83c738174c625218$export$71a53c8753c032be(baseUrl, resolvedResourceEntry);
};
function $83c738174c625218$export$d4a94ef9062fefbf(uuid) {
    const [a, b, c, d, e] = uuid.split('-');
    const combinedUuid = [
        a,
        `${b}${c}${d}`,
        e
    ];
    return combinedUuid.map((s)=>parseInt(s, 16)).map((s)=>s.toString(36)).join('-');
}
function $83c738174c625218$export$824f5b1835a75769(shortenedUuid) {
    const [a, b, c] = shortenedUuid.split('-').map((s)=>parseInt(s, 36)).map((s)=>s.toString(16));
    // expands the middle segment into the original UUID
    // ffffffff-abcdabcdabcd-ffffffffffff ===> ffffffff-abcd-abcd-abcd-ffffffffffff
    const middleExpanded = b.match(/.{1,4}/g) || b;
    return [
        a,
        ...middleExpanded,
        c
    ].join('-');
}
function $83c738174c625218$export$223741b87b7c6af6(str) {
    return str.replace(/\+/g, '-') // Replace '+' with '-'
    .replace(/\//g, '_') // Replace '/' with '_'
    .replace(/=+$/, ''); // Remove padding
}
module.exports["appendResolvedResourceEntry"] = $83c738174c625218$export$71a53c8753c032be;
module.exports["createSrcFromExtension"] = $83c738174c625218$export$158d41afab8f2af8;
module.exports["urlSafeB64"] = $83c738174c625218$export$223741b87b7c6af6;

});

parcelRegister("LiNdD", function(module, exports) {
const $3ac7139ae0ef30fb$export$563e375d286a76a7 = ()=>{
    if (navigator.languages) return navigator.languages[0];
    return navigator.language;
};
module.exports["getBrowserLocale"] = $3ac7139ae0ef30fb$export$563e375d286a76a7;

});

parcelRegister("4jZsH", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $337f83d71a1a0efc$export$bd17c6970f4d989e = ()=>{
    const platformFeatureFlags = [];
    // Add feature flags that are required to be passed down to the iframe
    // EXAMPLE:
    // if (fg(<flag-name>)) {
    // 	platformFeatureFlags.push(<flag-name>);
    // }
    if ((0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')) platformFeatureFlags.push('forge-ui-iframe-analytics');
    if ((0, $dh538.fg)('forge-ui-bridge-core-reset')) platformFeatureFlags.push('forge-ui-bridge-core-reset');
    if ((0, $dh538.fg)('platform_ufo_3p_segment_timings')) platformFeatureFlags.push('forge-ui-iframe-ufo-perf-observers');
    if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) platformFeatureFlags.push('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $dh538.fg)('platform-dst-shape-theme-default')) platformFeatureFlags.push('platform-dst-shape-theme-default');
    if ((0, $dh538.fg)('platform-dst-motion-uplift-popup')) platformFeatureFlags.push('platform-dst-motion-uplift-popup');
    if ((0, $dh538.fg)('platform-dst-motion-uplift-modal')) platformFeatureFlags.push('platform-dst-motion-uplift-modal');
    if ((0, $dh538.fg)('platform-dst-motion-uplift-spotlight')) platformFeatureFlags.push('platform-dst-motion-uplift-spotlight');
    if ((0, $dh538.fg)('platform-dst-motion-uplift')) platformFeatureFlags.push('platform-dst-motion-uplift');
    return platformFeatureFlags;
};



var $5oEbs = parcelRequire("5oEbs");

const $f045517dec5f1afb$export$6dd3d030a75d6dba = (tunnels, extensionResource, defaultUrl, urlSafeContext, resolvedResourceEntry)=>{
    const matchTunnel = tunnels.find((tunnel)=>tunnel.resourceKey === extensionResource);
    const platformFeatureFlags = (0, $337f83d71a1a0efc$export$bd17c6970f4d989e)();
    const queryParams = new URLSearchParams({
        ...platformFeatureFlags.length > 0 ? {
            platformFeatureFlags: platformFeatureFlags.join(',')
        } : {},
        // when tunnelling, pass hostname into query param to be passed into CSP
        ...matchTunnel ? {
            hostname: window.location.hostname,
            ctx: urlSafeContext
        } : {}
    }).toString();
    const query = queryParams ? `?${queryParams}` : '';
    if (matchTunnel) return `${(0, $5oEbs.appendResolvedResourceEntry)(matchTunnel.tunnelUrl, resolvedResourceEntry)}${query}`;
    return `${defaultUrl}${query}`;
};
const $f045517dec5f1afb$export$6f3f630a07b3a5ad = (src)=>{
    try {
        return new URL(src).hostname === 'localhost';
    } catch  {
        return false;
    }
};
module.exports["getSrcUrl"] = $f045517dec5f1afb$export$6dd3d030a75d6dba;
module.exports["isTunnelSrc"] = $f045517dec5f1afb$export$6f3f630a07b3a5ad;

});

parcelRegister("ge8sG", function(module, exports) {
const $ac41360860378247$export$c34ac5b863279caa = (coreData, extensionData)=>({
        ...coreData,
        extension: extensionData
    });
module.exports["getResolverContext"] = $ac41360860378247$export$c34ac5b863279caa;

});

parcelRegister("UZU5S", function(module, exports) {
const $fff5b396b669afc2$export$68ca3577dbf1f96c = (scopes = [], egress = [])=>{
    // Create a map to store egress data by type then loop through the map to populate the external permissions object
    const egressMap = new Map();
    egress.forEach(({ type: type, addresses: addresses })=>{
        egressMap.set(type, addresses);
    });
    // Construct external permissions from the map
    const externalPermissions = {
        fetch: {
            backend: egressMap.get('FETCH_BACKEND_SIDE') ?? [],
            client: egressMap.get('FETCH_CLIENT_SIDE') ?? []
        },
        fonts: egressMap.get('FONTS') ?? [],
        styles: egressMap.get('STYLES') ?? [],
        frames: egressMap.get('FRAMES') ?? [],
        images: egressMap.get('IMAGES') ?? [],
        media: egressMap.get('MEDIA') ?? [],
        scripts: egressMap.get('SCRIPTS') ?? []
    };
    return {
        scopes: scopes,
        external: externalPermissions
    };
};
const $fff5b396b669afc2$export$20af16720c0f9c71 = ({ resolverContext: resolverContext, accountId: accountId, extension: extension, timezone: timezone, locale: locale, location: location, extensionPayload: extensionPayload, extensionViewData: extensionViewData, theme: theme, surfaceColor: surfaceColor })=>{
    // Combine the static macro extension data with the dynamic extension view data (macro body) into a single macro object
    const macro = {
        ...resolverContext.extension?.macro,
        ...extensionViewData?.macro,
        ...extensionPayload?.macro
    };
    /* adding hasAccess separately instead of using userAccess as a whole is to avoid appending __typename in the context */ const userAccess = extension.userAccess ?? {
        enabled: false,
        hasAccess: false
    };
    // Construct permissions object from scopes and egress
    const permissions = $fff5b396b669afc2$export$68ca3577dbf1f96c(extension?.scopes || [], extension?.egress || []);
    const isGlobalUIModule = extension?.type === 'global:ui';
    return {
        ...resolverContext,
        extension: {
            ...resolverContext.extension,
            ...extensionViewData,
            ...extensionPayload,
            ...Object.keys(macro).length > 0 ? {
                macro: macro
            } : {},
            location: location
        },
        accountId: accountId,
        ...isGlobalUIModule ? {
            installationId: extension.installationId
        } : {},
        license: extension?.license || null,
        timezone: timezone,
        locale: locale,
        theme: theme,
        surfaceColor: surfaceColor,
        userAccess: userAccess,
        permissions: permissions
    };
};
module.exports["getViewContext"] = $fff5b396b669afc2$export$20af16720c0f9c71;

});

parcelRegister("6baEI", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $dh538 = parcelRequire("dh538");


var $42omo = parcelRequire("42omo");


var $T9xHm = parcelRequire("T9xHm");

const $3169be2c7bdce757$export$98b91f32256d29a8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $3169be2c7bdce757$export$a6dd2b5c1fe5c76e();
        $[0] = t0;
    } else t0 = $[0];
    const [isLoading, setIsLoading] = (0, $42omo.useState)(t0);
    let t1;
    let t2;
    if ($[1] !== isLoading) {
        t1 = ()=>{
            let cancelled = false;
            if (isLoading) $3169be2c7bdce757$var$loadCDNAuthSignedCookie().catch($3169be2c7bdce757$var$_temp).finally(()=>{
                if (!cancelled) setIsLoading(false);
            });
            return ()=>{
                cancelled = true;
            };
        };
        t2 = [
            isLoading
        ];
        $[1] = isLoading;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    return isLoading;
} : ()=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)($3169be2c7bdce757$export$a6dd2b5c1fe5c76e());
    (0, $42omo.useEffect)(()=>{
        let cancelled = false;
        if (isLoading) $3169be2c7bdce757$var$loadCDNAuthSignedCookie().catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Error loading CDN auth signed cookie:', err);
        }).finally(()=>{
            if (!cancelled) setIsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        isLoading
    ]);
    return isLoading;
};
const $3169be2c7bdce757$var$MAX_SIGNED_COOKIE_AGE_MS = 1800000; // 30 minutes
let $3169be2c7bdce757$var$lastSignedCookieFetchTime = 0;
let $3169be2c7bdce757$var$loadingPromise = null;
const $3169be2c7bdce757$var$doLoadCDNAuthSignedCookie = async ()=>{
    // Step 1: Get the signed cookies URL from our backend -> session token based auth
    const signedCookiesUrlResponse = await fetch('/gateway/api/forge-cdn/signed-cookies-url');
    if (!signedCookiesUrlResponse.ok) throw new Error(`Failed to get signed cookies URL: ${signedCookiesUrlResponse.statusText}`);
    // Step 2: Fetch the signed cookies using the obtained URL (with signed URL) -> this will set the cookies in the browser
    const { data: signedCookiesUrl } = await signedCookiesUrlResponse.json();
    if (!signedCookiesUrl || typeof signedCookiesUrl !== 'string') throw new Error('Invalid signed cookies URL received from backend');
    const response = await fetch(signedCookiesUrl, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch signed cookies: ${response.statusText}`);
};
const $3169be2c7bdce757$var$loadCDNAuthSignedCookie = async ()=>{
    if (Date.now() - $3169be2c7bdce757$var$lastSignedCookieFetchTime < $3169be2c7bdce757$var$MAX_SIGNED_COOKIE_AGE_MS) return;
    // this is to ensure only one loadingPromise is active at a time (to avoid multiple simultaneous requests)
    if ($3169be2c7bdce757$var$loadingPromise) await $3169be2c7bdce757$var$loadingPromise;
    else {
        $3169be2c7bdce757$var$loadingPromise = (async ()=>{
            try {
                await $3169be2c7bdce757$var$doLoadCDNAuthSignedCookie();
                $3169be2c7bdce757$var$lastSignedCookieFetchTime = Date.now();
            } finally{
                $3169be2c7bdce757$var$loadingPromise = null;
            }
        })();
        await $3169be2c7bdce757$var$loadingPromise;
    }
};
const $3169be2c7bdce757$export$a6dd2b5c1fe5c76e = ()=>{
    return (0, $dh538.fg)('forge-ui-cdn-auth') && (0, $T9xHm.isIsolatedCloud)();
};
const $3169be2c7bdce757$export$1b22f04514004ab6 = ()=>{
    $3169be2c7bdce757$var$lastSignedCookieFetchTime = 0;
    $3169be2c7bdce757$var$loadingPromise = null;
};
function $3169be2c7bdce757$var$_temp(err) {
    console.error("Error loading CDN auth signed cookie:", err);
}
module.exports["useCDNAuthSignedCookie"] = $3169be2c7bdce757$export$98b91f32256d29a8;
module.exports["shouldUseCDNAuth"] = $3169be2c7bdce757$export$a6dd2b5c1fe5c76e;

});

parcelRegister("ly9ul", function(module, exports) {
const $b9631ed1ce649aaf$var$messages = [
    'Window closed for',
    'Window did not load after'
];
const $b9631ed1ce649aaf$export$fab3177d2bcbd98a = (error)=>error instanceof Error && $b9631ed1ce649aaf$var$messages.some((message)=>error.message.startsWith(message));
module.exports["isUnrecoverableError"] = $b9631ed1ce649aaf$export$fab3177d2bcbd98a;

});

parcelRegister("9wL22", function(module, exports) {
/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */ // eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    var count = 0, logEnabled = false, hiddenCheckEnabled = false, msgHeader = 'message', msgHeaderLen = msgHeader.length, msgId = '[iFrameSizer]', msgIdLen = msgId.length, pagePosition = null, requestAnimationFrame = window.requestAnimationFrame, resetRequiredMethods = {
        max: 1,
        scroll: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, settings = {}, timer = null, defaults = {
        autoResize: true,
        bodyBackground: null,
        bodyMargin: null,
        bodyMarginV1: 8,
        bodyPadding: null,
        checkOrigin: true,
        inPageLinks: false,
        enablePublicMethods: true,
        heightCalculationMethod: 'bodyOffset',
        id: 'iFrameResizer',
        interval: 32,
        log: false,
        maxHeight: Infinity,
        maxWidth: Infinity,
        minHeight: 0,
        minWidth: 0,
        mouseEvents: true,
        resizeFrom: 'parent',
        scrolling: false,
        sizeHeight: true,
        sizeWidth: false,
        warningTimeout: 5000,
        tolerance: 0,
        widthCalculationMethod: 'scroll',
        onClose: function() {
            return true;
        },
        onClosed: function() {},
        onInit: function() {},
        onMessage: function() {
            warn('onMessage function not defined');
        },
        onMouseEnter: function() {},
        onMouseLeave: function() {},
        onResized: function() {},
        onScroll: function() {
            return true;
        }
    };
    function getMutationObserver() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    function addEventListener(el, evt, func) {
        el.addEventListener(evt, func, false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function setupRequestAnimationFrame() {
        var vendors = [
            'moz',
            'webkit',
            'o',
            'ms'
        ];
        var x;
        // Remove vendor prefixing if prefixed and break early if not
        for(x = 0; x < vendors.length && !requestAnimationFrame; x += 1)requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        if (!requestAnimationFrame) log('setup', 'RequestAnimationFrame not supported');
        else // Firefox extension content-scripts have a globalThis object that is not the same as window.
        // Binding `requestAnimationFrame` to window allows the function to work and prevents errors
        // being thrown when run in that context, and should be a no-op in every other context.
        requestAnimationFrame = requestAnimationFrame.bind(window);
    }
    function getMyID(iframeId) {
        var retStr = 'Host page: ' + iframeId;
        if (window.top !== window.self) retStr = window.parentIFrame && window.parentIFrame.getId ? window.parentIFrame.getId() + ': ' + iframeId : 'Nested host page: ' + iframeId;
        return retStr;
    }
    function formatLogHeader(iframeId) {
        return msgId + '[' + getMyID(iframeId) + ']';
    }
    function isLogEnabled(iframeId) {
        return settings[iframeId] ? settings[iframeId].log : logEnabled;
    }
    function log(iframeId, msg) {
        output('log', iframeId, msg, isLogEnabled(iframeId));
    }
    function info(iframeId, msg) {
        output('info', iframeId, msg, isLogEnabled(iframeId));
    }
    function warn(iframeId, msg) {
        output('warn', iframeId, msg, true);
    }
    function output(type, iframeId, msg, enabled) {
        if (true === enabled && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console[type](formatLogHeader(iframeId), msg);
    }
    function iFrameListener(event) {
        function resizeIFrame() {
            function resize() {
                setSize(messageData);
                setPagePosition(iframeId);
                on('onResized', messageData);
            }
            ensureInRange('Height');
            ensureInRange('Width');
            syncResize(resize, messageData, 'init');
        }
        function processMsg() {
            var data = msg.substr(msgIdLen).split(':');
            var height = data[1] ? parseInt(data[1], 10) : 0;
            var iframe = settings[data[0]] && settings[data[0]].iframe;
            var compStyle = getComputedStyle(iframe);
            return {
                iframe: iframe,
                id: data[0],
                height: height + getPaddingEnds(compStyle) + getBorderEnds(compStyle),
                width: data[2],
                type: data[3]
            };
        }
        function getPaddingEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.paddingTop ? parseInt(compStyle.paddingTop, 10) : 0;
            var bot = compStyle.paddingBottom ? parseInt(compStyle.paddingBottom, 10) : 0;
            return top + bot;
        }
        function getBorderEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.borderTopWidth ? parseInt(compStyle.borderTopWidth, 10) : 0;
            var bot = compStyle.borderBottomWidth ? parseInt(compStyle.borderBottomWidth, 10) : 0;
            return top + bot;
        }
        function ensureInRange(Dimension) {
            var max = Number(settings[iframeId]['max' + Dimension]), min = Number(settings[iframeId]['min' + Dimension]), dimension = Dimension.toLowerCase(), size = Number(messageData[dimension]);
            log(iframeId, 'Checking ' + dimension + ' is in range ' + min + '-' + max);
            if (size < min) {
                size = min;
                log(iframeId, 'Set ' + dimension + ' to min value');
            }
            if (size > max) {
                size = max;
                log(iframeId, 'Set ' + dimension + ' to max value');
            }
            messageData[dimension] = '' + size;
        }
        function isMessageFromIFrame() {
            function checkAllowedOrigin() {
                function checkList() {
                    var i = 0, retCode = false;
                    log(iframeId, 'Checking connection is from allowed list of origins: ' + checkOrigin);
                    for(; i < checkOrigin.length; i++)if (checkOrigin[i] === origin) {
                        retCode = true;
                        break;
                    }
                    return retCode;
                }
                function checkSingle() {
                    var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
                    log(iframeId, 'Checking connection is from: ' + remoteHost);
                    return origin === remoteHost;
                }
                return checkOrigin.constructor === Array ? checkList() : checkSingle();
            }
            var origin = event.origin, checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
            if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) throw new Error('Unexpected message received from: ' + origin + ' for ' + messageData.iframe.id + '. Message was: ' + event.data + '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.');
            return true;
        }
        function isMessageForUs() {
            return msgId === ('' + msg).substr(0, msgIdLen) && msg.substr(msgIdLen).split(':')[0] in settings // ''+Protects against non-string msg
            ;
        }
        function isMessageFromMetaParent() {
            // Test if this message is from a parent above us. This is an ugly test, however, updating
            // the message format would break backwards compatibity.
            var retCode = messageData.type in {
                true: 1,
                false: 1,
                undefined: 1
            };
            if (retCode) log(iframeId, 'Ignoring init message from meta parent page');
            return retCode;
        }
        function getMsgBody(offset) {
            return msg.substr(msg.indexOf(':') + msgHeaderLen + offset);
        }
        function forwardMsgFromIFrame(msgBody) {
            log(iframeId, 'onMessage passed: {iframe: ' + messageData.iframe.id + ', message: ' + msgBody + '}');
            on('onMessage', {
                iframe: messageData.iframe,
                message: JSON.parse(msgBody)
            });
            log(iframeId, '--');
        }
        function getPageInfo() {
            var bodyPosition = document.body.getBoundingClientRect(), iFramePosition = messageData.iframe.getBoundingClientRect();
            return JSON.stringify({
                iframeHeight: iFramePosition.height,
                iframeWidth: iFramePosition.width,
                clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                clientWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
                offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
                scrollTop: window.pageYOffset,
                scrollLeft: window.pageXOffset,
                documentHeight: document.documentElement.clientHeight,
                documentWidth: document.documentElement.clientWidth,
                windowHeight: window.innerHeight,
                windowWidth: window.innerWidth
            });
        }
        function sendPageInfoToIframe(iframe, iframeId) {
            function debouncedTrigger() {
                trigger('Send Page Info', 'pageInfo:' + getPageInfo(), iframe, iframeId);
            }
            debounceFrameEvents(debouncedTrigger, 32, iframeId);
        }
        function startPageInfoMonitor() {
            function setListener(type, func) {
                function sendPageInfo() {
                    if (settings[id]) sendPageInfoToIframe(settings[id].iframe, id);
                    else stop();
                }
                [
                    'scroll',
                    'resize'
                ].forEach(function(evt) {
                    log(id, type + evt + ' listener for sendPageInfo');
                    func(window, evt, sendPageInfo);
                });
            }
            function stop() {
                setListener('Remove ', removeEventListener);
            }
            function start() {
                setListener('Add ', addEventListener);
            }
            var id = iframeId // Create locally scoped copy of iFrame ID
            ;
            start();
            if (settings[id]) settings[id].stopPageInfo = stop;
        }
        function stopPageInfoMonitor() {
            if (settings[iframeId] && settings[iframeId].stopPageInfo) {
                settings[iframeId].stopPageInfo();
                delete settings[iframeId].stopPageInfo;
            }
        }
        function checkIFrameExists() {
            var retBool = true;
            if (null === messageData.iframe) {
                warn(iframeId, 'IFrame (' + messageData.id + ') not found');
                retBool = false;
            }
            return retBool;
        }
        function getElementPosition(target) {
            var iFramePosition = target.getBoundingClientRect();
            getPagePosition(iframeId);
            return {
                x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
                y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
            };
        }
        function scrollRequestFromChild(addOffset) {
            /* istanbul ignore next */ // Not testable in Karma
            function reposition() {
                pagePosition = newPosition;
                scrollTo();
                log(iframeId, '--');
            }
            function calcOffset() {
                return {
                    x: Number(messageData.width) + offset.x,
                    y: Number(messageData.height) + offset.y
                };
            }
            function scrollParent() {
                if (window.parentIFrame) window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](newPosition.x, newPosition.y);
                else warn(iframeId, 'Unable to scroll to requested position, window.parentIFrame not found');
            }
            var offset = addOffset ? getElementPosition(messageData.iframe) : {
                x: 0,
                y: 0
            }, newPosition = calcOffset();
            log(iframeId, 'Reposition requested from iFrame (offset x:' + offset.x + ' y:' + offset.y + ')');
            if (window.top !== window.self) scrollParent();
            else reposition();
        }
        function scrollTo() {
            if (false !== on('onScroll', pagePosition)) setPagePosition(iframeId);
            else unsetPagePosition();
        }
        function findTarget(location) {
            function jumpToTarget() {
                var jumpPosition = getElementPosition(target);
                log(iframeId, 'Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                pagePosition = {
                    x: jumpPosition.x,
                    y: jumpPosition.y
                };
                scrollTo();
                log(iframeId, '--');
            }
            function jumpToParent() {
                if (window.parentIFrame) window.parentIFrame.moveToAnchor(hash);
                else log(iframeId, 'In page link #' + hash + ' not found and window.parentIFrame not found');
            }
            var hash = location.split('#')[1] || '', hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (target) jumpToTarget();
            else if (window.top !== window.self) jumpToParent();
            else log(iframeId, 'In page link #' + hash + ' not found');
        }
        function onMouse(event) {
            var mousePos = {};
            if (Number(messageData.width) === 0 && Number(messageData.height) === 0) {
                var data = getMsgBody(9).split(':');
                mousePos = {
                    x: data[1],
                    y: data[0]
                };
            } else mousePos = {
                x: messageData.width,
                y: messageData.height
            };
            on(event, {
                iframe: messageData.iframe,
                screenX: Number(mousePos.x),
                screenY: Number(mousePos.y),
                type: messageData.type
            });
        }
        function on(funcName, val) {
            return chkEvent(iframeId, funcName, val);
        }
        function actionMsg() {
            if (settings[iframeId] && settings[iframeId].firstRun) firstRun();
            switch(messageData.type){
                case 'close':
                    closeIFrame(messageData.iframe);
                    break;
                case 'message':
                    forwardMsgFromIFrame(getMsgBody(6));
                    break;
                case 'mouseenter':
                    onMouse('onMouseEnter');
                    break;
                case 'mouseleave':
                    onMouse('onMouseLeave');
                    break;
                case 'autoResize':
                    settings[iframeId].autoResize = JSON.parse(getMsgBody(9));
                    break;
                case 'scrollTo':
                    scrollRequestFromChild(false);
                    break;
                case 'scrollToOffset':
                    scrollRequestFromChild(true);
                    break;
                case 'pageInfo':
                    sendPageInfoToIframe(settings[iframeId] && settings[iframeId].iframe, iframeId);
                    startPageInfoMonitor();
                    break;
                case 'pageInfoStop':
                    stopPageInfoMonitor();
                    break;
                case 'inPageLink':
                    findTarget(getMsgBody(9));
                    break;
                case 'reset':
                    resetIFrame(messageData);
                    break;
                case 'init':
                    resizeIFrame();
                    on('onInit', messageData.iframe);
                    break;
                default:
                    if (Number(messageData.width) === 0 && Number(messageData.height) === 0) warn('Unsupported message received (' + messageData.type + '), this is likely due to the iframe containing a later ' + 'version of iframe-resizer than the parent page');
                    else resizeIFrame();
            }
        }
        function hasSettings(iframeId) {
            var retBool = true;
            if (!settings[iframeId]) {
                retBool = false;
                warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
            }
            return retBool;
        }
        function iFrameReadyMsgReceived() {
            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for(var iframeId in settings)trigger('iFrame requested init', createOutgoingMsg(iframeId), settings[iframeId].iframe, iframeId);
        }
        function firstRun() {
            if (settings[iframeId]) settings[iframeId].firstRun = false;
        }
        var msg = event.data, messageData = {}, iframeId = null;
        if ('[iFrameResizerChild]Ready' === msg) iFrameReadyMsgReceived();
        else if (isMessageForUs()) {
            messageData = processMsg();
            iframeId = messageData.id;
            if (settings[iframeId]) settings[iframeId].loaded = true;
            if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
                log(iframeId, 'Received: ' + msg);
                if (checkIFrameExists() && isMessageFromIFrame()) actionMsg();
            }
        } else info(iframeId, 'Ignored: ' + msg);
    }
    function chkEvent(iframeId, funcName, val) {
        var func = null, retVal = null;
        if (settings[iframeId]) {
            func = settings[iframeId][funcName];
            if ('function' === typeof func) retVal = func(val);
            else throw new TypeError(funcName + ' on iFrame[' + iframeId + '] is not a function');
        }
        return retVal;
    }
    function removeIframeListeners(iframe) {
        var iframeId = iframe.id;
        delete settings[iframeId];
    }
    function closeIFrame(iframe) {
        var iframeId = iframe.id;
        if (chkEvent(iframeId, 'onClose', iframeId) === false) {
            log(iframeId, 'Close iframe cancelled by onClose event');
            return;
        }
        log(iframeId, 'Removing iFrame: ' + iframeId);
        try {
            // Catch race condition error with React
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        } catch (error) {
            warn(error);
        }
        chkEvent(iframeId, 'onClosed', iframeId);
        log(iframeId, '--');
        removeIframeListeners(iframe);
    }
    function getPagePosition(iframeId) {
        if (null === pagePosition) {
            pagePosition = {
                x: window.pageXOffset !== undefined ? window.pageXOffset : document.documentElement.scrollLeft,
                y: window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop
            };
            log(iframeId, 'Get page position: ' + pagePosition.x + ',' + pagePosition.y);
        }
    }
    function setPagePosition(iframeId) {
        if (null !== pagePosition) {
            window.scrollTo(pagePosition.x, pagePosition.y);
            log(iframeId, 'Set page position: ' + pagePosition.x + ',' + pagePosition.y);
            unsetPagePosition();
        }
    }
    function unsetPagePosition() {
        pagePosition = null;
    }
    function resetIFrame(messageData) {
        function reset() {
            setSize(messageData);
            trigger('reset', 'reset', messageData.iframe, messageData.id);
        }
        log(messageData.id, 'Size reset requested by ' + ('init' === messageData.type ? 'host page' : 'iFrame'));
        getPagePosition(messageData.id);
        syncResize(reset, messageData, 'reset');
    }
    function setSize(messageData) {
        function setDimension(dimension) {
            if (!messageData.id) {
                log('undefined', 'messageData id not set');
                return;
            }
            messageData.iframe.style[dimension] = messageData[dimension] + 'px';
            log(messageData.id, 'IFrame (' + iframeId + ') ' + dimension + ' set to ' + messageData[dimension] + 'px');
        }
        function chkZero(dimension) {
            // FireFox sets dimension of hidden iFrames to zero.
            // So if we detect that set up an event to check for
            // when iFrame becomes visible.
            /* istanbul ignore next */ // Not testable in PhantomJS
            if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
                hiddenCheckEnabled = true;
                log(iframeId, 'Hidden iFrame detected, creating visibility listener');
                fixHiddenIFrames();
            }
        }
        function processDimension(dimension) {
            setDimension(dimension);
            chkZero(dimension);
        }
        var iframeId = messageData.iframe.id;
        if (settings[iframeId]) {
            if (settings[iframeId].sizeHeight) processDimension('height');
            if (settings[iframeId].sizeWidth) processDimension('width');
        }
    }
    function syncResize(func, messageData, doNotSync) {
        /* istanbul ignore if */ // Not testable in PhantomJS
        if (doNotSync !== messageData.type && requestAnimationFrame && // including check for jasmine because had trouble getting spy to work in unit test using requestAnimationFrame
        !window.jasmine) {
            log(messageData.id, 'Requesting animation frame');
            requestAnimationFrame(func);
        } else func();
    }
    function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
        function postMessageToIFrame() {
            var target = settings[id] && settings[id].targetOrigin;
            log(id, '[' + calleeMsg + '] Sending msg to iframe[' + id + '] (' + msg + ') targetOrigin: ' + target);
            iframe.contentWindow.postMessage(msgId + msg, target);
        }
        function iFrameNotFound() {
            warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
        }
        function chkAndSend() {
            if (iframe && 'contentWindow' in iframe && null !== iframe.contentWindow) // Null test for PhantomJS
            postMessageToIFrame();
            else iFrameNotFound();
        }
        function warnOnNoResponse() {
            function warning() {
                if (settings[id] && !settings[id].loaded && !errorShown) {
                    errorShown = true;
                    warn(id, 'IFrame has not responded within ' + settings[id].warningTimeout / 1000 + ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
                }
            }
            if (!!noResponseWarning && settings[id] && !!settings[id].warningTimeout) settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
        }
        var errorShown = false;
        id = id || iframe.id;
        if (settings[id]) {
            chkAndSend();
            warnOnNoResponse();
        }
    }
    function createOutgoingMsg(iframeId) {
        return iframeId + ':' + settings[iframeId].bodyMarginV1 + ':' + settings[iframeId].sizeWidth + ':' + settings[iframeId].log + ':' + settings[iframeId].interval + ':' + settings[iframeId].enablePublicMethods + ':' + settings[iframeId].autoResize + ':' + settings[iframeId].bodyMargin + ':' + settings[iframeId].heightCalculationMethod + ':' + settings[iframeId].bodyBackground + ':' + settings[iframeId].bodyPadding + ':' + settings[iframeId].tolerance + ':' + settings[iframeId].inPageLinks + ':' + settings[iframeId].resizeFrom + ':' + settings[iframeId].widthCalculationMethod + ':' + settings[iframeId].mouseEvents;
    }
    function isNumber(value) {
        return typeof value === 'number';
    }
    function setupIFrame(iframe, options) {
        function setLimits() {
            function addStyle(style) {
                var styleValue = settings[iframeId][style];
                if (Infinity !== styleValue && 0 !== styleValue) {
                    iframe.style[style] = isNumber(styleValue) ? styleValue + 'px' : styleValue;
                    log(iframeId, 'Set ' + style + ' = ' + iframe.style[style]);
                }
            }
            function chkMinMax(dimension) {
                if (settings[iframeId]['min' + dimension] > settings[iframeId]['max' + dimension]) throw new Error('Value for min' + dimension + ' can not be greater than max' + dimension);
            }
            chkMinMax('Height');
            chkMinMax('Width');
            addStyle('maxHeight');
            addStyle('minHeight');
            addStyle('maxWidth');
            addStyle('minWidth');
        }
        function newId() {
            var id = options && options.id || defaults.id + count++;
            if (null !== document.getElementById(id)) id += count++;
            return id;
        }
        function ensureHasId(iframeId) {
            if ('' === iframeId) {
                // eslint-disable-next-line no-multi-assign
                iframe.id = iframeId = newId();
                logEnabled = (options || {}).log;
                log(iframeId, 'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')');
            }
            return iframeId;
        }
        function setScrolling() {
            log(iframeId, 'IFrame scrolling ' + (settings[iframeId] && settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
            iframe.style.overflow = false === (settings[iframeId] && settings[iframeId].scrolling) ? 'hidden' : 'auto';
            switch(settings[iframeId] && settings[iframeId].scrolling){
                case 'omit':
                    break;
                case true:
                    iframe.scrolling = 'yes';
                    break;
                case false:
                    iframe.scrolling = 'no';
                    break;
                default:
                    iframe.scrolling = settings[iframeId] ? settings[iframeId].scrolling : 'no';
            }
        }
        // The V1 iFrame script expects an int, where as in V2 expects a CSS
        // string value such as '1px 3em', so if we have an int for V2, set V1=V2
        // and then convert V2 to a string PX value.
        function setupBodyMarginValues() {
            if ('number' === typeof (settings[iframeId] && settings[iframeId].bodyMargin) || '0' === (settings[iframeId] && settings[iframeId].bodyMargin)) {
                settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
                settings[iframeId].bodyMargin = '' + settings[iframeId].bodyMargin + 'px';
            }
        }
        function checkReset() {
            // Reduce scope of firstRun to function, because IE8's JS execution
            // context stack is borked and this value gets externally
            // changed midway through running this function!!!
            var firstRun = settings[iframeId] && settings[iframeId].firstRun, resetRequertMethod = settings[iframeId] && settings[iframeId].heightCalculationMethod in resetRequiredMethods;
            if (!firstRun && resetRequertMethod) resetIFrame({
                iframe: iframe,
                height: 0,
                width: 0,
                type: 'init'
            });
        }
        function setupIFrameObject() {
            if (settings[iframeId]) settings[iframeId].iframe.iFrameResizer = {
                close: closeIFrame.bind(null, settings[iframeId].iframe),
                removeListeners: removeIframeListeners.bind(null, settings[iframeId].iframe),
                resize: trigger.bind(null, 'Window resize', 'resize', settings[iframeId].iframe),
                moveToAnchor: function(anchor) {
                    trigger('Move to anchor', 'moveToAnchor:' + anchor, settings[iframeId].iframe, iframeId);
                },
                sendMessage: function(message) {
                    message = JSON.stringify(message);
                    trigger('Send Message', 'message:' + message, settings[iframeId].iframe, iframeId);
                }
            };
        }
        // We have to call trigger twice, as we can not be sure if all
        // iframes have completed loading when this code runs. The
        // event listener also catches the page changing in the iFrame.
        function init(msg) {
            function iFrameLoaded() {
                trigger('iFrame.onload', msg, iframe, undefined, true);
                checkReset();
            }
            function createDestroyObserver(MutationObserver) {
                if (!iframe.parentNode) return;
                var destroyObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        var removedNodes = Array.prototype.slice.call(mutation.removedNodes) // Transform NodeList into an Array
                        ;
                        removedNodes.forEach(function(removedNode) {
                            if (removedNode === iframe) closeIFrame(iframe);
                        });
                    });
                });
                destroyObserver.observe(iframe.parentNode, {
                    childList: true
                });
            }
            var MutationObserver = getMutationObserver();
            if (MutationObserver) createDestroyObserver(MutationObserver);
            addEventListener(iframe, 'load', iFrameLoaded);
            trigger('init', msg, iframe, undefined, true);
        }
        function checkOptions(options) {
            if ('object' !== typeof options) throw new TypeError('Options is not an object');
        }
        function copyOptions(options) {
            // eslint-disable-next-line no-restricted-syntax
            for(var option in defaults)if (Object.prototype.hasOwnProperty.call(defaults, option)) settings[iframeId][option] = Object.prototype.hasOwnProperty.call(options, option) ? options[option] : defaults[option];
        }
        function getTargetOrigin(remoteHost) {
            return '' === remoteHost || null !== remoteHost.match(/^(about:blank|javascript:|file:\/\/)/) ? '*' : remoteHost;
        }
        function depricate(key) {
            var splitName = key.split('Callback');
            if (splitName.length === 2) {
                var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
                this[name] = this[key];
                delete this[key];
                warn(iframeId, "Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
            }
        }
        function processOptions(options) {
            options = options || {};
            settings[iframeId] = {
                firstRun: true,
                iframe: iframe,
                remoteHost: iframe.src && iframe.src.split('/').slice(0, 3).join('/')
            };
            checkOptions(options);
            Object.keys(options).forEach(depricate, options);
            copyOptions(options);
            if (settings[iframeId]) settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
        }
        function beenHere() {
            return iframeId in settings && 'iFrameResizer' in iframe;
        }
        var iframeId = ensureHasId(iframe.id);
        if (!beenHere()) {
            processOptions(options);
            setScrolling();
            setLimits();
            setupBodyMarginValues();
            init(createOutgoingMsg(iframeId));
            setupIFrameObject();
        } else warn(iframeId, 'Ignored iFrame, already setup.');
    }
    function debouce(fn, time) {
        if (null === timer) timer = setTimeout(function() {
            timer = null;
            fn();
        }, time);
    }
    var frameTimer = {};
    function debounceFrameEvents(fn, time, frameId) {
        if (!frameTimer[frameId]) frameTimer[frameId] = setTimeout(function() {
            frameTimer[frameId] = null;
            fn();
        }, time);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function fixHiddenIFrames() {
        function checkIFrames() {
            function checkIFrame(settingId) {
                function chkDimension(dimension) {
                    return '0px' === (settings[settingId] && settings[settingId].iframe.style[dimension]);
                }
                function isVisible(el) {
                    return null !== el.offsetParent;
                }
                if (settings[settingId] && isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))) trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
            }
            Object.keys(settings).forEach(function(key) {
                checkIFrame(key);
            });
        }
        function mutationObserved(mutations) {
            log('window', 'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
            debouce(checkIFrames, 16);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            }, observer = new MutationObserver(mutationObserved);
            observer.observe(target, config);
        }
        var MutationObserver = getMutationObserver();
        if (MutationObserver) createMutationObserver();
    }
    function resizeIFrames(event) {
        function resize() {
            sendTriggerMsg('Window ' + event, 'resize');
        }
        log('window', 'Trigger event: ' + event);
        debouce(resize, 16);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function tabVisible() {
        function resize() {
            sendTriggerMsg('Tab Visable', 'resize');
        }
        if ('hidden' !== document.visibilityState) {
            log('document', 'Trigger event: Visiblity change');
            debouce(resize, 16);
        }
    }
    function sendTriggerMsg(eventName, event) {
        function isIFrameResizeEnabled(iframeId) {
            return settings[iframeId] && 'parent' === settings[iframeId].resizeFrom && settings[iframeId].autoResize && !settings[iframeId].firstRun;
        }
        Object.keys(settings).forEach(function(iframeId) {
            if (isIFrameResizeEnabled(iframeId)) trigger(eventName, event, settings[iframeId].iframe, iframeId);
        });
    }
    function setupEventListeners() {
        addEventListener(window, 'message', iFrameListener);
        addEventListener(window, 'resize', function() {
            resizeIFrames('resize');
        });
        addEventListener(document, 'visibilitychange', tabVisible);
        addEventListener(document, '-webkit-visibilitychange', tabVisible);
    }
    function factory() {
        function init(options, element) {
            function chkType() {
                if (!element.tagName) throw new TypeError('Object is not a valid DOM element');
                else if ('IFRAME' !== element.tagName.toUpperCase()) throw new TypeError('Expected <IFRAME> tag, found <' + element.tagName + '>');
            }
            if (element) {
                chkType();
                setupIFrame(element, options);
                iFrames.push(element);
            }
        }
        function warnDeprecatedOptions(options) {
            if (options && options.enablePublicMethods) warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
        }
        var iFrames;
        setupRequestAnimationFrame();
        setupEventListeners();
        return function iFrameResizeF(options, target) {
            iFrames = []; // Only return iFrames past in on this call
            warnDeprecatedOptions(options);
            switch(typeof target){
                case 'undefined':
                case 'string':
                    Array.prototype.forEach.call(document.querySelectorAll(target || 'iframe'), init.bind(undefined, options));
                    break;
                case 'object':
                    init(options, target);
                    break;
                default:
                    throw new TypeError('Unexpected data type (' + typeof target + ')');
            }
            return iFrames;
        };
    }
    function createJQueryPublicMethod($) {
        if (!$.fn) info('', 'Unable to bind to jQuery, it is not fully loaded.');
        else if (!$.fn.iFrameResize) $.fn.iFrameResize = function $iFrameResizeF(options) {
            function init(index, element) {
                setupIFrame(element, options);
            }
            return this.filter('iframe').each(init).end();
        };
    }
    if (window.jQuery) createJQueryPublicMethod(window.jQuery);
    if (typeof define === 'function' && define.amd) define([], factory);
    else if (typeof module.exports === 'object') // Node for browserfy
    module.exports = factory();
    window.iFrameResize = window.iFrameResize || factory();
})();

});

parcelRegister("ijfiP", function(module, exports) {

var $7MEO5 = parcelRequire("7MEO5");

const $e2d7503e18a8780a$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $7MEO5.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};
module.exports["parseExtensionId"] = $e2d7503e18a8780a$export$bae42cbaf7fa3e1b;

});

parcelRegister("eI4ye", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $9JpPs = parcelRequire("9JpPs");


var $dh538 = parcelRequire("dh538");


var $42omo = parcelRequire("42omo");


var $1uzCd = parcelRequire("1uzCd");


var $kynWP = parcelRequire("kynWP");


var $IiIMy = parcelRequire("IiIMy");


var $cUcZ5 = parcelRequire("cUcZ5");

const $7f6ed9fbce688d04$export$433ff3d294755246 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $7f6ed9fbce688d04$export$e943a7fca26f09e4 = 10000;
const $7f6ed9fbce688d04$var$offsetElapsedTimestamps = (events, elapsedBaselineMark)=>{
    return events.map((event)=>{
        const evaluatedElapsedTime = event.elapsed - elapsedBaselineMark;
        event.elapsed = evaluatedElapsedTime;
        return event;
    });
};
const $7f6ed9fbce688d04$export$9cdba3450d9c6cdc = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { children: children, appType: appType, forgeEnvironment: forgeEnvironment, profileKey: profileKey, extensionType: extensionType, appVersion: appVersion } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            events: [],
            listeners: new Set()
        };
        $[0] = t1;
    } else t1 = $[0];
    const performanceTimelineRef = (0, $42omo.useRef)(t1);
    const hasSent = (0, $42omo.useRef)(false);
    const elapsedBaselineMark = (0, $42omo.useRef)(0);
    const profileIdRef = (0, $42omo.useRef)(null);
    let t2;
    if ($[1] !== extensionType) {
        t2 = (0, $kynWP.getAppPerfCaptureConfig)({
            module: extensionType
        });
        $[1] = extensionType;
        $[2] = t2;
    } else t2 = $[2];
    const captureConfig = t2;
    let t3;
    if ($[3] !== captureConfig || $[4] !== profileKey) {
        t3 = {
            config: captureConfig,
            samplingKey: profileKey
        };
        $[3] = captureConfig;
        $[4] = profileKey;
        $[5] = t3;
    } else t3 = $[5];
    const { enabled: enabled, capture: capture } = (0, $IiIMy.useAppPerfCaptureStrategy)(t3);
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            hasSent.current = false;
            performanceTimelineRef.current.events = [];
            elapsedBaselineMark.current = (0, $1uzCd.getPerformanceMark)();
            profileIdRef.current = null;
        };
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== profileKey) {
        t5 = [
            profileKey
        ];
        $[7] = profileKey;
        $[8] = t5;
    } else t5 = $[8];
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[9] !== appType || $[10] !== appVersion || $[11] !== captureConfig.version || $[12] !== forgeEnvironment) {
        t6 = {
            appType: appType,
            forgeEnvironment: forgeEnvironment,
            appVersion: appVersion,
            eventVersion: captureConfig.version
        };
        $[9] = appType;
        $[10] = appVersion;
        $[11] = captureConfig.version;
        $[12] = forgeEnvironment;
        $[13] = t6;
    } else t6 = $[13];
    const staticAttributes = t6;
    let t7;
    if ($[14] !== capture || $[15] !== staticAttributes) {
        t7 = ()=>{
            if (!profileIdRef.current) profileIdRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
            capture({
                profileId: profileIdRef.current,
                events: $7f6ed9fbce688d04$var$offsetElapsedTimestamps(performanceTimelineRef.current.events, elapsedBaselineMark.current),
                navigationTimeStart: elapsedBaselineMark.current,
                ...staticAttributes
            });
            hasSent.current = true;
        };
        $[14] = capture;
        $[15] = staticAttributes;
        $[16] = t7;
    } else t7 = $[16];
    const captureAnalytics = t7;
    let t8;
    let t9;
    if ($[17] !== captureAnalytics || $[18] !== enabled) {
        t8 = ()=>{
            if (!enabled || hasSent.current) return;
            const timeout = setTimeout(()=>{
                captureAnalytics();
            }, $7f6ed9fbce688d04$export$e943a7fca26f09e4);
            return ()=>{
                clearTimeout(timeout);
            };
        };
        t9 = [
            enabled,
            captureAnalytics
        ];
        $[17] = captureAnalytics;
        $[18] = enabled;
        $[19] = t8;
        $[20] = t9;
    } else {
        t8 = $[19];
        t9 = $[20];
    }
    (0, $42omo.useEffect)(t8, t9);
    let t10;
    if ($[21] !== children) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f6ed9fbce688d04$export$433ff3d294755246.Provider, {
            value: performanceTimelineRef
        }, children);
        $[21] = children;
        $[22] = t10;
    } else t10 = $[22];
    return t10;
} : ({ children: children, appType: appType, forgeEnvironment: forgeEnvironment, profileKey: profileKey, extensionType: extensionType, appVersion: appVersion })=>{
    // Rely on refs to avoid re-rendering all children components when the state changes
    const performanceTimelineRef = (0, $42omo.useRef)({
        events: [],
        listeners: new Set()
    });
    const hasSent = (0, $42omo.useRef)(false);
    const elapsedBaselineMark = (0, $42omo.useRef)(0);
    // Store profile ID in ref to generate once per session and reuse
    const profileIdRef = (0, $42omo.useRef)(null);
    const captureConfig = (0, $kynWP.getAppPerfCaptureConfig)({
        module: extensionType
    });
    const { enabled: enabled, capture: capture } = (0, $IiIMy.useAppPerfCaptureStrategy)({
        config: captureConfig,
        samplingKey: profileKey
    });
    // Reset state when profileKey changes
    (0, $42omo.useEffect)(()=>{
        hasSent.current = false;
        performanceTimelineRef.current.events = [];
        elapsedBaselineMark.current = (0, $1uzCd.getPerformanceMark)();
        profileIdRef.current = null; // Reset profile ID for new session
    // Use `profileKey` to reset all state when the extension or entryPoint changes to collect a new set of analytics
    }, [
        profileKey
    ]);
    // Memoize static attributes to avoid recreating on every render
    const staticAttributes = (0, $42omo.useMemo)(()=>({
            appType: appType,
            forgeEnvironment: forgeEnvironment,
            appVersion: appVersion,
            eventVersion: captureConfig.version
        }), [
        appType,
        forgeEnvironment,
        appVersion,
        captureConfig.version
    ]);
    // Create stable callback for capturing analytics
    const captureAnalytics = (0, $42omo.useCallback)(()=>{
        // Generate profile ID once per session
        if (!profileIdRef.current) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        profileIdRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        capture({
            profileId: profileIdRef.current,
            events: $7f6ed9fbce688d04$var$offsetElapsedTimestamps(performanceTimelineRef.current.events, elapsedBaselineMark.current),
            // Time difference since this event was fired and since page loaded
            navigationTimeStart: elapsedBaselineMark.current,
            ...staticAttributes
        });
        hasSent.current = true;
    }, [
        capture,
        staticAttributes
    ]);
    // Send all collected performance related analytics in a single event
    (0, $42omo.useEffect)(()=>{
        if (!enabled || hasSent.current) return;
        const timeout = setTimeout(()=>{
            captureAnalytics();
        }, $7f6ed9fbce688d04$export$e943a7fca26f09e4);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        enabled,
        captureAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f6ed9fbce688d04$export$433ff3d294755246.Provider, {
        value: performanceTimelineRef
    }, children);
};
const $7f6ed9fbce688d04$export$ec3453941beb4064 = (0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('forge-ui-app-perf-tracking-enabled'), $7f6ed9fbce688d04$export$9cdba3450d9c6cdc, (0, $42omo.Fragment));
module.exports["PerformanceAnalyticsContext"] = $7f6ed9fbce688d04$export$433ff3d294755246;
module.exports["PERFORMANCE_ANALYTICS_INTERVAL"] = $7f6ed9fbce688d04$export$e943a7fca26f09e4;
module.exports["PerformanceAnalyticsProviderRollout"] = $7f6ed9fbce688d04$export$ec3453941beb4064;

});

parcelRegister("3Faxc", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $iXCQx = parcelRequire("iXCQx");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");

const $addf217f71a4534b$var$cssActionItem = null;
const $addf217f71a4534b$var$messages = (0, $aXWIB.defineMessages)({
    navigationWarningTitle: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-title",
        defaultMessage: "Opening external page on {hostname}"
    },
    navigationWarningBody: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-body",
        defaultMessage: "is sending you to an external page. Ensure you trust that page before you continue."
    },
    navigationWarningBodyNoAppName: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-body-no-app-name",
        defaultMessage: "This app is sending you to an external page. Ensure you trust that page before you continue."
    },
    navigationWarningAppSecurityLink: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-app-security-link",
        defaultMessage: "Learn more about app security"
    },
    navigationWarningCancelButton: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-cancel-button",
        defaultMessage: "Cancel"
    },
    navigationWarningContinueButton: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-continue-button",
        defaultMessage: "Continue"
    }
});
const $addf217f71a4534b$var$ModalFooter = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { onCancel: onCancel, onConfirm: onConfirm } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _1bsb1osq"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf"
        ]);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== intl) {
        t3 = intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningAppSecurityLink);
        $[2] = intl;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
            href: "https://go.atlassian.com/forge-help-app-security",
            appearance: "subtle-link",
            target: "_blank",
            rel: "noopener noreferrer",
            className: t2
        }, t3);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $gMc0m.default)([
            "_1e0c116y _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr"
        ]);
        t6 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
        ]);
        $[6] = t5;
        $[7] = t6;
    } else {
        t5 = $[6];
        t6 = $[7];
    }
    let t7;
    if ($[8] !== intl) {
        t7 = intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningCancelButton);
        $[8] = intl;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== onCancel || $[11] !== t7) {
        t8 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t6
        }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
            appearance: "subtle",
            onClick: onCancel
        }, t7));
        $[10] = onCancel;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
        ]);
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== intl) {
        t10 = intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningContinueButton);
        $[14] = intl;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== onConfirm || $[17] !== t10) {
        t11 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t9
        }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
            appearance: "warning",
            onClick: onConfirm
        }, t10));
        $[16] = onConfirm;
        $[17] = t10;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== t11 || $[20] !== t8) {
        t12 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t5
        }, t8, t11);
        $[19] = t11;
        $[20] = t8;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== t12 || $[23] !== t4) {
        t13 = /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement("div", {
            className: t1
        }, t4, t12));
        $[22] = t12;
        $[23] = t4;
        $[24] = t13;
    } else t13 = $[24];
    return t13;
} : ({ onCancel: onCancel, onConfirm: onConfirm })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- to avoid import of css module from @compiled/react
    , {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _1bsb1osq"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        href: "https://go.atlassian.com/forge-help-app-security",
        appearance: "subtle-link",
        target: "_blank",
        rel: "noopener noreferrer",
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf"
        ])
    }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningAppSecurityLink)), /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1e0c116y _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onCancel
    }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningCancelButton))), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "warning",
        onClick: onConfirm
    }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningContinueButton))))));
};
const $addf217f71a4534b$export$72ece4fe8d8dbff9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { url: url, extensionTitle: extensionTitle, onConfirm: onConfirm, onCancel: onCancel } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== intl || $[1] !== url.hostname) {
        t1 = intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningTitle, {
            hostname: url.hostname
        });
        $[0] = intl;
        $[1] = url.hostname;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), {
            appearance: "warning"
        }, t1));
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== extensionTitle || $[6] !== intl) {
        t3 = extensionTitle ? /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            as: "p"
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            as: "strong"
        }, extensionTitle), " ", intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningBody)) : /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            as: "p"
        }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningBodyNoAppName));
        $[5] = extensionTitle;
        $[6] = intl;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== url.href) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            as: "p",
            maxLines: 1
        }, url.href);
        $[8] = url.href;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, t3, t4);
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== onCancel || $[14] !== onConfirm) {
        t6 = /*#__PURE__*/ $42omo.createElement($addf217f71a4534b$var$ModalFooter, {
            onCancel: onCancel,
            onConfirm: onConfirm
        });
        $[13] = onCancel;
        $[14] = onConfirm;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== onCancel || $[17] !== t2 || $[18] !== t5 || $[19] !== t6) {
        t7 = /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
            onClose: onCancel
        }, t2, t5, t6));
        $[16] = onCancel;
        $[17] = t2;
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : ({ url: url, extensionTitle: extensionTitle, onConfirm: onConfirm, onCancel: onCancel })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: onCancel
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningTitle, {
        hostname: url.hostname
    }))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, extensionTitle ? /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p"
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "strong"
    }, extensionTitle), ' ', intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningBody)) : /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p"
    }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningBodyNoAppName)), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p",
        maxLines: 1
    }, url.href)), /*#__PURE__*/ $42omo.createElement($addf217f71a4534b$var$ModalFooter, {
        onCancel: onCancel,
        onConfirm: onConfirm
    })));
};
module.exports["ExternalLinkModal"] = $addf217f71a4534b$export$72ece4fe8d8dbff9;

});

parcelRegister("kxKUs", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $4No1R = parcelRequire("4No1R");


var $42omo = parcelRequire("42omo");


var $5yfLD = parcelRequire("5yfLD");


var $9zb43 = parcelRequire("9zb43");


var $inPa6 = parcelRequire("inPa6");


var $lzcvT = parcelRequire("lzcvT");


var $8z9j5 = parcelRequire("8z9j5");


var $dWSaf = parcelRequire("dWSaf");


var $4c2yb = parcelRequire("4c2yb");


var $b4nol = parcelRequire("b4nol");


var $luNHV = parcelRequire("luNHV");


var $7KMPr = parcelRequire("7KMPr");

var $kaOT1 = parcelRequire("kaOT1");


var $5U2YR = parcelRequire("5U2YR");


var $cMiG0 = parcelRequire("cMiG0");


var $3e6Uc = parcelRequire("3e6Uc");


var $irOoi = parcelRequire("irOoi");


var $iqcSr = parcelRequire("iqcSr");

var $ijfiP = parcelRequire("ijfiP");


var $1JDPF = parcelRequire("1JDPF");


var $dh538 = parcelRequire("dh538");


var $974zo = parcelRequire("974zo");


var $2gNWY = parcelRequire("2gNWY");


var $6oQb1 = parcelRequire("6oQb1");


var $1uzCd = parcelRequire("1uzCd");


var $iUjrf = parcelRequire("iUjrf");


var $buzAL = parcelRequire("buzAL");


var $hQK66 = parcelRequire("hQK66");


var $3qMxz = parcelRequire("3qMxz");


var $fyIiK = parcelRequire("fyIiK");

let $2472ed5b4088eda9$var$storedBaseUrlRelay = '';
let $2472ed5b4088eda9$var$createIframeBridge = null;
let $2472ed5b4088eda9$var$postRobotSend = null;


// bridge-core import relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    $2472ed5b4088eda9$var$createIframeBridge = (parcelRequire("eLUTa")).createIframeBridge;
    $2472ed5b4088eda9$var$postRobotSend = (parcelRequire("eLUTa")).postRobotSend;
}
const $2472ed5b4088eda9$var$mapCustomBridgeMethods = ({ customBridgeMethods: customBridgeMethods, withFausMessageForwarder: withFausMessageForwarder, isUIKitEmbeddedMacro: isUIKitEmbeddedMacro, embeddedMacroLocalId: embeddedMacroLocalId })=>{
    if (!customBridgeMethods) return {};
    return Object.keys(customBridgeMethods).reduce((acc, key)=>{
        return {
            ...acc,
            [key]: withFausMessageForwarder(key, (payload)=>{
                const data = isUIKitEmbeddedMacro ? (0, $fyIiK.transformDataForEmbeddedMacros)(key, embeddedMacroLocalId, payload?.data) : payload?.data;
                return customBridgeMethods[key](data);
            })
        };
    }, {});
};
class $2472ed5b4088eda9$export$d86296fe47e644cc extends Error {
    constructor(cause){
        super(cause);
    }
}
const $2472ed5b4088eda9$var$MACRO_MODULE_NAME = 'xen:macro';
const $2472ed5b4088eda9$export$c2bd95920a67f979 = 'forge-adf-renderer';
// Tracks re-initialisation of the bridge and logs a warning to console and analytics
const $2472ed5b4088eda9$var$useBridgeReinitTracker = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $42omo.useRef)(0);
    let t0;
    let t1;
    if ($[0] !== trackExtensionRemounted) {
        t0 = ()=>{
            try {
                mountedCount.current = mountedCount.current + 1;
                if (mountedCount.current > 1) {
                    trackExtensionRemounted({
                        mountCount: mountedCount.current,
                        isUseBridgeReinit: true
                    });
                    console.warn(`Warning: useBridge re-initialised the bridge ${mountedCount.current} times.`);
                }
            } catch  {}
        };
        t1 = [
            mountedCount,
            trackExtensionRemounted
        ];
        $[0] = trackExtensionRemounted;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    const trackBridgeReinited = (0, $hQK66.useCallbackOne)(t0, t1);
    return trackBridgeReinited;
} : ()=>{
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $42omo.useRef)(0);
    const trackBridgeReinited = (0, $hQK66.useCallbackOne)(()=>{
        try {
            mountedCount.current += 1;
            if (mountedCount.current > 1) {
                trackExtensionRemounted({
                    mountCount: mountedCount.current,
                    isUseBridgeReinit: true
                });
                // eslint-disable-next-line no-console
                console.warn(`Warning: useBridge re-initialised the bridge ${mountedCount.current} times.`);
            }
        } catch  {}
    }, [
        mountedCount,
        trackExtensionRemounted
    ]);
    return trackBridgeReinited;
};
const $2472ed5b4088eda9$export$23a7a1286dcfa590 = ({ cloudId: cloudId, theme: theme, surfaceColor: surfaceColor, origin: origin, api: api, customBridgeMethods: customBridgeMethods, onLoad: onLoad, isResizable: isResizable, height: height, environment: environment, extension: extension, iframeRef: iframeRef, contextIds: contextIds, isInModal: isInModal, localId: localId, isEmbeddedMacro: isEmbeddedMacro = false, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, extensionPayload: extensionPayload, extensionData: extensionData })=>{
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [loadedAt, setLoadedAt] = (0, $42omo.useState)(null);
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    // This ref avoids the api object ending up in the dep array
    // of the effect that calls createIframeBridge. It means that
    // people can pass anonymous functions as the api without the
    // bridge being re-created every render.
    const apiRef = (0, $42omo.useRef)(api);
    (0, $42omo.useEffect)(()=>{
        apiRef.current = api;
    }, [
        api
    ]);
    // Used for passing embedded macro extension object to
    // parent bodied macro Custom UI renderer.
    const extensionRef = (0, $42omo.useRef)(extension);
    // Used for passing embedded macro extensionPayload to  modal renderer.
    // Only used in editor view mode so config will always be up to date.
    const extensionPayloadRef = (0, $42omo.useRef)(extensionPayload);
    // Used for passing embedded macro extensionData to modal renderer
    // Extension data is a static object containing context values for the app, so no update needed.
    const extensionDataRef = (0, $42omo.useRef)(extensionData);
    const enableThemingRef = (0, $42omo.useRef)();
    const setThemeRef = (0, $42omo.useRef)();
    // this ref tracks the initial theme to avoid unnecessary theme updates.
    // specifically, it is used in createIframeBridge during the initial forge runtime initialization,
    // so that the iframe can set the theme correctly on the ready event (initial handshake).
    // however, subsequent theme should not cause createIframeBridge to be called again.
    const initialThemeRef = (0, $42omo.useRef)({
        theme: theme,
        surfaceColor: surfaceColor
    });
    const trackBridgeReinited = $2472ed5b4088eda9$var$useBridgeReinitTracker();
    (0, $42omo.useEffect)(()=>{
        if (!setThemeRef.current) return;
        // we track the theme changes here to avoid calling createIframeBridge (expensive and error prone) unnecessarily
        initialThemeRef.current = {
            theme: theme,
            surfaceColor: surfaceColor
        };
        setThemeRef.current(theme, surfaceColor, environment);
        (0, $luNHV.emit)('FORGE_CORE_THEME_CHANGED', {
            theme: theme
        });
    }, [
        theme,
        surfaceColor,
        loading,
        environment
    ]);
    // same as above, but for customBridgeMethods
    const customBridgeMethodsRef = (0, $42omo.useRef)(customBridgeMethods);
    (0, $42omo.useEffect)(()=>{
        customBridgeMethodsRef.current = customBridgeMethods;
    }, [
        customBridgeMethods
    ]);
    const [errorExtensionDetails, setErrorExtensionDetails] = (0, $42omo.useState)({
        id: extension.id,
        properties: extension.properties,
        type: extension.type,
        environmentType: extension.environmentType,
        appOwnerAccountId: extension.appOwner?.accountId
    });
    const tracing = (0, $kaOT1.useTracingContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trackForgeFeatureFlagEvent: trackForgeFeatureFlagEvent, trackObjectStoreAction: trackObjectStoreAction, trackHandShakeMetric: trackHandShakeMetric } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    (0, $42omo.useEffect)(()=>{
        const { type: type, environmentType: environmentType, properties: properties, appOwnerAccountId: appOwnerAccountId, id: id } = errorExtensionDetails;
        if (extension.id !== id || extension.type !== type || extension.environmentType !== environmentType || extension.appOwner?.accountId !== appOwnerAccountId || !(0, (/*@__PURE__*/$parcel$interopDefault($5yfLD)))(extension.properties, properties)) setErrorExtensionDetails({
            id: extension.id,
            properties: extension.properties,
            type: extension.type,
            environmentType: extension.environmentType,
            appOwnerAccountId: extension.appOwner?.accountId
        });
    }, [
        extension,
        errorExtensionDetails
    ]);
    const { id: id, installationId: installationId } = extension;
    // Need to retrieve appId here because extension.appId could be undefined in certain products. For example, Jira extensions do not provide the appId.
    const appId = extension.appId ?? (0, $ijfiP.parseExtensionId)(extension.id).appId;
    const getAppForgeUIExtensions = (0, $1JDPF.useGetAppForgeUIExtensions)({
        appId: appId,
        environmentId: extension.environmentId,
        moduleType: extension.type,
        contextIds: contextIds,
        context: {},
        includeHidden: false,
        cloudId: cloudId,
        bypassNewForgeExtensionListCall: true
    });
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    // Query to retrieve the base url of a tenant.
    // The same Atlassian tenant could have a different custom domain for each product.
    // We retrieve the underlying Atlassian domain here to use for URL creation in routing to support cross custom domain routing
    const getBaseUrl = (0, $42omo.useCallback)(async ()=>{
        if (!cloudId) return window.location.origin;
        if (relayEnvironment) {
            if ($2472ed5b4088eda9$var$storedBaseUrlRelay) return $2472ed5b4088eda9$var$storedBaseUrlRelay;
            const observable = (0, $3e6Uc.fetchQuery)(relayEnvironment, (0, $4No1R.default), {
                cloudIds: [
                    cloudId
                ]
            });
            return new Promise((resolve, reject)=>{
                let settled = false;
                observable.subscribe({
                    next: (data)=>{
                        if (settled) return;
                        settled = true;
                        const baseUrl = data?.tenantContexts?.[0]?.cloudUrl ?? '';
                        $2472ed5b4088eda9$var$storedBaseUrlRelay = baseUrl;
                        resolve(baseUrl);
                    },
                    error: (err)=>{
                        if (!settled) {
                            settled = true;
                            reject(err);
                        }
                    },
                    complete: ()=>{
                        if (!settled) {
                            settled = true;
                            resolve($2472ed5b4088eda9$var$storedBaseUrlRelay ?? '');
                        }
                    }
                });
            });
        } else return window.location.origin;
    }, [
        cloudId,
        relayEnvironment
    ]);
    const appType = (0, $42omo.useMemo)(()=>(0, $iqcSr.isCustomUI)(extension) ? 'CustomUI' : 'UIKit', [
        extension
    ]);
    const { captureEvent: captureEvent, captureUntrustedEvent: captureUntrustedEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    // The event subscription need to be maintained outside of useEffect to avoid missing events when the createIframeBridge is re-created
    // specifically, createIframeBridge could be re-created when the app "re-render", however, in such cases we do not want to lose the existing event subscriptions
    // after all, we should consider ensure createIframeBridge not to be re-created unnecessarily (only when completely app re-mount is really needed)
    const eventCallbacksRef = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            for (const subscription of eventCallbacksRef.current)subscription.unsubscribe();
            eventCallbacksRef.current = [];
        };
    }, []);
    const { properties: { layout: layout }, type: type, environmentType: environmentType } = extension;
    (0, $42omo.useEffect)(()=>{
        //this should never happen on client side
        if (!$2472ed5b4088eda9$var$createIframeBridge) return;
        const iframeEl = iframeRef.current;
        if (iframeEl?.contentWindow && !loading && typeof loadedAt === 'number') {
            const extensionDetails = {
                appId: appId,
                id: id.split('/').slice(0, 3).join('/'),
                installationId: installationId
            };
            const sendHandshakeMetric = (page)=>{
                return (success, error)=>{
                    trackHandShakeMetric({
                        source: page,
                        success: success,
                        error: error
                    });
                    if (error) {
                        const handshakeError = error instanceof Error ? new Error(`Bridge handshake error: ${error.message}`) : new Error('Unknown bridge handshake error');
                        (0, $7KMPr.captureAndReportError)({
                            error: handshakeError,
                            environment: environment,
                            errorExtensionDetails: errorExtensionDetails,
                            page: page,
                            tracing: tracing
                        });
                    }
                };
            };
            // Only forward when we're the gateway (FAUS). Product (e.g. forge-ui-kit adf-renderer) uses bridge directly.
            // TODO: isEmbeddedMacro prop can be removed after rollout of platform_forge_ui_refactor_macro_parent_type
            const isRenderedInFAUS = page === $2472ed5b4088eda9$export$c2bd95920a67f979;
            const embeddedMacroAdditionalForwardedData = {
                sourceAppId: appId,
                sourceInstallationId: extensionRef.current.installationId,
                sourceEnvironmentId: extensionRef.current.environmentId,
                extension: extensionRef.current,
                isEmbeddedMacroModal: true,
                extensionPayload: extensionPayloadRef.current,
                extensionData: extensionDataRef.current,
                embeddedMacroExtensionDetails: extensionDetails,
                embeddedMacroLocalId: localId
            };
            const withFausMessageForwarder = (methodName, bridgeMethodFn)=>{
                // Only forward when we're the gateway (FAUS). Product (e.g. forge-ui-kit adf-renderer) uses bridge directly.
                const isRenderedInFAUS = page === $2472ed5b4088eda9$export$c2bd95920a67f979;
                const shouldUseMessageForwarder = (0, $dh538.fg)('platform_forge_ui_refactor_macro_parent_type') ? embeddedMacroParentType === 'CustomUI' : isEmbeddedMacro && isRenderedInFAUS;
                return shouldUseMessageForwarder ? (0, $3qMxz.createMessageForwarder)(methodName, embeddedMacroAdditionalForwardedData, $2472ed5b4088eda9$var$postRobotSend, embeddedParentLocalId, extensionDetails) : bridgeMethodFn;
            };
            // Only bodied macros should receive embedded macro messages
            const isBodiedMacro = layout === 'bodied';
            // Confluence embed card has the same origin as top level product
            const isNativeConfluenceEmbeddedCard = ()=>{
                try {
                    window.parent.location.href;
                    return true;
                } catch  {
                    return false;
                }
            };
            const isProductLevel = typeof window !== 'undefined' && (window.location.ancestorOrigins?.length === 0 || isNativeConfluenceEmbeddedCard()) && !isInModal;
            const { open: open } = $2472ed5b4088eda9$var$createIframeBridge({
                theme: initialThemeRef.current.theme,
                surfaceColor: initialThemeRef.current.surfaceColor,
                withDomain: origin,
                withWindow: iframeEl.contentWindow,
                metadata: {
                    env: environment,
                    module: type,
                    product: type.split(':')[0],
                    isFedRamp: (0, $lzcvT.isFedRamp)(),
                    localId: localId
                },
                features: (0, $dWSaf.withMetricsAndAnalytics)({
                    features: {
                        invoke: async ({ data: data })=>{
                            const performanceStart = (0, $1uzCd.getPerformanceMark)();
                            captureEvent({
                                type: 'resolver-invoke-initiated',
                                elapsed: performanceStart
                            });
                            const { onInvoke: onInvoke, onThreeLO: onThreeLO } = apiRef.current;
                            const result = await onInvoke(data);
                            if (result.type === '3lo') return new Promise((resolve, reject)=>{
                                onThreeLO(result.authUrl, ()=>{
                                    const performanceAuthEnd = (0, $1uzCd.getPerformanceMark)();
                                    return onInvoke(data).then((res)=>{
                                        const performanceEnd = (0, $1uzCd.getPerformanceMark)();
                                        captureEvent({
                                            type: 'resolver-invoked',
                                            duration: performanceEnd - performanceStart,
                                            authDuration: performanceAuthEnd - performanceStart,
                                            elapsed: performanceEnd
                                        });
                                        if (res.type === 'ok') {
                                            if (!!data.metadata && (0, $dh538.fg)('forge-ui-return-invocation-metadata')) {
                                                const optsInToRateLimitProperties = data.metadata?.rateLimitProperties === true;
                                                resolve({
                                                    body: res.response,
                                                    metadata: {
                                                        ...optsInToRateLimitProperties ? {
                                                            rateLimitProperties: res.metadata?.rateLimitProperties ?? null
                                                        } : {}
                                                    }
                                                });
                                            } else resolve(res.response);
                                        }
                                        // Unexpected case where 3LO consent requested again after consenting
                                        reject();
                                    }, reject);
                                });
                            });
                            const performanceEnd = (0, $1uzCd.getPerformanceMark)();
                            captureEvent({
                                type: 'resolver-invoked',
                                duration: performanceEnd - performanceStart,
                                authDuration: 0,
                                elapsed: performanceEnd
                            });
                            if (result.type === 'err') throw new Error(result.message);
                            if (!!data.metadata && (0, $dh538.fg)('forge-ui-return-invocation-metadata')) {
                                const optsInToRateLimitProperties = data.metadata?.rateLimitProperties === true;
                                return {
                                    body: result.response,
                                    metadata: {
                                        ...optsInToRateLimitProperties ? {
                                            rateLimitProperties: result.metadata?.rateLimitProperties ?? null
                                        } : {}
                                    }
                                };
                            }
                            return result.response;
                        },
                        initFeatureFlags: async ({ data: data })=>{
                            if (!(0, $dh538.fg)('platform_forge_ff_client_sdk')) return {};
                            const { onInitFeatureFlags: onInitFeatureFlags } = apiRef.current;
                            const result = await onInitFeatureFlags(data);
                            if ((0, $dh538.fg)('platform_forge_ff_ui_analytics')) trackForgeFeatureFlagEvent({
                                appType: appType,
                                appId: appId,
                                baseUrl: window.location.origin,
                                eventType: (0, $b4nol.FeatureFlagEventTypes).INITIALIZATION,
                                success: result.type !== 'err',
                                featureFlagEnv: data.user?.statsigEnvironment?.tier || (0, $b4nol.FeatureFlagEnv).development,
                                forgeEnvironment: environmentType
                            });
                            if (result.type === 'err') return {};
                            return result.response;
                        },
                        emitFrontendCustomMetric: async ({ data: data })=>{
                            if (!(0, $dh538.fg)('platform_forge_frontend_custom_metrics')) return;
                            try {
                                await apiRef.current.onEmitFrontendCustomMetric?.(data);
                            } catch  {
                            // Silent fail: emitting a metric must never surface an error to the app.
                            }
                        },
                        trackFeatureFlagEvent: async ({ data: data })=>{
                            if (!(0, $dh538.fg)('platform_forge_ff_ui_analytics')) return;
                            const allowedEventTypes = [
                                (0, $b4nol.FeatureFlagEventTypes).CHECKFLAG.toUpperCase()
                            ];
                            try {
                                // basic validations
                                if (!data.type || !allowedEventTypes.includes(data.type.toUpperCase())) return;
                                if (data.type.toUpperCase() === (0, $b4nol.FeatureFlagEventTypes).CHECKFLAG.toUpperCase() && data.properties.name && (data.properties.name.length < 3 || data.properties.name.length > 50)) return;
                                if (typeof data.properties.success !== 'boolean') return;
                                if (!(data.properties.environment && data.properties.environment.toLowerCase() in (0, $b4nol.FeatureFlagEnv))) return;
                                trackForgeFeatureFlagEvent({
                                    appType: appType,
                                    appId: appId,
                                    baseUrl: window.location.origin,
                                    flagName: data.properties.name || '',
                                    eventType: data.type,
                                    success: data.properties.success,
                                    featureFlagEnv: data.properties.environment,
                                    forgeEnvironment: environmentType
                                });
                            } catch  {
                            // all errors are ignored
                            }
                            return;
                        },
                        'iframe-analytics': async ({ data: data })=>{
                            captureUntrustedEvent(data);
                        },
                        ...(0, $dh538.fg)('platform_ufo_3p_segment_timings') ? {
                            'ufo-event': async ({ data: data })=>{
                                captureUntrustedEvent(data);
                            }
                        } : {},
                        getUrl: async ({ data: data })=>{
                            if (data.target) {
                                const path = await (0, $cMiG0.createNavigateTargetPath)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!path) return null;
                                // If the current domain is a custom domain, we need to request for the base url
                                const baseUrl = (0, $2gNWY.isCustomDomain)(window.location.hostname) ? await getBaseUrl() : window.location.origin;
                                // `getUrl` from `@forge/bridge` will return a URL object.
                                // We are returning a string here as a URL object will serialised into a string when being passed across the bridge
                                return `${baseUrl}${path}`;
                            }
                            return null;
                        },
                        navigate: withFausMessageForwarder('navigate', async ({ data: data })=>{
                            // If a NavigationLocation object was provided:
                            if ('target' in data && data.target) {
                                const path = await (0, $cMiG0.createNavigateTargetPath)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!path) {
                                    // eslint-disable-next-line no-console
                                    console.warn('Path was not found for the parameters provided');
                                    return;
                                }
                                // Request for the base url if the current domain is a custom domain
                                if ((0, $2gNWY.isCustomDomain)(window.location.hostname)) {
                                    const baseUrl = await getBaseUrl();
                                    return apiRef.current.onNavigate({
                                        type: data.type,
                                        url: `${baseUrl}${path}`
                                    });
                                } else return apiRef.current.onNavigate({
                                    type: data.type,
                                    url: path
                                });
                            }
                            return apiRef.current.onNavigate(data);
                        }),
                        reconcile: async ({ data: data })=>{
                            return apiRef.current.reconcile(data);
                        },
                        onError: async ({ data: data })=>{
                            return apiRef.current.onError(data);
                        },
                        reload: withFausMessageForwarder('reload', async ()=>{
                            (0, $4c2yb.reload)();
                        }),
                        refresh: async ()=>{
                            return apiRef.current.refresh();
                        },
                        // WARNING — BAD PAYLOAD SHAPE FOR V2 (do not replicate for new bridge methods)
                        //
                        // The handlers below (`submit`, `onClose`, `close`, `openModal`) incorrectly pass
                        // the raw port-rpc event object `{ data: payload }` to `apiRef.current.*` instead
                        // of the unwrapped `payload` directly. This means product-side `BridgeConfig`
                        // callbacks receive `{ data: payload }` and must access `opts.data` to get the
                        // actual value — a leaky abstraction.
                        //
                        // New bridge methods should follow the pattern used by `fetchProduct`/`fetchRemote`/`reconcile`
                        // below: destructure `{ data }` from the port-rpc event and pass `data` directly
                        // to `apiRef.current.*`. The v2 bridge path (`bridge-config-delegates.ts`) already
                        // re-wraps these specific keys as `{ data: payload }` to maintain backward
                        // compatibility with existing product callbacks.
                        //
                        // Do NOT copy this pattern for new bridge methods.
                        submit: async (payload)=>{
                            return apiRef.current.submit(payload);
                        },
                        open: withFausMessageForwarder('open', async ()=>{
                            return apiRef.current.open();
                        }),
                        onClose: async (payload)=>{
                            return apiRef.current.onClose(payload);
                        },
                        close: async (payload)=>{
                            return apiRef.current.close(payload);
                        },
                        emitReadyEvent: withFausMessageForwarder('emitReadyEvent', async ()=>{
                            captureEvent({
                                type: 'emit-ready-event',
                                elapsed: (0, $1uzCd.getPerformanceMark)()
                            });
                            return apiRef.current.emitReadyEvent();
                        }),
                        getContext: ()=>{
                            return apiRef.current.getContext();
                        },
                        openModal: withFausMessageForwarder('openModal', async (payload)=>{
                            return apiRef.current.openModal(payload);
                        }),
                        createHistory: async ()=>{
                            return apiRef.current.createHistory();
                        },
                        fetchProduct: async ({ data: data })=>{
                            return apiRef.current.fetchProduct(data);
                        },
                        fetchRemote: async ({ data: data })=>{
                            return apiRef.current.fetchRemote(data);
                        },
                        showFlag: withFausMessageForwarder('showFlag', async ({ data: data })=>{
                            const flagActions = data.actions?.map((action)=>{
                                const { onClick: onClick } = action;
                                return {
                                    ...action,
                                    onClick: onClick ? ()=>onClick() : ()=>{}
                                };
                            });
                            return apiRef.current.showFlag({
                                ...data,
                                actions: flagActions
                            });
                        }),
                        closeFlag: withFausMessageForwarder('closeFlag', async ({ data: data })=>apiRef.current.closeFlag(data)),
                        on: async (payload)=>{
                            const { event: event, callback: callback } = payload.data;
                            const subscription = (0, $luNHV.on)(event, callback, extensionDetails);
                            eventCallbacksRef.current.push(subscription);
                            return {
                                unsubscribe: ()=>{
                                    eventCallbacksRef.current.splice(eventCallbacksRef.current.indexOf(subscription), 1);
                                    subscription.unsubscribe();
                                }
                            };
                        },
                        onPublic: async (payload)=>{
                            const { event: event, callback: callback } = payload.data;
                            const subscription = (0, $luNHV.onPublic)(event, callback, extensionDetails);
                            eventCallbacksRef.current.push(subscription);
                            return {
                                unsubscribe: ()=>{
                                    eventCallbacksRef.current.splice(eventCallbacksRef.current.indexOf(subscription), 1);
                                    subscription.unsubscribe();
                                }
                            };
                        },
                        emitPublic: async (payload)=>{
                            return apiRef.current.emitPublic?.(payload.data);
                        },
                        emit: withFausMessageForwarder('emit', async (payload)=>{
                            return (0, $luNHV.emit)(payload.data.event, payload.data.payload, payload.data.embeddedMacroExtensionDetails || extensionDetails);
                        }),
                        enableTheming: async ()=>{
                            await enableThemingRef.current?.();
                            const currentTheme = (0, $8z9j5.default)();
                            const surfaceColor = null;
                            setThemeRef.current?.(currentTheme, surfaceColor, environment);
                        },
                        changeWindowTitle: async ({ data: data })=>{
                            apiRef.current.changeWindowTitle(data);
                        },
                        getFrameId: async ()=>{
                            return apiRef.current.getFrameId();
                        },
                        getFrameDispatch: async ()=>{
                            return apiRef.current.getFrameDispatch();
                        },
                        subscribeRealtimeChannel: async (payload)=>{
                            return apiRef.current.subscribeRealtimeChannel?.(payload);
                        },
                        publishRealtimeChannel: async (payload)=>{
                            return apiRef.current.publishRealtimeChannel?.(payload);
                        },
                        openRovo: withFausMessageForwarder('openRovo', async ({ data: data })=>{
                            return apiRef.current.openRovo?.(data);
                        }),
                        isRovoEnabled: withFausMessageForwarder('isRovoEnabled', async ()=>{
                            if (!cloudId) return false;
                            return (0, $974zo.getIsRovoEnabled)({
                                cloudId: cloudId,
                                relayEnvironment: relayEnvironment
                            });
                        }),
                        trackObjectStoreAction: async ({ data: data })=>{
                            trackObjectStoreAction({
                                appType: appType,
                                appId: appId,
                                action: data.action,
                                forgeEnvironment: environmentType
                            });
                        },
                        ...(0, $buzAL.getUseBridgePermissionFunctions)(apiRef),
                        ...$2472ed5b4088eda9$var$mapCustomBridgeMethods({
                            customBridgeMethods: customBridgeMethodsRef.current,
                            isUIKitEmbeddedMacro: (0, $dh538.fg)('platform_forge_ui_refactor_macro_parent_type') ? embeddedMacroParentType === 'UIKit' : isEmbeddedMacro && !isRenderedInFAUS,
                            embeddedMacroLocalId: localId,
                            withFausMessageForwarder: withFausMessageForwarder
                        })
                    },
                    page: page,
                    environment: environment,
                    forgeEnvironment: environmentType,
                    errorExtensionDetails: errorExtensionDetails,
                    createAnalyticsEvent: createAnalyticsEvent,
                    tracing: tracing
                }),
                sendHandshakeMetric: sendHandshakeMetric(page),
                shouldReceiveEmbeddedMacroMessages: isBodiedMacro && isProductLevel
            });
            if (isResizable) {
                const isInNonJSMResizableModal = isInModal && !type?.startsWith('jiraServiceManagement');
                const isInInlineMacro = layout === 'inline' && type === $2472ed5b4088eda9$var$MACRO_MODULE_NAME;
                (0, $9zb43.iframeResizer)({
                    heightCalculationMethod: 'bodyScroll',
                    widthCalculationMethod: 'bodyScroll',
                    scrolling: true,
                    // @ts-ignore minHeight can be a string
                    minHeight: height,
                    sizeWidth: (0, $dh538.fg)('forge-ui-enable-resizable-custom-ui-modal') ? isInNonJSMResizableModal || isInInlineMacro : isInInlineMacro,
                    initCallback: (iframe)=>{
                        iframe?.iFrameResizer?.resize();
                    }
                }, iframeEl);
            }
            const { close: close, enableTheming: enableTheming, setTheme: setTheme } = open();
            setThemeRef.current = setTheme;
            enableThemingRef.current = enableTheming;
            // this tracking is to identify re-initializations of the bridge, which should never happen (or we should try avoid)
            // during the lifecycle of a Forge app. re-initialise bridge could be expensive and error prone (losing existing event subscriptions, etc)
            trackBridgeReinited();
            return ()=>{
                close?.(); // close may be undefined here if createIframeBridge call fails
                iframeEl?.iFrameResizer && iframeEl?.iFrameResizer.removeListeners();
            };
        }
    // We intentionally add react-hooks/exhaustive-deps disable here, so that we don't blindly
    // add new dependencies without considering the impact of re-creating the bridge.
    // The following dependencies are excluded for the reasons stated:
    //   - trackBridgeReinited - it's memoised and used for observability and should not trigger bridge recreation
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getBaseUrl,
        iframeRef,
        origin,
        loading,
        page,
        isResizable,
        height,
        environment,
        errorExtensionDetails,
        id,
        layout,
        type,
        environmentType,
        installationId,
        tracing,
        createAnalyticsEvent,
        loadedAt,
        getAppForgeUIExtensions,
        appType,
        captureEvent,
        captureUntrustedEvent,
        appId,
        trackForgeFeatureFlagEvent,
        trackObjectStoreAction,
        isInModal,
        localId,
        isEmbeddedMacro,
        embeddedMacroParentType,
        embeddedParentLocalId
    ]);
    // [WARN] Please take careful consideration when adding new dependencies to the above useEffect.
    // createIframeBridge is expensive to call and re-creating the bridge could lead to lost event subscriptions.
    // - Try to avoid adding dependencies that could change on every render (e.g. objects or functions defined inline).
    // - If you need to add a function, consider wrapping it in useCallbackOne / useRef / useMemoOne to stabilise the reference.
    // - Please ensure multiple revewers in the Forge UI team review and approve the change.
    // - As the standard lint for dependency array is disabled, please ensure the dependency array is kept up to date with necessary dependencies.
    return {
        loading: loading,
        iframeProps: {
            ref: iframeRef,
            onLoad: ()=>{
                onLoad && onLoad();
                setLoading(false);
                setLoadedAt(Date.now());
            }
        }
    };
};
module.exports["BridgeClientError"] = $2472ed5b4088eda9$export$d86296fe47e644cc;
module.exports["useBridge"] = $2472ed5b4088eda9$export$23a7a1286dcfa590;

});

parcelRegister("i5CVI", function(module, exports) {
function $6828e685c7239bdd$export$ff7962acd6052c28(url, type, push) {
    switch(type){
        case 'new-tab':
            window.open(url, '_blank', 'noopener noreferrer');
            break;
        case 'same-tab':
            if (push) push(url);
            else window.location.href = url;
            break;
    }
}
module.exports["navigate"] = $6828e685c7239bdd$export$ff7962acd6052c28;

});

parcelRegister("2kGKp", function(module, exports) {
const $676d2d098e4ba6be$export$5a759dc7a1cfb72a = ()=>{
    return window.location.origin;
};
module.exports["getOrigin"] = $676d2d098e4ba6be$export$5a759dc7a1cfb72a;

});

parcelRegister("kTcrU", function(module, exports) {

var $2kGKp = parcelRequire("2kGKp");

const $3716a239e20d61f7$var$emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Filters out all parameters that may be used for malicious purposes such as attaching local files or adding bcc recipients
// Only subject and body are allowed
const $3716a239e20d61f7$var$filterMailtoParams = (mailtoLink)=>{
    try {
        const url = new URL(mailtoLink);
        const params = url.searchParams;
        const email = url.pathname;
        let newParams = '';
        if (!$3716a239e20d61f7$var$emailRegex.test(email)) // throw empty error for makeUrl to catch
        throw new Error();
        if (params.has('subject')) newParams += 'subject=' + encodeURIComponent(params.get('subject') || '');
        if (params.has('body')) {
            newParams += newParams ? '&body=' : 'body=';
            newParams += encodeURIComponent(params.get('body') || '');
        }
        return `${url.protocol}${email}` + (newParams ? '?' + newParams : '');
    } catch (error) {
        // throw empty error for makeUrl to catch
        throw new Error();
    }
};
function $3716a239e20d61f7$export$e98ca45c96b2aafe(urlString) {
    try {
        if (urlString.startsWith('mailto:')) return new URL($3716a239e20d61f7$var$filterMailtoParams(urlString));
        if (urlString.startsWith('tel:')) // For telephone links, we just return the URL as is
        return new URL(urlString);
        // Check if URL starts with a custom URL scheme (e.g., forge:\\, spotify:, etc.)
        const customURLSchemeRegex = /^[a-zA-Z]+:(\\\\)?/;
        if (customURLSchemeRegex.test(urlString)) return new URL(urlString);
        // We decode the URL string to handle cases where a malicious app might pass in a URL with encoded characters to bypass our egress checks
        const decodedUrlString = decodeURIComponent(urlString);
        const fullUrl = decodedUrlString.startsWith('/') ? `${(0, $2kGKp.getOrigin)()}${urlString}` : urlString;
        // Checks if `fullUrl` has a protocol(eg. http://, https://, etc), if not, add the `https://` protocol
        const protocolRegex = /^(.*?:\/\/)/;
        const urlWithProtocol = protocolRegex.test(fullUrl) ? fullUrl : `https://${fullUrl}`;
        // We use the URL constructor to validate the URL
        const url = new URL(urlWithProtocol);
        return url;
    } catch  {
        return undefined;
    }
}
module.exports["makeUrl"] = $3716a239e20d61f7$export$e98ca45c96b2aafe;

});

parcelRegister("9v4R2", function(module, exports) {
// domains from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
const $6946f2676d93d3f0$export$bbc6c05835b799fc = [
    'atl-paas.net',
    'atlassian.com',
    'atlassian.net',
    'ss-inf.net',
    'jira.com',
    'bitbucket.org',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net'
];
module.exports["TRUSTED_ROOT_DOMAINS"] = $6946f2676d93d3f0$export$bbc6c05835b799fc;

});

parcelRegister("471wb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("kRUUL")), module.exports);

});

parcelRegister("hBtmC", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5ixVX = parcelRequire("5ixVX");


var $b0R0S = parcelRequire("b0R0S");


var $80yqV = parcelRequire("80yqV");

const $3def292b140f7269$export$773a0bb3e5560a3d = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    const { error: error, extension: extension } = props;
    if ((0, $80yqV.isDeveloperSpaceError)(error ?? "")) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ixVX.ForgeDevSpaceErrorMessage), null);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    const t0 = error ?? "";
    let t1;
    if ($[1] !== extension || $[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b0R0S.ForgeDeprecationMessage), {
            error: t0,
            extension: extension
        });
        $[1] = extension;
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const { error: error, extension: extension } = props;
    if ((0, $80yqV.isDeveloperSpaceError)(error ?? '')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ixVX.ForgeDevSpaceErrorMessage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b0R0S.ForgeDeprecationMessage), {
        error: error ?? '',
        extension: extension
    });
};
module.exports["ForgeAppErrorMessage"] = $3def292b140f7269$export$773a0bb3e5560a3d;

});

parcelRegister("80yqV", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $0aef42f9d85d0e13$export$22d69806bfc9e8c1 = 'INVALID_INVOCATION_RUNTIME_ERROR';
const $0aef42f9d85d0e13$var$DEVELOPER_SPACE_SETUP_INCOMPLETE = 'DEVELOPER_SPACE_SETUP_INCOMPLETE';
const $0aef42f9d85d0e13$var$MISSING_DEVELOPER_SPACE = 'MISSING_DEVELOPER_SPACE';
const $0aef42f9d85d0e13$var$DEVELOPER_SPACE_ERRORS = [
    $0aef42f9d85d0e13$var$DEVELOPER_SPACE_SETUP_INCOMPLETE,
    $0aef42f9d85d0e13$var$MISSING_DEVELOPER_SPACE
];
const $0aef42f9d85d0e13$export$8f341ade5f91f587 = (errorCode)=>{
    if (!(0, $dh538.fg)('forge-ui-dev-space-error')) return false;
    return $0aef42f9d85d0e13$var$DEVELOPER_SPACE_ERRORS.includes(errorCode);
};
const $0aef42f9d85d0e13$export$575b7edf2360f53e = (error)=>{
    return $0aef42f9d85d0e13$export$8f341ade5f91f587(error) || error === $0aef42f9d85d0e13$export$22d69806bfc9e8c1;
};
module.exports["SANDBOX_DEPRECATION_ERROR"] = $0aef42f9d85d0e13$export$22d69806bfc9e8c1;
module.exports["isDeveloperSpaceError"] = $0aef42f9d85d0e13$export$8f341ade5f91f587;
module.exports["shouldRenderForgeAppErrorMessage"] = $0aef42f9d85d0e13$export$575b7edf2360f53e;

});

parcelRegister("gvvHu", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $CMcde = parcelRequire("CMcde");

function $3044cb8be034d2df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $3044cb8be034d2df$var$AKSectionMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hcdJZ")));

const $3044cb8be034d2df$var$SectionMessageAction = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fLmnB")));
const $3044cb8be034d2df$var$textWrapCss = {
    name: "1089mxj",
    styles: "white-space:pre-wrap"
};
var $3044cb8be034d2df$var$_ref = {
    name: "1axjbqe",
    styles: "width:100%;ul{padding-left:0;}"
};
const $3044cb8be034d2df$var$ErrorPanel = ({ error: error, dispatch: dispatch, isReloadPage: isReloadPage })=>{
    const { message: message, errorDetails: errorDetails, errorMessage: errorMessage } = error;
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const intl = (0, $aXWIB.useIntl)();
    const reinitializeApp = async ()=>{
        if (isReloadPage) window.location.reload();
        setIsLoading(true);
        try {
            if (dispatch) await dispatch({
                type: 'render',
                extensionData: {}
            });
        } finally{
            setIsLoading(false);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $CMcde.Loader), null);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $3044cb8be034d2df$var$_ref
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($3044cb8be034d2df$var$AKSectionMessage, {
        appearance: "error",
        title: message,
        actions: [
            {
                key: 'refresh',
                text: intl.formatMessage(isReloadPage ? $3044cb8be034d2df$var$messages.reloadPage : $3044cb8be034d2df$var$messages.refreshApp),
                onClick: reinitializeApp
            }
        ].map(({ text: text, key: key, onClick: onClick })=>/*#__PURE__*/ (0, $9K4OG.jsx)($3044cb8be034d2df$var$SectionMessageAction, {
                key: key,
                onClick: onClick
            }, text))
    }, errorMessage && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gdv5Z.default), {
        xcss: $3044cb8be034d2df$var$textWrapCss
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), {
        as: "p"
    }, errorMessage)), errorDetails && /*#__PURE__*/ (0, $9K4OG.jsx)("pre", {
        css: $3044cb8be034d2df$var$textWrapCss
    }, errorDetails)));
};
var $3044cb8be034d2df$export$2e2bcd8739ae039 = $3044cb8be034d2df$var$ErrorPanel;
const $3044cb8be034d2df$export$1fe699079d0f690f = ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { error: error } = forgeDoc.props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)($3044cb8be034d2df$var$ErrorPanel, {
        key: "error",
        error: error,
        dispatch: dispatch
    });
};
const $3044cb8be034d2df$var$messages = (0, $aXWIB.defineMessages)({
    refreshApp: {
        id: "confluence.error.panel.refresh.app",
        defaultMessage: "Refresh app"
    },
    reloadPage: {
        id: "confluence.error.panel.reload.page",
        defaultMessage: "Reload page"
    }
});
module.exports["default"] = $3044cb8be034d2df$export$2e2bcd8739ae039;

});

parcelRegister("dQZ64", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $dh538 = parcelRequire("dh538");

// Read via the useForgeUIRuntime hook, not directly.
const $266614fb7f47bfe6$var$ForgeUIRuntimeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $266614fb7f47bfe6$export$63eb6a8e3cf9ab23 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($266614fb7f47bfe6$var$ForgeUIRuntimeContext);
} : ()=>(0, $42omo.useContext)($266614fb7f47bfe6$var$ForgeUIRuntimeContext);
const $266614fb7f47bfe6$export$7b0cb68140ccacd4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { runtime: runtime, children: children } = t0;
    if (!(0, $dh538.fg)("forge-ui-bridge-core-reset")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== runtime) {
        t1 = {
            forgeUIAttributes: {
                runtime: runtime
            }
        };
        $[2] = runtime;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: t1
        }, children);
        $[4] = children;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== runtime || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($266614fb7f47bfe6$var$ForgeUIRuntimeContext.Provider, {
            value: runtime
        }, t2);
        $[7] = runtime;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ runtime: runtime, children: children })=>{
    // Gate the attribute on the bridge-core v2 rollout: only emit `runtime` once
    // `forge-ui-bridge-core-reset` is on, leaving legacy v1 analytics untouched.
    if (!(0, $dh538.fg)('forge-ui-bridge-core-reset')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($266614fb7f47bfe6$var$ForgeUIRuntimeContext.Provider, {
        value: runtime
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: {
            forgeUIAttributes: {
                runtime: runtime
            }
        }
    }, children));
};
module.exports["useForgeUIRuntime"] = $266614fb7f47bfe6$export$63eb6a8e3cf9ab23;
module.exports["ForgeUIRuntimeAnalyticsContext"] = $266614fb7f47bfe6$export$7b0cb68140ccacd4;

});

parcelRegister("amyZ5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $73oQr = parcelRequire("73oQr");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $aoVih = parcelRequire("aoVih");


var $aXWIB = parcelRequire("aXWIB");


var $1Igmn = parcelRequire("1Igmn");


var $lCRfz = parcelRequire("lCRfz");

/**
 * This message is displayed when a forge custom field is using a deprecated modal experience for rendering on the Jira issue view.
 * It is displayed in a modal dialog and is not dismissible.
 * It is one of the steps related to the deprecation of the modal experience which was decided here:
 * https://hello.atlassian.net/wiki/spaces/Ditto/pages/5092641172/DACI+-+Modal+experience+for+the+Forge+custom+fields+on+issue+view+clean-up?focusedCommentId=5111022370
 */ const $3ed8ce0b7cea2643$var$ForgeModalDeprecationMessageInner = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(11);
    const { extension: extension } = props;
    const t0 = extension?.id || "";
    let t1;
    if ($[0] !== t0) {
        t1 = {
            id: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        "atl-attribution": (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            }
        };
        $[2] = t2;
    } else t2 = $[2];
    const data = (0, $irOoi.useLazyLoadQuery)((0, $73oQr.default), t1, t2);
    const intl = (0, $aXWIB.useIntl)();
    let t3;
    if ($[3] !== intl) {
        t3 = intl.formatMessage($3ed8ce0b7cea2643$var$messages.title);
        $[3] = intl;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== data.app?.name || $[6] !== intl) {
        t4 = intl.formatMessage($3ed8ce0b7cea2643$var$messages.message, {
            appName: data.app?.name
        });
        $[5] = data.app?.name;
        $[6] = intl;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            title: t3,
            appearance: "error"
        }, t4);
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : (props)=>{
    const { extension: extension } = props;
    const data = (0, $irOoi.useLazyLoadQuery)((0, $73oQr.default), {
        id: extension?.id || ''
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                }
            }
        }
    });
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: intl.formatMessage($3ed8ce0b7cea2643$var$messages.title),
        appearance: "error"
    }, intl.formatMessage($3ed8ce0b7cea2643$var$messages.message, {
        appName: data.app?.name
    }));
};
const $3ed8ce0b7cea2643$var$ForgeModalDeprecationMessageFallback = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    const intl = (0, $aXWIB.useIntl)();
    const appName = props.extension?.properties.title;
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($3ed8ce0b7cea2643$var$messages.title);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== appName || $[3] !== intl) {
        t1 = intl.formatMessage($3ed8ce0b7cea2643$var$messages.message, {
            appName: appName
        });
        $[2] = appName;
        $[3] = intl;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            title: t0,
            appearance: "error"
        }, t1);
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (props)=>{
    const intl = (0, $aXWIB.useIntl)();
    const appName = props.extension?.properties.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: intl.formatMessage($3ed8ce0b7cea2643$var$messages.title),
        appearance: "error"
    }, intl.formatMessage($3ed8ce0b7cea2643$var$messages.message, {
        appName: appName
    }));
};
const $3ed8ce0b7cea2643$export$5b67d59ebd4f147c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ed8ce0b7cea2643$var$ForgeModalDeprecationMessageFallback, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const fallback = t0;
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ed8ce0b7cea2643$var$ForgeModalDeprecationMessageInner, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== fallback || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lCRfz.RelaySuspensefulBoundary), {
            fallback: fallback,
            errorFallback: fallback
        }, t1);
        $[4] = fallback;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ed8ce0b7cea2643$var$ForgeModalDeprecationMessageFallback, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lCRfz.RelaySuspensefulBoundary), {
        fallback: fallback,
        errorFallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ed8ce0b7cea2643$var$ForgeModalDeprecationMessageInner, props));
};
const $3ed8ce0b7cea2643$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "forge.modal.deprecation.title",
        defaultMessage: "Update your app"
    },
    message: {
        id: "forge.modal.deprecation.message",
        defaultMessage: "Your app {appName} uses the deprecated modal editing experience for custom fields, which is being phased out. Please have your system admin update the app to use inline editing instead. If issues remain, contact the app developer."
    }
});
module.exports["ForgeModalDeprecationMessage"] = $3ed8ce0b7cea2643$export$5b67d59ebd4f147c;

});

parcelRegister("i9F01", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1DHa6 = parcelRequire("1DHa6");


var $dh538 = parcelRequire("dh538");


var $b4nol = parcelRequire("b4nol");

const $dc67d857f203b917$var$sizeStyles = {
    small: "_2rkofajl _4t3i1tmh _1tkenklw _bfhk1bhr",
    medium: "_2rkofajl _4t3ivzbd _1tke1lk4 _bfhk1bhr",
    large: "_2rkofajl _4t3i1rxh _1tke1yw0 _bfhk1bhr",
    xlarge: "_2rkofajl _4t3i10fc _1tkezwhf _bfhk1bhr",
    max: "_2rkofajl _4t3i1osq _bfhk1bhr",
    fullscreen: "_4t3i1osq _bfhk1bhr",
    resizable: "_1reo1wug _18m91wug _2rkofajl _1ul91kdj _p12f18uh _1tkenklw _c71l1osq _1bsb1wug _4t3i1wug _1e0c1txw _2lx21bp4 _bfhk1bhr"
};
const $dc67d857f203b917$var$resizableStyles = {
    jsmModal: "_1reo1wug _18m91wug _4t3i1wug",
    namedSize: "_1reo1wug _18m91wug _4t3i1wug",
    default: "_1reo1wug _18m91wug _2rkofajl _1ul91kdj _p12f18uh _1tkenklw _c71l1osq _1bsb1wug _4t3i1wug _1e0c1txw _2lx21bp4 _bfhk1bhr"
};
const $dc67d857f203b917$var$namedSizes = new Set(Object.keys($dc67d857f203b917$var$sizeStyles));
const $dc67d857f203b917$export$a6d6b74199964ee4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(68);
    const { children: children, size: size, styles: styles, isResizable: isResizable, isJsmModule: isJsmModule } = t0;
    const namedSizeKey = $dc67d857f203b917$var$namedSizes.has(size) ? size : null;
    if ((0, $dh538.fg)("forge-ui-refactor-custom-ui-modal")) {
        if (!namedSizeKey) {
            let t1;
            if ($[0] !== children) {
                t1 = /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, children);
                $[0] = children;
                $[1] = t1;
            } else t1 = $[1];
            return t1;
        }
        if (isJsmModule) {
            const supportsJsmResizable = isResizable && namedSizeKey !== "max" && namedSizeKey !== "fullscreen";
            const t1 = $dc67d857f203b917$var$sizeStyles[namedSizeKey];
            const t2 = supportsJsmResizable && $dc67d857f203b917$var$resizableStyles.jsmModal;
            let t3;
            if ($[2] !== t1 || $[3] !== t2) {
                t3 = (0, $gMc0m.default)([
                    t1,
                    t2
                ]);
                $[2] = t1;
                $[3] = t2;
                $[4] = t3;
            } else t3 = $[4];
            let t4;
            if ($[5] !== children || $[6] !== styles || $[7] !== t3) {
                t4 = /*#__PURE__*/ $42omo.createElement("div", {
                    style: styles,
                    className: t3
                }, children);
                $[5] = children;
                $[6] = styles;
                $[7] = t3;
                $[8] = t4;
            } else t4 = $[8];
            return t4;
        }
        const supportsResizable = isResizable && namedSizeKey !== "max" && namedSizeKey !== "fullscreen";
        const useFullResizableModalStyles = supportsResizable && namedSizeKey === "resizable" && (0, $dh538.fg)("forge-ui-enable-resizable-custom-ui-modal");
        if (useFullResizableModalStyles) {
            const t1 = $dc67d857f203b917$var$sizeStyles[namedSizeKey];
            let t2;
            if ($[9] !== t1) {
                t2 = (0, $gMc0m.default)([
                    t1,
                    $dc67d857f203b917$var$resizableStyles.default
                ]);
                $[9] = t1;
                $[10] = t2;
            } else t2 = $[10];
            let t3;
            if ($[11] !== children || $[12] !== styles || $[13] !== t2) {
                t3 = /*#__PURE__*/ $42omo.createElement("div", {
                    style: styles,
                    className: t2
                }, children);
                $[11] = children;
                $[12] = styles;
                $[13] = t2;
                $[14] = t3;
            } else t3 = $[14];
            return t3;
        }
        const t1 = $dc67d857f203b917$var$sizeStyles[namedSizeKey];
        const t2 = supportsResizable && $dc67d857f203b917$var$resizableStyles.namedSize;
        let t3;
        if ($[15] !== t1 || $[16] !== t2) {
            t3 = (0, $gMc0m.default)([
                t1,
                t2
            ]);
            $[15] = t1;
            $[16] = t2;
            $[17] = t3;
        } else t3 = $[17];
        let t4;
        if ($[18] !== children || $[19] !== styles || $[20] !== t3) {
            t4 = /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: t3
            }, children);
            $[18] = children;
            $[19] = styles;
            $[20] = t3;
            $[21] = t4;
        } else t4 = $[21];
        return t4;
    }
    switch(size){
        case "small":
            {
                const t1 = isResizable && $dc67d857f203b917$var$resizableStyles.namedSize;
                let t2;
                if ($[22] !== t1) {
                    t2 = (0, $gMc0m.default)([
                        $dc67d857f203b917$var$sizeStyles.small,
                        t1
                    ]);
                    $[22] = t1;
                    $[23] = t2;
                } else t2 = $[23];
                let t3;
                if ($[24] !== children || $[25] !== styles || $[26] !== t2) {
                    t3 = /*#__PURE__*/ $42omo.createElement("div", {
                        style: styles,
                        className: t2
                    }, children);
                    $[24] = children;
                    $[25] = styles;
                    $[26] = t2;
                    $[27] = t3;
                } else t3 = $[27];
                return t3;
            }
        case "medium":
            {
                const t1 = isResizable && $dc67d857f203b917$var$resizableStyles.namedSize;
                let t2;
                if ($[28] !== t1) {
                    t2 = (0, $gMc0m.default)([
                        $dc67d857f203b917$var$sizeStyles.medium,
                        t1
                    ]);
                    $[28] = t1;
                    $[29] = t2;
                } else t2 = $[29];
                let t3;
                if ($[30] !== children || $[31] !== styles || $[32] !== t2) {
                    t3 = /*#__PURE__*/ $42omo.createElement("div", {
                        style: styles,
                        className: t2
                    }, children);
                    $[30] = children;
                    $[31] = styles;
                    $[32] = t2;
                    $[33] = t3;
                } else t3 = $[33];
                return t3;
            }
        case "large":
            {
                const t1 = isResizable && $dc67d857f203b917$var$resizableStyles.namedSize;
                let t2;
                if ($[34] !== t1) {
                    t2 = (0, $gMc0m.default)([
                        $dc67d857f203b917$var$sizeStyles.large,
                        t1
                    ]);
                    $[34] = t1;
                    $[35] = t2;
                } else t2 = $[35];
                let t3;
                if ($[36] !== children || $[37] !== styles || $[38] !== t2) {
                    t3 = /*#__PURE__*/ $42omo.createElement("div", {
                        style: styles,
                        className: t2
                    }, children);
                    $[36] = children;
                    $[37] = styles;
                    $[38] = t2;
                    $[39] = t3;
                } else t3 = $[39];
                return t3;
            }
        case "xlarge":
            {
                const t1 = isResizable && $dc67d857f203b917$var$resizableStyles.namedSize;
                let t2;
                if ($[40] !== t1) {
                    t2 = (0, $gMc0m.default)([
                        $dc67d857f203b917$var$sizeStyles.xlarge,
                        t1
                    ]);
                    $[40] = t1;
                    $[41] = t2;
                } else t2 = $[41];
                let t3;
                if ($[42] !== children || $[43] !== styles || $[44] !== t2) {
                    t3 = /*#__PURE__*/ $42omo.createElement("div", {
                        style: styles,
                        className: t2
                    }, children);
                    $[42] = children;
                    $[43] = styles;
                    $[44] = t2;
                    $[45] = t3;
                } else t3 = $[45];
                return t3;
            }
        case "max":
            {
                let t1;
                if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = (0, $gMc0m.default)([
                        $dc67d857f203b917$var$sizeStyles.max
                    ]);
                    $[46] = t1;
                } else t1 = $[46];
                let t2;
                if ($[47] !== children || $[48] !== styles || $[49] !== t1) {
                    t2 = /*#__PURE__*/ $42omo.createElement("div", {
                        style: styles,
                        className: t1
                    }, children);
                    $[47] = children;
                    $[48] = styles;
                    $[49] = t1;
                    $[50] = t2;
                } else t2 = $[50];
                return t2;
            }
        case "fullscreen":
            {
                let t1;
                if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = (0, $gMc0m.default)([
                        $dc67d857f203b917$var$sizeStyles.fullscreen
                    ]);
                    $[51] = t1;
                } else t1 = $[51];
                let t2;
                if ($[52] !== children || $[53] !== styles || $[54] !== t1) {
                    t2 = /*#__PURE__*/ $42omo.createElement("div", {
                        style: styles,
                        className: t1
                    }, children);
                    $[52] = children;
                    $[53] = styles;
                    $[54] = t1;
                    $[55] = t2;
                } else t2 = $[55];
                return t2;
            }
        case "resizable":
            if ((0, $dh538.fg)("forge-ui-enable-resizable-custom-ui-modal")) {
                let t1;
                if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = (0, $gMc0m.default)([
                        $dc67d857f203b917$var$sizeStyles.resizable
                    ]);
                    $[56] = t1;
                } else t1 = $[56];
                let t2;
                if ($[57] !== children || $[58] !== styles) {
                    t2 = /*#__PURE__*/ $42omo.createElement("div", {
                        style: styles,
                        className: t1
                    }, children);
                    $[57] = children;
                    $[58] = styles;
                    $[59] = t2;
                } else t2 = $[59];
                return t2;
            } else {
                const t1 = isResizable && $dc67d857f203b917$var$resizableStyles.namedSize;
                let t2;
                if ($[60] !== t1) {
                    t2 = (0, $gMc0m.default)([
                        $dc67d857f203b917$var$sizeStyles.medium,
                        t1
                    ]);
                    $[60] = t1;
                    $[61] = t2;
                } else t2 = $[61];
                let t3;
                if ($[62] !== children || $[63] !== styles || $[64] !== t2) {
                    t3 = /*#__PURE__*/ $42omo.createElement("div", {
                        style: styles,
                        className: t2
                    }, children);
                    $[62] = children;
                    $[63] = styles;
                    $[64] = t2;
                    $[65] = t3;
                } else t3 = $[65];
                return t3;
            }
        default:
            {
                let t1;
                if ($[66] !== children) {
                    t1 = /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, children);
                    $[66] = children;
                    $[67] = t1;
                } else t1 = $[67];
                return t1;
            }
    }
} : ({ children: children, size: size, styles: styles, isResizable: isResizable, isJsmModule: isJsmModule })=>{
    const namedSizeKey = $dc67d857f203b917$var$namedSizes.has(size) ? size : null;
    if ((0, $dh538.fg)('forge-ui-refactor-custom-ui-modal')) {
        if (!namedSizeKey) return /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, children);
         // Modals in JSM modules have only been resizable height-wise but not width wise.
        // We are unsure on the business context behind this, so maintain the existing styling in case we break something.
        // For JSM: apply resizableStyles to any non-max/non-fullscreen named size (existing behaviour).
        // For non-JSM: only apply resizableStyles when the size is explicitly 'resizable' — named sizes like
        // 'xlarge' must not have their fixed vh height overridden by resizableStyles (which sets height: auto).
        if (isJsmModule) {
            const supportsJsmResizable = isResizable && namedSizeKey !== 'max' && namedSizeKey !== 'fullscreen';
            return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            , {
                style: styles,
                className: (0, $gMc0m.default)([
                    $dc67d857f203b917$var$sizeStyles[namedSizeKey],
                    supportsJsmResizable && $dc67d857f203b917$var$resizableStyles.jsmModal
                ])
            }, children);
        } // For the 'resizable' size, apply the full resizable modal styles (behind gate).
        // For other named sizes, apply only the minimal overflow/height styles (matching pre-EXT-4856 behaviour).
        const supportsResizable = isResizable && namedSizeKey !== 'max' && namedSizeKey !== 'fullscreen';
        const useFullResizableModalStyles = supportsResizable && namedSizeKey === 'resizable' && (0, $dh538.fg)('forge-ui-enable-resizable-custom-ui-modal');
        if (useFullResizableModalStyles) return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        , {
            style: styles,
            className: (0, $gMc0m.default)([
                $dc67d857f203b917$var$sizeStyles[namedSizeKey],
                $dc67d857f203b917$var$resizableStyles.default
            ])
        }, children);
        return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        , {
            style: styles,
            className: (0, $gMc0m.default)([
                $dc67d857f203b917$var$sizeStyles[namedSizeKey],
                supportsResizable && $dc67d857f203b917$var$resizableStyles.namedSize
            ])
        }, children);
    } // Legacy switch-based implementation
    switch(size){
        case 'small':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    $dc67d857f203b917$var$sizeStyles.small,
                    isResizable && $dc67d857f203b917$var$resizableStyles.namedSize
                ])
            }, children);
        case 'medium':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    $dc67d857f203b917$var$sizeStyles.medium,
                    isResizable && $dc67d857f203b917$var$resizableStyles.namedSize
                ])
            }, children);
        case 'large':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    $dc67d857f203b917$var$sizeStyles.large,
                    isResizable && $dc67d857f203b917$var$resizableStyles.namedSize
                ])
            }, children);
        case 'xlarge':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    $dc67d857f203b917$var$sizeStyles.xlarge,
                    isResizable && $dc67d857f203b917$var$resizableStyles.namedSize
                ])
            }, children);
        case 'max':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    $dc67d857f203b917$var$sizeStyles.max
                ])
            }, children);
        case 'fullscreen':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    $dc67d857f203b917$var$sizeStyles.fullscreen
                ])
            }, children);
        case 'resizable':
            if ((0, $dh538.fg)('forge-ui-enable-resizable-custom-ui-modal')) return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    $dc67d857f203b917$var$sizeStyles.resizable
                ])
            }, children);
            else return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    $dc67d857f203b917$var$sizeStyles.medium,
                    isResizable && $dc67d857f203b917$var$resizableStyles.namedSize
                ])
            }, children);
        default:
            return /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, children);
    }
};
const $dc67d857f203b917$export$ca177c112881662a = (modalSize)=>{
    if (modalSize === 'xlarge') return 'x-large';
    if (modalSize === 'max' || modalSize === 'fullscreen') return '100%';
    if (modalSize === 'resizable') {
        if ((0, $dh538.fg)('forge-ui-enable-resizable-custom-ui-modal')) return 'auto';
        return 'medium';
    }
    return modalSize;
};
const $dc67d857f203b917$export$437c376ee7467324 = (extension)=>{
    return extension?.properties?.config?.icon ?? extension?.properties?.icon;
};
const $dc67d857f203b917$var$getHeight = ({ customDimensions: customDimensions, isResizableSize: isResizableSize, namedSize: namedSize, shouldFallbackFromFullscreen: shouldFallbackFromFullscreen })=>{
    if (customDimensions?.height) return customDimensions.height;
    if (isResizableSize) return 'auto';
    if (namedSize === 'max' || shouldFallbackFromFullscreen) return '100%';
    return undefined;
}; /**
    * Consolidates all modal dimension logic into one place.
    *
    * Priority for named size: modalWidthForMacroCustomConfig → size (string) → viewportSize → 'medium'
    * Priority for width: getModalWidth override → customDimensions.width → ADS named width
    * Priority for height: customDimensions.height → 'auto' (for isResizableSize) → '100%' (for max/fullscreen fallback) → undefined (ModalContentWrapper handles it)
    */ 
const $dc67d857f203b917$export$ad12395fd71244a5 = ({ size: size, getModalWidth: getModalWidth, shouldFallbackFromFullscreen: shouldFallbackFromFullscreen, isResizableSize: isResizableSize })=>{
    const hasCustomDimensions = !!size && (0, $b4nol.isCustomDimensions)(size);
    const customDimensions = hasCustomDimensions ? size : undefined;
    const namedSize = size !== undefined && (0, $b4nol.isNamedSize)(size) ? size : 'medium';
    const namedWidth = getModalWidth ? getModalWidth(namedSize) : $dc67d857f203b917$export$ca177c112881662a(namedSize);
    const resolvedWidth = customDimensions?.width ?? namedWidth;
    const width = shouldFallbackFromFullscreen ? '100%' : resolvedWidth;
    const height = $dc67d857f203b917$var$getHeight({
        customDimensions: customDimensions,
        isResizableSize: isResizableSize,
        namedSize: namedSize,
        shouldFallbackFromFullscreen: shouldFallbackFromFullscreen
    }); // When custom dimensions are provided, the <Modal> component is sized via explicit width/height props.
    // ModalContentWrapper must use 'max' (height: 100%) so the iframe fills the full modal height
    // rather than being constrained to a named size's fixed vh value (e.g. 'medium' = 40vh).
    const contentSize = customDimensions ? 'max' : namedSize;
    return {
        width: width,
        height: height,
        contentSize: contentSize
    };
};
module.exports["ModalContentWrapper"] = $dc67d857f203b917$export$a6d6b74199964ee4;
module.exports["getAtlasKitModalWidth"] = $dc67d857f203b917$export$ca177c112881662a;
module.exports["getExtensionIcon"] = $dc67d857f203b917$export$437c376ee7467324;
module.exports["resolveModalDimensions"] = $dc67d857f203b917$export$ad12395fd71244a5;

});

parcelRegister("artsb", function(module, exports) {

var $1c598 = parcelRequire("1c598");

const $9db9a10eb8628549$export$cdf18e5be3e1a776 = new Set([
    (0, $1c598.ConfluenceExtension).MACRO,
    (0, $1c598.ConfluenceExtension).BYLINE
]);
module.exports["FULLSCREEN_SUPPORTED_EXTENSION_TYPES"] = $9db9a10eb8628549$export$cdf18e5be3e1a776;

});

parcelRegister("b7qxC", function(module, exports) {

var $1c598 = parcelRequire("1c598");


var $lzcvT = parcelRequire("lzcvT");

const $ea538cc77ceb57f0$export$d86e18ec9052db2c = (productEnvironment)=>{
    if ((0, $lzcvT.isFedRamp)()) {
        if (productEnvironment === (0, $1c598.ProductEnvironment).STAGING) return (0, $1c598.ForgeCDNEnvironment).STAGING;
        else return (0, $1c598.ForgeCDNEnvironment).PRODUCTION;
    }
    if (productEnvironment === (0, $1c598.ProductEnvironment).DEVELOPMENT) return (0, $1c598.ForgeCDNEnvironment).DEVELOPMENT;
    else if (productEnvironment === (0, $1c598.ProductEnvironment).STAGING) return (0, $1c598.ForgeCDNEnvironment).STAGING;
    else return (0, $1c598.ForgeCDNEnvironment).PRODUCTION;
};
module.exports["getCDNEnvironment"] = $ea538cc77ceb57f0$export$d86e18ec9052db2c;

});

parcelRegister("dRFAM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("9FlsF")), module.exports);

$hXuPC.__exportStar((parcelRequire("87m1m")), module.exports);

});

parcelRegister("hEvav", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $5hXFK = parcelRequire("5hXFK");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $irOoi = parcelRequire("irOoi");


var $aXWIB = parcelRequire("aXWIB");


var $9UyM5 = parcelRequire("9UyM5");


var $kpdGL = parcelRequire("kpdGL");

var $esRft = parcelRequire("esRft");


var $c4sKh = parcelRequire("c4sKh");


var $lCRfz = parcelRequire("lCRfz");

const $556ea5977eff619b$var$containerStyle = null;
const $556ea5977eff619b$var$messages = (0, $aXWIB.defineMessages)({
    unknownUser: {
        id: "confluence.user.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});
const $556ea5977eff619b$var$Avatar = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { name: name, picture: picture, hideDisplayName: hideDisplayName } = t0;
    if (hideDisplayName) {
        let t1;
        if ($[0] !== name || $[1] !== picture) {
            t1 = /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
                name: name,
                src: picture
            });
            $[0] = name;
            $[1] = picture;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_1gzjidpf _1plv1j28 _1r3373ad"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== name || $[5] !== picture) {
        t2 = /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
            name: name,
            src: picture
        });
        $[4] = name;
        $[5] = picture;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== name || $[8] !== t2) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $kpdGL.default), {
            avatar: t2,
            primaryText: name
        });
        $[7] = name;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t1 || $[11] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t1
        }, t3);
        $[10] = t1;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ name: name, picture: picture, hideDisplayName: hideDisplayName })=>{
    if (hideDisplayName) return /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
        name: name,
        src: picture
    });
    return /*#__PURE__*/ $42omo.createElement("div" // Reduce Atlaskit padding to vertically-align with other components
    , {
        className: (0, $gMc0m.default)([
            "_1gzjidpf _1plv1j28 _1r3373ad"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $kpdGL.default), {
        avatar: /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
            name: name,
            src: picture
        }),
        primaryText: name
    }));
};
const $556ea5977eff619b$var$UserInline = (0, $4pOgL.isReactCompilerActivePlatform)() ? function UserInline(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== intl || $[1] !== name) {
        t1 = name || intl.formatMessage($556ea5977eff619b$var$messages.unknownUser);
        $[0] = intl;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), {
            appearance: "primary"
        }, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function UserInline({ name: name }) {
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), {
        appearance: "primary"
    }, name || intl.formatMessage($556ea5977eff619b$var$messages.unknownUser));
};
const $556ea5977eff619b$var$User = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { accountId: accountId, hideDisplayName: hideDisplayName } = t0;
    let t1;
    if ($[0] !== accountId) {
        t1 = {
            accountId: accountId
        };
        $[0] = accountId;
        $[1] = t1;
    } else t1 = $[1];
    const data = (0, $irOoi.useLazyLoadQuery)((0, $5hXFK.default), t1);
    let t2;
    if ($[2] !== data?.user) {
        t2 = data?.user ?? {
            picture: "",
            name: ""
        };
        $[2] = data?.user;
        $[3] = t2;
    } else t2 = $[3];
    const { picture: picture, name: name } = t2;
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (!picture && !name) return null;
    if (inline) {
        let t3;
        if ($[4] !== name) {
            t3 = /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$UserInline, {
                name: name
            });
            $[4] = name;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    let t3;
    if ($[6] !== hideDisplayName || $[7] !== name || $[8] !== picture) {
        t3 = /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$Avatar, {
            name: name,
            picture: picture,
            hideDisplayName: hideDisplayName
        });
        $[6] = hideDisplayName;
        $[7] = name;
        $[8] = picture;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ accountId: accountId, hideDisplayName: hideDisplayName })=>{
    const data = (0, $irOoi.useLazyLoadQuery)((0, $5hXFK.default), {
        accountId: accountId
    });
    const { picture: picture, name: name } = data?.user ?? {
        picture: '',
        name: ''
    };
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (!picture && !name) return null;
    if (inline) return /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$UserInline, {
        name: name
    });
    return /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$Avatar, {
        name: name,
        picture: picture,
        hideDisplayName: hideDisplayName
    });
};
const $556ea5977eff619b$export$4e4c41e4152a9f8a = ()=>{
    return function UserFnNext({ forgeDoc: { props: props } }) {
        const { accountId: accountId, hideDisplayName: hideDisplayName } = props;
        return /*#__PURE__*/ $42omo.createElement((0, $lCRfz.RelaySuspensefulBoundary), null, /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$User, {
            accountId: accountId,
            hideDisplayName: hideDisplayName
        }));
    };
};
module.exports["makeUser"] = $556ea5977eff619b$export$4e4c41e4152a9f8a;

});

parcelRegister("keDkq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $eU26O = parcelRequire("eU26O");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $2Pg7f = parcelRequire("2Pg7f");


var $c4sKh = parcelRequire("c4sKh");


var $9UyM5 = parcelRequire("9UyM5");


var $irOoi = parcelRequire("irOoi");


var $lCRfz = parcelRequire("lCRfz");

const $2674e7e6928452b6$export$fec8fa59b6e2a0db = (users, accountIds, intl)=>{
    // order should match accountIds
    return accountIds.map((key)=>{
        const { name: name = intl.formatMessage($2674e7e6928452b6$var$messages.unknownUserMessage), picture: picture = '' } = users[key] || {};
        return {
            key: key,
            name: name,
            src: picture
        };
    });
};
const $2674e7e6928452b6$export$7962e827ea8ac95f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { data: data } = t0;
    let t1;
    if ($[0] !== data) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
            appearance: "stack",
            data: data
        });
        $[0] = data;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ data: data })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        appearance: "stack",
        data: data
    });
};
const $2674e7e6928452b6$export$d440bfe209149ca5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { data: data } = t0;
    const t1 = `+${data.length}`;
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), null, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : ({ data: data })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), null, `+${data.length}`);
};
const $2674e7e6928452b6$export$82c3b28526691c79 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { data: data } = t0;
    const end = Math.max(Math.min(8, data.length), 0);
    let hasMore;
    let more;
    let t1;
    if ($[0] !== data || $[1] !== end) {
        const shown = data.slice(0, end);
        more = data.slice(end);
        hasMore = more.length > 0;
        let t2;
        if ($[5] !== end || $[6] !== hasMore) {
            t2 = (t3, i)=>{
                const { name: name } = t3;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                    appearance: "primary"
                }, name), hasMore || i !== end - 1 ? " " : null);
            };
            $[5] = end;
            $[6] = hasMore;
            $[7] = t2;
        } else t2 = $[7];
        t1 = shown.map(t2);
        $[0] = data;
        $[1] = end;
        $[2] = hasMore;
        $[3] = more;
        $[4] = t1;
    } else {
        hasMore = $[2];
        more = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[8] !== hasMore || $[9] !== more) {
        t2 = hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$d440bfe209149ca5, {
            data: more
        }) : null;
        $[8] = hasMore;
        $[9] = more;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] !== t1 || $[12] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, t1, t2);
        $[11] = t1;
        $[12] = t2;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ data: data })=>{
    const end = Math.max(Math.min(8, data.length), 0); // 4 would be the same as AvatarStack
    const shown = data.slice(0, end);
    const more = data.slice(end);
    const hasMore = more.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, shown.map(({ name: name }, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
            appearance: "primary"
        }, name), hasMore || i !== end - 1 ? ' ' : null);
    }), hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$d440bfe209149ca5, {
        data: more
    }) : null);
};
// @ts-ignore setting z index to 0 so that the avatars do not overlap other components
const $2674e7e6928452b6$var$avatarStackWrapper = (0, $ecnYn.xcss)({
    zIndex: 0,
    position: 'relative'
});
const $2674e7e6928452b6$export$2475c2afa469f7f7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { accountIds: accountIds } = t0;
    let t1;
    if ($[0] !== accountIds) {
        t1 = accountIds.filter($2674e7e6928452b6$var$_temp);
        $[0] = accountIds;
        $[1] = t1;
    } else t1 = $[1];
    const nonEmptyAccountIds = t1;
    let t2;
    if ($[2] !== nonEmptyAccountIds) {
        t2 = {
            accountIds: nonEmptyAccountIds
        };
        $[2] = nonEmptyAccountIds;
        $[3] = t2;
    } else t2 = $[3];
    const data = (0, $irOoi.useLazyLoadQuery)((0, $eU26O.default), t2);
    let users = {};
    if (data && data.users) users = data.users.reduce($2674e7e6928452b6$var$_temp2, {});
    const intl = (0, $aXWIB.useIntl)();
    const avatarStackData = $2674e7e6928452b6$export$fec8fa59b6e2a0db(users, accountIds, intl);
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (inline) {
        let t3;
        if ($[4] !== avatarStackData) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$82c3b28526691c79, {
                data: avatarStackData
            });
            $[4] = avatarStackData;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    let t3;
    if ($[6] !== avatarStackData) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2674e7e6928452b6$var$avatarStackWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$7962e827ea8ac95f, {
            data: avatarStackData
        }));
        $[6] = avatarStackData;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ accountIds: accountIds })=>{
    const nonEmptyAccountIds = accountIds.filter((id)=>!(id === ''));
    const data = (0, $irOoi.useLazyLoadQuery)((0, $eU26O.default), {
        accountIds: nonEmptyAccountIds
    });
    let users = {};
    if (data && data.users) users = data.users.reduce((prev, user)=>{
        if (user.accountId) prev[user.accountId] = {
            picture: user.picture,
            accountId: user.accountId,
            name: user.name
        };
        return prev;
    }, {});
    const intl = (0, $aXWIB.useIntl)();
    const avatarStackData = $2674e7e6928452b6$export$fec8fa59b6e2a0db(users, accountIds, intl);
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (inline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$82c3b28526691c79, {
        data: avatarStackData
    });
    return(// Each avatar in an avatar stack has a z index value applied.
    // Setting a container with a z index here to 0 so that the avatars do no overlap other components such as the Select menu
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2674e7e6928452b6$var$avatarStackWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$7962e827ea8ac95f, {
        data: avatarStackData
    })));
};
const $2674e7e6928452b6$export$6f1d3bf96df15c79 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] !== props.forgeDoc.children) {
        t0 = props.forgeDoc.children.map($2674e7e6928452b6$var$_temp3).filter($2674e7e6928452b6$var$_temp4);
        $[0] = props.forgeDoc.children;
        $[1] = t0;
    } else t0 = $[1];
    const accountIds = t0;
    let t1;
    if ($[2] !== accountIds) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lCRfz.RelaySuspensefulBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$2475c2afa469f7f7, {
            accountIds: accountIds
        }));
        $[2] = accountIds;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const accountIds = props.forgeDoc.children.map((child)=>{
        if (child.type !== 'User' && child.type !== 'Avatar') return '';
        const { props: props_0 } = child;
        const { accountId: accountId } = props_0;
        return accountId;
    }).filter((x)=>x);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lCRfz.RelaySuspensefulBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$2475c2afa469f7f7, {
        accountIds: accountIds
    }));
};
const $2674e7e6928452b6$var$messages = (0, $aXWIB.defineMessages)({
    unknownUserMessage: {
        id: "confluence.user.group.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});
function $2674e7e6928452b6$var$_temp(id) {
    return !(id === "");
}
function $2674e7e6928452b6$var$_temp2(prev, user) {
    if (user.accountId) prev[user.accountId] = {
        picture: user.picture,
        accountId: user.accountId,
        name: user.name
    };
    return prev;
}
function $2674e7e6928452b6$var$_temp3(child) {
    if (child.type !== "User" && child.type !== "Avatar") return "";
    const { props: props_0 } = child;
    const { accountId: accountId } = props_0;
    return accountId;
}
function $2674e7e6928452b6$var$_temp4(x) {
    return x;
}
module.exports["UserGroup"] = $2674e7e6928452b6$export$6f1d3bf96df15c79;

});

parcelRegister("539Bm", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1uzCd = parcelRequire("1uzCd");


var $hBuHI = parcelRequire("hBuHI");


var $iUjrf = parcelRequire("iUjrf");


var $eI4ye = parcelRequire("eI4ye");

const $4db8dff54302fa45$export$1b708c663f12db29 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { isEnabled: isEnabled, viewportDimensions: viewportDimensions } = t0;
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const { containerRef: containerRef, height: height } = (0, $hBuHI.useHeightObserver)();
    const isTrackingRef = (0, $42omo.useRef)(true);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const timeoutId = setTimeout(()=>{
                isTrackingRef.current = false;
            }, (0, $eI4ye.PERFORMANCE_ANALYTICS_INTERVAL));
            return ()=>clearTimeout(timeoutId);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== captureEvent || $[3] !== height || $[4] !== isEnabled || $[5] !== viewportDimensions?.measuredHeight || $[6] !== viewportDimensions?.viewportHeight) {
        t3 = ()=>{
            if (height !== null && isEnabled && isTrackingRef.current) captureEvent({
                type: "resized",
                height: height,
                measuredHeight: viewportDimensions?.measuredHeight,
                viewportHeight: viewportDimensions?.viewportHeight,
                elapsed: (0, $1uzCd.getPerformanceMark)()
            });
        };
        $[2] = captureEvent;
        $[3] = height;
        $[4] = isEnabled;
        $[5] = viewportDimensions?.measuredHeight;
        $[6] = viewportDimensions?.viewportHeight;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== captureEvent || $[9] !== height || $[10] !== isEnabled || $[11] !== viewportDimensions) {
        t4 = [
            height,
            isEnabled,
            captureEvent,
            viewportDimensions
        ];
        $[8] = captureEvent;
        $[9] = height;
        $[10] = isEnabled;
        $[11] = viewportDimensions;
        $[12] = t4;
    } else t4 = $[12];
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[13] !== containerRef) {
        t5 = {
            containerRef: containerRef
        };
        $[13] = containerRef;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ isEnabled: isEnabled, viewportDimensions: viewportDimensions })=>{
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const { containerRef: containerRef, height: height } = (0, $hBuHI.useHeightObserver)();
    const isTrackingRef = (0, $42omo.useRef)(true);
    // Initialize tracking timeout on mount, clear on unmount
    (0, $42omo.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            isTrackingRef.current = false;
        }, (0, $eI4ye.PERFORMANCE_ANALYTICS_INTERVAL));
        return ()=>clearTimeout(timeoutId);
    }, []);
    // Capture resize events when height changes and tracking is active
    (0, $42omo.useEffect)(()=>{
        // Only capture if height is valid, feature is enabled, and we're still tracking
        if (height !== null && isEnabled && isTrackingRef.current) captureEvent({
            type: 'resized',
            height: height,
            measuredHeight: viewportDimensions?.measuredHeight,
            viewportHeight: viewportDimensions?.viewportHeight,
            elapsed: (0, $1uzCd.getPerformanceMark)()
        });
    }, [
        height,
        isEnabled,
        captureEvent,
        viewportDimensions
    ]);
    return {
        containerRef: containerRef
    };
};
module.exports["useResizeAnalytics"] = $4db8dff54302fa45$export$1b708c663f12db29;

});

parcelRegister("9ZQdx", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hEvav = parcelRequire("hEvav");

var $durRy = parcelRequire("durRy");


var $dx0OV = parcelRequire("dx0OV");


var $keDkq = parcelRequire("keDkq");


var $gwUcI = parcelRequire("gwUcI");

const $21632699a983d1c1$export$58982618823f55fc = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { accountId: accountId, bridge: bridge, cloudId: cloudId, workspaceId: workspaceId, mentionProvider: mentionProvider, product: product, components: components } = t0;
    let t1;
    if ($[0] !== components) {
        t1 = components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
        $[0] = components;
        $[1] = t1;
    } else t1 = $[1];
    const injectedComponentsWithKey = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hEvav.makeUser)();
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== accountId || $[4] !== cloudId || $[5] !== mentionProvider || $[6] !== product || $[7] !== workspaceId) {
        t3 = (0, $durRy.makeNativeUserPicker)({
            mentionProvider: mentionProvider,
            accountId: accountId,
            ...workspaceId ? {
                cloudId: "bitbucket"
            } : {
                cloudId: cloudId
            },
            productAttributes: workspaceId ? {
                workspaceIds: [
                    (0, $gwUcI.uncurlyUuid)(workspaceId)
                ]
            } : undefined,
            productKey: product
        });
        $[3] = accountId;
        $[4] = cloudId;
        $[5] = mentionProvider;
        $[6] = product;
        $[7] = workspaceId;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== bridge) {
        t4 = (0, $dx0OV.makeADFRenderer)({
            bridge: bridge
        });
        $[9] = bridge;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t4) {
        t5 = {
            AdfRenderer: t4
        };
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== t3 || $[14] !== t5) {
        t6 = {
            Avatar: t2,
            AvatarStack: (0, $keDkq.UserGroup),
            UserPicker: t3,
            ...t5
        };
        $[13] = t3;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    const wiredComponents = t6;
    let t7;
    if ($[16] !== injectedComponentsWithKey || $[17] !== wiredComponents) {
        t7 = (defaults)=>({
                ...defaults,
                ...wiredComponents,
                ...injectedComponentsWithKey
            });
        $[16] = injectedComponentsWithKey;
        $[17] = wiredComponents;
        $[18] = t7;
    } else t7 = $[18];
    const getComponents = t7;
    return getComponents;
} : ({ accountId: accountId, bridge: bridge, cloudId: cloudId, workspaceId: workspaceId, mentionProvider: mentionProvider, product: product, components: components })=>{
    const injectedComponentsWithKey = (0, $42omo.useMemo)(()=>{
        return components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                // A key is required to ensure React creates new component instances when forgeDoc.key changes.
                // Without this key, React reuses the same component instance across different forgeDoc updates,
                // causing hook call order violations when the component structure changes between renders.
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
    }, [
        components
    ]);
    const wiredComponents = (0, $42omo.useMemo)(()=>({
            Avatar: (0, $hEvav.makeUser)(),
            AvatarStack: (0, $keDkq.UserGroup),
            UserPicker: (0, $durRy.makeNativeUserPicker)({
                mentionProvider: mentionProvider,
                accountId: accountId,
                ...workspaceId ? {
                    cloudId: 'bitbucket'
                } : {
                    cloudId: cloudId
                },
                productAttributes: workspaceId ? {
                    workspaceIds: [
                        (0, $gwUcI.uncurlyUuid)(workspaceId)
                    ]
                } : undefined,
                productKey: product
            }),
            AdfRenderer: (0, $dx0OV.makeADFRenderer)({
                bridge: bridge
            })
        }), [
        accountId,
        cloudId,
        mentionProvider,
        product,
        workspaceId,
        bridge
    ]);
    const getComponents = (0, $42omo.useCallback)((defaults)=>({
            ...defaults,
            ...wiredComponents,
            ...injectedComponentsWithKey
        }), [
        injectedComponentsWithKey,
        wiredComponents
    ]);
    return getComponents;
};
module.exports["useUIKitComponents"] = $21632699a983d1c1$export$58982618823f55fc;

});

parcelRegister("h6bEF", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $a9dFP = parcelRequire("a9dFP");

var $cOrQJ = parcelRequire("cOrQJ");


var $jIiuI = parcelRequire("jIiuI");


var $ijfiP = parcelRequire("ijfiP");

var $1I2N5 = parcelRequire("1I2N5");


var $2uzbP = parcelRequire("2uzbP");


var $kaOT1 = parcelRequire("kaOT1");


var $5oEbs = parcelRequire("5oEbs");

var $LiNdD = parcelRequire("LiNdD");

var $hcbSV = parcelRequire("hcbSV");

var $ge8sG = parcelRequire("ge8sG");

var $4jZsH = parcelRequire("4jZsH");

var $UZU5S = parcelRequire("UZU5S");

var $6baEI = parcelRequire("6baEI");


var $6hkBe = parcelRequire("6hkBe");


var $f0Xuq = parcelRequire("f0Xuq");


var $bn0yX = parcelRequire("bn0yX");


var $6UsXz = parcelRequire("6UsXz");


var $6oQb1 = parcelRequire("6oQb1");


var $jc2GP = parcelRequire("jc2GP");


var $jNc4k = parcelRequire("jNc4k");


var $cqiXo = parcelRequire("cqiXo");





var $dh538 = parcelRequire("dh538");


var $ifmal = parcelRequire("ifmal");

const $f2c0519b4a165d40$var$styles = {
    hostedResourcesIframeContainer: "_kqswh2mm",
    box: "_1bsb1osq _4t3i1osq"
};
const $f2c0519b4a165d40$var$ReloadOnContextChangeWrapper = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion } = t0;
    if (getCurrentForgeReactMajorVersion) {
        let t1;
        if ($[0] !== children || $[1] !== context || $[2] !== getCurrentForgeReactMajorVersion) {
            t1 = /*#__PURE__*/ $42omo.createElement((0, $jNc4k.ContextChangeObserverWrapper), {
                context: context,
                getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion
            }, children);
            $[0] = children;
            $[1] = context;
            $[2] = getCurrentForgeReactMajorVersion;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    let t1;
    if ($[4] !== context) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(context);
        $[4] = context;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== children || $[7] !== t1) {
        t2 = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), {
            key: t1
        }, children);
        $[6] = children;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    if (getCurrentForgeReactMajorVersion) return /*#__PURE__*/ $42omo.createElement((0, $jNc4k.ContextChangeObserverWrapper), {
        context: context,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion
    }, children);
    return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), {
        key: (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(context)
    }, children);
};
const $f2c0519b4a165d40$export$5137ec99f248330b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', bridge: bridge, customBridgeMethods: customBridgeMethods, customBridge: customBridge, isResizable: isResizable = true, entryPoint: entryPoint, extensionPayload: extensionPayload, getContextToken: getContextToken, timezone: timezone, locale: locale, isHidden: isHidden = false, isInModal: isInModal = false, setShouldShowRenderer: setShouldShowRenderer, setIsLoading: setIsLoading, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion, onError: onError, isEmbeddedMacro: isEmbeddedMacro = false, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId, contextChangeListeners: contextChangeListeners }, iframeRef)=>{
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext)); // ARKEN-856: useThemeObserver() is a bit noisy, it returns copies of the same theme which breaks useBridge() dependencies
    // We use useMemoizedStateObject() to properly memoize its output doing a deep-equality check
    const theme = (0, $1I2N5.useMemoizedStateObject)((0, $cOrQJ.default)());
    const iframeWrapperRef = (0, $42omo.useRef)(null);
    const [surfaceColor, setSurfaceColor] = (0, $42omo.useState)(null);
    const { trackExtensionLoaded: trackExtensionLoaded } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    (0, $42omo.useEffect)(()=>{
        if (!iframeWrapperRef.current) return;
        const nextSurfaceColor = getComputedStyle(iframeWrapperRef.current).getPropertyValue((0, $a9dFP.CURRENT_SURFACE_CSS_VAR));
        setSurfaceColor(nextSurfaceColor);
    }, [
        theme
    ]);
    const { appId: appId, moduleKey: moduleKey } = (0, $ijfiP.parseExtensionId)(extension.id);
    const { environmentId: environmentId, environmentType: environmentType } = extension; // getExtensionEntryPoint resolves both the resource and its resolvedResourceEntry from the
    // active entryPoint together, so the top-level resource's HTML filename does not bleed into a
    // sub-entry-point's (config/edit/view/create/contextConfig) CDN URL.
    const { resource: extensionEntryPoint, resolvedResourceEntry: activeResolvedResourceEntry } = (0, $6hkBe.getExtensionEntryPoint)(extension, entryPoint);
    const extensionViewDataMemoKey = (0, $dh538.fg)('confluence_fix_embedded_pages_memory_leak') ? (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(extensionViewData) : extensionViewData; // eslint-disable-next-line react-hooks/exhaustive-deps -- extensionViewDataMemoKey is a deep-equality proxy when the gate is enabled; extensionViewData is intentionally excluded to avoid referential-inequality re-renders.
    const stableExtensionViewData = (0, $42omo.useMemo)(()=>extensionViewData, [
        extensionViewDataMemoKey
    ]);
    const urlSafeContext = (0, $42omo.useMemo)(()=>(0, $5oEbs.urlSafeB64)((0, $cqiXo.getEncodedAppContext)(extension, stableExtensionViewData)), [
        extension,
        stableExtensionViewData
    ]);
    const defaultSrc = (0, $42omo.useMemo)(()=>(0, $5oEbs.createSrcFromExtension)(appId, extension, environment, extensionEntryPoint, stableExtensionViewData, activeResolvedResourceEntry), [
        appId,
        extension,
        environment,
        extensionEntryPoint,
        stableExtensionViewData,
        activeResolvedResourceEntry
    ]);
    const isSignedCookieLoading = (0, $6baEI.useCDNAuthSignedCookie)();
    (0, $42omo.useEffect)(()=>{
        const renderType = extension?.properties?.render === 'native' ? 'UIKit' : 'CustomUI';
        const extensionType = (0, $jc2GP.getExtensionType)(extension);
        trackExtensionLoaded({
            forgeEnvironment: extension?.environmentType,
            renderType: renderType,
            extensionType: extensionType
        }); // This should run for each new unique appId/moduleKey combination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        appId,
        moduleKey
    ]);
    const [isThreeLOPromptVisible, setIsThreeLOPromptVisible] = (0, $42omo.useState)(false);
    const coreDataInner = {
        ...coreData,
        environmentId: environmentId,
        environmentType: environmentType,
        moduleKey: moduleKey,
        siteUrl: window.location.origin
    };
    const viewportSize = extension.properties.viewportSize; // Manifest viewportSize normally disables iframe auto-resize (fixed shell heights).
    // viewportSize: 'resizable' is paired with resizable modal chrome — keep iframe resizer on.
    const isResizableViewportSize = viewportSize === 'resizable' && (0, $dh538.fg)('forge-ui-enable-resizable-custom-ui-modal');
    const resizingEnabled = isResizable && (!viewportSize || isResizableViewportSize); // moves specific macro extension data (isEditing, macro) to extensionData instead of extensionPayload as this is required for Tempo (#hot-300905)
    // the first check enables the feature for Tempo specifically, the second check enables the feature for all extensions if needed
    const enabledForTempo = appId === '76206a70-b9d6-4328-9e20-db79196c548a' && (0, $dh538.fg)('forge-ui-move-macro-data-for-tempo');
    const shouldIncludeMacroDataInExtensionData = enabledForTempo || (0, $dh538.fg)('forge-ui-move-macro-data-to-extension-data');
    return /*#__PURE__*/ $42omo.createElement((0, $6UsXz.TunnelsProvider), {
        environmentType: extension.environmentType,
        appId: appId,
        contextIds: contextIds,
        environmentId: environmentId
    }, ({ tunnels: tunnels, loading: loading })=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            ref: iframeWrapperRef,
            testId: "hosted-resources-iframe-container",
            xcss: $f2c0519b4a165d40$var$styles.hostedResourcesIframeContainer,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: isThreeLOPromptVisible || isHidden || ((0, $dh538.fg)('platform_forge_ui_refactor_macro_parent_type') ? !!embeddedMacroParentType : isEmbeddedMacro) ? undefined : height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: resizingEnabled || isThreeLOPromptVisible || isHidden ? undefined : height,
                width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width
            }
        }, (loading || (0, $6baEI.shouldUseCDNAuth)() && isSignedCookieLoading) && /*#__PURE__*/ $42omo.createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $f2c0519b4a165d40$var$styles.box
        }, loading && !isHidden && (0, $bn0yX.getLoadingComponent)(loadingComponent))), !(loading || (0, $6baEI.shouldUseCDNAuth)() && isSignedCookieLoading) && /*#__PURE__*/ $42omo.createElement((0, $kaOT1.TracingProvider), null, (0, $dh538.fg)('forge-ui-bridge-core-reset') ? /*#__PURE__*/ $42omo.createElement((0, $ifmal.InnerIframe), {
            accountId: accountId,
            extension: extension,
            contextIds: contextIds,
            components: components,
            coreData: coreDataInner,
            customBridge: customBridge,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            loadingComponent: loadingComponent,
            onLoad: onLoad,
            height: height,
            width: width,
            src: (0, $4jZsH.getSrcUrl)(tunnels, extensionEntryPoint, defaultSrc, urlSafeContext, activeResolvedResourceEntry),
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            isResizable: resizingEnabled,
            getContextToken: getContextToken,
            timezone: timezone,
            locale: locale,
            setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
            setShouldShowRenderer: setShouldShowRenderer,
            extensionPayload: extensionPayload,
            isHidden: isHidden,
            theme: theme,
            surfaceColor: surfaceColor,
            appId: appId,
            ref: iframeRef,
            isInModal: isInModal,
            setIsLoading: setIsLoading,
            onError: onError,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedParentLocalId: embeddedParentLocalId,
            contextChangeListeners: contextChangeListeners
        }) : /*#__PURE__*/ $42omo.createElement($f2c0519b4a165d40$var$ReloadOnContextChangeWrapper, {
            getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
            context: (0, $UZU5S.getViewContext)({
                resolverContext: (0, $ge8sG.getResolverContext)(coreDataInner, extensionData),
                accountId: accountId,
                extension: extension,
                timezone: timezone ?? (0, $hcbSV.getBrowserTimezone)(),
                locale: locale ?? (0, $LiNdD.getBrowserLocale)(),
                extensionViewData: extensionViewData,
                extensionPayload: {
                    config: extensionPayload?.config,
                    macro: shouldIncludeMacroDataInExtensionData ? extensionData?.macro : extensionPayload?.macro,
                    isEditing: shouldIncludeMacroDataInExtensionData ? extensionData?.isEditing : extensionPayload?.isEditing
                }
            })
        }, /*#__PURE__*/ $42omo.createElement((0, $f0Xuq.InnerIframe), {
            accountId: accountId,
            extension: extension,
            contextIds: contextIds,
            components: components,
            coreData: coreDataInner,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            loadingComponent: loadingComponent,
            onLoad: onLoad,
            height: height,
            width: width,
            src: (0, $4jZsH.getSrcUrl)(tunnels, extensionEntryPoint, defaultSrc, urlSafeContext, activeResolvedResourceEntry),
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            isResizable: resizingEnabled,
            getContextToken: getContextToken,
            timezone: timezone,
            locale: locale,
            setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
            setShouldShowRenderer: setShouldShowRenderer,
            extensionPayload: extensionPayload,
            isHidden: isHidden,
            theme: theme,
            surfaceColor: surfaceColor,
            appId: appId,
            ref: iframeRef,
            isInModal: isInModal,
            setIsLoading: setIsLoading,
            onError: onError,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedParentLocalId: embeddedParentLocalId
        })))));
});
module.exports["Iframe"] = $f2c0519b4a165d40$export$5137ec99f248330b;

});

parcelRegister("cqiXo", function(module, exports) {

var $2uzbP = parcelRequire("2uzbP");


var $6otn0 = parcelRequire("6otn0");


var $hTKp4 = parcelRequire("hTKp4");


var $dh538 = parcelRequire("dh538");

const $11028dbc0e45417b$export$423a62223c29d468 = (extension, extensionViewData)=>{
    const { egress: egress = [], installationConfig: installationConfig = [] } = extension;
    const getMacroParentHostDomain = ()=>{
        const doc = (0, $hTKp4.getDocument)(); // browser stips off referer and origin.
        const { hostname: hostname, pathname: pathname } = window.location;
        // Allow all origins for local Confluence development where the FAUS ADF renderer
        // runs at /forge-apps/adf-renderer and the browser strips off the referrer/origin.
        if (hostname === 'localhost' && pathname === '/forge-apps/adf-renderer') return '*';
        if (doc?.referrer && extension.type === 'xen:macro') {
            const referrerUrl = new URL(doc.referrer);
            const hostnameParts = referrerUrl.hostname.split('.');
            // Check if the second subdomain is 'cdn' to confirm it's a CDN URL
            const isCdnUrl = hostnameParts.length > 1 && hostnameParts[1] === 'cdn';
            if (isCdnUrl) return hostnameParts[0];
            const isLocalHost = referrerUrl.hostname === 'localhost';
            if (isLocalHost) return referrerUrl.host;
        }
    };
    const macroParentHostDomain = getMacroParentHostDomain();
    const shouldIncludeConnectMacroParentDomain = Boolean(extensionViewData?.connectMacroOrigin) && (0, $dh538.fg)('forge_nbm_set_frame_ancestors');
    // Include the host-threaded cross-domain embedding origin so the Forge CDN can add it to the
    // macro iframe's `frame-ancestors` CSP; without it the iframe is blocked when Confluence is
    // embedded cross-domain (e.g. on a custom domain).
    const shouldIncludeCrossDomainEmbeddingOrigin = Boolean(extensionViewData?.crossDomainEmbeddingOrigin) && extension.type === 'xen:macro' && (0, $dh538.fg)('forge-ui-embedded-confluence-custom-domain-csp');
    const contextPayload = {
        egress: egress,
        installationConfig: installationConfig,
        hostname: window.location.hostname,
        ...macroParentHostDomain ? {
            macroParentHostDomain: macroParentHostDomain,
            macroParentHost: macroParentHostDomain
        } : {},
        ...shouldIncludeConnectMacroParentDomain ? {
            connectMacroParentDomain: extensionViewData?.connectMacroOrigin
        } : {},
        ...shouldIncludeCrossDomainEmbeddingOrigin ? {
            parentEmbeddingDomain: extensionViewData?.crossDomainEmbeddingOrigin
        } : {}
    };
    return $11028dbc0e45417b$var$gzipAndB64Encode(contextPayload);
};
const $11028dbc0e45417b$var$gzipAndB64Encode = (json)=>{
    const jsonString = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(json); // We use fast-json-stable-stringify to ensure that the JSON is deterministic
    try {
        const zippedData = (0, $6otn0.gzipSync)(new TextEncoder().encode(jsonString), {
            level: 9,
            // Max compression,
            mtime: 0 // We set the mtime to 0 to ensure that the output is deterministic
        });
        return btoa(String.fromCharCode(...zippedData));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err.message);
    }
    return '';
};
module.exports["getEncodedAppContext"] = $11028dbc0e45417b$export$423a62223c29d468;

});

parcelRegister("4GQnE", function(module, exports) {
(()=>{
    "use strict";
    var e = {
        167 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.deserializeError = t.deserialize = void 0;
            const n = r(438), o = (e)=>"proxyCache" in e && "functionRegistry" in e;
            t.deserialize = (e, r, n = new WeakSet())=>{
                if (null == e) return e;
                if ("object" != typeof e) return e;
                if (a(e)) switch(e.__type__){
                    case "port_rpc_function":
                        return s(e, r);
                    case "port_rpc_error":
                        return (0, t.deserializeError)(e);
                    case "port_rpc_regex":
                        return c(e);
                }
                return e instanceof Date || e instanceof ArrayBuffer || ArrayBuffer.isView(e) ? e : n.has(e) ? void 0 : (n.add(e), i(e, r, n));
            };
            const i = (e, r, n)=>{
                if (Array.isArray(e)) return e.map((e)=>(0, t.deserialize)(e, r, n));
                if (e instanceof Map) {
                    const o = new Map();
                    for (const [i, s] of e)o.set(i, (0, t.deserialize)(s, r, n));
                    return o;
                }
                if (e instanceof Set) {
                    const o = new Set();
                    for (const i of e)o.add((0, t.deserialize)(i, r, n));
                    return o;
                }
                const o = {};
                for (const i of Object.keys(e))o[i] = (0, t.deserialize)(e[i], r, n);
                return o;
            }, s = (e, t)=>{
                const r = e[n.PROXY_ID_FIELD], { __name__: i } = e;
                if (o(t)) {
                    const e = t.functionStore.get(r);
                    if (e) return e;
                }
                if (o(t)) {
                    const e = t.proxyCache.get(r)?.deref();
                    if (e) return e;
                }
                const s = async (...e)=>t.send(`${n.FUNCTION_CALL_PREFIX}:${r}`, {
                        args: e
                    });
                return s[n.PROXY_ID_SYMBOL] = r, s[n.PROXY_ID_FIELD] = r, Object.defineProperty(s, "name", {
                    value: `proxy<${i}>`,
                    configurable: !0
                }), o(t) && (s[n.PROXY_OWNER_SYMBOL] = t.functionStore, t.proxyCache.set(r, new WeakRef(s)), t.functionRegistry.register(s, r, s)), s;
            };
            t.deserializeError = (e)=>{
                const t = new Error(e.message);
                return e.stack && (t.stack = e.stack), e.name && (t.name = e.name), e.code && (t.code = e.code), t;
            };
            const c = (e)=>new RegExp(e.source, e.flags), a = (e)=>"object" == typeof e && null !== e && "__type__" in e && "string" == typeof e.__type__;
        },
        227 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.establish = void 0;
            const n = r(438), o = r(402), i = r(441), s = r(690), c = r(259), a = (e)=>{
                e.settled = !0;
                try {
                    e.port1.postMessage({
                        type: "DISCONNECT",
                        id: (0, n.uniqueID)()
                    });
                } catch  {}
                try {
                    e.port1.close();
                } catch  {}
            };
            t.establish = (e, t)=>{
                const { timeout: r, origin: d = "*", context: u, verify: l, waitForReady: f, connectionOptions: _ } = t ?? {}, p = r ?? (u ? n.ROUTED_HANDSHAKE_TIMEOUT : n.HANDSHAKE_TIMEOUT), h = (t)=>new Promise((r, c)=>{
                        const f = (0, s.resolveTarget)(e, d, "establish"), { port1: p, port2: h } = new MessageChannel(), E = {
                            port1: p,
                            timer: void 0,
                            settled: !1,
                            verify: l,
                            resolve: r,
                            reject: c,
                            connectionOptions: _
                        };
                        E.timer = setTimeout(()=>{
                            E.settled || (a(E), c(new i.TimeoutError(`Handshake timeout: no response within ${t}ms`)));
                        }, t), p.onmessage = ((e)=>async (t)=>{
                                if (e.settled) return;
                                const r = t.data;
                                r?.type !== n.ROUTE_REJECT_TYPE ? r?.type === n.HANDSHAKE_ACK_TYPE && await (async (e, t)=>{
                                    if (e.verify) try {
                                        const r = await e.verify(t.verificationData);
                                        if (e.settled) return;
                                        if (!r) return clearTimeout(e.timer), a(e), void e.reject(new i.VerificationError());
                                    } catch (t) {
                                        if (e.settled) return;
                                        return clearTimeout(e.timer), a(e), void e.reject(new i.VerificationError(t instanceof Error ? t.message : "Verification failed"));
                                    }
                                    e.settled || (clearTimeout(e.timer), e.settled = !0, e.port1.onmessage = null, e.resolve(new o.ConnectionImpl(e.port1, e.connectionOptions)));
                                })(e, r) : ((e, t)=>{
                                    clearTimeout(e.timer), a(e), e.reject(new i.RoutingError(t.error || "Route rejected"));
                                })(e, r);
                            })(E);
                        const m = {
                            type: n.HANDSHAKE_MSG_TYPE,
                            ...u ? {
                                context: u
                            } : {}
                        };
                        try {
                            f.post(m, [
                                h
                            ]);
                        } catch (e) {
                            clearTimeout(E.timer), a(E), c(new i.RoutingError(`Failed to send handshake: ${e instanceof Error ? e.message : String(e)}`));
                        }
                    });
                if (!f) return h(p);
                const E = Date.now();
                return (0, c.waitForReady)(e, {
                    origin: d,
                    timeout: p
                }).then(()=>{
                    const e = Math.max(0, p - (Date.now() - E));
                    return h(e);
                });
            };
        },
        259 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.waitForReady = void 0;
            const n = r(438), o = r(441), i = r(690);
            t.waitForReady = (e, t)=>{
                const { origin: r = "*", timeout: s = n.READY_TIMEOUT, interval: c = n.READY_PROBE_INTERVAL } = t ?? {};
                return new Promise((t, a)=>{
                    let d;
                    try {
                        d = ((e, t)=>{
                            if ("undefined" != typeof HTMLIFrameElement && e instanceof HTMLIFrameElement) {
                                const r = e.contentWindow;
                                if (!r) throw new o.PortRpcError("Cannot waitForReady: iframe has no contentWindow (not yet loaded?)");
                                if ("undefined" == typeof window) throw new o.PortRpcError("waitForReady requires a window context for Window/iframe targets");
                                return {
                                    listenTarget: window,
                                    post: (e)=>r.postMessage(e, t),
                                    expectedSource: r
                                };
                            }
                            if ("undefined" != typeof Worker && e instanceof Worker) return {
                                listenTarget: e,
                                post: (t)=>e.postMessage(t),
                                expectedSource: void 0
                            };
                            if ((0, i.isWindow)(e)) {
                                if ("undefined" == typeof window) throw new o.PortRpcError("waitForReady requires a window context for Window targets");
                                return {
                                    listenTarget: window,
                                    post: (r)=>e.postMessage(r, t),
                                    expectedSource: e
                                };
                            }
                            throw new o.PortRpcError("Unsupported waitForReady target");
                        })(e, r);
                    } catch (e) {
                        return void a(e instanceof Error ? e : new o.PortRpcError(String(e)));
                    }
                    const { listenTarget: u, post: l, expectedSource: f } = d, _ = (0, n.uniqueID)();
                    let p = !1;
                    const h = ()=>{
                        p = !0, clearInterval(g), clearTimeout(y), u.removeEventListener("message", E);
                    }, E = (e)=>{
                        if (p) return;
                        const r = e.data;
                        r && r.type === n.READY_TYPE && r.nonce === _ && (f && e.source && e.source !== f || (h(), t()));
                    };
                    u.addEventListener("message", E);
                    const m = ()=>{
                        try {
                            l({
                                type: n.READY_PROBE_TYPE,
                                nonce: _
                            });
                        } catch  {}
                    };
                    m();
                    const g = setInterval(m, c), y = setTimeout(()=>{
                        p || (h(), a(new o.TimeoutError(`waitForReady timeout: no ready signal within ${s}ms`)));
                    }, s);
                });
            };
        },
        304 (e, t, r) {
            t.GJ = t._4 = void 0;
            var n = r(227);
            Object.defineProperty(t, "_4", {
                enumerable: !0,
                get: function() {
                    return n.establish;
                }
            });
            var o = r(930);
            Object.defineProperty(t, "GJ", {
                enumerable: !0,
                get: function() {
                    return o.onConnect;
                }
            });
            r(629), r(441);
        },
        402 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.ConnectionImpl = void 0;
            const n = r(438), o = r(906), i = r(167), s = r(441);
            t.ConnectionImpl = class {
                on(e, t) {
                    if (this.requestListeners.has(e)) throw new s.DuplicateListenerError(e);
                    return this.requestListeners.set(e, {
                        handler: t,
                        once: !1
                    }), {
                        cancel: ()=>{
                            this.requestListeners.delete(e);
                        }
                    };
                }
                once(e, t) {
                    if (this.requestListeners.has(e)) throw new s.DuplicateListenerError(e);
                    return this.requestListeners.set(e, {
                        handler: t,
                        once: !0
                    }), {
                        cancel: ()=>{
                            this.requestListeners.delete(e);
                        }
                    };
                }
                send(e, t, r) {
                    if (this.destroyed) return Promise.reject(new s.ConnectionClosedError("Cannot send on a destroyed connection"));
                    const i = r?.fireAndForget ?? !1, c = r?.ackTimeout ?? this.defaultAckTimeout, a = r?.timeout ?? this.defaultResponseTimeout, d = `${e}_${(0, n.uniqueID)()}`, u = {
                        type: "REQUEST",
                        id: d,
                        name: e,
                        data: (0, o.serialize)(t, this.functionStore, this.fnToId),
                        ...i ? {
                            fireAndForget: !0
                        } : {}
                    };
                    try {
                        this.port.postMessage(u);
                    } catch (e) {
                        return Promise.reject(e);
                    }
                    return i ? Promise.resolve(void 0) : this.awaitResponse(d, e, c, a);
                }
                awaitResponse(e, t, r, n) {
                    return new Promise((o, i)=>{
                        const c = {
                            resolve: o,
                            reject: i,
                            ackTimer: null,
                            responseTimer: null,
                            acked: !1
                        };
                        !1 !== r && r > 0 && (c.ackTimer = setTimeout(()=>{
                            c.acked || (this.pendingRequests.delete(e), this.clearPendingTimers(c), i(new s.TimeoutError(`ACK timeout: no ACK received for "${t}" within ${r}ms`)));
                        }, r)), n > 0 && (c.responseTimer = setTimeout(()=>{
                            this.pendingRequests.delete(e), this.clearPendingTimers(c), i(new s.TimeoutError(`Response timeout: no response for "${t}" within ${n}ms`));
                        }, n)), this.pendingRequests.set(e, c);
                    });
                }
                async ping(e) {
                    if (this.destroyed) return !1;
                    const t = e ?? n.PING_TIMEOUT;
                    try {
                        return await this.send(n.PING_NAME, void 0, {
                            timeout: t,
                            ackTimeout: t
                        }), !0;
                    } catch  {
                        return !1;
                    }
                }
                onDisconnect(e) {
                    return this.disconnectHandlers.add(e), {
                        cancel: ()=>{
                            this.disconnectHandlers.delete(e);
                        }
                    };
                }
                destroy() {
                    if (!this.destroyed) {
                        this.destroyed = !0;
                        try {
                            this.port.postMessage({
                                type: "DISCONNECT",
                                id: (0, n.uniqueID)()
                            });
                        } catch  {}
                        this.teardown();
                    }
                }
                handleMessage(e) {
                    switch(e.type){
                        case "REQUEST":
                            this.handleRequest(e);
                            break;
                        case "RESPONSE":
                            this.handleResponse(e);
                            break;
                        case "ACK":
                            this.handleAck(e);
                            break;
                        case "DISCONNECT":
                            this.handleDisconnect();
                            break;
                        case "FUNCTION_RELEASE":
                            this.handleFunctionRelease(e);
                    }
                }
                handleRequest(e) {
                    const { id: t, name: r, data: o, fireAndForget: c } = e;
                    if (c) return void this.handleFireAndForget(r, o);
                    if (this.sendAck(t), r === n.PING_NAME) return void this.sendResponse(t, void 0);
                    if (r.startsWith(`${n.FUNCTION_CALL_PREFIX}:`)) {
                        const e = r.slice(n.FUNCTION_CALL_PREFIX.length + 1), c = this.functionStore.get(e);
                        if (!c) return void this.sendErrorResponse(t, new s.HandlerNotFoundError(`function:${e}`));
                        const a = (0, i.deserialize)(o, this);
                        return void this.invokeHandlerAndRespond(t, ()=>c(...a?.args ?? []));
                    }
                    const a = this.requestListeners.get(r);
                    if (!a) return void this.sendErrorResponse(t, new s.HandlerNotFoundError(r));
                    a.once && this.requestListeners.delete(r);
                    const d = {
                        data: (0, i.deserialize)(o, this)
                    };
                    this.invokeHandlerAndRespond(t, ()=>a.handler(d));
                }
                handleResponse(e) {
                    const t = this.pendingRequests.get(e.id);
                    t && (this.pendingRequests.delete(e.id), this.clearPendingTimers(t), e.error ? t.reject((0, i.deserializeError)(e.error)) : t.resolve((0, i.deserialize)(e.data, this)));
                }
                handleAck(e) {
                    const t = this.pendingRequests.get(e.id);
                    t && (t.acked = !0, null !== t.ackTimer && (clearTimeout(t.ackTimer), t.ackTimer = null));
                }
                handleDisconnect() {
                    this.destroyed || (this.destroyed = !0, this.teardown());
                }
                handleFunctionRelease(e) {
                    const { functionId: t } = e, r = this.functionStore.get(t);
                    r && (this.fnToId.delete(r), this.functionStore.delete(t));
                }
                sendAck(e) {
                    try {
                        this.port.postMessage({
                            type: "ACK",
                            id: e
                        });
                    } catch  {}
                }
                sendFunctionRelease(e) {
                    if (!this.destroyed) try {
                        this.port.postMessage({
                            type: "FUNCTION_RELEASE",
                            functionId: e
                        });
                    } catch  {}
                }
                sendResponse(e, t) {
                    try {
                        const r = (0, o.serialize)(t, this.functionStore, this.fnToId);
                        this.port.postMessage({
                            type: "RESPONSE",
                            id: e,
                            data: r
                        });
                    } catch (t) {
                        try {
                            this.sendErrorResponse(e, t instanceof Error ? t : new Error(String(t)));
                        } catch  {}
                    }
                }
                sendErrorResponse(e, t) {
                    const r = t instanceof Error ? t : new Error(String(t)), n = {
                        message: r.message,
                        stack: r.stack,
                        name: r.name,
                        code: r.code
                    };
                    try {
                        this.port.postMessage({
                            type: "RESPONSE",
                            id: e,
                            error: n
                        });
                    } catch  {}
                }
                handleFireAndForget(e, t) {
                    if (e === n.PING_NAME) return;
                    if (e.startsWith(`${n.FUNCTION_CALL_PREFIX}:`)) {
                        const r = e.slice(n.FUNCTION_CALL_PREFIX.length + 1), o = this.functionStore.get(r);
                        if (!o) return;
                        const s = (0, i.deserialize)(t, this);
                        return void this.invokeAndForget(o, s?.args ?? []);
                    }
                    const r = this.requestListeners.get(e);
                    if (!r) return;
                    r.once && this.requestListeners.delete(e);
                    const o = {
                        data: (0, i.deserialize)(t, this)
                    };
                    try {
                        const e = r.handler(o);
                        e instanceof Promise && e.catch(()=>{});
                    } catch  {}
                }
                invokeAndForget(e, t) {
                    try {
                        const r = e(...t);
                        r instanceof Promise && r.catch(()=>{});
                    } catch  {}
                }
                invokeHandlerAndRespond(e, t) {
                    try {
                        const r = t();
                        r instanceof Promise ? r.then((t)=>this.sendResponse(e, t), (t)=>this.sendErrorResponse(e, t)) : this.sendResponse(e, r);
                    } catch (t) {
                        this.sendErrorResponse(e, t);
                    }
                }
                teardown() {
                    const e = new s.ConnectionClosedError();
                    for (const [, t] of this.pendingRequests)this.clearPendingTimers(t), t.reject(e);
                    for (const e of this.disconnectHandlers)try {
                        e();
                    } catch  {}
                    this.requestListeners.clear(), this.pendingRequests.clear(), this.functionStore.clear(), this.fnToId.clear();
                    for (const e of this.proxyCache.values()){
                        const t = e.deref();
                        t && this.functionRegistry.unregister(t);
                    }
                    this.proxyCache.clear(), this.disconnectHandlers.clear();
                    try {
                        this.port.close();
                    } catch  {}
                }
                clearPendingTimers(e) {
                    null !== e.ackTimer && (clearTimeout(e.ackTimer), e.ackTimer = null), null !== e.responseTimer && (clearTimeout(e.responseTimer), e.responseTimer = null);
                }
                constructor(e, t){
                    this.requestListeners = new Map(), this.pendingRequests = new Map(), this.functionStore = new Map(), this.fnToId = new Map(), this.proxyCache = new Map(), this.functionRegistry = new FinalizationRegistry((e)=>{
                        this.proxyCache.delete(e), this.sendFunctionRelease(e);
                    }), this.disconnectHandlers = new Set(), this.destroyed = !1, this.port = e, this.defaultAckTimeout = t?.ackTimeout ?? n.DEFAULT_ACK_TIMEOUT, this.defaultResponseTimeout = t?.timeout ?? n.RESPONSE_TIMEOUT, this.port.onmessage = (e)=>{
                        this.handleMessage(e.data);
                    };
                }
            };
        },
        438 (e, t) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.uniqueID = t.READY_TIMEOUT = t.READY_PROBE_INTERVAL = t.READY_TYPE = t.READY_PROBE_TYPE = t.PING_TIMEOUT = t.PROXY_ID_FIELD = t.PROXY_OWNER_SYMBOL = t.PROXY_ID_SYMBOL = t.PING_NAME = t.ROUTE_REJECT_TYPE = t.FUNCTION_RELEASE_TYPE = t.FUNCTION_CALL_PREFIX = t.HANDSHAKE_ACK_TYPE = t.HANDSHAKE_MSG_TYPE = t.ROUTED_HANDSHAKE_TIMEOUT = t.HANDSHAKE_TIMEOUT = t.RESPONSE_TIMEOUT = t.DEFAULT_ACK_TIMEOUT = void 0, t.DEFAULT_ACK_TIMEOUT = 2e3, t.RESPONSE_TIMEOUT = -1, t.HANDSHAKE_TIMEOUT = 5e3, t.ROUTED_HANDSHAKE_TIMEOUT = 1e4, t.HANDSHAKE_MSG_TYPE = "__port_rpc_handshake__", t.HANDSHAKE_ACK_TYPE = "__port_rpc_handshake_ack__", t.FUNCTION_CALL_PREFIX = "__port_rpc_fn__", t.FUNCTION_RELEASE_TYPE = "__port_rpc_fn_release__", t.ROUTE_REJECT_TYPE = "__port_rpc_route_reject__", t.PING_NAME = "__port_rpc_ping__", t.PROXY_ID_SYMBOL = Symbol.for("port_rpc_proxy_id"), t.PROXY_OWNER_SYMBOL = Symbol.for("port_rpc_proxy_owner"), t.PROXY_ID_FIELD = "__id__", t.PING_TIMEOUT = 2e3, t.READY_PROBE_TYPE = "__port_rpc_ready_probe__", t.READY_TYPE = "__port_rpc_ready__", t.READY_PROBE_INTERVAL = 100, t.READY_TIMEOUT = 5e3;
            let r = 0;
            t.uniqueID = ()=>`uid_${Math.random().toString(36).substring(2)}_${++r}`;
        },
        441 (e, t) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.RoutingError = t.VerificationError = t.DuplicateListenerError = t.HandlerNotFoundError = t.ConnectionClosedError = t.TimeoutError = t.PortRpcError = void 0;
            class r extends Error {
                constructor(e, t = "PORT_RPC_ERROR"){
                    super(e), this.code = t, this.name = "PortRpcError";
                }
            }
            t.PortRpcError = r, t.TimeoutError = class extends r {
                constructor(e = "Operation timed out"){
                    super(e, "TIMEOUT"), this.name = "TimeoutError";
                }
            }, t.ConnectionClosedError = class extends r {
                constructor(e = "Connection is closed"){
                    super(e, "CONNECTION_CLOSED"), this.name = "ConnectionClosedError";
                }
            }, t.HandlerNotFoundError = class extends r {
                constructor(e){
                    super(`No handler registered for "${e}"`, "HANDLER_NOT_FOUND"), this.name = "HandlerNotFoundError";
                }
            }, t.DuplicateListenerError = class extends r {
                constructor(e){
                    super(`A listener is already registered for "${e}"`, "DUPLICATE_LISTENER"), this.name = "DuplicateListenerError";
                }
            }, t.VerificationError = class extends r {
                constructor(e = "Verification failed"){
                    super(e, "VERIFICATION_FAILED"), this.name = "VerificationError";
                }
            }, t.RoutingError = class extends r {
                constructor(e = "Routing failed"){
                    super(e, "ROUTING_FAILED"), this.name = "RoutingError";
                }
            };
        },
        629 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.forward = void 0;
            const n = r(930);
            t.forward = (e, t)=>(0, n.registerForwardResolver)(e, t);
        },
        690 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.resolveTarget = t.isWindow = void 0;
            const n = r(441);
            t.isWindow = (e)=>{
                if (!e) return !1;
                try {
                    const t = e;
                    return "function" == typeof t.postMessage && "object" == typeof t.self && null !== t.self;
                } catch (e) {
                    return e instanceof DOMException && "SecurityError" === e.name;
                }
            }, t.resolveTarget = (e, r, o = "connect")=>{
                if ("undefined" != typeof HTMLIFrameElement && e instanceof HTMLIFrameElement) {
                    const t = e.contentWindow;
                    if (!t) throw new n.PortRpcError(`Cannot ${o}: iframe has no contentWindow (not yet loaded?)`);
                    return {
                        post (e, n) {
                            t.postMessage(e, r, n);
                        }
                    };
                }
                if ("undefined" != typeof Worker && e instanceof Worker) return {
                    post (t, r) {
                        e.postMessage(t, r);
                    }
                };
                if ((0, t.isWindow)(e)) return {
                    post (t, n) {
                        e.postMessage(t, r, n);
                    }
                };
                throw new n.PortRpcError(`Unsupported ${o} target`);
            };
        },
        906 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.serialize = void 0;
            const n = r(438);
            t.serialize = (e, t, r, n = new WeakSet())=>{
                if (null == e) return e;
                if ("function" == typeof e) return i(e, t, r);
                if (e instanceof Error) return s(e);
                if (e instanceof RegExp) return c(e);
                if (e instanceof Date || e instanceof ArrayBuffer || ArrayBuffer.isView(e)) return e;
                if ("object" == typeof e) {
                    if (n.has(e)) return;
                    n.add(e);
                    const i = o(e, t, r, n);
                    return n.delete(e), i;
                }
                return "symbol" != typeof e ? e : void 0;
            };
            const o = (e, r, n, o)=>{
                if (Array.isArray(e)) return e.map((e)=>(0, t.serialize)(e, r, n, o));
                if (e instanceof Map) {
                    const i = new Map();
                    for (const [s, c] of e)i.set(s, (0, t.serialize)(c, r, n, o));
                    return i;
                }
                if (e instanceof Set) {
                    const i = new Set();
                    for (const s of e)i.add((0, t.serialize)(s, r, n, o));
                    return i;
                }
                const i = {};
                for (const s of Object.keys(e))i[s] = (0, t.serialize)(e[s], r, n, o);
                return i;
            }, i = (e, t, r)=>{
                const o = e, i = o[n.PROXY_ID_SYMBOL];
                if (i && "string" == typeof i) {
                    const s = o[n.PROXY_OWNER_SYMBOL];
                    if (void 0 === s || s === t) return {
                        __type__: "port_rpc_function",
                        __id__: i,
                        __name__: e.name || "anonymous"
                    };
                    const c = r.get(e) ?? (0, n.uniqueID)();
                    return r.set(e, c), t.set(c, e), {
                        __type__: "port_rpc_function",
                        __id__: c,
                        __name__: e.name || "anonymous"
                    };
                }
                const s = r.get(e);
                if (s) return {
                    __type__: "port_rpc_function",
                    __id__: s,
                    __name__: e.name || "anonymous"
                };
                const c = e[n.PROXY_ID_FIELD] || (0, n.uniqueID)();
                return r.set(e, c), t.set(c, e), {
                    __type__: "port_rpc_function",
                    __id__: c,
                    __name__: e.name || "anonymous"
                };
            }, s = (e)=>({
                    __type__: "port_rpc_error",
                    message: e.message,
                    stack: e.stack,
                    code: e.code,
                    name: e.name
                }), c = (e)=>({
                    __type__: "port_rpc_regex",
                    source: e.source,
                    flags: e.flags
                });
        },
        930 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t._resetDispatcher = t.registerForwardResolver = t.onConnect = t.accept = void 0;
            const n = r(438), o = r(402), i = r(441), s = r(690), c = [], a = [];
            let d = null, u = null;
            const l = ()=>"undefined" != typeof DedicatedWorkerGlobalScope && self instanceof DedicatedWorkerGlobalScope, f = ()=>{
                if (d) return;
                const e = (()=>{
                    if (l()) return self;
                    if ("undefined" != typeof window) return window;
                    throw new i.PortRpcError("Cannot detect accept/forward context");
                })(), t = (e)=>{
                    const t = e.data;
                    if (t?.type === n.READY_PROBE_TYPE) {
                        const r = l() ? "worker" : e.origin ?? "unknown";
                        return void (w(r) && R(e, t.nonce ?? ""));
                    }
                    m(e);
                };
                u = e, d = t, e.addEventListener("message", t);
            }, _ = ()=>{
                u && d && u.removeEventListener("message", d), u = null, d = null;
            }, p = (e, t)=>{
                const r = e.indexOf(t);
                return -1 !== r && (e.splice(r, 1), 0 === c.length && 0 === a.length && _(), !0);
            }, h = async (e, t, r, n)=>e.consumed ? "next" : !e.allowedOrigins || l() || e.allowedOrigins.includes(n) ? e.matcher ? E(e, t, r) : (e.resolve && (e.consumed = !0), y(t, !0), g(e, new o.ConnectionImpl(t, e.connectionOptions), r), "consumed") : "next", E = async (e, t, r)=>{
                let n;
                try {
                    n = await e.matcher(r);
                } catch  {
                    return "next";
                }
                return !1 === n ? "next" : e.consumed ? "restart" : (e.resolve && (e.consumed = !0), y(t, "object" != typeof n || n), g(e, new o.ConnectionImpl(t, e.connectionOptions), r), "consumed");
            }, m = async (e)=>{
                const t = e.data;
                if (!t || t.type !== n.HANDSHAKE_MSG_TYPE) return;
                const r = e.ports?.[0];
                if (!r) return;
                const o = "context" in t && null != t.context ? t.context : void 0, i = l() ? "worker" : e.origin ?? "unknown";
                if (o && await (async (e, t, r)=>{
                    for (const n of [
                        ...c
                    ]){
                        if (n.options?.allowedOrigins && !l() && !n.options.allowedOrigins.includes(r)) continue;
                        let o;
                        try {
                            o = await n.resolver(t);
                        } catch (t) {
                            return T(e, t instanceof Error ? t.message : String(t)), !0;
                        }
                        if (null != o) return O(e, t, o, r), !0;
                    }
                    return !1;
                })(r, o, i)) return;
                const s = o ? {
                    ...o,
                    origin: i
                } : {
                    origin: i
                };
                if (!await (async (e, t, r)=>{
                    let n = !1;
                    do {
                        n = !1;
                        for (const o of a){
                            const i = await h(o, e, t, r);
                            if ("consumed" === i) return !0;
                            if ("restart" === i) {
                                n = !0;
                                break;
                            }
                        }
                    }while (n);
                    return !1;
                })(r, s, i)) try {
                    r.close();
                } catch  {}
            }, g = (e, t, r)=>{
                e.resolve ? (p(a, e), e.resolve(t, r)) : e.handler && e.handler(t, r);
            }, y = (e, t)=>{
                const r = {
                    type: n.HANDSHAKE_ACK_TYPE,
                    verificationData: t
                };
                try {
                    e.postMessage(r);
                } catch  {}
            }, T = (e, t)=>{
                const r = {
                    type: n.ROUTE_REJECT_TYPE,
                    error: t
                };
                try {
                    e.postMessage(r);
                } catch  {}
            }, w = (e)=>{
                if (l()) return !0;
                for (const t of a)if (!t.allowedOrigins || t.allowedOrigins.includes(e)) return !0;
                for (const t of c)if (!t.options?.allowedOrigins || t.options.allowedOrigins.includes(e)) return !0;
                return !1;
            }, R = (e, t)=>{
                const r = {
                    type: n.READY_TYPE,
                    nonce: t
                };
                if (l()) {
                    try {
                        self.postMessage(r);
                    } catch  {}
                    return;
                }
                const o = e.source;
                if (o && "function" == typeof o.postMessage) try {
                    o.postMessage(r, e.origin || "*");
                } catch  {}
            }, O = (e, t, r, o)=>{
                const i = {
                    ...t,
                    origin: o
                }, c = r.origin ?? "*", a = {
                    type: n.HANDSHAKE_MSG_TYPE,
                    context: i
                };
                try {
                    (0, s.resolveTarget)(r.target, c, "forward").post(a, [
                        e
                    ]);
                } catch (t) {
                    T(e, `Forward failed: ${t instanceof Error ? t.message : String(t)}`);
                }
            };
            t.accept = (e)=>{
                f();
                const t = e?.timeout ?? n.HANDSHAKE_TIMEOUT;
                return new Promise((r, n)=>{
                    const o = {
                        matcher: e?.matcher,
                        allowedOrigins: e?.allowedOrigins,
                        connectionOptions: e?.connectionOptions,
                        resolve: (e)=>{
                            clearTimeout(s), r(e);
                        },
                        reject: n
                    };
                    a.push(o);
                    const s = setTimeout(()=>{
                        o.consumed || (p(a, o), n(new i.TimeoutError(`Accept timeout: no connection received within ${t}ms`)));
                    }, t);
                });
            }, t.onConnect = (e, t)=>{
                f();
                const r = new Set(), n = {
                    matcher: t?.matcher,
                    allowedOrigins: t?.allowedOrigins,
                    connectionOptions: t?.connectionOptions,
                    handler: (t, n)=>{
                        r.add(t), t.onDisconnect(()=>{
                            r.delete(t);
                        }), e(t, n);
                    }
                };
                a.push(n);
                const o = {
                    connections: r,
                    cancel () {
                        p(a, n);
                    },
                    destroyAll () {
                        o.cancel();
                        for (const e of [
                            ...r
                        ])e.destroy();
                        r.clear();
                    }
                };
                return o;
            }, t.registerForwardResolver = (e, t)=>{
                f();
                const r = {
                    resolver: e,
                    options: t
                };
                return c.push(r), {
                    cancel () {
                        p(c, r);
                    }
                };
            }, t._resetDispatcher = ()=>{
                for (const e of a)e.consumed = !0;
                c.length = 0, a.length = 0, _();
            };
        }
    }, t = {};
    function r(n) {
        var o = t[n];
        if (void 0 !== o) return o.exports;
        var i = t[n] = {
            exports: {}
        };
        return e[n](i, i.exports, r), i.exports;
    }
    r.d = (e, t)=>{
        for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
        });
    }, r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    };
    var n = {};
    r.r(n), r.d(n, {
        createEmbeddedMacroBridgeListener: ()=>_,
        createEmbeddedMacroListener: ()=>p,
        createIframeBridge: ()=>f,
        createWorkerBridge: ()=>E,
        establishConnectionWithProductHost: ()=>h,
        setupSandboxController: ()=>m
    });
    var o = r(304), i = function(e) {
        return "HANDLER_NOT_FOUND" === (null == e ? void 0 : e.code) || (null == e ? void 0 : e.message.startsWith("No handler found for post message:")) ? Promise.resolve() : Promise.reject("Error while sending bridge message: ".concat(null == e ? void 0 : e.message));
    }, s = "__ready", c = 2e4, a = 1e4, d = function(e, t) {
        return Object.entries(t).map(function(t) {
            var r = t[0], n = t[1];
            return e.on(r, function(e) {
                return n ? n(e) : Promise.resolve();
            });
        });
    }, u = function(e, t, r, n) {
        e.send(s, t, {
            timeout: c,
            ackTimeout: !1
        }).then(function() {
            r(!0);
        }).catch(function(e) {
            return r(!1, e), i(e);
        }).catch(function(e) {
            console.error(n, e);
        });
    }, l = function() {
        return l = Object.assign || function(e) {
            for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
        }, l.apply(this, arguments);
    }, f = function(e) {
        if (!e.withWindow) throw new Error("Target window to setup the bridge with is not defined");
        return {
            open: function() {
                var t = e.withWindow, r = e.withDomain, n = e.features, f = e.theme, _ = e.surfaceColor, p = e.sendHandshakeMetric, h = e.metadata, E = e.shouldWaitForReady;
                return (0, o._4)(t, {
                    origin: r,
                    timeout: c,
                    connectionOptions: {
                        ackTimeout: a
                    },
                    waitForReady: E,
                    context: {
                        type: "iframe-bridge",
                        metadata: h
                    }
                }).then(function(e) {
                    var t = d(e, n), r = e.on(s, function() {
                        return null;
                    });
                    return u(e, l({
                        theme: f,
                        surfaceColor: _
                    }, h || {}), p, "Iframe bridge: unexpected error in READY_EVENT handler:"), {
                        enableTheming: function() {
                            e.send("__theme_enable", null).catch(i);
                        },
                        setTheme: function(t, r, n) {
                            e.send("__theme_change", {
                                theme: t,
                                surfaceColor: r,
                                env: n,
                                isFedRamp: null == h ? void 0 : h.isFedRamp
                            }).catch(i);
                        },
                        close: function() {
                            r.cancel(), t.forEach(function(e) {
                                return (0, e.cancel)();
                            }), e.destroy();
                        }
                    };
                });
            }
        };
    }, _ = function(e) {
        var t = window.location.origin;
        return (0, o.GJ)(function(t) {
            d(t, e);
        }, {
            matcher: function(e) {
                return "embeddedMacro" === e.type && e.origin === t && {
                    origin: t
                };
            }
        });
    }, p = function(e) {
        var t = _(e);
        return {
            close: function() {
                return t.destroyAll();
            }
        };
    }, h = function(e, t, r) {
        return (0, o._4)(e, {
            timeout: c,
            connectionOptions: {
                ackTimeout: a
            },
            waitForReady: r,
            context: {
                type: "embeddedMacro",
                origin: t
            },
            verify: function(e) {
                return e.origin === t;
            }
        });
    }, E = function(e) {
        if (!e.withWindow) throw new Error("Target window to setup the bridge with is not defined");
        return {
            open: function() {
                var t = e.withWindow, r = e.withDomain, n = e.features, i = e.sendHandshakeMetric, s = e.metadata, l = e.workerId, f = e.shouldWaitForReady;
                return (0, o._4)(t, {
                    origin: r,
                    timeout: c,
                    connectionOptions: {
                        ackTimeout: a
                    },
                    waitForReady: f,
                    context: {
                        type: "worker-bridge",
                        workerId: l,
                        metadata: s
                    }
                }).then(function(e) {
                    var t = d(e, n);
                    return u(e, null, i, "Worker bridge: unexpected error in READY_EVENT handler:"), {
                        enableTheming: function() {},
                        setTheme: function() {},
                        close: function() {
                            t.forEach(function(e) {
                                return (0, e.cancel)();
                            }), e.destroy();
                        }
                    };
                });
            }
        };
    }, m = function(e, t, r) {
        return (0, o._4)(e, {
            origin: t,
            timeout: 1e4,
            connectionOptions: {
                ackTimeout: a
            },
            waitForReady: r
        }).then(function(e) {
            return e.send("__sandbox_controller_request", null, {
                timeout: 1e4,
                ackTimeout: !1
            }).then(function(t) {
                return {
                    controller: t,
                    destroy: function() {
                        return e.destroy();
                    }
                };
            }).catch(function(r) {
                throw e.destroy(), new Error("Sandbox did not provide a controller (origin: ".concat(t, "): ").concat(r.message));
            });
        }, function(e) {
            throw new Error("Sandbox handshake failed (origin: ".concat(t, "): ").concat(e.message));
        });
    };
    module.exports = n;
})();

});

parcelRegister("6hkBe", function(module, exports) {
const $79126e23f70deddc$export$5dfdba3e408a8d60 = (extension, entryPoint)=>{
    const entryPointProperties = entryPoint ? extension.properties[entryPoint] : extension.properties;
    // The entry point owns the resource+entry pair only when it declares its own resource bundle.
    if (entryPointProperties?.resource) return {
        resource: entryPointProperties.resource,
        resolvedResourceEntry: entryPointProperties.resolvedResourceEntry
    };
    // Otherwise borrow the top-level resource bundle, served at its default entry (no entry carried over).
    return {
        resource: extension.properties.resource,
        resolvedResourceEntry: undefined
    };
};
module.exports["getExtensionEntryPoint"] = $79126e23f70deddc$export$5dfdba3e408a8d60;

});

parcelRegister("lwhTs", function(module, exports) {

var $fDyI6 = parcelRequire("fDyI6");


var $aGJob = parcelRequire("aGJob");


var $5Pxyc = parcelRequire("5Pxyc");

/**
 * Middlewares applied to every bridge method across all runtimes.
 * Order is outermost-first: the first entry wraps all subsequent ones.
 *
 * `withErrorDisplay` is outermost so it catches errors after `withMetrics` has
 * reported them (Sentry/analytics), then surfaces an error from the Forge app for
 * classified `ForgeAppError`s before the error continues rejecting to the app.
 */ const $083504e283bb0724$var$DEFAULT_MIDDLEWARES = [
    (0, $5Pxyc.withErrorDisplay),
    (0, $aGJob.withMetrics)
];
const $083504e283bb0724$var$applyMiddleware = (method, methodName, middlewares)=>middlewares.reduceRight((m, mw)=>mw(m, methodName), method);
const $083504e283bb0724$export$35cddec71f2b332c = (getBridgeContext, adaptBridgeMethods, adaptMiddlewares = (defaults)=>defaults)=>{
    const middlewares = adaptMiddlewares([
        ...$083504e283bb0724$var$DEFAULT_MIDDLEWARES
    ]);
    const bridgeMethods = adaptBridgeMethods ? adaptBridgeMethods((0, $fDyI6.bridgeMethods)) : (0, $fDyI6.bridgeMethods);
    return Object.entries(bridgeMethods).reduce((features, [methodName, method])=>{
        const wrapped = $083504e283bb0724$var$applyMiddleware(method, methodName, middlewares);
        features[methodName] = $083504e283bb0724$var$convertToBridgeInvokeHandler((payload)=>{
            // Call getBridgeContext() at invocation time, not creation time, so each
            // bridge call always uses the latest context rather than a stale snapshot.
            return wrapped(getBridgeContext(), payload);
        });
        return features;
    }, {});
};
const $083504e283bb0724$var$convertToBridgeInvokeHandler = (method)=>{
    return async ({ data: data })=>{
        if (method) return await method(data) ?? true;
        return false;
    };
};
module.exports["createBridgeFeatures"] = $083504e283bb0724$export$35cddec71f2b332c;

});

parcelRegister("i7d45", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $hYe60 = parcelRequire("hYe60");


var $luNHV = parcelRequire("luNHV");

const $650e4e464f468af1$export$e28a9b61f2b3f391 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props, getServices, contextChangeListeners)=>{
    const $ = (0, $frIzR.c)(25);
    const contextObjectRef = (0, $42omo.useRef)(null);
    if (contextObjectRef.current === null) {
        let t0;
        if ($[0] !== getServices || $[1] !== props) {
            t0 = new (0, $hYe60.BridgeContextObject)(props, getServices);
            $[0] = getServices;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        contextObjectRef.current = t0;
    }
    let t0;
    if ($[3] !== props) {
        t0 = ()=>{
            contextObjectRef.current.update(props);
        };
        $[3] = props;
        $[4] = t0;
    } else t0 = $[4];
    (0, $42omo.useEffect)(t0);
    let t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>contextObjectRef.current.get();
        t2 = [];
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    const getBridgeContext = (0, $hQK66.useCallbackOne)(t1, t2);
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>contextObjectRef.current.destroy();
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    const destroy = (0, $hQK66.useCallbackOne)(t3, t4);
    let t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (listener)=>contextObjectRef.current.onChange(listener);
        t6 = [];
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    const onChange = (0, $hQK66.useCallbackOne)(t5, t6);
    let t7;
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (controls)=>contextObjectRef.current.setBridgeControl(controls);
        t8 = [];
        $[11] = t7;
        $[12] = t8;
    } else {
        t7 = $[11];
        t8 = $[12];
    }
    const setBridgeControl = (0, $hQK66.useCallbackOne)(t7, t8);
    let t10;
    let t9;
    if ($[13] !== onChange) {
        t9 = ()=>onChange($650e4e464f468af1$var$_temp);
        t10 = [
            onChange
        ];
        $[13] = onChange;
        $[14] = t10;
        $[15] = t9;
    } else {
        t10 = $[14];
        t9 = $[15];
    }
    (0, $42omo.useEffect)(t9, t10);
    let t11;
    let t12;
    if ($[16] !== contextChangeListeners || $[17] !== onChange) {
        t11 = ()=>{
            if (!contextChangeListeners?.length) return;
            const unsubs = contextChangeListeners.map((listener_0)=>onChange(listener_0));
            return ()=>unsubs.forEach($650e4e464f468af1$var$_temp2);
        };
        t12 = [
            onChange,
            contextChangeListeners
        ];
        $[16] = contextChangeListeners;
        $[17] = onChange;
        $[18] = t11;
        $[19] = t12;
    } else {
        t11 = $[18];
        t12 = $[19];
    }
    (0, $42omo.useEffect)(t11, t12);
    let t13;
    if ($[20] !== destroy || $[21] !== getBridgeContext || $[22] !== onChange || $[23] !== setBridgeControl) {
        t13 = {
            getBridgeContext: getBridgeContext,
            destroy: destroy,
            onChange: onChange,
            setBridgeControl: setBridgeControl
        };
        $[20] = destroy;
        $[21] = getBridgeContext;
        $[22] = onChange;
        $[23] = setBridgeControl;
        $[24] = t13;
    } else t13 = $[24];
    return t13;
} : (props, getServices, contextChangeListeners)=>{
    // Created once for the lifetime of the component.
    // BridgeContextObject owns all memoization and change notification internally.
    const contextObjectRef = (0, $42omo.useRef)(null);
    if (contextObjectRef.current === null) contextObjectRef.current = new (0, $hYe60.BridgeContextObject)(props, getServices);
    // Update after every commit. Bridge calls arrive via postRobot (async message events)
    // so the context will always be current before any bridge method is invoked.
    (0, $42omo.useEffect)(()=>{
        contextObjectRef.current.update(props);
    });
    const getBridgeContext = (0, $hQK66.useCallbackOne)(()=>contextObjectRef.current.get(), []);
    const destroy = (0, $hQK66.useCallbackOne)(()=>contextObjectRef.current.destroy(), []);
    const onChange = (0, $hQK66.useCallbackOne)((listener)=>contextObjectRef.current.onChange(listener), []);
    const setBridgeControl = (0, $hQK66.useCallbackOne)((controls)=>contextObjectRef.current.setBridgeControl(controls), []);
    // This registers general bridge context change events that is common to all
    // bridge runtimes and Forge modules.
    (0, $42omo.useEffect)(()=>{
        return onChange((_prev, next, changes)=>{
            if (changes.theme || changes.surfaceColor) (0, $luNHV.emit)('FORGE_CORE_THEME_CHANGED', {
                theme: next.theme
            });
        });
    }, [
        onChange
    ]);
    // Register integrator-supplied context change listeners (e.g. from xen-editor-provider).
    // Listeners must be stable module-level references to avoid re-registration on each render.
    (0, $42omo.useEffect)(()=>{
        if (!contextChangeListeners?.length) return;
        const unsubs = contextChangeListeners.map((listener_0)=>onChange(listener_0));
        return ()=>unsubs.forEach((unsub)=>unsub());
    }, [
        onChange,
        contextChangeListeners
    ]);
    return {
        getBridgeContext: getBridgeContext,
        destroy: destroy,
        onChange: onChange,
        setBridgeControl: setBridgeControl
    };
};
function $650e4e464f468af1$var$_temp(_prev, next, changes) {
    if (changes.theme || changes.surfaceColor) (0, $luNHV.emit)("FORGE_CORE_THEME_CHANGED", {
        theme: next.theme
    });
}
function $650e4e464f468af1$var$_temp2(unsub) {
    return unsub();
}
module.exports["useBridgeContext"] = $650e4e464f468af1$export$e28a9b61f2b3f391;

});

parcelRegister("1qkDW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $inPa6 = parcelRequire("inPa6");


var $6oQb1 = parcelRequire("6oQb1");


var $iUjrf = parcelRequire("iUjrf");


var $dj2Gr = parcelRequire("dj2Gr");


var $kaOT1 = parcelRequire("kaOT1");


var $jIiuI = parcelRequire("jIiuI");


var $9XihO = parcelRequire("9XihO");


var $20GoR = parcelRequire("20GoR");


var $3AYRA = parcelRequire("3AYRA");


var $i25hX = parcelRequire("i25hX");

const $b22670f2947f2693$var$ROVO_TOPIC = 'ai-mate';
const $b22670f2947f2693$export$74964fd55d087734 = (props, overlayController, renderThreeLOPrompt, showAppError)=>{
    // renderThreeLOPrompt is read from props at service-assembly time (see servicesRef below).
    const invoker = (0, $dj2Gr.useInvokeExtension)(props.contextIds, props.extension.id);
    const tracing = (0, $kaOT1.useTracingContext)();
    const environment = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $jIiuI.EnvironmentContext));
    const relayContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $irOoi.ReactRelayContext));
    const isAnonymousAccessSupportedByApp = props.extension.properties?.unlicensedAccess?.includes('anonymous') ?? false;
    // Adapts the two-argument renderThreeLOPrompt into the single-argument shape
    // expected by useProductFetchClient. Falls back to a no-op when the extension
    // has no consentUrl (e.g. sandbox/test environments).
    const productRenderThreeLOPrompt = (retry)=>{
        const consentUrl = props.extension.consentUrl;
        if (!consentUrl) return Promise.resolve();
        return renderThreeLOPrompt(consentUrl, retry);
    };
    const remoteFetchClient = (0, $3AYRA.useRemoteFetchClient)();
    const permissionFetchClient = (0, $20GoR.usePermissionFetchClient)({
        appId: props.appId,
        installationId: props.extension.installationId,
        contextIds: props.contextIds,
        extensionId: props.extension.id,
        renderThreeLOPrompt: productRenderThreeLOPrompt
    });
    const productFetchClient = (0, $9XihO.useProductFetchClient)({
        appId: props.appId,
        environment: environment,
        contextIds: props.contextIds,
        cloudId: props.coreData.cloudId,
        workspaceId: props.coreData.workspaceId,
        extensionId: props.extension.id,
        isAnonymousAccessSupportedByApp: isAnonymousAccessSupportedByApp,
        renderThreeLOPrompt: productRenderThreeLOPrompt
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const analyticsTracker = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const { captureUntrustedEvent: captureUntrustedEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const rovoPublisher = (0, $i25hX.usePublish)($b22670f2947f2693$var$ROVO_TOPIC);
    // All hook calls must precede the tracing guard below.
    // servicesRef holds the latest assembled BridgeServices snapshot and is updated
    // synchronously every render. The stable getter reads from it at bridge-call time,
    // so every service (invoker, getContextToken, productFetchClient, etc.) is always
    // current — regardless of which dep changed — without per-service ref boilerplate.
    const servicesRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const getServices = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>servicesRef.current).current;
    if (!tracing) throw new Error('WorkerWebRuntime: TracingProvider not found in the component tree. ');
    if (!relayContext?.environment) throw new Error('useBridgeServices: RelayEnvironmentProvider not found in the component tree.');
    // Assembled fresh every render; updates the ref synchronously so any in-flight
    // bridge call that fires after this render always sees the latest values.
    servicesRef.current = {
        invoker: invoker,
        getContextToken: props.getContextToken ?? $b22670f2947f2693$var$nullGetContextToken,
        tracing: tracing,
        overlayController: overlayController,
        onThreeLO: renderThreeLOPrompt,
        showAppError: showAppError,
        productFetchClient: productFetchClient,
        permissionFetchClient: permissionFetchClient,
        remoteFetchClient: remoteFetchClient,
        relayEnvironment: relayContext.environment,
        analytics: {
            createAnalyticsEvent: createAnalyticsEvent,
            fireUIEvent: (payload)=>(0, $6oQb1.fireUIEvent)(createAnalyticsEvent, payload),
            tracker: analyticsTracker,
            captureUntrustedEvent: captureUntrustedEvent
        },
        rovoPublisher: rovoPublisher
    };
    return {
        getServices: getServices
    };
};
// TODO: currently sandbox does not support getContextToken (unlike other products),
// so we provide a noop implementation to avoid having to guard every bridge method that uses it.
const $b22670f2947f2693$var$nullGetContextToken = ()=>undefined;
module.exports["useBridgeServices"] = $b22670f2947f2693$export$74964fd55d087734;

});

parcelRegister("jIrI4", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b44b52f09e1be159$export$38896ac4f3cfe88b = ()=>{
    const [overlayContent, setOverlayContent] = (0, $42omo.useState)(null);
    const [isOverlayOpen, setIsOverlayOpen] = (0, $42omo.useState)(false);
    const [affectsLayout, setAffectsLayout] = (0, $42omo.useState)(false);
    // Stable object — never recreated, always points at the current setter.
    const overlayControllerRef = (0, $42omo.useRef)({
        show: (content, willAffectsLayout = false)=>{
            setOverlayContent(content);
            setAffectsLayout(willAffectsLayout);
            setIsOverlayOpen(true);
        },
        hide: ()=>setIsOverlayOpen(false)
    });
    const overlay = isOverlayOpen ? overlayContent : null;
    return {
        overlay: overlay,
        overlayController: overlayControllerRef.current,
        isInlineActive: affectsLayout && isOverlayOpen
    };
};
module.exports["useRuntimeOverlayController"] = $b44b52f09e1be159$export$38896ac4f3cfe88b;

});

parcelRegister("45XLP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $hBtmC = parcelRequire("hBtmC");

const $95763a2a5f395eb4$export$52e78aa5a2993420 = ({ overlayController: overlayController, extension: extension, setShouldShowRenderer: setShouldShowRenderer, onError: onError })=>{
    // Always-current values so the stable callback never reads stale props.
    const latestRef = (0, $42omo.useRef)({
        overlayController: overlayController,
        extension: extension,
        setShouldShowRenderer: setShouldShowRenderer,
        onError: onError
    });
    latestRef.current = {
        overlayController: overlayController,
        extension: extension,
        setShouldShowRenderer: setShouldShowRenderer,
        onError: onError
    };
    return (0, $hQK66.useCallbackOne)((error)=>{
        const { overlayController: overlayController_0, extension: extension_0, setShouldShowRenderer: setShouldShowRenderer_0, onError: onError_0 } = latestRef.current;
        overlayController_0.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hBtmC.ForgeAppErrorMessage), {
            extension: extension_0,
            error: error.errorType
        }), true);
        setShouldShowRenderer_0?.(false);
        // Notify the product. Display is handled above; in UIKit `setShouldShowRenderer(false)` keeps
        // RendererNext suppressed, so this only fires the `onError`/`onAppError` side-effects.
        onError_0?.(error.errorType);
    }, []);
};
module.exports["useRuntimeErrorOverlay"] = $95763a2a5f395eb4$export$52e78aa5a2993420;

});

parcelRegister("4k05I", function(module, exports) {
const $f43cd4265afb1a4d$export$f4f2aa6cb4b9798b = (method)=>async (_ctx, payload)=>{
        return await method(payload);
    };
const $f43cd4265afb1a4d$export$19e15058b637a8c7 = (baseBridgeMethods, legacyCustomBridgeMethods, customBridge)=>{
    if (!legacyCustomBridgeMethods && !customBridge) return baseBridgeMethods;
    const convertedLegacyMethods = legacyCustomBridgeMethods ? Object.entries(legacyCustomBridgeMethods).reduce((acc, [methodName, method])=>{
        acc[methodName] = $f43cd4265afb1a4d$export$f4f2aa6cb4b9798b(method);
        return acc;
    }, {}) : {};
    return {
        ...baseBridgeMethods,
        ...convertedLegacyMethods,
        ...customBridge
    };
};
module.exports["consolidateCustomBridge"] = $f43cd4265afb1a4d$export$19e15058b637a8c7;

});

parcelRegister("gwUcI", function(module, exports) {
const $388fc69d2d887761$var$uuidRe = new RegExp('^{([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})}$');
const $388fc69d2d887761$export$3a1a8bfb58a690be = (uuid)=>{
    const match = $388fc69d2d887761$var$uuidRe.exec(uuid);
    if (!match) return '';
    return match[1];
};
module.exports["uncurlyUuid"] = $388fc69d2d887761$export$3a1a8bfb58a690be;

});

parcelRegister("69400", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $6b91a44b41ae4f33$export$61945ff869c3ddb = /*#__PURE__*/ (0, $42omo.createContext)({
    frameCount: 0,
    setFrameCount: ()=>{}
});
const $6b91a44b41ae4f33$var$FrameCountProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [frameCount, setFrameCount] = (0, $42omo.useState)(0);
    let t1;
    if ($[0] !== frameCount) {
        t1 = {
            frameCount: frameCount,
            setFrameCount: setFrameCount
        };
        $[0] = frameCount;
        $[1] = t1;
    } else t1 = $[1];
    const value = t1;
    let t2;
    let t3;
    if ($[2] !== frameCount) {
        t2 = ()=>{
            if (frameCount > 1) throw new Error("Max limit of one frame component per module.");
        };
        t3 = [
            frameCount
        ];
        $[2] = frameCount;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[5] !== children || $[6] !== value) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b91a44b41ae4f33$export$61945ff869c3ddb.Provider, {
            value: value
        }, children);
        $[5] = children;
        $[6] = value;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children })=>{
    const [frameCount, setFrameCount] = (0, $42omo.useState)(0);
    const value = {
        frameCount: frameCount,
        setFrameCount: setFrameCount
    };
    (0, $42omo.useEffect)(()=>{
        if (frameCount > 1) throw new Error('Max limit of one frame component per module.');
    }, [
        frameCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b91a44b41ae4f33$export$61945ff869c3ddb.Provider, {
        value: value
    }, children);
};
var $6b91a44b41ae4f33$export$2e2bcd8739ae039 = $6b91a44b41ae4f33$var$FrameCountProvider;
module.exports["FrameCount"] = $6b91a44b41ae4f33$export$61945ff869c3ddb;
module.exports["default"] = $6b91a44b41ae4f33$export$2e2bcd8739ae039;

});

parcelRegister("9c0Ac", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bedQP = parcelRequire("bedQP");

var $49YLc = parcelRequire("49YLc");

const $a542b484036b0115$var$createUserAccessContext = ()=>/*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $a542b484036b0115$var$createNoopContext = ()=>/*#__PURE__*/ (0, $42omo.createContext)({
        accountId: undefined,
        isUserAnonymous: false
    });
const $a542b484036b0115$export$45572a5e2c7b827f = (0, $49YLc.functionWithFG)('forge-ui-allow-anon-rest-calls', $a542b484036b0115$var$createUserAccessContext, $a542b484036b0115$var$createNoopContext)();
const $a542b484036b0115$var$UserAccessProviderImpl = ({ accountId: accountId, children: children })=>{
    const value = (0, $42omo.useMemo)(()=>{
        return {
            accountId: accountId,
            // Determine whether a user is anonymously accessing the Forge app UI.
            // Future: enhance to incorporate product account types, and Forge
            // decoupled licensing logic.
            get isUserAnonymous () {
                return !accountId;
            }
        };
    }, [
        accountId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a542b484036b0115$export$45572a5e2c7b827f.Provider, {
        value: value
    }, children);
};
const $a542b484036b0115$export$413b4e1df9bd6693 = (0, $bedQP.componentWithFG)('forge-ui-allow-anon-rest-calls', $a542b484036b0115$var$UserAccessProviderImpl, (0, $42omo.Fragment));
module.exports["UserAccessContext"] = $a542b484036b0115$export$45572a5e2c7b827f;
module.exports["UserAccessProvider"] = $a542b484036b0115$export$413b4e1df9bd6693;

});

parcelRegister("i35rc", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fgbwU = parcelRequire("fgbwU");


var $aXWIB = parcelRequire("aXWIB");


var $u9agA = parcelRequire("u9agA");


var $ebrpi = parcelRequire("ebrpi");


var $9P47v = parcelRequire("9P47v");


var $dh538 = parcelRequire("dh538");

// TODO: We should make appName non-optional later: http://go/j/AUX-570
// appName was made optional because it isn't in already inserted apps prior to the change in http://go/j/AUX-411
const $cf1792e251a9a919$var$defaultPromptMessage = (intl, appName)=>{
    return intl.formatMessage((0, $dh538.fg)('product-terminology-refresh') ? $cf1792e251a9a919$var$messages.defaultPromptMessageAppify : $cf1792e251a9a919$var$messages.defaultPromptMessage, {
        appString: appName ? appName : intl.formatMessage($cf1792e251a9a919$var$messages.thisAppLower)
    });
};
const $cf1792e251a9a919$var$externalAuthPromptMessage = (intl, appName)=>{
    return intl.formatMessage($cf1792e251a9a919$var$messages.externalAuthPromptMessage, {
        appString: appName ? appName : intl.formatMessage($cf1792e251a9a919$var$messages.thisAppUpper)
    });
};
const $cf1792e251a9a919$export$1d39dc5b47e56ff0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(31);
    const { message: message, promptText: promptText, appName: appName, authUrl: authUrl, onSuccess: onSuccess } = t0;
    const [failedToAuthenticate, setFailedToAuthenticate] = (0, $42omo.useState)(false);
    const [authFailureMessage, setAuthFailureMessage] = (0, $42omo.useState)(false);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== authUrl) {
        t1 = (0, $fgbwU.isExternalAuth)(authUrl);
        $[0] = authUrl;
        $[1] = t1;
    } else t1 = $[1];
    const promptIsForExternalAuth = t1;
    const intl = (0, $aXWIB.useIntl)();
    let t2;
    if ($[2] !== authUrl || $[3] !== onSuccess) {
        t2 = ()=>{
            setLoading(true);
            setAuthFailureMessage(false);
            (0, $fgbwU.safeAuth)(authUrl).then(()=>{
                onSuccess().then((callbackAfterConsentFlowHasFinished)=>{
                    setLoading(false);
                    setFailedToAuthenticate(false);
                    if (callbackAfterConsentFlowHasFinished && typeof callbackAfterConsentFlowHasFinished === "function") callbackAfterConsentFlowHasFinished();
                });
            }, (err)=>{
                setLoading(false);
                setFailedToAuthenticate(true);
                if ((0, $9P47v.isOfTypeAuthError)(err.type)) setAuthFailureMessage(err.message);
            });
        };
        $[2] = authUrl;
        $[3] = onSuccess;
        $[4] = t2;
    } else t2 = $[4];
    const startAuth = t2;
    let t3;
    if ($[5] !== appName || $[6] !== authFailureMessage || $[7] !== failedToAuthenticate || $[8] !== intl || $[9] !== message || $[10] !== promptIsForExternalAuth) {
        t3 = failedToAuthenticate ? authFailureMessage || intl.formatMessage($cf1792e251a9a919$var$messages.defaultFailedToAuthMessage) : message || (promptIsForExternalAuth ? $cf1792e251a9a919$var$externalAuthPromptMessage(intl, appName) : $cf1792e251a9a919$var$defaultPromptMessage(intl, appName));
        $[5] = appName;
        $[6] = authFailureMessage;
        $[7] = failedToAuthenticate;
        $[8] = intl;
        $[9] = message;
        $[10] = promptIsForExternalAuth;
        $[11] = t3;
    } else t3 = $[11];
    const promptMessage = t3;
    let t4;
    if ($[12] !== intl) {
        t4 = intl.formatMessage($cf1792e251a9a919$var$messages.externalAuthWarning);
        $[12] = intl;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            label: t4,
            color: "var(--ds-icon-warning, #E06C00)",
            spacing: "spacious"
        });
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== promptMessage || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center"
        }, t5, promptMessage);
        $[16] = promptMessage;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    const content = t6;
    let t7;
    if ($[19] !== intl) {
        t7 = intl.formatMessage($cf1792e251a9a919$var$messages.configureAccess);
        $[19] = intl;
        $[20] = t7;
    } else t7 = $[20];
    const externalAuthButtonText = t7;
    let t8;
    if ($[21] !== externalAuthButtonText || $[22] !== intl || $[23] !== promptIsForExternalAuth || $[24] !== promptText) {
        t8 = promptText || (promptIsForExternalAuth ? externalAuthButtonText : intl.formatMessage($cf1792e251a9a919$var$messages.allowAccess));
        $[21] = externalAuthButtonText;
        $[22] = intl;
        $[23] = promptIsForExternalAuth;
        $[24] = promptText;
        $[25] = t8;
    } else t8 = $[25];
    const buttonText = t8;
    let t9;
    if ($[26] !== buttonText || $[27] !== content || $[28] !== loading || $[29] !== startAuth) {
        t9 = {
            loading: loading,
            startAuth: startAuth,
            promptMessage: content,
            buttonText: buttonText
        };
        $[26] = buttonText;
        $[27] = content;
        $[28] = loading;
        $[29] = startAuth;
        $[30] = t9;
    } else t9 = $[30];
    return t9;
} : ({ message: message, promptText: promptText, appName: appName, authUrl: authUrl, onSuccess: onSuccess, metadata: metadata })=>{
    const [failedToAuthenticate, setFailedToAuthenticate] = (0, $42omo.useState)(false);
    const [authFailureMessage, setAuthFailureMessage] = (0, $42omo.useState)(false);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const promptIsForExternalAuth = (0, $fgbwU.isExternalAuth)(authUrl);
    const intl = (0, $aXWIB.useIntl)();
    const startAuth = (0, $42omo.useCallback)(()=>{
        setLoading(true);
        setAuthFailureMessage(false);
        (0, $fgbwU.safeAuth)(authUrl).then(()=>{
            onSuccess().then((callbackAfterConsentFlowHasFinished)=>{
                setLoading(false);
                setFailedToAuthenticate(false);
                if (callbackAfterConsentFlowHasFinished && typeof callbackAfterConsentFlowHasFinished === 'function') callbackAfterConsentFlowHasFinished();
            });
        }, (err)=>{
            setLoading(false);
            setFailedToAuthenticate(true);
            if ((0, $9P47v.isOfTypeAuthError)(err.type)) setAuthFailureMessage(err.message);
        });
    }, [
        authUrl,
        onSuccess,
        setLoading,
        setFailedToAuthenticate,
        setAuthFailureMessage
    ]);
    const promptMessage = failedToAuthenticate ? authFailureMessage || intl.formatMessage($cf1792e251a9a919$var$messages.defaultFailedToAuthMessage) : message || (promptIsForExternalAuth ? $cf1792e251a9a919$var$externalAuthPromptMessage(intl, appName) : $cf1792e251a9a919$var$defaultPromptMessage(intl, appName));
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: intl.formatMessage($cf1792e251a9a919$var$messages.externalAuthWarning),
        color: "var(--ds-icon-warning, #E06C00)",
        spacing: "spacious"
    }), promptMessage);
    const externalAuthButtonText = intl.formatMessage($cf1792e251a9a919$var$messages.configureAccess);
    const buttonText = promptText || (promptIsForExternalAuth ? externalAuthButtonText : intl.formatMessage($cf1792e251a9a919$var$messages.allowAccess));
    return {
        loading: loading,
        startAuth: startAuth,
        promptMessage: content,
        buttonText: buttonText
    };
};
const $cf1792e251a9a919$var$messages = (0, $aXWIB.defineMessages)({
    defaultPromptMessage: {
        id: "confluence.threeLOPrompt.use-auth.default.prompt.message",
        defaultMessage: "For {appString} to display, you need to allow the app to access Atlassian products on your behalf."
    },
    defaultPromptMessageAppify: {
        id: "confluence.threeLOPrompt.use-auth.default.prompt.message-appify",
        defaultMessage: "For {appString} to display, you need to grant it access to Atlassian apps on your behalf."
    },
    externalAuthPromptMessage: {
        id: "confluence.threeLOPrompt.use-auth.external.auth.prompt.message",
        defaultMessage: "{appString} requires additional access to your account."
    },
    thisAppUpper: {
        id: "confluence.threeLOPrompt.use-auth.this.app.upper.message",
        defaultMessage: "This app"
    },
    thisAppLower: {
        id: "confluence.threeLOPrompt.use-auth.this.app.lower.message",
        defaultMessage: "this app"
    },
    defaultFailedToAuthMessage: {
        id: "confluence.threeLOPrompt.use-auth.default.failed.to.auth.message",
        defaultMessage: "Failed to authenticate."
    },
    externalAuthWarning: {
        id: "confluence.threeLOPrompt.use-auth.external.auth.warning.message",
        defaultMessage: "External Auth Warning"
    },
    configureAccess: {
        id: "confluence.threeLOPrompt.use-auth.configure.access.button.text",
        defaultMessage: "Configure access"
    },
    allowAccess: {
        id: "confluence.threeLOPrompt.use-auth.allow.access.button.text",
        defaultMessage: "Allow access"
    }
});
module.exports["useAuth"] = $cf1792e251a9a919$export$1d39dc5b47e56ff0;

});

parcelRegister("7oKJR", function(module, exports) {

var $c4TO3 = parcelRequire("c4TO3");

const $65eef95050715244$var$SESSION_APPS_KEY = 'forge-ui.seen-app-keys';
/**
 *  This module is used to track the seen app context keys in session storage specifically
 *  for the forge.ui.extension loaded analytic event
 *  - Stores the last accessed date and the seen app context keys in session storage
 *  - The last accessed date is used to determine if the session is expired
 *  - The seen app context keys are used to determine if the event has already been sent
 *  - Session storage is used to avoid sending duplicate events on page refreshes or navigations
 */ let $65eef95050715244$var$storageState = {
    lastUpdated: null,
    appKeys: null
};
// Use a number for faster comparisons
const $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch = ()=>{
    return Math.floor(Date.now() / 86400000);
};
const $65eef95050715244$var$checkIsExpired = ()=>{
    const today = $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch();
    // If the last updated date is not today, the state has expired and so we reset it
    return today !== $65eef95050715244$var$storageState.lastUpdated;
};
const $65eef95050715244$var$resetState = ()=>{
    $65eef95050715244$var$storageState.appKeys = new Set();
    $65eef95050715244$var$storageState.lastUpdated = $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch();
};
const $65eef95050715244$export$b103ab7a7dac10e9 = ()=>{
    // If the app context keys have values, this call has already been made by another renderer and so we can return here
    if ($65eef95050715244$var$storageState.appKeys !== null) return;
    // Check for the app context keys in session storage and store it into memory
    // This is called once across any number of ForgeUIRenderers on the page guarded by the above `if` statement
    try {
        const appKeyfilterSessionStorageContextInStorage = JSON.parse((0, $c4TO3.AtlBrowserStorageSession).getItem($65eef95050715244$var$SESSION_APPS_KEY) ?? '{}');
        $65eef95050715244$var$storageState = {
            appKeys: new Set(appKeyfilterSessionStorageContextInStorage.appKeys),
            lastUpdated: Number(appKeyfilterSessionStorageContextInStorage.lastUpdated)
        };
        // If the state is expired, we reset it
        if ($65eef95050715244$var$checkIsExpired()) {
            $65eef95050715244$var$resetState();
            return;
        }
    } catch  {
        $65eef95050715244$var$resetState();
    }
};
const $65eef95050715244$var$writeToSessionStorage = ()=>{
    try {
        // Set a limit to avoid overloading session storage
        if ($65eef95050715244$var$storageState?.appKeys?.size && $65eef95050715244$var$storageState?.appKeys?.size < 100) (0, $c4TO3.AtlBrowserStorageSession).setItem($65eef95050715244$var$SESSION_APPS_KEY, JSON.stringify({
            appKeys: Array.from($65eef95050715244$var$storageState.appKeys ?? []),
            lastUpdated: $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch()
        }));
    } catch  {
    // If session storage is not available, we don't want to throw an error
    }
};
// Catches navigation or page refresh events and writes to session storage synchronously
window.addEventListener('beforeunload', ()=>{
    $65eef95050715244$var$writeToSessionStorage();
});
const $65eef95050715244$var$shouldAllowAndTrackEvent = (contextKey)=>{
    // State has expired
    if ($65eef95050715244$var$checkIsExpired()) {
        $65eef95050715244$var$resetState();
        $65eef95050715244$var$storageState.appKeys?.add(contextKey);
        return true;
    }
    if ($65eef95050715244$var$storageState.appKeys?.has(contextKey)) return false;
    $65eef95050715244$var$storageState.appKeys?.add(contextKey);
    return true;
};
const $65eef95050715244$var$findAppContextKeyInEvent = (event)=>{
    if (!event.context) return undefined;
    for (const context of event.context){
        const { appId: appId, extensionKey: extensionKey } = context.forgeUIAttributes ?? {};
        if (appId && extensionKey) return `${appId}/${extensionKey}`;
    }
    return undefined;
};
const $65eef95050715244$export$8869481ff1a02956 = (event)=>{
    try {
        const appContextKey = $65eef95050715244$var$findAppContextKeyInEvent(event);
        if (appContextKey) {
            const shouldAllow = $65eef95050715244$var$shouldAllowAndTrackEvent(appContextKey);
            return shouldAllow;
        }
    } catch  {
    // in case of any error, we let the event through, so we don't accidentally break analytics
    }
    return true;
};
module.exports["setupContextKeysFromSessionStorage"] = $65eef95050715244$export$b103ab7a7dac10e9;
module.exports["extensionLoadedEventFilter"] = $65eef95050715244$export$8869481ff1a02956;

});

parcelRegister("2W3B8", function(module, exports) {
const $b62d428850ff7f45$export$87eeb477611c8fe = (layout)=>{
    if (layout === 'full-width') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--full-width-layout-width))';
    if (layout === 'wide') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--breakout-wide-layout-width))';
    return '100%';
};
module.exports["calcBreakoutWidthCss"] = $b62d428850ff7f45$export$87eeb477611c8fe;

});

parcelRegister("3HdsG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $1bY7o = parcelRequire("1bY7o");


var $1oCLl = parcelRequire("1oCLl");


var $3gadb = parcelRequire("3gadb");


var $3kBFe = parcelRequire("3kBFe");

function $ba5ac32bd70f8fda$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ba5ac32bd70f8fda$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $ba5ac32bd70f8fda$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $ba5ac32bd70f8fda$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $ba5ac32bd70f8fda$var$copyAnchorButtonStyles = {
    name: "x4slh0",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #292A2E);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ba5ac32bd70f8fda$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) {
            if ((0, $1oCLl.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true)) // Fix for A11Y-30972: Use content as a function with update callback so
            // the Tooltip repositions without unmounting (which caused focus loss).
            // @see https://hello.jira.atlassian.cloud/browse/A11Y-30972
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
                // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
                tag: $ba5ac32bd70f8fda$var$CopyAnchorWrapperWithRef,
                content: this.renderTooltipContent,
                position: "top",
                delay: 0,
                isScreenReaderAnnouncementDisabled: (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
            }, this.renderAnchorButton());
            // We set the key to the message to ensure it remounts when the message
            // changes, so that it correctly repositions.
            // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
                // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
                tag: $ba5ac32bd70f8fda$var$CopyAnchorWrapperWithRef,
                content: tooltipMessage,
                position: "top",
                delay: 0,
                key: tooltipMessage,
                isScreenReaderAnnouncementDisabled: (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
            }, this.renderAnchorButton());
        }
        return this.renderAnchorButton();
    }
    constructor(props){
        super(props);
        this.state = {
            tooltipMessage: '',
            isClicked: false
        };
        this.copyLinkId = void 0;
        this._tooltipUpdate = void 0;
        // Stable reference for Tooltip content prop to avoid recreating on each render
        this.renderTooltipContent = ({ update: update })=>{
            this._tooltipUpdate = update;
            return this.state.tooltipMessage;
        };
        this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            }, ()=>{
                // Reposition tooltip after content change (replaces the key-based remount)
                if ((0, $1oCLl.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true)) this._tooltipUpdate?.();
            });
        };
        this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $3kBFe.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        };
        this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $3kBFe.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch  {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        };
        this.resetMessage = ()=>{
            const tooltip = (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? (0, $3kBFe.headingAnchorLinkMessages).copyLinkToClipboard : (0, $3kBFe.headingAnchorLinkMessages).copyHeadingLinkToClipboard;
            this.setTooltipState(tooltip);
        };
        this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            const labelledBy = (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? this.props.intl.formatMessage((0, $3kBFe.headingAnchorLinkMessages).copyHeadingLinkLabelledBy, {
                copyLink: this.copyLinkId,
                heading: headingId
            }) : headingId;
            const tabIndex = (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? 0 : hideFromScreenReader ? undefined : -1;
            return /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
                "data-testid": "anchor-button",
                id: this.copyLinkId,
                css: $ba5ac32bd70f8fda$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onBlur: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: this.getCopyAriaLabel(),
                color: this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        };
        this.copyLinkId = (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? crypto.randomUUID() : undefined;
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $ba5ac32bd70f8fda$var$_default_1 = (0, $aXWIB.injectIntl)($ba5ac32bd70f8fda$var$HeadingAnchor);
var $ba5ac32bd70f8fda$export$2e2bcd8739ae039 = $ba5ac32bd70f8fda$var$_default_1;
module.exports["HeadingAnchorWrapperClassName"] = $ba5ac32bd70f8fda$export$3c9cedc52604835d;
module.exports["default"] = $ba5ac32bd70f8fda$export$2e2bcd8739ae039;

});

parcelRegister("drJ23", function(module, exports) {
function $67762bf75d20c8f0$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}
module.exports["getListIndentLevel"] = $67762bf75d20c8f0$export$75aa84e85754623e;

});

parcelRegister("aVZM7", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $1c598 = parcelRequire("1c598");


var $b7qxC = parcelRequire("b7qxC");

function $745598479b6c5b3c$export$faef963e38d4b894(environment) {
    const cdnEnv = (0, $b7qxC.getCDNEnvironment)(environment);
    // DEVELOPMENT has no dedicated CDN; fall back to STAGING assets.
    const urlEnv = cdnEnv === (0, $1c598.ForgeCDNEnvironment).DEVELOPMENT ? (0, $1c598.ForgeCDNEnvironment).STAGING : cdnEnv;
    const secondLevelDomain = (0, $lzcvT.isFedRamp)() ? 'atlassian-dev-us-gov-mod' : 'atlassian-dev';
    return `cdn.${urlEnv}.${secondLevelDomain}.net`;
}
module.exports["getForgeCDNBaseDomain"] = $745598479b6c5b3c$export$faef963e38d4b894;

});

parcelRegister("kynWP", function(module, exports) {

var $65XYT = parcelRequire("65XYT");

const $c1947462b986f18c$var$disabledPerfCaptureConfig = {
    enabled: false,
    sampleRate: 0.0
};
const $c1947462b986f18c$export$3e4354104e72ffa1 = ({ module: module })=>{
    const isModuleEnabled = (0, $65XYT.enabledModulesForPerfCapture).indexOf(module) > -1;
    // Space to apply gates and experiments.
    return isModuleEnabled ? (0, $65XYT.defaultPerfCaptureConfig) : $c1947462b986f18c$var$disabledPerfCaptureConfig;
};
module.exports["getAppPerfCaptureConfig"] = $c1947462b986f18c$export$3e4354104e72ffa1;

});

parcelRegister("IiIMy", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $inPa6 = parcelRequire("inPa6");


var $6oQb1 = parcelRequire("6oQb1");


var $42omo = parcelRequire("42omo");


var $5U2YR = parcelRequire("5U2YR");


var $dh538 = parcelRequire("dh538");

const $7f04a8099d8fa691$export$587370d4749ec188 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { config: config, samplingKey: samplingKey } = t0;
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    bb0: {
        if (!samplingKey) {
            t1 = false;
            break bb0;
        }
        if (!config.enabled || !(0, $dh538.fg)("forge-ui-app-perf-tracking-enabled")) {
            t1 = false;
            break bb0;
        }
        const captureAllFlag = (0, $dh538.fg)("forge-ui-app-perf-capture-all-enabled");
        if (captureAllFlag) {
            t1 = true;
            break bb0;
        }
        const captureSampleFlag = (0, $dh538.fg)("forge-ui-app-perf-capture-sampling-enabled");
        if (captureSampleFlag && Math.random() <= config.sampleRate) {
            t1 = true;
            break bb0;
        }
        t1 = false;
    }
    const enabled = t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== enabled || $[2] !== source) {
        t2 = (attributes)=>{
            if (!enabled) return;
            (0, $6oQb1.fireEvent)(createAnalyticsEvent, {
                action: "performance.profiled",
                actionSubject: "forge.ui.extension",
                attributes: attributes,
                source: source
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = enabled;
        $[2] = source;
        $[3] = t2;
    } else t2 = $[3];
    const capture = t2;
    let t3;
    if ($[4] !== capture || $[5] !== enabled) {
        t3 = {
            enabled: enabled,
            capture: capture
        };
        $[4] = capture;
        $[5] = enabled;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ config: config, samplingKey: samplingKey })=>{
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const enabled = (0, $42omo.useMemo)(()=>{
        if (!samplingKey) return false;
        if (!config.enabled || !(0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')) return false;
        // Override: capture all events.
        const captureAllFlag = (0, $dh538.fg)('forge-ui-app-perf-capture-all-enabled');
        if (captureAllFlag) return true;
        // Capture a sample of events.
        const captureSampleFlag = (0, $dh538.fg)('forge-ui-app-perf-capture-sampling-enabled');
        if (captureSampleFlag && Math.random() <= config.sampleRate) return true;
        return false;
    }, [
        config,
        samplingKey
    ]);
    const capture = (0, $42omo.useCallback)((attributes)=>{
        if (!enabled) return;
        (0, $6oQb1.fireEvent)(createAnalyticsEvent, {
            action: 'performance.profiled',
            actionSubject: 'forge.ui.extension',
            attributes: attributes,
            source: source
        });
    }, [
        source,
        createAnalyticsEvent,
        enabled
    ]);
    return {
        enabled: enabled,
        capture: capture
    };
};
module.exports["useAppPerfCaptureStrategy"] = $7f04a8099d8fa691$export$587370d4749ec188;

});

parcelRegister("4No1R", function(module, exports) {
/**
 * @generated SignedSource<<01a63b7d5e7ff313a9ca48c171279668>>
 * @relayHash 03405d83b15f59d0889abdb0c63674a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 94a10998312c3467f8472075ae93ba6a72f87e0e5fc80ed56a84b36ab8800138
const $fa60f31b64adbc4c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudIds",
                    "variableName": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBridge_tenantUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBridge_tenantUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "94a10998312c3467f8472075ae93ba6a72f87e0e5fc80ed56a84b36ab8800138",
            "metadata": {},
            "name": "useBridge_tenantUserQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fa60f31b64adbc4c$var$node.hash = "608300bf42cc1b2188141c51b357201e";
var $fa60f31b64adbc4c$export$2e2bcd8739ae039 = $fa60f31b64adbc4c$var$node;
module.exports["default"] = $fa60f31b64adbc4c$export$2e2bcd8739ae039;

});

parcelRegister("9zb43", function(module, exports) {

module.exports = (parcelRequire("1BqC1"));

});

parcelRegister("dWSaf", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $7KMPr = parcelRequire("7KMPr");


var $kxKUs = parcelRequire("kxKUs");


var $fSMLG = parcelRequire("fSMLG");


var $3Spjc = parcelRequire("3Spjc");


var $6oQb1 = parcelRequire("6oQb1");


var $ly9ul = parcelRequire("ly9ul");

const $053a3977db87c15f$export$60b209a72f44cb2e = (bridgeMethod, payload, isSucceed)=>{
    if (bridgeMethod === 'submit' && isSucceed) {
        const payloadFields = Array.from(Object.entries(payload?.data ?? {})).filter(([, value])=>value).map(([key])=>key);
        return {
            payloadFields: payloadFields
        };
    }
    if (bridgeMethod === 'navigate') {
        const { target: target, url: url, type: type } = payload?.data ?? {};
        const navigationContext = {
            target: 'trusted',
            type: type
        };
        if (url && typeof url === 'string') try {
            if ([
                'https:',
                'http:'
            ].includes(new URL(url).protocol)) navigationContext.target = 'external';
        } catch  {}
        else if (target && typeof target === 'string') navigationContext.target = target;
        return navigationContext;
    }
    if (bridgeMethod === 'openRovo' && isSucceed) {
        const { agentName: agentName, agentKey: agentKey, sourceAppId: sourceAppId } = payload?.data ?? {};
        const agentDetails = {
            agentName: agentName,
            agentKey: agentKey,
            sourceAppId: sourceAppId,
            isForgeAgent: false
        };
        if (agentName && agentKey) agentDetails.isForgeAgent = true;
        return agentDetails;
    }
    return {};
};
const $053a3977db87c15f$var$wrapFeatureWithMetricsAndAnalytics = ({ feature: feature, createAnalyticsEvent: createAnalyticsEvent, page: page, bridgeMethod: bridgeMethod, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>async (payload)=>{
        try {
            tracing?.recordBridgeCall(`${bridgeMethod}() - start`);
            const result = await feature(payload);
            tracing?.recordBridgeCall(`${bridgeMethod}() - end`);
            if (bridgeMethod === 'on') createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'subscribed',
                    actionSubject: 'bridgeEvent',
                    attributes: {
                        // TODO: remove the condition (and related test) once Developer UGC spec is ready
                        event: payload.data.event === 'JIRA_ISSUE_CHANGED' ? 'JIRA_ISSUE_CHANGED' : 'other'
                    },
                    source: page,
                    tags: [
                        'forge'
                    ]
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
            // this replaces the BRIDGE_REQUEST_RECEIVED metal client event
            (0, $6oQb1.trackBridgeSucceed)(createAnalyticsEvent, {
                source: page,
                method: bridgeMethod,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: $053a3977db87c15f$export$60b209a72f44cb2e(bridgeMethod, payload, true)
            });
            return result;
        } catch (err) {
            const error = err instanceof Error ? err : new Error(`Unknown Custom UI Bridge error: ${typeof err}`);
            if (!(error instanceof (0, $kxKUs.BridgeClientError))) {
                if (!(0, $fSMLG.blocklistedErrorMessagePatterns).some((pattern)=>pattern.test(error.message))) {
                    (0, $6oQb1.trackBridgeFailed)(createAnalyticsEvent, {
                        source: page,
                        errorName: error.name,
                        method: bridgeMethod,
                        forgeEnvironment: forgeEnvironment,
                        additionalAttributes: {
                            ...$053a3977db87c15f$export$60b209a72f44cb2e(bridgeMethod, payload, false),
                            reason: error.message,
                            isUnrecoverable: (0, $ly9ul.isUnrecoverableError)(error)
                        }
                    });
                    (0, $7KMPr.captureAndReportError)({
                        error: error,
                        environment: environment,
                        errorExtensionDetails: errorExtensionDetails,
                        page: page,
                        tracing: tracing
                    });
                }
            }
            throw err;
        }
    };
const $053a3977db87c15f$export$68a362b9cb2811d7 = ({ features: features, createAnalyticsEvent: createAnalyticsEvent, page: page, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>Object.entries(features).reduce((acc, [key, feature])=>({
            ...acc,
            [key]: $053a3977db87c15f$var$wrapFeatureWithMetricsAndAnalytics({
                feature: feature,
                createAnalyticsEvent: createAnalyticsEvent,
                page: page,
                bridgeMethod: key,
                environment: environment,
                forgeEnvironment: forgeEnvironment,
                errorExtensionDetails: errorExtensionDetails,
                tracing: tracing
            })
        }), {});
module.exports["prepareBridgeEventAttributes"] = $053a3977db87c15f$export$60b209a72f44cb2e;
module.exports["withMetricsAndAnalytics"] = $053a3977db87c15f$export$68a362b9cb2811d7;

});

parcelRegister("4c2yb", function(module, exports) {
function $3a24103e0164297d$export$32da5b5043dcd88c() {
    window.location.reload();
}
module.exports["reload"] = $3a24103e0164297d$export$32da5b5043dcd88c;

});

parcelRegister("cMiG0", function(module, exports) {

var $6t4vQ = parcelRequire("6t4vQ");


var $faCvF = parcelRequire("faCvF");


var $6usda = parcelRequire("6usda");


var $6wbTo = parcelRequire("6wbTo");


var $j4W8T = parcelRequire("j4W8T");

const $bd08d1f86405f93a$var$extensionURLHelpers = {
    ...(0, $6t4vQ.bitbucketExtensionURLHelpers),
    ...(0, $faCvF.confluenceExtensionURLHelpers),
    ...(0, $6wbTo.jiraExtensionURLHelpers)
};
const $bd08d1f86405f93a$var$navigationTargetHandlers = {
    ...(0, $6wbTo.jiraNavigationTargetHandlers),
    ...(0, $faCvF.confluenceNavigationTargetURLHelpers),
    userProfile: async ({ accountId: accountId })=>(0, $j4W8T.ensureURLPath)(`/people/${accountId}`),
    module: async ({ moduleKey: moduleKey, ...params }, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        if (!moduleKey) throw (0, $6usda.NavigationError).MissingProperty('moduleKey');
        const module = await (0, $6usda.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
        if (!module || !module.appId || !module.environmentId || !module.environmentKey) throw (0, $6usda.NavigationError).ModuleNotFound(moduleKey);
        const moduleUrlHelper = $bd08d1f86405f93a$var$extensionURLHelpers[module.type];
        if (!moduleUrlHelper) throw (0, $6usda.NavigationError).NotSupportedExtensionType(module.type);
        return await moduleUrlHelper(module, params);
    }
};
const $bd08d1f86405f93a$export$6aa8556afece32b2 = async (targetInfo, utils)=>{
    const { target: target, ...payload } = targetInfo;
    const handler = $bd08d1f86405f93a$var$navigationTargetHandlers[target];
    if (!handler) return null;
    try {
        const path = await handler(payload, utils);
        return path;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message);
        return null;
    }
};
module.exports["createNavigateTargetPath"] = $bd08d1f86405f93a$export$6aa8556afece32b2;

});

parcelRegister("1JDPF", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $fYGGr = parcelRequire("fYGGr");


var $grQpA = parcelRequire("grQpA");


var $a4TK8 = parcelRequire("a4TK8");

const $a32dcdb2dcf56aee$var$useCustomCompareMemo = (factory, dependency, isEqual)=>{
    const dependencyRef = (0, $42omo.useRef)(dependency);
    const valueRef = (0, $42omo.useRef)(factory());
    if (!isEqual(dependency, dependencyRef.current)) {
        dependencyRef.current = dependency;
        valueRef.current = factory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>valueRef.current, [
        dependencyRef.current
    ]);
};
const $a32dcdb2dcf56aee$var$isSameDeps = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    const [relayEnvironmentA, appIdA, environmentIdA, contextIdsA] = a;
    const [relayEnvironmentB, appIdB, environmentIdB, contextIdsB] = b;
    return relayEnvironmentA === relayEnvironmentB && appIdA === appIdB && environmentIdA === environmentIdB && (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(contextIdsA.sort(), contextIdsB.sort());
};
const $a32dcdb2dcf56aee$export$10dcd63d9a8843c4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { appId: appId, environmentId: environmentId, contextIds: contextIds, cloudId: cloudId, includeHidden: includeHidden, moduleType: moduleType, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall } = t0;
    const relayEnvironment = (0, $irOoi.useRelayEnvironment)();
    let t1;
    if ($[0] !== appId || $[1] !== bypassNewForgeExtensionListCall || $[2] !== cloudId || $[3] !== contextIds || $[4] !== environmentId || $[5] !== includeHidden || $[6] !== moduleType || $[7] !== relayEnvironment) {
        t1 = ()=>async (params)=>await (0, $fYGGr.getForgeUIExtensionsRelayAsync)({
                    contextIds: contextIds,
                    extensionsFilter: [
                        {
                            type: (0, $grQpA.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                            value: [
                                `${appId}:${environmentId}`
                            ]
                        }
                    ],
                    ...params,
                    cloudId: cloudId,
                    includeHidden: includeHidden,
                    moduleType: moduleType,
                    bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall,
                    relayEnvironment: relayEnvironment
                });
        $[0] = appId;
        $[1] = bypassNewForgeExtensionListCall;
        $[2] = cloudId;
        $[3] = contextIds;
        $[4] = environmentId;
        $[5] = includeHidden;
        $[6] = moduleType;
        $[7] = relayEnvironment;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== appId || $[10] !== contextIds || $[11] !== environmentId || $[12] !== relayEnvironment) {
        t2 = [
            relayEnvironment,
            appId,
            environmentId,
            contextIds
        ];
        $[9] = appId;
        $[10] = contextIds;
        $[11] = environmentId;
        $[12] = relayEnvironment;
        $[13] = t2;
    } else t2 = $[13];
    return $a32dcdb2dcf56aee$var$useCustomCompareMemo(t1, t2, $a32dcdb2dcf56aee$var$isSameDeps);
} : ({ appId: appId, environmentId: environmentId, contextIds: contextIds, cloudId: cloudId, includeHidden: includeHidden, moduleType: moduleType, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall })=>{
    const relayEnvironment = (0, $irOoi.useRelayEnvironment)();
    return $a32dcdb2dcf56aee$var$useCustomCompareMemo(()=>{
        return async (params)=>{
            return await (0, $fYGGr.getForgeUIExtensionsRelayAsync)({
                contextIds: contextIds,
                extensionsFilter: [
                    {
                        type: (0, $grQpA.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                        value: [
                            `${appId}:${environmentId}`
                        ]
                    }
                ],
                ...params,
                cloudId: cloudId,
                includeHidden: includeHidden,
                moduleType: moduleType,
                bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall,
                relayEnvironment: relayEnvironment
            });
        };
    }, [
        relayEnvironment,
        appId,
        environmentId,
        contextIds
    ], $a32dcdb2dcf56aee$var$isSameDeps);
};
module.exports["useGetAppForgeUIExtensions"] = $a32dcdb2dcf56aee$export$10dcd63d9a8843c4;

});

parcelRegister("974zo", function(module, exports) {

var $dIZZf = parcelRequire("dIZZf");


var $irOoi = parcelRequire("irOoi");


var $1Igmn = parcelRequire("1Igmn");

const $22833f81d2ea0d44$export$24d1d5a4c1bec897 = async ({ cloudId: cloudId, relayEnvironment: relayEnvironment })=>{
    if (relayEnvironment) {
        const observable = (0, $irOoi.fetchQuery)(relayEnvironment, (0, $dIZZf.default), {
            cloudId: cloudId
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            }
        });
        return new Promise((resolve)=>{
            observable.subscribe({
                next: (data)=>{
                    resolve(data?.atlassianStudio_userSiteContext?.isRovoEnabled ?? false);
                },
                error: ()=>{
                    resolve(false);
                }
            });
        });
    }
    return false;
};
module.exports["getIsRovoEnabled"] = $22833f81d2ea0d44$export$24d1d5a4c1bec897;

});

parcelRegister("2gNWY", function(module, exports) {

var $9v4R2 = parcelRequire("9v4R2");

const $3722eb8dac50bf58$export$97f4c254b641e719 = (hostname)=>{
    return ![
        ...(0, $9v4R2.TRUSTED_ROOT_DOMAINS),
        'localhost',
        'jira-dev.com'
    ].some((trustedDomain)=>hostname.includes(trustedDomain));
};
module.exports["isCustomDomain"] = $3722eb8dac50bf58$export$97f4c254b641e719;

});

parcelRegister("buzAL", function(module, exports) {
/* usePermission.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @deprecated
 * This hook implements the v1 (stateful, React hook-based) permission bridge.
 *
 * New code should use the v2 stateless bridge methods instead:
 *   `platform/packages/forge/forge-ui/src/bridge/methods/permissions/index.tsx`
 *
 * The v2 methods (`egressGet`, `egressSet`, `egressDeleteDomain`,
 * `egressDeleteGroup`, `remoteGet`, `remoteSet`) are registered as
 * `__permission__*` bridge methods and are gated by
 * `fg('configurable-egress-mvp-frontend')`.
 *
 * This file is retained to support the legacy custom-UI iframe bridge path
 * (`usePermission` hook consumed via `useBridge`). Do not add new permission
 * logic here.
 */ 
var $42omo = parcelRequire("42omo");


var $kxKUs = parcelRequire("kxKUs");


var $fJCAk = parcelRequire("fJCAk");


var $dh538 = parcelRequire("dh538");


var $20GoR = parcelRequire("20GoR");


var $4LgCj = parcelRequire("4LgCj");


var $dhMrf = parcelRequire("dhMrf");


var $6oQb1 = parcelRequire("6oQb1");

const $5ea234701956fa1d$export$9d631cbf20f994be = [
    'egressSet',
    'egressGet',
    'egressDeleteDomain',
    'egressDeleteGroup',
    'remoteGet',
    'remoteSet'
];
const $5ea234701956fa1d$export$e6656e96c25a61f6 = '__permission__';
const $5ea234701956fa1d$var$RATE_LIMIT_MS = 5000;
const $5ea234701956fa1d$export$6adf362786c5a28e = (apiRef)=>({
        __permission__egressSet: async ({ data: data })=>{
            return apiRef.current.__permission__egressSet?.(data);
        },
        __permission__egressGet: async ({ data: data })=>{
            return apiRef.current.__permission__egressGet?.(data);
        },
        __permission__egressDeleteDomain: async ({ data: data })=>{
            return apiRef.current.__permission__egressDeleteDomain?.(data);
        },
        __permission__egressDeleteGroup: async ({ data: data })=>{
            return apiRef.current.__permission__egressDeleteGroup?.(data);
        },
        __permission__remoteGet: async ({ data: data })=>{
            return apiRef.current.__permission__remoteGet?.(data);
        },
        __permission__remoteSet: async ({ data: data })=>{
            return apiRef.current.__permission__remoteSet?.(data);
        }
    });
const $5ea234701956fa1d$export$dc21730956491a4c = (bridge)=>Object.fromEntries($5ea234701956fa1d$export$9d631cbf20f994be.map((method)=>[
            `${$5ea234701956fa1d$export$e6656e96c25a61f6}${method}`,
            (0, $4LgCj.createBridgeMethod)(bridge?.[`${$5ea234701956fa1d$export$e6656e96c25a61f6}${method}`])
        ]));
function $5ea234701956fa1d$export$d7376454a3cf5ab4({ appId: appId, installationId: installationId, contextIds: contextIds, extensionId: extensionId, renderThreeLOPrompt: renderThreeLOPrompt }) {
    const [modalState, setModalState] = (0, $42omo.useState)({
        state: 'closed'
    });
    const [isRateLimited, setIsRateLimited] = (0, $42omo.useState)(false);
    const { trackPermissionAction: trackPermissionAction } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const permissionFetchClient = (0, $20GoR.usePermissionFetchClient)({
        appId: appId,
        installationId: installationId,
        contextIds: contextIds,
        extensionId: extensionId,
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const queryForgeApp = (0, $dhMrf.useForgeAppQuery)();
    const fetchAppData = async (id, contextIds_0)=>{
        try {
            return await queryForgeApp(id, contextIds_0);
        } catch (e) {
            if (e instanceof Error) {
                const error = new (0, $kxKUs.BridgeClientError)(e.message);
                error.stack = e.stack;
                throw error;
            }
            throw new (0, $kxKUs.BridgeClientError)(typeof e === 'string' ? e : String(e));
        }
    };
    const canOpenModal = ()=>{
        return modalState.state === 'closed' && !isRateLimited;
    };
    const noteModalOpened = ()=>{
        setIsRateLimited(true);
        setTimeout(()=>{
            setIsRateLimited(false);
        }, $5ea234701956fa1d$var$RATE_LIMIT_MS);
    };
    return {
        getModalJsx: ()=>(0, $dh538.fg)('configurable-egress-mvp-frontend') ? /*#__PURE__*/ $42omo.createElement((0, $fJCAk.AdminModal), {
                modalState: modalState
            }) : null,
        egressSet: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressSet'
            });
            const app = await fetchAppData(appId, contextIds);
            const response = await permissionFetchClient.egressSet(payload, true);
            if (!response.ok) throw new (0, $kxKUs.BridgeClientError)('Dry run failed');
            if (!canOpenModal()) throw new (0, $kxKUs.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
            return new Promise((resolve, reject)=>{
                noteModalOpened();
                setModalState({
                    state: 'open',
                    onCancel: ()=>{
                        setModalState({
                            state: 'closed'
                        });
                        reject('Setting egress was rejected by admin');
                    },
                    onConfirm: async ()=>{
                        try {
                            const setEgressResp = await permissionFetchClient.egressSet(payload, false);
                            const json = await setEgressResp.json();
                            if (!setEgressResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                            setModalState({
                                state: 'closed'
                            });
                            resolve(json);
                        } catch (err) {
                            reject(err);
                        }
                    },
                    domainInfo: {
                        type: 'EGRESS',
                        payload: payload
                    },
                    appName: app.name,
                    termsOfUseLink: app.termsOfService,
                    privacyPolicyLink: app.privacyPolicy
                });
            });
        },
        egressGet: async (payload_0)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressGet'
            });
            try {
                const getEgressResp = await permissionFetchClient.egressGet(payload_0);
                const json_0 = await getEgressResp.json();
                if (!getEgressResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json_0, null, 2));
                return json_0;
            } catch (err_0) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not get egress due to: ${err_0}`);
            }
        },
        egressDeleteDomain: async (payload_1)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressDeleteDomain'
            });
            try {
                const egressDeleteDomainResp = await permissionFetchClient.egressDeleteDomain(payload_1);
                if (egressDeleteDomainResp.ok && egressDeleteDomainResp.status === 204) return undefined;
                const json_1 = await egressDeleteDomainResp.json();
                if (!egressDeleteDomainResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json_1, null, 2));
                return json_1;
            } catch (err_1) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not delete egress domain due to ${err_1}`);
            }
        },
        egressDeleteGroup: async (payload_2)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressDeleteGroup'
            });
            try {
                const egressDeleteGroupResp = await permissionFetchClient.egressDeleteGroup(payload_2);
                if (egressDeleteGroupResp.ok && egressDeleteGroupResp.status === 204) return undefined;
                const json_2 = await egressDeleteGroupResp.json();
                if (!egressDeleteGroupResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json_2, null, 2));
                return json_2;
            } catch (err_2) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not delete egress group due to ${err_2}`);
            }
        },
        remoteGet: async (payload_3)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'remoteGet'
            });
            try {
                const remoteGetResp = await permissionFetchClient.remoteGet(payload_3);
                const json_3 = await remoteGetResp.json();
                if (!remoteGetResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json_3, null, 2));
                return json_3;
            } catch (err_3) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not get remote due to: ${err_3}`);
            }
        },
        remoteSet: async (payload_4)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'remoteSet'
            });
            const app_0 = await fetchAppData(appId, contextIds);
            const response_0 = await permissionFetchClient.remoteSet(payload_4, true);
            if (!response_0.ok) throw new (0, $kxKUs.BridgeClientError)('Dry run failed');
            if (!canOpenModal()) throw new (0, $kxKUs.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
            const node = (app_0.installationsByContexts?.edges ?? [])[0]?.node;
            const payloadKeys = new Set(payload_4.remotes.map((r)=>r.key));
            const manifestRemoteMap = (node?.appEnvironmentVersion?.extensions?.nodes ?? []).filter((e_0)=>e_0 && e_0.extensionData.type === 'core:remote' && payloadKeys.has(e_0.extensionData.key)).reduce((acc, e_1)=>{
                if (e_1?.extensionData) acc[e_1.extensionData.key] = e_1.extensionData.configurable;
                return acc;
            }, {});
            return new Promise((resolve_0, reject_0)=>{
                noteModalOpened();
                setModalState({
                    state: 'open',
                    onCancel: ()=>{
                        setModalState({
                            state: 'closed'
                        });
                        reject_0(new (0, $kxKUs.BridgeClientError)('Setting remote was rejected by admin'));
                    },
                    onConfirm: async ()=>{
                        try {
                            const remoteSetResp = await permissionFetchClient.remoteSet(payload_4, false);
                            if (!remoteSetResp.ok) throw new (0, $kxKUs.BridgeClientError)(remoteSetResp.statusText);
                            setModalState({
                                state: 'closed'
                            });
                            resolve_0();
                        } catch (err_4) {
                            reject_0(new (0, $kxKUs.BridgeClientError)(`API call was rejected with the following error: ${err_4}`));
                        }
                    },
                    domainInfo: {
                        type: 'REMOTE',
                        payload: payload_4,
                        manifestRemoteMap: manifestRemoteMap
                    },
                    appName: app_0.name,
                    termsOfUseLink: app_0.termsOfService,
                    privacyPolicyLink: app_0.privacyPolicy
                });
            });
        }
    };
}
module.exports["permissionMethods"] = $5ea234701956fa1d$export$9d631cbf20f994be;
module.exports["PERMISSION_METHOD_PREFIX"] = $5ea234701956fa1d$export$e6656e96c25a61f6;
module.exports["getUseBridgePermissionFunctions"] = $5ea234701956fa1d$export$6adf362786c5a28e;
module.exports["getCreateBridgeApiPermissionFunctions"] = $5ea234701956fa1d$export$dc21730956491a4c;
module.exports["usePermission"] = $5ea234701956fa1d$export$d7376454a3cf5ab4;

});

parcelRegister("fyIiK", function(module, exports) {
const $2f7e23fa50cc881e$export$684c8d19f84f3f84 = (key, embeddedMacroLocalId, data)=>{
    if (key === 'getMacroContent' || key === 'updateMacroContent') return {
        ...typeof data === 'object' ? data : {},
        embeddedMacroLocalId: embeddedMacroLocalId
    };
    return data;
};
module.exports["transformDataForEmbeddedMacros"] = $2f7e23fa50cc881e$export$684c8d19f84f3f84;

});

parcelRegister("5ixVX", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aoVih = parcelRequire("aoVih");


var $aXWIB = parcelRequire("aXWIB");

const $8d34721cabca6b4b$var$messages = (0, $aXWIB.defineMessages)({
    developerSpaceErrorTitle: {
        id: "forge-ui.renderer.errorMessages.ForgeDevSpaceErrorMessage.developerSpaceErrorTitle",
        defaultMessage: "This app is currently unavailable"
    },
    developerSpaceErrorBody: {
        id: "forge-ui.renderer.errorMessages.ForgeDevSpaceErrorMessage.developerSpaceErrorBody",
        defaultMessage: "The app developer needs to complete required setup before this app can become available. Contact your app provider for more information or to request support."
    }
});
const $8d34721cabca6b4b$export$fab3d5a87354bfa8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($8d34721cabca6b4b$var$messages.developerSpaceErrorTitle);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($8d34721cabca6b4b$var$messages.developerSpaceErrorBody);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            title: t0,
            appearance: "error"
        }, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: intl.formatMessage($8d34721cabca6b4b$var$messages.developerSpaceErrorTitle),
        appearance: "error"
    }, intl.formatMessage($8d34721cabca6b4b$var$messages.developerSpaceErrorBody));
};
module.exports["ForgeDevSpaceErrorMessage"] = $8d34721cabca6b4b$export$fab3d5a87354bfa8;

});

parcelRegister("b0R0S", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $46zjh = parcelRequire("46zjh");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $aoVih = parcelRequire("aoVih");


var $1Igmn = parcelRequire("1Igmn");


var $lCRfz = parcelRequire("lCRfz");


var $80yqV = parcelRequire("80yqV");

const $5dee1acf00c8b0b9$var$buildMessage = (title, error)=>{
    if (error === (0, $80yqV.SANDBOX_DEPRECATION_ERROR)) return `Your app ${title} is no longer working as it uses a deprecated platform feature. Please check if an update for this app is available through Atlassian Administration, or ask the app developer to upgrade the app.\nIf the app is listed on the marketplace, contact the developer using the Support tab.`;
    return `${title} version is outdated due to a deprecated platform component.\nThe app developer needs to update it to a compatible version.\nPlease ask your admin to check for updates or contact the app developer.`;
};
const $5dee1acf00c8b0b9$var$ForgeDeprecationMessageInner = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    const { extension: extension, error: error } = props;
    const t0 = extension?.id;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            id: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        "atl-attribution": (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            }
        };
        $[2] = t2;
    } else t2 = $[2];
    const data = (0, $irOoi.useLazyLoadQuery)((0, $46zjh.default), t1, t2);
    const title = data.app?.name ? data.app?.name : extension.properties.title;
    let t3;
    if ($[3] !== error || $[4] !== title) {
        t3 = $5dee1acf00c8b0b9$var$buildMessage(title, error);
        $[3] = error;
        $[4] = title;
        $[5] = t3;
    } else t3 = $[5];
    const message = t3;
    let t4;
    if ($[6] !== message) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            title: "App update required",
            appearance: "error"
        }, message);
        $[6] = message;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const { extension: extension, error: error } = props;
    const data = (0, $irOoi.useLazyLoadQuery)((0, $46zjh.default), {
        id: extension?.id
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                }
            }
        }
    });
    const title = data.app?.name ? data.app?.name : extension.properties.title;
    const message = $5dee1acf00c8b0b9$var$buildMessage(title, error);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: "App update required",
        appearance: "error"
    }, message);
};
const $5dee1acf00c8b0b9$var$ForgeDeprecationMessageFallback = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const { extension: extension, error: error } = props;
    const title = extension.properties.title;
    let t0;
    if ($[0] !== error || $[1] !== title) {
        t0 = $5dee1acf00c8b0b9$var$buildMessage(title, error);
        $[0] = error;
        $[1] = title;
        $[2] = t0;
    } else t0 = $[2];
    const message = t0;
    let t1;
    if ($[3] !== message) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            title: "App update required",
            appearance: "error"
        }, message);
        $[3] = message;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { extension: extension, error: error } = props;
    const title = extension.properties.title;
    const message = $5dee1acf00c8b0b9$var$buildMessage(title, error);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: "App update required",
        appearance: "error"
    }, message);
};
const $5dee1acf00c8b0b9$export$e812f4e5298c004d = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5dee1acf00c8b0b9$var$ForgeDeprecationMessageFallback, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const fallback = t0;
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5dee1acf00c8b0b9$var$ForgeDeprecationMessageInner, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== fallback || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lCRfz.RelaySuspensefulBoundary), {
            fallback: fallback,
            errorFallback: fallback
        }, t1);
        $[4] = fallback;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5dee1acf00c8b0b9$var$ForgeDeprecationMessageFallback, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lCRfz.RelaySuspensefulBoundary), {
        fallback: fallback,
        errorFallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5dee1acf00c8b0b9$var$ForgeDeprecationMessageInner, props));
};
module.exports["ForgeDeprecationMessage"] = $5dee1acf00c8b0b9$export$e812f4e5298c004d;

});

parcelRegister("73oQr", function(module, exports) {
/**
 * @generated SignedSource<<8e95e05a6faa0da7a3f16bed87ddef4a>>
 * @relayHash 0d86d9514ed0dc62ec55c47550347432
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10ddb346add2537047e9d08fed9494c213c3fbe41490cba82af8d9314e0e9855
const $1d95279d912e46c1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ForgeModalDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ForgeModalDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "10ddb346add2537047e9d08fed9494c213c3fbe41490cba82af8d9314e0e9855",
            "metadata": {},
            "name": "ForgeModalDeprecationMessage_appQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1d95279d912e46c1$var$node.hash = "6249f13b9dc8b658b8478b0412f6a152";
var $1d95279d912e46c1$export$2e2bcd8739ae039 = $1d95279d912e46c1$var$node;
module.exports["default"] = $1d95279d912e46c1$export$2e2bcd8739ae039;

});

parcelRegister("lCRfz", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dClXj = parcelRequire("dClXj");

const $43bea25c2aea9ada$export$4234d7cd582aba17 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children, fallback: t1, errorFallback: t2 } = t0;
    const fallback = t1 === undefined ? null : t1;
    const errorFallback = t2 === undefined ? null : t2;
    let t3;
    if ($[0] !== children || $[1] !== fallback) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: fallback
        }, children);
        $[0] = children;
        $[1] = fallback;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== errorFallback || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dClXj.RelayErrorBoundary), {
            fallback: errorFallback
        }, t3);
        $[3] = errorFallback;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ children: children, fallback: fallback = null, errorFallback: errorFallback = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dClXj.RelayErrorBoundary), {
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: fallback
    }, children));
module.exports["RelaySuspensefulBoundary"] = $43bea25c2aea9ada$export$4234d7cd582aba17;

});

parcelRegister("5hXFK", function(module, exports) {
/**
 * @generated SignedSource<<845dc4dc6ae5e67e36d3cbb2c72ca965>>
 * @relayHash ebca7fca92ead3748b535be27a7da2d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9b2fb272613065d86d17a8320d95aabce6cbe3c4fe87e476268744b2c438c43
const $8f3869bffe483adc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "user_forge_ui_userQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "user_forge_ui_userQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9b2fb272613065d86d17a8320d95aabce6cbe3c4fe87e476268744b2c438c43",
            "metadata": {},
            "name": "user_forge_ui_userQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8f3869bffe483adc$var$node.hash = "d05625ee70ba3d55ce9b8d550af8d0eb";
var $8f3869bffe483adc$export$2e2bcd8739ae039 = $8f3869bffe483adc$var$node;
module.exports["default"] = $8f3869bffe483adc$export$2e2bcd8739ae039;

});

parcelRegister("eU26O", function(module, exports) {
/**
 * @generated SignedSource<<f9f8a732fc0bc8e97cfa59a06dddcaed>>
 * @relayHash 803200a52f130572caf872b4e016fb1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2792700d56c071d783bc368a3b8cec5a1a1b6af55acd17a1b662a73ae865bd12
const $d186ff71452c9d53$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usergroup_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usergroup_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2792700d56c071d783bc368a3b8cec5a1a1b6af55acd17a1b662a73ae865bd12",
            "metadata": {},
            "name": "usergroup_forge_ui_usersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d186ff71452c9d53$var$node.hash = "d0105c23c646ed326ba46ee28241752a";
var $d186ff71452c9d53$export$2e2bcd8739ae039 = $d186ff71452c9d53$var$node;
module.exports["default"] = $d186ff71452c9d53$export$2e2bcd8739ae039;

});

parcelRegister("hBuHI", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS = 15;
const $5ba58c31384319a3$export$9de303ca9515c607 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const containerRef = (0, $42omo.useRef)(null);
    const [height, setHeight] = (0, $42omo.useState)(null);
    const [observationInvalidatedReason, setObservationInvalidatedReason] = (0, $42omo.useState)(null);
    const uniqueSizeObservationsRef = (0, $42omo.useRef)(0);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (newHeight)=>{
            setHeight((prevHeight)=>{
                if (prevHeight !== newHeight) uniqueSizeObservationsRef.current = uniqueSizeObservationsRef.current + 1;
                return newHeight;
            });
        };
        $[0] = t0;
    } else t0 = $[0];
    const handleHeightChange = t0;
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if (!containerRef.current) return;
            uniqueSizeObservationsRef.current = 0;
            const observer = new ResizeObserver((t3)=>{
                const [entry] = t3;
                const newHeight_0 = Math.trunc(entry.contentRect.height);
                handleHeightChange(newHeight_0);
                if (uniqueSizeObservationsRef.current >= $5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS) {
                    observer.disconnect();
                    setObservationInvalidatedReason(`Stopped counting after ${$5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS} unique resize events`);
                }
            });
            observer.observe(containerRef.current);
            return ()=>observer.disconnect();
        };
        t2 = [
            handleHeightChange
        ];
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[3] !== height || $[4] !== observationInvalidatedReason) {
        t3 = {
            containerRef: containerRef,
            height: height,
            observationInvalidatedReason: observationInvalidatedReason
        };
        $[3] = height;
        $[4] = observationInvalidatedReason;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ()=>{
    const containerRef = (0, $42omo.useRef)(null);
    const [height, setHeight] = (0, $42omo.useState)(null);
    const [observationInvalidatedReason, setObservationInvalidatedReason] = (0, $42omo.useState)(null);
    const uniqueSizeObservationsRef = (0, $42omo.useRef)(0);
    // Memoize the observer callback to handle height changes
    const handleHeightChange = (0, $42omo.useCallback)((newHeight)=>{
        setHeight((prevHeight)=>{
            if (prevHeight !== newHeight) uniqueSizeObservationsRef.current++;
            return newHeight;
        });
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!containerRef.current) return;
        // Reset observation counter for this instance
        uniqueSizeObservationsRef.current = 0;
        const observer = new ResizeObserver(([entry])=>{
            const newHeight_0 = Math.trunc(entry.contentRect.height);
            handleHeightChange(newHeight_0);
            // Break after too many unique changes to prevent excessive tracking
            if (uniqueSizeObservationsRef.current >= $5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS) {
                observer.disconnect();
                setObservationInvalidatedReason(`Stopped counting after ${$5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS} unique resize events`);
            }
        });
        observer.observe(containerRef.current);
        // Cleanup observer on unmount
        return ()=>observer.disconnect();
    }, [
        handleHeightChange
    ]);
    return {
        containerRef: containerRef,
        height: height,
        observationInvalidatedReason: observationInvalidatedReason
    };
};
module.exports["useHeightObserver"] = $5ba58c31384319a3$export$9de303ca9515c607;

});

parcelRegister("1I2N5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

const $fbfcc51dc5b115ca$export$cc725e2aa41de44a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (data, t0)=>{
    const $ = (0, $frIzR.c)(5);
    const equalityCheck = t0 === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))) : t0;
    const [memoizedData, setMemoizedData] = (0, $42omo.useState)(data);
    let t1;
    let t2;
    if ($[0] !== data || $[1] !== equalityCheck || $[2] !== memoizedData) {
        t1 = ()=>{
            if (!equalityCheck(data, memoizedData)) setMemoizedData(data);
        };
        t2 = [
            data,
            memoizedData,
            equalityCheck
        ];
        $[0] = data;
        $[1] = equalityCheck;
        $[2] = memoizedData;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return memoizedData;
} : (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))))=>{
    const [memoizedData, setMemoizedData] = (0, $42omo.useState)(data);
    (0, $42omo.useEffect)(()=>{
        if (!equalityCheck(data, memoizedData)) setMemoizedData(data);
    }, [
        data,
        memoizedData,
        equalityCheck
    ]);
    return memoizedData;
};
module.exports["useMemoizedStateObject"] = $fbfcc51dc5b115ca$export$cc725e2aa41de44a;

});

parcelRegister("hcbSV", function(module, exports) {

var $5oEbs = parcelRequire("5oEbs");


var $4jZsH = parcelRequire("4jZsH");


var $LiNdD = parcelRequire("LiNdD");


var $ge8sG = parcelRequire("ge8sG");


var $UZU5S = parcelRequire("UZU5S");



var $6baEI = parcelRequire("6baEI");

const $130ab70bfb5bcaa7$export$9b96caef38763092 = ()=>{
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
module.exports["getBrowserTimezone"] = $130ab70bfb5bcaa7$export$9b96caef38763092;

});

parcelRegister("f0Xuq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $4Ybnb = parcelRequire("4Ybnb");


var $gdv5Z = parcelRequire("gdv5Z");


var $iP9n7 = parcelRequire("iP9n7");


var $dh538 = parcelRequire("dh538");


var $irOoi = parcelRequire("irOoi");


var $jIiuI = parcelRequire("jIiuI");


var $1QQWr = parcelRequire("1QQWr");

var $dj2Gr = parcelRequire("dj2Gr");

var $4Marr = parcelRequire("4Marr");

var $iWy5D = parcelRequire("iWy5D");


var $4ZTaE = parcelRequire("4ZTaE");


var $4LgCj = parcelRequire("4LgCj");

var $6fRDv = parcelRequire("6fRDv");

var $9XihO = parcelRequire("9XihO");

var $kxKUs = parcelRequire("kxKUs");

var $kZjf5 = parcelRequire("kZjf5");

var $buzAL = parcelRequire("buzAL");

var $cPPTB = parcelRequire("cPPTB");


var $kaOT1 = parcelRequire("kaOT1");


var $LiNdD = parcelRequire("LiNdD");

var $hcbSV = parcelRequire("hcbSV");

var $ge8sG = parcelRequire("ge8sG");

var $UZU5S = parcelRequire("UZU5S");


var $aGCtG = parcelRequire("aGCtG");


var $bn0yX = parcelRequire("bn0yX");


var $80yqV = parcelRequire("80yqV");


var $539Bm = parcelRequire("539Bm");


var $iqcSr = parcelRequire("iqcSr");

var $ijfiP = parcelRequire("ijfiP");


var $lMJg3 = parcelRequire("lMJg3");


var $cKUnA = parcelRequire("cKUnA");


var $cr6KQ = parcelRequire("cr6KQ");


var $3AYRA = parcelRequire("3AYRA");




let $ab5a832ac7acfeff$var$postRobotOn = null;

if (typeof window !== 'undefined') $ab5a832ac7acfeff$var$postRobotOn = (parcelRequire("eLUTa")).postRobotOn;
const $ab5a832ac7acfeff$var$styles = {
    threeLOInfo: "_1bsb1osq _4t3i1osq",
    box: "_kqswh2mm"
}; // TODO: no styles defined for resizable modals yet.
// Only Jira enables resizing on modals at the moment.
const $ab5a832ac7acfeff$var$modalIframeStyles = null;
const $ab5a832ac7acfeff$var$iframeStyles = null;
const $ab5a832ac7acfeff$var$hiddenIframeStyles = null;
const $ab5a832ac7acfeff$var$nonResizeableIframeStyles = null;
const $ab5a832ac7acfeff$var$defaultComponents = {
    ThreeLOPrompt: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ZTaE.default), props)
}; /**
    * Hook for determining default IFrame React ref, using parent ref when provided
    *
    * @param parentIframeRef parent IFrame React ref
    * @returns default IFrame React ref
    */ 
const $ab5a832ac7acfeff$var$useDefaultIframeRef = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useDefaultIframeRef(parentIframeRef) {
    const $ = (0, $frIzR.c)(2);
    const localIframeRef = (0, $42omo.useRef)(null);
    let t0;
    if ($[0] !== parentIframeRef) {
        t0 = [
            parentIframeRef,
            localIframeRef
        ];
        $[0] = parentIframeRef;
        $[1] = t0;
    } else t0 = $[1];
    const mergedRef = (0, $iP9n7.useMergeRefs)(t0);
    return mergedRef;
} : function useDefaultIframeRef(parentIframeRef) {
    const localIframeRef = (0, $42omo.useRef)(null);
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        parentIframeRef,
        localIframeRef
    ]);
    return mergedRef;
};
const $ab5a832ac7acfeff$export$3c4d31cb85fd39c5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', src: src, bridge: bridge, customBridgeMethods: customBridgeMethods, isResizable: isResizable, getContextToken: getContextToken, timezone: timezone, locale: locale, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, extensionPayload: extensionPayload, isHidden: isHidden, theme: theme, surfaceColor: surfaceColor, appId: appId, isInModal: isInModal, setIsLoading: setIsLoading, onError: onError, entryPoint: entryPoint, isEmbeddedMacro: isEmbeddedMacro, embeddedMacroParentType: embeddedMacroParentType, embeddedParentLocalId: embeddedParentLocalId }, parentIframeRef)=>{
    const { ThreeLOPrompt: ThreeLOPrompt } = components ? components($ab5a832ac7acfeff$var$defaultComponents) : $ab5a832ac7acfeff$var$defaultComponents;
    const appIsAuthenticated = (0, $aGCtG.isAppConsentedLocally)(appId, accountId);
    const { appVersion: appVersion, consentUrl: consentUrl, currentUserConsent: currentUserConsent, requiresUserConsent: requiresUserConsent, properties: { frameId: frameId, layout: layout } } = extension;
    const [userConsentRequired, setUserConsentRequired] = (0, $42omo.useState)(consentUrl && !currentUserConsent && requiresUserConsent && !appIsAuthenticated);
    const productContext = (0, $42omo.useMemo)(()=>{
        const resolverContext = (0, $ge8sG.getResolverContext)({
            ...coreData,
            appVersion: appVersion
        }, extensionData);
        const viewContext = (0, $UZU5S.getViewContext)({
            resolverContext: resolverContext,
            accountId: accountId,
            extension: extension,
            timezone: timezone ?? (0, $hcbSV.getBrowserTimezone)(),
            locale: locale ?? (0, $LiNdD.getBrowserLocale)(),
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            theme: theme,
            surfaceColor: surfaceColor,
            location: window.location.toString()
        });
        return {
            resolverContext: resolverContext,
            viewContext: viewContext
        };
    }, [
        appVersion,
        coreData,
        extensionData,
        extensionViewData,
        accountId,
        extension,
        timezone,
        locale,
        extensionPayload,
        theme,
        surfaceColor
    ]); // For embedded macros, create context token options to pass to getContextToken
    // This ensures the token is generated for the embedded macro's context, not the parent's
    const embeddedMacroContextTokenOptions = ((0, $dh538.fg)('platform_forge_ui_refactor_macro_parent_type') ? !!embeddedMacroParentType : isEmbeddedMacro) ? {
        extensionOverride: {
            extension: extension,
            localId: coreData.localId
        }
    } : undefined; /**
                  * Wrapper for getContextToken that handles both embedded macro and regular cases.
                  * For embedded macros, includes the extension override to generate a token scoped to the embedded macro.
                  * Falls back to cached token when getContextToken is not available.
                  */ 
    const getContextTokenWrapper = async (contextIdsOverride)=>{
        if (!getContextToken) return contextTokenRef.current?.jwt;
        if ((0, $dh538.fg)('platform_forge_ui_refactor_macro_parent_type') ? !!embeddedMacroParentType : isEmbeddedMacro) return getContextToken({
            extensionOverride: {
                extension: extension,
                localId: coreData.localId
            },
            ...contextIdsOverride && {
                contextIdsOverride: contextIdsOverride
            }
        });
        return contextIdsOverride ? getContextToken({
            contextIdsOverride: contextIdsOverride
        }) : getContextToken();
    };
    const tracing = (0, $kaOT1.useTracingContext)();
    const contextTokenRef = (0, $42omo.useRef)(undefined);
    const [threeLOInfo, setThreeLOInfo] = (0, $42omo.useState)(null);
    const invokeRetriesRef = (0, $42omo.useRef)([]);
    const iframeRef = $ab5a832ac7acfeff$var$useDefaultIframeRef(parentIframeRef);
    (0, $42omo.useEffect)(()=>{
        const clearThreeLOInfo = async ()=>setThreeLOInfo(null);
        if (userConsentRequired) {
            tracing?.recordConsentFlow('consent flow - start');
            setThreeLOInfo({
                authUrl: consentUrl,
                onSuccess: async ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'success');
                    setUserConsentRequired(false);
                    setIsThreeLOPromptVisible(false);
                    (0, $aGCtG.setAppConsentLocal)(appId, accountId);
                    return clearThreeLOInfo();
                },
                onReject: ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'rejected');
                    return clearThreeLOInfo();
                }
            });
            setIsThreeLOPromptVisible(true);
            setShouldShowRenderer?.(false);
            if (onLoad) onLoad();
        }
    }, [
        onLoad,
        setIsThreeLOPromptVisible,
        setShouldShowRenderer,
        tracing,
        appId,
        accountId,
        consentUrl,
        userConsentRequired
    ]);
    const navigation = (0, $kZjf5.useNavigation)({
        extension: extension,
        push: bridge?.spaPush
    });
    const navigationRef = (0, $42omo.useRef)(navigation);
    navigationRef.current = navigation; // Skip FAUS navigate listener setup when this is the UI Kit macro custom config view (current resource is the config resource).
    const isMacroConfigView = Boolean(extension.properties?.config?.resource && extension.properties?.resource === extension.properties?.config?.resource); // Listen for navigate events from FAUS (e.g. link clicks in forge-adf-renderer). Skip when in modal or UI Kit macro custom config so only the macro body registers.
    (0, $42omo.useEffect)(()=>{
        if (layout === 'bodied' && coreData.localId && $ab5a832ac7acfeff$var$postRobotOn && !isInModal && !isMacroConfigView && (0, $dh538.fg)('platform_faus_navigate_to_product')) {
            const allowedDomain = (0, $6fRDv.getProductDomain)();
            try {
                const listener = $ab5a832ac7acfeff$var$postRobotOn(`navigateFromEmbeddedFAUS_${coreData.localId}`, {
                    domain: allowedDomain
                }, async ({ data: data })=>{
                    if (!data?.url) return;
                    navigationRef.current.onNavigate({
                        type: 'new-tab',
                        url: data.url
                    }).catch(()=>{});
                });
                return ()=>{
                    listener.cancel();
                }; // eslint-disable-next-line no-unused-vars
            } catch (_) {
                // eslint-disable-next-line no-console
                console.log('Failed to set up navigation listener');
            }
        }
    }, [
        layout,
        coreData.localId,
        isInModal,
        isMacroConfigView
    ]);
    const invoker = (0, $dj2Gr.useInvokeExtension)(contextIds, extension.id); // The hash generated here should match the one created in the Realtime service when it hashes extension.context
    // in the FCT.
    // If this is flaky because of differences between extensionData and the FCT's extension.context, then
    // use the decoded FCT context directly here as well.
    const extensionContext = (()=>{
        try {
            const { modal: // eslint-disable-next-line no-unused-vars
            modal, ...productExtensionData } = extensionData;
            return (0, (/*@__PURE__*/$parcel$interopDefault($4Ybnb)))(productExtensionData || {}); // eslint-disable-next-line no-unused-vars
        } catch (__0) {
            // eslint-disable-next-line no-console
            console.error('Product context is not a serializable object.');
            return '';
        }
    })(); // the realtime hooks below have no side effect (i.e. does not actively trigger any network calls or actively makes any subscription).
    // It is because everything inside this hook is lazily initialized.
    // Importantly:
    // - SubscribeRealtimeChannel is called by the client (i.e. @forge/bridge)
    const subscribeRealtimeChannel = (0, $iWy5D.useSubscribeRealtimeChannel)(extension.installationId, extensionContext, getContextToken, embeddedMacroContextTokenOptions);
    const publishRealtimeChannel = (0, $4Marr.usePublishRealtimeChannel)(extension.installationId, extensionContext, appId);
    const renderThreeLOPrompt = (retry)=>{
        return new Promise((resolve, reject)=>{
            const authUrl = threeLOInfo?.authUrl || consentUrl;
            if (authUrl) {
                invokeRetriesRef.current.push(retry);
                tracing?.recordConsentFlow('consent flow - start');
                setThreeLOInfo({
                    authUrl: authUrl,
                    onSuccess: ()=>{
                        tracing?.recordConsentFlow('consent flow - end', 'success');
                        resolve();
                        setThreeLOInfo(null);
                        setIsThreeLOPromptVisible(false);
                        setShouldShowRenderer?.(true);
                        return Promise.all(invokeRetriesRef.current.map((retry_0)=>retry_0())).then(()=>{
                            invokeRetriesRef.current = [];
                        });
                    },
                    onReject: ()=>{
                        tracing?.recordConsentFlow('consent flow - end', 'rejected');
                        return reject();
                    }
                });
                setIsThreeLOPromptVisible(true);
                setShouldShowRenderer?.(false);
            }
        });
    };
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const relayEnvironment = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext))?.environment;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const rovoChat = (0, $cPPTB.useRovoAgentsChat)(extension.type, appId, cloudId, extension.installationId, extension.environmentId);
    const isAnonymousAccessSupportedByApp = extension.properties?.unlicensedAccess?.includes('anonymous') ?? false;
    const productFetchClient = (0, $9XihO.useProductFetchClient)({
        appId: appId,
        environment: environment,
        contextIds: contextIds,
        cloudId: cloudId,
        workspaceId: workspaceId,
        extensionId: extension.id,
        renderThreeLOPrompt: renderThreeLOPrompt,
        isAnonymousAccessSupportedByApp: isAnonymousAccessSupportedByApp
    });
    const permissions = (0, $buzAL.usePermission)({
        appId: appId,
        installationId: extension.installationId,
        contextIds: contextIds,
        extensionId: extension.id,
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const emitPublicEvent = (0, $1QQWr.useEmitPublicEvent)(contextIds[0], {
        appId: extension.appId,
        id: extension.id.split('/').slice(0, 3).join('/'),
        installationId: extension.installationId
    });
    const fetchRemoteClient = (0, $3AYRA.useRemoteFetchClient)();
    const permissionFunctions = Object.fromEntries((0, $buzAL.permissionMethods).map((method)=>[
            `${(0, $buzAL.PERMISSION_METHOD_PREFIX)}${method}`,
            permissions[method]
        ]));
    const { loading: loading, iframeProps: { onLoad: onLoadIframeFromProps } } = (0, $kxKUs.useBridge)({
        cloudId: cloudId,
        theme: theme,
        surfaceColor: surfaceColor,
        origin: new URL(src).origin,
        api: {
            ...(0, $4LgCj.createBridgeApi)(bridge, {
                userConsentRequired: !!userConsentRequired
            }),
            openRovo: rovoChat.openRovo,
            onInvoke: async (payload)=>{
                const contextToken = await getContextTokenWrapper(contextIds);
                tracing?.recordGqlCall('invokeExtension - start');
                const { data: data_0 } = await invoker({
                    call: payload,
                    context: {
                        ...productContext.resolverContext
                    },
                    extensionPayload: extensionPayload,
                    contextToken: contextToken
                }); // Default to using the regular invocation response
                var resp = data_0?.invokeExtension;
                if (!resp?.success) {
                    const error = resp?.errors?.[0];
                    if (error?.extensions.errorType === 'USER_CONSENT_REQUIRED') return {
                        type: '3lo',
                        authUrl: error?.extensions.fields?.authInfoUrl
                    };
                    if ((error?.extensions.errorType === (0, $80yqV.SANDBOX_DEPRECATION_ERROR) || (0, $80yqV.isDeveloperSpaceError)(error?.extensions.errorType)) && onError) onError(error?.extensions.errorType);
                    return {
                        type: 'err',
                        message: error?.message ?? 'An error occurred while trying to invoke.'
                    };
                }
                tracing?.recordGqlCall('invokeExtension - end');
                contextTokenRef.current = resp?.contextToken;
                return {
                    type: 'ok',
                    response: resp?.response?.body,
                    metadata: {
                        rateLimitProperties: resp?.rateLimitProperties
                    }
                };
            },
            onInitFeatureFlags: async (data_1)=>{
                const contextToken_0 = await getContextTokenWrapper();
                tracing?.recordBridgeCall('getFeatureFlags - start');
                try {
                    const resp_0 = await (0, $cKUnA.getFeatureFlags)(appId, data_1.user, data_1.config, environment, contextToken_0);
                    tracing?.recordBridgeCall('getFeatureFlags - end');
                    return {
                        type: 'ok',
                        response: resp_0
                    };
                } catch (err) {
                    tracing?.recordBridgeCall('getFeatureFlags - end'); // eslint-disable-next-line no-console
                    console.error('There were errors while initialising feature flags client ', err);
                    return {
                        type: 'err',
                        message: 'An error occurred while trying to initialise feature flags client.'
                    };
                }
            },
            onEmitFrontendCustomMetric: async (data_2)=>{
                // Bail without a context ARI or Relay env. `contextIds[0]` is typed `string` but is `undefined` for an empty array.
                const contextAri = contextIds[0];
                if (!contextAri || !relayEnvironment) return;
                tracing?.recordBridgeCall('emitFrontendCustomMetric - start');
                try {
                    // `extension.type` is the module *type* (e.g. `jira:issuePanel`); the module *key* is the
                    // last segment of the extension ARI — parse it the same way Iframe.tsx does.
                    const { moduleKey: moduleKey } = (0, $ijfiP.parseExtensionId)(extension.id);
                    await (0, $cr6KQ.emitFrontendCustomMetric)({
                        relayEnvironment: relayEnvironment,
                        contextAri: contextAri,
                        appId: appId,
                        installationId: extension.installationId,
                        moduleKey: moduleKey,
                        customMetricName: data_2.customMetricName,
                        value: data_2.value
                    });
                } catch  {}
                tracing?.recordBridgeCall('emitFrontendCustomMetric - end');
            },
            onNavigate: navigation.onNavigate,
            onThreeLO: async (authUrl_0, retry_1)=>{
                return new Promise((resolve_0, reject_0)=>{
                    invokeRetriesRef.current.push(retry_1);
                    tracing?.recordConsentFlow('consent flow - start');
                    setThreeLOInfo({
                        authUrl: authUrl_0,
                        onSuccess: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'success');
                            resolve_0();
                            setThreeLOInfo(null);
                            setIsThreeLOPromptVisible(false);
                            setShouldShowRenderer?.(true);
                            return Promise.all(invokeRetriesRef.current.map((retry_2)=>retry_2())).then(()=>{
                                invokeRetriesRef.current = [];
                            });
                        },
                        onReject: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'rejected');
                            return reject_0();
                        }
                    });
                    setIsThreeLOPromptVisible(true);
                    setShouldShowRenderer?.(false);
                });
            },
            getContext: async ()=>({
                    ...productContext.viewContext
                }),
            fetchProduct: async ({ restPath: restPath, product: product, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
                const response = await productFetchClient(restPath, product, fetchRequestInit, isMultipartFormData);
                const { status: status, statusText: statusText } = response;
                const headers = Object.fromEntries(response.headers.entries());
                const isAttachment = (0, $9XihO.isBinaryContentType)(response.headers.get('content-type'));
                const body = response.body ? await response.text() : undefined;
                return {
                    headers: headers,
                    status: status,
                    statusText: statusText,
                    body: body,
                    isAttachment: isAttachment
                };
            },
            fetchRemote: async ({ remoteKey: remoteKey, fetchRequestInit: fetchRequestInit_0, isMultipartFormData: isMultipartFormData_0 })=>{
                const { path: path, ...init } = fetchRequestInit_0;
                const contextToken_1 = await getContextTokenWrapper();
                const response_0 = await fetchRemoteClient(remoteKey, init, isMultipartFormData_0, path, contextToken_1);
                const { status: status_0, statusText: statusText_0 } = response_0;
                const headers_0 = Object.fromEntries(response_0.headers.entries());
                const isAttachment_0 = (0, $9XihO.isBinaryContentType)(response_0.headers.get('content-type'));
                const body_0 = response_0.body ? await response_0.text() : undefined;
                return {
                    headers: headers_0,
                    status: status_0,
                    statusText: statusText_0,
                    body: body_0,
                    isAttachment: isAttachment_0
                };
            },
            getFrameId: ()=>frameId ?? null,
            subscribeRealtimeChannel: async (payload_0)=>{
                return subscribeRealtimeChannel(payload_0);
            },
            publishRealtimeChannel: async (payload_1)=>{
                const contextToken_2 = await getContextTokenWrapper();
                return publishRealtimeChannel(payload_1, contextToken_2);
            },
            emitPublic: emitPublicEvent,
            ...permissionFunctions
        },
        customBridgeMethods: customBridgeMethods,
        onLoad: onLoad,
        isResizable: isResizable,
        height: height,
        environment: environment,
        extension: extension,
        iframeRef: iframeRef,
        contextIds: contextIds,
        isInModal: isInModal,
        localId: coreData.localId,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedParentLocalId: embeddedParentLocalId,
        extensionPayload: extensionPayload,
        extensionData: extensionData
    });
    (0, $42omo.useEffect)(()=>{
        setIsLoading?.(loading);
    }, [
        loading,
        setIsLoading
    ]);
    const { containerRef: containerRef } = (0, $539Bm.useResizeAnalytics)({
        // need to check if the extension is custom UI as well since this component is used in WebRuntime for UI Kit
        isEnabled: (0, $iqcSr.isCustomUI)(extension, entryPoint) && (0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')
    });
    const sandboxAttributeRules = [
        'allow-downloads',
        'allow-forms',
        'allow-modals',
        'allow-pointer-lock',
        'allow-same-origin',
        'allow-scripts'
    ];
    try {
        const egressService = (0, $lMJg3.egressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
        const containsWildCardEgress = egressService.containsWildCardEgress();
        if (containsWildCardEgress) {
            sandboxAttributeRules.push('allow-popups', 'allow-popups-to-escape-sandbox');
            if ((0, $dh538.fg)('allow_storage_access_by_user_activation_attribute')) sandboxAttributeRules.push('allow-storage-access-by-user-activation');
        } // eslint-disable-next-line no-unused-vars
    } catch (__1) {}
    let framePermissionsPolicy = 'camera; clipboard-write; display-capture; fullscreen; microphone';
    if ((0, $dh538.fg)('platform_forge-ui_frame-allow-local-network-access')) framePermissionsPolicy += '; local-network-access';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: containerRef,
        xcss: $ab5a832ac7acfeff$var$styles.box,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: isResizable || threeLOInfo ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        }
    }, navigation.getModalJsx(), permissions.getModalJsx(), (loading || threeLOInfo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ab5a832ac7acfeff$var$styles.threeLOInfo
    }, loading && !threeLOInfo && !isHidden && (0, $bn0yX.getLoadingComponent)(loadingComponent), threeLOInfo && ThreeLOPrompt({
        authUrl: threeLOInfo.authUrl,
        onSuccess: threeLOInfo.onSuccess,
        metadata: {
            moduleType: extension.type
        }
    })), !userConsentRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        "data-testid": "hosted-resources-iframe",
        "data-forge-iframe": true,
        sandbox: sandboxAttributeRules.join(' '),
        allow: framePermissionsPolicy,
        src: src,
        ref: iframeRef,
        onLoad: onLoadIframeFromProps,
        title: `Iframe ${frameId ?? (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()} from ${appId}`,
        className: (0, $gMc0m.default)([
            "_19itglyw _1e0c1ule _1bsb1osq",
            (loading || threeLOInfo || isHidden) && "_1e0cglyw",
            isInModal && "_2rkofajl _4t3i1osq",
            !isResizable && "_4t3i1osq"
        ])
    })));
});
module.exports["InnerIframe"] = $ab5a832ac7acfeff$export$3c4d31cb85fd39c5;

});

parcelRegister("bn0yX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $CMcde = parcelRequire("CMcde");

const $13104cd2bb06c6a7$export$aee5524fcec014ce = (loadingComponent)=>{
    if (loadingComponent) return typeof loadingComponent === 'function' ? loadingComponent() : loadingComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CMcde.Loader), null);
};
module.exports["getLoadingComponent"] = $13104cd2bb06c6a7$export$aee5524fcec014ce;

});

parcelRegister("6UsXz", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7mt4M = parcelRequire("7mt4M");


var $dClXj = parcelRequire("dClXj");

const $8ec10056009983e2$var$TunnelsLoader = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { appId: appId, contextIds: contextIds, environmentId: environmentId, children: children } = t0;
    let t1;
    if ($[0] !== appId || $[1] !== contextIds || $[2] !== environmentId) {
        t1 = {
            appId: appId,
            environmentId: environmentId,
            contextIds: contextIds
        };
        $[0] = appId;
        $[1] = contextIds;
        $[2] = environmentId;
        $[3] = t1;
    } else t1 = $[3];
    const { tunnels: tunnels } = (0, $7mt4M.useCustomUITunnelsListRelay)(t1);
    let t2;
    if ($[4] !== children || $[5] !== tunnels) {
        t2 = children({
            loading: false,
            tunnels: tunnels
        });
        $[4] = children;
        $[5] = tunnels;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ appId: appId, contextIds: contextIds, environmentId: environmentId, children: children })=>{
    const { tunnels: tunnels } = (0, $7mt4M.useCustomUITunnelsListRelay)({
        appId: appId,
        environmentId: environmentId,
        contextIds: contextIds
    });
    return children({
        loading: false,
        tunnels: tunnels
    });
};
const $8ec10056009983e2$export$ac05e5a66b1a4559 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { environmentType: environmentType, appId: appId, contextIds: contextIds, environmentId: environmentId, children: children } = t0;
    let t1;
    if ($[0] !== appId || $[1] !== children || $[2] !== contextIds || $[3] !== environmentId || $[4] !== environmentType) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const fallbackResult = {
                tunnels: [],
                loading: true
            };
            if (environmentType === "DEVELOPMENT") {
                let t2;
                if ($[6] !== children) {
                    t2 = children({
                        tunnels: [],
                        loading: false
                    });
                    $[6] = children;
                    $[7] = t2;
                } else t2 = $[7];
                let t3;
                if ($[8] !== appId || $[9] !== children || $[10] !== contextIds || $[11] !== environmentId) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ec10056009983e2$var$TunnelsLoader, {
                        appId: appId,
                        contextIds: contextIds,
                        environmentId: environmentId,
                        children: children
                    });
                    $[8] = appId;
                    $[9] = children;
                    $[10] = contextIds;
                    $[11] = environmentId;
                    $[12] = t3;
                } else t3 = $[12];
                const t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
                    fallback: children(fallbackResult)
                }, t3);
                let t5;
                if ($[13] !== t2 || $[14] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dClXj.RelayErrorBoundary), {
                        fallback: t2
                    }, t4);
                    $[13] = t2;
                    $[14] = t4;
                    $[15] = t5;
                } else t5 = $[15];
                t1 = t5;
                break bb0;
            }
        }
        $[0] = appId;
        $[1] = children;
        $[2] = contextIds;
        $[3] = environmentId;
        $[4] = environmentType;
        $[5] = t1;
    } else t1 = $[5];
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    let t2;
    if ($[16] !== children) {
        t2 = children({
            loading: false,
            tunnels: []
        });
        $[16] = children;
        $[17] = t2;
    } else t2 = $[17];
    return t2;
} : ({ environmentType: environmentType, appId: appId, contextIds: contextIds, environmentId: environmentId, children: children })=>{
    const fallbackResult = {
        tunnels: [],
        loading: true
    };
    if (environmentType === 'DEVELOPMENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dClXj.RelayErrorBoundary), {
        fallback: children({
            tunnels: [],
            loading: false
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: children(fallbackResult)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ec10056009983e2$var$TunnelsLoader, {
        appId: appId,
        contextIds: contextIds,
        environmentId: environmentId,
        children: children
    })));
    return children({
        loading: false,
        tunnels: []
    });
};
module.exports["TunnelsProvider"] = $8ec10056009983e2$export$ac05e5a66b1a4559;

});

parcelRegister("jNc4k", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $luNHV = parcelRequire("luNHV");


var $2uzbP = parcelRequire("2uzbP");


var $hQK66 = parcelRequire("hQK66");


var $6oQb1 = parcelRequire("6oQb1");

const $81f81791d185e0cc$export$5585193a0b9bb43d = ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    const forgeReactMajorVersion = (0, $42omo.useRef)(null);
    const initialConfigKey = (0, $42omo.useRef)(null);
    const { config: config, ...extensionWithoutConfig } = context.extension ?? {};
    const currentConfigKey = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(config);
    const baseContextKey = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))({
        ...context,
        extension: extensionWithoutConfig
    });
    const trackWrappedComponentMounted = $81f81791d185e0cc$var$useWrappedComponentMountTracker();
    (0, $42omo.useEffect)(()=>{
        (0, $luNHV.emit)('FORGE_CORE_MACRO_CONFIG_CHANGED', {
            config: config
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentConfigKey
    ]);
    if (forgeReactMajorVersion.current === null) forgeReactMajorVersion.current = getCurrentForgeReactMajorVersion();
    if (initialConfigKey.current === null) initialConfigKey.current = currentConfigKey;
    // for existing apps we need to ensure backwards compatibility
    const shouldContextKeyChangeOnConfigChange = forgeReactMajorVersion.current === null || forgeReactMajorVersion.current < 11;
    // if the app is using the new version of Forge react, we always uses the initial config key
    const key = baseContextKey + (shouldContextKeyChangeOnConfigChange ? currentConfigKey : initialConfigKey.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($81f81791d185e0cc$var$WrappedComponent, {
        key: key,
        onMounted: trackWrappedComponentMounted
    }, children);
};
const $81f81791d185e0cc$var$useWrappedComponentMountTracker = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $42omo.useRef)(0);
    let t0;
    let t1;
    if ($[0] !== trackExtensionRemounted) {
        t0 = ()=>{
            mountedCount.current = mountedCount.current + 1;
            if (mountedCount.current > 1) trackExtensionRemounted({
                mountCount: mountedCount.current
            });
        };
        t1 = [
            mountedCount,
            trackExtensionRemounted
        ];
        $[0] = trackExtensionRemounted;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    const trackWrappedComponentMounted = (0, $hQK66.useCallbackOne)(t0, t1);
    return trackWrappedComponentMounted;
} : ()=>{
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $42omo.useRef)(0);
    const trackWrappedComponentMounted = (0, $hQK66.useCallbackOne)(()=>{
        mountedCount.current += 1;
        if (mountedCount.current > 1) trackExtensionRemounted({
            mountCount: mountedCount.current
        });
    }, [
        mountedCount,
        trackExtensionRemounted
    ]);
    return trackWrappedComponentMounted;
};
const $81f81791d185e0cc$var$WrappedComponent = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, onMounted: onMounted } = t0;
    let t1;
    let t2;
    if ($[0] !== onMounted) {
        t1 = ()=>{
            onMounted();
        };
        t2 = [
            onMounted
        ];
        $[0] = onMounted;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, onMounted: onMounted })=>{
    (0, $42omo.useEffect)(()=>{
        onMounted();
    }, [
        onMounted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
module.exports["ContextChangeObserverWrapper"] = $81f81791d185e0cc$export$5585193a0b9bb43d;

});

parcelRegister("ifmal", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $gdv5Z = parcelRequire("gdv5Z");


var $iP9n7 = parcelRequire("iP9n7");


var $4GQnE = parcelRequire("4GQnE");


var $9zb43 = parcelRequire("9zb43");


var $jIiuI = parcelRequire("jIiuI");

var $5U2YR = parcelRequire("5U2YR");


var $8012d = parcelRequire("8012d");


var $jIrI4 = parcelRequire("jIrI4");


var $45XLP = parcelRequire("45XLP");


var $1qkDW = parcelRequire("1qkDW");


var $bn0yX = parcelRequire("bn0yX");


var $4jZsH = parcelRequire("4jZsH");


var $6oQb1 = parcelRequire("6oQb1");


var $i7d45 = parcelRequire("i7d45");


var $lwhTs = parcelRequire("lwhTs");


var $lMJg3 = parcelRequire("lMJg3");


var $dh538 = parcelRequire("dh538");


var $4k05I = parcelRequire("4k05I");


var $7KMPr = parcelRequire("7KMPr");

var $kaOT1 = parcelRequire("kaOT1");


var $hUsLn = parcelRequire("hUsLn");

const $d57816887e77fd9b$var$styles = {
    box: "_kqswh2mm",
    loadingOverlay: "_1bsb1osq _4t3i1osq"
}; // TODO: no styles defined for resizable modals yet.
// Only Jira enables resizing on modals at the moment.
const $d57816887e77fd9b$var$modalIframeStyles = null;
const $d57816887e77fd9b$var$iframeStyles = null; // Hide via `visibility: hidden` (not `display: none`): some browsers (e.g. Safari) suspend scripts in
// non-rendered iframes, breaking app init / the bridge handshake. `height: 0` then collapses the box —
// otherwise the in-flow iframe falls back to the ~150px replaced-element default, leaving whitespace
// (e.g. under hidden UI Modifications apps).
const $d57816887e77fd9b$var$hiddenIframeStyles = null;
const $d57816887e77fd9b$var$nonResizableIframeStyles = null;
const $d57816887e77fd9b$var$MACRO_MODULE_NAME = 'xen:macro'; // All permissions granted unconditionally — this is a fresh implementation with no legacy rollout gates.
const $d57816887e77fd9b$var$FRAME_PERMISSIONS_POLICY = 'camera; clipboard-write; display-capture; fullscreen; microphone; local-network-access'; // Base sandbox rules always applied to every hosted-resource iframe.
const $d57816887e77fd9b$var$BASE_SANDBOX_RULES = [
    'allow-downloads',
    'allow-forms',
    'allow-modals',
    'allow-pointer-lock',
    'allow-same-origin',
    'allow-scripts'
]; /**
                                                                                                                                                       * Returns the sandbox attribute string for the iframe.
                                                                                                                                                       * Apps with a wildcard egress rule are granted popup permissions so they can
                                                                                                                                                       * open third-party URLs in new tabs/windows.
                                                                                                                                                       */ 
const $d57816887e77fd9b$var$getSandboxAttribute = (egress)=>{
    const rules = [
        ...$d57816887e77fd9b$var$BASE_SANDBOX_RULES
    ];
    try {
        if ((0, $lMJg3.egressPermissionService)('FETCH_CLIENT_SIDE', egress).containsWildCardEgress()) {
            rules.push('allow-popups', 'allow-popups-to-escape-sandbox');
            if ((0, $dh538.fg)('allow_storage_access_by_user_activation_attribute')) rules.push('allow-storage-access-by-user-activation');
        } // eslint-disable-next-line no-unused-vars
    } catch (_) {}
    return rules.join(' ');
};
const $d57816887e77fd9b$export$3c4d31cb85fd39c5 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, parentIframeRef)=>{
    const $ = (0, $frIzR.c)(87);
    const { accountId: accountId, appId: appId, bridge: bridge, customBridgeMethods: legacyCustomBridgeMethods, customBridge: customBridge, components: components, contextIds: contextIds, coreData: coreData, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, height: t1, isHidden: isHidden, isInModal: isInModal, isResizable: isResizable, loadingComponent: loadingComponent, locale: locale, onError: onError, onLoad: onLoad, src: src, setIsLoading: setIsLoading, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, surfaceColor: surfaceColor, theme: theme, timezone: timezone, width: t2, contextChangeListeners: contextChangeListeners } = t0;
    const height = t1 === undefined ? "100%" : t1;
    const width = t2 === undefined ? "100%" : t2;
    const { overlay: overlay, overlayController: overlayController, isInlineActive: isInlineActive } = (0, $jIrI4.useRuntimeOverlayController)();
    let t3;
    if ($[0] !== extension || $[1] !== onError || $[2] !== overlayController || $[3] !== setShouldShowRenderer) {
        t3 = {
            overlayController: overlayController,
            extension: extension,
            setShouldShowRenderer: setShouldShowRenderer,
            onError: onError
        };
        $[0] = extension;
        $[1] = onError;
        $[2] = overlayController;
        $[3] = setShouldShowRenderer;
        $[4] = t3;
    } else t3 = $[4];
    const showAppError = (0, $45XLP.useRuntimeErrorOverlay)(t3);
    let t4;
    if ($[5] !== accountId || $[6] !== appId || $[7] !== components || $[8] !== extension || $[9] !== onLoad || $[10] !== overlayController || $[11] !== setIsThreeLOPromptVisible || $[12] !== setShouldShowRenderer) {
        t4 = {
            extension: extension,
            appId: appId,
            accountId: accountId,
            components: components,
            onLoad: onLoad,
            setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
            setShouldShowRenderer: setShouldShowRenderer,
            overlayController: overlayController
        };
        $[5] = accountId;
        $[6] = appId;
        $[7] = components;
        $[8] = extension;
        $[9] = onLoad;
        $[10] = overlayController;
        $[11] = setIsThreeLOPromptVisible;
        $[12] = setShouldShowRenderer;
        $[13] = t4;
    } else t4 = $[13];
    const { userConsentRequired: userConsentRequired, renderThreeLOPrompt: renderThreeLOPrompt } = (0, $8012d.useInitialAppState)(t4);
    let t5;
    if ($[14] !== accountId || $[15] !== appId || $[16] !== bridge || $[17] !== contextChangeListeners || $[18] !== contextIds || $[19] !== coreData || $[20] !== extension || $[21] !== extensionData || $[22] !== extensionPayload || $[23] !== extensionViewData || $[24] !== getContextToken || $[25] !== locale || $[26] !== surfaceColor || $[27] !== theme || $[28] !== timezone) {
        t5 = {
            accountId: accountId,
            appId: appId,
            bridge: bridge,
            contextIds: contextIds,
            coreData: coreData,
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            getContextToken: getContextToken,
            locale: locale,
            surfaceColor: surfaceColor,
            theme: theme,
            timezone: timezone,
            contextChangeListeners: contextChangeListeners
        };
        $[14] = accountId;
        $[15] = appId;
        $[16] = bridge;
        $[17] = contextChangeListeners;
        $[18] = contextIds;
        $[19] = coreData;
        $[20] = extension;
        $[21] = extensionData;
        $[22] = extensionPayload;
        $[23] = extensionViewData;
        $[24] = getContextToken;
        $[25] = locale;
        $[26] = surfaceColor;
        $[27] = theme;
        $[28] = timezone;
        $[29] = t5;
    } else t5 = $[29];
    const { getBridgeFeatures: getBridgeFeatures, getBridgeContext: getBridgeContext, destroy: cleanupBridge, setBridgeControl: setBridgeControl } = $d57816887e77fd9b$var$useBridgeFeatures(t5, overlayController, renderThreeLOPrompt, showAppError, legacyCustomBridgeMethods, customBridge);
    const localIframeRef = (0, $42omo.useRef)(null);
    let t6;
    if ($[30] !== parentIframeRef) {
        t6 = [
            parentIframeRef,
            localIframeRef
        ];
        $[30] = parentIframeRef;
        $[31] = t6;
    } else t6 = $[31];
    const iframeRef = (0, $iP9n7.useMergeRefs)(t6);
    const iframeTitle = $d57816887e77fd9b$var$useIframeTitle(extension.properties.frameId, appId);
    let t7;
    if ($[32] !== customBridge || $[33] !== extension || $[34] !== getBridgeContext || $[35] !== legacyCustomBridgeMethods) {
        t7 = {
            extension: extension,
            getBridgeContext: getBridgeContext,
            legacyCustomBridgeMethods: legacyCustomBridgeMethods,
            customBridge: customBridge
        };
        $[32] = customBridge;
        $[33] = extension;
        $[34] = getBridgeContext;
        $[35] = legacyCustomBridgeMethods;
        $[36] = t7;
    } else t7 = $[36];
    (0, $hUsLn.useEmbeddedMacroConnection)(t7);
    const sendHandshakeMetric = $d57816887e77fd9b$var$useSendHandshakeMetric(extension);
    const [loadVersion, setLoadVersion] = (0, $42omo.useState)(null);
    let t8;
    if ($[37] !== cleanupBridge || $[38] !== getBridgeFeatures || $[39] !== loadVersion || $[40] !== onLoad || $[41] !== sendHandshakeMetric || $[42] !== setBridgeControl || $[43] !== src || $[44] !== surfaceColor || $[45] !== theme) {
        t8 = {
            iframeRef: localIframeRef,
            loadVersion: loadVersion,
            src: src,
            theme: theme,
            surfaceColor: surfaceColor,
            getBridgeFeatures: getBridgeFeatures,
            cleanupBridge: cleanupBridge,
            onLoad: onLoad,
            setBridgeControl: setBridgeControl,
            sendHandshakeMetric: sendHandshakeMetric
        };
        $[37] = cleanupBridge;
        $[38] = getBridgeFeatures;
        $[39] = loadVersion;
        $[40] = onLoad;
        $[41] = sendHandshakeMetric;
        $[42] = setBridgeControl;
        $[43] = src;
        $[44] = surfaceColor;
        $[45] = theme;
        $[46] = t8;
    } else t8 = $[46];
    const { isBridgeReady: isBridgeReady } = $d57816887e77fd9b$var$useIframeBridgeConnection(t8);
    let t10;
    let t9;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            setLoadVersion($d57816887e77fd9b$var$_temp);
        };
        t10 = [];
        $[47] = t10;
        $[48] = t9;
    } else {
        t10 = $[47];
        t9 = $[48];
    }
    const handleIframeLoad = (0, $hQK66.useCallbackOne)(t9, t10);
    const loading = !isBridgeReady;
    let t11;
    if ($[49] !== extension.properties.layout || $[50] !== extension.type || $[51] !== height || $[52] !== isInModal || $[53] !== isResizable || $[54] !== loadVersion) {
        t11 = {
            iframeRef: localIframeRef,
            loadVersion: loadVersion,
            isResizable: isResizable,
            height: height,
            isInModal: isInModal,
            layout: extension.properties.layout,
            type: extension.type
        };
        $[49] = extension.properties.layout;
        $[50] = extension.type;
        $[51] = height;
        $[52] = isInModal;
        $[53] = isResizable;
        $[54] = loadVersion;
        $[55] = t11;
    } else t11 = $[55];
    $d57816887e77fd9b$var$useIframeResizer(t11);
    let t12;
    let t13;
    if ($[56] !== loading || $[57] !== setIsLoading) {
        t12 = ()=>{
            setIsLoading?.(loading);
        };
        t13 = [
            loading,
            setIsLoading
        ];
        $[56] = loading;
        $[57] = setIsLoading;
        $[58] = t12;
        $[59] = t13;
    } else {
        t12 = $[58];
        t13 = $[59];
    }
    (0, $42omo.useEffect)(t12, t13);
    let t14;
    if ($[60] !== extension.egress) {
        t14 = $d57816887e77fd9b$var$getSandboxAttribute(extension.egress);
        $[60] = extension.egress;
        $[61] = t14;
    } else t14 = $[61];
    const sandbox = t14;
    const t15 = isResizable || isInlineActive ? undefined : height;
    let t16;
    if ($[62] !== t15 || $[63] !== width) {
        t16 = {
            height: t15,
            width: width
        };
        $[62] = t15;
        $[63] = width;
        $[64] = t16;
    } else t16 = $[64];
    let t17;
    if ($[65] !== isHidden || $[66] !== isInlineActive || $[67] !== loading || $[68] !== loadingComponent) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d57816887e77fd9b$var$IframeLoadingOverlay, {
            loading: loading,
            isInlineActive: isInlineActive,
            isHidden: isHidden,
            loadingComponent: loadingComponent
        });
        $[65] = isHidden;
        $[66] = isInlineActive;
        $[67] = loading;
        $[68] = loadingComponent;
        $[69] = t17;
    } else t17 = $[69];
    let t18;
    if ($[70] !== handleIframeLoad || $[71] !== iframeRef || $[72] !== iframeTitle || $[73] !== isHidden || $[74] !== isInModal || $[75] !== isInlineActive || $[76] !== isResizable || $[77] !== loading || $[78] !== sandbox || $[79] !== src || $[80] !== userConsentRequired) {
        t18 = !userConsentRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
            "data-testid": "hosted-resources-iframe",
            "data-forge-iframe": true,
            sandbox: sandbox,
            allow: $d57816887e77fd9b$var$FRAME_PERMISSIONS_POLICY,
            src: src,
            ref: iframeRef,
            onLoad: handleIframeLoad,
            title: iframeTitle,
            className: (0, $gMc0m.default)([
                "_19itglyw _1e0c1ule _1bsb1osq",
                isInModal && "_2rkofajl _4t3i1osq",
                !isResizable && "_4t3i1osq",
                (loading || isInlineActive || isHidden) && "_1reo15vq _18m915vq _3um015vq _4t3iidpf"
            ])
        });
        $[70] = handleIframeLoad;
        $[71] = iframeRef;
        $[72] = iframeTitle;
        $[73] = isHidden;
        $[74] = isInModal;
        $[75] = isInlineActive;
        $[76] = isResizable;
        $[77] = loading;
        $[78] = sandbox;
        $[79] = src;
        $[80] = userConsentRequired;
        $[81] = t18;
    } else t18 = $[81];
    let t19;
    if ($[82] !== overlay || $[83] !== t16 || $[84] !== t17 || $[85] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d57816887e77fd9b$var$styles.box,
            style: t16
        }, t17, overlay, t18);
        $[82] = overlay;
        $[83] = t16;
        $[84] = t17;
        $[85] = t18;
        $[86] = t19;
    } else t19 = $[86];
    return t19;
} : ({ accountId: accountId, appId: appId, bridge: bridge, customBridgeMethods: legacyCustomBridgeMethods, customBridge: customBridge, components: components, contextIds: contextIds, coreData: coreData, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, height: height = '100%', isHidden: isHidden, isInModal: isInModal, isResizable: isResizable, loadingComponent: loadingComponent, locale: locale, onError: onError, onLoad: onLoad, src: src, setIsLoading: setIsLoading, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, surfaceColor: surfaceColor, theme: theme, timezone: timezone, width: width = '100%', contextChangeListeners: contextChangeListeners }, parentIframeRef)=>{
    const { overlay: overlay, overlayController: overlayController, isInlineActive: isInlineActive } = (0, $jIrI4.useRuntimeOverlayController)(); // Shared presenter: shows a Forge app error in the overlay + suppresses the host
    // renderer (UIKit) + provides i18n. Exposed as the `showAppError` bridge service
    // for the withErrorDisplay middleware to call on classified bridge errors.
    const showAppError = (0, $45XLP.useRuntimeErrorOverlay)({
        overlayController: overlayController,
        extension: extension,
        setShouldShowRenderer: setShouldShowRenderer,
        onError: onError
    });
    const { userConsentRequired: userConsentRequired, renderThreeLOPrompt: renderThreeLOPrompt } = (0, $8012d.useInitialAppState)({
        extension: extension,
        appId: appId,
        accountId: accountId,
        components: components,
        onLoad: onLoad,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        overlayController: overlayController
    });
    const { getBridgeFeatures: getBridgeFeatures, getBridgeContext: getBridgeContext, destroy: cleanupBridge, setBridgeControl: setBridgeControl } = $d57816887e77fd9b$var$useBridgeFeatures({
        accountId: accountId,
        appId: appId,
        bridge: bridge,
        contextIds: contextIds,
        coreData: coreData,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        locale: locale,
        surfaceColor: surfaceColor,
        theme: theme,
        timezone: timezone,
        contextChangeListeners: contextChangeListeners
    }, overlayController, renderThreeLOPrompt, showAppError, legacyCustomBridgeMethods, customBridge);
    const localIframeRef = (0, $42omo.useRef)(null);
    const iframeRef = (0, $iP9n7.useMergeRefs)([
        parentIframeRef,
        localIframeRef
    ]);
    const iframeTitle = $d57816887e77fd9b$var$useIframeTitle(extension.properties.frameId, appId);
    (0, $hUsLn.useEmbeddedMacroConnection)({
        extension: extension,
        getBridgeContext: getBridgeContext,
        legacyCustomBridgeMethods: legacyCustomBridgeMethods,
        customBridge: customBridge
    });
    const sendHandshakeMetric = $d57816887e77fd9b$var$useSendHandshakeMetric(extension); // `null` until the iframe fires its first `load` event; incremented on each subsequent
    // reload (e.g. tunnel-mode hot-reload). Both useIframeBridgeConnection and useIframeResizer
    // depend on it so they automatically re-run their setup+cleanup cycle on every reload.
    const [loadVersion, setLoadVersion] = (0, $42omo.useState)(null);
    const { isBridgeReady: isBridgeReady } = $d57816887e77fd9b$var$useIframeBridgeConnection({
        iframeRef: localIframeRef,
        loadVersion: loadVersion,
        src: src,
        theme: theme,
        surfaceColor: surfaceColor,
        getBridgeFeatures: getBridgeFeatures,
        cleanupBridge: cleanupBridge,
        onLoad: onLoad,
        setBridgeControl: setBridgeControl,
        sendHandshakeMetric: sendHandshakeMetric
    });
    const handleIframeLoad = (0, $hQK66.useCallbackOne)(()=>{
        setLoadVersion((v)=>(v ?? 0) + 1);
    }, []);
    const loading = !isBridgeReady;
    $d57816887e77fd9b$var$useIframeResizer({
        iframeRef: localIframeRef,
        loadVersion: loadVersion,
        isResizable: isResizable,
        height: height,
        isInModal: isInModal,
        layout: extension.properties.layout,
        type: extension.type
    });
    (0, $42omo.useEffect)(()=>{
        setIsLoading?.(loading);
    }, [
        loading,
        setIsLoading
    ]);
    const sandbox = $d57816887e77fd9b$var$getSandboxAttribute(extension.egress);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d57816887e77fd9b$var$styles.box,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: isResizable || isInlineActive ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d57816887e77fd9b$var$IframeLoadingOverlay, {
        loading: loading,
        isInlineActive: isInlineActive,
        isHidden: isHidden,
        loadingComponent: loadingComponent
    }), overlay, !userConsentRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        "data-testid": "hosted-resources-iframe",
        "data-forge-iframe": true,
        sandbox: sandbox,
        allow: $d57816887e77fd9b$var$FRAME_PERMISSIONS_POLICY,
        src: src,
        ref: iframeRef,
        onLoad: handleIframeLoad,
        title: iframeTitle,
        className: (0, $gMc0m.default)([
            "_19itglyw _1e0c1ule _1bsb1osq",
            isInModal && "_2rkofajl _4t3i1osq",
            !isResizable && "_4t3i1osq",
            (loading || isInlineActive || isHidden) && "_1reo15vq _18m915vq _3um015vq _4t3iidpf"
        ])
    }));
});
const $d57816887e77fd9b$var$IframeLoadingOverlay = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { loading: loading, isInlineActive: isInlineActive, isHidden: isHidden, loadingComponent: loadingComponent } = t0;
    if (!loading || isInlineActive || isHidden) return null;
    let t1;
    if ($[0] !== loadingComponent) {
        t1 = (0, $bn0yX.getLoadingComponent)(loadingComponent);
        $[0] = loadingComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d57816887e77fd9b$var$styles.loadingOverlay
        }, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ loading: loading, isInlineActive: isInlineActive, isHidden: isHidden, loadingComponent: loadingComponent })=>{
    if (!loading || isInlineActive || isHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d57816887e77fd9b$var$styles.loadingOverlay
    }, (0, $bn0yX.getLoadingComponent)(loadingComponent));
};
const $d57816887e77fd9b$var$useIframeTitle = (frameId, appId)=>{
    const idRef = (0, $42omo.useRef)(null);
    if (idRef.current === null) idRef.current = crypto.randomUUID();
    return `Iframe ${frameId ?? idRef.current} from ${appId}`;
};
const $d57816887e77fd9b$var$useIframeBridgeConnection = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { iframeRef: iframeRef, loadVersion: loadVersion, src: src, theme: theme, surfaceColor: surfaceColor, getBridgeFeatures: getBridgeFeatures, cleanupBridge: cleanupBridge, onLoad: onLoad, setBridgeControl: setBridgeControl, sendHandshakeMetric: sendHandshakeMetric } = t0;
    const [isBridgeReady, setIsBridgeReady] = (0, $42omo.useState)(false);
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    let t1;
    if ($[0] !== getBridgeFeatures || $[1] !== iframeRef || $[2] !== loadVersion || $[3] !== onLoad || $[4] !== sendHandshakeMetric || $[5] !== setBridgeControl || $[6] !== src || $[7] !== surfaceColor || $[8] !== theme || $[9] !== trackExtensionRemounted) {
        t1 = ()=>{
            if (loadVersion === null) return;
            setIsBridgeReady(false);
            const contentWindow = iframeRef.current?.contentWindow;
            if (!contentWindow) return;
            let cancelled = false;
            (0, $4GQnE.createIframeBridge)({
                withWindow: contentWindow,
                withDomain: new URL(src).origin,
                features: getBridgeFeatures(),
                theme: theme,
                surfaceColor: surfaceColor,
                sendHandshakeMetric: sendHandshakeMetric
            }).open().then((controls)=>{
                if (cancelled) {
                    controls.close();
                    return;
                }
                setBridgeControl(controls);
                setIsBridgeReady(true);
                onLoad?.();
                if (loadVersion > 1 && !(0, $4jZsH.isTunnelSrc)(src)) trackExtensionRemounted({
                    mountCount: loadVersion
                });
            }).catch($d57816887e77fd9b$var$_temp2);
            return ()=>{
                cancelled = true;
            };
        };
        $[0] = getBridgeFeatures;
        $[1] = iframeRef;
        $[2] = loadVersion;
        $[3] = onLoad;
        $[4] = sendHandshakeMetric;
        $[5] = setBridgeControl;
        $[6] = src;
        $[7] = surfaceColor;
        $[8] = theme;
        $[9] = trackExtensionRemounted;
        $[10] = t1;
    } else t1 = $[10];
    let t2;
    if ($[11] !== loadVersion) {
        t2 = [
            loadVersion
        ];
        $[11] = loadVersion;
        $[12] = t2;
    } else t2 = $[12];
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[13] !== cleanupBridge) {
        t3 = ()=>cleanupBridge;
        t4 = [
            cleanupBridge
        ];
        $[13] = cleanupBridge;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[16] !== isBridgeReady) {
        t5 = {
            isBridgeReady: isBridgeReady
        };
        $[16] = isBridgeReady;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ iframeRef: iframeRef, loadVersion: loadVersion, src: src, theme: theme, surfaceColor: surfaceColor, getBridgeFeatures: getBridgeFeatures, cleanupBridge: cleanupBridge, onLoad: onLoad, setBridgeControl: setBridgeControl, sendHandshakeMetric: sendHandshakeMetric })=>{
    const [isBridgeReady, setIsBridgeReady] = (0, $42omo.useState)(false);
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)(); // Keyed solely on loadVersion: other inputs are stable after mount, and theme/surfaceColor
    // changes flow through useBridgeFeatures' onChange listener (which calls controls.setTheme
    // on the live connection) rather than re-triggering the handshake.
    (0, $42omo.useEffect)(()=>{
        if (loadVersion === null) return;
        setIsBridgeReady(false);
        const contentWindow = iframeRef.current?.contentWindow;
        if (!contentWindow) return;
        let cancelled = false;
        (0, $4GQnE.createIframeBridge)({
            withWindow: contentWindow,
            withDomain: new URL(src).origin,
            features: getBridgeFeatures(),
            theme: theme,
            surfaceColor: surfaceColor,
            sendHandshakeMetric: sendHandshakeMetric
        }).open().then((controls)=>{
            if (cancelled) {
                // Discard the resolved controls — effect was torn down (reload or unmount).
                controls.close();
                return;
            }
            setBridgeControl(controls);
            setIsBridgeReady(true);
            onLoad?.(); // Tunnel hot-reloads are expected dev-loop noise; only track reloads in non-tunnel src.
            if (loadVersion > 1 && !(0, $4jZsH.isTunnelSrc)(src)) trackExtensionRemounted({
                mountCount: loadVersion
            });
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Failed to open iframe bridge', err);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        loadVersion
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Full teardown on unmount: BridgeContextObject.destroy() closes any live connection.
    // Effect body is intentionally empty — `cleanupBridge` is returned as the cleanup function,
    // invoked by React on unmount (and when `cleanupBridge` changes, which it shouldn't in practice).
    (0, $42omo.useEffect)(()=>cleanupBridge, [
        cleanupBridge
    ]);
    return {
        isBridgeReady: isBridgeReady
    };
};
const $d57816887e77fd9b$var$useIframeResizer = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { iframeRef: iframeRef, loadVersion: loadVersion, isResizable: isResizable, height: height, isInModal: isInModal, layout: layout, type: type } = t0;
    let t1;
    if ($[0] !== height || $[1] !== iframeRef || $[2] !== isInModal || $[3] !== isResizable || $[4] !== layout || $[5] !== loadVersion || $[6] !== type) {
        t1 = ()=>{
            if (!isResizable || loadVersion === null) return;
            const iframeEl = iframeRef.current;
            if (!iframeEl) return;
            const isInNonJSMResizableModal = isInModal && !type?.startsWith("jiraServiceManagement");
            const isInInlineMacro = layout === "inline" && type === $d57816887e77fd9b$var$MACRO_MODULE_NAME;
            const sizeWidth = (0, $dh538.fg)("forge-ui-enable-resizable-custom-ui-modal") ? isInNonJSMResizableModal || isInInlineMacro : isInInlineMacro;
            (0, $9zb43.iframeResizer)({
                heightCalculationMethod: "bodyScroll",
                widthCalculationMethod: "bodyScroll",
                scrolling: true,
                minHeight: height,
                sizeWidth: sizeWidth,
                initCallback: $d57816887e77fd9b$var$_temp3
            }, iframeEl);
            return ()=>{
                iframeEl?.iFrameResizer?.removeListeners();
            };
        };
        $[0] = height;
        $[1] = iframeRef;
        $[2] = isInModal;
        $[3] = isResizable;
        $[4] = layout;
        $[5] = loadVersion;
        $[6] = type;
        $[7] = t1;
    } else t1 = $[7];
    let t2;
    if ($[8] !== isResizable || $[9] !== loadVersion) {
        t2 = [
            loadVersion,
            isResizable
        ];
        $[8] = isResizable;
        $[9] = loadVersion;
        $[10] = t2;
    } else t2 = $[10];
    (0, $42omo.useEffect)(t1, t2);
} : ({ iframeRef: iframeRef, loadVersion: loadVersion, isResizable: isResizable, height: height, isInModal: isInModal, layout: layout, type: type })=>{
    // Deps are intentionally narrowed to [loadVersion, isResizable]. `height`, `isInModal`,
    // `layout`, and `type` are captured by closure from whichever render last fired a `load`
    // event, matching v1's "init once per load with the values current at that moment" behaviour.
    // `iframeRef` is a stable ref object and never triggers re-runs.
    //
    // Latent assumption: this hook does NOT react to mid-lifecycle changes of those values. They
    // configure `minHeight` and `sizeWidth` at init time and the library has no runtime API to
    // update them on a live instance. In current usage they are effectively static after mount
    // (layout/type/isInModal come from extension + host chrome; height is parent-supplied). If a
    // product ever mutates them at runtime while `isResizable=true`, re-init on change or replace
    // the library with one that supports in-place updates.
    (0, $42omo.useEffect)(()=>{
        if (!isResizable || loadVersion === null) return;
        const iframeEl = iframeRef.current;
        if (!iframeEl) return;
         // JSM modals are always height resizable, but not width resizable.
        // TODO: Can remove this once aligned with JSM on width resizing
        const isInNonJSMResizableModal = isInModal && !type?.startsWith('jiraServiceManagement');
        const isInInlineMacro = layout === 'inline' && type === $d57816887e77fd9b$var$MACRO_MODULE_NAME;
        const sizeWidth = (0, $dh538.fg)('forge-ui-enable-resizable-custom-ui-modal') ? isInNonJSMResizableModal || isInInlineMacro : isInInlineMacro;
        (0, $9zb43.iframeResizer)({
            heightCalculationMethod: 'bodyScroll',
            widthCalculationMethod: 'bodyScroll',
            scrolling: true,
            // @ts-expect-error minHeight accepts a CSS string at runtime but the TS type only allows number
            minHeight: height,
            sizeWidth: sizeWidth,
            initCallback: (iframe)=>{
                iframe?.iFrameResizer?.resize();
            }
        }, iframeEl);
        return ()=>{
            iframeEl?.iFrameResizer?.removeListeners();
        };
    }, [
        loadVersion,
        isResizable
    ]); // eslint-disable-line react-hooks/exhaustive-deps
};
const $d57816887e77fd9b$var$useSendHandshakeMetric = (extension)=>{
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const tracing = (0, $kaOT1.useTracingContext)();
    const { trackHandShakeMetric: trackHandShakeMetric } = (0, $6oQb1.useForgeUiAnalyticsEvent)(); // Keep a ref so the callback always reads the latest extension without needing
    // it as a dependency — avoids recreating the callback on every render when the
    // extension object reference changes but its identity (id, type, etc.) has not.
    const extensionRef = (0, $42omo.useRef)(extension);
    extensionRef.current = extension;
    return (0, $hQK66.useCallbackOne)((success, error)=>{
        trackHandShakeMetric({
            source: page,
            success: success,
            error: error
        });
        if (error) {
            const { id: id, type: type, environmentType: environmentType, appOwner: appOwner, properties: properties } = extensionRef.current;
            const handshakeError = error instanceof Error ? new Error(`Bridge handshake error: ${error.message}`) : new Error('Unknown bridge handshake error');
            (0, $7KMPr.captureAndReportError)({
                error: handshakeError,
                environment: environment,
                errorExtensionDetails: {
                    id: id,
                    type: type,
                    environmentType: environmentType,
                    appOwnerAccountId: appOwner?.accountId,
                    properties: properties
                },
                page: page,
                runtime: 'iframev2',
                tracing: tracing
            });
        }
    }, [
        page,
        environment,
        tracing,
        trackHandShakeMetric
    ]);
};
const $d57816887e77fd9b$var$useBridgeFeatures = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props, overlayController, renderThreeLOPrompt, showAppError, legacyCustomBridgeMethods, customBridge)=>{
    const $ = (0, $frIzR.c)(14);
    const legacyCustomBridgeMethodsRef = (0, $42omo.useRef)(legacyCustomBridgeMethods);
    const customBridgeRef = (0, $42omo.useRef)(customBridge);
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { getServices: getServices } = (0, $1qkDW.useBridgeServices)(props, overlayController, renderThreeLOPrompt, showAppError);
    let t0;
    if ($[0] !== environment || $[1] !== page || $[2] !== props) {
        t0 = {
            ...props,
            environment: environment,
            page: page,
            runtime: "iframev2"
        };
        $[0] = environment;
        $[1] = page;
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    const { getBridgeContext: getBridgeContext, destroy: destroy, onChange: onChange, setBridgeControl: setBridgeControl } = (0, $i7d45.useBridgeContext)(t0, getServices, props.contextChangeListeners);
    let t1;
    let t2;
    if ($[4] !== onChange) {
        t1 = ()=>onChange($d57816887e77fd9b$var$_temp4);
        t2 = [
            onChange
        ];
        $[4] = onChange;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[7] !== getBridgeContext) {
        t3 = ()=>(0, $lwhTs.createBridgeFeatures)(getBridgeContext, (baseBridgeMethods)=>(0, $4k05I.consolidateCustomBridge)(baseBridgeMethods, legacyCustomBridgeMethodsRef.current, customBridgeRef.current));
        $[7] = getBridgeContext;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== destroy || $[10] !== getBridgeContext || $[11] !== setBridgeControl || $[12] !== t3) {
        t4 = {
            destroy: destroy,
            getBridgeContext: getBridgeContext,
            getBridgeFeatures: t3,
            setBridgeControl: setBridgeControl
        };
        $[9] = destroy;
        $[10] = getBridgeContext;
        $[11] = setBridgeControl;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : (props, overlayController, renderThreeLOPrompt, showAppError, legacyCustomBridgeMethods, customBridge)=>{
    // Captured once at mount — custom bridge methods are not supported to change after initial render.
    const legacyCustomBridgeMethodsRef = (0, $42omo.useRef)(legacyCustomBridgeMethods);
    const customBridgeRef = (0, $42omo.useRef)(customBridge);
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { page: page } = (0, $5U2YR.useMetricsContext)(); // Assembles host-side capabilities (invoker, fetch client, tracing, etc.) for bridge methods.
    // Returns a getter rather than a snapshot so services are always current at call time.
    const { getServices: getServices } = (0, $1qkDW.useBridgeServices)(props, overlayController, renderThreeLOPrompt, showAppError); // [Important] getBridgeContext is stable and does not change across the lifecycle of the component,
    // so it is safe to include it in the dependency array of createBridgeFeatures without causing
    // unnecessary re-renders or re-creations of the bridge features.
    const { getBridgeContext: getBridgeContext, destroy: destroy, onChange: onChange, setBridgeControl: setBridgeControl } = (0, $i7d45.useBridgeContext)({
        ...props,
        environment: environment,
        page: page,
        runtime: 'iframev2'
    }, getServices, props.contextChangeListeners); // Registered once — `onChange` is stable and `destroy()` clears the listener on unmount.
    (0, $42omo.useEffect)(()=>{
        return onChange((_prev, next, changes, getContext)=>{
            // Push theme/surfaceColor changes to the open bridge connection whenever they change.
            // Custom UI only — we only do this for iframe based runtime, as this is only
            // relevant for Custom UI app, as the Custom UI app will need to update the theme style assets.
            if (changes.theme || changes.surfaceColor) getContext().bridgeControls?.setTheme(next.theme ?? null, next.surfaceColor ?? null, next.environment);
        });
    }, [
        onChange
    ]);
    return {
        destroy: destroy,
        getBridgeContext: getBridgeContext,
        getBridgeFeatures: ()=>(0, $lwhTs.createBridgeFeatures)(getBridgeContext, (baseBridgeMethods)=>(0, $4k05I.consolidateCustomBridge)(baseBridgeMethods, legacyCustomBridgeMethodsRef.current, customBridgeRef.current)),
        setBridgeControl: setBridgeControl
    };
};
function $d57816887e77fd9b$var$_temp(v) {
    return (v ?? 0) + 1;
}
function $d57816887e77fd9b$var$_temp2(err) {
    console.error("Failed to open iframe bridge", err);
}
function $d57816887e77fd9b$var$_temp3(iframe) {
    iframe?.iFrameResizer?.resize();
}
function $d57816887e77fd9b$var$_temp4(_prev, next, changes, getContext) {
    if (changes.theme || changes.surfaceColor) getContext().bridgeControls?.setTheme(next.theme ?? null, next.surfaceColor ?? null, next.environment);
}
module.exports["InnerIframe"] = $d57816887e77fd9b$export$3c4d31cb85fd39c5;

});

parcelRegister("fDyI6", function(module, exports) {

var $egaak = parcelRequire("egaak");


var $b2rVn = parcelRequire("b2rVn");


var $iFTSh = parcelRequire("iFTSh");


var $2LhtV = parcelRequire("2LhtV");


var $72NYl = parcelRequire("72NYl");


var $dOXc2 = parcelRequire("dOXc2");


var $4RbK9 = parcelRequire("4RbK9");


var $4ihhW = parcelRequire("4ihhW");


var $dhw6T = parcelRequire("dhw6T");


var $bITJ8 = parcelRequire("bITJ8");


var $7GGkx = parcelRequire("7GGkx");


var $kl7WN = parcelRequire("kl7WN");


var $bBmTt = parcelRequire("bBmTt");


var $9xeXg = parcelRequire("9xeXg");


var $ibJMJ = parcelRequire("ibJMJ");

const $328c065070943708$export$d0f4e0785e15fc49 = {
    ...(0, $72NYl.bridgeConfigDelegates),
    getContext: // Core methods
    $egaak.getContext,
    invoke: $egaak.invoke,
    getFrameId: $egaak.getFrameId,
    reload: $egaak.reload,
    fetchProduct: // Fetch methods
    $dOXc2.fetchProduct,
    fetchRemote: $4RbK9.fetchRemote,
    enableTheming: // Theming methods
    $4ihhW.enableTheming,
    on: // Event methods
    $dhw6T.on,
    emit: $dhw6T.emit,
    onPublic: // Public event methods
    $bITJ8.onPublic,
    emitPublic: $bITJ8.emitPublic,
    subscribeRealtimeChannel: // Realtime methods
    $7GGkx.subscribeRealtimeChannel,
    publishRealtimeChannel: $7GGkx.publishRealtimeChannel,
    getUrl: // Navigation methods
    $kl7WN.getUrl,
    navigate: $kl7WN.navigate,
    createHistory: // History methods
    $bBmTt.createHistory,
    initFeatureFlags: // Feature flag methods
    $b2rVn.initFeatureFlags,
    trackFeatureFlagEvent: $b2rVn.trackFeatureFlagEvent,
    emitFrontendCustomMetric: // Frontend custom metrics
    $iFTSh.emitFrontendCustomMetric,
    // Telemetry methods
    'iframe-analytics': (0, $2LhtV.iframeAnalytics),
    trackObjectStoreAction: $2LhtV.trackObjectStoreAction,
    'ufo-event': (0, $2LhtV.ufoEvent),
    isRovoEnabled: // Rovo methods
    $9xeXg.isRovoEnabled,
    openRovo: $9xeXg.openRovo,
    // Permission methods
    ...(0, $ibJMJ.permissionBridgeMethods)
};
module.exports["bridgeMethods"] = $328c065070943708$export$d0f4e0785e15fc49;

});

parcelRegister("aGJob", function(module, exports) {

var $7KMPr = parcelRequire("7KMPr");


var $kxKUs = parcelRequire("kxKUs");


var $dWSaf = parcelRequire("dWSaf");


var $fSMLG = parcelRequire("fSMLG");


var $ly9ul = parcelRequire("ly9ul");

const $fd3c13cdbd639d0c$export$14e56d7f5d3f917c = (method, methodName)=>async (context, payload)=>{
        const { services: { analytics: analytics, tracing: tracing }, extension: extension, environment: environment, page: page, runtime: runtime } = context;
        const forgeEnvironment = extension.environmentType;
        try {
            tracing.recordBridgeCall(`${methodName}() - start`);
            // invoke the original implementation
            const result = await method(context, payload);
            tracing.recordBridgeCall(`${methodName}() - end`);
            analytics.tracker.trackBridgeSucceed({
                method: methodName,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: (0, $dWSaf.prepareBridgeEventAttributes)(methodName, {
                    data: payload
                }, true)
            });
            return result;
        } catch (err) {
            const error = err instanceof Error ? err : new Error(`Unknown Custom UI Bridge error: ${typeof err}`);
            if (!(error instanceof (0, $kxKUs.BridgeClientError))) {
                if (!(0, $fSMLG.blocklistedErrorMessagePatterns).some((pattern)=>pattern.test(error.message))) {
                    analytics.tracker.trackBridgeFailed({
                        method: methodName,
                        errorName: error.name,
                        forgeEnvironment: forgeEnvironment,
                        additionalAttributes: {
                            ...(0, $dWSaf.prepareBridgeEventAttributes)(methodName, {
                                data: payload
                            }, false),
                            reason: error.message,
                            isUnrecoverable: (0, $ly9ul.isUnrecoverableError)(error)
                        }
                    });
                    (0, $7KMPr.captureAndReportError)({
                        error: error,
                        environment: environment,
                        errorExtensionDetails: {
                            id: extension.id,
                            type: extension.type,
                            environmentType: extension.environmentType,
                            properties: extension.properties,
                            appOwnerAccountId: extension.appOwner?.accountId
                        },
                        page: page,
                        runtime: runtime,
                        tracing: tracing
                    });
                }
            }
            throw err;
        }
    };
module.exports["withMetrics"] = $fd3c13cdbd639d0c$export$14e56d7f5d3f917c;

});

parcelRegister("5Pxyc", function(module, exports) {

var $ib6QY = parcelRequire("ib6QY");


var $80yqV = parcelRequire("80yqV");

const $9803d209b62f18c4$export$e628d863fc52abdc = (method, methodName)=>async (context, payload)=>{
        try {
            return await method(context, payload);
        } catch (err) {
            if (err instanceof (0, $ib6QY.ForgeAppError) && (0, $80yqV.shouldRenderForgeAppErrorMessage)(err.errorType)) context.services.showAppError(err);
            throw err;
        }
    };
module.exports["withErrorDisplay"] = $9803d209b62f18c4$export$e628d863fc52abdc;

});

parcelRegister("hYe60", function(module, exports) {

var $LiNdD = parcelRequire("LiNdD");

var $hcbSV = parcelRequire("hcbSV");

var $ge8sG = parcelRequire("ge8sG");

var $UZU5S = parcelRequire("UZU5S");


var $ijfiP = parcelRequire("ijfiP");


var $luNHV = parcelRequire("luNHV");


var $bjfFJ = parcelRequire("bjfFJ");


var $7ZDjd = parcelRequire("7ZDjd");

/**
 * A single lazily-computed slot. Call `get(factory)` to read (computing on first access),
 * and `invalidate()` to clear so the next `get()` recomputes.
 *
 * Note: `T` must not be `null` — `null` is used as the uncomputed sentinel.
 */ class $368eadf79cf92bf5$var$LazyCell {
    get(compute) {
        if (this.value === null) this.value = compute();
        return this.value;
    }
    invalidate() {
        this.value = null;
    }
    constructor(){
        this.value = null;
    }
}
/**
 * Unified registry for per-instance bridge resources.
 * Each resource defines its own create and destroy lifecycle.
 * BridgeContextObject.destroy() calls destroy(state) for every claimed resource.
 */ class $368eadf79cf92bf5$var$BridgeResourceRegistry {
    destroy() {
        for (const { resource: resource, state: state } of this.entries.values())resource.destroy(state);
        this.entries.clear();
    }
    constructor(){
        this.entries = new Map();
        this.claimBridgeResource = (resource)=>{
            if (this.entries.has(resource.id)) return this.entries.get(resource.id).state;
            const state = resource.create();
            this.entries.set(resource.id, {
                resource: resource,
                state: state
            });
            return state;
        };
    }
}
class $368eadf79cf92bf5$export$692584c74926c9b3 {
    /**
   * Registers the live bridge-core v2 connection.
   *
   * Called once on initial load and again on each iframe reload (e.g. tunnel mode hot-reload).
   * On reload, the previous connection is closed before the new one is stored, so the old
   * bridge-core channel is torn down without destroying the bridge context or resource registry.
   */ setBridgeControl(controls) {
        if (this.bridgeControls !== null) {
            // eslint-disable-next-line no-console
            console.debug('close and refresh existing bridge control');
            this.bridgeControls.close();
        }
        this.bridgeControls = controls;
    }
    /**
   * Tears down all resources owned by this object. Should be called on component
   * unmount to prevent memory leaks.
   */ destroy() {
        // Close the connection before destroying resources — prevents new bridge calls arriving after teardown.
        this.bridgeControls?.close();
        this.bridgeControls = null;
        this.resourceRegistry.destroy();
        this.changeListeners.clear();
    }
    /**
   * Registers a listener that is called whenever one or more props change.
   * The listener receives the previous props, the new props, and a lazy `getContext()`
   * accessor — call it only if you need the context, as it allocates on first call.
   * Returns an unsubscribe function — call it to stop receiving notifications.
   *
   * Listeners only fire when something actually changed (`changes.__all__` is true).
   * They are cleared automatically on `destroy()`.
   */ onChange(listener) {
        this.changeListeners.add(listener);
        return ()=>this.changeListeners.delete(listener);
    }
    /**
   * Diffs incoming props against stored props, clears the cache, and emits
   * change events for updated BridgeContext fields.
   *
   * Must be called inside useEffect (not during render) because it emits DOM events.
   */ update(nextProps) {
        const prevProps = this.props;
        const changes = (0, $7ZDjd.computeBridgeContextChanges)(prevProps, nextProps);
        this.props = nextProps;
        if (changes.__all__) {
            // Brief always-on log; deep diff opt-in via DEBUG_ENABLED in BridgeContextDebug.ts.
            (0, $bjfFJ.logBridgeContextChange)(prevProps, nextProps, changes);
            this.resolverContextCell.invalidate();
            this.viewContextCell.invalidate();
            this.extensionDetailsCell.invalidate();
            // Lazy: computed at most once, only if a listener actually reads it.
            let contextCache;
            // note, ??= is currently not supported in our build environment, hence will need to be rewritten when we upgrade to a newer TypeScript version
            const getContext = ()=>contextCache !== undefined ? contextCache : contextCache = this.get();
            for (const listener of this.changeListeners)listener(prevProps, nextProps, changes, getContext);
        }
    }
    /**
   * Returns the current BridgeContext.
   *
   * Fields that involve non-trivial work are getter properties — deferred until
   * the bridge method actually reads them.
   *
   * Pass-through fields are direct values, since reading a prop is O(1).
   */ get() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        return {
            // Deferred — resolved only when the bridge method accesses the field.
            get resolverContext () {
                return self.resolverContext;
            },
            get viewContext () {
                return self.viewContext;
            },
            get extensionDetails () {
                return self.extensionDetails;
            },
            get services () {
                return self.getServices();
            },
            // Immediate — direct prop reads, no benefit to deferring.
            bridgeConfig: this.props.bridge ?? {},
            bridgeControls: this.bridgeControls,
            claimBridgeResource: this.resourceRegistry.claimBridgeResource,
            contextIds: this.props.contextIds,
            environment: this.props.environment,
            page: this.props.page,
            runtime: this.props.runtime,
            extension: this.props.extension,
            extensionPayload: this.props.extensionPayload,
            // Exposed on context rather than via services to give change listeners
            // a scoped emit without needing to import the events module directly.
            emit: (event, payload)=>(0, $luNHV.emit)(event, payload, self.extensionDetails)
        };
    }
    get resolverContext() {
        return this.resolverContextCell.get(()=>(0, $ge8sG.getResolverContext)({
                ...this.props.coreData,
                appVersion: this.props.extension.appVersion
            }, this.props.extensionData));
    }
    get extensionDetails() {
        return this.extensionDetailsCell.get(()=>{
            const { extension: extension } = this.props;
            return {
                appId: extension.appId ?? (0, $ijfiP.parseExtensionId)(extension.id).appId,
                id: extension.id.split('/').slice(0, 3).join('/'),
                installationId: extension.installationId
            };
        });
    }
    get viewContext() {
        return this.viewContextCell.get(()=>this.buildViewContext(this.props, this.resolverContext));
    }
    buildViewContext(props, resolverContext) {
        return (0, $UZU5S.getViewContext)({
            resolverContext: resolverContext,
            accountId: props.accountId,
            extension: props.extension,
            timezone: props.timezone ?? (0, $hcbSV.getBrowserTimezone)(),
            locale: props.locale ?? (0, $LiNdD.getBrowserLocale)(),
            extensionPayload: props.extensionPayload,
            extensionViewData: props.extensionViewData,
            theme: props.theme,
            surfaceColor: props.surfaceColor,
            location: window.location.toString()
        });
    }
    constructor(props, getServices){
        this.props = void 0;
        this.getServices = void 0;
        this.bridgeControls = null;
        this.changeListeners = new Set();
        this.resolverContextCell = new $368eadf79cf92bf5$var$LazyCell();
        this.viewContextCell = new $368eadf79cf92bf5$var$LazyCell();
        this.extensionDetailsCell = new $368eadf79cf92bf5$var$LazyCell();
        this.resourceRegistry = new $368eadf79cf92bf5$var$BridgeResourceRegistry();
        this.props = props;
        this.getServices = getServices;
    }
}
module.exports["BridgeContextObject"] = $368eadf79cf92bf5$export$692584c74926c9b3;

});

parcelRegister("9XihO", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $JsJ4Y = parcelRequire("JsJ4Y");

var $b7qxC = parcelRequire("b7qxC");


var $dh538 = parcelRequire("dh538");


var $7MEO5 = parcelRequire("7MEO5");


var $1uzCd = parcelRequire("1uzCd");


var $iUjrf = parcelRequire("iUjrf");


var $hpRDw = parcelRequire("hpRDw");


var $cTsf6 = parcelRequire("cTsf6");


var $irOoi = parcelRequire("irOoi");


var $9c0Ac = parcelRequire("9c0Ac");

const $d04645d643f36821$var$validProducts = [
    'confluence',
    'jira',
    'bitbucket'
];
const $d04645d643f36821$var$apiGatewayUrlMap = {
    dev: 'api.stg.atlassian.com',
    stg: 'api.stg.atlassian.com',
    prod: 'api.atlassian.com'
};
const $d04645d643f36821$var$getApiGatewayUrl = (environment)=>{
    const apiBase = $d04645d643f36821$var$apiGatewayUrlMap[environment];
    const url = (0, $lzcvT.isFedRamp)() ? apiBase.replace('atlassian.com', 'atlassian-us-gov-mod.com') : apiBase;
    if (!url) throw new Error(`Invalid environment: ${environment}`);
    return url;
};
const $d04645d643f36821$var$getBaseUrlForIsolatedCloud = (product, cloudId)=>{
    if (product === 'bitbucket') throw new Error('product not supported in Isolated Cloud yet.');
    const apiBase = `api.${(0, $T9xHm.isolatedCloudDomain)()}`;
    return `https://${apiBase}/ex/${product}/${cloudId}`;
};
function $d04645d643f36821$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId) {
    if (product === 'bitbucket') return environment === 'prod' ? 'https://api.bitbucket.org' : 'https://api.integration.bb-inf.net';
    const apiBase = $d04645d643f36821$var$getApiGatewayUrl(environment);
    return `https://${apiBase}/ex/${product}/${cloudId}`;
}
function $d04645d643f36821$var$getBaseUrl(environment, product, cloudId) {
    if ((0, $dh538.fg)('forge-ui-oasis-enabled')) return (0, $T9xHm.isIsolatedCloud)() ? $d04645d643f36821$var$getBaseUrlForIsolatedCloud(product, cloudId) : $d04645d643f36821$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId);
    return $d04645d643f36821$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId);
}
function $d04645d643f36821$var$createProductUrl(environment, product, restPath, cloudId) {
    const baseUrl = $d04645d643f36821$var$getBaseUrl(environment, product, cloudId);
    const fullUrl = // bitbucket requests could be made with absolute URLs
    // e.g. when following href links in API responses
    product === 'bitbucket' && restPath.startsWith(`${baseUrl}/`) ? restPath : `${baseUrl}${restPath}`;
    const productUrl = new URL(fullUrl).toString();
    if (!productUrl.startsWith(`${baseUrl}/`)) throw new Error('Invalid product URL');
    return productUrl;
}
function $d04645d643f36821$export$d1a8c8b605234fe8(token) {
    return !!(token && token.expiry > Date.now());
}
function $d04645d643f36821$var$isProduct(product) {
    return $d04645d643f36821$var$validProducts.includes(product);
}
function $d04645d643f36821$export$da8d8c42bfb20907(contentType) {
    return Boolean(contentType && !contentType.includes('application/json') && contentType.search(/text\//) === -1);
}
function $d04645d643f36821$var$parseFormData(formLike) {
    const form = new FormData();
    for (const [key, value] of Object.entries(formLike))if (key === 'file') {
        const fileName = formLike['__fileName'];
        const mimeType = formLike['__fileType'];
        // convert back from base64 to File (Blob)
        const blob = (0, $JsJ4Y.base64ToBlob)(value, mimeType);
        const file = new File([
            blob
        ], fileName, {
            type: mimeType
        });
        form.append('file', file);
    } else form.append(key, value);
    // remove request metadata properties
    form.delete('__fileName');
    form.delete('__fileType');
    return form;
}
const $d04645d643f36821$var$requestProduct = async (url, init)=>{
    const response = await fetch(url, init);
    const isAttachment = $d04645d643f36821$export$da8d8c42bfb20907(response.headers.get('content-type'));
    if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
        const b64Content = await (0, $JsJ4Y.blobToBase64)(await response.blob());
        return new Response(b64Content, {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
    return response;
};
const $d04645d643f36821$export$2f041121bdb61a5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useProductFetchClient(t0) {
    const $ = (0, $frIzR.c)(16);
    const { appId: appId, extensionId: extensionId, environment: environment, cloudId: cloudId, workspaceId: workspaceId, renderThreeLOPrompt: renderThreeLOPrompt, contextIds: t1, isAnonymousAccessSupportedByApp: t2 } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const contextIds = t3;
    const isAnonymousAccessSupportedByApp = t2 === undefined ? false : t2;
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const userAccess = (0, $42omo.useContext)((0, $9c0Ac.UserAccessContext));
    const authTokenRef = (0, $42omo.useRef)(undefined);
    const isUserAnonymous = userAccess?.isUserAnonymous ?? false;
    const anonymousRequestsEnabled = (0, $42omo.useRef)(isUserAnonymous && isAnonymousAccessSupportedByApp);
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    let t4;
    if ($[2] !== renderThreeLOPrompt) {
        t4 = {
            renderThreeLOPrompt: renderThreeLOPrompt
        };
        $[2] = renderThreeLOPrompt;
        $[3] = t4;
    } else t4 = $[3];
    const fetchOAuthToken = (0, $hpRDw.useFetchAuthToken)(t4);
    if (!cloudId && !workspaceId) return $d04645d643f36821$var$_temp;
    let t5;
    if ($[4] !== environment) {
        t5 = (0, $b7qxC.getCDNEnvironment)(environment);
        $[4] = environment;
        $[5] = t5;
    } else t5 = $[5];
    const cdnEnvironment = t5;
    let t6;
    if ($[6] !== appId || $[7] !== captureEvent || $[8] !== cdnEnvironment || $[9] !== cloudId || $[10] !== contextIds || $[11] !== extensionId || $[12] !== fetchOAuthToken || $[13] !== isAnonymousAccessSupportedByApp || $[14] !== relayEnvironment) {
        t6 = async (restPath, product, init, isMultipartFormData)=>{
            if (!$d04645d643f36821$var$isProduct(product)) throw new Error(`Invalid product: ${product}`);
            const requestAuthStartMark = (0, $1uzCd.getPerformanceMark)();
            captureEvent?.({
                type: "product-api-request-initiated",
                elapsed: requestAuthStartMark
            });
            const prerequisites = [];
            const headers = new Headers(init.headers);
            if ((0, $dh538.fg)("forge-ui-enable-region-steering")) prerequisites.push((0, $cTsf6.getTenantRegion)({
                product: product,
                cloudId: cloudId,
                relayEnvironment: relayEnvironment
            }).then((targetRegion)=>{
                if (!!targetRegion) headers.set("atl-edge-region-hint", targetRegion);
            }).catch($d04645d643f36821$var$_temp2));
            const isAccessValid = anonymousRequestsEnabled.current || $d04645d643f36821$export$d1a8c8b605234fe8(authTokenRef.current);
            if (!isAccessValid) prerequisites.push(fetchOAuthToken(extensionId, contextIds).then((token)=>{
                authTokenRef.current = token;
            }).catch((e)=>{
                if (isAnonymousAccessSupportedByApp && (0, $dh538.fg)("forge-ui-allow-anon-rest-calls")) {
                    anonymousRequestsEnabled.current = true;
                    return;
                }
                throw e;
            }));
            await Promise.all(prerequisites);
            if (!anonymousRequestsEnabled.current) headers.set("Authorization", `Bearer ${authTokenRef.current?.token}`);
            const appAri = (0, $7MEO5.createAppAri)({
                appId: appId
            }).toString();
            headers.set("x-ecosystem-user-agent", `forge ${appAri}`);
            const body = isMultipartFormData ? $d04645d643f36821$var$parseFormData(JSON.parse(init.body)) : init.body;
            if (isMultipartFormData) headers.delete("content-type");
            const request = $d04645d643f36821$var$requestProduct($d04645d643f36821$var$createProductUrl(cdnEnvironment, product, restPath, cloudId), {
                credentials: (0, $dh538.fg)("forge-ui-allow-anon-rest-calls") ? "omit" : undefined,
                ...init,
                body: body,
                headers: headers
            });
            if ((0, $dh538.fg)("forge-ui-app-perf-tracking-enabled")) {
                const requestAuthEndMark = (0, $1uzCd.getPerformanceMark)();
                request.then(()=>{
                    const requestEndMark = (0, $1uzCd.getPerformanceMark)();
                    captureEvent?.({
                        type: "product-api-requested",
                        duration: requestEndMark - requestAuthStartMark,
                        authDuration: requestAuthEndMark - requestAuthStartMark,
                        elapsed: requestEndMark
                    });
                });
            }
            return request;
        };
        $[6] = appId;
        $[7] = captureEvent;
        $[8] = cdnEnvironment;
        $[9] = cloudId;
        $[10] = contextIds;
        $[11] = extensionId;
        $[12] = fetchOAuthToken;
        $[13] = isAnonymousAccessSupportedByApp;
        $[14] = relayEnvironment;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function useProductFetchClient({ appId: appId, extensionId: extensionId, environment: environment, cloudId: cloudId, workspaceId: workspaceId, renderThreeLOPrompt: renderThreeLOPrompt, contextIds: contextIds = [], isAnonymousAccessSupportedByApp: isAnonymousAccessSupportedByApp = false }) {
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const userAccess = (0, $42omo.useContext)((0, $9c0Ac.UserAccessContext));
    const authTokenRef = (0, $42omo.useRef)(undefined);
    const isUserAnonymous = userAccess?.isUserAnonymous ?? false;
    const anonymousRequestsEnabled = (0, $42omo.useRef)(isUserAnonymous && isAnonymousAccessSupportedByApp);
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    const fetchOAuthToken = (0, $hpRDw.useFetchAuthToken)({
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    /**
   * Workspace based products like Trello and Bitbucket will not pass in cloudId,
   * they will pass in workspaceId instead.
   */ if (!cloudId && !workspaceId) return async ()=>{
        throw new Error('Product APIs are not available in this module. Remove requestConfluence, requestJira or requestBitbucket from your code.');
    };
    const cdnEnvironment = (0, $b7qxC.getCDNEnvironment)(environment);
    return async (restPath, product, init, isMultipartFormData)=>{
        if (!$d04645d643f36821$var$isProduct(product)) throw new Error(`Invalid product: ${product}`);
        const requestAuthStartMark = (0, $1uzCd.getPerformanceMark)();
        captureEvent?.({
            type: 'product-api-request-initiated',
            elapsed: requestAuthStartMark
        });
        const prerequisites = [];
        const headers = new Headers(init.headers);
        if ((0, $dh538.fg)('forge-ui-enable-region-steering')) // We need to fetch the tenant region to know which region to steer the request to.
        prerequisites.push((0, $cTsf6.getTenantRegion)({
            product: product,
            cloudId: cloudId,
            relayEnvironment: relayEnvironment
        }).then((targetRegion)=>{
            if (!!targetRegion) headers.set('atl-edge-region-hint', targetRegion);
        })// Fallback to no steering.
        .catch(()=>null));
        const isAccessValid = anonymousRequestsEnabled.current || $d04645d643f36821$export$d1a8c8b605234fe8(authTokenRef.current);
        if (!isAccessValid) // Non-anonymous user -> fetch an OAuth token for API auth
        prerequisites.push(fetchOAuthToken(extensionId, contextIds).then((token)=>{
            // Token valid -> use in API calls
            authTokenRef.current = token;
        }).catch((e)=>{
            // Failure -> fallback to anon access if supported by app
            if (isAnonymousAccessSupportedByApp && (0, $dh538.fg)('forge-ui-allow-anon-rest-calls')) {
                anonymousRequestsEnabled.current = true;
                return;
            }
            // Expecting token -> Rethrow
            throw e;
        }));
        await Promise.all(prerequisites);
        if (!anonymousRequestsEnabled.current) headers.set('Authorization', `Bearer ${authTokenRef.current?.token}`);
        // this header is used to identify requests made by Forge, based on:
        // https://hello.atlassian.net/wiki/x/O5jUIwE?atlOrigin=eyJpIjoiM2NhNjU1MDUxOWJkNDcxNThiNzJjNWU1NzE5Y2FmZTMiLCJwIjoiYyJ9
        const appAri = (0, $7MEO5.createAppAri)({
            appId: appId
        }).toString();
        headers.set('x-ecosystem-user-agent', `forge ${appAri}`);
        const body = isMultipartFormData ? $d04645d643f36821$var$parseFormData(JSON.parse(init.body)) : init.body;
        if (isMultipartFormData) // let the fetch api correctly set the multipart/form-data content-type
        // https://github.com/github/fetch/issues/505#issuecomment-293064470
        headers.delete('content-type');
        const request = $d04645d643f36821$var$requestProduct($d04645d643f36821$var$createProductUrl(cdnEnvironment, product, restPath, cloudId), {
            // Defensive assumption: only token & anonymous auth is supported; prevent unintended
            // fallback to other auth mechanisms by omitting credentials (e.g. cookies).
            credentials: (0, $dh538.fg)('forge-ui-allow-anon-rest-calls') ? 'omit' : undefined,
            ...init,
            body: body,
            headers: headers
        });
        if ((0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')) {
            const requestAuthEndMark = (0, $1uzCd.getPerformanceMark)();
            request.then(()=>{
                const requestEndMark = (0, $1uzCd.getPerformanceMark)();
                captureEvent?.({
                    type: 'product-api-requested',
                    duration: requestEndMark - requestAuthStartMark,
                    authDuration: requestAuthEndMark - requestAuthStartMark,
                    elapsed: requestEndMark
                });
            });
        }
        return request;
    };
};
function $d04645d643f36821$var$_temp2() {
    return null;
}
async function $d04645d643f36821$var$_temp() {
    throw new Error("Product APIs are not available in this module. Remove requestConfluence, requestJira or requestBitbucket from your code.");
}
module.exports["isTokenValid"] = $d04645d643f36821$export$d1a8c8b605234fe8;
module.exports["isBinaryContentType"] = $d04645d643f36821$export$da8d8c42bfb20907;
module.exports["useProductFetchClient"] = $d04645d643f36821$export$2f041121bdb61a5;

});

parcelRegister("20GoR", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $1uzCd = parcelRequire("1uzCd");


var $iUjrf = parcelRequire("iUjrf");


var $9XihO = parcelRequire("9XihO");


var $7MEO5 = parcelRequire("7MEO5");


var $hpRDw = parcelRequire("hpRDw");

const $703d3a3574eac153$var$EGRESS_GET = ()=>({
        method: 'GET',
        route: '/forge/installation/v1/dynamic/egress'
    });
const $703d3a3574eac153$var$EGRESS_SET = (installationId, dryRun = false)=>({
        method: 'PUT',
        route: `/forge/installation/v1/${installationId}/dynamic/egress?dryRun=${dryRun}`
    });
const $703d3a3574eac153$var$EGRESS_DELETE_GROUP = (installationId)=>({
        method: 'DELETE',
        route: `/forge/installation/v1/${installationId}/dynamic/egress`
    });
const $703d3a3574eac153$var$EGRESS_DELETE_DOMAIN = (installationId)=>({
        method: 'PATCH',
        route: `/forge/installation/v1/${installationId}/dynamic/egress/delete-domain`
    });
const $703d3a3574eac153$var$REMOTE_GET = ()=>({
        method: 'GET',
        route: '/forge/installation/v1/dynamic/remote'
    });
const $703d3a3574eac153$var$REMOTE_SET = (installationId, dryRun = false)=>({
        method: 'PUT',
        route: `/forge/installation/v1/${installationId}/dynamic/remote?dryRun=${dryRun}`
    });
const $703d3a3574eac153$export$70250d945629938a = (0, $4pOgL.isReactCompilerActivePlatform)() ? function usePermissionFetchClient(t0) {
    const $ = (0, $frIzR.c)(30);
    const { appId: appId, installationId: installationId, extensionId: extensionId, accountType: accountType, renderThreeLOPrompt: renderThreeLOPrompt, contextIds: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const contextIds = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = function getBaseUrl() {
            const currentUrl = new URL(document.URL);
            return `${currentUrl.origin}/gateway/api`;
        };
        $[2] = t3;
    } else t3 = $[2];
    const getBaseUrl = t3;
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const authTokenRef = (0, $42omo.useRef)(undefined);
    let t4;
    if ($[3] !== renderThreeLOPrompt) {
        t4 = {
            renderThreeLOPrompt: renderThreeLOPrompt
        };
        $[3] = renderThreeLOPrompt;
        $[4] = t4;
    } else t4 = $[4];
    const fetchOAuthToken = (0, $hpRDw.useFetchAuthToken)(t4);
    let t5;
    if ($[5] !== accountType || $[6] !== appId || $[7] !== captureEvent || $[8] !== contextIds || $[9] !== extensionId || $[10] !== fetchOAuthToken) {
        t5 = async (restPath, init)=>{
            const requestAuthStartMark = (0, $1uzCd.getPerformanceMark)();
            captureEvent?.({
                type: "permission-api-request-initiated",
                elapsed: requestAuthStartMark
            });
            const atlassianAccount = !accountType || accountType === "atlassian";
            if (!(0, $9XihO.isTokenValid)(authTokenRef.current) && atlassianAccount) authTokenRef.current = await fetchOAuthToken(extensionId, contextIds);
            const headers = new Headers(init.headers);
            headers.set("Authorization", `Bearer ${authTokenRef?.current?.token}`);
            const appAri = (0, $7MEO5.createAppAri)({
                appId: appId
            }).toString();
            headers.set("x-ecosystem-user-agent", `forge ${appAri}`);
            const requestAuthEndMark = (0, $1uzCd.getPerformanceMark)();
            const request = fetch(new URL(`${getBaseUrl()}${restPath}`), {
                ...init,
                body: init.body,
                headers: headers
            });
            if ((0, $dh538.fg)("forge-ui-app-perf-tracking-enabled")) request.then(()=>{
                const requestEndMark = (0, $1uzCd.getPerformanceMark)();
                captureEvent?.({
                    type: "permission-api-requested",
                    duration: requestEndMark - requestAuthStartMark,
                    authDuration: requestAuthEndMark - requestAuthStartMark,
                    elapsed: requestEndMark
                });
            });
            return request;
        };
        $[5] = accountType;
        $[6] = appId;
        $[7] = captureEvent;
        $[8] = contextIds;
        $[9] = extensionId;
        $[10] = fetchOAuthToken;
        $[11] = t5;
    } else t5 = $[11];
    const oauthFetch = t5;
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = async (restPath_0, init_0)=>{
            const request_0 = fetch(`${getBaseUrl()}${restPath_0}`, {
                ...init_0,
                body: init_0.body
            });
            return request_0;
        };
        $[12] = t6;
    } else t6 = $[12];
    const sessionFetch = t6;
    let t7;
    if ($[13] !== oauthFetch) {
        t7 = async (payload)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$EGRESS_GET();
            const init_1 = {
                method: method
            };
            const sp = new URLSearchParams();
            if (payload.keys && payload.keys.length > 0) payload.keys.forEach((k)=>{
                sp.append("keys", k);
            });
            if (payload.pageSize) sp.append("pageSize", `${payload.pageSize}`);
            if (payload.nextPageToken) sp.append("nextPageToken", payload.nextPageToken);
            let routeToUse = route;
            if (sp.size > 0) routeToUse = `${route}?${sp.toString()}`;
            return oauthFetch(routeToUse, init_1);
        };
        $[13] = oauthFetch;
        $[14] = t7;
    } else t7 = $[14];
    let t10;
    let t8;
    let t9;
    if ($[15] !== installationId) {
        t8 = async (payload_0, isDryRun)=>{
            const { route: route_0, method: method_0 } = $703d3a3574eac153$var$EGRESS_SET(installationId, isDryRun);
            const body = JSON.stringify(payload_0);
            const init_2 = {
                method: method_0,
                headers: {
                    "Content-Type": "application/json"
                },
                body: body
            };
            return sessionFetch(route_0, init_2);
        };
        t9 = async (payload_1)=>{
            const { route: route_1, method: method_1 } = $703d3a3574eac153$var$EGRESS_DELETE_DOMAIN(installationId);
            const body_0 = JSON.stringify(payload_1);
            const init_3 = {
                method: method_1,
                headers: {
                    "Content-Type": "application/json"
                },
                body: body_0
            };
            return sessionFetch(route_1, init_3);
        };
        t10 = async (payload_2)=>{
            const { route: route_2, method: method_2 } = $703d3a3574eac153$var$EGRESS_DELETE_GROUP(installationId);
            const init_4 = {
                method: method_2
            };
            const sp_0 = new URLSearchParams();
            if (payload_2.key) sp_0.append("key", payload_2.key);
            let routeToUse_0 = route_2;
            if (sp_0.size > 0) routeToUse_0 = `${route_2}?${sp_0.toString()}`;
            return sessionFetch(routeToUse_0, init_4);
        };
        $[15] = installationId;
        $[16] = t10;
        $[17] = t8;
        $[18] = t9;
    } else {
        t10 = $[16];
        t8 = $[17];
        t9 = $[18];
    }
    let t11;
    if ($[19] !== oauthFetch) {
        t11 = async (payload_3)=>{
            const { route: route_3, method: method_3 } = $703d3a3574eac153$var$REMOTE_GET();
            const init_5 = {
                method: method_3
            };
            const sp_1 = new URLSearchParams();
            if (payload_3.keys && payload_3.keys.length > 0) payload_3.keys.forEach((k_0)=>{
                sp_1.append("keys", k_0);
            });
            if (payload_3.pageSize) sp_1.append("pageSize", `${payload_3.pageSize}`);
            if (payload_3.nextPageToken) sp_1.append("nextPageToken", payload_3.nextPageToken);
            let routeToUse_1 = route_3;
            if (sp_1.size > 0) routeToUse_1 = `${route_3}?${sp_1.toString()}`;
            return oauthFetch(routeToUse_1, init_5);
        };
        $[19] = oauthFetch;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== installationId) {
        t12 = async (payload_4, isDryRun_0)=>{
            const { route: route_4, method: method_4 } = $703d3a3574eac153$var$REMOTE_SET(installationId, isDryRun_0);
            const body_1 = JSON.stringify(payload_4);
            const init_6 = {
                method: method_4,
                headers: {
                    "Content-Type": "application/json"
                },
                body: body_1
            };
            return sessionFetch(route_4, init_6);
        };
        $[21] = installationId;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== t10 || $[24] !== t11 || $[25] !== t12 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
        t13 = {
            egressGet: t7,
            egressSet: t8,
            egressDeleteDomain: t9,
            egressDeleteGroup: t10,
            remoteGet: t11,
            remoteSet: t12
        };
        $[23] = t10;
        $[24] = t11;
        $[25] = t12;
        $[26] = t7;
        $[27] = t8;
        $[28] = t9;
        $[29] = t13;
    } else t13 = $[29];
    return t13;
} : function usePermissionFetchClient({ appId: appId, installationId: installationId, extensionId: extensionId, accountType: accountType, renderThreeLOPrompt: renderThreeLOPrompt, contextIds: contextIds = [] }) {
    function getBaseUrl() {
        const currentUrl = new URL(document.URL);
        return `${currentUrl.origin}/gateway/api`;
    }
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const authTokenRef = (0, $42omo.useRef)(undefined);
    const fetchOAuthToken = (0, $hpRDw.useFetchAuthToken)({
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const oauthFetch = async (restPath, init)=>{
        const requestAuthStartMark = (0, $1uzCd.getPerformanceMark)();
        captureEvent?.({
            type: 'permission-api-request-initiated',
            elapsed: requestAuthStartMark
        });
        const atlassianAccount = !accountType || accountType === 'atlassian';
        if (!(0, $9XihO.isTokenValid)(authTokenRef.current) && atlassianAccount) authTokenRef.current = await fetchOAuthToken(extensionId, contextIds);
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${authTokenRef?.current?.token}`);
        // this header is used to identify requests made by Forge, based on:
        // https://hello.atlassian.net/wiki/x/O5jUIwE?atlOrigin=eyJpIjoiM2NhNjU1MDUxOWJkNDcxNThiNzJjNWU1NzE5Y2FmZTMiLCJwIjoiYyJ9
        const appAri = (0, $7MEO5.createAppAri)({
            appId: appId
        }).toString();
        headers.set('x-ecosystem-user-agent', `forge ${appAri}`);
        const requestAuthEndMark = (0, $1uzCd.getPerformanceMark)();
        const request = fetch(new URL(`${getBaseUrl()}${restPath}`), {
            ...init,
            body: init.body,
            headers: headers
        });
        if ((0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')) request.then(()=>{
            const requestEndMark = (0, $1uzCd.getPerformanceMark)();
            captureEvent?.({
                type: 'permission-api-requested',
                duration: requestEndMark - requestAuthStartMark,
                authDuration: requestAuthEndMark - requestAuthStartMark,
                elapsed: requestEndMark
            });
        });
        return request;
    };
    const sessionFetch = async (restPath_0, init_0)=>{
        const request_0 = fetch(`${getBaseUrl()}${restPath_0}`, {
            ...init_0,
            body: init_0.body
        });
        return request_0;
    };
    return {
        egressGet: async (payload)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$EGRESS_GET();
            const init_1 = {
                method: method
            };
            const sp = new URLSearchParams();
            if (payload.keys && payload.keys.length > 0) payload.keys.forEach((k)=>{
                sp.append('keys', k);
            });
            if (payload.pageSize) sp.append('pageSize', `${payload.pageSize}`);
            if (payload.nextPageToken) sp.append('nextPageToken', payload.nextPageToken);
            let routeToUse = route;
            if (sp.size > 0) routeToUse = `${route}?${sp.toString()}`;
            return oauthFetch(routeToUse, init_1);
        },
        egressSet: async (payload_0, isDryRun)=>{
            const { route: route_0, method: method_0 } = $703d3a3574eac153$var$EGRESS_SET(installationId, isDryRun);
            const body = JSON.stringify(payload_0);
            const init_2 = {
                method: method_0,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body
            };
            return sessionFetch(route_0, init_2);
        },
        egressDeleteDomain: async (payload_1)=>{
            const { route: route_1, method: method_1 } = $703d3a3574eac153$var$EGRESS_DELETE_DOMAIN(installationId);
            const body_0 = JSON.stringify(payload_1);
            const init_3 = {
                method: method_1,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body_0
            };
            return sessionFetch(route_1, init_3);
        },
        egressDeleteGroup: async (payload_2)=>{
            const { route: route_2, method: method_2 } = $703d3a3574eac153$var$EGRESS_DELETE_GROUP(installationId);
            const init_4 = {
                method: method_2
            };
            const sp_0 = new URLSearchParams();
            if (payload_2.key) sp_0.append('key', payload_2.key);
            let routeToUse_0 = route_2;
            if (sp_0.size > 0) routeToUse_0 = `${route_2}?${sp_0.toString()}`;
            return sessionFetch(routeToUse_0, init_4);
        },
        remoteGet: async (payload_3)=>{
            const { route: route_3, method: method_3 } = $703d3a3574eac153$var$REMOTE_GET();
            const init_5 = {
                method: method_3
            };
            const sp_1 = new URLSearchParams();
            if (payload_3.keys && payload_3.keys.length > 0) payload_3.keys.forEach((k_0)=>{
                sp_1.append('keys', k_0);
            });
            if (payload_3.pageSize) sp_1.append('pageSize', `${payload_3.pageSize}`);
            if (payload_3.nextPageToken) sp_1.append('nextPageToken', payload_3.nextPageToken);
            let routeToUse_1 = route_3;
            if (sp_1.size > 0) routeToUse_1 = `${route_3}?${sp_1.toString()}`;
            return oauthFetch(routeToUse_1, init_5);
        },
        remoteSet: async (payload_4, isDryRun_0)=>{
            const { route: route_4, method: method_4 } = $703d3a3574eac153$var$REMOTE_SET(installationId, isDryRun_0);
            const body_1 = JSON.stringify(payload_4);
            const init_6 = {
                method: method_4,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body_1
            };
            return sessionFetch(route_4, init_6);
        }
    };
};
module.exports["usePermissionFetchClient"] = $703d3a3574eac153$export$70250d945629938a;

});

parcelRegister("3AYRA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $iGoXY = parcelRequire("iGoXY");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $JsJ4Y = parcelRequire("JsJ4Y");

// FIT tokens are valid for 1 hour, but to include some buffer, we'll use 30 minutes.
const $f0e8edd6ba016f56$var$FIT_TOKEN_EXPIRY_MS = 1800000;
const $f0e8edd6ba016f56$export$a30e8bad2b49cec5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const [signInvocationTokenForUIMutation] = (0, $irOoi.useMutation)((0, $iGoXY.default));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new Map();
        $[0] = t0;
    } else t0 = $[0];
    const cachedFitTokenMapRef = (0, $42omo.useRef)(t0);
    let t1;
    if ($[1] !== signInvocationTokenForUIMutation) {
        t1 = async (remoteKey, init, isMultipartFormData, restPath, contextToken)=>{
            if (!contextToken) throw new Error("Context token is required");
            const { fitToken: fitToken, remoteBaseUrl: remoteBaseUrl } = await $f0e8edd6ba016f56$var$getCachedFitToken(remoteKey, contextToken, cachedFitTokenMapRef, signInvocationTokenForUIMutation);
            const targetUrl = restPath ? new URL(restPath, remoteBaseUrl) : remoteBaseUrl;
            const headers = new Headers(init.headers);
            headers.set("Authorization", `Bearer ${fitToken}`);
            const body = isMultipartFormData ? $f0e8edd6ba016f56$var$parseFormData(JSON.parse(init.body)) : init.body;
            if (isMultipartFormData) headers.delete("content-type");
            const response = await fetch(targetUrl, {
                ...init,
                headers: headers,
                body: body
            });
            const isAttachment = $f0e8edd6ba016f56$var$isBinaryContentType(response.headers.get("content-type"));
            if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
                const b64Content = await (0, $JsJ4Y.blobToBase64)(await response.blob());
                return new Response(b64Content, {
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers
                });
            }
            return response;
        };
        $[1] = signInvocationTokenForUIMutation;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const [signInvocationTokenForUIMutation] = (0, $irOoi.useMutation)((0, $iGoXY.default));
    // Cache the FIT tokens against remoteKey to avoid excessively minting new FIT tokens.
    const cachedFitTokenMapRef = (0, $42omo.useRef)(new Map());
    return async (remoteKey, init, isMultipartFormData, restPath, contextToken)=>{
        if (!contextToken) throw new Error('Context token is required');
        const { fitToken: fitToken, remoteBaseUrl: remoteBaseUrl } = await $f0e8edd6ba016f56$var$getCachedFitToken(remoteKey, contextToken, cachedFitTokenMapRef, signInvocationTokenForUIMutation);
        // Call the remote with the FIT token as the authorization header
        const targetUrl = restPath ? new URL(restPath, remoteBaseUrl) : remoteBaseUrl;
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${fitToken}`);
        // handle multipart form data
        const body = isMultipartFormData ? $f0e8edd6ba016f56$var$parseFormData(JSON.parse(init.body)) : init.body;
        if (isMultipartFormData) // let the fetch api correctly set the multipart/form-data content-type
        // https://github.com/github/fetch/issues/505#issuecomment-293064470
        headers.delete('content-type');
        const response = await fetch(targetUrl, {
            ...init,
            headers: headers,
            body: body
        });
        // Handle binary response types
        const isAttachment = $f0e8edd6ba016f56$var$isBinaryContentType(response.headers.get('content-type'));
        if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
            const b64Content = await (0, $JsJ4Y.blobToBase64)(await response.blob());
            return new Response(b64Content, {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
            });
        }
        return response;
    };
};
async function $f0e8edd6ba016f56$var$getCachedFitToken(remoteKey, contextToken, cachedFitTokenMapRef, signInvocationTokenForUIMutation) {
    let fitToken;
    let remoteBaseUrl;
    const cachedFitToken = cachedFitTokenMapRef.current.get(remoteKey);
    // Attempt to use the cached FIT token if it is in the map and is valid
    if (cachedFitToken && $f0e8edd6ba016f56$var$isFitValid(cachedFitToken)) {
        fitToken = cachedFitToken.fitToken;
        remoteBaseUrl = cachedFitToken.remoteBaseUrl;
    } else {
        const fitExchangeResponse = await $f0e8edd6ba016f56$var$exchangeFCTForFIT(contextToken, remoteKey, signInvocationTokenForUIMutation);
        const { fitToken: newFitToken, remoteBaseUrl: newRemoteBaseUrl } = fitExchangeResponse;
        cachedFitTokenMapRef.current.set(remoteKey, {
            fitToken: newFitToken,
            remoteBaseUrl: newRemoteBaseUrl,
            fitTokenExpiresAt: Date.now() + $f0e8edd6ba016f56$var$FIT_TOKEN_EXPIRY_MS
        });
        fitToken = newFitToken;
        remoteBaseUrl = newRemoteBaseUrl;
    }
    if (!remoteBaseUrl) throw new Error('Remote base URL is not available for the given remote key');
    if (!fitToken) throw new Error('FIT token is not available for the given remote key');
    return {
        fitToken: fitToken,
        remoteBaseUrl: remoteBaseUrl
    };
}
async function $f0e8edd6ba016f56$var$exchangeFCTForFIT(contextToken, remoteKey, signInvocationTokenForUIMutation) {
    return new Promise((resolve, reject)=>{
        signInvocationTokenForUIMutation({
            variables: {
                input: {
                    forgeContextToken: contextToken,
                    remoteKey: remoteKey
                }
            },
            onCompleted: (data, errors)=>{
                if (errors || !data?.signInvocationTokenForUI || data.signInvocationTokenForUI.errors) reject(new Error(`Failed to generate FIT token`));
                const response = {
                    fitToken: data.signInvocationTokenForUI?.forgeInvocationToken?.jwt ?? '',
                    remoteBaseUrl: data.signInvocationTokenForUI?.metadata?.baseUrl ?? ''
                };
                resolve(response);
            }
        });
    });
}
function $f0e8edd6ba016f56$var$isFitValid(cachedFitToken) {
    return cachedFitToken.fitTokenExpiresAt > Date.now();
}
function $f0e8edd6ba016f56$var$parseFormData(formLike) {
    const form = new FormData();
    for (const [key, value] of Object.entries(formLike))if (key.startsWith('file')) {
        const encodedFileNameKey = `__${key}Name`;
        const encodedMimeTypeKey = `__${key}Type`;
        const fileName = formLike[encodedFileNameKey];
        const mimeType = formLike[encodedMimeTypeKey];
        // convert back from base64 to File (Blob)
        const blob = (0, $JsJ4Y.base64ToBlob)(value, mimeType);
        const file = new File([
            blob
        ], fileName, {
            type: mimeType
        });
        form.append(key, file);
    } else form.append(key, value);
    // remove request metadata properties
    form.delete('__fileName');
    form.delete('__fileType');
    return form;
}
function $f0e8edd6ba016f56$var$isBinaryContentType(contentType) {
    return Boolean(contentType && !contentType.includes('application/json') && contentType.search(/text\//) === -1);
}
module.exports["useRemoteFetchClient"] = $f0e8edd6ba016f56$export$a30e8bad2b49cec5;

});

parcelRegister("fgbwU", function(module, exports) {

var $3uVVG = parcelRequire("3uVVG");


var $jLYRk = parcelRequire("jLYRk");

const $40dbef35f15607cc$export$6baf9fc1d877ea76 = 'atlassian-token-service-key';
const $40dbef35f15607cc$export$5a2d35665f488c3c = async (startUrl, windowFeatures)=>{
    return (0, $3uVVG.auth)((0, $jLYRk.sanitizeUrl)(startUrl), windowFeatures);
};
const $40dbef35f15607cc$export$4211976e157c7ad8 = (startUrl)=>{
    const url = new URL(startUrl || '', window.location.href);
    const serviceKey = url.searchParams.get('serviceKey');
    return serviceKey !== $40dbef35f15607cc$export$6baf9fc1d877ea76;
};
module.exports["safeAuth"] = $40dbef35f15607cc$export$5a2d35665f488c3c;
module.exports["isExternalAuth"] = $40dbef35f15607cc$export$4211976e157c7ad8;

});

parcelRegister("65XYT", function(module, exports) {
const $bb678f18ba43cf1b$var$DEFAULT_EVENT_SAMPLE_RATE = 0.1;
const $bb678f18ba43cf1b$var$DEFAULT_PROFILE_EVENT_VERSION = '2.0';
const $bb678f18ba43cf1b$export$b516b893fff0f452 = {
    enabled: true,
    sampleRate: $bb678f18ba43cf1b$var$DEFAULT_EVENT_SAMPLE_RATE,
    version: $bb678f18ba43cf1b$var$DEFAULT_PROFILE_EVENT_VERSION
};
const $bb678f18ba43cf1b$export$b8357089f6c151ea = [
    // Jira modules
    'jira:adminPage',
    'jira:customField',
    'jira:customFieldType',
    'jira:dashboardGadget',
    'jira:globalPage',
    'jira:issueAction',
    'jira:issueActivity',
    'jira:issueContext',
    'jira:issuePanel',
    'jira:projectPage',
    'jira:projectSettingsPage',
    'jira:uiModifications',
    // Confluence modules
    'confluence:contentAction',
    'confluence:contentBylineItem',
    'confluence:globalPage',
    'confluence:globalSettings',
    'confluence:spacePage',
    'xen:macro'
];
module.exports["defaultPerfCaptureConfig"] = $bb678f18ba43cf1b$export$b516b893fff0f452;
module.exports["enabledModulesForPerfCapture"] = $bb678f18ba43cf1b$export$b8357089f6c151ea;

});

parcelRegister("fSMLG", function(module, exports) {
const $796443ed50933d56$export$5458688a52e32026 = [
    // Error in user code
    /^There was an error invoking the function/,
    // User code returned non-JSON value, so XIS threw an InvalidInvocationPayloadError.
    /^Invalid response body, data must be JSON or undefined$/,
    // Networking errors
    /^Failed to fetch$/,
    /^Network error: Failed to fetch$/,
    /^Network error: Network failure: TypeError: Failed to fetch$/,
    /^NetworkError when attempting to fetch resource.$/,
    /^Network error: Received status 504$/,
    // time out
    /^GraphQL error: The underlying service call timed out$/,
    // Unauthenticated requests made from public confluence content
    /^GraphQL error: Auth category: UNAUTHENTICATED is not allowed in service xen_invocation_service$/
];
module.exports["blocklistedErrorMessagePatterns"] = $796443ed50933d56$export$5458688a52e32026;

});

parcelRegister("6t4vQ", function(module, exports) {

var $i3Ypo = parcelRequire("i3Ypo");


var $j4W8T = parcelRequire("j4W8T");


var $6usda = parcelRequire("6usda");

const $002c78d4647c8af0$var$getExtensionParams = (extension)=>{
    const { appId: appId, environmentKey: environmentKey, key: key } = extension;
    if (!appId) throw (0, $6usda.NavigationError).MissingProperty('appId');
    if (!environmentKey) throw (0, $6usda.NavigationError).MissingProperty('environmentKey');
    if (!key) throw (0, $6usda.NavigationError).MissingProperty('key');
    return {
        appId: appId,
        environmentKey: environmentKey,
        key: key
    };
};
const $002c78d4647c8af0$export$7e2ccfc9450d6cc0 = {
    [(0, $i3Ypo.BitbucketExtension).REPOSITORY_MAIN_MENU_PAGE]: (extension, { workspaceId: workspaceId, repositoryId: repositoryId })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $002c78d4647c8af0$var$getExtensionParams(extension);
        (0, $6usda.ensurePropertyExists)('workspaceId', workspaceId);
        (0, $6usda.ensurePropertyExists)('repositoryId', repositoryId);
        return (0, $j4W8T.ensureURLPath)(`/${workspaceId}/${repositoryId}/forge/${appId}/${environmentKey}/${key}`);
    },
    [(0, $i3Ypo.BitbucketExtension).REPOSITORY_SETTINGS_MENU_PAGE]: (extension, { workspaceId: workspaceId, repositoryId: repositoryId })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $002c78d4647c8af0$var$getExtensionParams(extension);
        (0, $6usda.ensurePropertyExists)('workspaceId', workspaceId);
        (0, $6usda.ensurePropertyExists)('repositoryId', repositoryId);
        return (0, $j4W8T.ensureURLPath)(`/${workspaceId}/${repositoryId}/admin/forge/${appId}/${environmentKey}/${key}`);
    },
    [(0, $i3Ypo.BitbucketExtension).PROJECT_SETTINGS_MENU_PAGE]: (extension, { workspaceId: workspaceId, projectKey: projectKey })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $002c78d4647c8af0$var$getExtensionParams(extension);
        (0, $6usda.ensurePropertyExists)('workspaceId', workspaceId);
        (0, $6usda.ensurePropertyExists)('projectKey', projectKey);
        return (0, $j4W8T.ensureURLPath)(`/${workspaceId}/workspace/projects/${projectKey}/settings/forge/${appId}/${environmentKey}/${key}`);
    },
    [(0, $i3Ypo.BitbucketExtension).WORKSPACE_GLOBAL_PAGE]: (extension, { workspaceId: workspaceId })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $002c78d4647c8af0$var$getExtensionParams(extension);
        (0, $6usda.ensurePropertyExists)('workspaceId', workspaceId);
        return (0, $j4W8T.ensureURLPath)(`/${workspaceId}/workspace/forge/${appId}/${environmentKey}/${key}`);
    },
    [(0, $i3Ypo.BitbucketExtension).WORKSPACE_PERSONAL_SETTINGS_PAGE]: (extension, { workspaceId: workspaceId })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $002c78d4647c8af0$var$getExtensionParams(extension);
        (0, $6usda.ensurePropertyExists)('workspaceId', workspaceId);
        return (0, $j4W8T.ensureURLPath)(`/${workspaceId}/workspace/personal-settings/forge/${appId}/${environmentKey}/${key}`);
    },
    [(0, $i3Ypo.BitbucketExtension).WORKSPACE_SETTINGS_MENU_PAGE]: (extension, { workspaceId: workspaceId })=>{
        const { appId: appId, environmentKey: environmentKey, key: key } = $002c78d4647c8af0$var$getExtensionParams(extension);
        (0, $6usda.ensurePropertyExists)('workspaceId', workspaceId);
        return (0, $j4W8T.ensureURLPath)(`/${workspaceId}/workspace/settings/forge/${appId}/${environmentKey}/${key}`);
    }
};
module.exports["bitbucketExtensionURLHelpers"] = $002c78d4647c8af0$export$7e2ccfc9450d6cc0;

});

parcelRegister("faCvF", function(module, exports) {

var $1c598 = parcelRequire("1c598");


var $j4W8T = parcelRequire("j4W8T");


var $6usda = parcelRequire("6usda");

const $04ed449cb34fa9a4$var$makeConfluenceURLPath = (0, $j4W8T.createMakeProductURLPath)('/wiki');
const $04ed449cb34fa9a4$var$isCustomContentType = (contentType)=>contentType.startsWith('forge:');
const $04ed449cb34fa9a4$export$68f051c1b56c060f = {
    [(0, $1c598.ConfluenceExtension).FULL_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        const { routePrefix: routePrefix } = properties;
        if (!routePrefix) return null;
        return `/forge-apps/a/${appId}/e/${environmentId}/r/${routePrefix}`;
    },
    [(0, $1c598.ConfluenceExtension).GLOBAL_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId })=>{
        const { route: route } = properties;
        if (appId && environmentId && route) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $1c598.ConfluenceExtension).GLOBAL_SETTINGS]: ({ id: id })=>$04ed449cb34fa9a4$var$makeConfluenceURLPath('/admin/forge', {
            id: id
        }),
    [(0, $1c598.ConfluenceExtension).SPACE_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (route && environmentId && appId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $1c598.ConfluenceExtension).SPACE_SETTINGS]: ({ properties: properties, appId: appId, environmentId: environmentId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (!spaceKey) throw (0, $6usda.NavigationError).MissingProperty('spaceKey');
        if (route && environmentId && appId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}/settings/apps/${appId}/${environmentId}/${route}`);
        return null;
    }
};
const $04ed449cb34fa9a4$export$f91bdc214ca5389d = {
    contentView: async ({ contentId: contentId, version: version })=>{
        if (!contentId) throw (0, $6usda.NavigationError).MissingProperty('contentId');
        let resp = null;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $6usda.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { id: id, type: type, _links: { webui: webui } } = await resp.json();
        // if version is provided, we should use it, however, it only works for none-custom content type
        if (version && version >= 0) {
            if ($04ed449cb34fa9a4$var$isCustomContentType(type)) throw new Error('Version is not supported for custom content type');
            return $04ed449cb34fa9a4$var$makeConfluenceURLPath('/pages/viewpage.action', {
                pageId: id,
                pageVersion: `${version}`
            });
        } else if (webui) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(webui);
        throw (0, $6usda.NavigationError).LinkForContentNotFound(contentId);
    },
    contentEdit: async ({ contentId: contentId })=>{
        let resp;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $6usda.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { _links: { edituiv2: edituiv2 } } = await resp.json();
        // content with custom content type doesn't have edit link
        if (edituiv2) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(edituiv2);
        throw (0, $6usda.NavigationError).LinkForContentNotFound(contentId);
    },
    spaceView: async ({ spaceKey: spaceKey })=>{
        return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}`);
    },
    contentList: async (params, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        const { contentType: contentType } = params;
        if (!contentType) throw (0, $6usda.NavigationError).MissingProperty('contentType');
        if (contentType === 'customContent' && params.moduleKey) {
            const { moduleKey: moduleKey } = params;
            const module = await (0, $6usda.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
            if (!module) throw (0, $6usda.NavigationError).ModuleNotFound(moduleKey);
            const { appId: appId, environmentId: environmentId } = module;
            if (appId && environmentId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath('/search', {
                type: `forge:${appId}:${environmentId}:${moduleKey}`
            });
        } else if (contentType === 'page' && params.spaceKey) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/pages`);
        else if (contentType === 'blogpost' && params.spaceKey) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/blogs`);
        throw (0, $6usda.NavigationError).InvalidValueForProperty('contentType', contentType);
    }
};
module.exports["confluenceExtensionURLHelpers"] = $04ed449cb34fa9a4$export$68f051c1b56c060f;
module.exports["confluenceNavigationTargetURLHelpers"] = $04ed449cb34fa9a4$export$f91bdc214ca5389d;

});

parcelRegister("6usda", function(module, exports) {
const $9406182ad5621a53$export$c1f2bec49c0b084d = async (getAppForgeUIExtensions, moduleKey)=>{
    const { extensions: extensions } = await getAppForgeUIExtensions({
        expandAppOwner: false
    });
    const module = extensions?.find(({ key: key })=>key === moduleKey);
    return module?.type ? module : null;
};
const $9406182ad5621a53$export$c53ed1333d39ada3 = {
    ModuleNotFound: (moduleKey)=>{
        return new Error(`Navigation failed: Module with moduleKey ${moduleKey} was not found`);
    },
    MissingProperty: (property)=>{
        return new Error(`Navigation failed: ${property} not provided`);
    },
    FailedToFetchContentInfo: (contentId)=>{
        return new Error(`Navigation failed: Failed to fetch content information with id ${contentId}. Please check if the ID provided is correct`);
    },
    NotSupportedExtensionType: (moduleType)=>{
        return new Error(`Navigation failed: Module type ${moduleType} is not supported`);
    },
    InvalidValueForProperty: (property, value)=>{
        return new Error(`Navigation failed: ${value} is not a valid value for ${property}`);
    },
    LinkForContentNotFound: (contentId)=>{
        return new Error(`Navigation failed: Link for content with id ${contentId} was not found`);
    }
};
const $9406182ad5621a53$export$ae701e18d3b38cae = (propertyName, propertyValue)=>{
    if (propertyValue === undefined || propertyValue === null) throw $9406182ad5621a53$export$c53ed1333d39ada3.MissingProperty(propertyName);
    return propertyValue;
};
module.exports["getModuleByKey"] = $9406182ad5621a53$export$c1f2bec49c0b084d;
module.exports["NavigationError"] = $9406182ad5621a53$export$c53ed1333d39ada3;
module.exports["ensurePropertyExists"] = $9406182ad5621a53$export$ae701e18d3b38cae;

});

parcelRegister("6wbTo", function(module, exports) {

var $1c598 = parcelRequire("1c598");


var $dh538 = parcelRequire("dh538");


var $j4W8T = parcelRequire("j4W8T");


var $6usda = parcelRequire("6usda");

const $d3b8e1134d73790d$var$makeJiraURLPath = (0, $j4W8T.createMakeProductURLPath)('/jira');
const $d3b8e1134d73790d$var$PROJECT_TYPE_SEGMENT_MAP = {
    software: 'software',
    business: 'core',
    service_desk: 'servicedesk'
};
const $d3b8e1134d73790d$var$projectTypeSegmentCache = new Map();
const $d3b8e1134d73790d$export$8901d41959b1b84d = ()=>$d3b8e1134d73790d$var$projectTypeSegmentCache.clear();
const $d3b8e1134d73790d$var$resolveJiraProjectTypeSegment = async (projectKey)=>{
    const cached = $d3b8e1134d73790d$var$projectTypeSegmentCache.get(projectKey);
    if (cached) return cached;
    try {
        const resp = await fetch(`/rest/api/3/project/${projectKey}`);
        const { projectTypeKey: projectTypeKey } = await resp.json();
        const segment = $d3b8e1134d73790d$var$PROJECT_TYPE_SEGMENT_MAP[projectTypeKey];
        if (segment) {
            $d3b8e1134d73790d$var$projectTypeSegmentCache.set(projectKey, segment);
            return segment;
        }
        // eslint-disable-next-line no-console
        console.warn(`Navigation: Unknown project type key "${projectTypeKey}" for "${projectKey}"`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Navigation: Failed to resolve project type for "${projectKey}"`, e);
    }
    // default to software segment if we fail to resolve the project type, this ensure backwards compatibility with the existing apps
    return 'software';
};
const $d3b8e1134d73790d$export$47842863b73e9046 = {
    [(0, $1c598.JiraExtension).FULL_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        const { routePrefix: routePrefix } = properties;
        if (!routePrefix) return null;
        return `/forge-apps/a/${appId}/e/${environmentId}/r/${routePrefix}`;
    },
    [(0, $1c598.JiraExtension).ADMIN_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        const { useAsGetStarted: useAsGetStarted, useAsConfig: useAsConfig } = properties;
        if (useAsGetStarted) return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/apps/get-started/${appId}/${environmentId}`);
        if (useAsConfig) return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/apps/configure/${appId}/${environmentId}`);
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).GLOBAL_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PERSONAL_SETTINGS_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/personal/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PROJECT_SETTINGS_PAGE]: async ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        const validatedKey = (0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase();
        if ((0, $dh538.fg)('forge-ui-get-url-supprt-jira-project-type-lookup')) {
            const segment = await $d3b8e1134d73790d$var$resolveJiraProjectTypeSegment(validatedKey);
            return $d3b8e1134d73790d$var$makeJiraURLPath(`/${segment}/projects/${validatedKey}/settings/apps/${appId}/${environmentId}`);
        }
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${validatedKey}/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PROJECT_PAGE]: async ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        const validatedKey = (0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase();
        if ((0, $dh538.fg)('forge-ui-get-url-supprt-jira-project-type-lookup')) {
            const segment = await $d3b8e1134d73790d$var$resolveJiraProjectTypeSegment(validatedKey);
            return $d3b8e1134d73790d$var$makeJiraURLPath(`/${segment}/projects/${validatedKey}/apps/${appId}/${environmentId}`);
        }
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${validatedKey}/apps/${appId}/${environmentId}`);
    }
};
const $d3b8e1134d73790d$export$ca7043166c283e6d = {
    dashboard: async ({ dashboardId: dashboardId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/dashboards/${(0, $6usda.ensurePropertyExists)('dashboardId', dashboardId)}`);
    },
    issue: async ({ issueKey: issueKey })=>{
        return `/browse/${(0, $6usda.ensurePropertyExists)('issueKey', issueKey)}`;
    },
    // equivalent to Connects projectAdminSummary target
    projectSettingsDetails: async ({ projectKey: projectKey })=>{
        const validatedKey = (0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase();
        if ((0, $dh538.fg)('forge-ui-get-url-supprt-jira-project-type-lookup')) {
            const segment = await $d3b8e1134d73790d$var$resolveJiraProjectTypeSegment(validatedKey);
            return $d3b8e1134d73790d$var$makeJiraURLPath(`/${segment}/projects/${validatedKey}/settings/details`);
        }
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${validatedKey}/settings/details`);
    }
};
module.exports["jiraExtensionURLHelpers"] = $d3b8e1134d73790d$export$47842863b73e9046;
module.exports["jiraNavigationTargetHandlers"] = $d3b8e1134d73790d$export$ca7043166c283e6d;

});

parcelRegister("j4W8T", function(module, exports) {
// Ensures that the path structured correctly and adds provided parameters to the path
const $ae891dc783a5dbcf$export$26e2379e0018d084 = (path, parameters)=>{
    let encodedPath = (path ?? '').split('/').map(encodeURIComponent).join('/');
    if (parameters && Object.keys(parameters).length > 0) encodedPath += '?' + new URLSearchParams(parameters).toString();
    return encodedPath;
};
const $ae891dc783a5dbcf$export$ab31bc7dd6e328ce = (productPathPrefix)=>(path, parameters)=>{
        return $ae891dc783a5dbcf$export$26e2379e0018d084(path ? productPathPrefix + path : productPathPrefix, parameters);
    };
module.exports["ensureURLPath"] = $ae891dc783a5dbcf$export$26e2379e0018d084;
module.exports["createMakeProductURLPath"] = $ae891dc783a5dbcf$export$ab31bc7dd6e328ce;

});

parcelRegister("dIZZf", function(module, exports) {
/**
 * @generated SignedSource<<708c1bbd91c0ce7794de647ad883ea2d>>
 * @relayHash a8d997cf9f56d7a9bc9c3a4673a4ab05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 392e69b59b157550f874185ece3f2558dca2cfd138ebbca83e163ba479f415b2
const $a84e2492be2891c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRovoEnabled"
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getIsRovoEnabledQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getIsRovoEnabledQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "392e69b59b157550f874185ece3f2558dca2cfd138ebbca83e163ba479f415b2",
            "metadata": {},
            "name": "getIsRovoEnabledQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a84e2492be2891c8$var$node.hash = "4e6658c9c4fce21189d6b3b9b3b4e535";
var $a84e2492be2891c8$export$2e2bcd8739ae039 = $a84e2492be2891c8$var$node;
module.exports["default"] = $a84e2492be2891c8$export$2e2bcd8739ae039;

});

parcelRegister("fJCAk", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $ccHMk = parcelRequire("ccHMk");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $aXWIB = parcelRequire("aXWIB");

const $f58f5052b341dbb2$export$9dd6ff9ea0189349 = {
    titleContainer: "_otyrxy5q",
    modalFooterContainer: "_15a5nqa1 _uwhke4h9 _1i531l7x",
    disclaimerContainer: "_19pkxy5q _otyrxy5q",
    rowContainer: "_ca0qu2gc _n3tdu2gc _u5f3u2gc _19bvu2gc _1il9nqa1 _1doce4h9 _1o3i1l7x"
};
const $f58f5052b341dbb2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    declineButtonLabel: {
        id: "forge-ui.adminConsentModal.decline.button.label",
        defaultMessage: "Decline"
    },
    approveButtonLabel: {
        id: "forge-ui.adminConsentModal.approve.button.label",
        defaultMessage: "Approve"
    },
    noticeForMoreDetails: {
        id: "forge-ui.adminConsentModal.notice.for-more-details",
        defaultMessage: "For more details, refer to {appName}'s"
    },
    noticeAnd: {
        id: "forge-ui.adminConsentModal.notice.and",
        defaultMessage: "and"
    },
    termsOfUseLink: {
        id: "forge-ui.adminConsentModal.terms-of-use.link",
        defaultMessage: "terms of use"
    },
    privacyPolicyLink: {
        id: "forge-ui.adminConsentModal.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    modalTransitionTitle: {
        id: "forge-ui.adminConsentModal.modal-transition.title",
        defaultMessage: "Data storage, sharing, receiving and processing"
    },
    modalTransitionText: {
        id: "forge-ui.adminConsentModal.modal-transition.text",
        defaultMessage: "{appName} is requesting to share with and receive data from the following domains:"
    }
});
const $f58f5052b341dbb2$export$24cbef36aabf5e56 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(38);
    const { modalState: modalState } = t0;
    const intl = (0, $aXWIB.useIntl)();
    if (modalState.state === "closed") {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null);
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    let t1;
    if ($[1] !== intl || $[2] !== modalState.onCancel || $[3] !== modalState.onConfirm) {
        t1 = ()=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.modalFooterContainer
            }, /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                space: "space.075"
            }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
                onClick: modalState.onCancel
            }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.declineButtonLabel)), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
                onClick: modalState.onConfirm,
                appearance: "primary"
            }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.approveButtonLabel)))));
        $[1] = intl;
        $[2] = modalState.onCancel;
        $[3] = modalState.onConfirm;
        $[4] = t1;
    } else t1 = $[4];
    const ModalFooter = t1;
    let t2;
    if ($[5] !== modalState.domainInfo) {
        t2 = ()=>{
            const getHumanReadableName = $f58f5052b341dbb2$var$_temp;
            const domainInfo = modalState.domainInfo;
            if (Object.keys(domainInfo).length === 0) return null;
            if (domainInfo.type === "REMOTE") return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
                direction: "column",
                gap: "space.150"
            }, domainInfo.payload.remotes.map((r)=>{
                const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
                return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                    key: r.key,
                    space: "space.150"
                }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                    size: "small"
                }, manifestRemoteInfo ? manifestRemoteInfo.description : "Remote"), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                    xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.rowContainer,
                    spread: "space-between",
                    grow: "fill"
                }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, r.configured.endpoint === null ? "This remote is being reset to the default value" : r.configured.endpoint), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
            }));
            if (domainInfo.type === "EGRESS") return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
                direction: "column",
                gap: "space.150"
            }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                    key: e.key,
                    space: "space.150"
                }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                    size: "xsmall"
                }, e.description), e.configured.map((c)=>c.type.map((t)=>/*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                            xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.rowContainer,
                            spread: "space-between",
                            grow: "fill"
                        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, c.domain), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, getHumanReadableName(t))))))));
        };
        $[5] = modalState.domainInfo;
        $[6] = t2;
    } else t2 = $[6];
    const renderDomains = t2;
    let t3;
    if ($[7] !== intl || $[8] !== modalState) {
        t3 = ()=>{
            const { appName: appName, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink } = modalState;
            if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeForMoreDetails, {
                appName: appName ?? "the app"
            }), " ", /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                href: termsOfUseLink
            }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.termsOfUseLink)), " ", intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeAnd), " ", /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                href: privacyPolicyLink
            }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.privacyPolicyLink)));
            else {
                if (termsOfUseLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeForMoreDetails, {
                    appName: appName ?? "the app"
                }), " ", /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    href: termsOfUseLink
                }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.termsOfUseLink)));
                else {
                    if (privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeForMoreDetails, {
                        appName: appName ?? "the app"
                    }), " ", /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                        href: privacyPolicyLink
                    }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.privacyPolicyLink)));
                }
            }
        };
        $[7] = intl;
        $[8] = modalState;
        $[9] = t3;
    } else t3 = $[9];
    const Notice = t3;
    let t4;
    if ($[10] !== modalState) {
        t4 = ()=>{
            modalState.onCancel();
        };
        $[10] = modalState;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== intl) {
        t5 = intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.modalTransitionTitle);
        $[12] = intl;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t5) {
        t6 = /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.titleContainer
        }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), null, t5)));
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== intl || $[17] !== modalState.appName) {
        t7 = intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.modalTransitionText, {
            appName: modalState.appName ?? "The app"
        });
        $[16] = intl;
        $[17] = modalState.appName;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t7) {
        t8 = /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, t7);
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== renderDomains) {
        t9 = renderDomains();
        $[21] = renderDomains;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== Notice) {
        t10 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.disclaimerContainer
        }, /*#__PURE__*/ $42omo.createElement(Notice, null));
        $[23] = Notice;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== t10 || $[26] !== t9) {
        t11 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), null, t9, t10);
        $[25] = t10;
        $[26] = t9;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== t11 || $[29] !== t8) {
        t12 = /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
            space: "space.300"
        }, t8, t11));
        $[28] = t11;
        $[29] = t8;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== ModalFooter) {
        t13 = /*#__PURE__*/ $42omo.createElement(ModalFooter, null);
        $[31] = ModalFooter;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== t12 || $[34] !== t13 || $[35] !== t4 || $[36] !== t6) {
        t14 = /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
            onClose: t4,
            width: "large"
        }, t6, t12, t13));
        $[33] = t12;
        $[34] = t13;
        $[35] = t4;
        $[36] = t6;
        $[37] = t14;
    } else t14 = $[37];
    return t14;
} : ({ modalState: modalState })=>{
    const intl = (0, $aXWIB.useIntl)();
    if (modalState.state === 'closed') return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null);
    const ModalFooter = ()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.modalFooterContainer
        }, /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            space: "space.075"
        }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            onClick: modalState.onCancel
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.declineButtonLabel)), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            onClick: modalState.onConfirm,
            appearance: "primary"
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.approveButtonLabel)))));
    };
    const renderDomains = ()=>{
        const getHumanReadableName = (operation)=>{
            switch(operation){
                case 'FETCH_BACKEND_SIDE':
                    return 'Fetch backend side';
                case 'FETCH_CLIENT_SIDE':
                    return 'Fetch client side';
                case 'FONTS':
                    return 'Fonts';
                case 'FRAMES':
                    return 'Frames';
                case 'IMAGES':
                    return 'Images';
                case 'MEDIA':
                    return 'Media';
                case 'NAVIGATION':
                    return 'Navigation';
                case 'SCRIPTS':
                    return 'Scripts';
                case 'STYLES':
                    return 'Styles';
                default:
                    return 'Egress';
            }
        };
        const domainInfo = modalState.domainInfo;
        if (Object.keys(domainInfo).length === 0) return null;
        if (domainInfo.type === 'REMOTE') return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.remotes.map((r)=>{
            const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
            return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                key: r.key,
                space: "space.150"
            }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                size: "small"
            }, manifestRemoteInfo ? manifestRemoteInfo.description : 'Remote'), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.rowContainer,
                spread: "space-between",
                grow: "fill"
            }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, r.configured.endpoint === null ? 'This remote is being reset to the default value' : r.configured.endpoint), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
        }));
        if (domainInfo.type === 'EGRESS') return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                key: e.key,
                space: "space.150"
            }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                size: "xsmall"
            }, e.description), e.configured.map((c)=>{
                return c.type.map((t)=>{
                    return /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                        xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.rowContainer,
                        spread: "space-between",
                        grow: "fill"
                    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, c.domain), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, getHumanReadableName(t)));
                });
            }))));
    };
    const Notice = ()=>{
        const { appName: appName, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink } = modalState;
        if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeForMoreDetails, {
            appName: appName ?? 'the app'
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: termsOfUseLink
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.termsOfUseLink)), ' ', intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeAnd), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: privacyPolicyLink
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.privacyPolicyLink)));
        else if (termsOfUseLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeForMoreDetails, {
            appName: appName ?? 'the app'
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: termsOfUseLink
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.termsOfUseLink)));
        else if (privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeForMoreDetails, {
            appName: appName ?? 'the app'
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: privacyPolicyLink
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.privacyPolicyLink)));
    };
    return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: ()=>{
            modalState.onCancel();
        },
        width: "large"
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.titleContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.modalTransitionTitle)))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.300"
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.modalTransitionText, {
        appName: modalState.appName ?? 'The app'
    })), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), null, renderDomains(), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.disclaimerContainer
    }, /*#__PURE__*/ $42omo.createElement(Notice, null))))), /*#__PURE__*/ $42omo.createElement(ModalFooter, null)));
};
function $f58f5052b341dbb2$var$_temp(operation) {
    switch(operation){
        case "FETCH_BACKEND_SIDE":
            return "Fetch backend side";
        case "FETCH_CLIENT_SIDE":
            return "Fetch client side";
        case "FONTS":
            return "Fonts";
        case "FRAMES":
            return "Frames";
        case "IMAGES":
            return "Images";
        case "MEDIA":
            return "Media";
        case "NAVIGATION":
            return "Navigation";
        case "SCRIPTS":
            return "Scripts";
        case "STYLES":
            return "Styles";
        default:
            return "Egress";
    }
}
module.exports["styles"] = $f58f5052b341dbb2$export$9dd6ff9ea0189349;
module.exports["messages"] = $f58f5052b341dbb2$export$defe85febe8b728c;
module.exports["AdminModal"] = $f58f5052b341dbb2$export$24cbef36aabf5e56;

});

parcelRegister("4LgCj", function(module, exports) {

var $hvvoj = parcelRequire("hvvoj");


var $buzAL = parcelRequire("buzAL");

const $53fbfe482eb8d8a0$export$41b5b6d6fbe1e6b6 = (bridge, args)=>{
    const { userConsentRequired: userConsentRequired } = args;
    return {
        refresh: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.refresh),
        submit: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.submit),
        open: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.open),
        close: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.close),
        onClose: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.onClose),
        openModal: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.openModal, {
            requiresUserConsent: userConsentRequired
        }),
        showFlag: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.showFlag),
        closeFlag: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.closeFlag),
        reconcile: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.reconcile),
        getFrameDispatch: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.getFrameDispatch),
        emitReadyEvent: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.emitReadyEvent),
        onError: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.onError),
        createHistory: ()=>(0, $hvvoj.createHistory)({
                history: bridge?.history,
                extensionBasePath: bridge?.extensionBasePath
            }),
        changeWindowTitle: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.changeWindowTitle),
        ...(0, $buzAL.getCreateBridgeApiPermissionFunctions)(bridge)
    };
};
const $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8 = (method, ...args)=>{
    return async (payload)=>{
        if (method) return method(payload, ...args) ?? true;
        return false;
    };
};
module.exports["createBridgeApi"] = $53fbfe482eb8d8a0$export$41b5b6d6fbe1e6b6;
module.exports["createBridgeMethod"] = $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8;

});

parcelRegister("dhMrf", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $6mbqJ = parcelRequire("6mbqJ");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $7MEO5 = parcelRequire("7MEO5");


var $kaOT1 = parcelRequire("kaOT1");


var $1Igmn = parcelRequire("1Igmn");

class $c2921b3ec001e75a$export$67e3479a9f34cffa extends Error {
}
const $c2921b3ec001e75a$export$cea4d5b903e9aab5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useForgeAppQuery() {
    const $ = (0, $frIzR.c)(3);
    const tracing = (0, $kaOT1.useTracingContext)();
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const environment = relayContext?.environment;
    let t0;
    if ($[0] !== environment || $[1] !== tracing) {
        t0 = async (appId, contextIds)=>{
            const appAri = (0, $7MEO5.createAppAri)({
                appId: appId
            }).toString();
            tracing?.recordGqlCall("APP_BY_ID_QUERY - start");
            return new Promise((resolve, reject)=>{
                if (environment) (0, $irOoi.fetchQuery)(environment, (0, $6mbqJ.default), {
                    appAri: appAri,
                    contextIds: contextIds
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                "atl-attribution": (0, $1Igmn.createAtlAttributionHeader)()
                            }
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve(data.app);
                    },
                    error: (error)=>{
                        const details = JSON.stringify(error);
                        reject(new $c2921b3ec001e75a$export$67e3479a9f34cffa(`Failed to fetch app data by its ID: ${appAri}, GraphQLError: ${details}`));
                    },
                    complete: ()=>{
                        tracing?.recordGqlCall("APP_BY_ID_QUERY - end");
                    }
                });
            });
        };
        $[0] = environment;
        $[1] = tracing;
        $[2] = t0;
    } else t0 = $[2];
    const fetchAppData = t0;
    return fetchAppData;
} : function useForgeAppQuery() {
    const tracing = (0, $kaOT1.useTracingContext)();
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const environment = relayContext?.environment;
    const fetchAppData = async (appId, contextIds)=>{
        const appAri = (0, $7MEO5.createAppAri)({
            appId: appId
        }).toString();
        tracing?.recordGqlCall('APP_BY_ID_QUERY - start');
        // TODO move query fragment into AdminConsentModal.tsx
        return new Promise((resolve, reject)=>{
            if (environment) (0, $irOoi.fetchQuery)(environment, (0, $6mbqJ.default), {
                appAri: appAri,
                contextIds: contextIds
            }, {
                networkCacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                        }
                    }
                }
            }).subscribe({
                next: (data)=>{
                    resolve(data.app);
                },
                error: (error)=>{
                    const details = JSON.stringify(error);
                    reject(new $c2921b3ec001e75a$export$67e3479a9f34cffa(`Failed to fetch app data by its ID: ${appAri}, GraphQLError: ${details}`));
                },
                complete: ()=>{
                    tracing?.recordGqlCall('APP_BY_ID_QUERY - end');
                }
            });
        });
    };
    return fetchAppData;
};
module.exports["useForgeAppQuery"] = $c2921b3ec001e75a$export$cea4d5b903e9aab5;

});

parcelRegister("46zjh", function(module, exports) {
/**
 * @generated SignedSource<<54cacd868d486df8b9e16a54c838040b>>
 * @relayHash 1ddb7206934ab3dcd1cf0292ff839f9d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ddbf791d2d018cacdc833e0d1652f1d86228e3ac6814a7974f843771169ae3ee
const $0e44439ff8369d8c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ForgeDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ForgeDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ddbf791d2d018cacdc833e0d1652f1d86228e3ac6814a7974f843771169ae3ee",
            "metadata": {},
            "name": "ForgeDeprecationMessage_appQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0e44439ff8369d8c$var$node.hash = "06c66e4e27413d7a6996129034e23a82";
var $0e44439ff8369d8c$export$2e2bcd8739ae039 = $0e44439ff8369d8c$var$node;
module.exports["default"] = $0e44439ff8369d8c$export$2e2bcd8739ae039;

});

parcelRegister("dClXj", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $77bb5e7ce6fe0664$export$efd8f108e163181c extends (0, $42omo.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    render() {
        return this.state.hasError ? this.props.fallback : this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
module.exports["RelayErrorBoundary"] = $77bb5e7ce6fe0664$export$efd8f108e163181c;

});

parcelRegister("iRhnt", function(module, exports) {
/**
 * Utilities for JWT token decoding and comparison logic used in shadow invocation feature
 */ 
var $6oQb1 = parcelRequire("6oQb1");

function $bf12390738a3ef23$export$96751ef617237d7e(jwt) {
    if (!jwt) return undefined;
    try {
        const payload = jwt.split('.')[1];
        if (!payload) return undefined;
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
        return JSON.parse(atob(padded));
    } catch (e) {
        return undefined;
    }
}
/**
 * Checks if a value is a plain object (not array, null, or primitive)
 * @param value - The value to check
 * @returns True if the value is a plain object
 */ function $bf12390738a3ef23$var$isPlainObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
/**
 * Recursively compares two objects and returns the differences
 * @param shadow - The shadow object to compare
 * @param regular - The regular object to compare
 * @param path - The current path in the object hierarchy
 * @param result - The result object to accumulate differences
 */ function $bf12390738a3ef23$var$visitObjectDifferences(shadow, regular, path, result) {
    const sObj = $bf12390738a3ef23$var$isPlainObject(shadow) ? shadow : {};
    const rObj = $bf12390738a3ef23$var$isPlainObject(regular) ? regular : {};
    const sKeys = new Set(Object.keys(sObj));
    const rKeys = new Set(Object.keys(rObj));
    // Find keys only in shadow
    sKeys.forEach((k)=>{
        if (!rKeys.has(k)) result.onlyInShadow.push([
            ...path,
            k
        ].join('.'));
    });
    // Find keys only in regular
    rKeys.forEach((k)=>{
        if (!sKeys.has(k)) result.onlyInRegular.push([
            ...path,
            k
        ].join('.'));
    });
    // Compare common keys
    sKeys.forEach((k)=>{
        if (!rKeys.has(k)) return;
        const sv = sObj[k];
        const rv = rObj[k];
        if ($bf12390738a3ef23$var$isPlainObject(sv) && $bf12390738a3ef23$var$isPlainObject(rv)) $bf12390738a3ef23$var$visitObjectDifferences(sv, rv, [
            ...path,
            k
        ], result);
        else if (JSON.stringify(sv) !== JSON.stringify(rv)) result.mismatchedValues.push({
            key: [
                ...path,
                k
            ].join('.'),
            shadow: sv,
            regular: rv
        });
    });
}
function $bf12390738a3ef23$export$c88750430cbf4afc(shadowToken, regularToken) {
    const shadow = shadowToken?.context || {};
    const regular = regularToken?.context || {};
    const result = {
        onlyInShadow: [],
        onlyInRegular: [],
        mismatchedValues: []
    };
    $bf12390738a3ef23$var$visitObjectDifferences(shadow, regular, [], result);
    return result;
}
function $bf12390738a3ef23$export$ad8401ab212af28d(differences) {
    const allDifferingKeys = new Set();
    // Add keys that are only in shadow token
    differences.onlyInShadow.forEach((key)=>allDifferingKeys.add(key));
    // Add keys that are only in regular token
    differences.onlyInRegular.forEach((key)=>allDifferingKeys.add(key));
    // Add keys that have mismatched values
    differences.mismatchedValues.forEach((mismatch)=>allDifferingKeys.add(mismatch.key));
    // Return sorted array for consistent output
    return Array.from(allDifferingKeys).sort();
}
function $bf12390738a3ef23$export$6c4ccde2488ac6b8(differences) {
    const keyValues = {};
    // Keys only in shadow token
    differences.onlyInShadow.forEach((key)=>{
        keyValues[key] = {
            shadow: 'present',
            regular: undefined
        };
    });
    // Keys only in regular token
    differences.onlyInRegular.forEach((key)=>{
        keyValues[key] = {
            regular: 'present',
            shadow: undefined
        };
    });
    // Keys with mismatched values
    differences.mismatchedValues.forEach((mismatch)=>{
        keyValues[mismatch.key] = {
            regular: mismatch.regular,
            shadow: mismatch.shadow
        };
    });
    return keyValues;
}
function $bf12390738a3ef23$export$91cd38f87a379a31(shadowToken, regularToken) {
    const shadow = shadowToken || {};
    const regular = regularToken || {};
    const result = {
        onlyInShadow: [],
        onlyInRegular: [],
        mismatchedValues: []
    };
    $bf12390738a3ef23$var$visitObjectDifferences(shadow, regular, [], result);
    return result;
}
function $bf12390738a3ef23$export$ce683f7fc0bd28b1(differences, regularToken) {
    const mismatchesEmpty = differences.mismatchedValues.length === 0;
    const onlyInRegularOk = differences.onlyInRegular.length <= 1;
    if (!mismatchesEmpty || !onlyInRegularOk) return false;
    if (differences.onlyInRegular.length === 1) {
        const onlyKey = differences.onlyInRegular[0];
        // When using context-only paths, this should be 'extension.content.subtype'
        const regularCtx = regularToken?.context || {};
        const regularSubtype = regularCtx?.extension?.content?.subtype;
        return onlyKey === 'extension.content.subtype' && regularSubtype === null;
    }
    // No differences inside context
    return true;
}
function $bf12390738a3ef23$export$86c16fc1ae19506b(differences, useShadow, regularResponse, shadowResponse) {
    const differingKeys = $bf12390738a3ef23$export$ad8401ab212af28d(differences);
    const differingKeysWithValues = $bf12390738a3ef23$export$6c4ccde2488ac6b8(differences);
    const hasDifferences = differingKeys.length > 0;
    return {
        action: 'contextTokenComparison',
        actionSubject: 'forge.ui.invocation',
        source: 'forge.ui.iframe',
        attributes: {
            comparisonResult: hasDifferences ? 'different' : 'same',
            hasDifferences: hasDifferences,
            differenceCount: differingKeys.length,
            differingKeys: differingKeys,
            differingKeysWithValues: // Flat array of actionable key paths
            differingKeysWithValues,
            // Detailed values for each differing key
            onlyInRegularCount: differences.onlyInRegular.length,
            onlyInShadowCount: differences.onlyInShadow.length,
            mismatchedValuesCount: differences.mismatchedValues.length,
            useShadowResponse: useShadow,
            extensionId: regularResponse.extensionId || shadowResponse.extensionId,
            extensionType: regularResponse.extensionType || shadowResponse.extensionType
        }
    };
}
function $bf12390738a3ef23$export$782f13e8807e97e6(regularResponse, shadowResponse, createAnalyticsEvent) {
    if (!shadowResponse || !regularResponse) return regularResponse;
    const decodedTokens = {
        shadow: $bf12390738a3ef23$export$96751ef617237d7e(shadowResponse.contextToken?.jwt),
        regular: $bf12390738a3ef23$export$96751ef617237d7e(regularResponse.contextToken?.jwt)
    };
    // Use context-only comparison for the decision logic (existing behavior)
    const contextDifferences = $bf12390738a3ef23$export$c88750430cbf4afc(decodedTokens.shadow, decodedTokens.regular);
    const useShadow = $bf12390738a3ef23$export$ce683f7fc0bd28b1(contextDifferences, decodedTokens.regular);
    if (createAnalyticsEvent) {
        // Use full token comparison for comprehensive analytics
        const fullDifferences = $bf12390738a3ef23$export$91cd38f87a379a31(decodedTokens.shadow, decodedTokens.regular);
        const analyticsPayload = $bf12390738a3ef23$export$86c16fc1ae19506b(fullDifferences, useShadow, regularResponse, shadowResponse);
        (0, $6oQb1.fireEvent)(createAnalyticsEvent, analyticsPayload);
    }
    return useShadow ? shadowResponse : regularResponse;
}
module.exports["decodeJwtPayload"] = $bf12390738a3ef23$export$96751ef617237d7e;

});

parcelRegister("4Ybnb", function(module, exports) {
!function(e) {
    var t;
    module.exports = e();
}(function() {
    return (function r(o, i, u) {
        function s(n, e) {
            if (!i[n]) {
                if (!o[n]) {
                    var t = undefined;
                    if (!e && t) return t(n, !0);
                    if (a) return a(n, !0);
                    throw new Error("Cannot find module '" + n + "'");
                }
                e = i[n] = {
                    exports: {}
                };
                o[n][0].call(e.exports, function(e) {
                    var t = o[n][1][e];
                    return s(t || e);
                }, e, e.exports, r, o, i, u);
            }
            return i[n].exports;
        }
        for(var a = undefined, e = 0; e < u.length; e++)s(u[e]);
        return s;
    })({
        1: [
            function(w, b, m) {
                (function(e, n, s, c, d, h, p, g, y) {
                    "use strict";
                    var r = w("crypto");
                    function t(e, t) {
                        t = u(e, t);
                        var n;
                        return void 0 === (n = "passthrough" !== t.algorithm ? r.createHash(t.algorithm) : new l).write && (n.write = n.update, n.end = n.update), f(t, n).dispatch(e), n.update || n.end(""), n.digest ? n.digest("buffer" === t.encoding ? void 0 : t.encoding) : (e = n.read(), "buffer" !== t.encoding ? e.toString(t.encoding) : e);
                    }
                    (m = b.exports = t).sha1 = function(e) {
                        return t(e);
                    }, m.keys = function(e) {
                        return t(e, {
                            excludeValues: !0,
                            algorithm: "sha1",
                            encoding: "hex"
                        });
                    }, m.MD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex"
                        });
                    }, m.keysMD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex",
                            excludeValues: !0
                        });
                    };
                    var o = r.getHashes ? r.getHashes().slice() : [
                        "sha1",
                        "md5"
                    ], i = (o.push("passthrough"), [
                        "buffer",
                        "hex",
                        "binary",
                        "base64"
                    ]);
                    function u(e, t) {
                        var n = {};
                        if (n.algorithm = (t = t || {}).algorithm || "sha1", n.encoding = t.encoding || "hex", n.excludeValues = !!t.excludeValues, n.algorithm = n.algorithm.toLowerCase(), n.encoding = n.encoding.toLowerCase(), n.ignoreUnknown = !0 === t.ignoreUnknown, n.respectType = !1 !== t.respectType, n.respectFunctionNames = !1 !== t.respectFunctionNames, n.respectFunctionProperties = !1 !== t.respectFunctionProperties, n.unorderedArrays = !0 === t.unorderedArrays, n.unorderedSets = !1 !== t.unorderedSets, n.unorderedObjects = !1 !== t.unorderedObjects, n.replacer = t.replacer || void 0, n.excludeKeys = t.excludeKeys || void 0, void 0 === e) throw new Error("Object argument required.");
                        for(var r = 0; r < o.length; ++r)o[r].toLowerCase() === n.algorithm.toLowerCase() && (n.algorithm = o[r]);
                        if (-1 === o.indexOf(n.algorithm)) throw new Error('Algorithm "' + n.algorithm + '"  not supported. supported values: ' + o.join(", "));
                        if (-1 === i.indexOf(n.encoding) && "passthrough" !== n.algorithm) throw new Error('Encoding "' + n.encoding + '"  not supported. supported values: ' + i.join(", "));
                        return n;
                    }
                    function a(e) {
                        if ("function" == typeof e) return null != /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(e));
                    }
                    function f(o, t, i) {
                        i = i || [];
                        function u(e) {
                            return t.update ? t.update(e, "utf8") : t.write(e, "utf8");
                        }
                        return {
                            dispatch: function(e) {
                                return this["_" + (null === (e = o.replacer ? o.replacer(e) : e) ? "null" : typeof e)](e);
                            },
                            _object: function(t) {
                                var n, e = Object.prototype.toString.call(t), r = /\[object (.*)\]/i.exec(e);
                                r = (r = r ? r[1] : "unknown:[" + e + "]").toLowerCase();
                                if (0 <= (e = i.indexOf(t))) return this.dispatch("[CIRCULAR:" + e + "]");
                                if (i.push(t), void 0 !== s && s.isBuffer && s.isBuffer(t)) return u("buffer:"), u(t);
                                if ("object" === r || "function" === r || "asyncfunction" === r) return e = Object.keys(t), o.unorderedObjects && (e = e.sort()), !1 === o.respectType || a(t) || e.splice(0, 0, "prototype", "__proto__", "constructor"), o.excludeKeys && (e = e.filter(function(e) {
                                    return !o.excludeKeys(e);
                                })), u("object:" + e.length + ":"), n = this, e.forEach(function(e) {
                                    n.dispatch(e), u(":"), o.excludeValues || n.dispatch(t[e]), u(",");
                                });
                                if (!this["_" + r]) {
                                    if (o.ignoreUnknown) return u("[" + r + "]");
                                    throw new Error('Unknown object type "' + r + '"');
                                }
                                this["_" + r](t);
                            },
                            _array: function(e, t) {
                                t = void 0 !== t ? t : !1 !== o.unorderedArrays;
                                var n = this;
                                if (u("array:" + e.length + ":"), !t || e.length <= 1) return e.forEach(function(e) {
                                    return n.dispatch(e);
                                });
                                var r = [], t = e.map(function(e) {
                                    var t = new l, n = i.slice();
                                    return f(o, t, n).dispatch(e), r = r.concat(n.slice(i.length)), t.read().toString();
                                });
                                return i = i.concat(r), t.sort(), this._array(t, !1);
                            },
                            _date: function(e) {
                                return u("date:" + e.toJSON());
                            },
                            _symbol: function(e) {
                                return u("symbol:" + e.toString());
                            },
                            _error: function(e) {
                                return u("error:" + e.toString());
                            },
                            _boolean: function(e) {
                                return u("bool:" + e.toString());
                            },
                            _string: function(e) {
                                u("string:" + e.length + ":"), u(e.toString());
                            },
                            _function: function(e) {
                                u("fn:"), a(e) ? this.dispatch("[native]") : this.dispatch(e.toString()), !1 !== o.respectFunctionNames && this.dispatch("function-name:" + String(e.name)), o.respectFunctionProperties && this._object(e);
                            },
                            _number: function(e) {
                                return u("number:" + e.toString());
                            },
                            _xml: function(e) {
                                return u("xml:" + e.toString());
                            },
                            _null: function() {
                                return u("Null");
                            },
                            _undefined: function() {
                                return u("Undefined");
                            },
                            _regexp: function(e) {
                                return u("regex:" + e.toString());
                            },
                            _uint8array: function(e) {
                                return u("uint8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint8clampedarray: function(e) {
                                return u("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int8array: function(e) {
                                return u("int8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint16array: function(e) {
                                return u("uint16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int16array: function(e) {
                                return u("int16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint32array: function(e) {
                                return u("uint32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int32array: function(e) {
                                return u("int32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float32array: function(e) {
                                return u("float32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float64array: function(e) {
                                return u("float64array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _arraybuffer: function(e) {
                                return u("arraybuffer:"), this.dispatch(new Uint8Array(e));
                            },
                            _url: function(e) {
                                return u("url:" + e.toString());
                            },
                            _map: function(e) {
                                u("map:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _set: function(e) {
                                u("set:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _file: function(e) {
                                return u("file:"), this.dispatch([
                                    e.name,
                                    e.size,
                                    e.type,
                                    e.lastModfied
                                ]);
                            },
                            _blob: function() {
                                if (o.ignoreUnknown) return u("[blob]");
                                throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n');
                            },
                            _domwindow: function() {
                                return u("domwindow");
                            },
                            _bigint: function(e) {
                                return u("bigint:" + e.toString());
                            },
                            _process: function() {
                                return u("process");
                            },
                            _timer: function() {
                                return u("timer");
                            },
                            _pipe: function() {
                                return u("pipe");
                            },
                            _tcp: function() {
                                return u("tcp");
                            },
                            _udp: function() {
                                return u("udp");
                            },
                            _tty: function() {
                                return u("tty");
                            },
                            _statwatcher: function() {
                                return u("statwatcher");
                            },
                            _securecontext: function() {
                                return u("securecontext");
                            },
                            _connection: function() {
                                return u("connection");
                            },
                            _zlib: function() {
                                return u("zlib");
                            },
                            _context: function() {
                                return u("context");
                            },
                            _nodescript: function() {
                                return u("nodescript");
                            },
                            _httpparser: function() {
                                return u("httpparser");
                            },
                            _dataview: function() {
                                return u("dataview");
                            },
                            _signal: function() {
                                return u("signal");
                            },
                            _fsevent: function() {
                                return u("fsevent");
                            },
                            _tlswrap: function() {
                                return u("tlswrap");
                            }
                        };
                    }
                    function l() {
                        return {
                            buf: "",
                            write: function(e) {
                                this.buf += e;
                            },
                            end: function(e) {
                                this.buf += e;
                            },
                            read: function() {
                                return this.buf;
                            }
                        };
                    }
                    m.writeToStream = function(e, t, n) {
                        return void 0 === n && (n = t, t = {}), f(t = u(e, t), n).dispatch(e);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
            },
            {
                buffer: 3,
                crypto: 5,
                lYpoI2: 11
            }
        ],
        2: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    !function(e) {
                        "use strict";
                        var a = "undefined" != typeof Uint8Array ? Uint8Array : Array, t = "+".charCodeAt(0), n = "/".charCodeAt(0), r = "0".charCodeAt(0), o = "a".charCodeAt(0), i = "A".charCodeAt(0), u = "-".charCodeAt(0), s = "_".charCodeAt(0);
                        function f(e) {
                            e = e.charCodeAt(0);
                            return e === t || e === u ? 62 : e === n || e === s ? 63 : e < r ? -1 : e < r + 10 ? e - r + 26 + 26 : e < i + 26 ? e - i : e < o + 26 ? e - o + 26 : void 0;
                        }
                        e.toByteArray = function(e) {
                            var t, n;
                            if (0 < e.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                            var r = e.length, r = "=" === e.charAt(r - 2) ? 2 : "=" === e.charAt(r - 1) ? 1 : 0, o = new a(3 * e.length / 4 - r), i = 0 < r ? e.length - 4 : e.length, u = 0;
                            function s(e) {
                                o[u++] = e;
                            }
                            for(t = 0; t < i; t += 4)s((16711680 & (n = f(e.charAt(t)) << 18 | f(e.charAt(t + 1)) << 12 | f(e.charAt(t + 2)) << 6 | f(e.charAt(t + 3)))) >> 16), s((65280 & n) >> 8), s(255 & n);
                            return 2 == r ? s(255 & (n = f(e.charAt(t)) << 2 | f(e.charAt(t + 1)) >> 4)) : 1 == r && (s((n = f(e.charAt(t)) << 10 | f(e.charAt(t + 1)) << 4 | f(e.charAt(t + 2)) >> 2) >> 8 & 255), s(255 & n)), o;
                        }, e.fromByteArray = function(e) {
                            var t, n, r, o, i = e.length % 3, u = "";
                            function s(e) {
                                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e);
                            }
                            for(t = 0, r = e.length - i; t < r; t += 3)n = (e[t] << 16) + (e[t + 1] << 8) + e[t + 2], u += s((o = n) >> 18 & 63) + s(o >> 12 & 63) + s(o >> 6 & 63) + s(63 & o);
                            switch(i){
                                case 1:
                                    u = (u += s((n = e[e.length - 1]) >> 2)) + s(n << 4 & 63) + "==";
                                    break;
                                case 2:
                                    u = (u = (u += s((n = (e[e.length - 2] << 8) + e[e.length - 1]) >> 10)) + s(n >> 4 & 63)) + s(n << 2 & 63) + "=";
                            }
                            return u;
                        };
                    }(void 0 === f ? this.base64js = {} : f);
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        3: [
            function(O, e, H) {
                (function(e, n, f, r, h, p, g, y, w) {
                    var a = O("base64-js"), i = O("ieee754");
                    function f(e, t, n) {
                        if (!(this instanceof f)) return new f(e, t, n);
                        var r, o, i, u, s = typeof e;
                        if ("base64" === t && "string" == s) for(e = (u = e).trim ? u.trim() : u.replace(/^\s+|\s+$/g, ""); e.length % 4 != 0;)e += "=";
                        if ("number" == s) r = j(e);
                        else if ("string" == s) r = f.byteLength(e, t);
                        else {
                            if ("object" != s) throw new Error("First argument needs to be a number, array or string.");
                            r = j(e.length);
                        }
                        if (f._useTypedArrays ? o = f._augment(new Uint8Array(r)) : ((o = this).length = r, o._isBuffer = !0), f._useTypedArrays && "number" == typeof e.byteLength) o._set(e);
                        else if (C(u = e) || f.isBuffer(u) || u && "object" == typeof u && "number" == typeof u.length) for(i = 0; i < r; i++)f.isBuffer(e) ? o[i] = e.readUInt8(i) : o[i] = e[i];
                        else if ("string" == s) o.write(e, 0, t);
                        else if ("number" == s && !f._useTypedArrays && !n) for(i = 0; i < r; i++)o[i] = 0;
                        return o;
                    }
                    function b(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t = [], n = 0; n < e.length; n++)t.push(255 & e.charCodeAt(n));
                            return t;
                        }(t), e, n, r);
                    }
                    function m(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t, n, r = [], o = 0; o < e.length; o++)n = e.charCodeAt(o), t = n >> 8, n = n % 256, r.push(n), r.push(t);
                            return r;
                        }(t), e, n, r);
                    }
                    function v(e, t, n) {
                        var r = "";
                        n = Math.min(e.length, n);
                        for(var o = t; o < n; o++)r += String.fromCharCode(e[o]);
                        return r;
                    }
                    function o(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (o = e[t], t + 1 < r && (o |= e[t + 1] << 8)) : (o = e[t] << 8, t + 1 < r && (o |= e[t + 1])), o;
                    }
                    function u(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (t + 2 < r && (o = e[t + 2] << 16), t + 1 < r && (o |= e[t + 1] << 8), o |= e[t], t + 3 < r && (o += e[t + 3] << 24 >>> 0)) : (t + 1 < r && (o = e[t + 1] << 16), t + 2 < r && (o |= e[t + 2] << 8), t + 3 < r && (o |= e[t + 3]), o += e[t] << 24 >>> 0), o;
                    }
                    function _(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = o(e, t, n, !0), 32768 & r ? -1 * (65535 - r + 1) : r;
                    }
                    function E(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = u(e, t, n, !0), 2147483648 & r ? -1 * (4294967295 - r + 1) : r;
                    }
                    function I(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 3 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 23, 4);
                    }
                    function A(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 7 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 52, 8);
                    }
                    function s(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "trying to write beyond buffer length"), Y(t, 65535));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 2); i < u; i++)e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
                    }
                    function l(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "trying to write beyond buffer length"), Y(t, 4294967295));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 4); i < u; i++)e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
                    }
                    function B(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "Trying to write beyond buffer length"), F(t, 32767, -32768)), e.length <= n || s(e, 0 <= t ? t : 65535 + t + 1, n, r, o);
                    }
                    function L(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), F(t, 2147483647, -2147483648)), e.length <= n || l(e, 0 <= t ? t : 4294967295 + t + 1, n, r, o);
                    }
                    function U(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), D(t, 34028234663852886e22, -3.4028234663852886e+38)), e.length <= n || i.write(e, t, n, r, 23, 4);
                    }
                    function x(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 7 < e.length, "Trying to write beyond buffer length"), D(t, 17976931348623157e292, -1.7976931348623157e+308)), e.length <= n || i.write(e, t, n, r, 52, 8);
                    }
                    H.Buffer = f, H.SlowBuffer = f, H.INSPECT_MAX_BYTES = 50, f.poolSize = 8192, f._useTypedArrays = function() {
                        try {
                            var e = new ArrayBuffer(0), t = new Uint8Array(e);
                            return t.foo = function() {
                                return 42;
                            }, 42 === t.foo() && "function" == typeof t.subarray;
                        } catch (e) {
                            return !1;
                        }
                    }(), f.isEncoding = function(e) {
                        switch(String(e).toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "binary":
                            case "base64":
                            case "raw":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return !0;
                            default:
                                return !1;
                        }
                    }, f.isBuffer = function(e) {
                        return !(null == e || !e._isBuffer);
                    }, f.byteLength = function(e, t) {
                        var n;
                        switch(e += "", t || "utf8"){
                            case "hex":
                                n = e.length / 2;
                                break;
                            case "utf8":
                            case "utf-8":
                                n = T(e).length;
                                break;
                            case "ascii":
                            case "binary":
                            case "raw":
                                n = e.length;
                                break;
                            case "base64":
                                n = M(e).length;
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                n = 2 * e.length;
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return n;
                    }, f.concat = function(e, t) {
                        if (d(C(e), "Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."), 0 === e.length) return new f(0);
                        if (1 === e.length) return e[0];
                        if ("number" != typeof t) for(o = t = 0; o < e.length; o++)t += e[o].length;
                        for(var n = new f(t), r = 0, o = 0; o < e.length; o++){
                            var i = e[o];
                            i.copy(n, r), r += i.length;
                        }
                        return n;
                    }, f.prototype.write = function(e, t, n, r) {
                        isFinite(t) ? isFinite(n) || (r = n, n = void 0) : (a = r, r = t, t = n, n = a), t = Number(t) || 0;
                        var o, i, u, s, a = this.length - t;
                        switch((!n || a < (n = Number(n))) && (n = a), r = String(r || "utf8").toLowerCase()){
                            case "hex":
                                o = function(e, t, n, r) {
                                    n = Number(n) || 0;
                                    var o = e.length - n;
                                    (!r || o < (r = Number(r))) && (r = o), d((o = t.length) % 2 == 0, "Invalid hex string"), o / 2 < r && (r = o / 2);
                                    for(var i = 0; i < r; i++){
                                        var u = parseInt(t.substr(2 * i, 2), 16);
                                        d(!isNaN(u), "Invalid hex string"), e[n + i] = u;
                                    }
                                    return f._charsWritten = 2 * i, i;
                                }(this, e, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                i = this, u = t, s = n, o = f._charsWritten = c(T(e), i, u, s);
                                break;
                            case "ascii":
                            case "binary":
                                o = b(this, e, t, n);
                                break;
                            case "base64":
                                i = this, u = t, s = n, o = f._charsWritten = c(M(e), i, u, s);
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                o = m(this, e, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return o;
                    }, f.prototype.toString = function(e, t, n) {
                        var r, o, i, u, s = this;
                        if (e = String(e || "utf8").toLowerCase(), t = Number(t) || 0, (n = void 0 !== n ? Number(n) : s.length) === t) return "";
                        switch(e){
                            case "hex":
                                r = function(e, t, n) {
                                    var r = e.length;
                                    (!t || t < 0) && (t = 0);
                                    (!n || n < 0 || r < n) && (n = r);
                                    for(var o = "", i = t; i < n; i++)o += k(e[i]);
                                    return o;
                                }(s, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                r = function(e, t, n) {
                                    var r = "", o = "";
                                    n = Math.min(e.length, n);
                                    for(var i = t; i < n; i++)e[i] <= 127 ? (r += N(o) + String.fromCharCode(e[i]), o = "") : o += "%" + e[i].toString(16);
                                    return r + N(o);
                                }(s, t, n);
                                break;
                            case "ascii":
                            case "binary":
                                r = v(s, t, n);
                                break;
                            case "base64":
                                o = s, u = n, r = 0 === (i = t) && u === o.length ? a.fromByteArray(o) : a.fromByteArray(o.slice(i, u));
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                r = function(e, t, n) {
                                    for(var r = e.slice(t, n), o = "", i = 0; i < r.length; i += 2)o += String.fromCharCode(r[i] + 256 * r[i + 1]);
                                    return o;
                                }(s, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return r;
                    }, f.prototype.toJSON = function() {
                        return {
                            type: "Buffer",
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    }, f.prototype.copy = function(e, t, n, r) {
                        if (t = t || 0, (r = r || 0 === r ? r : this.length) !== (n = n || 0) && 0 !== e.length && 0 !== this.length) {
                            d(n <= r, "sourceEnd < sourceStart"), d(0 <= t && t < e.length, "targetStart out of bounds"), d(0 <= n && n < this.length, "sourceStart out of bounds"), d(0 <= r && r <= this.length, "sourceEnd out of bounds"), r > this.length && (r = this.length);
                            var o = (r = e.length - t < r - n ? e.length - t + n : r) - n;
                            if (o < 100 || !f._useTypedArrays) for(var i = 0; i < o; i++)e[i + t] = this[i + n];
                            else e._set(this.subarray(n, n + o), t);
                        }
                    }, f.prototype.slice = function(e, t) {
                        var n = this.length;
                        if (e = S(e, n, 0), t = S(t, n, n), f._useTypedArrays) return f._augment(this.subarray(e, t));
                        for(var r = t - e, o = new f(r, void 0, !0), i = 0; i < r; i++)o[i] = this[i + e];
                        return o;
                    }, f.prototype.get = function(e) {
                        return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e);
                    }, f.prototype.set = function(e, t) {
                        return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e, t);
                    }, f.prototype.readUInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return this[e];
                    }, f.prototype.readUInt16LE = function(e, t) {
                        return o(this, e, !0, t);
                    }, f.prototype.readUInt16BE = function(e, t) {
                        return o(this, e, !1, t);
                    }, f.prototype.readUInt32LE = function(e, t) {
                        return u(this, e, !0, t);
                    }, f.prototype.readUInt32BE = function(e, t) {
                        return u(this, e, !1, t);
                    }, f.prototype.readInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                    }, f.prototype.readInt16LE = function(e, t) {
                        return _(this, e, !0, t);
                    }, f.prototype.readInt16BE = function(e, t) {
                        return _(this, e, !1, t);
                    }, f.prototype.readInt32LE = function(e, t) {
                        return E(this, e, !0, t);
                    }, f.prototype.readInt32BE = function(e, t) {
                        return E(this, e, !1, t);
                    }, f.prototype.readFloatLE = function(e, t) {
                        return I(this, e, !0, t);
                    }, f.prototype.readFloatBE = function(e, t) {
                        return I(this, e, !1, t);
                    }, f.prototype.readDoubleLE = function(e, t) {
                        return A(this, e, !0, t);
                    }, f.prototype.readDoubleBE = function(e, t) {
                        return A(this, e, !1, t);
                    }, f.prototype.writeUInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "trying to write beyond buffer length"), Y(e, 255)), t >= this.length || (this[t] = e);
                    }, f.prototype.writeUInt16LE = function(e, t, n) {
                        s(this, e, t, !0, n);
                    }, f.prototype.writeUInt16BE = function(e, t, n) {
                        s(this, e, t, !1, n);
                    }, f.prototype.writeUInt32LE = function(e, t, n) {
                        l(this, e, t, !0, n);
                    }, f.prototype.writeUInt32BE = function(e, t, n) {
                        l(this, e, t, !1, n);
                    }, f.prototype.writeInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "Trying to write beyond buffer length"), F(e, 127, -128)), t >= this.length || (0 <= e ? this.writeUInt8(e, t, n) : this.writeUInt8(255 + e + 1, t, n));
                    }, f.prototype.writeInt16LE = function(e, t, n) {
                        B(this, e, t, !0, n);
                    }, f.prototype.writeInt16BE = function(e, t, n) {
                        B(this, e, t, !1, n);
                    }, f.prototype.writeInt32LE = function(e, t, n) {
                        L(this, e, t, !0, n);
                    }, f.prototype.writeInt32BE = function(e, t, n) {
                        L(this, e, t, !1, n);
                    }, f.prototype.writeFloatLE = function(e, t, n) {
                        U(this, e, t, !0, n);
                    }, f.prototype.writeFloatBE = function(e, t, n) {
                        U(this, e, t, !1, n);
                    }, f.prototype.writeDoubleLE = function(e, t, n) {
                        x(this, e, t, !0, n);
                    }, f.prototype.writeDoubleBE = function(e, t, n) {
                        x(this, e, t, !1, n);
                    }, f.prototype.fill = function(e, t, n) {
                        if (t = t || 0, n = n || this.length, d("number" == typeof (e = "string" == typeof (e = e || 0) ? e.charCodeAt(0) : e) && !isNaN(e), "value is not a number"), d(t <= n, "end < start"), n !== t && 0 !== this.length) {
                            d(0 <= t && t < this.length, "start out of bounds"), d(0 <= n && n <= this.length, "end out of bounds");
                            for(var r = t; r < n; r++)this[r] = e;
                        }
                    }, f.prototype.inspect = function() {
                        for(var e = [], t = this.length, n = 0; n < t; n++)if (e[n] = k(this[n]), n === H.INSPECT_MAX_BYTES) {
                            e[n + 1] = "...";
                            break;
                        }
                        return "<Buffer " + e.join(" ") + ">";
                    }, f.prototype.toArrayBuffer = function() {
                        if ("undefined" == typeof Uint8Array) throw new Error("Buffer.toArrayBuffer not supported in this browser");
                        if (f._useTypedArrays) return new f(this).buffer;
                        for(var e = new Uint8Array(this.length), t = 0, n = e.length; t < n; t += 1)e[t] = this[t];
                        return e.buffer;
                    };
                    var t = f.prototype;
                    function S(e, t, n) {
                        return "number" != typeof e ? n : t <= (e = ~~e) ? t : 0 <= e || 0 <= (e += t) ? e : 0;
                    }
                    function j(e) {
                        return (e = ~~Math.ceil(+e)) < 0 ? 0 : e;
                    }
                    function C(e) {
                        return (Array.isArray || function(e) {
                            return "[object Array]" === Object.prototype.toString.call(e);
                        })(e);
                    }
                    function k(e) {
                        return e < 16 ? "0" + e.toString(16) : e.toString(16);
                    }
                    function T(e) {
                        for(var t = [], n = 0; n < e.length; n++){
                            var r = e.charCodeAt(n);
                            if (r <= 127) t.push(e.charCodeAt(n));
                            else for(var o = n, i = (55296 <= r && r <= 57343 && n++, encodeURIComponent(e.slice(o, n + 1)).substr(1).split("%")), u = 0; u < i.length; u++)t.push(parseInt(i[u], 16));
                        }
                        return t;
                    }
                    function M(e) {
                        return a.toByteArray(e);
                    }
                    function c(e, t, n, r) {
                        for(var o = 0; o < r && !(o + n >= t.length || o >= e.length); o++)t[o + n] = e[o];
                        return o;
                    }
                    function N(e) {
                        try {
                            return decodeURIComponent(e);
                        } catch (e) {
                            return String.fromCharCode(65533);
                        }
                    }
                    function Y(e, t) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(0 <= e, "specified a negative value for writing an unsigned value"), d(e <= t, "value is larger than maximum value for type"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function F(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function D(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value");
                    }
                    function d(e, t) {
                        if (!e) throw new Error(t || "Failed assertion");
                    }
                    f._augment = function(e) {
                        return e._isBuffer = !0, e._get = e.get, e._set = e.set, e.get = t.get, e.set = t.set, e.write = t.write, e.toString = t.toString, e.toLocaleString = t.toString, e.toJSON = t.toJSON, e.copy = t.copy, e.slice = t.slice, e.readUInt8 = t.readUInt8, e.readUInt16LE = t.readUInt16LE, e.readUInt16BE = t.readUInt16BE, e.readUInt32LE = t.readUInt32LE, e.readUInt32BE = t.readUInt32BE, e.readInt8 = t.readInt8, e.readInt16LE = t.readInt16LE, e.readInt16BE = t.readInt16BE, e.readInt32LE = t.readInt32LE, e.readInt32BE = t.readInt32BE, e.readFloatLE = t.readFloatLE, e.readFloatBE = t.readFloatBE, e.readDoubleLE = t.readDoubleLE, e.readDoubleBE = t.readDoubleBE, e.writeUInt8 = t.writeUInt8, e.writeUInt16LE = t.writeUInt16LE, e.writeUInt16BE = t.writeUInt16BE, e.writeUInt32LE = t.writeUInt32LE, e.writeUInt32BE = t.writeUInt32BE, e.writeInt8 = t.writeInt8, e.writeInt16LE = t.writeInt16LE, e.writeInt16BE = t.writeInt16BE, e.writeInt32LE = t.writeInt32LE, e.writeInt32BE = t.writeInt32BE, e.writeFloatLE = t.writeFloatLE, e.writeFloatBE = t.writeFloatBE, e.writeDoubleLE = t.writeDoubleLE, e.writeDoubleBE = t.writeDoubleBE, e.fill = t.fill, e.inspect = t.inspect, e.toArrayBuffer = t.toArrayBuffer, e;
                    };
                }).call(this, O("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, O("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
            },
            {
                "base64-js": 2,
                buffer: 3,
                ieee754: 10,
                lYpoI2: 11
            }
        ],
        4: [
            function(c, d, e) {
                (function(e, t, a, n, r, o, i, u, s) {
                    var a = c("buffer").Buffer, f = 4, l = new a(f);
                    l.fill(0);
                    d.exports = {
                        hash: function(e, t, n, r) {
                            for(var o = t(function(e, t) {
                                e.length % f != 0 && (n = e.length + (f - e.length % f), e = a.concat([
                                    e,
                                    l
                                ], n));
                                for(var n, r = [], o = t ? e.readInt32BE : e.readInt32LE, i = 0; i < e.length; i += f)r.push(o.call(e, i));
                                return r;
                            }(e = a.isBuffer(e) ? e : new a(e), r), 8 * e.length), t = r, i = new a(n), u = t ? i.writeInt32BE : i.writeInt32LE, s = 0; s < o.length; s++)u.call(i, o[s], 4 * s, !0);
                            return i;
                        }
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        5: [
            function(v, e, _) {
                (function(l, c, u, d, h, p, g, y, w) {
                    var u = v("buffer").Buffer, e = v("./sha"), t = v("./sha256"), n = v("./rng"), b = {
                        sha1: e,
                        sha256: t,
                        md5: v("./md5")
                    }, s = 64, a = new u(s);
                    function r(e, n) {
                        var r = b[e = e || "sha1"], o = [];
                        return r || i("algorithm:", e, "is not yet supported"), {
                            update: function(e) {
                                return u.isBuffer(e) || (e = new u(e)), o.push(e), e.length, this;
                            },
                            digest: function(e) {
                                var t = u.concat(o), t = n ? function(e, t, n) {
                                    u.isBuffer(t) || (t = new u(t)), u.isBuffer(n) || (n = new u(n)), t.length > s ? t = e(t) : t.length < s && (t = u.concat([
                                        t,
                                        a
                                    ], s));
                                    for(var r = new u(s), o = new u(s), i = 0; i < s; i++)r[i] = 54 ^ t[i], o[i] = 92 ^ t[i];
                                    return n = e(u.concat([
                                        r,
                                        n
                                    ])), e(u.concat([
                                        o,
                                        n
                                    ]));
                                }(r, n, t) : r(t);
                                return o = null, e ? t.toString(e) : t;
                            }
                        };
                    }
                    function i() {
                        var e = [].slice.call(arguments).join(" ");
                        throw new Error([
                            e,
                            "we accept pull requests",
                            "http://github.com/dominictarr/crypto-browserify"
                        ].join("\n"));
                    }
                    a.fill(0), _.createHash = function(e) {
                        return r(e);
                    }, _.createHmac = r, _.randomBytes = function(e, t) {
                        if (!t || !t.call) return new u(n(e));
                        try {
                            t.call(this, void 0, new u(n(e)));
                        } catch (e) {
                            t(e);
                        }
                    };
                    var o, f = [
                        "createCredentials",
                        "createCipher",
                        "createCipheriv",
                        "createDecipher",
                        "createDecipheriv",
                        "createSign",
                        "createVerify",
                        "createDiffieHellman",
                        "pbkdf2"
                    ], m = function(e) {
                        _[e] = function() {
                            i("sorry,", e, "is not implemented yet");
                        };
                    };
                    for(o in f)m(f[o], o);
                }).call(this, v("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, v("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./md5": 6,
                "./rng": 7,
                "./sha": 8,
                "./sha256": 9,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        6: [
            function(w, b, e) {
                (function(e, r, o, i, u, a, f, l, y) {
                    var t = w("./helpers");
                    function n(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
                        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, u = 0; u < e.length; u += 16){
                            var s = n, a = r, f = o, l = i, n = c(n, r, o, i, e[u + 0], 7, -680876936), i = c(i, n, r, o, e[u + 1], 12, -389564586), o = c(o, i, n, r, e[u + 2], 17, 606105819), r = c(r, o, i, n, e[u + 3], 22, -1044525330);
                            n = c(n, r, o, i, e[u + 4], 7, -176418897), i = c(i, n, r, o, e[u + 5], 12, 1200080426), o = c(o, i, n, r, e[u + 6], 17, -1473231341), r = c(r, o, i, n, e[u + 7], 22, -45705983), n = c(n, r, o, i, e[u + 8], 7, 1770035416), i = c(i, n, r, o, e[u + 9], 12, -1958414417), o = c(o, i, n, r, e[u + 10], 17, -42063), r = c(r, o, i, n, e[u + 11], 22, -1990404162), n = c(n, r, o, i, e[u + 12], 7, 1804603682), i = c(i, n, r, o, e[u + 13], 12, -40341101), o = c(o, i, n, r, e[u + 14], 17, -1502002290), n = d(n, r = c(r, o, i, n, e[u + 15], 22, 1236535329), o, i, e[u + 1], 5, -165796510), i = d(i, n, r, o, e[u + 6], 9, -1069501632), o = d(o, i, n, r, e[u + 11], 14, 643717713), r = d(r, o, i, n, e[u + 0], 20, -373897302), n = d(n, r, o, i, e[u + 5], 5, -701558691), i = d(i, n, r, o, e[u + 10], 9, 38016083), o = d(o, i, n, r, e[u + 15], 14, -660478335), r = d(r, o, i, n, e[u + 4], 20, -405537848), n = d(n, r, o, i, e[u + 9], 5, 568446438), i = d(i, n, r, o, e[u + 14], 9, -1019803690), o = d(o, i, n, r, e[u + 3], 14, -187363961), r = d(r, o, i, n, e[u + 8], 20, 1163531501), n = d(n, r, o, i, e[u + 13], 5, -1444681467), i = d(i, n, r, o, e[u + 2], 9, -51403784), o = d(o, i, n, r, e[u + 7], 14, 1735328473), n = h(n, r = d(r, o, i, n, e[u + 12], 20, -1926607734), o, i, e[u + 5], 4, -378558), i = h(i, n, r, o, e[u + 8], 11, -2022574463), o = h(o, i, n, r, e[u + 11], 16, 1839030562), r = h(r, o, i, n, e[u + 14], 23, -35309556), n = h(n, r, o, i, e[u + 1], 4, -1530992060), i = h(i, n, r, o, e[u + 4], 11, 1272893353), o = h(o, i, n, r, e[u + 7], 16, -155497632), r = h(r, o, i, n, e[u + 10], 23, -1094730640), n = h(n, r, o, i, e[u + 13], 4, 681279174), i = h(i, n, r, o, e[u + 0], 11, -358537222), o = h(o, i, n, r, e[u + 3], 16, -722521979), r = h(r, o, i, n, e[u + 6], 23, 76029189), n = h(n, r, o, i, e[u + 9], 4, -640364487), i = h(i, n, r, o, e[u + 12], 11, -421815835), o = h(o, i, n, r, e[u + 15], 16, 530742520), n = p(n, r = h(r, o, i, n, e[u + 2], 23, -995338651), o, i, e[u + 0], 6, -198630844), i = p(i, n, r, o, e[u + 7], 10, 1126891415), o = p(o, i, n, r, e[u + 14], 15, -1416354905), r = p(r, o, i, n, e[u + 5], 21, -57434055), n = p(n, r, o, i, e[u + 12], 6, 1700485571), i = p(i, n, r, o, e[u + 3], 10, -1894986606), o = p(o, i, n, r, e[u + 10], 15, -1051523), r = p(r, o, i, n, e[u + 1], 21, -2054922799), n = p(n, r, o, i, e[u + 8], 6, 1873313359), i = p(i, n, r, o, e[u + 15], 10, -30611744), o = p(o, i, n, r, e[u + 6], 15, -1560198380), r = p(r, o, i, n, e[u + 13], 21, 1309151649), n = p(n, r, o, i, e[u + 4], 6, -145523070), i = p(i, n, r, o, e[u + 11], 10, -1120210379), o = p(o, i, n, r, e[u + 2], 15, 718787259), r = p(r, o, i, n, e[u + 9], 21, -343485551), n = g(n, s), r = g(r, a), o = g(o, f), i = g(i, l);
                        }
                        return Array(n, r, o, i);
                    }
                    function s(e, t, n, r, o, i) {
                        return g((t = g(g(t, e), g(r, i))) << o | t >>> 32 - o, n);
                    }
                    function c(e, t, n, r, o, i, u) {
                        return s(t & n | ~t & r, e, t, o, i, u);
                    }
                    function d(e, t, n, r, o, i, u) {
                        return s(t & r | n & ~r, e, t, o, i, u);
                    }
                    function h(e, t, n, r, o, i, u) {
                        return s(t ^ n ^ r, e, t, o, i, u);
                    }
                    function p(e, t, n, r, o, i, u) {
                        return s(n ^ (t | ~r), e, t, o, i, u);
                    }
                    function g(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    b.exports = function(e) {
                        return t.hash(e, n, 16);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        7: [
            function(e, l, t) {
                (function(e, t, n, r, o, i, u, s, f) {
                    var a;
                    l.exports = a || function(e) {
                        for(var t, n = new Array(e), r = 0; r < e; r++)0 == (3 & r) && (t = 4294967296 * Math.random()), n[r] = t >>> ((3 & r) << 3) & 255;
                        return n;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        8: [
            function(c, d, e) {
                (function(e, t, n, r, o, s, a, f, l) {
                    var i = c("./helpers");
                    function u(l, c) {
                        l[c >> 5] |= 128 << 24 - c % 32, l[15 + (c + 64 >> 9 << 4)] = c;
                        for(var e, t, n, r = Array(80), o = 1732584193, i = -271733879, u = -1732584194, s = 271733878, d = -1009589776, h = 0; h < l.length; h += 16){
                            for(var p = o, g = i, y = u, w = s, b = d, a = 0; a < 80; a++){
                                r[a] = a < 16 ? l[h + a] : v(r[a - 3] ^ r[a - 8] ^ r[a - 14] ^ r[a - 16], 1);
                                var f = m(m(v(o, 5), (f = i, t = u, n = s, (e = a) < 20 ? f & t | ~f & n : !(e < 40) && e < 60 ? f & t | f & n | t & n : f ^ t ^ n)), m(m(d, r[a]), (e = a) < 20 ? 1518500249 : e < 40 ? 1859775393 : e < 60 ? -1894007588 : -899497514)), d = s, s = u, u = v(i, 30), i = o, o = f;
                            }
                            o = m(o, p), i = m(i, g), u = m(u, y), s = m(s, w), d = m(d, b);
                        }
                        return Array(o, i, u, s, d);
                    }
                    function m(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function v(e, t) {
                        return e << t | e >>> 32 - t;
                    }
                    d.exports = function(e) {
                        return i.hash(e, u, 20, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        9: [
            function(c, d, e) {
                (function(e, t, n, r, u, s, a, f, l) {
                    function b(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function o(e, l) {
                        var c, d = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), t = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), n = new Array(64);
                        e[l >> 5] |= 128 << 24 - l % 32, e[15 + (l + 64 >> 9 << 4)] = l;
                        for(var r, o, h = 0; h < e.length; h += 16){
                            for(var i = t[0], u = t[1], s = t[2], p = t[3], a = t[4], g = t[5], y = t[6], w = t[7], f = 0; f < 64; f++)n[f] = f < 16 ? e[f + h] : b(b(b((o = n[f - 2], m(o, 17) ^ m(o, 19) ^ v(o, 10)), n[f - 7]), (o = n[f - 15], m(o, 7) ^ m(o, 18) ^ v(o, 3))), n[f - 16]), c = b(b(b(b(w, m(o = a, 6) ^ m(o, 11) ^ m(o, 25)), a & g ^ ~a & y), d[f]), n[f]), r = b(m(r = i, 2) ^ m(r, 13) ^ m(r, 22), i & u ^ i & s ^ u & s), w = y, y = g, g = a, a = b(p, c), p = s, s = u, u = i, i = b(c, r);
                            t[0] = b(i, t[0]), t[1] = b(u, t[1]), t[2] = b(s, t[2]), t[3] = b(p, t[3]), t[4] = b(a, t[4]), t[5] = b(g, t[5]), t[6] = b(y, t[6]), t[7] = b(w, t[7]);
                        }
                        return t;
                    }
                    var i = c("./helpers"), m = function(e, t) {
                        return e >>> t | e << 32 - t;
                    }, v = function(e, t) {
                        return e >>> t;
                    };
                    d.exports = function(e) {
                        return i.hash(e, o, 32, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        10: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    f.read = function(e, t, n, r, o) {
                        var i, u, l = 8 * o - r - 1, c = (1 << l) - 1, d = c >> 1, s = -7, a = n ? o - 1 : 0, f = n ? -1 : 1, o = e[t + a];
                        for(a += f, i = o & (1 << -s) - 1, o >>= -s, s += l; 0 < s; i = 256 * i + e[t + a], a += f, s -= 8);
                        for(u = i & (1 << -s) - 1, i >>= -s, s += r; 0 < s; u = 256 * u + e[t + a], a += f, s -= 8);
                        if (0 === i) i = 1 - d;
                        else {
                            if (i === c) return u ? NaN : 1 / 0 * (o ? -1 : 1);
                            u += Math.pow(2, r), i -= d;
                        }
                        return (o ? -1 : 1) * u * Math.pow(2, i - r);
                    }, f.write = function(e, t, l, n, r, c) {
                        var o, i, u = 8 * c - r - 1, s = (1 << u) - 1, a = s >> 1, d = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : c - 1, h = n ? 1 : -1, c = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                        for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (i = isNaN(t) ? 1 : 0, o = s) : (o = Math.floor(Math.log(t) / Math.LN2), t * (n = Math.pow(2, -o)) < 1 && (o--, n *= 2), 2 <= (t += 1 <= o + a ? d / n : d * Math.pow(2, 1 - a)) * n && (o++, n /= 2), s <= o + a ? (i = 0, o = s) : 1 <= o + a ? (i = (t * n - 1) * Math.pow(2, r), o += a) : (i = t * Math.pow(2, a - 1) * Math.pow(2, r), o = 0)); 8 <= r; e[l + f] = 255 & i, f += h, i /= 256, r -= 8);
                        for(o = o << r | i, u += r; 0 < u; e[l + f] = 255 & o, f += h, o /= 256, u -= 8);
                        e[l + f - h] |= 128 * c;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        11: [
            function(e, h, t) {
                (function(e, t, n, r, o, f, l, c, d) {
                    var i, u, s;
                    function a() {}
                    (e = h.exports = {}).nextTick = (u = "undefined" != typeof window && window.setImmediate, s = "undefined" != typeof window && window.postMessage && window.addEventListener, u ? function(e) {
                        return window.setImmediate(e);
                    } : s ? (i = [], window.addEventListener("message", function(e) {
                        var t = e.source;
                        t !== window && null !== t || "process-tick" !== e.data || (e.stopPropagation(), 0 < i.length && i.shift()());
                    }, !0), function(e) {
                        i.push(e), window.postMessage("process-tick", "*");
                    }) : function(e) {
                        setTimeout(e, 0);
                    }), e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.on = a, e.addListener = a, e.once = a, e.off = a, e.removeListener = a, e.removeAllListeners = a, e.emit = a, e.binding = function(e) {
                        throw new Error("process.binding is not supported");
                    }, e.cwd = function() {
                        return "/";
                    }, e.chdir = function(e) {
                        throw new Error("process.chdir is not supported");
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ]
    }, {}, [
        1
    ])(1);
});

});

parcelRegister("1QQWr", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $KsUAk = parcelRequire("KsUAk");


var $grQpA = parcelRequire("grQpA");


var $irOoi = parcelRequire("irOoi");


var $1Igmn = parcelRequire("1Igmn");


var $42omo = parcelRequire("42omo");

const $e3bb6e17ec90ff99$var$CORE_EVENT = 'core:event';
const $e3bb6e17ec90ff99$var$CLIENT_EVENTS = 'client-events';
const $e3bb6e17ec90ff99$var$CLIENT_EVENT = 'client-event';
const $e3bb6e17ec90ff99$var$EVENT_PREFIX = 'forge.bridge.';
const $e3bb6e17ec90ff99$var$filterAllowedRecipients = (allExtensions, extension)=>{
    const matchingExtension = allExtensions.find((ext)=>{
        if (ext && ext?.appId && ext?.key) return ext.appId === extension.appId && (ext.key === $e3bb6e17ec90ff99$var$CLIENT_EVENTS || ext.key === $e3bb6e17ec90ff99$var$CLIENT_EVENT);
    });
    const allowedRecipients = matchingExtension?.properties?.allowedRecipients ?? [];
    const filteredAllowedRecipients = allowedRecipients.filter((recipient)=>recipient !== '*').map((recipient)=>recipient.split('/').pop());
    if (!filteredAllowedRecipients.includes(extension.appId)) filteredAllowedRecipients.push(extension.appId);
    return filteredAllowedRecipients;
};
const $e3bb6e17ec90ff99$export$444d4d38f9da2a78 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (contextId, extension)=>{
    const $ = (0, $frIzR.c)(7);
    const relayEnvironment = (0, $irOoi.useRelayEnvironment)();
    const allowedRecipientsRef = (0, $42omo.useRef)(null);
    if (!extension?.appId) return $e3bb6e17ec90ff99$var$_temp;
    let t0;
    if ($[0] !== contextId || $[1] !== extension || $[2] !== relayEnvironment) {
        t0 = async ()=>{
            if (allowedRecipientsRef.current !== null) return allowedRecipientsRef.current;
            if (relayEnvironment) {
                const observable = (0, $irOoi.fetchQuery)(relayEnvironment, (0, $KsUAk.default), {
                    contextIds: [
                        contextId
                    ],
                    filter: [
                        {
                            type: (0, $grQpA.GQLExtensionContextsFilterType).ExtensionType,
                            value: [
                                $e3bb6e17ec90ff99$var$CORE_EVENT
                            ]
                        }
                    ]
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                "atl-attribution": (0, $1Igmn.createAtlAttributionHeader)()
                            }
                        }
                    }
                });
                return new Promise((resolve)=>{
                    observable.subscribe({
                        next: (result)=>{
                            const allExtensions = result?.extensionContexts?.[0]?.extensions || [];
                            const filteredAllowedRecipients = $e3bb6e17ec90ff99$var$filterAllowedRecipients(Array.from(allExtensions), extension);
                            resolve(filteredAllowedRecipients);
                        },
                        error: ()=>{
                            resolve([
                                extension.appId ?? ""
                            ]);
                        }
                    });
                });
            }
            return [
                extension.appId
            ];
        };
        $[0] = contextId;
        $[1] = extension;
        $[2] = relayEnvironment;
        $[3] = t0;
    } else t0 = $[3];
    const getAllowedRecipients = t0;
    let t1;
    if ($[4] !== extension || $[5] !== getAllowedRecipients) {
        t1 = async (eventData)=>{
            const { event: event, payload: payload } = eventData;
            if (allowedRecipientsRef.current === null) {
                const allowedRecipients = await getAllowedRecipients();
                allowedRecipientsRef.current = allowedRecipients;
            }
            const newEvent = new CustomEvent(`${$e3bb6e17ec90ff99$var$EVENT_PREFIX}${event}`, {
                detail: {
                    extension: extension,
                    payload: payload,
                    allowedRecipients: allowedRecipientsRef.current ?? [
                        extension.appId
                    ]
                }
            });
            window.document.dispatchEvent(newEvent);
        };
        $[4] = extension;
        $[5] = getAllowedRecipients;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : (contextId, extension)=>{
    const relayEnvironment = (0, $irOoi.useRelayEnvironment)();
    const allowedRecipientsRef = (0, $42omo.useRef)(null);
    if (!extension?.appId) return async ()=>{};
    const getAllowedRecipients = async ()=>{
        if (allowedRecipientsRef.current !== null) return allowedRecipientsRef.current;
        if (relayEnvironment) {
            const observable = (0, $irOoi.fetchQuery)(relayEnvironment, (0, $KsUAk.default), {
                contextIds: [
                    contextId
                ],
                filter: [
                    {
                        type: (0, $grQpA.GQLExtensionContextsFilterType).ExtensionType,
                        value: [
                            $e3bb6e17ec90ff99$var$CORE_EVENT
                        ]
                    }
                ]
            }, {
                networkCacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                        }
                    }
                }
            });
            return new Promise((resolve)=>{
                observable.subscribe({
                    next: (result)=>{
                        const allExtensions = result?.extensionContexts?.[0]?.extensions || [];
                        const filteredAllowedRecipients = $e3bb6e17ec90ff99$var$filterAllowedRecipients(Array.from(allExtensions), extension);
                        resolve(filteredAllowedRecipients);
                    },
                    error: ()=>{
                        resolve([
                            extension.appId ?? ''
                        ]);
                    }
                });
            });
        }
        return [
            extension.appId
        ];
    };
    return async (eventData)=>{
        const { event: event, payload: payload } = eventData;
        if (allowedRecipientsRef.current === null) {
            const allowedRecipients = await getAllowedRecipients();
            allowedRecipientsRef.current = allowedRecipients;
        }
        const newEvent = new CustomEvent(`${$e3bb6e17ec90ff99$var$EVENT_PREFIX}${event}`, {
            detail: {
                extension: extension,
                payload: payload,
                allowedRecipients: allowedRecipientsRef.current ?? [
                    extension.appId
                ]
            }
        });
        window.document.dispatchEvent(newEvent);
    };
};
async function $e3bb6e17ec90ff99$var$_temp() {}
module.exports["useEmitPublicEvent"] = $e3bb6e17ec90ff99$export$444d4d38f9da2a78;

});

parcelRegister("4Marr", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $4AcGw = parcelRequire("4AcGw");


var $1Igmn = parcelRequire("1Igmn");


var $auFhA = parcelRequire("auFhA");


var $dh538 = parcelRequire("dh538");


var $irOoi = parcelRequire("irOoi");

const $e9c93549781f9d57$export$df7d62be1d7f5fc9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (installationId, context, appId)=>{
    const $ = (0, $frIzR.c)(5);
    const relayEnvironment = (0, $irOoi.useRelayEnvironment)();
    let t0;
    if ($[0] !== appId || $[1] !== context || $[2] !== installationId || $[3] !== relayEnvironment) {
        t0 = async (payload, contextToken)=>{
            const { channelName: channelName, isGlobal: isGlobal, options: options } = payload.data;
            const { token: token, contextOverrides: contextOverrides } = options || {};
            if (token) {
                const validation = (0, $auFhA.validateRealtimeChannelToken)(token, {
                    requiredPermission: "publish",
                    channelName: channelName
                });
                if (!validation.valid) return {
                    eventId: null,
                    eventTimestamp: null,
                    errors: [
                        {
                            message: `Realtime token validation failed: ${validation.error}`
                        }
                    ]
                };
            }
            const eventPayload = JSON.stringify(payload.data.eventPayload);
            const channelContext = contextOverrides ? JSON.stringify({
                context: context,
                contextOverrides: contextOverrides
            }) : context;
            return new Promise((resolve, reject)=>{
                (0, $irOoi.commitMutation)(relayEnvironment, {
                    mutation: (0, $4AcGw.default),
                    variables: {
                        installationId: installationId,
                        name: channelName,
                        payload: eventPayload,
                        context: channelContext,
                        isGlobal: isGlobal ?? false,
                        token: token
                    },
                    cacheConfig: {
                        metadata: {
                            headers: {
                                "atl-attribution": (0, $1Igmn.createAtlAttributionHeader)(),
                                ...contextToken ? {
                                    "x-forge-context-token": contextToken
                                } : {},
                                ...appId ? {
                                    "x-rate-limit-app-id": appId
                                } : {},
                                ...installationId ? {
                                    "x-rate-limit-installation-id": installationId
                                } : {}
                            }
                        }
                    },
                    onCompleted: (data, errors)=>{
                        if (errors) return resolve({
                            eventId: null,
                            eventTimestamp: null,
                            errors: (0, $dh538.fg)("forge-ui-handle-realtime-rate-limit-error") ? errors.map($e9c93549781f9d57$var$_temp) : errors
                        });
                        if (data?.ecosystem?.publishRealtimeChannel) {
                            const { eventId: eventId, eventTimestamp: eventTimestamp } = data.ecosystem.publishRealtimeChannel;
                            if (eventId && eventTimestamp) resolve({
                                eventId: eventId,
                                eventTimestamp: eventTimestamp
                            });
                            else resolve(undefined);
                        } else resolve(undefined);
                    },
                    onError: reject
                });
            });
        };
        $[0] = appId;
        $[1] = context;
        $[2] = installationId;
        $[3] = relayEnvironment;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : (installationId, context, appId)=>{
    const relayEnvironment = (0, $irOoi.useRelayEnvironment)();
    return async (payload, contextToken)=>{
        const { channelName: channelName, isGlobal: isGlobal, options: options } = payload.data;
        const { token: token, contextOverrides: contextOverrides } = options || {};
        if (token) {
            const validation = (0, $auFhA.validateRealtimeChannelToken)(token, {
                requiredPermission: 'publish',
                channelName: channelName
            });
            if (!validation.valid) return {
                eventId: null,
                eventTimestamp: null,
                errors: [
                    {
                        message: `Realtime token validation failed: ${validation.error}`
                    }
                ]
            };
        }
        const eventPayload = JSON.stringify(payload.data.eventPayload);
        const channelContext = contextOverrides ? JSON.stringify({
            context: context,
            contextOverrides: contextOverrides
        }) : context;
        return new Promise((resolve, reject)=>{
            (0, $irOoi.commitMutation)(relayEnvironment, {
                mutation: (0, $4AcGw.default),
                variables: {
                    installationId: installationId,
                    name: channelName,
                    payload: eventPayload,
                    context: channelContext,
                    isGlobal: isGlobal ?? false,
                    token: token
                },
                cacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(),
                            ...contextToken ? {
                                'x-forge-context-token': contextToken
                            } : {},
                            ...appId ? {
                                'x-rate-limit-app-id': appId
                            } : {},
                            ...installationId ? {
                                'x-rate-limit-installation-id': installationId
                            } : {}
                        }
                    }
                },
                onCompleted: (data, errors)=>{
                    if (errors) return resolve({
                        eventId: null,
                        eventTimestamp: null,
                        errors: (0, $dh538.fg)('forge-ui-handle-realtime-rate-limit-error') ? errors.map((error)=>{
                            if (error.extensions?.statusCode === 429) return {
                                message: 'RATE_LIMIT_EXCEEDED'
                            };
                            return error;
                        }) : errors
                    });
                    if (data?.ecosystem?.publishRealtimeChannel) {
                        const { eventId: eventId, eventTimestamp: eventTimestamp } = data.ecosystem.publishRealtimeChannel;
                        if (eventId && eventTimestamp) resolve({
                            eventId: eventId,
                            eventTimestamp: eventTimestamp
                        });
                        else resolve(undefined);
                    } else resolve(undefined);
                },
                onError: reject
            });
        });
    };
};
function $e9c93549781f9d57$var$_temp(error) {
    if (error.extensions?.statusCode === 429) return {
        message: "RATE_LIMIT_EXCEEDED"
    };
    return error;
}
module.exports["usePublishRealtimeChannel"] = $e9c93549781f9d57$export$df7d62be1d7f5fc9;

});

parcelRegister("iWy5D", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kK6dd = parcelRequire("kK6dd");


var $auFhA = parcelRequire("auFhA");


var $dh538 = parcelRequire("dh538");

const $364771c9cefa2143$var$realtimeChannel = `
	subscription realtimeChannel(
		$installationId: ID!
		$name: String!
		$context: String
		$isGlobal: Boolean
		$token: String
	) {
		ecosystem {
			realtimeChannel(
				installationId: $installationId
				name: $name
				context: $context
				isGlobal: $isGlobal
				token: $token
			) {
				payload
			}
		}
	}
`;
const $364771c9cefa2143$var$getChannelKey = (context)=>{
    return Object.entries(context).sort((a, b)=>a[0].localeCompare(b[0])).toString();
};
const $364771c9cefa2143$export$905d34fe81a9cf60 = ({ payload: payload, context: context, installationId: installationId, contextToken: contextToken })=>{
    const query = {
        operationName: 'realtimeChannel',
        query: $364771c9cefa2143$var$realtimeChannel
    };
    return {
        ...query,
        variables: {
            installationId: installationId,
            name: payload.data.channelName,
            context: context,
            isGlobal: payload.data.isGlobal ?? false,
            token: payload.data.options?.token
        },
        extensions: {
            'x-forge-context-token': contextToken,
            ...payload.data.options?.replaySeconds && {
                command: {
                    type: 'replay',
                    data: {
                        // Timestamp in seconds of when to replay messages from. Valid for up to 7 days in the past.
                        sequenceNumber: Date.now() / 1000 - payload.data.options.replaySeconds
                    }
                }
            }
        }
    };
};
const $364771c9cefa2143$var$unsubscribeAllSubscriptions = (activeSubscriptions)=>{
    activeSubscriptions.forEach((subscription)=>{
        if (!subscription.closed) subscription.unsubscribe();
    });
    activeSubscriptions.clear();
};
const $364771c9cefa2143$export$21407f03011cb801 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (installationId, context, getContextToken, getContextTokenOptions)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new Map();
        $[0] = t0;
    } else t0 = $[0];
    const activeSubscriptions = (0, $42omo.useRef)(t0);
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const currentSubscriptions = activeSubscriptions.current;
            return ()=>{
                $364771c9cefa2143$var$unsubscribeAllSubscriptions(currentSubscriptions);
            };
        };
        t2 = [];
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[3] !== context || $[4] !== getContextToken || $[5] !== getContextTokenOptions || $[6] !== installationId) {
        t3 = async (payload)=>{
            const { onEvent: onEvent, channelName: channelName, options: options, isGlobal: isGlobal } = payload.data;
            const { token: token } = options || {};
            if (token) {
                const validation = (0, $auFhA.validateRealtimeChannelToken)(token, {
                    requiredPermission: "subscribe",
                    channelName: channelName
                });
                if (!validation.valid) return Promise.reject(new Error(`Realtime token validation failed: ${validation.error}`));
            }
            const channelContext = options?.contextOverrides ? JSON.stringify({
                context: context,
                contextOverrides: options?.contextOverrides
            }) : context;
            const channelKey = $364771c9cefa2143$var$getChannelKey({
                channelName: channelName,
                isGlobal: isGlobal,
                channelContext: channelContext
            });
            const existingSubscription = activeSubscriptions.current.get(channelKey);
            if (existingSubscription) {
                existingSubscription.addCallback(onEvent);
                onEvent("SUBSCRIPTION_STARTED");
            } else {
                const createSubscription = async ()=>{
                    const subscriptionPayload = $364771c9cefa2143$export$905d34fe81a9cf60({
                        payload: payload,
                        context: channelContext,
                        installationId: installationId,
                        contextToken: await getContextToken?.(getContextTokenOptions)
                    });
                    const subscription = (0, $kK6dd.subscribe)(subscriptionPayload, {
                        next: (result)=>{
                            subscription.onNext(result.data.ecosystem?.realtimeChannel?.payload);
                        },
                        error: async (err)=>{
                            const error = Array.isArray(err) ? err[0] : err;
                            if (error?.extensions?.statusCode === 429 && (0, $dh538.fg)("forge-ui-handle-realtime-rate-limit-error")) {
                                subscription.onError(new Error("RATE_LIMIT_EXCEEDED"));
                                return;
                            }
                            const shouldRetrySubscribe = error?.message === "FCT has expired on subscribe request";
                            if (shouldRetrySubscribe) try {
                                const newSubscription = await createSubscription();
                                newSubscription.subscriptionCallbacks = [
                                    ...subscription.subscriptionCallbacks
                                ];
                                activeSubscriptions.current.set(channelKey, newSubscription);
                                subscription.unsubscribe();
                                return;
                            } catch (t4) {
                                const err_0 = t4;
                                subscription.onError(err_0);
                                activeSubscriptions.current.delete(channelKey);
                                return;
                            }
                            subscription.onError(err);
                            activeSubscriptions.current.delete(channelKey);
                        },
                        complete: ()=>{
                            activeSubscriptions.current.delete(channelKey);
                        }
                    }, onEvent);
                    activeSubscriptions.current.set(channelKey, subscription);
                    return subscription;
                };
                createSubscription();
            }
            return {
                unsubscribe: ()=>{
                    const subscription_0 = activeSubscriptions.current.get(channelKey);
                    if (subscription_0) {
                        subscription_0.removeCallback(onEvent);
                        if (subscription_0.subscriptionCallbacks.length === 0) {
                            activeSubscriptions.current.delete(channelKey);
                            if (!subscription_0.closed) subscription_0.unsubscribe();
                        }
                    }
                }
            };
        };
        $[3] = context;
        $[4] = getContextToken;
        $[5] = getContextTokenOptions;
        $[6] = installationId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : (installationId, context, getContextToken, getContextTokenOptions)=>{
    const activeSubscriptions = (0, $42omo.useRef)(new Map());
    (0, $42omo.useEffect)(()=>{
        const currentSubscriptions = activeSubscriptions.current;
        return ()=>{
            $364771c9cefa2143$var$unsubscribeAllSubscriptions(currentSubscriptions);
        };
    }, []);
    // this is the bridge method that will be called from the extension
    return async (payload)=>{
        const { onEvent: onEvent, channelName: channelName, options: options, isGlobal: isGlobal } = payload.data;
        const { token: token } = options || {};
        if (token) {
            const validation = (0, $auFhA.validateRealtimeChannelToken)(token, {
                requiredPermission: 'subscribe',
                channelName: channelName
            });
            if (!validation.valid) return Promise.reject(new Error(`Realtime token validation failed: ${validation.error}`));
        }
        const channelContext = options?.contextOverrides ? JSON.stringify({
            context: context,
            contextOverrides: options?.contextOverrides
        }) : context;
        const channelKey = $364771c9cefa2143$var$getChannelKey({
            channelName: channelName,
            isGlobal: isGlobal,
            channelContext: channelContext
        });
        const existingSubscription = activeSubscriptions.current.get(channelKey);
        if (existingSubscription) {
            // if subscription already exists
            existingSubscription.addCallback(onEvent);
            onEvent('SUBSCRIPTION_STARTED');
        } else {
            // helper to create a subscription and handle token refresh
            const createSubscription = async ()=>{
                const subscriptionPayload = $364771c9cefa2143$export$905d34fe81a9cf60({
                    payload: payload,
                    context: channelContext,
                    installationId: installationId,
                    contextToken: await getContextToken?.(getContextTokenOptions)
                });
                const subscription = (0, $kK6dd.subscribe)(subscriptionPayload, {
                    next: (result)=>{
                        subscription.onNext(result.data.ecosystem?.realtimeChannel?.payload);
                    },
                    error: async (err)=>{
                        const error = Array.isArray(err) ? err[0] : err;
                        if (error?.extensions?.statusCode === 429 && (0, $dh538.fg)('forge-ui-handle-realtime-rate-limit-error')) {
                            subscription.onError(new Error('RATE_LIMIT_EXCEEDED'));
                            return;
                        }
                        const shouldRetrySubscribe = error?.message === 'FCT has expired on subscribe request';
                        if (shouldRetrySubscribe) try {
                            const newSubscription = await createSubscription();
                            newSubscription.subscriptionCallbacks = [
                                ...subscription.subscriptionCallbacks
                            ];
                            activeSubscriptions.current.set(channelKey, newSubscription);
                            subscription.unsubscribe();
                            return;
                        } catch (err_0) {
                            subscription.onError(err_0);
                            activeSubscriptions.current.delete(channelKey);
                            return;
                        }
                        subscription.onError(err);
                        activeSubscriptions.current.delete(channelKey);
                    },
                    complete: ()=>{
                        activeSubscriptions.current.delete(channelKey);
                    }
                }, onEvent);
                activeSubscriptions.current.set(channelKey, subscription);
                return subscription;
            };
            createSubscription();
        }
        return {
            unsubscribe: ()=>{
                const subscription_0 = activeSubscriptions.current.get(channelKey);
                if (subscription_0) {
                    // remove one subscription
                    subscription_0.removeCallback(onEvent);
                    // if no more subscriptions remove the channelKey and unsubscribe
                    if (subscription_0.subscriptionCallbacks.length === 0) {
                        activeSubscriptions.current.delete(channelKey);
                        if (!subscription_0.closed) subscription_0.unsubscribe();
                    }
                }
            }
        };
    };
};
module.exports["getSubscribePayload"] = $364771c9cefa2143$export$905d34fe81a9cf60;
module.exports["useSubscribeRealtimeChannel"] = $364771c9cefa2143$export$21407f03011cb801;

});

parcelRegister("6fRDv", function(module, exports) {
/**
 * Gets the target window for forwarding messages from FAUS to the product.
 *
 * Current architecture:
 * - Product (Confluence) → Bodied Macro → FAUS → Embedded Macro
 * - FAUS is nested 2 levels deep, so window.parent.parent is the product
 *
 * Future: This can be updated to support multiple nesting levels by checking
 * ancestorOrigins.length or using a more dynamic approach.
 *
 * @returns The product window, or null if not in a nested context
 */ function $1ed0c4b4d8f6d1ca$export$532d4b4b6d3d2c95() {
    // This would need to be changed if we want to support multiple nesting levels
    const targetWindow = window.parent?.parent;
    // Ensure we have a valid target that's not the current window
    if (targetWindow && targetWindow !== window) return targetWindow;
    return null;
}
function $1ed0c4b4d8f6d1ca$export$f0bf9a3931c6275e() {
    return `${window.location.protocol}//${window.location.hostname}`;
}
module.exports["getProductDomain"] = $1ed0c4b4d8f6d1ca$export$f0bf9a3931c6275e;

});

parcelRegister("cPPTB", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $i25hX = parcelRequire("i25hX");


var $kLl6K = parcelRequire("kLl6K");


var $6XtTp = parcelRequire("6XtTp");


var $irOoi = parcelRequire("irOoi");


var $42omo = parcelRequire("42omo");

const $a6f437d394af1fd4$var$ROVO_TOPIC = 'ai-mate';
const $a6f437d394af1fd4$var$FORGE_SOURCE = 'forge-bridge-open-rovo';
const $a6f437d394af1fd4$var$ROVO_EVENT_TYPE = 'chat-new';
const $a6f437d394af1fd4$var$makeForgeAgentExternalConfigReference = (appId, installationId, environmentId, agentKey)=>{
    return `${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${agentKey}`;
};
const $a6f437d394af1fd4$export$1b9e058b7e689de = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useRovoAgentsChat(extensionType, appId, cloudId, installationId, environmentId) {
    const $ = (0, $frIzR.c)(8);
    const publish = (0, $i25hX.usePublish)($a6f437d394af1fd4$var$ROVO_TOPIC);
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    let t0;
    if ($[0] !== appId || $[1] !== cloudId || $[2] !== environmentId || $[3] !== extensionType || $[4] !== installationId || $[5] !== publish || $[6] !== relayEnvironment) {
        t0 = {
            openRovo: async (t1)=>{
                const { agentKey: agentKey, agentName: agentName, prompt: prompt, sourceAppId: sourceAppId, sourceInstallationId: sourceInstallationId, sourceEnvironmentId: sourceEnvironmentId } = t1;
                const product = (0, $kLl6K.getRovoProductFromExtensionType)(extensionType);
                if (!cloudId || !product) return false;
                const effectiveAppId = sourceAppId || appId;
                const effectiveInstallationId = sourceInstallationId || installationId;
                const effectiveEnvironmentId = sourceEnvironmentId || environmentId;
                const isForgeAgent = agentName && agentKey;
                const publishEventDetails = {
                    type: $a6f437d394af1fd4$var$ROVO_EVENT_TYPE,
                    product: product,
                    source: $a6f437d394af1fd4$var$FORGE_SOURCE
                };
                let agentIdConfig;
                if (isForgeAgent) agentIdConfig = {
                    agentExternalConfigReference: $a6f437d394af1fd4$var$makeForgeAgentExternalConfigReference(effectiveAppId, effectiveInstallationId, effectiveEnvironmentId, agentKey)
                };
                else {
                    const agentId = agentName && !agentKey ? await (0, $6XtTp.getRovoAgentId)({
                        agentAppId: effectiveAppId,
                        cloudId: cloudId,
                        input: {
                            name: agentName
                        },
                        product: product,
                        agentKey: agentKey,
                        relayEnvironment: relayEnvironment
                    }) : (0, $6XtTp.DEFAULT_AGENT_REFERENCE);
                    agentIdConfig = {
                        agentId: agentId
                    };
                }
                publish({
                    ...publishEventDetails,
                    data: {
                        dialogues: [],
                        ...agentIdConfig,
                        ...prompt ? {
                            prompt: prompt
                        } : {}
                    }
                });
            }
        };
        $[0] = appId;
        $[1] = cloudId;
        $[2] = environmentId;
        $[3] = extensionType;
        $[4] = installationId;
        $[5] = publish;
        $[6] = relayEnvironment;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
} : function useRovoAgentsChat(extensionType, appId, cloudId, installationId, environmentId) {
    const publish = (0, $i25hX.usePublish)($a6f437d394af1fd4$var$ROVO_TOPIC);
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    return {
        openRovo: async ({ agentKey: agentKey, agentName: agentName, prompt: prompt, sourceAppId: sourceAppId, sourceInstallationId: sourceInstallationId, sourceEnvironmentId: sourceEnvironmentId })=>{
            const product = (0, $kLl6K.getRovoProductFromExtensionType)(extensionType);
            if (!cloudId || !product) return false;
            // Use sourceAppId if provided (from embedded macro forwarding), otherwise use the captured appId
            const effectiveAppId = sourceAppId || appId;
            const effectiveInstallationId = sourceInstallationId || installationId;
            const effectiveEnvironmentId = sourceEnvironmentId || environmentId;
            const isForgeAgent = agentName && agentKey;
            const publishEventDetails = {
                type: $a6f437d394af1fd4$var$ROVO_EVENT_TYPE,
                product: product,
                source: $a6f437d394af1fd4$var$FORGE_SOURCE
            };
            let agentIdConfig;
            if (isForgeAgent) agentIdConfig = {
                agentExternalConfigReference: $a6f437d394af1fd4$var$makeForgeAgentExternalConfigReference(effectiveAppId, effectiveInstallationId, effectiveEnvironmentId, agentKey)
            };
            else {
                // If agent name is not provided use default rovo chat agent
                const agentId = agentName && !agentKey ? await (0, $6XtTp.getRovoAgentId)({
                    agentAppId: effectiveAppId,
                    cloudId: cloudId,
                    input: {
                        name: agentName
                    },
                    product: product,
                    agentKey: agentKey,
                    relayEnvironment: relayEnvironment
                }) : (0, $6XtTp.DEFAULT_AGENT_REFERENCE);
                agentIdConfig = {
                    agentId: agentId
                };
            }
            publish({
                ...publishEventDetails,
                data: {
                    dialogues: [],
                    ...agentIdConfig,
                    ...prompt ? {
                        prompt: prompt
                    } : {}
                }
            });
        }
    };
};
module.exports["useRovoAgentsChat"] = $a6f437d394af1fd4$export$1b9e058b7e689de;

});

parcelRegister("aGCtG", function(module, exports) {
const $dd25f80afb746bb3$export$c58c2ef6cd7b14a1 = (appId, accountId)=>!!window['__consentedApps']?.[`${appId}:${accountId}`];
const $dd25f80afb746bb3$export$8d4e05c53de89926 = (appId, accountId)=>{
    window.__consentedApps = window.__consentedApps || {};
    window.__consentedApps[`${appId}:${accountId}`] = true;
};
module.exports["isAppConsentedLocally"] = $dd25f80afb746bb3$export$c58c2ef6cd7b14a1;
module.exports["setAppConsentLocal"] = $dd25f80afb746bb3$export$8d4e05c53de89926;

});

parcelRegister("cKUnA", function(module, exports) {

var $1Igmn = parcelRequire("1Igmn");

var $b7qxC = parcelRequire("b7qxC");

const $9c850cca6011a656$var$globalEdgeUrlMap = {
    dev: 'dev.services.atlassian.com',
    stg: 'stg.services.atlassian.com',
    prod: 'services.atlassian.com'
};
const $9c850cca6011a656$var$getBaseUrl = (environment)=>{
    const baseUrl = $9c850cca6011a656$var$globalEdgeUrlMap[environment];
    if (!baseUrl) throw new Error(`Invalid environment: ${environment}`);
    const service = 'forge-outbound-proxy';
    const url = `https://${service}.${baseUrl}`;
    return url;
};
const $9c850cca6011a656$export$e02fc95a45760598 = async (appId, user, config, environment, contextToken)=>{
    const init = {
        method: 'POST',
        headers: {
            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(),
            'Content-Type': 'application/json',
            Authentication: `Bearer ${contextToken}`
        },
        body: JSON.stringify({
            user: user,
            config: config,
            appId: appId
        })
    };
    const url = $9c850cca6011a656$var$getBaseUrl((0, $b7qxC.getCDNEnvironment)(environment)) + '/client/feature-flags';
    const response = await fetch(url, init);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
};
module.exports["getFeatureFlags"] = $9c850cca6011a656$export$e02fc95a45760598;

});

parcelRegister("cr6KQ", function(module, exports) {

var $6iOy7 = parcelRequire("6iOy7");


var $irOoi = parcelRequire("irOoi");


var $1Igmn = parcelRequire("1Igmn");

const $7458ed5688e9ec89$export$44a0e63a6f1a626c = async (input)=>{
    const { relayEnvironment: relayEnvironment, ...metricInput } = input;
    return new Promise((resolve)=>{
        // Resolve at most once; the metric is fire-and-forget so the response is ignored.
        let settled = false;
        const finish = ()=>{
            if (settled) return;
            settled = true;
            resolve();
        };
        (0, $irOoi.commitMutation)(relayEnvironment, {
            mutation: (0, $6iOy7.default),
            variables: {
                input: metricInput
            },
            cacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            },
            // Fire-and-forget: the response is intentionally ignored.
            onCompleted: finish,
            // Silent fail: emitting a metric must never surface an error to the app.
            onError: finish
        });
    });
};
module.exports["emitFrontendCustomMetric"] = $7458ed5688e9ec89$export$44a0e63a6f1a626c;

});

parcelRegister("7mt4M", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $kaRs6 = parcelRequire("kaRs6");


var $1Igmn = parcelRequire("1Igmn");


var $irOoi = parcelRequire("irOoi");

const $783b254f80b9fbef$export$f31e7455041d7e13 = ({ loading: loading, data: data })=>{
    if (!loading) return data?.appActiveTunnels?.customUI;
    return undefined;
};
const $783b254f80b9fbef$export$fe132995f21ca9ac = (0, $4pOgL.isReactCompilerActivePlatform)() ? (options)=>{
    const $ = (0, $frIzR.c)(16);
    const { appId: appId, environmentId: environmentId } = options;
    let t0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== appId || $[1] !== environmentId || $[2] !== options.contextIds) {
        const contextIds = options.contextIds ?? [];
        t1 = (0, $irOoi.useLazyLoadQuery);
        t2 = (0, $kaRs6.default);
        if ($[7] !== appId || $[8] !== environmentId) {
            t3 = {
                appId: appId,
                environmentId: environmentId
            };
            $[7] = appId;
            $[8] = environmentId;
            $[9] = t3;
        } else t3 = $[9];
        t0 = (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join());
        $[0] = appId;
        $[1] = environmentId;
        $[2] = options.contextIds;
        $[3] = t0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        t0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[10] !== t0) {
        t4 = {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        "atl-attribution": t0
                    }
                }
            }
        };
        $[10] = t0;
        $[11] = t4;
    } else t4 = $[11];
    const data = t1(t2, t3, t4);
    let t5;
    if ($[12] !== data?.appActiveTunnels?.customUI) {
        t5 = data?.appActiveTunnels?.customUI ?? [];
        $[12] = data?.appActiveTunnels?.customUI;
        $[13] = t5;
    } else t5 = $[13];
    const tunnels = t5;
    let t6;
    if ($[14] !== tunnels) {
        t6 = {
            tunnels: tunnels,
            loading: false
        };
        $[14] = tunnels;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : (options)=>{
    const { appId: appId, environmentId: environmentId } = options;
    const contextIds = options.contextIds ?? [];
    /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/no-wrapping-hooks */ const data = (0, $irOoi.useLazyLoadQuery)((0, $kaRs6.default), {
        appId: appId,
        environmentId: environmentId
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                }
            }
        }
    });
    /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/no-wrapping-hooks */ const tunnels = data?.appActiveTunnels?.customUI ?? [];
    return {
        tunnels: tunnels,
        loading: false
    };
};
module.exports["useCustomUITunnelsListRelay"] = $783b254f80b9fbef$export$fe132995f21ca9ac;

});

parcelRegister("8012d", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $4ZTaE = parcelRequire("4ZTaE");


var $aGCtG = parcelRequire("aGCtG");

const $9d587b1ca74180de$var$defaultComponents = {
    ThreeLOPrompt: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ZTaE.default), props)
};
const $9d587b1ca74180de$export$3be8e8bcb6b54c3e = ({ extension: extension, appId: appId, accountId: accountId, components: components, onLoad: onLoad, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, overlayController: overlayController })=>{
    const { ThreeLOPrompt: ThreeLOPrompt } = components ? components($9d587b1ca74180de$var$defaultComponents) : $9d587b1ca74180de$var$defaultComponents;
    const { consentUrl: consentUrl, requiresUserConsent: requiresUserConsent, currentUserConsent: currentUserConsent } = extension;
    const appIsAuthenticated = (0, $aGCtG.isAppConsentedLocally)(appId, accountId);
    const [userConsentRequired, setUserConsentRequired] = (0, $42omo.useState)(!!(consentUrl && !currentUserConsent && requiresUserConsent && !appIsAuthenticated));
    // Queue of pending retries across concurrent runtime 3LO prompts.
    const invokeRetriesRef = (0, $42omo.useRef)([]);
    // Always-current values so callbacks created inside effects and renderThreeLOPrompt
    // always reference the latest props without stale closure issues.
    const latestRef = (0, $42omo.useRef)({
        ThreeLOPrompt: ThreeLOPrompt,
        overlayController: overlayController,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        extension: extension,
        appId: appId,
        accountId: accountId,
        consentUrl: consentUrl,
        onLoad: onLoad
    });
    latestRef.current = {
        ThreeLOPrompt: ThreeLOPrompt,
        overlayController: overlayController,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        extension: extension,
        appId: appId,
        accountId: accountId,
        consentUrl: consentUrl,
        onLoad: onLoad
    };
    // Shared presenter — shows <ThreeLOPrompt> via overlayController and handles
    // the common teardown (hide overlay, restore visibility + renderer) before
    // delegating to the caller-specific `onConsented` callback.
    const showThreeLOPrompt = (0, $hQK66.useCallbackOne)((authUrl, onConsented)=>{
        const { ThreeLOPrompt: ThreeLOPrompt_0, overlayController: overlayController_0, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible_0, setShouldShowRenderer: setShouldShowRenderer_0, extension: extension_0 } = latestRef.current;
        overlayController_0.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ThreeLOPrompt_0, {
            authUrl: authUrl,
            onSuccess: async ()=>{
                overlayController_0.hide();
                setIsThreeLOPromptVisible_0(false);
                setShouldShowRenderer_0?.(true);
                await onConsented();
            },
            metadata: {
                moduleType: extension_0.type
            }
        }), true);
        setIsThreeLOPromptVisible_0(true);
        setShouldShowRenderer_0?.(false);
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!userConsentRequired) return;
        const { appId: appId_0, accountId: accountId_0, consentUrl: consentUrl_0, onLoad: onLoad_0 } = latestRef.current;
        showThreeLOPrompt(consentUrl_0, async ()=>{
            setUserConsentRequired(false);
            (0, $aGCtG.setAppConsentLocal)(appId_0, accountId_0);
        });
        onLoad_0?.();
    }, [
        userConsentRequired,
        showThreeLOPrompt
    ]);
    // Stable handler — created once, reads all values via latestRef at call time.
    const renderThreeLOPrompt = (0, $hQK66.useCallbackOne)((authUrl_0, retry)=>new Promise((resolve)=>{
            invokeRetriesRef.current.push(retry);
            showThreeLOPrompt(authUrl_0, async ()=>{
                resolve();
                try {
                    await Promise.all(invokeRetriesRef.current.map((r)=>r()));
                } finally{
                    invokeRetriesRef.current = [];
                }
            });
        }), [
        showThreeLOPrompt
    ]);
    return {
        userConsentRequired: userConsentRequired,
        renderThreeLOPrompt: renderThreeLOPrompt
    };
};
module.exports["useInitialAppState"] = $9d587b1ca74180de$export$3be8e8bcb6b54c3e;

});

parcelRegister("hUsLn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4GQnE = parcelRequire("4GQnE");


var $iqcSr = parcelRequire("iqcSr");


var $lwhTs = parcelRequire("lwhTs");


var $4k05I = parcelRequire("4k05I");


var $fxdkV = parcelRequire("fxdkV");

const $3ad0720bee1a01b6$export$aaaa1ba4b40a0c2f = ({ extension: extension, getBridgeContext: getBridgeContext, legacyCustomBridgeMethods: legacyCustomBridgeMethods, customBridge: customBridge })=>{
    const isCustomUIBodiedMacro = (0, $iqcSr.isCustomUI)(extension) && extension.properties?.layout === 'bodied';
    (0, $42omo.useEffect)(()=>{
        if (!isCustomUIBodiedMacro) return;
        // withEmbeddedMacroContext is injected as the outermost middleware so it:
        //  - unwraps the { embeddedMacroContext, payload } envelope before withMetrics sees it
        //  - provides the correctly merged context (embedded macro identity over host context)
        //    to withMetrics and all inner methods — no mutable refs or manual BridgeFeatures
        //    reconstruction needed.
        const bridgeFeatures = (0, $lwhTs.createBridgeFeatures)(getBridgeContext, (baseBridgeMethods)=>(0, $4k05I.consolidateCustomBridge)(baseBridgeMethods, legacyCustomBridgeMethods, customBridge), (defaults)=>[
                (0, $fxdkV.withEmbeddedMacroContext),
                ...defaults
            ]);
        const connection = (0, $4GQnE.createEmbeddedMacroListener)(bridgeFeatures);
        return ()=>{
            connection?.close();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getBridgeContext is stable; legacyCustomBridgeMethods and customBridge are intentionally captured at mount only
    }, [
        isCustomUIBodiedMacro
    ]);
};
module.exports["useEmbeddedMacroConnection"] = $3ad0720bee1a01b6$export$aaaa1ba4b40a0c2f;

});

parcelRegister("egaak", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $ib6QY = parcelRequire("ib6QY");

const $a1b262b25c77d73e$export$31553aaa555c1514 = async ({ viewContext: viewContext })=>{
    return viewContext;
};
const $a1b262b25c77d73e$export$468cda29b159ee5d = async ({ services: { invoker: invoker, getContextToken: getContextToken, tracing: tracing, onThreeLO: onThreeLO }, resolverContext: resolverContext, extensionPayload: extensionPayload, contextIds: contextIds }, data)=>{
    // A single resolver call: returns the success body, signals that user consent is
    // required (without prompting), or throws for any other backend error.
    const attemptInvoke = async ()=>{
        const contextToken = await getContextToken({
            contextIdsOverride: contextIds
        });
        tracing.recordGqlCall('invokeExtension - start');
        // `metadata` is a frontend-only opt-in flag (it shapes the response, see below) — strip it
        // from the resolver `call` while forwarding every other field, so arbitrary call shapes pass through.
        const { metadata: metadata, ...call } = data;
        const { data: gqlData } = await invoker({
            call: call,
            context: {
                ...resolverContext
            },
            extensionPayload: extensionPayload,
            contextToken: contextToken
        });
        const resp = gqlData?.invokeExtension;
        if (!resp?.success) {
            const error = resp?.errors?.[0];
            if (error?.extensions.errorType === 'USER_CONSENT_REQUIRED') return {
                authUrl: error?.extensions.fields?.authInfoUrl,
                status: 'consent'
            };
            const message = error?.message ?? 'An error occurred while trying to invoke.';
            // Carry the errorType so the withErrorDisplay middleware can classify and
            // (for display-worthy types) surface an error message. Still throws either way.
            if (error?.extensions.errorType) throw new (0, $ib6QY.ForgeAppError)(error.extensions.errorType, message);
            throw new Error(message);
        }
        tracing.recordGqlCall('invokeExtension - end');
        if (!!metadata && (0, $dh538.fg)('forge-ui-return-invocation-metadata')) {
            const optsInToRateLimitProperties = metadata.rateLimitProperties === true;
            return {
                result: {
                    body: resp.response?.body ?? {},
                    metadata: {
                        ...optsInToRateLimitProperties ? {
                            rateLimitProperties: resp.rateLimitProperties ?? null
                        } : {}
                    }
                },
                status: 'ok'
            };
        }
        return {
            result: resp.response?.body ?? {},
            status: 'ok'
        };
    };
    const first = await attemptInvoke();
    if (first.status === 'ok') return first.result;
    // USER_CONSENT_REQUIRED: prompt for consent, then retry the resolver exactly once.
    // A second consent-required is terminal (matches v1) — re-prompting here would loop
    // indefinitely if the backend keeps requesting consent.
    return new Promise((resolve, reject)=>{
        onThreeLO(first.authUrl, async ()=>{
            try {
                const retried = await attemptInvoke();
                if (retried.status === 'ok') resolve(retried.result);
                else reject(new Error('User consent was required again after consenting.'));
            } catch (e) {
                reject(e);
            }
        }).catch(reject);
    });
};
const $a1b262b25c77d73e$export$34bfdcdeb272e2c2 = async ({ extension: extension })=>{
    return extension.properties?.frameId ?? null;
};
const $a1b262b25c77d73e$export$32da5b5043dcd88c = async ()=>{
    window.location.reload();
};
module.exports["getContext"] = $a1b262b25c77d73e$export$31553aaa555c1514;
module.exports["invoke"] = $a1b262b25c77d73e$export$468cda29b159ee5d;
module.exports["getFrameId"] = $a1b262b25c77d73e$export$34bfdcdeb272e2c2;
module.exports["reload"] = $a1b262b25c77d73e$export$32da5b5043dcd88c;

});

parcelRegister("b2rVn", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $cKUnA = parcelRequire("cKUnA");


var $b4nol = parcelRequire("b4nol");


var $jLVKK = parcelRequire("jLVKK");

const $9815f75a5eca48fa$var$fireFeatureFlagAnalyticsEvent = (tracker, extension, appId, params)=>{
    tracker.trackForgeFeatureFlagEvent({
        appType: (0, $jLVKK.getAppType)(extension),
        appId: appId,
        baseUrl: window.location.origin,
        forgeEnvironment: extension.environmentType,
        ...params
    });
};
const $9815f75a5eca48fa$export$f9d0db67c92b2ab2 = async (context, payload)=>{
    const { extensionDetails: { appId: appId }, extension: extension, contextIds: contextIds, environment: environment, services: { getContextToken: getContextToken, tracing: tracing, analytics: analytics } } = context;
    if (!(0, $dh538.fg)('platform_forge_ff_client_sdk')) return {};
    const contextToken = await getContextToken({
        contextIdsOverride: contextIds
    });
    tracing.recordBridgeCall('getFeatureFlags - start');
    const featureFlagEnv = payload.user?.statsigEnvironment?.tier || (0, $b4nol.FeatureFlagEnv).development;
    const trackInit = (success)=>{
        if ((0, $dh538.fg)('platform_forge_ff_ui_analytics')) $9815f75a5eca48fa$var$fireFeatureFlagAnalyticsEvent(analytics.tracker, extension, appId, {
            eventType: (0, $b4nol.FeatureFlagEventTypes).INITIALIZATION,
            success: success,
            featureFlagEnv: featureFlagEnv
        });
    };
    try {
        const resp = await (0, $cKUnA.getFeatureFlags)(appId, payload.user, payload.config, environment, contextToken);
        tracing.recordBridgeCall('getFeatureFlags - end');
        trackInit(true);
        return resp;
    } catch (err) {
        tracing.recordBridgeCall('getFeatureFlags - end');
        // eslint-disable-next-line no-console
        console.error('There were errors while initialising feature flags client ', err);
        trackInit(false);
        return {};
    }
};
const $9815f75a5eca48fa$var$ALLOWED_EVENT_TYPES = [
    (0, $b4nol.FeatureFlagEventTypes).CHECKFLAG.toUpperCase()
];
const $9815f75a5eca48fa$var$isValidFeatureFlagEventPayload = (data)=>{
    if (!data.type || !$9815f75a5eca48fa$var$ALLOWED_EVENT_TYPES.includes(data.type.toUpperCase())) return false;
    if (data.type.toUpperCase() === (0, $b4nol.FeatureFlagEventTypes).CHECKFLAG.toUpperCase() && data.properties.name && (data.properties.name.length < 3 || data.properties.name.length > 50)) return false;
    if (typeof data.properties.success !== 'boolean') return false;
    if (!(data.properties.environment && data.properties.environment.toLowerCase() in (0, $b4nol.FeatureFlagEnv))) return false;
    return true;
};
const $9815f75a5eca48fa$export$40367c2ce2684f9b = async (context, data)=>{
    if (!(0, $dh538.fg)('platform_forge_ff_ui_analytics')) return;
    const { extensionDetails: { appId: appId }, extension: extension, services: { analytics: analytics } } = context;
    try {
        if (!$9815f75a5eca48fa$var$isValidFeatureFlagEventPayload(data)) return;
        $9815f75a5eca48fa$var$fireFeatureFlagAnalyticsEvent(analytics.tracker, extension, appId, {
            flagName: data.properties.name || '',
            eventType: data.type,
            success: data.properties.success,
            featureFlagEnv: data.properties.environment
        });
    } catch  {
    // all errors are ignored
    }
};
module.exports["initFeatureFlags"] = $9815f75a5eca48fa$export$f9d0db67c92b2ab2;
module.exports["trackFeatureFlagEvent"] = $9815f75a5eca48fa$export$40367c2ce2684f9b;

});

parcelRegister("iFTSh", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $ijfiP = parcelRequire("ijfiP");


var $cr6KQ = parcelRequire("cr6KQ");

const $e9494f37b985b992$export$44a0e63a6f1a626c = async ({ extension: extension, extensionDetails: extensionDetails, contextIds: contextIds, services: { relayEnvironment: relayEnvironment } }, payload)=>{
    if (!(0, $dh538.fg)('platform_forge_frontend_custom_metrics')) return;
    // No context ARI → bail. `contextIds[0]` is typed `string` but is `undefined` for an empty array.
    const contextAri = contextIds[0];
    if (!contextAri) return;
    try {
        const { moduleKey: moduleKey } = (0, $ijfiP.parseExtensionId)(extension.id);
        await (0, $cr6KQ.emitFrontendCustomMetric)({
            relayEnvironment: relayEnvironment,
            contextAri: contextAri,
            appId: extensionDetails.appId,
            installationId: extension.installationId,
            moduleKey: moduleKey,
            customMetricName: payload.customMetricName,
            value: payload.value
        });
    } catch  {
    // Silent fail: emitting a metric must never surface an error to the app.
    }
};
module.exports["emitFrontendCustomMetric"] = $e9494f37b985b992$export$44a0e63a6f1a626c;

});

parcelRegister("2LhtV", function(module, exports) {

var $jLVKK = parcelRequire("jLVKK");

const $5a50fa18555d29bc$export$2052623e8b7dc210 = async (context, payload)=>{
    context.services.analytics.captureUntrustedEvent(payload);
};
const $5a50fa18555d29bc$export$ffaff761e5d8cf6c = async (context, payload)=>{
    context.services.analytics.captureUntrustedEvent(payload);
};
const $5a50fa18555d29bc$export$d39f84faa1bc5db6 = async (context, payload)=>{
    const { extension: extension, extensionDetails: { appId: appId }, services: { analytics: analytics } } = context;
    analytics.tracker.trackObjectStoreAction({
        appType: (0, $jLVKK.getAppType)(extension),
        appId: appId,
        action: payload.action,
        forgeEnvironment: extension.environmentType
    });
};
module.exports["iframeAnalytics"] = $5a50fa18555d29bc$export$2052623e8b7dc210;
module.exports["ufoEvent"] = $5a50fa18555d29bc$export$ffaff761e5d8cf6c;
module.exports["trackObjectStoreAction"] = $5a50fa18555d29bc$export$d39f84faa1bc5db6;

});

parcelRegister("72NYl", function(module, exports) {
/**
 * Creates a bridge method that delegates to a single `BridgeConfig` callback,
 * passing the payload through directly.
 *
 * Contract:
 *   - Callback present  → `(await callback(payload)) ?? true`
 *   - Callback absent   → `false`
 *
 * The callback is read from `bridgeConfig` at invocation time (not creation time),
 * so updates to the product's bridge prop are always reflected.
 */ const $55bae7f37a7a68d8$var$createBridgeConfigDelegate = (callbackName)=>async ({ bridgeConfig: bridgeConfig }, payload)=>{
        const callback = bridgeConfig[callbackName];
        if (!callback) return false;
        return await callback(payload) ?? true;
    };
/**
 * Creates a bridge method that delegates to a single `BridgeConfig` callback,
 * re-wrapping the payload as `{ data: payload }` before forwarding.
 *
 * BAD LEGACY PAYLOAD SHAPE — do not use this for new bridge methods.
 *
 * In the legacy bridge path (postRobot), feature handlers received the raw port-rpc
 * event object `{ data: actualPayload }` and product-side `BridgeConfig` callbacks
 * were written to access `opts.data` to get the actual value. The v2 bridge
 * (`bridge-core-reset`) correctly unwraps `{ data }` before invoking the bridge
 * method — so these delegates must re-wrap to maintain backward compatibility with
 * all existing product implementations (Confluence, Jira, xen-editor-provider, etc.)
 * that were written against the legacy contract.
 *
 * New bridge methods should use `createBridgeConfigDelegate` and accept the payload
 * directly (no `.data` wrapping).
 */ const $55bae7f37a7a68d8$var$createBridgeConfigDelegateForLegacyWrappedPayload = (callbackName)=>async ({ bridgeConfig: bridgeConfig }, payload)=>{
        const callback = bridgeConfig[callbackName];
        if (!callback) return false;
        return await callback({
            data: payload
        }) ?? true;
    };
/**
 * Canonical list of every `BridgeConfig` key exposed as a bridge feature.
 *
 * Keys excluded from this list (e.g. `spaPush`, `history`, `extensionBasePath`)
 * are used internally by other bridge methods and are not directly dispatched
 * from the app iframe.
 */ const $55bae7f37a7a68d8$var$BRIDGE_CONFIG_DELEGATE_KEYS = [
    'changeWindowTitle',
    'close',
    'closeFlag',
    'emitReadyEvent',
    'getFrameDispatch',
    'onClose',
    'onError',
    'open',
    'openModal',
    'reconcile',
    'refresh',
    'showFlag',
    'submit'
];
const $55bae7f37a7a68d8$export$4497e820804c31db = [
    'close',
    'onClose',
    'openModal',
    'submit'
];
const $55bae7f37a7a68d8$export$966b3425a26d5e9f = Object.fromEntries($55bae7f37a7a68d8$var$BRIDGE_CONFIG_DELEGATE_KEYS.map((key)=>[
        key,
        $55bae7f37a7a68d8$export$4497e820804c31db.includes(key) ? $55bae7f37a7a68d8$var$createBridgeConfigDelegateForLegacyWrappedPayload(key) : $55bae7f37a7a68d8$var$createBridgeConfigDelegate(key)
    ]));
module.exports["bridgeConfigDelegates"] = $55bae7f37a7a68d8$export$966b3425a26d5e9f;

});

parcelRegister("dOXc2", function(module, exports) {

var $9XihO = parcelRequire("9XihO");

const $4c7afe794077cd89$export$28eb87eac4188ed6 = async ({ services: { productFetchClient: productFetchClient } }, { restPath: restPath, product: product, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
    const response = await productFetchClient(restPath, product, fetchRequestInit, isMultipartFormData);
    const { status: status, statusText: statusText } = response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const headers = Object.fromEntries(response.headers.entries());
    const isAttachment = (0, $9XihO.isBinaryContentType)(response.headers.get('content-type'));
    const body = response.body ? await response.text() : undefined;
    return {
        headers: headers,
        status: status,
        statusText: statusText,
        body: body,
        isAttachment: isAttachment
    };
};
module.exports["fetchProduct"] = $4c7afe794077cd89$export$28eb87eac4188ed6;

});

parcelRegister("4RbK9", function(module, exports) {

var $9XihO = parcelRequire("9XihO");

const $b1098c5558ff5ddd$export$db36d2f1649120da = async ({ services: { getContextToken: getContextToken, remoteFetchClient: remoteFetchClient } }, { remoteKey: remoteKey, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
    const { path: path, ...init } = fetchRequestInit;
    const contextToken = await getContextToken();
    const response = await remoteFetchClient(remoteKey, init, isMultipartFormData, path, contextToken);
    const { status: status, statusText: statusText } = response;
    const headers = Object.fromEntries(response.headers.entries());
    const isAttachment = (0, $9XihO.isBinaryContentType)(response.headers.get('content-type'));
    const body = response.body ? await response.text() : undefined;
    return {
        headers: headers,
        status: status,
        statusText: statusText,
        body: body,
        isAttachment: isAttachment
    };
};
module.exports["fetchRemote"] = $b1098c5558ff5ddd$export$db36d2f1649120da;

});

parcelRegister("4ihhW", function(module, exports) {

var $8z9j5 = parcelRequire("8z9j5");

const $31a41e3290348206$export$cee03385e28d6243 = async ({ environment: environment, bridgeControls: bridgeControls })=>{
    bridgeControls.enableTheming();
    const currentTheme = (0, $8z9j5.default)();
    bridgeControls.setTheme(currentTheme, null, environment);
};
module.exports["enableTheming"] = $31a41e3290348206$export$cee03385e28d6243;

});

parcelRegister("dhw6T", function(module, exports) {

var $luNHV = parcelRequire("luNHV");


var $6dZft = parcelRequire("6dZft");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");

const $dd0f09981f0dd0e2$export$dfbfa9404d7ff498 = (0, $6dZft.createBridgeResource)('events', ()=>({
        subscriptions: new Set()
    }), ({ subscriptions: subscriptions })=>{
    for (const sub of subscriptions)sub.unsubscribe();
    subscriptions.clear();
});
const $dd0f09981f0dd0e2$export$af631764ddc44097 = async ({ extensionDetails: extensionDetails, claimBridgeResource: claimBridgeResource, page: page, services: { analytics: analytics } }, { event: event, callback: callback })=>{
    const state = claimBridgeResource($dd0f09981f0dd0e2$export$dfbfa9404d7ff498);
    const subscription = (0, $luNHV.on)(event, callback, extensionDetails);
    state.subscriptions.add(subscription);
    analytics.createAnalyticsEvent({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        data: {
            action: 'subscribed',
            actionSubject: 'bridgeEvent',
            attributes: {
                // TODO: remove the condition (and related test) once Developer UGC spec is ready
                event: event === 'JIRA_ISSUE_CHANGED' ? 'JIRA_ISSUE_CHANGED' : 'other'
            },
            source: page,
            tags: [
                'forge'
            ]
        }
    }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    return {
        unsubscribe: ()=>{
            if (state.subscriptions.delete(subscription)) subscription.unsubscribe();
        }
    };
};
const $dd0f09981f0dd0e2$export$8f35fbd5db0f3634 = async ({ extensionDetails: extensionDetails }, { event: event, payload: payload })=>{
    (0, $luNHV.emit)(event, payload, extensionDetails);
};
module.exports["on"] = $dd0f09981f0dd0e2$export$af631764ddc44097;
module.exports["emit"] = $dd0f09981f0dd0e2$export$8f35fbd5db0f3634;

});

parcelRegister("bITJ8", function(module, exports) {

var $9Foz2 = parcelRequire("9Foz2");


var $3e6Uc = parcelRequire("3e6Uc");


var $grQpA = parcelRequire("grQpA");


var $1Igmn = parcelRequire("1Igmn");


var $6dZft = parcelRequire("6dZft");


var $luNHV = parcelRequire("luNHV");

const $26de492c7928fc91$export$fc4b2a656c4af0a2 = (0, $6dZft.createBridgeResource)('public-events', ()=>({
        subscriptions: new Set()
    }), ({ subscriptions: subscriptions })=>{
    for (const sub of subscriptions)sub.unsubscribe();
    subscriptions.clear();
});
// ─── Cache ────────────────────────────────────────────────────────────────────
/**
 * Module-level cache of allowed-recipients lists keyed on the sorted, joined
 * contextIds string. Sorting makes the key order-independent; joining with
 * a null byte avoids false collisions between adjacent entries.
 * The number of distinct keys in a session is bounded by the number of distinct
 * page contexts visited, so there is no meaningful memory growth.
 *
 * Exposed via `clearAllowedRecipientsCache` for test teardown.
 */ const $26de492c7928fc91$var$allowedRecipientsCache = new Map();
const $26de492c7928fc91$export$28205a69263b59e6 = ()=>$26de492c7928fc91$var$allowedRecipientsCache.clear();
// ─── GQL constants ────────────────────────────────────────────────────────────
const $26de492c7928fc91$var$CORE_EVENT = 'core:event';
const $26de492c7928fc91$var$CLIENT_EVENTS = 'client-events';
const $26de492c7928fc91$var$CLIENT_EVENT = 'client-event';
const $26de492c7928fc91$var$EVENT_PREFIX = 'forge.bridge.';
// ─── Shared helpers ───────────────────────────────────────────────────────────
/**
 * Mirrors `filterAllowedRecipients` in `useEmitPublicEvent.ts`.
 * Finds the `core:event` extension for this app with key `client-events` or
 * `client-event`, extracts the `allowedRecipients` property. The `*` wildcard
 * is not supported — it is discarded rather than treated as "broadcast to all".
 * Converts full ARIs to bare app IDs (last `/`-segment), and unconditionally
 * appends the sender's own `appId` so the emitting extension always receives
 * its own public events.
 */ const $26de492c7928fc91$var$filterAllowedRecipients = (allExtensions, extension)=>{
    const matchingExtension = allExtensions.find((ext)=>ext.appId && ext.key && ext.appId === extension.appId && (ext.key === $26de492c7928fc91$var$CLIENT_EVENTS || ext.key === $26de492c7928fc91$var$CLIENT_EVENT));
    const allowedRecipients = matchingExtension?.properties?.allowedRecipients ?? [];
    const filtered = allowedRecipients.filter((r)=>r !== '*').map((r)=>r.split('/').at(-1) ?? r);
    if (!filtered.includes(extension.appId)) filtered.push(extension.appId);
    return filtered;
};
/**
 * Fetches the allowed-recipients list for `emitPublic` by querying the
 * `core:event` extension manifest via Relay. Falls back to `[extensionDetails.appId]`
 * on network error so public events always reach the sending extension at minimum.
 */ const $26de492c7928fc91$var$fetchAllowedRecipients = (relayEnvironment, contextIds, extensionDetails)=>{
    const observable = (0, $3e6Uc.fetchQuery)(relayEnvironment, (0, $9Foz2.default), {
        contextIds: contextIds,
        filter: [
            {
                type: (0, $grQpA.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    $26de492c7928fc91$var$CORE_EVENT
                ]
            }
        ]
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                }
            }
        }
    });
    return new Promise((resolve)=>{
        observable.subscribe({
            next: (result)=>{
                const allExtensions = result?.extensionContexts?.[0]?.extensions ?? [];
                resolve($26de492c7928fc91$var$filterAllowedRecipients(Array.from(allExtensions), extensionDetails));
            },
            error: ()=>{
                resolve([
                    extensionDetails.appId
                ]);
            }
        });
    });
};
const $26de492c7928fc91$var$getOrFetchAllowedRecipients = async (relayEnvironment, contextIds, extensionDetails)=>{
    const cacheKey = [
        ...contextIds
    ].sort().join('\0');
    if (!$26de492c7928fc91$var$allowedRecipientsCache.has(cacheKey)) {
        const recipients = await $26de492c7928fc91$var$fetchAllowedRecipients(relayEnvironment, contextIds, extensionDetails);
        $26de492c7928fc91$var$allowedRecipientsCache.set(cacheKey, recipients);
        return recipients;
    }
    return $26de492c7928fc91$var$allowedRecipientsCache.get(cacheKey);
};
const $26de492c7928fc91$export$2b8594f1cc80daad = async ({ extensionDetails: extensionDetails, claimBridgeResource: claimBridgeResource }, { event: event, callback: callback })=>{
    const state = claimBridgeResource($26de492c7928fc91$export$fc4b2a656c4af0a2);
    const subscription = (0, $luNHV.onPublic)(event, callback, extensionDetails);
    state.subscriptions.add(subscription);
    return {
        unsubscribe: ()=>{
            if (state.subscriptions.delete(subscription)) subscription.unsubscribe();
        }
    };
};
const $26de492c7928fc91$export$343310a09924dfa5 = async ({ contextIds: contextIds, extensionDetails: extensionDetails, services: { relayEnvironment: relayEnvironment } }, { event: event, payload: payload })=>{
    const allowedRecipients = await $26de492c7928fc91$var$getOrFetchAllowedRecipients(relayEnvironment, contextIds, extensionDetails);
    const newEvent = new CustomEvent(`${$26de492c7928fc91$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extensionDetails,
            payload: payload,
            allowedRecipients: allowedRecipients
        }
    });
    window.document.dispatchEvent(newEvent);
};
module.exports["onPublic"] = $26de492c7928fc91$export$2b8594f1cc80daad;
module.exports["emitPublic"] = $26de492c7928fc91$export$343310a09924dfa5;

});

parcelRegister("7GGkx", function(module, exports) {

var $3jdzl = parcelRequire("3jdzl");


var $4Ybnb = parcelRequire("4Ybnb");


var $irOoi = parcelRequire("irOoi");


var $1Igmn = parcelRequire("1Igmn");


var $iWy5D = parcelRequire("iWy5D");


var $kK6dd = parcelRequire("kK6dd");


var $auFhA = parcelRequire("auFhA");


var $6dZft = parcelRequire("6dZft");


var $dh538 = parcelRequire("dh538");

const $80d3ad4501d9050f$export$77e681b21805710f = (0, $6dZft.createBridgeResource)('realtime', ()=>({
        activeSubscriptions: new Map()
    }), (state)=>{
    for (const { subscription: subscription } of state.activeSubscriptions.values())if (!subscription.closed) subscription.unsubscribe();
    state.activeSubscriptions.clear();
});
const $80d3ad4501d9050f$var$getChannelKey = (context)=>{
    return Object.entries(context).sort((a, b)=>a[0].localeCompare(b[0])).toString();
};
/**
 * Computes the extension context hash used to scope realtime channels.
 * Matches the hash computed by the backend Realtime service and the legacy InnerIframe.tsx.
 */ const $80d3ad4501d9050f$var$computeExtensionContext = (resolverContext)=>{
    try {
        const { modal: _modal, ...productExtensionData } = resolverContext.extension ?? {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($4Ybnb)))(productExtensionData);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Product context is not a serializable object.');
        return '';
    }
};
const $80d3ad4501d9050f$export$361c332a01480dda = async (context, payload)=>{
    const { extension: extension, claimBridgeResource: claimBridgeResource, resolverContext: resolverContext, services: { getContextToken: getContextToken } } = context;
    const realtimeState = claimBridgeResource($80d3ad4501d9050f$export$77e681b21805710f);
    const { onEvent: onEvent, channelName: channelName, options: options, isGlobal: isGlobal } = payload;
    const { token: token } = options || {};
    if (token) {
        const validation = (0, $auFhA.validateRealtimeChannelToken)(token, {
            requiredPermission: 'subscribe',
            channelName: channelName
        });
        if (!validation.valid) return Promise.reject(new Error(`Realtime token validation failed: ${validation.error}`));
    }
    const extensionContext = $80d3ad4501d9050f$var$computeExtensionContext(resolverContext);
    const channelContext = options?.contextOverrides ? JSON.stringify({
        context: extensionContext,
        contextOverrides: options?.contextOverrides
    }) : extensionContext;
    const channelKey = $80d3ad4501d9050f$var$getChannelKey({
        channelName: channelName,
        isGlobal: isGlobal,
        channelContext: channelContext
    });
    const existingEntry = realtimeState.activeSubscriptions.get(channelKey);
    if (existingEntry) {
        existingEntry.subscription.addCallback(onEvent);
        onEvent('SUBSCRIPTION_STARTED');
    } else {
        const createSubscription = async ()=>{
            const subscriptionPayload = (0, $iWy5D.getSubscribePayload)({
                // getSubscribePayload expects the v1-shaped { data: {...} } envelope.
                payload: {
                    data: payload
                },
                context: channelContext,
                installationId: extension.installationId,
                contextToken: await getContextToken()
            });
            // Declare before subscribe() so the sink closures can reference it.
            // Assignment happens synchronously before any sink callbacks fire.
            let subscription;
            subscription = (0, $kK6dd.subscribe)(subscriptionPayload, {
                next: (result)=>{
                    subscription.onNext(result.data.ecosystem?.realtimeChannel?.payload);
                },
                error: async (err)=>{
                    const error = Array.isArray(err) ? err[0] : err;
                    if (error?.extensions?.statusCode === 429 && (0, $dh538.fg)('forge-ui-handle-realtime-rate-limit-error')) {
                        subscription.onError(new Error('RATE_LIMIT_EXCEEDED'));
                        return;
                    }
                    const shouldRetrySubscribe = error?.message === 'FCT has expired on subscribe request';
                    if (shouldRetrySubscribe) try {
                        const callbacksToCopy = [
                            ...subscription.subscriptionCallbacks
                        ];
                        await createSubscription();
                        const newEntry = realtimeState.activeSubscriptions.get(channelKey);
                        if (newEntry) newEntry.subscription.subscriptionCallbacks = callbacksToCopy;
                        subscription.unsubscribe();
                        // The new subscription is already at channelKey — don't delete the map entry.
                        return;
                    } catch (retryError) {
                        subscription.onError(retryError);
                        if (realtimeState.activeSubscriptions.get(channelKey)?.subscription === subscription) realtimeState.activeSubscriptions.delete(channelKey);
                        if (!subscription.closed) subscription.unsubscribe();
                        return;
                    }
                    subscription.onError(error);
                    if (realtimeState.activeSubscriptions.get(channelKey)?.subscription === subscription) realtimeState.activeSubscriptions.delete(channelKey);
                    if (!subscription.closed) subscription.unsubscribe();
                },
                complete: ()=>{
                    if (realtimeState.activeSubscriptions.get(channelKey)?.subscription === subscription) realtimeState.activeSubscriptions.delete(channelKey);
                    if (!subscription.closed) subscription.unsubscribe();
                }
            }, onEvent);
            realtimeState.activeSubscriptions.set(channelKey, {
                subscription: subscription
            });
            return subscription;
        };
        createSubscription();
    }
    return {
        unsubscribe: ()=>{
            const entry = realtimeState.activeSubscriptions.get(channelKey);
            if (entry) {
                entry.subscription.removeCallback(onEvent);
                if (entry.subscription.subscriptionCallbacks.length === 0) {
                    realtimeState.activeSubscriptions.delete(channelKey);
                    if (!entry.subscription.closed) entry.subscription.unsubscribe();
                }
            }
        }
    };
};
const $80d3ad4501d9050f$export$50666a6a6eccdc2e = async (context, payload)=>{
    const { extension: extension, resolverContext: resolverContext, services: { getContextToken: getContextToken, relayEnvironment: relayEnvironment } } = context;
    const extensionContext = $80d3ad4501d9050f$var$computeExtensionContext(resolverContext);
    const contextToken = await getContextToken();
    const { channelName: channelName, isGlobal: isGlobal, options: options } = payload;
    const { token: token, contextOverrides: contextOverrides } = options || {};
    if (token) {
        const validation = (0, $auFhA.validateRealtimeChannelToken)(token, {
            requiredPermission: 'publish',
            channelName: channelName
        });
        if (!validation.valid) return {
            eventId: null,
            eventTimestamp: null,
            errors: [
                {
                    message: `Realtime token validation failed: ${validation.error}`
                }
            ]
        };
    }
    const eventPayload = JSON.stringify(payload.eventPayload);
    const channelContext = contextOverrides ? JSON.stringify({
        context: extensionContext,
        contextOverrides: contextOverrides
    }) : extensionContext;
    return new Promise((resolve, reject)=>{
        (0, $irOoi.commitMutation)(relayEnvironment, {
            mutation: (0, $3jdzl.default),
            variables: {
                installationId: extension.installationId,
                name: channelName,
                payload: eventPayload,
                context: channelContext,
                isGlobal: isGlobal ?? false,
                token: token
            },
            cacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(),
                        ...contextToken ? {
                            'x-forge-context-token': contextToken
                        } : {},
                        'x-rate-limit-app-id': extension.appId,
                        'x-rate-limit-installation-id': extension.installationId
                    }
                }
            },
            onCompleted: (data, errors)=>{
                if (errors) return resolve({
                    eventId: null,
                    eventTimestamp: null,
                    errors: (0, $dh538.fg)('forge-ui-handle-realtime-rate-limit-error') ? errors.map((error)=>{
                        if (error.extensions?.statusCode === 429) return {
                            message: 'RATE_LIMIT_EXCEEDED'
                        };
                        return error;
                    }) : errors
                });
                if (data?.ecosystem?.publishRealtimeChannel) {
                    const { eventId: eventId, eventTimestamp: eventTimestamp } = data.ecosystem.publishRealtimeChannel;
                    if (eventId && eventTimestamp) {
                        resolve({
                            eventId: eventId,
                            eventTimestamp: eventTimestamp
                        });
                        return;
                    }
                }
                resolve(undefined);
            },
            onError: reject
        });
    });
};
module.exports["subscribeRealtimeChannel"] = $80d3ad4501d9050f$export$361c332a01480dda;
module.exports["publishRealtimeChannel"] = $80d3ad4501d9050f$export$50666a6a6eccdc2e;

});

parcelRegister("kl7WN", function(module, exports) {

var $9C3JU = parcelRequire("9C3JU");


var $42omo = parcelRequire("42omo");


var $3e6Uc = parcelRequire("3e6Uc");


var $lMJg3 = parcelRequire("lMJg3");


var $kZjf5 = parcelRequire("kZjf5");


var $kTcrU = parcelRequire("kTcrU");


var $i5CVI = parcelRequire("i5CVI");


var $2gNWY = parcelRequire("2gNWY");


var $cMiG0 = parcelRequire("cMiG0");


var $fYGGr = parcelRequire("fYGGr");


var $grQpA = parcelRequire("grQpA");


var $kxKUs = parcelRequire("kxKUs");


var $3Faxc = parcelRequire("3Faxc");

// ─── Module-level base URL cache ──────────────────────────────────────────────
const $ad08296303e30ee4$var$storedBaseUrlRelayByCloudId = new Map();
const $ad08296303e30ee4$export$448f9742733bb2de = ()=>{
    $ad08296303e30ee4$var$storedBaseUrlRelayByCloudId.clear();
};
/**
 * Retrieves the base URL for the given cloud tenant using a Relay query,
 * caching the result for the lifetime of the module. Needed to support
 * cross-custom-domain routing when `isCustomDomain()` returns true.
 */ const $ad08296303e30ee4$var$getBaseUrl = (relayEnvironment, cloudId)=>{
    if (!cloudId) return Promise.resolve(window.location.origin);
    const cachedBaseUrl = $ad08296303e30ee4$var$storedBaseUrlRelayByCloudId.get(cloudId);
    if (cachedBaseUrl) return Promise.resolve(cachedBaseUrl);
    const observable = (0, $3e6Uc.fetchQuery)(relayEnvironment, (0, $9C3JU.default), {
        cloudIds: [
            cloudId
        ]
    });
    return new Promise((resolve, reject)=>{
        let settled = false;
        observable.subscribe({
            next: (data)=>{
                if (settled) return;
                settled = true;
                const baseUrl = data?.tenantContexts?.[0]?.cloudUrl ?? '';
                $ad08296303e30ee4$var$storedBaseUrlRelayByCloudId.set(cloudId, baseUrl);
                resolve(baseUrl);
            },
            error: (err)=>{
                if (!settled) {
                    settled = true;
                    reject(err);
                }
            },
            complete: ()=>{
                if (!settled) {
                    settled = true;
                    resolve($ad08296303e30ee4$var$storedBaseUrlRelayByCloudId.get(cloudId) ?? '');
                }
            }
        });
    });
};
// ─── Extension query helper ───────────────────────────────────────────────────
/**
 * Returns a `getAppForgeUIExtensions` function compatible with `TargetURLUtils`,
 * pre-bound to the current extension's appId + environmentId. Uses Relay directly
 * (no Apollo fallback) since the bridge layer is Relay-only.
 */ const $ad08296303e30ee4$var$makeGetAppForgeUIExtensions = (relayEnvironment, contextIds, appId, environmentId, cloudId)=>{
    return (params)=>(0, $fYGGr.getForgeUIExtensionsRelayAsync)({
            contextIds: contextIds,
            extensionsFilter: [
                {
                    type: (0, $grQpA.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                    value: [
                        `${appId}:${environmentId}`
                    ]
                }
            ],
            cloudId: cloudId,
            relayEnvironment: relayEnvironment,
            ...params,
            // Must use the product-agnostic extensionContexts query (bypassNewForgeExtensionListCall: true).
            // Without this flag, getForgeUIExtensionsRelayAsync defaults to the confluence_forgeExtensionsByType
            // query which returns no results outside of Confluence, causing module key lookups to silently
            // fail in Jira and other products.
            bypassNewForgeExtensionListCall: true
        });
};
// ─── Shared onNavigate helper ─────────────────────────────────────────────────
/**
 * Validates the URL, navigates immediately for trusted links, and for external
 * links shows the ExternalLinkModal via overlayController before navigating.
 *
 * `spaPush` (the product's client-side router push, from `bridgeConfig.spaPush`)
 * is forwarded to `navigateToUrl` so `same-tab` trusted navigations perform an
 * SPA push instead of a full page reload. Mirrors the v1 wiring in
 * `useNavigation({ push: bridge?.spaPush })`.
 */ const $ad08296303e30ee4$var$onNavigate = async ({ type: type, url: urlString }, { extension: extension, overlayController: overlayController, analytics: { fireUIEvent: fireUIEvent }, spaPush: spaPush })=>{
    const url = (0, $kTcrU.makeUrl)(urlString);
    const egressService = (0, $lMJg3.egressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
    const linkType = (0, $kZjf5.getLinkType)(url, egressService);
    if (linkType === 'invalid' || !url) throw new (0, $kxKUs.BridgeClientError)(`link is invalid: ${urlString}`);
    if (linkType === 'trusted') {
        (0, $i5CVI.navigate)(url.href, type, spaPush);
        return;
    }
    const analyticsAttributes = (0, $kZjf5.getAnalyticsAttributes)(url);
    fireUIEvent({
        action: 'viewed',
        actionSubject: 'externalLinkModal',
        attributes: analyticsAttributes
    });
    return new Promise((resolve, reject)=>{
        overlayController.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Faxc.ExternalLinkModal), {
            url: url,
            extensionTitle: extension.properties?.title,
            onConfirm: ()=>{
                (0, $i5CVI.navigate)(url.href, type, spaPush);
                fireUIEvent({
                    action: 'approved',
                    actionSubject: 'externalLinkModal',
                    attributes: analyticsAttributes
                });
                overlayController.hide();
                resolve();
            },
            onCancel: ()=>{
                fireUIEvent({
                    action: 'cancelled',
                    actionSubject: 'externalLinkModal',
                    attributes: analyticsAttributes
                });
                overlayController.hide();
                reject(new (0, $kxKUs.BridgeClientError)('cancelled'));
            }
        }));
    });
};
const $ad08296303e30ee4$export$94df0e59ebebf4a7 = async ({ extension: extension, extensionDetails: extensionDetails, contextIds: contextIds, viewContext: viewContext, services: { relayEnvironment: relayEnvironment } }, data)=>{
    if (!data.target) return null;
    const { appId: appId } = extensionDetails;
    const { environmentId: environmentId } = extension;
    const path = await (0, $cMiG0.createNavigateTargetPath)(data, {
        getContext: async ()=>viewContext,
        getAppForgeUIExtensions: $ad08296303e30ee4$var$makeGetAppForgeUIExtensions(relayEnvironment, contextIds, appId, environmentId, viewContext.cloudId)
    });
    if (!path) return null;
    const baseUrl = (0, $2gNWY.isCustomDomain)(window.location.hostname) ? await $ad08296303e30ee4$var$getBaseUrl(relayEnvironment, viewContext.cloudId) : window.location.origin;
    return `${baseUrl}${path}`;
};
const $ad08296303e30ee4$export$ff7962acd6052c28 = async ({ extension: extension, extensionDetails: extensionDetails, contextIds: contextIds, viewContext: viewContext, bridgeConfig: bridgeConfig, services: { relayEnvironment: relayEnvironment, overlayController: overlayController, analytics: analytics } }, data)=>{
    const { spaPush: spaPush } = bridgeConfig;
    if ('target' in data && data.target) {
        const targetData = data;
        const { appId: appId } = extensionDetails;
        const { environmentId: environmentId } = extension;
        const path = await (0, $cMiG0.createNavigateTargetPath)(targetData, {
            getContext: async ()=>viewContext,
            getAppForgeUIExtensions: $ad08296303e30ee4$var$makeGetAppForgeUIExtensions(relayEnvironment, contextIds, appId, environmentId, viewContext.cloudId)
        });
        if (!path) {
            // eslint-disable-next-line no-console
            console.warn('Path was not found for the parameters provided');
            return;
        }
        const url = (0, $2gNWY.isCustomDomain)(window.location.hostname) ? `${await $ad08296303e30ee4$var$getBaseUrl(relayEnvironment, viewContext.cloudId)}${path}` : path;
        return $ad08296303e30ee4$var$onNavigate({
            type: targetData.type,
            url: url
        }, {
            extension: extension,
            overlayController: overlayController,
            analytics: analytics,
            spaPush: spaPush
        });
    }
    return $ad08296303e30ee4$var$onNavigate(data, {
        extension: extension,
        overlayController: overlayController,
        analytics: analytics,
        spaPush: spaPush
    });
};
module.exports["getUrl"] = $ad08296303e30ee4$export$94df0e59ebebf4a7;
module.exports["navigate"] = $ad08296303e30ee4$export$ff7962acd6052c28;

});

parcelRegister("bBmTt", function(module, exports) {

var $hvvoj = parcelRequire("hvvoj");

const $1b2dcd1ebae61034$export$4178d7ac16e6cf7c = async ({ bridgeConfig: bridgeConfig })=>{
    return (0, $hvvoj.createHistory)({
        history: bridgeConfig.history,
        extensionBasePath: bridgeConfig.extensionBasePath
    });
};
module.exports["createHistory"] = $1b2dcd1ebae61034$export$4178d7ac16e6cf7c;

});

parcelRegister("9xeXg", function(module, exports) {

var $974zo = parcelRequire("974zo");


var $kLl6K = parcelRequire("kLl6K");


var $6XtTp = parcelRequire("6XtTp");

// ─── constants ───────────────────────────────────────────────────────────────
const $e926d56b38388590$var$FORGE_SOURCE = 'forge-bridge-open-rovo';
const $e926d56b38388590$var$ROVO_EVENT_TYPE = 'chat-new';
const $e926d56b38388590$var$makeForgeAgentExternalConfigReference = (appId, installationId, environmentId, agentKey)=>`${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${agentKey}`;
const $e926d56b38388590$export$9be383b35c20e3cc = async ({ resolverContext: resolverContext, extension: extension, extensionDetails: extensionDetails, services: { relayEnvironment: relayEnvironment, rovoPublisher: rovoPublisher } }, { agentKey: agentKey, agentName: agentName, prompt: prompt })=>{
    const { cloudId: cloudId } = resolverContext;
    const product = (0, $kLl6K.getRovoProductFromExtensionType)(extension.type);
    if (!cloudId || !product) return false;
    const appId = extensionDetails.appId;
    const installationId = extension.installationId;
    const environmentId = extension.environmentId;
    const publishEventDetails = {
        type: $e926d56b38388590$var$ROVO_EVENT_TYPE,
        product: product,
        source: $e926d56b38388590$var$FORGE_SOURCE
    };
    let agentIdConfig;
    if (agentName && agentKey) // Forge-managed agent: reference by external config reference ARI
    agentIdConfig = {
        agentExternalConfigReference: $e926d56b38388590$var$makeForgeAgentExternalConfigReference(appId, installationId, environmentId, agentKey)
    };
    else {
        // Named agent (by name only, no key) or default Rovo chat agent
        const agentId = agentName && !agentKey ? await (0, $6XtTp.getRovoAgentId)({
            agentAppId: appId,
            cloudId: cloudId,
            input: {
                name: agentName
            },
            product: product,
            relayEnvironment: // agentKey is guaranteed falsy in this branch (condition: agentName && !agentKey)
            relayEnvironment
        }) : (0, $6XtTp.DEFAULT_AGENT_REFERENCE);
        agentIdConfig = {
            agentId: agentId
        };
    }
    rovoPublisher({
        ...publishEventDetails,
        data: {
            dialogues: [],
            ...agentIdConfig,
            ...prompt ? {
                prompt: prompt
            } : {}
        }
    });
    return true;
};
const $e926d56b38388590$export$243c13f4da40a98e = async ({ resolverContext: resolverContext, services: { relayEnvironment: relayEnvironment } })=>{
    const { cloudId: cloudId } = resolverContext;
    if (!cloudId) return false;
    return (0, $974zo.getIsRovoEnabled)({
        cloudId: cloudId,
        relayEnvironment: relayEnvironment
    });
};
module.exports["openRovo"] = $e926d56b38388590$export$9be383b35c20e3cc;
module.exports["isRovoEnabled"] = $e926d56b38388590$export$243c13f4da40a98e;

});

parcelRegister("ibJMJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $6dZft = parcelRequire("6dZft");


var $kxKUs = parcelRequire("kxKUs");


var $6HTvd = parcelRequire("6HTvd");


var $4Wrsi = parcelRequire("4Wrsi");

const $b7ca193c69923706$var$RATE_LIMIT_MS = 5000;
const $b7ca193c69923706$var$permissionModalResource = (0, $6dZft.createBridgeResource)('permissionModal', ()=>({
        isRateLimited: false,
        isModalOpen: false
    }), ()=>{}); // ─── Context type ─────────────────────────────────────────────────────────────
const $b7ca193c69923706$var$fetchAppData = async (relayEnvironment, appId, contextIds)=>{
    try {
        return await (0, $4Wrsi.getForgeApp)(relayEnvironment, appId, contextIds);
    } catch (e) {
        if (e instanceof Error) {
            const error = new (0, $kxKUs.BridgeClientError)(e.message);
            error.stack = e.stack;
            throw error;
        }
        throw new (0, $kxKUs.BridgeClientError)(typeof e === 'string' ? e : String(e));
    }
};
const $b7ca193c69923706$var$trackPermission = (analytics, appId, installationId, action)=>{
    analytics.tracker.trackPermissionAction({
        appId: appId,
        installationId: installationId,
        action: action
    });
};
const $b7ca193c69923706$var$canOpenModal = (state)=>!state.isModalOpen && !state.isRateLimited;
const $b7ca193c69923706$var$noteModalOpened = (state)=>{
    state.isModalOpen = true;
    state.isRateLimited = true;
    setTimeout(()=>{
        state.isRateLimited = false;
    }, $b7ca193c69923706$var$RATE_LIMIT_MS);
};
const $b7ca193c69923706$var$noteModalClosed = (state)=>{
    state.isModalOpen = false;
}; // ─── egressGet ────────────────────────────────────────────────────────────────
const $b7ca193c69923706$export$7d243a3c2dda5c06 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'egressGet');
    try {
        const resp = await permissionFetchClient.egressGet(payload);
        const json = await resp.json();
        if (!resp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $kxKUs.BridgeClientError)(`Could not get egress due to: ${err}`);
    }
};
const $b7ca193c69923706$export$ecdd54002a55cf8b = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics, overlayController: overlayController, relayEnvironment: relayEnvironment }, extensionDetails: { appId: appId }, extension: { installationId: installationId }, contextIds: contextIds, claimBridgeResource: claimBridgeResource }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'egressSet');
    const app = await $b7ca193c69923706$var$fetchAppData(relayEnvironment, appId, contextIds);
    const dryRunResp = await permissionFetchClient.egressSet(payload, true);
    if (!dryRunResp.ok) throw new (0, $kxKUs.BridgeClientError)('Dry run failed');
    const modalState = claimBridgeResource($b7ca193c69923706$var$permissionModalResource);
    if (!$b7ca193c69923706$var$canOpenModal(modalState)) throw new (0, $kxKUs.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
    return new Promise((resolve, reject)=>{
        $b7ca193c69923706$var$noteModalOpened(modalState);
        overlayController.show(/*#__PURE__*/ $42omo.createElement((0, $6HTvd.AdminConsentModal), {
            appName: app.name,
            domainInfo: {
                type: 'EGRESS',
                payload: payload
            },
            termsOfUseLink: app.termsOfService ?? null,
            privacyPolicyLink: app.privacyPolicy ?? null,
            onCancel: ()=>{
                $b7ca193c69923706$var$noteModalClosed(modalState);
                reject(new (0, $kxKUs.BridgeClientError)('Setting egress was rejected by admin'));
            },
            onConfirm: async ()=>{
                const setResp = await permissionFetchClient.egressSet(payload, false);
                const json = await setResp.json();
                if (!setResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                $b7ca193c69923706$var$noteModalClosed(modalState);
                resolve(json);
            }
        }), false);
    });
};
const $b7ca193c69923706$export$370bd1f6454115f4 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'egressDeleteDomain');
    try {
        const resp = await permissionFetchClient.egressDeleteDomain(payload);
        if (resp.ok && resp.status === 204) return undefined;
        const json = await resp.json();
        if (!resp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $kxKUs.BridgeClientError)(`Could not delete egress domain due to ${err}`);
    }
}; // ─── egressDeleteGroup ────────────────────────────────────────────────────────
const $b7ca193c69923706$export$f9aaf7f6a0038759 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'egressDeleteGroup');
    try {
        const resp = await permissionFetchClient.egressDeleteGroup(payload);
        if (resp.ok && resp.status === 204) return undefined;
        const json = await resp.json();
        if (!resp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $kxKUs.BridgeClientError)(`Could not delete egress group due to ${err}`);
    }
}; // ─── remoteGet ────────────────────────────────────────────────────────────────
const $b7ca193c69923706$export$3eb5f19ac16138d9 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'remoteGet');
    try {
        const resp = await permissionFetchClient.remoteGet(payload);
        const json = await resp.json();
        if (!resp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $kxKUs.BridgeClientError)(`Could not get remote due to: ${err}`);
    }
}; // ─── remoteSet ────────────────────────────────────────────────────────────────
const $b7ca193c69923706$export$9cf051d35cd846be = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics, overlayController: overlayController, relayEnvironment: relayEnvironment }, extensionDetails: { appId: appId }, extension: { installationId: installationId }, contextIds: contextIds, claimBridgeResource: claimBridgeResource }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'remoteSet');
    const app = await $b7ca193c69923706$var$fetchAppData(relayEnvironment, appId, contextIds);
    const dryRunResp = await permissionFetchClient.remoteSet(payload, true);
    if (!dryRunResp.ok) throw new (0, $kxKUs.BridgeClientError)('Dry run failed');
    const modalState = claimBridgeResource($b7ca193c69923706$var$permissionModalResource);
    if (!$b7ca193c69923706$var$canOpenModal(modalState)) throw new (0, $kxKUs.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
     // Build the manifest remote map from the app's extension nodes so the modal
    // can show descriptive names and supported patterns for each remote key.
    const node = (app.installationsByContexts?.edges ?? [])[0]?.node;
    const payloadKeys = new Set(payload.remotes.map((r)=>r.key));
    const manifestRemoteMap = (node?.appEnvironmentVersion?.extensions?.nodes ?? []).filter((e)=>e && e.extensionData.type === 'core:remote' && payloadKeys.has(e.extensionData.key)).reduce((acc, e)=>{
        if (e?.extensionData) acc[e.extensionData.key] = e.extensionData.configurable;
        return acc;
    }, {});
    return new Promise((resolve, reject)=>{
        $b7ca193c69923706$var$noteModalOpened(modalState);
        overlayController.show(/*#__PURE__*/ $42omo.createElement((0, $6HTvd.AdminConsentModal), {
            appName: app.name,
            domainInfo: {
                type: 'REMOTE',
                payload: payload,
                manifestRemoteMap: manifestRemoteMap
            },
            termsOfUseLink: app.termsOfService ?? null,
            privacyPolicyLink: app.privacyPolicy ?? null,
            onCancel: ()=>{
                $b7ca193c69923706$var$noteModalClosed(modalState);
                reject(new (0, $kxKUs.BridgeClientError)('Setting remote was rejected by admin'));
            },
            onConfirm: async ()=>{
                const setResp = await permissionFetchClient.remoteSet(payload, false);
                if (!setResp.ok) throw new (0, $kxKUs.BridgeClientError)(setResp.statusText);
                $b7ca193c69923706$var$noteModalClosed(modalState);
                resolve(undefined);
            }
        }), false);
    });
};
const $b7ca193c69923706$export$2e94858f69910d94 = {
    __permission__egressGet: $b7ca193c69923706$export$7d243a3c2dda5c06,
    __permission__egressSet: $b7ca193c69923706$export$ecdd54002a55cf8b,
    __permission__egressDeleteDomain: $b7ca193c69923706$export$370bd1f6454115f4,
    __permission__egressDeleteGroup: $b7ca193c69923706$export$f9aaf7f6a0038759,
    __permission__remoteGet: $b7ca193c69923706$export$3eb5f19ac16138d9,
    __permission__remoteSet: $b7ca193c69923706$export$9cf051d35cd846be
};
module.exports["permissionBridgeMethods"] = $b7ca193c69923706$export$2e94858f69910d94;

});

parcelRegister("ib6QY", function(module, exports) {
/**
 * Error thrown by bridge methods (e.g. `invoke`) that carries the backend
 * `errorType` alongside the message. The `withErrorDisplay` middleware inspects
 * `errorType` to decide whether to surface a Forge UI runtime error message; the error is
 * always rethrown so the app-side call still rejects.
 *
 * Pure (no React) so it can be thrown from the bridge method layer.
 */ class $db05967c4741fcfe$export$634a078025d77a0b extends Error {
    constructor(errorType, message){
        super(message ?? errorType);
        this.errorType = void 0;
        this.name = 'ForgeAppError';
        this.errorType = errorType;
        // Required for correct `instanceof` checks when transpiled to ES5.
        Object.setPrototypeOf(this, $db05967c4741fcfe$export$634a078025d77a0b.prototype);
    }
}
module.exports["ForgeAppError"] = $db05967c4741fcfe$export$634a078025d77a0b;

});

parcelRegister("bjfFJ", function(module, exports) {
/**
 * Debug helpers for diagnosing why BridgeContext re-fires its change listeners.
 *
 * Flip `DEBUG_ENABLED` to `true` locally when you want to see the exact leaf-level
 * properties that triggered a context change. Leave it `false` on every commit.
 */ 
var $7ZDjd = parcelRequire("7ZDjd");

const $c1fd7adb79fc0182$var$DEBUG_ENABLED = false;
/**
 * Returns true if `value` is a "plain" object — one we recurse into when diffing.
 * Library instances (Apollo client, Relay environment, etc.) have non-default
 * prototypes and are treated as opaque leaves to avoid traversing their internals.
 */ const $c1fd7adb79fc0182$var$isPlainObject = (value)=>{
    if (value === null || typeof value !== 'object' || Array.isArray(value)) return false;
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};
const $c1fd7adb79fc0182$var$diffValue = (prev, next, path, out)=>{
    if (Object.is(prev, next)) return;
    if (Array.isArray(prev) && Array.isArray(next)) {
        const max = Math.max(prev.length, next.length);
        for(let i = 0; i < max; i++)$c1fd7adb79fc0182$var$diffValue(prev[i], next[i], `${path}[${i}]`, out);
        return;
    }
    if ($c1fd7adb79fc0182$var$isPlainObject(prev) && $c1fd7adb79fc0182$var$isPlainObject(next)) {
        const keys = new Set([
            ...Object.keys(prev),
            ...Object.keys(next)
        ]);
        for (const key of keys)$c1fd7adb79fc0182$var$diffValue(prev[key], next[key], path ? `${path}.${key}` : key, out);
        return;
    }
    // Mixed types, primitives, functions, or opaque (non-plain) objects: emit a leaf entry.
    out.push({
        path: path,
        prev: prev,
        next: next
    });
};
const $c1fd7adb79fc0182$export$8b12422c455acfb9 = (prev, next, keys)=>{
    const out = [];
    for (const key of keys)$c1fd7adb79fc0182$var$diffValue(prev[key], next[key], key, out);
    return out;
};
const $c1fd7adb79fc0182$export$dad3a5c40b33fdca = (prev, next, changes)=>{
    if (!changes.__all__) return;
    const changedFields = (0, $7ZDjd.getBaseChangedFields)(changes);
    // eslint-disable-next-line no-console
    console.log('BridgeContext changed:', changedFields);
    if (!$c1fd7adb79fc0182$var$DEBUG_ENABLED) return;
    const diffs = $c1fd7adb79fc0182$export$8b12422c455acfb9(prev, next, changedFields);
    // eslint-disable-next-line no-console
    console.log('BridgeContext deep diff:', diffs);
};
module.exports["logBridgeContextChange"] = $c1fd7adb79fc0182$export$dad3a5c40b33fdca;

});

parcelRegister("7ZDjd", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");

// These are standard fields in the BridgeContextChanges, they are not used to indicate any specific context field changes.
const $9b761b3c44a8ed40$var$DEFAULT_CONTEXT_CHANGES_PROPS = [
    '__all__',
    'extensionPayloadChanges'
];
/**
 * Keys excluded entirely from the change calculation. Products typically pass a
 * freshly-allocated `bridge` object on every render, so reference-comparing it would mark
 * every render as a context change and spuriously fire listeners.
 */ const $9b761b3c44a8ed40$var$IGNORED_KEYS = [
    'bridge',
    'getContextToken'
];
/**
 * Keys that are deep-compared (via `lodash.isEqual`) instead of reference-compared. Products
 * commonly re-allocate these objects on every render with structurally identical content
 * (e.g. `coreData = { cloudId, workspaceId, ... }`); a simple `!==` would spuriously flag
 * them as changed.
 *
 * NOTE: values referenced by these keys must be plain JSON-shaped objects (no class instances,
 * no Apollo client, no Relay environment, no React refs). `lodash.isEqual` will recurse into
 * anything you put here, including library internals — keep these shapes simple.
 */ const $9b761b3c44a8ed40$var$STRUCTURAL_KEYS = [
    'coreData',
    'extension',
    'contextIds'
];
/**
 * Equality test for reference-compared keys. Two values are treated as equal (i.e. unchanged)
 * when they are reference-equal OR when both are functions.
 *
 * Functions are deliberately never compared by identity. Products commonly re-allocate callback
 * props (`onError`, `onLoad`, `setIsLoading`, …) on every render, and these can leak into the
 * change input via prop spreads at the call sites. Bridge methods read the latest props lazily and
 * no listener reacts to a function-identity change, so treating function↔function as equal
 * suppresses that spurious churn without dropping any real data change. Non-function values
 * (objects, arrays, primitives) fall back to reference equality — a reference change there may be a
 * genuine content change, so we must not blanket-ignore it.
 */ const $9b761b3c44a8ed40$var$isContextValueEqual = (prevValue, nextValue)=>prevValue === nextValue || typeof prevValue === 'function' && typeof nextValue === 'function';
const $9b761b3c44a8ed40$export$7b88e6c4776bbc6a = (prev, next)=>{
    const allKeys = new Set([
        ...Object.keys(prev),
        ...Object.keys(next)
    ]);
    const changes = {
        __all__: false,
        extensionPayloadChanges: {}
    };
    for (const key of allKeys){
        if ($9b761b3c44a8ed40$var$IGNORED_KEYS.includes(key)) {
            changes[key] = false;
            continue;
        }
        const prevValue = prev[key];
        const nextValue = next[key];
        const changed = $9b761b3c44a8ed40$var$STRUCTURAL_KEYS.includes(key) ? !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevValue, nextValue) : !$9b761b3c44a8ed40$var$isContextValueEqual(prevValue, nextValue);
        changes[key] = changed;
        if (changed) changes.__all__ = true;
    }
    // When extensionPayload reference changed, record per-top-level-key reference equality
    // as a cheap pre-filter signal for listeners.
    //
    // IMPORTANT: reference equality only — NOT value equality. A sub-key flagged `true` means
    // its reference changed, not necessarily that its serialised value changed. Listeners that
    // care about actual value equality must perform their own secondary comparison (e.g.
    // `isEqual`) before acting.
    //
    // The benefit is still real: when only `isEditing` changes and `config` keeps its reference,
    // `extensionPayloadChanges.config` is `false` and the listener short-circuits with zero
    // deep comparisons.
    if (changes.extensionPayload) {
        const prevPayload = prev.extensionPayload ?? {};
        const nextPayload = next.extensionPayload ?? {};
        const subKeys = new Set([
            ...Object.keys(prevPayload),
            ...Object.keys(nextPayload)
        ]);
        const subChanges = {};
        for (const k of subKeys)subChanges[k] = prevPayload[k] !== nextPayload[k];
        changes.extensionPayloadChanges = subChanges;
    }
    return changes;
};
const $9b761b3c44a8ed40$export$cf5490ed2de0a62 = (changes)=>{
    return Object.keys(changes).filter((k)=>{
        const key = k;
        return !$9b761b3c44a8ed40$var$DEFAULT_CONTEXT_CHANGES_PROPS.includes(key) && changes[key] === true;
    });
};
module.exports["computeBridgeContextChanges"] = $9b761b3c44a8ed40$export$7b88e6c4776bbc6a;
module.exports["getBaseChangedFields"] = $9b761b3c44a8ed40$export$cf5490ed2de0a62;

});

parcelRegister("JsJ4Y", function(module, exports) {
const $d09011ff2196b597$export$b3fb17ae4345ac8f = (b64string, mimeType)=>{
    const base64Data = b64string.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for(let i = 0; i < byteCharacters.length; i++)byteNumbers[i] = byteCharacters.charCodeAt(i);
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([
        byteArray
    ], {
        type: mimeType
    });
};
const $d09011ff2196b597$export$47a328b4cabd57cc = (blob)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
module.exports["base64ToBlob"] = $d09011ff2196b597$export$b3fb17ae4345ac8f;
module.exports["blobToBase64"] = $d09011ff2196b597$export$47a328b4cabd57cc;

});

parcelRegister("hpRDw", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gmeYw = parcelRequire("gmeYw");


var $irOoi = parcelRequire("irOoi");


var $kaOT1 = parcelRequire("kaOT1");


var $1Igmn = parcelRequire("1Igmn");

const $6d9ae53960c6917a$export$5d72c9fa1086d504 = 1000;
const $6d9ae53960c6917a$export$b3d02211996f2c0a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { renderThreeLOPrompt: renderThreeLOPrompt } = t0;
    const tracing = (0, $kaOT1.useTracingContext)();
    const [commitUserAuthTokenForExtensionMutation] = (0, $irOoi.useMutation)((0, $gmeYw.default));
    let fetchAuthToken;
    if ($[0] !== commitUserAuthTokenForExtensionMutation || $[1] !== renderThreeLOPrompt || $[2] !== tracing) {
        fetchAuthToken = async (extensionId, contextIds)=>{
            tracing?.recordGqlCall("userAuthTokenForExtension - start");
            return new Promise((resolve, reject)=>{
                commitUserAuthTokenForExtensionMutation({
                    variables: {
                        input: {
                            extensionId: extensionId,
                            contextIds: contextIds
                        }
                    },
                    cacheConfig: {
                        metadata: {
                            headers: {
                                "atl-attribution": (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                            }
                        }
                    },
                    onError: (error)=>{
                        reject(new Error(`Network error: ${error.message}`));
                    },
                    onCompleted: (data)=>{
                        if (data?.userAuthTokenForExtension) {
                            const { success: success, authToken: authToken, errors: errors } = data.userAuthTokenForExtension;
                            tracing?.recordGqlCall("userAuthTokenForExtension - end");
                            if (!success && errors && errors[0].message?.includes("No Atlassian OAuth token found for this user and extension")) {
                                renderThreeLOPrompt(async ()=>{
                                    const token = await fetchAuthToken(extensionId, contextIds);
                                    resolve(token);
                                });
                                return;
                            }
                            if (success && authToken) {
                                const { token: token_0, ttl: ttl } = authToken;
                                resolve({
                                    token: token_0,
                                    expiry: Date.now() + ttl * $6d9ae53960c6917a$export$5d72c9fa1086d504
                                });
                                return;
                            }
                            reject(new Error("An unexpected error occurred when fetching an auth token"));
                            return;
                        }
                    }
                });
            });
        };
        $[0] = commitUserAuthTokenForExtensionMutation;
        $[1] = renderThreeLOPrompt;
        $[2] = tracing;
        $[3] = fetchAuthToken;
    } else fetchAuthToken = $[3];
    return fetchAuthToken;
} : ({ renderThreeLOPrompt: renderThreeLOPrompt })=>{
    const tracing = (0, $kaOT1.useTracingContext)();
    const [commitUserAuthTokenForExtensionMutation] = (0, $irOoi.useMutation)((0, $gmeYw.default));
    const fetchAuthToken = async (extensionId, contextIds)=>{
        tracing?.recordGqlCall('userAuthTokenForExtension - start');
        return new Promise((resolve, reject)=>{
            commitUserAuthTokenForExtensionMutation({
                variables: {
                    input: {
                        extensionId: extensionId,
                        contextIds: contextIds
                    }
                },
                // @ts-ignore
                cacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                        }
                    }
                },
                onError: (error)=>{
                    reject(new Error(`Network error: ${error.message}`));
                },
                onCompleted: (data)=>{
                    if (data?.userAuthTokenForExtension) {
                        const { success: success, authToken: authToken, errors: errors } = data.userAuthTokenForExtension;
                        tracing?.recordGqlCall('userAuthTokenForExtension - end');
                        if (!success && errors && errors[0].message?.includes('No Atlassian OAuth token found for this user and extension')) {
                            renderThreeLOPrompt(async ()=>{
                                const token = await fetchAuthToken(extensionId, contextIds);
                                resolve(token);
                            });
                            return;
                        }
                        if (success && authToken) {
                            const { token: token_0, ttl: ttl } = authToken;
                            resolve({
                                token: token_0,
                                expiry: Date.now() + ttl * $6d9ae53960c6917a$export$5d72c9fa1086d504
                            });
                            return;
                        }
                        reject(new Error('An unexpected error occurred when fetching an auth token'));
                        return;
                    }
                }
            });
        });
    };
    return fetchAuthToken;
};
module.exports["useFetchAuthToken"] = $6d9ae53960c6917a$export$b3d02211996f2c0a;

});

parcelRegister("cTsf6", function(module, exports) {

var $eOpGZ = parcelRequire("eOpGZ");


var $49YLc = parcelRequire("49YLc");


var $irOoi = parcelRequire("irOoi");


var $1Igmn = parcelRequire("1Igmn");

let $edcbc2bd1a2659e9$var$tenantRegionResult;
const $edcbc2bd1a2659e9$export$e1b0b3d6e5c0e66c = ()=>{
    $edcbc2bd1a2659e9$var$tenantRegionResult = undefined;
};
const $edcbc2bd1a2659e9$var$getTenantRegionRelay = ({ product: product, cloudId: cloudId, relayEnvironment: relayEnvironment })=>{
    if (!!$edcbc2bd1a2659e9$var$tenantRegionResult) return $edcbc2bd1a2659e9$var$tenantRegionResult;
    if (!relayEnvironment || !cloudId) return Promise.resolve(null);
    try {
        const observable = (0, $irOoi.fetchQuery)(relayEnvironment, (0, $eOpGZ.default), {
            cloudIds: [
                cloudId
            ],
            product: product
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            }
        });
        $edcbc2bd1a2659e9$var$tenantRegionResult = new Promise((resolve)=>{
            observable.subscribe({
                next: (data)=>{
                    resolve(data?.tenantContexts?.[0]?.activationIdByProduct?.targetRegion ?? null);
                },
                error: ()=>{
                    resolve(null);
                }
            });
        });
        return $edcbc2bd1a2659e9$var$tenantRegionResult;
    } catch  {
        return Promise.resolve(null);
    }
};
const $edcbc2bd1a2659e9$export$f15a25d73b1f3084 = (0, $49YLc.functionWithFG)('forge-ui-enable-region-steering', $edcbc2bd1a2659e9$var$getTenantRegionRelay, ()=>Promise.resolve(null));
module.exports["getTenantRegion"] = $edcbc2bd1a2659e9$export$f15a25d73b1f3084;

});

parcelRegister("iGoXY", function(module, exports) {
/**
 * @generated SignedSource<<a86167cf33d9148d7192b88e655b4033>>
 * @relayHash 054ff1d044a88d72c8190c4e95486551
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d76d2d503320e36d09076652b2b41d61cb81839e0eedd2aa0b959bf242a17b03
const $97ad737b2742538f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "concreteType": "ForgeInvocationToken",
        "kind": "LinkedField",
        "name": "forgeInvocationToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jwt"
            }
        ]
    }, v7 = {
        "concreteType": "InvocationTokenForUIMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "baseUrl"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "SignInvocationTokenForUIResponse",
                    "kind": "LinkedField",
                    "name": "signInvocationTokenForUI",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "SignInvocationTokenForUIResponse",
                    "kind": "LinkedField",
                    "name": "signInvocationTokenForUI",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "d76d2d503320e36d09076652b2b41d61cb81839e0eedd2aa0b959bf242a17b03",
            "metadata": {},
            "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$97ad737b2742538f$var$node.hash = "fe7d32870ddf9b8f5524abb29f382040";
var $97ad737b2742538f$export$2e2bcd8739ae039 = $97ad737b2742538f$var$node;
module.exports["default"] = $97ad737b2742538f$export$2e2bcd8739ae039;

});

parcelRegister("hvvoj", function(module, exports) {

var $kxKUs = parcelRequire("kxKUs");

const $2a01424001f37a1e$export$21f63b78155c2049 = (extensionBasePath)=>{
    return {
        extensionRouteToFullPath: (extensionRoute)=>`${extensionBasePath}${extensionRoute ?? ''}`,
        fullPathToExtensionRoute: (fullLocation)=>{
            const extensionRoute = fullLocation.split(extensionBasePath).pop();
            return extensionRoute ? extensionRoute : '/';
        }
    };
};
const $2a01424001f37a1e$export$4178d7ac16e6cf7c = ({ history: history, extensionBasePath: extensionBasePath })=>{
    if (!history || !extensionBasePath) throw new (0, $kxKUs.BridgeClientError)('History API is not available within this module.');
    const { extensionRouteToFullPath: extensionRouteToFullPath, fullPathToExtensionRoute: fullPathToExtensionRoute } = $2a01424001f37a1e$export$21f63b78155c2049(extensionBasePath);
    const parseLocation = (location, parser)=>({
            ...location,
            pathname: parser(location.pathname)
        });
    const setNewHistoryLocation = (type, pathOrLocation, state)=>{
        const setHistory = type === 'push' ? history.push : history.replace;
        if (typeof pathOrLocation === 'string') return setHistory(extensionRouteToFullPath(pathOrLocation), state);
        return setHistory(parseLocation({
            state: state,
            ...pathOrLocation
        }, extensionRouteToFullPath));
    };
    return {
        ...history,
        location: parseLocation(history.location, fullPathToExtensionRoute),
        push (pathOrLocation, state) {
            setNewHistoryLocation('push', pathOrLocation, state);
        },
        replace (pathOrLocation, state) {
            setNewHistoryLocation('replace', pathOrLocation, state);
        },
        listen (listener) {
            const unlisten = history.listen((location, action)=>{
                listener(parseLocation(location, fullPathToExtensionRoute), action);
            });
            return unlisten;
        }
    };
};
module.exports["createHistory"] = $2a01424001f37a1e$export$4178d7ac16e6cf7c;

});

parcelRegister("6mbqJ", function(module, exports) {
/**
 * @generated SignedSource<<cafdf6a863735600bf8dd9feb570d348>>
 * @relayHash f7bba14ed0ba3e90a97cbe6770906a31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f678bd76c790e4ebfae99dd7eda54817e5a91318514b0cfd2d4a03ccfb0c7ad
const $b4ad3aab458be96b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "appAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "privacyPolicy"
    }, v4 = {
        "kind": "ScalarField",
        "name": "termsOfService"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "extensionData"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useForgeAppQuery_appByIdQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "App",
                        "kind": "LinkedField",
                        "name": "app",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            {
                                "args": v5 /*: any*/ ,
                                "concreteType": "AppInstallationByIndexConnection",
                                "kind": "LinkedField",
                                "name": "installationsByContexts",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AppInstallationByIndexEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "AppInstallation",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AppEnvironmentVersion",
                                                        "kind": "LinkedField",
                                                        "name": "appEnvironmentVersion",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AppVersionExtensions",
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AppVersionExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "nodes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v6 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useForgeAppQuery_appByIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "AppInstallationByIndexConnection",
                            "kind": "LinkedField",
                            "name": "installationsByContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "AppInstallationByIndexEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "AppInstallation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AppEnvironmentVersion",
                                                    "kind": "LinkedField",
                                                    "name": "appEnvironmentVersion",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AppVersionExtensions",
                                                            "kind": "LinkedField",
                                                            "name": "extensions",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AppVersionExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "3f678bd76c790e4ebfae99dd7eda54817e5a91318514b0cfd2d4a03ccfb0c7ad",
            "metadata": {},
            "name": "useForgeAppQuery_appByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b4ad3aab458be96b$var$node.hash = "8343441a33776d30a7ee1f511ffa878d";
var $b4ad3aab458be96b$export$2e2bcd8739ae039 = $b4ad3aab458be96b$var$node;
module.exports["default"] = $b4ad3aab458be96b$export$2e2bcd8739ae039;

});

parcelRegister("KsUAk", function(module, exports) {
/**
 * @generated SignedSource<<698d49f34e710bffcab59faf5fb5a56d>>
 * @relayHash 27a2ffb4f10a1c89ef127341679ca34d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 30715749324f4ce2692f3d99003222db57884cb021e35c4efc344badee2c59dd
const $fe98b83090a9da46$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmitPublicEvent_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmitPublicEvent_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "30715749324f4ce2692f3d99003222db57884cb021e35c4efc344badee2c59dd",
            "metadata": {},
            "name": "useEmitPublicEvent_getExtensionListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fe98b83090a9da46$var$node.hash = "d64f8ab7fa1f6f87512e638d0dec22de";
var $fe98b83090a9da46$export$2e2bcd8739ae039 = $fe98b83090a9da46$var$node;
module.exports["default"] = $fe98b83090a9da46$export$2e2bcd8739ae039;

});

parcelRegister("4AcGw", function(module, exports) {
/**
 * @generated SignedSource<<77c01d71360291bea3dc6bb34e30b0e9>>
 * @relayHash 146848d898d4f1b4f17c6ffe7e519e02
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81e1bc983c19feae9a62b87e16c21b378ccf00340edc9840ae4d1e14b946f849
const $3fd7314b2ab5e588$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "installationId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGlobal"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "payload"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "token"
    }, v6 = [
        {
            "concreteType": "EcosystemMutation",
            "kind": "LinkedField",
            "name": "ecosystem",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "context",
                            "variableName": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "installationId",
                            "variableName": "installationId"
                        },
                        {
                            "kind": "Variable",
                            "name": "isGlobal",
                            "variableName": "isGlobal"
                        },
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "name"
                        },
                        {
                            "kind": "Variable",
                            "name": "payload",
                            "variableName": "payload"
                        },
                        {
                            "kind": "Variable",
                            "name": "token",
                            "variableName": "token"
                        }
                    ],
                    "concreteType": "EcosystemRealtimePublishBody",
                    "kind": "LinkedField",
                    "name": "publishRealtimeChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "eventId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventTimestamp"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePublishRealtimeChannelMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePublishRealtimeChannelMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "id": "81e1bc983c19feae9a62b87e16c21b378ccf00340edc9840ae4d1e14b946f849",
            "metadata": {},
            "name": "usePublishRealtimeChannelMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3fd7314b2ab5e588$var$node.hash = "e82f2888e170470f31e8c75c07be4439";
var $3fd7314b2ab5e588$export$2e2bcd8739ae039 = $3fd7314b2ab5e588$var$node;
module.exports["default"] = $3fd7314b2ab5e588$export$2e2bcd8739ae039;

});

parcelRegister("auFhA", function(module, exports) {

var $iRhnt = parcelRequire("iRhnt");

function $2d19221b41ce3fba$export$3e18358e83fbc375(token, options) {
    const decoded = (0, $iRhnt.decodeJwtPayload)(token);
    if (!decoded) return {
        valid: false,
        error: 'INVALID_TOKEN'
    };
    const { channelName: channelName, requiredPermission: requiredPermission } = options;
    const { exp: exp, channel: channel, permissions: permissions } = decoded;
    if (exp !== undefined && Date.now() / 1000 >= exp) return {
        valid: false,
        error: 'TOKEN_EXPIRED'
    };
    if (channel.name && channel.name !== channelName) return {
        valid: false,
        error: 'CHANNEL_NAME_MISMATCH'
    };
    if (permissions && !permissions.includes(requiredPermission)) return {
        valid: false,
        error: 'MISSING_PERMISSION'
    };
    return {
        valid: true
    };
}
module.exports["validateRealtimeChannelToken"] = $2d19221b41ce3fba$export$3e18358e83fbc375;

});

parcelRegister("kK6dd", function(module, exports) {

var $lrJXD = parcelRequire("lrJXD");

const $b7f5501d28b11a4d$var$getAGGWebsocketURI = ()=>{
    return `wss://${window.location.host}/gateway/api/graphql/subscriptions`;
};
const $b7f5501d28b11a4d$var$createAGGSubscriptionClient = ()=>{
    return (0, $lrJXD.createClient)({
        url: $b7f5501d28b11a4d$var$getAGGWebsocketURI(),
        retryAttempts: 2,
        lazy: true
    });
};
const $b7f5501d28b11a4d$var$getAGGSubscriptionClient = ()=>{
    let client = window.__FORGE_AGG_SUBSCRIPTION_CLIENT__;
    if (!client) {
        client = $b7f5501d28b11a4d$var$createAGGSubscriptionClient();
        window.__FORGE_AGG_SUBSCRIPTION_CLIENT__ = client;
    }
    return client;
};
class $b7f5501d28b11a4d$var$BasicSubscription {
    get subscriptionCallbacks() {
        return this._subscriptionCallbacks;
    }
    set subscriptionCallbacks(callbacks) {
        this._subscriptionCallbacks = callbacks;
    }
    unsubscribe() {
        if (!this.closed) {
            this.baseUnsubscribe();
            this.closed = true;
            this._subscriptionCallbacks = [];
        }
    }
    addCallback(callback) {
        this._subscriptionCallbacks.push(callback);
    }
    removeCallback(callback) {
        const index = this._subscriptionCallbacks.indexOf(callback);
        if (index !== -1) this._subscriptionCallbacks.splice(index, 1);
    }
    onNext(event) {
        const payload = this.parsePayload(event);
        this._subscriptionCallbacks.forEach((callback)=>{
            try {
                callback(payload);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('[forge-realtime] Error in subscription callback: ', error);
            }
        });
    }
    onError(error) {
        this._subscriptionCallbacks.forEach((callback)=>{
            try {
                callback(null, error);
            } catch (callbackError) {
                // eslint-disable-next-line no-console
                console.error('[forge-realtime] Error in subscription callback:', callbackError);
            }
        });
    }
    parsePayload(payload) {
        try {
            return JSON.parse(payload);
        // eslint-disable-next-line no-unused-vars
        } catch (err) {
            return payload;
        }
    }
    constructor(baseUnsubscribe, callback){
        this.closed = void 0;
        this.baseUnsubscribe = void 0;
        this._subscriptionCallbacks = void 0;
        this.closed = false;
        this.baseUnsubscribe = baseUnsubscribe;
        this._subscriptionCallbacks = [
            callback
        ];
    }
}
const $b7f5501d28b11a4d$export$ec068583843480e7 = (payload, sink, subscriptionCallback, client)=>{
    if (!client) client = $b7f5501d28b11a4d$var$getAGGSubscriptionClient();
    const unsubscribe = client.subscribe(payload, sink);
    return new $b7f5501d28b11a4d$var$BasicSubscription(unsubscribe, subscriptionCallback);
};
module.exports["subscribe"] = $b7f5501d28b11a4d$export$ec068583843480e7;

});

parcelRegister("kLl6K", function(module, exports) {
const $87edcca4ef2d73a1$export$eb5f18ff99769aac = (extensionType)=>{
    const [product, moduleName] = extensionType.split(':');
    const SUPPORTED_PRODUCTS = [
        'jira',
        'confluence',
        'global'
    ];
    // For xen:macro
    if (product === 'xen') return 'confluence';
    // Resolve non-portal JSM modules to Jira
    if (product === 'jiraServiceManagement') {
        if (moduleName && !moduleName.includes('portal')) return 'jira';
    }
    if (!SUPPORTED_PRODUCTS.includes(product)) return null;
    return product;
};
module.exports["getRovoProductFromExtensionType"] = $87edcca4ef2d73a1$export$eb5f18ff99769aac;

});

parcelRegister("6XtTp", function(module, exports) {

var $iDpBI = parcelRequire("iDpBI");


var $irOoi = parcelRequire("irOoi");

const $8b4a60e16bea70d5$export$6e6c2af98f57fa9d = 'ai_mate_agent';
// From https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/06c1faa9feb39485f12c6528f9baf9bb1c653451/platform/packages/ai-mate/conversation-assistant-agent/src/services/paginated-agents/utils.tsx
const $8b4a60e16bea70d5$var$getAgentIdFromAri = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $8b4a60e16bea70d5$var$getIdFromAgent = (agent)=>{
    const id = agent?.node?.id;
    if (!id) return null;
    return $8b4a60e16bea70d5$var$getAgentIdFromAri(agent?.node?.id);
};
const $8b4a60e16bea70d5$export$73f5d5418567eaae = (agentsList, agentKey, agentAppId)=>{
    // No agents found from given name so fallback to default agent
    if (agentsList.length === 0) return null;
    // OOTB agents can't have the same name,
    // but it can have the same name as a custom agent or a forge agent
    if (!agentKey || !agentAppId) {
        // Custom agents don't have externalConfigReference
        const agent = agentsList.find((agent)=>agent?.node?.externalConfigReference != null && !agent?.node?.externalConfigReference.includes('ari:cloud:ecosystem::extension'));
        return $8b4a60e16bea70d5$var$getIdFromAgent(agent);
    }
    // Forge agents can have the same name so we have to filter further by key and appId
    // Their external config reference follows the pattern:
    // `${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${moduleKey}`;
    const forgeAgentRegex = new RegExp(`${agentAppId}/[^/]+/static/${agentKey}`);
    const agent = agentsList.find((agent)=>agent?.node?.externalConfigReference && forgeAgentRegex.test(agent?.node?.externalConfigReference));
    return $8b4a60e16bea70d5$var$getIdFromAgent(agent);
};
const $8b4a60e16bea70d5$export$de10b7621d6ba909 = async ({ cloudId: cloudId, product: product, input: input, agentKey: agentKey, agentAppId: agentAppId, relayEnvironment: relayEnvironment })=>{
    if (!relayEnvironment) return $8b4a60e16bea70d5$export$6e6c2af98f57fa9d;
    try {
        const observable = (0, $irOoi.fetchQuery)(relayEnvironment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $iDpBI.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            input: input,
            product: product
        });
        return new Promise((resolve)=>{
            observable.subscribe({
                next: (data)=>{
                    const agentsList = data?.agentStudio_getAgents?.edges ?? [];
                    const agentId = $8b4a60e16bea70d5$export$73f5d5418567eaae(agentsList, agentKey, agentAppId) ?? $8b4a60e16bea70d5$export$6e6c2af98f57fa9d;
                    resolve(agentId);
                },
                error: ()=>{
                    resolve($8b4a60e16bea70d5$export$6e6c2af98f57fa9d);
                }
            });
        });
    } catch  {
        return $8b4a60e16bea70d5$export$6e6c2af98f57fa9d;
    }
};
module.exports["DEFAULT_AGENT_REFERENCE"] = $8b4a60e16bea70d5$export$6e6c2af98f57fa9d;
module.exports["getRovoAgentId"] = $8b4a60e16bea70d5$export$de10b7621d6ba909;

});

parcelRegister("6iOy7", function(module, exports) {
/**
 * @generated SignedSource<<833852bc3ddd9a91a710ff19c2d356a2>>
 * @relayHash bfe07c4627cdf47f030bff23909d7190
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f6f405334e912ac423e5472ae733bed876222fcd844be006c0a9c718a6d4c9a
const $dae6e991aaad727f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "EcosystemMutation",
            "kind": "LinkedField",
            "name": "ecosystem",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ForgeObservabilityMutation",
                    "kind": "LinkedField",
                    "name": "forgeObservability",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "input"
                                }
                            ],
                            "concreteType": "ForgeObservabilityPublishFrontendCustomMetricResponse",
                            "kind": "LinkedField",
                            "name": "publishFrontendCustomMetric",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "emitFrontendCustomMetricMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "emitFrontendCustomMetricMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9f6f405334e912ac423e5472ae733bed876222fcd844be006c0a9c718a6d4c9a",
            "metadata": {},
            "name": "emitFrontendCustomMetricMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$dae6e991aaad727f$var$node.hash = "0525b01263b0e23397f5287e835f1eb4";
var $dae6e991aaad727f$export$2e2bcd8739ae039 = $dae6e991aaad727f$var$node;
module.exports["default"] = $dae6e991aaad727f$export$2e2bcd8739ae039;

});

parcelRegister("kaRs6", function(module, exports) {
/**
 * @generated SignedSource<<28d43f74f9a6863d0a8de40dec2b7423>>
 * @relayHash f504b87a4e0ed24c5467ba12a605952a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9123000e799c8af26e2146bcbeaf5a5445b2e622a89605e7d2dedac44d1c74aa
const $bae2b5f9b6a29d48$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "environmentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "appId",
                    "variableName": "appId"
                },
                {
                    "kind": "Variable",
                    "name": "environmentId",
                    "variableName": "environmentId"
                }
            ],
            "concreteType": "AppTunnelDefinitions",
            "kind": "LinkedField",
            "name": "appActiveTunnels",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CustomUITunnelDefinition",
                    "kind": "LinkedField",
                    "name": "customUI",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resourceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tunnelUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCustomUITunnelsListRelay_forge_ui_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCustomUITunnelsListRelay_forge_ui_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9123000e799c8af26e2146bcbeaf5a5445b2e622a89605e7d2dedac44d1c74aa",
            "metadata": {},
            "name": "useCustomUITunnelsListRelay_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bae2b5f9b6a29d48$var$node.hash = "f05d61452951b17f46031ee0cc173398";
var $bae2b5f9b6a29d48$export$2e2bcd8739ae039 = $bae2b5f9b6a29d48$var$node;
module.exports["default"] = $bae2b5f9b6a29d48$export$2e2bcd8739ae039;

});

parcelRegister("fxdkV", function(module, exports) {
function $290c361385bb69be$var$isEmbeddedMacroPayload(value) {
    return typeof value === 'object' && value !== null && 'embeddedMacroContext' in value;
}
function $290c361385bb69be$var$createOpenModalPayload(payload, embeddedMacroContext) {
    const { extension: extension, extensionPayload: extensionPayload, resolverContext: resolverContext } = embeddedMacroContext;
    return {
        ...payload,
        embeddedMacroLocalId: resolverContext?.localId,
        extension: extension,
        extensionData: resolverContext?.extension,
        extensionPayload: extensionPayload,
        isEmbeddedMacroModal: true
    };
}
const $290c361385bb69be$export$10fc17d781b6867c = (method, methodName)=>async (context, embeddedMacroPayload)=>{
        if (!$290c361385bb69be$var$isEmbeddedMacroPayload(embeddedMacroPayload)) return method(context, embeddedMacroPayload);
        const { embeddedMacroContext: embeddedMacroContext, payload: payload } = embeddedMacroPayload;
        const { contextIds: contextIds, extension: extension, extensionDetails: extensionDetails, extensionPayload: extensionPayload, page: page, resolverContext: resolverContext, viewContext: viewContext } = embeddedMacroContext;
        const mergedContext = {
            ...context,
            contextIds: contextIds,
            extension: extension,
            extensionDetails: extensionDetails,
            extensionPayload: extensionPayload,
            page: page,
            resolverContext: resolverContext,
            viewContext: viewContext
        };
        if (methodName === 'openModal') return method(mergedContext, $290c361385bb69be$var$createOpenModalPayload(payload, embeddedMacroContext));
        // `payload` is `unknown` from the embedded macro payload — cast to Payload since this middleware
        // intentionally unwraps it and forwards the inner args as-is to the method.
        return method(mergedContext, payload);
    };
module.exports["withEmbeddedMacroContext"] = $290c361385bb69be$export$10fc17d781b6867c;

});

parcelRegister("jLVKK", function(module, exports) {

var $iqcSr = parcelRequire("iqcSr");

const $3eda9c7596411f2d$export$7a88fe5d3687ebff = (extension)=>(0, $iqcSr.isCustomUI)(extension) ? 'CustomUI' : 'UIKit';
module.exports["getAppType"] = $3eda9c7596411f2d$export$7a88fe5d3687ebff;

});

parcelRegister("6dZft", function(module, exports) {
/**
 * Opaque handle describing a per-instance bridge resource: how to create its
 * state and how to tear it down when the BridgeContextObject is destroyed.
 *
 * Declare one resource per feature module (keep it private to the module unless
 * sharing across methods is intentional).
 *
 * Future lifecycle hooks (e.g. `onUpdate`, `onContextTokenRefresh`) can be
 * added here without changing existing callsites.
 */ const $a1d322db571e2009$export$c0f9ef43567dcb8a = (debugName, create, destroy)=>({
        id: Symbol(debugName),
        create: create,
        destroy: destroy
    });
module.exports["createBridgeResource"] = $a1d322db571e2009$export$c0f9ef43567dcb8a;

});

parcelRegister("9Foz2", function(module, exports) {
/**
 * @generated SignedSource<<d3085f3315879872c8437a2bae079d15>>
 * @relayHash b17b87df0361e2b091063266ad414333
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID add4418fa3b9922378db99ca8f4638f62a27cdbfc1ca37cb555b2c7463d0cdf4
const $04b69c81f887e002$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "publicEventsBridgeMethod_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "publicEventsBridgeMethod_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "add4418fa3b9922378db99ca8f4638f62a27cdbfc1ca37cb555b2c7463d0cdf4",
            "metadata": {},
            "name": "publicEventsBridgeMethod_getExtensionListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$04b69c81f887e002$var$node.hash = "7bbb57a8de2a877674c61a37fce31344";
var $04b69c81f887e002$export$2e2bcd8739ae039 = $04b69c81f887e002$var$node;
module.exports["default"] = $04b69c81f887e002$export$2e2bcd8739ae039;

});

parcelRegister("3jdzl", function(module, exports) {
/**
 * @generated SignedSource<<21db12c527eddb222f1bf05d8283d44d>>
 * @relayHash 93b3893a8e9a1daa7b144c57b1a4a9d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2856644f2efd708a0c94f2c0495a994e7de8bc5389ada3a88bbe8d568f1b0876
const $25eecfcb0e365d16$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "installationId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGlobal"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "payload"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "token"
    }, v6 = [
        {
            "concreteType": "EcosystemMutation",
            "kind": "LinkedField",
            "name": "ecosystem",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "context",
                            "variableName": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "installationId",
                            "variableName": "installationId"
                        },
                        {
                            "kind": "Variable",
                            "name": "isGlobal",
                            "variableName": "isGlobal"
                        },
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "name"
                        },
                        {
                            "kind": "Variable",
                            "name": "payload",
                            "variableName": "payload"
                        },
                        {
                            "kind": "Variable",
                            "name": "token",
                            "variableName": "token"
                        }
                    ],
                    "concreteType": "EcosystemRealtimePublishBody",
                    "kind": "LinkedField",
                    "name": "publishRealtimeChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "eventId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventTimestamp"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "realtimePublishChannelMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "realtimePublishChannelMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "id": "2856644f2efd708a0c94f2c0495a994e7de8bc5389ada3a88bbe8d568f1b0876",
            "metadata": {},
            "name": "realtimePublishChannelMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$25eecfcb0e365d16$var$node.hash = "5ea0f10b611a7938d84804613e71e265";
var $25eecfcb0e365d16$export$2e2bcd8739ae039 = $25eecfcb0e365d16$var$node;
module.exports["default"] = $25eecfcb0e365d16$export$2e2bcd8739ae039;

});

parcelRegister("9C3JU", function(module, exports) {
/**
 * @generated SignedSource<<949a41936564b270f94089d6d2803225>>
 * @relayHash ada3e04d4a67a0cf753a63d3ffc29f1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 18f7f0ebdb47541d86e76505147e1f52e7b4dc441ac13869211d7a904ef73b70
const $6a9ca4e123b07b6f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudIds",
                    "variableName": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "navigationBridgeMethod_tenantUrlQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "navigationBridgeMethod_tenantUrlQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "18f7f0ebdb47541d86e76505147e1f52e7b4dc441ac13869211d7a904ef73b70",
            "metadata": {},
            "name": "navigationBridgeMethod_tenantUrlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6a9ca4e123b07b6f$var$node.hash = "537ee6daeedfde6695ff904bf976af02";
var $6a9ca4e123b07b6f$export$2e2bcd8739ae039 = $6a9ca4e123b07b6f$var$node;
module.exports["default"] = $6a9ca4e123b07b6f$export$2e2bcd8739ae039;

});

parcelRegister("6HTvd", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $ccHMk = parcelRequire("ccHMk");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $fJCAk = parcelRequire("fJCAk");


var $aXWIB = parcelRequire("aXWIB");

const $1a72623c304bea83$var$getHumanReadableName = (operation)=>{
    switch(operation){
        case 'FETCH_BACKEND_SIDE':
            return 'Fetch backend side';
        case 'FETCH_CLIENT_SIDE':
            return 'Fetch client side';
        case 'FONTS':
            return 'Fonts';
        case 'FRAMES':
            return 'Frames';
        case 'IMAGES':
            return 'Images';
        case 'MEDIA':
            return 'Media';
        case 'NAVIGATION':
            return 'Navigation';
        case 'SCRIPTS':
            return 'Scripts';
        case 'STYLES':
            return 'Styles';
        default:
            return 'Egress';
    }
};
const $1a72623c304bea83$export$a7839a1d0a383d1f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { appName: appName, domainInfo: domainInfo, onCancel: onCancel, onConfirm: onConfirm, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink } = t0;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== onCancel) {
        t1 = ()=>{
            setIsOpen(false);
            onCancel();
        };
        $[0] = onCancel;
        $[1] = t1;
    } else t1 = $[1];
    const handleCancel = t1;
    let t2;
    if ($[2] !== onConfirm) {
        t2 = async ()=>{
            try {
                await onConfirm();
                setIsOpen(false);
            } catch  {}
        };
        $[2] = onConfirm;
        $[3] = t2;
    } else t2 = $[3];
    const handleConfirm = t2;
    let t3;
    if ($[4] !== domainInfo.manifestRemoteMap || $[5] !== domainInfo.payload.egresses || $[6] !== domainInfo.payload.remotes || $[7] !== domainInfo.type) {
        t3 = ()=>{
            if (domainInfo.type === "REMOTE") return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
                direction: "column",
                gap: "space.150"
            }, domainInfo.payload.remotes.map((r)=>{
                const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
                return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                    key: r.key,
                    space: "space.150"
                }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                    size: "small"
                }, manifestRemoteInfo ? manifestRemoteInfo.description : "Remote"), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                    xcss: (0, $fJCAk.styles).rowContainer,
                    spread: "space-between",
                    grow: "fill"
                }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, r.configured.endpoint === null ? "This remote is being reset to the default value" : r.configured.endpoint), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
            }));
            return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
                direction: "column",
                gap: "space.150"
            }, domainInfo.payload.egresses.map($1a72623c304bea83$var$_temp2));
        };
        $[4] = domainInfo.manifestRemoteMap;
        $[5] = domainInfo.payload.egresses;
        $[6] = domainInfo.payload.remotes;
        $[7] = domainInfo.type;
        $[8] = t3;
    } else t3 = $[8];
    const renderDomains = t3;
    let t4;
    if ($[9] !== appName || $[10] !== intl || $[11] !== privacyPolicyLink || $[12] !== termsOfUseLink) {
        t4 = ()=>{
            if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).noticeForMoreDetails, {
                appName: appName
            }), " ", /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                href: termsOfUseLink
            }, intl.formatMessage((0, $fJCAk.messages).termsOfUseLink)), " ", intl.formatMessage((0, $fJCAk.messages).noticeAnd), " ", /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                href: privacyPolicyLink
            }, intl.formatMessage((0, $fJCAk.messages).privacyPolicyLink)));
            if (termsOfUseLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).noticeForMoreDetails, {
                appName: appName
            }), " ", /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                href: termsOfUseLink
            }, intl.formatMessage((0, $fJCAk.messages).termsOfUseLink)));
            if (privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).noticeForMoreDetails, {
                appName: appName
            }), " ", /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                href: privacyPolicyLink
            }, intl.formatMessage((0, $fJCAk.messages).privacyPolicyLink)));
            return null;
        };
        $[9] = appName;
        $[10] = intl;
        $[11] = privacyPolicyLink;
        $[12] = termsOfUseLink;
        $[13] = t4;
    } else t4 = $[13];
    const Notice = t4;
    let t5;
    if ($[14] !== handleCancel || $[15] !== handleConfirm || $[16] !== intl) {
        t5 = ()=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                xcss: (0, $fJCAk.styles).modalFooterContainer
            }, /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                space: "space.075"
            }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
                onClick: handleCancel
            }, intl.formatMessage((0, $fJCAk.messages).declineButtonLabel)), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
                onClick: handleConfirm,
                appearance: "primary"
            }, intl.formatMessage((0, $fJCAk.messages).approveButtonLabel)))));
        $[14] = handleCancel;
        $[15] = handleConfirm;
        $[16] = intl;
        $[17] = t5;
    } else t5 = $[17];
    const ModalFooter = t5;
    let t6;
    if ($[18] !== ModalFooter || $[19] !== Notice || $[20] !== appName || $[21] !== handleCancel || $[22] !== intl || $[23] !== isOpen || $[24] !== renderDomains) {
        t6 = isOpen && /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
            onClose: handleCancel,
            width: "large"
        }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: (0, $fJCAk.styles).titleContainer
        }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), null, intl.formatMessage((0, $fJCAk.messages).modalTransitionTitle)))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
            space: "space.300"
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).modalTransitionText, {
            appName: appName
        })), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), null, renderDomains(), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: (0, $fJCAk.styles).disclaimerContainer
        }, /*#__PURE__*/ $42omo.createElement(Notice, null))))), /*#__PURE__*/ $42omo.createElement(ModalFooter, null));
        $[18] = ModalFooter;
        $[19] = Notice;
        $[20] = appName;
        $[21] = handleCancel;
        $[22] = intl;
        $[23] = isOpen;
        $[24] = renderDomains;
        $[25] = t6;
    } else t6 = $[25];
    let t7;
    if ($[26] !== t6) {
        t7 = /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, t6);
        $[26] = t6;
        $[27] = t7;
    } else t7 = $[27];
    return t7;
} : ({ appName: appName, domainInfo: domainInfo, onCancel: onCancel, onConfirm: onConfirm, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const intl = (0, $aXWIB.useIntl)();
    const handleCancel = ()=>{
        setIsOpen(false);
        onCancel();
    };
    const handleConfirm = async ()=>{
        try {
            await onConfirm();
            setIsOpen(false);
        } catch  {}
    };
    const renderDomains = ()=>{
        if (domainInfo.type === 'REMOTE') return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.remotes.map((r)=>{
            const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
            return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                key: r.key,
                space: "space.150"
            }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                size: "small"
            }, manifestRemoteInfo ? manifestRemoteInfo.description : 'Remote'), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                xcss: (0, $fJCAk.styles).rowContainer,
                spread: "space-between",
                grow: "fill"
            }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, r.configured.endpoint === null ? 'This remote is being reset to the default value' : r.configured.endpoint), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
        }));
        return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                key: e.key,
                space: "space.150"
            }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                size: "xsmall"
            }, e.description), e.configured.map((c)=>c.type.map((t)=>/*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                        key: t,
                        xcss: (0, $fJCAk.styles).rowContainer,
                        spread: "space-between",
                        grow: "fill"
                    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, c.domain), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, $1a72623c304bea83$var$getHumanReadableName(t))))))));
    };
    const Notice = ()=>{
        if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: termsOfUseLink
        }, intl.formatMessage((0, $fJCAk.messages).termsOfUseLink)), ' ', intl.formatMessage((0, $fJCAk.messages).noticeAnd), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: privacyPolicyLink
        }, intl.formatMessage((0, $fJCAk.messages).privacyPolicyLink)));
        if (termsOfUseLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: termsOfUseLink
        }, intl.formatMessage((0, $fJCAk.messages).termsOfUseLink)));
        if (privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: privacyPolicyLink
        }, intl.formatMessage((0, $fJCAk.messages).privacyPolicyLink)));
        return null;
    };
    const ModalFooter = ()=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: (0, $fJCAk.styles).modalFooterContainer
        }, /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            space: "space.075"
        }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            onClick: handleCancel
        }, intl.formatMessage((0, $fJCAk.messages).declineButtonLabel)), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            onClick: handleConfirm,
            appearance: "primary"
        }, intl.formatMessage((0, $fJCAk.messages).approveButtonLabel)))));
    return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: handleCancel,
        width: "large"
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $fJCAk.styles).titleContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), null, intl.formatMessage((0, $fJCAk.messages).modalTransitionTitle)))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.300"
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).modalTransitionText, {
        appName: appName
    })), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), null, renderDomains(), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $fJCAk.styles).disclaimerContainer
    }, /*#__PURE__*/ $42omo.createElement(Notice, null))))), /*#__PURE__*/ $42omo.createElement(ModalFooter, null)));
};
function $1a72623c304bea83$var$_temp(c) {
    return c.type.map((t)=>/*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            key: t,
            xcss: (0, $fJCAk.styles).rowContainer,
            spread: "space-between",
            grow: "fill"
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, c.domain), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, $1a72623c304bea83$var$getHumanReadableName(t))));
}
function $1a72623c304bea83$var$_temp2(e) {
    return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        key: e.key,
        space: "space.150"
    }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "xsmall"
    }, e.description), e.configured.map($1a72623c304bea83$var$_temp));
}
module.exports["AdminConsentModal"] = $1a72623c304bea83$export$a7839a1d0a383d1f;

});

parcelRegister("4Wrsi", function(module, exports) {

var $3DDmB = parcelRequire("3DDmB");


var $irOoi = parcelRequire("irOoi");


var $7MEO5 = parcelRequire("7MEO5");


var $1Igmn = parcelRequire("1Igmn");

class $6a9163af48013335$export$8814b2f3dd4388d5 extends Error {
}
const $6a9163af48013335$export$3d35432ad69f8123 = (relayEnvironment, appId, contextIds)=>{
    const appAri = (0, $7MEO5.createAppAri)({
        appId: appId
    }).toString();
    return new Promise((resolve, reject)=>{
        (0, $irOoi.fetchQuery)(relayEnvironment, (0, $3DDmB.default), {
            appAri: appAri,
            contextIds: contextIds
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            }
        }).subscribe({
            next: (data)=>{
                resolve(data.app);
            },
            error: (error)=>{
                reject(new $6a9163af48013335$export$8814b2f3dd4388d5(`Failed to fetch app data by its ID: ${appAri}, GraphQLError: ${JSON.stringify(error)}`));
            }
        });
    });
};
module.exports["getForgeApp"] = $6a9163af48013335$export$3d35432ad69f8123;

});

parcelRegister("gmeYw", function(module, exports) {
/**
 * @generated SignedSource<<243826f017886b1beee3409e510959ff>>
 * @relayHash 8044e66d6d14d3c8d608ad17b4c7a655
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bd98d71393d58feccd2a11d41423b399b61ad4c7d6d4a93b8d392ec2588d343
const $a58b42757ec4f68d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UserAuthTokenForExtensionResponse",
            "kind": "LinkedField",
            "name": "userAuthTokenForExtension",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "AuthToken",
                    "kind": "LinkedField",
                    "name": "authToken",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "token"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ttl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "4bd98d71393d58feccd2a11d41423b399b61ad4c7d6d4a93b8d392ec2588d343",
            "metadata": {},
            "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a58b42757ec4f68d$var$node.hash = "d3c16ce08d98682bc3fa0189ab747c05";
var $a58b42757ec4f68d$export$2e2bcd8739ae039 = $a58b42757ec4f68d$var$node;
module.exports["default"] = $a58b42757ec4f68d$export$2e2bcd8739ae039;

});

parcelRegister("eOpGZ", function(module, exports) {
/**
 * @generated SignedSource<<03e7f531f3d1ad6f240db21bb1800046>>
 * @relayHash e47a8d762ffff04a617bbcb521f2ffa5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dfe29aeb7d5310c6db8859a9de6a2e7e88aba2fbf6339df8df5a30ef3f21bad3
const $f0a21fde804fef06$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudIds",
                    "variableName": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "product",
                            "variableName": "product"
                        }
                    ],
                    "concreteType": "TenantContextActivationId",
                    "kind": "LinkedField",
                    "name": "activationIdByProduct",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "targetRegion"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getTenantRegionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getTenantRegionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "dfe29aeb7d5310c6db8859a9de6a2e7e88aba2fbf6339df8df5a30ef3f21bad3",
            "metadata": {},
            "name": "getTenantRegionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f0a21fde804fef06$var$node.hash = "6dc84af73dba89409a0c35ebb8003355";
var $f0a21fde804fef06$export$2e2bcd8739ae039 = $f0a21fde804fef06$var$node;
module.exports["default"] = $f0a21fde804fef06$export$2e2bcd8739ae039;

});

parcelRegister("iDpBI", function(module, exports) {
/**
 * @generated SignedSource<<f6479fdee294cd2cb25c85c511c27a04>>
 * @relayHash 6baab84fb33d5b03a95e7fc260932ffd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e09a83e61fd43789aeb35b90e2f5c323733ae91a0c8a217868f45694be7598a
const $98784d239f8db17c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                },
                {
                    "kind": "Variable",
                    "name": "product",
                    "variableName": "product"
                }
            ],
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AgentStudioAgentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAssistant",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "externalConfigReference"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getRovoAgentIdRelayQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getRovoAgentIdRelayQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9e09a83e61fd43789aeb35b90e2f5c323733ae91a0c8a217868f45694be7598a",
            "metadata": {},
            "name": "getRovoAgentIdRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$98784d239f8db17c$var$node.hash = "2d164c49d934dbe7dee2500c2971c832";
var $98784d239f8db17c$export$2e2bcd8739ae039 = $98784d239f8db17c$var$node;
module.exports["default"] = $98784d239f8db17c$export$2e2bcd8739ae039;

});

parcelRegister("3DDmB", function(module, exports) {
/**
 * @generated SignedSource<<c22a8773a4c94a6d083b02ef971eb34f>>
 * @relayHash 6c8bbff92427f8f13a9f68ade35e1315
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a614603202abfb55d7d7de64c2578f6deaab7e80d00892134b1cea54b0b6ade8
const $af5efc942a2c5e73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "appAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "privacyPolicy"
    }, v4 = {
        "kind": "ScalarField",
        "name": "termsOfService"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "extensionData"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getForgeApp_appByIdQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "App",
                        "kind": "LinkedField",
                        "name": "app",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            {
                                "args": v5 /*: any*/ ,
                                "concreteType": "AppInstallationByIndexConnection",
                                "kind": "LinkedField",
                                "name": "installationsByContexts",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AppInstallationByIndexEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "AppInstallation",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AppEnvironmentVersion",
                                                        "kind": "LinkedField",
                                                        "name": "appEnvironmentVersion",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AppVersionExtensions",
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AppVersionExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "nodes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v6 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getForgeApp_appByIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "AppInstallationByIndexConnection",
                            "kind": "LinkedField",
                            "name": "installationsByContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "AppInstallationByIndexEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "AppInstallation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AppEnvironmentVersion",
                                                    "kind": "LinkedField",
                                                    "name": "appEnvironmentVersion",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AppVersionExtensions",
                                                            "kind": "LinkedField",
                                                            "name": "extensions",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AppVersionExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "a614603202abfb55d7d7de64c2578f6deaab7e80d00892134b1cea54b0b6ade8",
            "metadata": {},
            "name": "getForgeApp_appByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$af5efc942a2c5e73$var$node.hash = "e93ae1f09519a9c62b2154493dddce01";
var $af5efc942a2c5e73$export$2e2bcd8739ae039 = $af5efc942a2c5e73$var$node;
module.exports["default"] = $af5efc942a2c5e73$export$2e2bcd8739ae039;

});


$parcel$global.rlb("RXMWr")
//# sourceMappingURL=inlineCard.1e15573b.js.map
